import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  DurationInMilliseconds: number;
  DurationInSeconds: number;
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { [key: string]: any };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { [key: string]: any };
  /** Raw JSON value */
  JsonObject: { [key: string]: any };
  /** Raw JSON value */
  Object: { [key: string]: any };
};

export type Access = {
  __typename: 'Access';
  CmsUsers: Maybe<CmsUsersAccess>;
  canAccessAdmin: Scalars['Boolean'];
  cms_banners: Maybe<Cms_BannersAccess>;
  cms_blog_pages: Maybe<Cms_Blog_PagesAccess>;
  cms_blog_posts: Maybe<Cms_Blog_PostsAccess>;
  cms_gamers: Maybe<Cms_GamersAccess>;
  cms_games: Maybe<Cms_GamesAccess>;
  cms_media: Maybe<Cms_MediaAccess>;
  payload_locked_documents: Maybe<Payload_Locked_DocumentsAccess>;
  payload_preferences: Maybe<Payload_PreferencesAccess>;
};

/** An account */
export type Account = {
  accountType: Scalars['String'];
  avatarURL: Maybe<Scalars['String']>;
  bannerURL: Maybe<Scalars['String']>;
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  groupInvites: Array<GroupInviteWithPossibleError>;
  groupMemberships: Array<GroupMembership>;
  id: Scalars['String'];
  isSupplier: Scalars['Boolean'];
  managedAccounts: Array<ManagedAccountWithPossibleError>;
  otherFields: Maybe<Array<AccountTag>>;
  payPurchaseTransactions: Array<PayPurchaseTransaction>;
  publicURL: Maybe<Scalars['String']>;
  purchaseTransactions: Array<PurchaseTransaction>;
  socialLinks: Array<SocialLink>;
  subscriptionProviderAccounts: Array<SubscriptionProviderAccount>;
  subscriptions: Array<SwarmioSubscription>;
  updated: Scalars['Date'];
  wallets: Array<SwarmioWallet>;
};

export type AccountInvite = AccountInviteWithPossibleError & {
  __typename: 'AccountInvite';
  accountId: Scalars['String'];
  created: Scalars['Date'];
  id: Scalars['String'];
  isError: Scalars['Boolean'];
  roles: Array<Role>;
};

/** An AccountInvite or an error */
export type AccountInviteWithPossibleError = {
  isError: Scalars['Boolean'];
};

export type AccountManager = AccountManagerWithPossibleError & {
  __typename: 'AccountManager';
  accountId: Scalars['String'];
  isError: Scalars['Boolean'];
  roles: Array<Role>;
};

/** An AccountManager or an error */
export type AccountManagerWithPossibleError = {
  isError: Scalars['Boolean'];
};

export type AccountNotification = {
  __typename: 'AccountNotification';
  created: Scalars['Date'];
  defaultMessage: Scalars['String'];
  expiry: Scalars['Date'];
  fields: Maybe<Scalars['JsonObject']>;
  id: Scalars['String'];
  notificationType: Scalars['String'];
  read: Scalars['Boolean'];
};

export type AccountNotificationEvent = StreamingEvent & {
  __typename: 'AccountNotificationEvent';
  created: Scalars['Date'];
  defaultMessage: Scalars['String'];
  expiry: Scalars['Date'];
  fields: Maybe<Scalars['JsonObject']>;
  id: Scalars['String'];
  notificationType: Scalars['String'];
  read: Scalars['Boolean'];
};

export type AccountProjection = {
  __typename: 'AccountProjection';
  accountManagers: Maybe<Array<AccountManager>>;
  avatarURL: Maybe<Scalars['String']>;
  birthday: Maybe<DateAttributeWithPossibleError>;
  created: Maybe<Scalars['Date']>;
  displayName: Maybe<Scalars['String']>;
  email: Maybe<StringAttributeWithPossibleError>;
  emailContact: Maybe<HiveContactWithPossibleError>;
  emailVerified: Maybe<Scalars['Boolean']>;
  groupInvites: Maybe<Array<GroupInviteWithPossibleError>>;
  groupMemberships: Maybe<Array<GroupMembership>>;
  id: Scalars['String'];
  linkedAccounts: Maybe<Array<IdentityProviderWithPossibleError>>;
  managedAccounts: Maybe<Array<ManagedAccountWithPossibleError>>;
  msisdn: Maybe<StringAttributeWithPossibleError>;
  msisdnContact: Maybe<HiveContactWithPossibleError>;
  otherContact: Maybe<HiveContactWithPossibleError>;
  publicURL: Maybe<Scalars['String']>;
  realName: Maybe<StringAttributeWithPossibleError>;
  updated: Maybe<Scalars['Date']>;
  userType: Maybe<Scalars['String']>;
};

export type AccountTag = {
  __typename: 'AccountTag';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type AccountTagInput = {
  label: Scalars['String'];
  value: Scalars['String'];
};

/** An error representing a generic forbidden action */
export type ActionNotAllowedError = AccountInviteWithPossibleError & AccountManagerWithPossibleError & ClientVisibleError & DateAttributeWithPossibleError & GroupInviteWithPossibleError & HiveContactWithPossibleError & IdentityProviderWithPossibleError & ManagedAccountWithPossibleError & StringAttributeWithPossibleError & {
  __typename: 'ActionNotAllowedError';
  isError: Scalars['Boolean'];
  message: Scalars['String'];
};

export type AdditionalInformation = {
  __typename: 'AdditionalInformation';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type AdditionalInformationInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

/** A generic event stage participant */
export type AdvanceStrategy = {
  advanceStrategyType: AdvanceStrategyType;
};

/** The type of Advance Strategy */
export enum AdvanceStrategyType {
  AtLeastPlacement = 'AtLeastPlacement',
  ExactPlacement = 'ExactPlacement'
}

export type AllDealInput = {
  dealStatus?: InputMaybe<DealStatus>;
};

export type AllEventStageCompetitionsUpdateRequest = {
  challenge?: InputMaybe<SingleChallengeUpdateRequest>;
  matchUp?: InputMaybe<SingleMatchUpUpdateRequest>;
  tournament?: InputMaybe<SingleTournamentUpdateRequest>;
};

export type AllServHealthCheck = {
  __typename: 'AllServHealthCheck';
  company: Maybe<Scalars['String']>;
  health: Maybe<Scalars['String']>;
  message: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
};

export type ApplicationConfig = {
  __typename: 'ApplicationConfig';
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  featureFlags: Array<FeatureFlag>;
  id: Scalars['String'];
  name: Scalars['String'];
  updated: Maybe<Scalars['Date']>;
};

export type ApplicationConfigCreationRequest = {
  description?: InputMaybe<Scalars['String']>;
  featureFlags: Array<FeatureFlagCreationRequest>;
  name: Scalars['String'];
};

export type ApplicationConfigUpdateRequest = {
  description?: InputMaybe<Scalars['String']>;
  featureFlags?: InputMaybe<Array<FeatureFlagUpdateRequest>>;
  name?: InputMaybe<Scalars['String']>;
};

export type AtLeastPlacementAdvanceStrategy = AdvanceStrategy & {
  __typename: 'AtLeastPlacementAdvanceStrategy';
  advanceStrategyType: AdvanceStrategyType;
  placement: Scalars['Int'];
};

export type AutomaticallyVerifiedResultInput = {
  participantId: Scalars['String'];
  score: Scalars['Float'];
};

export type AutomaticallyVerifiedResultsForRoundFromParticipant = {
  __typename: 'AutomaticallyVerifiedResultsForRoundFromParticipant';
  competitionId: Scalars['String'];
  created: Scalars['Date'];
  fromParticipantId: Scalars['String'];
  plzDelete: Scalars['Boolean'];
  roundId: Scalars['String'];
  unverifiedResults: Array<BasicAutomaticallyVerifiedResult>;
};

export type AutomaticallyVerifiedResultsForRoundFromParticipantInput = {
  competitionId: Scalars['String'];
  fromParticipantId: Scalars['String'];
  roundId: Scalars['String'];
  unverifiedResults: Array<AutomaticallyVerifiedResultInput>;
};

export type Banner = {
  __typename: 'Banner';
  buttonText: Maybe<Scalars['String']>;
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  logoUrl: Maybe<Scalars['String']>;
  primaryImageUrl: Scalars['String'];
  redirectUrl: Scalars['String'];
  secondaryImageUrl: Scalars['String'];
  title: Maybe<Scalars['String']>;
  updated: Maybe<Scalars['Date']>;
};

export type BannerCreationRequest = {
  buttonText?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  primaryImageUrl: Scalars['String'];
  redirectUrl: Scalars['String'];
  secondaryImageUrl: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type BannerUpdateRequest = {
  buttonText?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  primaryImageUrl?: InputMaybe<Scalars['String']>;
  redirectUrl?: InputMaybe<Scalars['String']>;
  secondaryImageUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type BaseEventTeamMember = EventTeamMember & {
  __typename: 'BaseEventTeamMember';
  accountId: Scalars['String'];
  id: Scalars['String'];
  roles: Array<GamingRole>;
};

export type BasicAutomaticallyVerifiedResult = {
  __typename: 'BasicAutomaticallyVerifiedResult';
  participantId: Scalars['String'];
  score: Scalars['Float'];
};

/** The type of prize payout receipt */
export enum BasicPrizePayoutReceiptType {
  CustomPrizePayoutReceiptType = 'CustomPrizePayoutReceiptType',
  SwarmioCurrencyFixedPrizePayoutReceiptType = 'SwarmioCurrencyFixedPrizePayoutReceiptType'
}

export type BasicResult = Result & {
  __typename: 'BasicResult';
  id: Scalars['String'];
  maybeShowed: Maybe<Scalars['Boolean']>;
  placement: Maybe<Scalars['Int']>;
  prizePayoutReceipt: Maybe<PrizePayoutReceipt>;
  resultImageURLs: Maybe<Array<Scalars['String']>>;
  score: Maybe<Scalars['Float']>;
  showed: Scalars['Boolean'];
};

export type BattleRoyaleFormatCreationDetails = {
  advanceFraction: Scalars['Float'];
  bucketDimensionsMapId?: InputMaybe<Scalars['String']>;
  bucketDimensionsMapRequest?: InputMaybe<BucketDimensionsMapRequest>;
  maxParticipantsPerRound: Scalars['Int'];
  phaseModifications?: InputMaybe<Array<PhaseModificationsCreationRequest>>;
};

export type BattleRoyaleFormatUpdateDetails = {
  advanceFraction?: InputMaybe<Scalars['Float']>;
  bucketDimensionsMapId?: InputMaybe<Scalars['String']>;
  bucketDimensionsMapRequest?: InputMaybe<BucketDimensionsMapRequest>;
  maxParticipantsPerRound?: InputMaybe<Scalars['Int']>;
};

export type BattleRoyaleSpecificDetails = CompetitionSpecificDetails & MatchUpFormatSpecificDetails & PhasedCompetitionFormatSpecificDetails & {
  __typename: 'BattleRoyaleSpecificDetails';
  advanceFraction: Scalars['Float'];
  definedBucketDimensionsMap: BucketDimensionsMap;
  id: Scalars['String'];
  matchUpFormat: MatchUpFormat;
  maxRoundParticipants: Scalars['Int'];
  maybeMaxRoundParticipants: Maybe<Scalars['Int']>;
  maybeParticipantsInRound: Maybe<Scalars['Int']>;
};

export type BeedlePayment = {
  __typename: 'BeedlePayment';
  alternateTransactionId: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  currency: Scalars['String'];
  externalPaymentServiceId: Maybe<Scalars['String']>;
  id: Scalars['String'];
  internalPaymentServiceId: Scalars['String'];
  paymentType: Scalars['String'];
  purchaseTransactionId: Scalars['String'];
  received: Scalars['Date'];
};

/** Bot difficulty type determines the skill level at which bots compete at */
export enum BotDifficultyType {
  /** Sets bots to an easy level of competition */
  Easy = 'Easy',
  /** Sets bots to an expert level of competition */
  Expert = 'Expert',
  /** Sets bots to a hard level of competition */
  Hard = 'Hard',
  /** Sets bots to a normal level of competition */
  Normal = 'Normal'
}

export type Bots = {
  __typename: 'Bots';
  difficulty: BotDifficultyType;
  quota: Scalars['Int'];
};

/** An Exchange of Real World Currency for Swarmio Currency */
export type BoughtTransaction = SwarmioWalletTransactionWithMetadata & {
  __typename: 'BoughtTransaction';
  amount: Scalars['Float'];
  created: Scalars['Date'];
  id: Scalars['String'];
  notes: Maybe<Scalars['String']>;
  swarmioCurrencyItemCostPurchaseRequest: SwarmioCurrencyItemCostPurchaseRequest;
  swarmioCurrencyItemCostPurchaseRequestId: Scalars['String'];
  /** The type of transaction */
  transactionType: SwarmioWalletTransactionType;
  wallet: SwarmioWallet;
  walletId: Scalars['String'];
};

export type BracketModifications = {
  __typename: 'BracketModifications';
  bracketName: TournamentBracketName;
  phaseModifications: Array<PhaseModifications>;
};

export type BracketModificationsCreationRequest = {
  bracketName: TournamentBracketName;
  phaseModifications: Array<PhaseModificationsCreationRequest>;
};

export type BracketModificationsUpdateRequest = {
  bracketName: TournamentBracketName;
  phaseModifications: Array<PhaseModificationsUpdateRequest>;
};

/** A generic event stage participant */
export type BreakStrategy = {
  breakStrategyType: BreakStrategyType;
};

/** The type of Break Strategy */
export enum BreakStrategyType {
  FixedNumber = 'FixedNumber',
  MaximumParticipants = 'MaximumParticipants'
}

export type BucketDimensionsMap = {
  __typename: 'BucketDimensionsMap';
  allBucketMultipliers: Array<BucketMultipliers>;
  bucketLabel: Scalars['String'];
  id: Scalars['String'];
};

export type BucketDimensionsMapRequest = {
  bucketLabel: Scalars['String'];
  bucketMultipliersRequests: Array<BucketMultipliersRequest>;
};

export type BucketMultipliers = {
  __typename: 'BucketMultipliers';
  dimensionMultipliers: Array<DimensionMultiplier>;
  id: Scalars['String'];
  resultBucket: ResultBucket;
  staticValue: Maybe<Scalars['Float']>;
};

export type BucketMultipliersRequest = {
  dimensionMultiplierRequests: Array<DimensionMultiplierRequest>;
  resultBucketRequest: ResultBucketRequest;
  staticValue?: InputMaybe<Scalars['Float']>;
};

export type CsgoCompetitionDetails = GameSpecificCompetitionDetails & GameSpecificDetails & {
  __typename: 'CSGOCompetitionDetails';
  gameId: Scalars['String'];
  maxOvertimeRounds: Maybe<Scalars['Int']>;
  maxRounds: Maybe<Scalars['Int']>;
};

export type CsgoMatchDetails = GameSpecificCompetitionDetails & GameSpecificDetails & {
  __typename: 'CSGOMatchDetails';
  gameId: Scalars['String'];
  serverDetails: ServerDetails;
};

export type CsvFile = {
  __typename: 'CSVFile';
  availableProducts: Maybe<Scalars['Int']>;
  availableVouchers: Maybe<Scalars['Int']>;
  createdBy: Maybe<Scalars['Int']>;
  createdDate: Maybe<Scalars['String']>;
  fileName: Maybe<Scalars['String']>;
  fileStatus: Maybe<FileStatus>;
  fileUrl: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  modifiedBy: Maybe<Scalars['Int']>;
  modifiedDate: Maybe<Scalars['String']>;
  supplier: Maybe<Supplier>;
  totalProducts: Maybe<Scalars['Int']>;
  totalVouchers: Maybe<Scalars['Int']>;
};

/** An Exchange of Swarmio Currency for Real World Currency */
export type CashOutTransaction = SwarmioWalletTransactionWithMetadata & {
  __typename: 'CashOutTransaction';
  amount: Scalars['Float'];
  created: Scalars['Date'];
  id: Scalars['String'];
  notes: Maybe<Scalars['String']>;
  swarmioCurrencyPayoutRequest: SwarmioCurrencyPayoutRequest;
  swarmioCurrencyPayoutRequestId: Scalars['String'];
  /** The type of transaction */
  transactionType: SwarmioWalletTransactionType;
  wallet: SwarmioWallet;
  walletId: Scalars['String'];
};

export type Catalog = {
  __typename: 'Catalog';
  catalogId: Maybe<Scalars['ID']>;
  catalogName: Maybe<Scalars['String']>;
  categoryOrder: Maybe<Scalars['String']>;
  createdBy: Maybe<Scalars['Int']>;
  createdDate: Maybe<Scalars['String']>;
  itemOrder: Maybe<Scalars['String']>;
  partner: Maybe<Partner>;
};

export type CatalogFilterInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  itemName?: InputMaybe<Scalars['String']>;
  itemStatus?: InputMaybe<ItemStatus>;
  itemType?: InputMaybe<ItemType>;
};

export type CatalogInput = {
  catalogId: Scalars['ID'];
  catalogName?: InputMaybe<Scalars['String']>;
  categoryOrder?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['Int']>;
  createdDate?: InputMaybe<Scalars['String']>;
  itemOrder?: InputMaybe<Scalars['String']>;
};

export type CatalogItem = {
  __typename: 'CatalogItem';
  availablePaymentChannels: Maybe<Array<Maybe<Scalars['String']>>>;
  contentType: Maybe<ContentType>;
  deal: Maybe<CatalogItemDeal>;
  displayName: Maybe<Scalars['String']>;
  fields: Maybe<Scalars['Object']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  itemDescBrief: Maybe<Scalars['String']>;
  itemDescDetail: Maybe<Scalars['String']>;
  itemGalleryUrls: Maybe<Array<Maybe<Scalars['String']>>>;
  itemId: Scalars['ID'];
  itemImageUrl: Maybe<Scalars['String']>;
  itemName: Maybe<Scalars['String']>;
  itemType: Maybe<ItemType>;
  outOfStockImageUrl: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['ID']>;
  productOrigin: Maybe<OrderStrategy>;
  productPrices: Maybe<Array<Maybe<ProductPrice>>>;
  productType: Maybe<ProductType>;
  sourceCurrency: Maybe<Scalars['String']>;
  stock: Maybe<Scalars['Int']>;
};

export type CatalogItemDeal = {
  __typename: 'CatalogItemDeal';
  dealActivePaymentChannels: Maybe<Array<Maybe<Scalars['String']>>>;
  dealId: Maybe<Scalars['ID']>;
  dealName: Maybe<Scalars['String']>;
  dealPercentage: Maybe<Scalars['Float']>;
  endDateTime: Maybe<Scalars['String']>;
  isActive: Maybe<Scalars['Boolean']>;
  startDateTime: Maybe<Scalars['String']>;
};

export type CatalogMappingDto = {
  __typename: 'CatalogMappingDto';
  catalogId: Maybe<Scalars['Int']>;
  catalogName: Maybe<Scalars['String']>;
  dealExist: Maybe<Scalars['Boolean']>;
};

export type CatalogSearchInput = {
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type CatalogSortInput = {
  order?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<Scalars['String']>;
};

export type Category = {
  __typename: 'Category';
  categoryCoverImage: Maybe<Scalars['String']>;
  categoryDescription: Maybe<Scalars['String']>;
  categoryIcon: Maybe<Scalars['String']>;
  categoryId: Maybe<Scalars['String']>;
  categoryImage: Maybe<Scalars['String']>;
  categoryName: Maybe<Scalars['String']>;
  featured: Maybe<Scalars['Boolean']>;
  groupOrder: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  parentCategory: Maybe<Scalars['Int']>;
  productGroupCatalogCategory: Maybe<Array<Maybe<ProductGroupCatalogCategory>>>;
  urlMask: Maybe<Scalars['String']>;
};

export type CategoryCatalog = {
  __typename: 'CategoryCatalog';
  categoryCoverImage: Maybe<Scalars['String']>;
  categoryDescription: Maybe<Scalars['String']>;
  categoryIcon: Maybe<Scalars['String']>;
  categoryId: Maybe<Scalars['String']>;
  categoryImage: Maybe<Scalars['String']>;
  categoryName: Maybe<Scalars['String']>;
  featured: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['ID']>;
  productGroups: Maybe<Array<Maybe<CategoryProductGroupResponse>>>;
  urlMask: Maybe<Scalars['String']>;
};

export type CategoryCatalogResponse = {
  __typename: 'CategoryCatalogResponse';
  categories: Maybe<Array<Maybe<CategoryCatalog>>>;
  currentPage: Maybe<Scalars['Int']>;
  totalCategories: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
};

export type CategoryDto = {
  __typename: 'CategoryDto';
  categoryCoverImage: Maybe<Scalars['String']>;
  categoryDescription: Maybe<Scalars['String']>;
  categoryIcon: Maybe<Scalars['String']>;
  categoryId: Maybe<Scalars['String']>;
  categoryImage: Maybe<Scalars['String']>;
  categoryName: Maybe<Scalars['String']>;
  featured: Maybe<Scalars['Boolean']>;
  groupCount: Maybe<Scalars['Int']>;
  groupOrder: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  mappedPartners: Maybe<Array<Maybe<Scalars['String']>>>;
  parentCategory: Maybe<Scalars['Int']>;
  productGroupCatalogCategory: Maybe<Array<Maybe<ProductGroupCatalogCategory>>>;
};

export type CategoryFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  productGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CategoryInfo = {
  __typename: 'CategoryInfo';
  categoryCoverImage: Maybe<Scalars['String']>;
  categoryDescription: Maybe<Scalars['String']>;
  categoryIcon: Maybe<Scalars['String']>;
  categoryId: Maybe<Scalars['String']>;
  categoryImage: Maybe<Scalars['String']>;
  categoryName: Maybe<Scalars['String']>;
  featured: Maybe<Scalars['Boolean']>;
  groupOrder: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  parentCategory: Maybe<Scalars['Int']>;
  productGroupCatalogCategory: Maybe<Array<Maybe<ProductGroupCatalogCategoryInfo>>>;
  urlMask: Maybe<Scalars['String']>;
};

export type CategoryLanguage = {
  __typename: 'CategoryLanguage';
  categoryId: Maybe<Scalars['String']>;
  categoryName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  languages: Maybe<Array<Maybe<LanguageDto>>>;
  unConfiguredLanguageIds: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type CategoryLanguageDataInput = {
  categoryDescription?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  categoryName?: InputMaybe<Scalars['String']>;
  languageId?: InputMaybe<Scalars['ID']>;
};

export type CategoryLanguageDataResponse = {
  __typename: 'CategoryLanguageDataResponse';
  categoryDescription: Maybe<Scalars['String']>;
  categoryId: Maybe<Scalars['ID']>;
  categoryName: Maybe<Scalars['String']>;
};

export type CategoryLanguageDetails = {
  __typename: 'CategoryLanguageDetails';
  categoryDescription: Maybe<Scalars['String']>;
  categoryId: Maybe<Scalars['ID']>;
  categoryName: Maybe<Scalars['String']>;
  countryCode: Maybe<Scalars['String']>;
  isDefault: Maybe<Scalars['Boolean']>;
  isLanguageConfigured: Maybe<Scalars['Boolean']>;
  languageCode: Maybe<Scalars['String']>;
  languageId: Maybe<Scalars['ID']>;
  languageName: Maybe<Scalars['String']>;
  mappedPartnerLanguage: Maybe<Scalars['Boolean']>;
};

export type CategoryListInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type CategoryProductGroupResponse = {
  __typename: 'CategoryProductGroupResponse';
  bannerImage: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  featured: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['ID']>;
  items: Maybe<Array<Maybe<CatalogItem>>>;
  name: Maybe<Scalars['String']>;
  productGroupId: Maybe<Scalars['String']>;
  thumbnail: Maybe<Scalars['String']>;
  urlMask: Maybe<Scalars['String']>;
};

export type CategoryResponseData = {
  __typename: 'CategoryResponseData';
  categories: Maybe<Array<Maybe<CategoryDto>>>;
  currentPage: Maybe<Scalars['Int']>;
  totalActiveCategories: Maybe<Scalars['Int']>;
  totalCategories: Maybe<Scalars['Int']>;
  totalDeletedCategories: Maybe<Scalars['Int']>;
  totalFilteredCategories: Maybe<Scalars['Int']>;
  totalInactiveCategories: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
};

/** A challenge */
export type Challenge = Competition & {
  __typename: 'Challenge';
  challengeFormat: ChallengeFormat;
  competitionSpecificDetails: Maybe<ChallengeSpecificDetails>;
  competitionState: EventElementState;
  competitionTiming: Maybe<CompetitionTiming>;
  competitionType: CompetitionType;
  created: Scalars['Date'];
  event: Event;
  eventId: Scalars['String'];
  eventStageId: Scalars['String'];
  game: Game;
  gameId: Scalars['String'];
  gameSpecificDetails: Maybe<GameSpecificCompetitionDetails>;
  id: Scalars['String'];
  manualAdvancement: Scalars['Boolean'];
  participantType: ParticipantType;
  participants: Array<CompetitionParticipantReference>;
};

export type ChallengeCreationRequest = {
  challengeFormat: ChallengeFormat;
  ladderSpecificDetails?: InputMaybe<LadderDetailsCreationRequest>;
  manualAdvancement: Scalars['Boolean'];
  startTime?: InputMaybe<Scalars['Date']>;
  valorantCompetitionDetailsCreationRequest?: InputMaybe<ValorantCompetitionDetailsCreationRequest>;
};

export enum ChallengeFormat {
  Basic = 'Basic',
  Ladder = 'Ladder',
  TopScore = 'TopScore'
}

export type ChallengeSpecificDetails = {
  ChallengeFormat: ChallengeFormat;
  id: Scalars['String'];
};

export enum CheckInMode {
  Captain = 'Captain',
  Disabled = 'Disabled',
  Everyone = 'Everyone'
}

export type ClientNotificationCreationRequest = {
  defaultMessage: Scalars['String'];
  expiry?: InputMaybe<Scalars['Date']>;
  fields?: InputMaybe<Scalars['JsonObject']>;
  notificationType: Scalars['String'];
  targetId?: InputMaybe<Scalars['String']>;
};

export type ClientNotificationEvent = StreamingEvent & {
  __typename: 'ClientNotificationEvent';
  created: Scalars['Date'];
  defaultMessage: Scalars['String'];
  expiry: Scalars['Date'];
  fields: Maybe<Scalars['JsonObject']>;
  id: Scalars['String'];
  notificationType: Scalars['String'];
  targetId: Maybe<Scalars['String']>;
};

export type ClientVisibleError = {
  isError: Scalars['Boolean'];
  message: Scalars['String'];
};

export type CmsBanner = {
  __typename: 'CmsBanner';
  createdAt: Maybe<Scalars['DateTime']>;
  featuredImage: CmsMedia;
  id: Scalars['String'];
  link: Maybe<Scalars['String']>;
  relatedPost: Maybe<CmsBlogPost>;
  title: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type CmsBanner_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsBanner_FeaturedImage_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsBanner_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsBanner_Link_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsBanner_RelatedPost_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsBanner_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsBanner_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsBanner_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsBanner_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsBanner_Where_Or>>>;
  createdAt?: InputMaybe<CmsBanner_CreatedAt_Operator>;
  featuredImage?: InputMaybe<CmsBanner_FeaturedImage_Operator>;
  id?: InputMaybe<CmsBanner_Id_Operator>;
  link?: InputMaybe<CmsBanner_Link_Operator>;
  relatedPost?: InputMaybe<CmsBanner_RelatedPost_Operator>;
  title?: InputMaybe<CmsBanner_Title_Operator>;
  updatedAt?: InputMaybe<CmsBanner_UpdatedAt_Operator>;
};

export type CmsBanner_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsBanner_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsBanner_Where_Or>>>;
  createdAt?: InputMaybe<CmsBanner_CreatedAt_Operator>;
  featuredImage?: InputMaybe<CmsBanner_FeaturedImage_Operator>;
  id?: InputMaybe<CmsBanner_Id_Operator>;
  link?: InputMaybe<CmsBanner_Link_Operator>;
  relatedPost?: InputMaybe<CmsBanner_RelatedPost_Operator>;
  title?: InputMaybe<CmsBanner_Title_Operator>;
  updatedAt?: InputMaybe<CmsBanner_UpdatedAt_Operator>;
};

export type CmsBanner_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsBanner_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsBanner_Where_Or>>>;
  createdAt?: InputMaybe<CmsBanner_CreatedAt_Operator>;
  featuredImage?: InputMaybe<CmsBanner_FeaturedImage_Operator>;
  id?: InputMaybe<CmsBanner_Id_Operator>;
  link?: InputMaybe<CmsBanner_Link_Operator>;
  relatedPost?: InputMaybe<CmsBanner_RelatedPost_Operator>;
  title?: InputMaybe<CmsBanner_Title_Operator>;
  updatedAt?: InputMaybe<CmsBanner_UpdatedAt_Operator>;
};

export type CmsBanners = {
  __typename: 'CmsBanners';
  docs: Array<CmsBanner>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  nextPage: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  pagingCounter: Scalars['Int'];
  prevPage: Maybe<Scalars['Int']>;
  totalDocs: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type CmsBannersCreateAccess = {
  __typename: 'CmsBannersCreateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBannersCreateDocAccess = {
  __typename: 'CmsBannersCreateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBannersDeleteAccess = {
  __typename: 'CmsBannersDeleteAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBannersDeleteDocAccess = {
  __typename: 'CmsBannersDeleteDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBannersDocAccessFields = {
  __typename: 'CmsBannersDocAccessFields';
  createdAt: Maybe<CmsBannersDocAccessFields_CreatedAt>;
  featuredImage: Maybe<CmsBannersDocAccessFields_FeaturedImage>;
  link: Maybe<CmsBannersDocAccessFields_Link>;
  relatedPost: Maybe<CmsBannersDocAccessFields_RelatedPost>;
  title: Maybe<CmsBannersDocAccessFields_Title>;
  updatedAt: Maybe<CmsBannersDocAccessFields_UpdatedAt>;
};

export type CmsBannersDocAccessFields_CreatedAt = {
  __typename: 'CmsBannersDocAccessFields_createdAt';
  create: Maybe<CmsBannersDocAccessFields_CreatedAt_Create>;
  delete: Maybe<CmsBannersDocAccessFields_CreatedAt_Delete>;
  read: Maybe<CmsBannersDocAccessFields_CreatedAt_Read>;
  update: Maybe<CmsBannersDocAccessFields_CreatedAt_Update>;
};

export type CmsBannersDocAccessFields_CreatedAt_Create = {
  __typename: 'CmsBannersDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_CreatedAt_Delete = {
  __typename: 'CmsBannersDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_CreatedAt_Read = {
  __typename: 'CmsBannersDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_CreatedAt_Update = {
  __typename: 'CmsBannersDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_FeaturedImage = {
  __typename: 'CmsBannersDocAccessFields_featuredImage';
  create: Maybe<CmsBannersDocAccessFields_FeaturedImage_Create>;
  delete: Maybe<CmsBannersDocAccessFields_FeaturedImage_Delete>;
  read: Maybe<CmsBannersDocAccessFields_FeaturedImage_Read>;
  update: Maybe<CmsBannersDocAccessFields_FeaturedImage_Update>;
};

export type CmsBannersDocAccessFields_FeaturedImage_Create = {
  __typename: 'CmsBannersDocAccessFields_featuredImage_Create';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_FeaturedImage_Delete = {
  __typename: 'CmsBannersDocAccessFields_featuredImage_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_FeaturedImage_Read = {
  __typename: 'CmsBannersDocAccessFields_featuredImage_Read';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_FeaturedImage_Update = {
  __typename: 'CmsBannersDocAccessFields_featuredImage_Update';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_Link = {
  __typename: 'CmsBannersDocAccessFields_link';
  create: Maybe<CmsBannersDocAccessFields_Link_Create>;
  delete: Maybe<CmsBannersDocAccessFields_Link_Delete>;
  read: Maybe<CmsBannersDocAccessFields_Link_Read>;
  update: Maybe<CmsBannersDocAccessFields_Link_Update>;
};

export type CmsBannersDocAccessFields_Link_Create = {
  __typename: 'CmsBannersDocAccessFields_link_Create';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_Link_Delete = {
  __typename: 'CmsBannersDocAccessFields_link_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_Link_Read = {
  __typename: 'CmsBannersDocAccessFields_link_Read';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_Link_Update = {
  __typename: 'CmsBannersDocAccessFields_link_Update';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_RelatedPost = {
  __typename: 'CmsBannersDocAccessFields_relatedPost';
  create: Maybe<CmsBannersDocAccessFields_RelatedPost_Create>;
  delete: Maybe<CmsBannersDocAccessFields_RelatedPost_Delete>;
  read: Maybe<CmsBannersDocAccessFields_RelatedPost_Read>;
  update: Maybe<CmsBannersDocAccessFields_RelatedPost_Update>;
};

export type CmsBannersDocAccessFields_RelatedPost_Create = {
  __typename: 'CmsBannersDocAccessFields_relatedPost_Create';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_RelatedPost_Delete = {
  __typename: 'CmsBannersDocAccessFields_relatedPost_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_RelatedPost_Read = {
  __typename: 'CmsBannersDocAccessFields_relatedPost_Read';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_RelatedPost_Update = {
  __typename: 'CmsBannersDocAccessFields_relatedPost_Update';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_Title = {
  __typename: 'CmsBannersDocAccessFields_title';
  create: Maybe<CmsBannersDocAccessFields_Title_Create>;
  delete: Maybe<CmsBannersDocAccessFields_Title_Delete>;
  read: Maybe<CmsBannersDocAccessFields_Title_Read>;
  update: Maybe<CmsBannersDocAccessFields_Title_Update>;
};

export type CmsBannersDocAccessFields_Title_Create = {
  __typename: 'CmsBannersDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_Title_Delete = {
  __typename: 'CmsBannersDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_Title_Read = {
  __typename: 'CmsBannersDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_Title_Update = {
  __typename: 'CmsBannersDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_UpdatedAt = {
  __typename: 'CmsBannersDocAccessFields_updatedAt';
  create: Maybe<CmsBannersDocAccessFields_UpdatedAt_Create>;
  delete: Maybe<CmsBannersDocAccessFields_UpdatedAt_Delete>;
  read: Maybe<CmsBannersDocAccessFields_UpdatedAt_Read>;
  update: Maybe<CmsBannersDocAccessFields_UpdatedAt_Update>;
};

export type CmsBannersDocAccessFields_UpdatedAt_Create = {
  __typename: 'CmsBannersDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_UpdatedAt_Delete = {
  __typename: 'CmsBannersDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_UpdatedAt_Read = {
  __typename: 'CmsBannersDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsBannersDocAccessFields_UpdatedAt_Update = {
  __typename: 'CmsBannersDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields = {
  __typename: 'CmsBannersFields';
  createdAt: Maybe<CmsBannersFields_CreatedAt>;
  featuredImage: Maybe<CmsBannersFields_FeaturedImage>;
  link: Maybe<CmsBannersFields_Link>;
  relatedPost: Maybe<CmsBannersFields_RelatedPost>;
  title: Maybe<CmsBannersFields_Title>;
  updatedAt: Maybe<CmsBannersFields_UpdatedAt>;
};

export type CmsBannersFields_CreatedAt = {
  __typename: 'CmsBannersFields_createdAt';
  create: Maybe<CmsBannersFields_CreatedAt_Create>;
  delete: Maybe<CmsBannersFields_CreatedAt_Delete>;
  read: Maybe<CmsBannersFields_CreatedAt_Read>;
  update: Maybe<CmsBannersFields_CreatedAt_Update>;
};

export type CmsBannersFields_CreatedAt_Create = {
  __typename: 'CmsBannersFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_CreatedAt_Delete = {
  __typename: 'CmsBannersFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_CreatedAt_Read = {
  __typename: 'CmsBannersFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_CreatedAt_Update = {
  __typename: 'CmsBannersFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_FeaturedImage = {
  __typename: 'CmsBannersFields_featuredImage';
  create: Maybe<CmsBannersFields_FeaturedImage_Create>;
  delete: Maybe<CmsBannersFields_FeaturedImage_Delete>;
  read: Maybe<CmsBannersFields_FeaturedImage_Read>;
  update: Maybe<CmsBannersFields_FeaturedImage_Update>;
};

export type CmsBannersFields_FeaturedImage_Create = {
  __typename: 'CmsBannersFields_featuredImage_Create';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_FeaturedImage_Delete = {
  __typename: 'CmsBannersFields_featuredImage_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_FeaturedImage_Read = {
  __typename: 'CmsBannersFields_featuredImage_Read';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_FeaturedImage_Update = {
  __typename: 'CmsBannersFields_featuredImage_Update';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_Link = {
  __typename: 'CmsBannersFields_link';
  create: Maybe<CmsBannersFields_Link_Create>;
  delete: Maybe<CmsBannersFields_Link_Delete>;
  read: Maybe<CmsBannersFields_Link_Read>;
  update: Maybe<CmsBannersFields_Link_Update>;
};

export type CmsBannersFields_Link_Create = {
  __typename: 'CmsBannersFields_link_Create';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_Link_Delete = {
  __typename: 'CmsBannersFields_link_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_Link_Read = {
  __typename: 'CmsBannersFields_link_Read';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_Link_Update = {
  __typename: 'CmsBannersFields_link_Update';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_RelatedPost = {
  __typename: 'CmsBannersFields_relatedPost';
  create: Maybe<CmsBannersFields_RelatedPost_Create>;
  delete: Maybe<CmsBannersFields_RelatedPost_Delete>;
  read: Maybe<CmsBannersFields_RelatedPost_Read>;
  update: Maybe<CmsBannersFields_RelatedPost_Update>;
};

export type CmsBannersFields_RelatedPost_Create = {
  __typename: 'CmsBannersFields_relatedPost_Create';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_RelatedPost_Delete = {
  __typename: 'CmsBannersFields_relatedPost_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_RelatedPost_Read = {
  __typename: 'CmsBannersFields_relatedPost_Read';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_RelatedPost_Update = {
  __typename: 'CmsBannersFields_relatedPost_Update';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_Title = {
  __typename: 'CmsBannersFields_title';
  create: Maybe<CmsBannersFields_Title_Create>;
  delete: Maybe<CmsBannersFields_Title_Delete>;
  read: Maybe<CmsBannersFields_Title_Read>;
  update: Maybe<CmsBannersFields_Title_Update>;
};

export type CmsBannersFields_Title_Create = {
  __typename: 'CmsBannersFields_title_Create';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_Title_Delete = {
  __typename: 'CmsBannersFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_Title_Read = {
  __typename: 'CmsBannersFields_title_Read';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_Title_Update = {
  __typename: 'CmsBannersFields_title_Update';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_UpdatedAt = {
  __typename: 'CmsBannersFields_updatedAt';
  create: Maybe<CmsBannersFields_UpdatedAt_Create>;
  delete: Maybe<CmsBannersFields_UpdatedAt_Delete>;
  read: Maybe<CmsBannersFields_UpdatedAt_Read>;
  update: Maybe<CmsBannersFields_UpdatedAt_Update>;
};

export type CmsBannersFields_UpdatedAt_Create = {
  __typename: 'CmsBannersFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_UpdatedAt_Delete = {
  __typename: 'CmsBannersFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_UpdatedAt_Read = {
  __typename: 'CmsBannersFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsBannersFields_UpdatedAt_Update = {
  __typename: 'CmsBannersFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsBannersReadAccess = {
  __typename: 'CmsBannersReadAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBannersReadDocAccess = {
  __typename: 'CmsBannersReadDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBannersUpdateAccess = {
  __typename: 'CmsBannersUpdateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBannersUpdateDocAccess = {
  __typename: 'CmsBannersUpdateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPage = {
  __typename: 'CmsBlogPage';
  createdAt: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  sections: Maybe<Array<CmsBlogPage_Sections>>;
  slug: Scalars['String'];
  status: Maybe<CmsBlogPage_Status>;
  title: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum CmsBlogPageUpdate_Sections_SectionType_MutationInput {
  FeaturedBanners = 'featuredBanners',
  FeaturedBlogPosts = 'featuredBlogPosts',
  FeaturedGamers = 'featuredGamers',
  FeaturedGames = 'featuredGames'
}

export enum CmsBlogPageUpdate_Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type CmsBlogPage_Sections = {
  __typename: 'CmsBlogPage_Sections';
  featuredBanners: Maybe<Array<CmsBanner>>;
  featuredBlogPosts: Maybe<Array<CmsBlogPost>>;
  featuredGamers: Maybe<Array<CmsGamer>>;
  featuredGames: Maybe<Array<CmsGame>>;
  id: Maybe<Scalars['String']>;
  sectionTitle: Maybe<Scalars['String']>;
  sectionType: Maybe<CmsBlogPage_Sections_SectionType>;
};

export enum CmsBlogPage_Sections_SectionType {
  FeaturedBanners = 'featuredBanners',
  FeaturedBlogPosts = 'featuredBlogPosts',
  FeaturedGamers = 'featuredGamers',
  FeaturedGames = 'featuredGames'
}

export enum CmsBlogPage_Sections_SectionType_MutationInput {
  FeaturedBanners = 'featuredBanners',
  FeaturedBlogPosts = 'featuredBlogPosts',
  FeaturedGamers = 'featuredGamers',
  FeaturedGames = 'featuredGames'
}

export type CmsBlogPage_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsBlogPage_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsBlogPage_Sections__FeaturedBanners_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsBlogPage_Sections__FeaturedBlogPosts_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsBlogPage_Sections__FeaturedGamers_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsBlogPage_Sections__FeaturedGames_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsBlogPage_Sections__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsBlogPage_Sections__SectionTitle_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum CmsBlogPage_Sections__SectionType_Input {
  FeaturedBanners = 'featuredBanners',
  FeaturedBlogPosts = 'featuredBlogPosts',
  FeaturedGamers = 'featuredGamers',
  FeaturedGames = 'featuredGames'
}

export type CmsBlogPage_Sections__SectionType_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsBlogPage_Sections__SectionType_Input>>>;
  equals?: InputMaybe<CmsBlogPage_Sections__SectionType_Input>;
  in?: InputMaybe<Array<InputMaybe<CmsBlogPage_Sections__SectionType_Input>>>;
  not_equals?: InputMaybe<CmsBlogPage_Sections__SectionType_Input>;
  not_in?: InputMaybe<Array<InputMaybe<CmsBlogPage_Sections__SectionType_Input>>>;
};

export type CmsBlogPage_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum CmsBlogPage_Status {
  Draft = 'draft',
  Published = 'published'
}

export enum CmsBlogPage_Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export enum CmsBlogPage_Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type CmsBlogPage_Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsBlogPage_Status_Input>>>;
  equals?: InputMaybe<CmsBlogPage_Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<CmsBlogPage_Status_Input>>>;
  not_equals?: InputMaybe<CmsBlogPage_Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<CmsBlogPage_Status_Input>>>;
};

export type CmsBlogPage_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsBlogPage_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsBlogPage_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsBlogPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsBlogPage_Where_Or>>>;
  createdAt?: InputMaybe<CmsBlogPage_CreatedAt_Operator>;
  id?: InputMaybe<CmsBlogPage_Id_Operator>;
  sections__featuredBanners?: InputMaybe<CmsBlogPage_Sections__FeaturedBanners_Operator>;
  sections__featuredBlogPosts?: InputMaybe<CmsBlogPage_Sections__FeaturedBlogPosts_Operator>;
  sections__featuredGamers?: InputMaybe<CmsBlogPage_Sections__FeaturedGamers_Operator>;
  sections__featuredGames?: InputMaybe<CmsBlogPage_Sections__FeaturedGames_Operator>;
  sections__id?: InputMaybe<CmsBlogPage_Sections__Id_Operator>;
  sections__sectionTitle?: InputMaybe<CmsBlogPage_Sections__SectionTitle_Operator>;
  sections__sectionType?: InputMaybe<CmsBlogPage_Sections__SectionType_Operator>;
  slug?: InputMaybe<CmsBlogPage_Slug_Operator>;
  status?: InputMaybe<CmsBlogPage_Status_Operator>;
  title?: InputMaybe<CmsBlogPage_Title_Operator>;
  updatedAt?: InputMaybe<CmsBlogPage_UpdatedAt_Operator>;
};

export type CmsBlogPage_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsBlogPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsBlogPage_Where_Or>>>;
  createdAt?: InputMaybe<CmsBlogPage_CreatedAt_Operator>;
  id?: InputMaybe<CmsBlogPage_Id_Operator>;
  sections__featuredBanners?: InputMaybe<CmsBlogPage_Sections__FeaturedBanners_Operator>;
  sections__featuredBlogPosts?: InputMaybe<CmsBlogPage_Sections__FeaturedBlogPosts_Operator>;
  sections__featuredGamers?: InputMaybe<CmsBlogPage_Sections__FeaturedGamers_Operator>;
  sections__featuredGames?: InputMaybe<CmsBlogPage_Sections__FeaturedGames_Operator>;
  sections__id?: InputMaybe<CmsBlogPage_Sections__Id_Operator>;
  sections__sectionTitle?: InputMaybe<CmsBlogPage_Sections__SectionTitle_Operator>;
  sections__sectionType?: InputMaybe<CmsBlogPage_Sections__SectionType_Operator>;
  slug?: InputMaybe<CmsBlogPage_Slug_Operator>;
  status?: InputMaybe<CmsBlogPage_Status_Operator>;
  title?: InputMaybe<CmsBlogPage_Title_Operator>;
  updatedAt?: InputMaybe<CmsBlogPage_UpdatedAt_Operator>;
};

export type CmsBlogPage_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsBlogPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsBlogPage_Where_Or>>>;
  createdAt?: InputMaybe<CmsBlogPage_CreatedAt_Operator>;
  id?: InputMaybe<CmsBlogPage_Id_Operator>;
  sections__featuredBanners?: InputMaybe<CmsBlogPage_Sections__FeaturedBanners_Operator>;
  sections__featuredBlogPosts?: InputMaybe<CmsBlogPage_Sections__FeaturedBlogPosts_Operator>;
  sections__featuredGamers?: InputMaybe<CmsBlogPage_Sections__FeaturedGamers_Operator>;
  sections__featuredGames?: InputMaybe<CmsBlogPage_Sections__FeaturedGames_Operator>;
  sections__id?: InputMaybe<CmsBlogPage_Sections__Id_Operator>;
  sections__sectionTitle?: InputMaybe<CmsBlogPage_Sections__SectionTitle_Operator>;
  sections__sectionType?: InputMaybe<CmsBlogPage_Sections__SectionType_Operator>;
  slug?: InputMaybe<CmsBlogPage_Slug_Operator>;
  status?: InputMaybe<CmsBlogPage_Status_Operator>;
  title?: InputMaybe<CmsBlogPage_Title_Operator>;
  updatedAt?: InputMaybe<CmsBlogPage_UpdatedAt_Operator>;
};

export type CmsBlogPages = {
  __typename: 'CmsBlogPages';
  docs: Array<CmsBlogPage>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  nextPage: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  pagingCounter: Scalars['Int'];
  prevPage: Maybe<Scalars['Int']>;
  totalDocs: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type CmsBlogPagesCreateAccess = {
  __typename: 'CmsBlogPagesCreateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPagesCreateDocAccess = {
  __typename: 'CmsBlogPagesCreateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPagesDeleteAccess = {
  __typename: 'CmsBlogPagesDeleteAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPagesDeleteDocAccess = {
  __typename: 'CmsBlogPagesDeleteDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPagesDocAccessFields = {
  __typename: 'CmsBlogPagesDocAccessFields';
  createdAt: Maybe<CmsBlogPagesDocAccessFields_CreatedAt>;
  sections: Maybe<CmsBlogPagesDocAccessFields_Sections>;
  slug: Maybe<CmsBlogPagesDocAccessFields_Slug>;
  status: Maybe<CmsBlogPagesDocAccessFields_Status>;
  title: Maybe<CmsBlogPagesDocAccessFields_Title>;
  updatedAt: Maybe<CmsBlogPagesDocAccessFields_UpdatedAt>;
};

export type CmsBlogPagesDocAccessFields_CreatedAt = {
  __typename: 'CmsBlogPagesDocAccessFields_createdAt';
  create: Maybe<CmsBlogPagesDocAccessFields_CreatedAt_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_CreatedAt_Delete>;
  read: Maybe<CmsBlogPagesDocAccessFields_CreatedAt_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_CreatedAt_Update>;
};

export type CmsBlogPagesDocAccessFields_CreatedAt_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_CreatedAt_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_CreatedAt_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_CreatedAt_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections = {
  __typename: 'CmsBlogPagesDocAccessFields_sections';
  create: Maybe<CmsBlogPagesDocAccessFields_Sections_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_Sections_Delete>;
  fields: Maybe<CmsBlogPagesDocAccessFields_Sections_Fields>;
  read: Maybe<CmsBlogPagesDocAccessFields_Sections_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_Sections_Update>;
};

export type CmsBlogPagesDocAccessFields_Sections_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_Fields = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_Fields';
  featuredBanners: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedBanners>;
  featuredBlogPosts: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedBlogPosts>;
  featuredGamers: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedGamers>;
  featuredGames: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedGames>;
  id: Maybe<CmsBlogPagesDocAccessFields_Sections_Id>;
  sectionTitle: Maybe<CmsBlogPagesDocAccessFields_Sections_SectionTitle>;
  sectionType: Maybe<CmsBlogPagesDocAccessFields_Sections_SectionType>;
};

export type CmsBlogPagesDocAccessFields_Sections_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedBanners = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredBanners';
  create: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedBanners_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedBanners_Delete>;
  read: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedBanners_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedBanners_Update>;
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedBanners_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredBanners_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedBanners_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredBanners_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedBanners_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredBanners_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedBanners_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredBanners_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedBlogPosts = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredBlogPosts';
  create: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedBlogPosts_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedBlogPosts_Delete>;
  read: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedBlogPosts_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedBlogPosts_Update>;
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedBlogPosts_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedBlogPosts_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedBlogPosts_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedBlogPosts_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedGamers = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredGamers';
  create: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedGamers_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedGamers_Delete>;
  read: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedGamers_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedGamers_Update>;
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedGamers_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredGamers_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedGamers_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredGamers_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedGamers_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredGamers_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedGamers_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredGamers_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedGames = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredGames';
  create: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedGames_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedGames_Delete>;
  read: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedGames_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_Sections_FeaturedGames_Update>;
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedGames_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredGames_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedGames_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredGames_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedGames_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredGames_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_FeaturedGames_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_featuredGames_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_Id = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_id';
  create: Maybe<CmsBlogPagesDocAccessFields_Sections_Id_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_Sections_Id_Delete>;
  read: Maybe<CmsBlogPagesDocAccessFields_Sections_Id_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_Sections_Id_Update>;
};

export type CmsBlogPagesDocAccessFields_Sections_Id_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_id_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_Id_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_id_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_Id_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_id_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_Id_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_id_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_SectionTitle = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_sectionTitle';
  create: Maybe<CmsBlogPagesDocAccessFields_Sections_SectionTitle_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_Sections_SectionTitle_Delete>;
  read: Maybe<CmsBlogPagesDocAccessFields_Sections_SectionTitle_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_Sections_SectionTitle_Update>;
};

export type CmsBlogPagesDocAccessFields_Sections_SectionTitle_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_sectionTitle_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_SectionTitle_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_sectionTitle_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_SectionTitle_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_sectionTitle_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_SectionTitle_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_sectionTitle_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_SectionType = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_sectionType';
  create: Maybe<CmsBlogPagesDocAccessFields_Sections_SectionType_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_Sections_SectionType_Delete>;
  read: Maybe<CmsBlogPagesDocAccessFields_Sections_SectionType_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_Sections_SectionType_Update>;
};

export type CmsBlogPagesDocAccessFields_Sections_SectionType_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_sectionType_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_SectionType_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_sectionType_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_SectionType_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_sectionType_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Sections_SectionType_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_sections_sectionType_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Slug = {
  __typename: 'CmsBlogPagesDocAccessFields_slug';
  create: Maybe<CmsBlogPagesDocAccessFields_Slug_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_Slug_Delete>;
  read: Maybe<CmsBlogPagesDocAccessFields_Slug_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_Slug_Update>;
};

export type CmsBlogPagesDocAccessFields_Slug_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Slug_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Slug_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Slug_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Status = {
  __typename: 'CmsBlogPagesDocAccessFields_status';
  create: Maybe<CmsBlogPagesDocAccessFields_Status_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_Status_Delete>;
  read: Maybe<CmsBlogPagesDocAccessFields_Status_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_Status_Update>;
};

export type CmsBlogPagesDocAccessFields_Status_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_status_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Status_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_status_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Status_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_status_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Status_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_status_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Title = {
  __typename: 'CmsBlogPagesDocAccessFields_title';
  create: Maybe<CmsBlogPagesDocAccessFields_Title_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_Title_Delete>;
  read: Maybe<CmsBlogPagesDocAccessFields_Title_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_Title_Update>;
};

export type CmsBlogPagesDocAccessFields_Title_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Title_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Title_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_Title_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_UpdatedAt = {
  __typename: 'CmsBlogPagesDocAccessFields_updatedAt';
  create: Maybe<CmsBlogPagesDocAccessFields_UpdatedAt_Create>;
  delete: Maybe<CmsBlogPagesDocAccessFields_UpdatedAt_Delete>;
  read: Maybe<CmsBlogPagesDocAccessFields_UpdatedAt_Read>;
  update: Maybe<CmsBlogPagesDocAccessFields_UpdatedAt_Update>;
};

export type CmsBlogPagesDocAccessFields_UpdatedAt_Create = {
  __typename: 'CmsBlogPagesDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_UpdatedAt_Delete = {
  __typename: 'CmsBlogPagesDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_UpdatedAt_Read = {
  __typename: 'CmsBlogPagesDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesDocAccessFields_UpdatedAt_Update = {
  __typename: 'CmsBlogPagesDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields = {
  __typename: 'CmsBlogPagesFields';
  createdAt: Maybe<CmsBlogPagesFields_CreatedAt>;
  sections: Maybe<CmsBlogPagesFields_Sections>;
  slug: Maybe<CmsBlogPagesFields_Slug>;
  status: Maybe<CmsBlogPagesFields_Status>;
  title: Maybe<CmsBlogPagesFields_Title>;
  updatedAt: Maybe<CmsBlogPagesFields_UpdatedAt>;
};

export type CmsBlogPagesFields_CreatedAt = {
  __typename: 'CmsBlogPagesFields_createdAt';
  create: Maybe<CmsBlogPagesFields_CreatedAt_Create>;
  delete: Maybe<CmsBlogPagesFields_CreatedAt_Delete>;
  read: Maybe<CmsBlogPagesFields_CreatedAt_Read>;
  update: Maybe<CmsBlogPagesFields_CreatedAt_Update>;
};

export type CmsBlogPagesFields_CreatedAt_Create = {
  __typename: 'CmsBlogPagesFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_CreatedAt_Delete = {
  __typename: 'CmsBlogPagesFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_CreatedAt_Read = {
  __typename: 'CmsBlogPagesFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_CreatedAt_Update = {
  __typename: 'CmsBlogPagesFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections = {
  __typename: 'CmsBlogPagesFields_sections';
  create: Maybe<CmsBlogPagesFields_Sections_Create>;
  delete: Maybe<CmsBlogPagesFields_Sections_Delete>;
  fields: Maybe<CmsBlogPagesFields_Sections_Fields>;
  read: Maybe<CmsBlogPagesFields_Sections_Read>;
  update: Maybe<CmsBlogPagesFields_Sections_Update>;
};

export type CmsBlogPagesFields_Sections_Create = {
  __typename: 'CmsBlogPagesFields_sections_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_Delete = {
  __typename: 'CmsBlogPagesFields_sections_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_Fields = {
  __typename: 'CmsBlogPagesFields_sections_Fields';
  featuredBanners: Maybe<CmsBlogPagesFields_Sections_FeaturedBanners>;
  featuredBlogPosts: Maybe<CmsBlogPagesFields_Sections_FeaturedBlogPosts>;
  featuredGamers: Maybe<CmsBlogPagesFields_Sections_FeaturedGamers>;
  featuredGames: Maybe<CmsBlogPagesFields_Sections_FeaturedGames>;
  id: Maybe<CmsBlogPagesFields_Sections_Id>;
  sectionTitle: Maybe<CmsBlogPagesFields_Sections_SectionTitle>;
  sectionType: Maybe<CmsBlogPagesFields_Sections_SectionType>;
};

export type CmsBlogPagesFields_Sections_Read = {
  __typename: 'CmsBlogPagesFields_sections_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_Update = {
  __typename: 'CmsBlogPagesFields_sections_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedBanners = {
  __typename: 'CmsBlogPagesFields_sections_featuredBanners';
  create: Maybe<CmsBlogPagesFields_Sections_FeaturedBanners_Create>;
  delete: Maybe<CmsBlogPagesFields_Sections_FeaturedBanners_Delete>;
  read: Maybe<CmsBlogPagesFields_Sections_FeaturedBanners_Read>;
  update: Maybe<CmsBlogPagesFields_Sections_FeaturedBanners_Update>;
};

export type CmsBlogPagesFields_Sections_FeaturedBanners_Create = {
  __typename: 'CmsBlogPagesFields_sections_featuredBanners_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedBanners_Delete = {
  __typename: 'CmsBlogPagesFields_sections_featuredBanners_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedBanners_Read = {
  __typename: 'CmsBlogPagesFields_sections_featuredBanners_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedBanners_Update = {
  __typename: 'CmsBlogPagesFields_sections_featuredBanners_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedBlogPosts = {
  __typename: 'CmsBlogPagesFields_sections_featuredBlogPosts';
  create: Maybe<CmsBlogPagesFields_Sections_FeaturedBlogPosts_Create>;
  delete: Maybe<CmsBlogPagesFields_Sections_FeaturedBlogPosts_Delete>;
  read: Maybe<CmsBlogPagesFields_Sections_FeaturedBlogPosts_Read>;
  update: Maybe<CmsBlogPagesFields_Sections_FeaturedBlogPosts_Update>;
};

export type CmsBlogPagesFields_Sections_FeaturedBlogPosts_Create = {
  __typename: 'CmsBlogPagesFields_sections_featuredBlogPosts_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedBlogPosts_Delete = {
  __typename: 'CmsBlogPagesFields_sections_featuredBlogPosts_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedBlogPosts_Read = {
  __typename: 'CmsBlogPagesFields_sections_featuredBlogPosts_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedBlogPosts_Update = {
  __typename: 'CmsBlogPagesFields_sections_featuredBlogPosts_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedGamers = {
  __typename: 'CmsBlogPagesFields_sections_featuredGamers';
  create: Maybe<CmsBlogPagesFields_Sections_FeaturedGamers_Create>;
  delete: Maybe<CmsBlogPagesFields_Sections_FeaturedGamers_Delete>;
  read: Maybe<CmsBlogPagesFields_Sections_FeaturedGamers_Read>;
  update: Maybe<CmsBlogPagesFields_Sections_FeaturedGamers_Update>;
};

export type CmsBlogPagesFields_Sections_FeaturedGamers_Create = {
  __typename: 'CmsBlogPagesFields_sections_featuredGamers_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedGamers_Delete = {
  __typename: 'CmsBlogPagesFields_sections_featuredGamers_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedGamers_Read = {
  __typename: 'CmsBlogPagesFields_sections_featuredGamers_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedGamers_Update = {
  __typename: 'CmsBlogPagesFields_sections_featuredGamers_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedGames = {
  __typename: 'CmsBlogPagesFields_sections_featuredGames';
  create: Maybe<CmsBlogPagesFields_Sections_FeaturedGames_Create>;
  delete: Maybe<CmsBlogPagesFields_Sections_FeaturedGames_Delete>;
  read: Maybe<CmsBlogPagesFields_Sections_FeaturedGames_Read>;
  update: Maybe<CmsBlogPagesFields_Sections_FeaturedGames_Update>;
};

export type CmsBlogPagesFields_Sections_FeaturedGames_Create = {
  __typename: 'CmsBlogPagesFields_sections_featuredGames_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedGames_Delete = {
  __typename: 'CmsBlogPagesFields_sections_featuredGames_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedGames_Read = {
  __typename: 'CmsBlogPagesFields_sections_featuredGames_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_FeaturedGames_Update = {
  __typename: 'CmsBlogPagesFields_sections_featuredGames_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_Id = {
  __typename: 'CmsBlogPagesFields_sections_id';
  create: Maybe<CmsBlogPagesFields_Sections_Id_Create>;
  delete: Maybe<CmsBlogPagesFields_Sections_Id_Delete>;
  read: Maybe<CmsBlogPagesFields_Sections_Id_Read>;
  update: Maybe<CmsBlogPagesFields_Sections_Id_Update>;
};

export type CmsBlogPagesFields_Sections_Id_Create = {
  __typename: 'CmsBlogPagesFields_sections_id_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_Id_Delete = {
  __typename: 'CmsBlogPagesFields_sections_id_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_Id_Read = {
  __typename: 'CmsBlogPagesFields_sections_id_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_Id_Update = {
  __typename: 'CmsBlogPagesFields_sections_id_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_SectionTitle = {
  __typename: 'CmsBlogPagesFields_sections_sectionTitle';
  create: Maybe<CmsBlogPagesFields_Sections_SectionTitle_Create>;
  delete: Maybe<CmsBlogPagesFields_Sections_SectionTitle_Delete>;
  read: Maybe<CmsBlogPagesFields_Sections_SectionTitle_Read>;
  update: Maybe<CmsBlogPagesFields_Sections_SectionTitle_Update>;
};

export type CmsBlogPagesFields_Sections_SectionTitle_Create = {
  __typename: 'CmsBlogPagesFields_sections_sectionTitle_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_SectionTitle_Delete = {
  __typename: 'CmsBlogPagesFields_sections_sectionTitle_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_SectionTitle_Read = {
  __typename: 'CmsBlogPagesFields_sections_sectionTitle_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_SectionTitle_Update = {
  __typename: 'CmsBlogPagesFields_sections_sectionTitle_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_SectionType = {
  __typename: 'CmsBlogPagesFields_sections_sectionType';
  create: Maybe<CmsBlogPagesFields_Sections_SectionType_Create>;
  delete: Maybe<CmsBlogPagesFields_Sections_SectionType_Delete>;
  read: Maybe<CmsBlogPagesFields_Sections_SectionType_Read>;
  update: Maybe<CmsBlogPagesFields_Sections_SectionType_Update>;
};

export type CmsBlogPagesFields_Sections_SectionType_Create = {
  __typename: 'CmsBlogPagesFields_sections_sectionType_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_SectionType_Delete = {
  __typename: 'CmsBlogPagesFields_sections_sectionType_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_SectionType_Read = {
  __typename: 'CmsBlogPagesFields_sections_sectionType_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Sections_SectionType_Update = {
  __typename: 'CmsBlogPagesFields_sections_sectionType_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Slug = {
  __typename: 'CmsBlogPagesFields_slug';
  create: Maybe<CmsBlogPagesFields_Slug_Create>;
  delete: Maybe<CmsBlogPagesFields_Slug_Delete>;
  read: Maybe<CmsBlogPagesFields_Slug_Read>;
  update: Maybe<CmsBlogPagesFields_Slug_Update>;
};

export type CmsBlogPagesFields_Slug_Create = {
  __typename: 'CmsBlogPagesFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Slug_Delete = {
  __typename: 'CmsBlogPagesFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Slug_Read = {
  __typename: 'CmsBlogPagesFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Slug_Update = {
  __typename: 'CmsBlogPagesFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Status = {
  __typename: 'CmsBlogPagesFields_status';
  create: Maybe<CmsBlogPagesFields_Status_Create>;
  delete: Maybe<CmsBlogPagesFields_Status_Delete>;
  read: Maybe<CmsBlogPagesFields_Status_Read>;
  update: Maybe<CmsBlogPagesFields_Status_Update>;
};

export type CmsBlogPagesFields_Status_Create = {
  __typename: 'CmsBlogPagesFields_status_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Status_Delete = {
  __typename: 'CmsBlogPagesFields_status_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Status_Read = {
  __typename: 'CmsBlogPagesFields_status_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Status_Update = {
  __typename: 'CmsBlogPagesFields_status_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Title = {
  __typename: 'CmsBlogPagesFields_title';
  create: Maybe<CmsBlogPagesFields_Title_Create>;
  delete: Maybe<CmsBlogPagesFields_Title_Delete>;
  read: Maybe<CmsBlogPagesFields_Title_Read>;
  update: Maybe<CmsBlogPagesFields_Title_Update>;
};

export type CmsBlogPagesFields_Title_Create = {
  __typename: 'CmsBlogPagesFields_title_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Title_Delete = {
  __typename: 'CmsBlogPagesFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Title_Read = {
  __typename: 'CmsBlogPagesFields_title_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_Title_Update = {
  __typename: 'CmsBlogPagesFields_title_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_UpdatedAt = {
  __typename: 'CmsBlogPagesFields_updatedAt';
  create: Maybe<CmsBlogPagesFields_UpdatedAt_Create>;
  delete: Maybe<CmsBlogPagesFields_UpdatedAt_Delete>;
  read: Maybe<CmsBlogPagesFields_UpdatedAt_Read>;
  update: Maybe<CmsBlogPagesFields_UpdatedAt_Update>;
};

export type CmsBlogPagesFields_UpdatedAt_Create = {
  __typename: 'CmsBlogPagesFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_UpdatedAt_Delete = {
  __typename: 'CmsBlogPagesFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_UpdatedAt_Read = {
  __typename: 'CmsBlogPagesFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesFields_UpdatedAt_Update = {
  __typename: 'CmsBlogPagesFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPagesReadAccess = {
  __typename: 'CmsBlogPagesReadAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPagesReadDocAccess = {
  __typename: 'CmsBlogPagesReadDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPagesUpdateAccess = {
  __typename: 'CmsBlogPagesUpdateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPagesUpdateDocAccess = {
  __typename: 'CmsBlogPagesUpdateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPost = {
  __typename: 'CmsBlogPost';
  content: Scalars['JSON'];
  createdAt: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  featuredImage: CmsMedia;
  id: Scalars['String'];
  relatedPosts: Maybe<Array<CmsBlogPost>>;
  title: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
  videos: Maybe<Array<CmsBlogPost_Videos>>;
};


export type CmsBlogPostContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type CmsBlogPost_Videos = {
  __typename: 'CmsBlogPost_Videos';
  embedId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type CmsBlogPost_Content_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type CmsBlogPost_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsBlogPost_Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type CmsBlogPost_FeaturedImage_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsBlogPost_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsBlogPost_RelatedPosts_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsBlogPost_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsBlogPost_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsBlogPost_Videos__EmbedId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsBlogPost_Videos__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsBlogPost_Videos__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsBlogPost_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsBlogPost_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsBlogPost_Where_Or>>>;
  content?: InputMaybe<CmsBlogPost_Content_Operator>;
  createdAt?: InputMaybe<CmsBlogPost_CreatedAt_Operator>;
  description?: InputMaybe<CmsBlogPost_Description_Operator>;
  featuredImage?: InputMaybe<CmsBlogPost_FeaturedImage_Operator>;
  id?: InputMaybe<CmsBlogPost_Id_Operator>;
  relatedPosts?: InputMaybe<CmsBlogPost_RelatedPosts_Operator>;
  title?: InputMaybe<CmsBlogPost_Title_Operator>;
  updatedAt?: InputMaybe<CmsBlogPost_UpdatedAt_Operator>;
  videos__embedId?: InputMaybe<CmsBlogPost_Videos__EmbedId_Operator>;
  videos__id?: InputMaybe<CmsBlogPost_Videos__Id_Operator>;
  videos__title?: InputMaybe<CmsBlogPost_Videos__Title_Operator>;
};

export type CmsBlogPost_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsBlogPost_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsBlogPost_Where_Or>>>;
  content?: InputMaybe<CmsBlogPost_Content_Operator>;
  createdAt?: InputMaybe<CmsBlogPost_CreatedAt_Operator>;
  description?: InputMaybe<CmsBlogPost_Description_Operator>;
  featuredImage?: InputMaybe<CmsBlogPost_FeaturedImage_Operator>;
  id?: InputMaybe<CmsBlogPost_Id_Operator>;
  relatedPosts?: InputMaybe<CmsBlogPost_RelatedPosts_Operator>;
  title?: InputMaybe<CmsBlogPost_Title_Operator>;
  updatedAt?: InputMaybe<CmsBlogPost_UpdatedAt_Operator>;
  videos__embedId?: InputMaybe<CmsBlogPost_Videos__EmbedId_Operator>;
  videos__id?: InputMaybe<CmsBlogPost_Videos__Id_Operator>;
  videos__title?: InputMaybe<CmsBlogPost_Videos__Title_Operator>;
};

export type CmsBlogPost_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsBlogPost_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsBlogPost_Where_Or>>>;
  content?: InputMaybe<CmsBlogPost_Content_Operator>;
  createdAt?: InputMaybe<CmsBlogPost_CreatedAt_Operator>;
  description?: InputMaybe<CmsBlogPost_Description_Operator>;
  featuredImage?: InputMaybe<CmsBlogPost_FeaturedImage_Operator>;
  id?: InputMaybe<CmsBlogPost_Id_Operator>;
  relatedPosts?: InputMaybe<CmsBlogPost_RelatedPosts_Operator>;
  title?: InputMaybe<CmsBlogPost_Title_Operator>;
  updatedAt?: InputMaybe<CmsBlogPost_UpdatedAt_Operator>;
  videos__embedId?: InputMaybe<CmsBlogPost_Videos__EmbedId_Operator>;
  videos__id?: InputMaybe<CmsBlogPost_Videos__Id_Operator>;
  videos__title?: InputMaybe<CmsBlogPost_Videos__Title_Operator>;
};

export type CmsBlogPosts = {
  __typename: 'CmsBlogPosts';
  docs: Array<CmsBlogPost>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  nextPage: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  pagingCounter: Scalars['Int'];
  prevPage: Maybe<Scalars['Int']>;
  totalDocs: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type CmsBlogPostsCreateAccess = {
  __typename: 'CmsBlogPostsCreateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPostsCreateDocAccess = {
  __typename: 'CmsBlogPostsCreateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPostsDeleteAccess = {
  __typename: 'CmsBlogPostsDeleteAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPostsDeleteDocAccess = {
  __typename: 'CmsBlogPostsDeleteDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPostsDocAccessFields = {
  __typename: 'CmsBlogPostsDocAccessFields';
  content: Maybe<CmsBlogPostsDocAccessFields_Content>;
  createdAt: Maybe<CmsBlogPostsDocAccessFields_CreatedAt>;
  description: Maybe<CmsBlogPostsDocAccessFields_Description>;
  featuredImage: Maybe<CmsBlogPostsDocAccessFields_FeaturedImage>;
  relatedPosts: Maybe<CmsBlogPostsDocAccessFields_RelatedPosts>;
  title: Maybe<CmsBlogPostsDocAccessFields_Title>;
  updatedAt: Maybe<CmsBlogPostsDocAccessFields_UpdatedAt>;
  videos: Maybe<CmsBlogPostsDocAccessFields_Videos>;
};

export type CmsBlogPostsDocAccessFields_Content = {
  __typename: 'CmsBlogPostsDocAccessFields_content';
  create: Maybe<CmsBlogPostsDocAccessFields_Content_Create>;
  delete: Maybe<CmsBlogPostsDocAccessFields_Content_Delete>;
  read: Maybe<CmsBlogPostsDocAccessFields_Content_Read>;
  update: Maybe<CmsBlogPostsDocAccessFields_Content_Update>;
};

export type CmsBlogPostsDocAccessFields_Content_Create = {
  __typename: 'CmsBlogPostsDocAccessFields_content_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Content_Delete = {
  __typename: 'CmsBlogPostsDocAccessFields_content_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Content_Read = {
  __typename: 'CmsBlogPostsDocAccessFields_content_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Content_Update = {
  __typename: 'CmsBlogPostsDocAccessFields_content_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_CreatedAt = {
  __typename: 'CmsBlogPostsDocAccessFields_createdAt';
  create: Maybe<CmsBlogPostsDocAccessFields_CreatedAt_Create>;
  delete: Maybe<CmsBlogPostsDocAccessFields_CreatedAt_Delete>;
  read: Maybe<CmsBlogPostsDocAccessFields_CreatedAt_Read>;
  update: Maybe<CmsBlogPostsDocAccessFields_CreatedAt_Update>;
};

export type CmsBlogPostsDocAccessFields_CreatedAt_Create = {
  __typename: 'CmsBlogPostsDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_CreatedAt_Delete = {
  __typename: 'CmsBlogPostsDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_CreatedAt_Read = {
  __typename: 'CmsBlogPostsDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_CreatedAt_Update = {
  __typename: 'CmsBlogPostsDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Description = {
  __typename: 'CmsBlogPostsDocAccessFields_description';
  create: Maybe<CmsBlogPostsDocAccessFields_Description_Create>;
  delete: Maybe<CmsBlogPostsDocAccessFields_Description_Delete>;
  read: Maybe<CmsBlogPostsDocAccessFields_Description_Read>;
  update: Maybe<CmsBlogPostsDocAccessFields_Description_Update>;
};

export type CmsBlogPostsDocAccessFields_Description_Create = {
  __typename: 'CmsBlogPostsDocAccessFields_description_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Description_Delete = {
  __typename: 'CmsBlogPostsDocAccessFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Description_Read = {
  __typename: 'CmsBlogPostsDocAccessFields_description_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Description_Update = {
  __typename: 'CmsBlogPostsDocAccessFields_description_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_FeaturedImage = {
  __typename: 'CmsBlogPostsDocAccessFields_featuredImage';
  create: Maybe<CmsBlogPostsDocAccessFields_FeaturedImage_Create>;
  delete: Maybe<CmsBlogPostsDocAccessFields_FeaturedImage_Delete>;
  read: Maybe<CmsBlogPostsDocAccessFields_FeaturedImage_Read>;
  update: Maybe<CmsBlogPostsDocAccessFields_FeaturedImage_Update>;
};

export type CmsBlogPostsDocAccessFields_FeaturedImage_Create = {
  __typename: 'CmsBlogPostsDocAccessFields_featuredImage_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_FeaturedImage_Delete = {
  __typename: 'CmsBlogPostsDocAccessFields_featuredImage_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_FeaturedImage_Read = {
  __typename: 'CmsBlogPostsDocAccessFields_featuredImage_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_FeaturedImage_Update = {
  __typename: 'CmsBlogPostsDocAccessFields_featuredImage_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_RelatedPosts = {
  __typename: 'CmsBlogPostsDocAccessFields_relatedPosts';
  create: Maybe<CmsBlogPostsDocAccessFields_RelatedPosts_Create>;
  delete: Maybe<CmsBlogPostsDocAccessFields_RelatedPosts_Delete>;
  read: Maybe<CmsBlogPostsDocAccessFields_RelatedPosts_Read>;
  update: Maybe<CmsBlogPostsDocAccessFields_RelatedPosts_Update>;
};

export type CmsBlogPostsDocAccessFields_RelatedPosts_Create = {
  __typename: 'CmsBlogPostsDocAccessFields_relatedPosts_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_RelatedPosts_Delete = {
  __typename: 'CmsBlogPostsDocAccessFields_relatedPosts_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_RelatedPosts_Read = {
  __typename: 'CmsBlogPostsDocAccessFields_relatedPosts_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_RelatedPosts_Update = {
  __typename: 'CmsBlogPostsDocAccessFields_relatedPosts_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Title = {
  __typename: 'CmsBlogPostsDocAccessFields_title';
  create: Maybe<CmsBlogPostsDocAccessFields_Title_Create>;
  delete: Maybe<CmsBlogPostsDocAccessFields_Title_Delete>;
  read: Maybe<CmsBlogPostsDocAccessFields_Title_Read>;
  update: Maybe<CmsBlogPostsDocAccessFields_Title_Update>;
};

export type CmsBlogPostsDocAccessFields_Title_Create = {
  __typename: 'CmsBlogPostsDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Title_Delete = {
  __typename: 'CmsBlogPostsDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Title_Read = {
  __typename: 'CmsBlogPostsDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Title_Update = {
  __typename: 'CmsBlogPostsDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_UpdatedAt = {
  __typename: 'CmsBlogPostsDocAccessFields_updatedAt';
  create: Maybe<CmsBlogPostsDocAccessFields_UpdatedAt_Create>;
  delete: Maybe<CmsBlogPostsDocAccessFields_UpdatedAt_Delete>;
  read: Maybe<CmsBlogPostsDocAccessFields_UpdatedAt_Read>;
  update: Maybe<CmsBlogPostsDocAccessFields_UpdatedAt_Update>;
};

export type CmsBlogPostsDocAccessFields_UpdatedAt_Create = {
  __typename: 'CmsBlogPostsDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_UpdatedAt_Delete = {
  __typename: 'CmsBlogPostsDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_UpdatedAt_Read = {
  __typename: 'CmsBlogPostsDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_UpdatedAt_Update = {
  __typename: 'CmsBlogPostsDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos = {
  __typename: 'CmsBlogPostsDocAccessFields_videos';
  create: Maybe<CmsBlogPostsDocAccessFields_Videos_Create>;
  delete: Maybe<CmsBlogPostsDocAccessFields_Videos_Delete>;
  fields: Maybe<CmsBlogPostsDocAccessFields_Videos_Fields>;
  read: Maybe<CmsBlogPostsDocAccessFields_Videos_Read>;
  update: Maybe<CmsBlogPostsDocAccessFields_Videos_Update>;
};

export type CmsBlogPostsDocAccessFields_Videos_Create = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_Delete = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_Fields = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_Fields';
  embedId: Maybe<CmsBlogPostsDocAccessFields_Videos_EmbedId>;
  id: Maybe<CmsBlogPostsDocAccessFields_Videos_Id>;
  title: Maybe<CmsBlogPostsDocAccessFields_Videos_Title>;
};

export type CmsBlogPostsDocAccessFields_Videos_Read = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_Update = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_EmbedId = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_embedId';
  create: Maybe<CmsBlogPostsDocAccessFields_Videos_EmbedId_Create>;
  delete: Maybe<CmsBlogPostsDocAccessFields_Videos_EmbedId_Delete>;
  read: Maybe<CmsBlogPostsDocAccessFields_Videos_EmbedId_Read>;
  update: Maybe<CmsBlogPostsDocAccessFields_Videos_EmbedId_Update>;
};

export type CmsBlogPostsDocAccessFields_Videos_EmbedId_Create = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_embedId_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_EmbedId_Delete = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_embedId_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_EmbedId_Read = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_embedId_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_EmbedId_Update = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_embedId_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_Id = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_id';
  create: Maybe<CmsBlogPostsDocAccessFields_Videos_Id_Create>;
  delete: Maybe<CmsBlogPostsDocAccessFields_Videos_Id_Delete>;
  read: Maybe<CmsBlogPostsDocAccessFields_Videos_Id_Read>;
  update: Maybe<CmsBlogPostsDocAccessFields_Videos_Id_Update>;
};

export type CmsBlogPostsDocAccessFields_Videos_Id_Create = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_id_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_Id_Delete = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_id_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_Id_Read = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_id_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_Id_Update = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_id_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_Title = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_title';
  create: Maybe<CmsBlogPostsDocAccessFields_Videos_Title_Create>;
  delete: Maybe<CmsBlogPostsDocAccessFields_Videos_Title_Delete>;
  read: Maybe<CmsBlogPostsDocAccessFields_Videos_Title_Read>;
  update: Maybe<CmsBlogPostsDocAccessFields_Videos_Title_Update>;
};

export type CmsBlogPostsDocAccessFields_Videos_Title_Create = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_title_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_Title_Delete = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_title_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_Title_Read = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_title_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsDocAccessFields_Videos_Title_Update = {
  __typename: 'CmsBlogPostsDocAccessFields_videos_title_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields = {
  __typename: 'CmsBlogPostsFields';
  content: Maybe<CmsBlogPostsFields_Content>;
  createdAt: Maybe<CmsBlogPostsFields_CreatedAt>;
  description: Maybe<CmsBlogPostsFields_Description>;
  featuredImage: Maybe<CmsBlogPostsFields_FeaturedImage>;
  relatedPosts: Maybe<CmsBlogPostsFields_RelatedPosts>;
  title: Maybe<CmsBlogPostsFields_Title>;
  updatedAt: Maybe<CmsBlogPostsFields_UpdatedAt>;
  videos: Maybe<CmsBlogPostsFields_Videos>;
};

export type CmsBlogPostsFields_Content = {
  __typename: 'CmsBlogPostsFields_content';
  create: Maybe<CmsBlogPostsFields_Content_Create>;
  delete: Maybe<CmsBlogPostsFields_Content_Delete>;
  read: Maybe<CmsBlogPostsFields_Content_Read>;
  update: Maybe<CmsBlogPostsFields_Content_Update>;
};

export type CmsBlogPostsFields_Content_Create = {
  __typename: 'CmsBlogPostsFields_content_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Content_Delete = {
  __typename: 'CmsBlogPostsFields_content_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Content_Read = {
  __typename: 'CmsBlogPostsFields_content_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Content_Update = {
  __typename: 'CmsBlogPostsFields_content_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_CreatedAt = {
  __typename: 'CmsBlogPostsFields_createdAt';
  create: Maybe<CmsBlogPostsFields_CreatedAt_Create>;
  delete: Maybe<CmsBlogPostsFields_CreatedAt_Delete>;
  read: Maybe<CmsBlogPostsFields_CreatedAt_Read>;
  update: Maybe<CmsBlogPostsFields_CreatedAt_Update>;
};

export type CmsBlogPostsFields_CreatedAt_Create = {
  __typename: 'CmsBlogPostsFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_CreatedAt_Delete = {
  __typename: 'CmsBlogPostsFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_CreatedAt_Read = {
  __typename: 'CmsBlogPostsFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_CreatedAt_Update = {
  __typename: 'CmsBlogPostsFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Description = {
  __typename: 'CmsBlogPostsFields_description';
  create: Maybe<CmsBlogPostsFields_Description_Create>;
  delete: Maybe<CmsBlogPostsFields_Description_Delete>;
  read: Maybe<CmsBlogPostsFields_Description_Read>;
  update: Maybe<CmsBlogPostsFields_Description_Update>;
};

export type CmsBlogPostsFields_Description_Create = {
  __typename: 'CmsBlogPostsFields_description_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Description_Delete = {
  __typename: 'CmsBlogPostsFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Description_Read = {
  __typename: 'CmsBlogPostsFields_description_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Description_Update = {
  __typename: 'CmsBlogPostsFields_description_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_FeaturedImage = {
  __typename: 'CmsBlogPostsFields_featuredImage';
  create: Maybe<CmsBlogPostsFields_FeaturedImage_Create>;
  delete: Maybe<CmsBlogPostsFields_FeaturedImage_Delete>;
  read: Maybe<CmsBlogPostsFields_FeaturedImage_Read>;
  update: Maybe<CmsBlogPostsFields_FeaturedImage_Update>;
};

export type CmsBlogPostsFields_FeaturedImage_Create = {
  __typename: 'CmsBlogPostsFields_featuredImage_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_FeaturedImage_Delete = {
  __typename: 'CmsBlogPostsFields_featuredImage_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_FeaturedImage_Read = {
  __typename: 'CmsBlogPostsFields_featuredImage_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_FeaturedImage_Update = {
  __typename: 'CmsBlogPostsFields_featuredImage_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_RelatedPosts = {
  __typename: 'CmsBlogPostsFields_relatedPosts';
  create: Maybe<CmsBlogPostsFields_RelatedPosts_Create>;
  delete: Maybe<CmsBlogPostsFields_RelatedPosts_Delete>;
  read: Maybe<CmsBlogPostsFields_RelatedPosts_Read>;
  update: Maybe<CmsBlogPostsFields_RelatedPosts_Update>;
};

export type CmsBlogPostsFields_RelatedPosts_Create = {
  __typename: 'CmsBlogPostsFields_relatedPosts_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_RelatedPosts_Delete = {
  __typename: 'CmsBlogPostsFields_relatedPosts_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_RelatedPosts_Read = {
  __typename: 'CmsBlogPostsFields_relatedPosts_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_RelatedPosts_Update = {
  __typename: 'CmsBlogPostsFields_relatedPosts_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Title = {
  __typename: 'CmsBlogPostsFields_title';
  create: Maybe<CmsBlogPostsFields_Title_Create>;
  delete: Maybe<CmsBlogPostsFields_Title_Delete>;
  read: Maybe<CmsBlogPostsFields_Title_Read>;
  update: Maybe<CmsBlogPostsFields_Title_Update>;
};

export type CmsBlogPostsFields_Title_Create = {
  __typename: 'CmsBlogPostsFields_title_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Title_Delete = {
  __typename: 'CmsBlogPostsFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Title_Read = {
  __typename: 'CmsBlogPostsFields_title_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Title_Update = {
  __typename: 'CmsBlogPostsFields_title_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_UpdatedAt = {
  __typename: 'CmsBlogPostsFields_updatedAt';
  create: Maybe<CmsBlogPostsFields_UpdatedAt_Create>;
  delete: Maybe<CmsBlogPostsFields_UpdatedAt_Delete>;
  read: Maybe<CmsBlogPostsFields_UpdatedAt_Read>;
  update: Maybe<CmsBlogPostsFields_UpdatedAt_Update>;
};

export type CmsBlogPostsFields_UpdatedAt_Create = {
  __typename: 'CmsBlogPostsFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_UpdatedAt_Delete = {
  __typename: 'CmsBlogPostsFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_UpdatedAt_Read = {
  __typename: 'CmsBlogPostsFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_UpdatedAt_Update = {
  __typename: 'CmsBlogPostsFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos = {
  __typename: 'CmsBlogPostsFields_videos';
  create: Maybe<CmsBlogPostsFields_Videos_Create>;
  delete: Maybe<CmsBlogPostsFields_Videos_Delete>;
  fields: Maybe<CmsBlogPostsFields_Videos_Fields>;
  read: Maybe<CmsBlogPostsFields_Videos_Read>;
  update: Maybe<CmsBlogPostsFields_Videos_Update>;
};

export type CmsBlogPostsFields_Videos_Create = {
  __typename: 'CmsBlogPostsFields_videos_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_Delete = {
  __typename: 'CmsBlogPostsFields_videos_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_Fields = {
  __typename: 'CmsBlogPostsFields_videos_Fields';
  embedId: Maybe<CmsBlogPostsFields_Videos_EmbedId>;
  id: Maybe<CmsBlogPostsFields_Videos_Id>;
  title: Maybe<CmsBlogPostsFields_Videos_Title>;
};

export type CmsBlogPostsFields_Videos_Read = {
  __typename: 'CmsBlogPostsFields_videos_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_Update = {
  __typename: 'CmsBlogPostsFields_videos_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_EmbedId = {
  __typename: 'CmsBlogPostsFields_videos_embedId';
  create: Maybe<CmsBlogPostsFields_Videos_EmbedId_Create>;
  delete: Maybe<CmsBlogPostsFields_Videos_EmbedId_Delete>;
  read: Maybe<CmsBlogPostsFields_Videos_EmbedId_Read>;
  update: Maybe<CmsBlogPostsFields_Videos_EmbedId_Update>;
};

export type CmsBlogPostsFields_Videos_EmbedId_Create = {
  __typename: 'CmsBlogPostsFields_videos_embedId_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_EmbedId_Delete = {
  __typename: 'CmsBlogPostsFields_videos_embedId_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_EmbedId_Read = {
  __typename: 'CmsBlogPostsFields_videos_embedId_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_EmbedId_Update = {
  __typename: 'CmsBlogPostsFields_videos_embedId_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_Id = {
  __typename: 'CmsBlogPostsFields_videos_id';
  create: Maybe<CmsBlogPostsFields_Videos_Id_Create>;
  delete: Maybe<CmsBlogPostsFields_Videos_Id_Delete>;
  read: Maybe<CmsBlogPostsFields_Videos_Id_Read>;
  update: Maybe<CmsBlogPostsFields_Videos_Id_Update>;
};

export type CmsBlogPostsFields_Videos_Id_Create = {
  __typename: 'CmsBlogPostsFields_videos_id_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_Id_Delete = {
  __typename: 'CmsBlogPostsFields_videos_id_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_Id_Read = {
  __typename: 'CmsBlogPostsFields_videos_id_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_Id_Update = {
  __typename: 'CmsBlogPostsFields_videos_id_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_Title = {
  __typename: 'CmsBlogPostsFields_videos_title';
  create: Maybe<CmsBlogPostsFields_Videos_Title_Create>;
  delete: Maybe<CmsBlogPostsFields_Videos_Title_Delete>;
  read: Maybe<CmsBlogPostsFields_Videos_Title_Read>;
  update: Maybe<CmsBlogPostsFields_Videos_Title_Update>;
};

export type CmsBlogPostsFields_Videos_Title_Create = {
  __typename: 'CmsBlogPostsFields_videos_title_Create';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_Title_Delete = {
  __typename: 'CmsBlogPostsFields_videos_title_Delete';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_Title_Read = {
  __typename: 'CmsBlogPostsFields_videos_title_Read';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsFields_Videos_Title_Update = {
  __typename: 'CmsBlogPostsFields_videos_title_Update';
  permission: Scalars['Boolean'];
};

export type CmsBlogPostsReadAccess = {
  __typename: 'CmsBlogPostsReadAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPostsReadDocAccess = {
  __typename: 'CmsBlogPostsReadDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPostsUpdateAccess = {
  __typename: 'CmsBlogPostsUpdateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsBlogPostsUpdateDocAccess = {
  __typename: 'CmsBlogPostsUpdateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGame = {
  __typename: 'CmsGame';
  avatar: CmsMedia;
  company: Scalars['String'];
  content: Scalars['JSON'];
  createdAt: Maybe<Scalars['DateTime']>;
  gameBanner: Maybe<CmsMedia>;
  gameLink: Scalars['String'];
  gameTrailerEmbedId: Maybe<CmsGame_GameTrailerEmbedId>;
  id: Scalars['String'];
  images: Maybe<Array<CmsGame_Images>>;
  name: Scalars['String'];
  relatedGames: Maybe<Array<CmsGame>>;
  shortDescription: Maybe<Scalars['String']>;
  status: Maybe<CmsGame_Status>;
  updatedAt: Maybe<Scalars['DateTime']>;
};


export type CmsGameContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export enum CmsGameUpdate_Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type CmsGame_GameTrailerEmbedId = {
  __typename: 'CmsGame_GameTrailerEmbedId';
  embedId: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
};

export type CmsGame_Images = {
  __typename: 'CmsGame_Images';
  id: Maybe<Scalars['String']>;
  image: Maybe<CmsMedia>;
};

export type CmsGame_Avatar_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsGame_Company_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsGame_Content_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type CmsGame_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsGame_GameBanner_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsGame_GameLink_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsGame_GameTrailerEmbedId__EmbedId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsGame_GameTrailerEmbedId__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsGame_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsGame_Images__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsGame_Images__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsGame_Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsGame_RelatedGames_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsGame_ShortDescription_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum CmsGame_Status {
  Draft = 'draft',
  Published = 'published'
}

export enum CmsGame_Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export enum CmsGame_Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type CmsGame_Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsGame_Status_Input>>>;
  equals?: InputMaybe<CmsGame_Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<CmsGame_Status_Input>>>;
  not_equals?: InputMaybe<CmsGame_Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<CmsGame_Status_Input>>>;
};

export type CmsGame_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsGame_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsGame_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsGame_Where_Or>>>;
  avatar?: InputMaybe<CmsGame_Avatar_Operator>;
  company?: InputMaybe<CmsGame_Company_Operator>;
  content?: InputMaybe<CmsGame_Content_Operator>;
  createdAt?: InputMaybe<CmsGame_CreatedAt_Operator>;
  gameBanner?: InputMaybe<CmsGame_GameBanner_Operator>;
  gameLink?: InputMaybe<CmsGame_GameLink_Operator>;
  gameTrailerEmbedId__embedId?: InputMaybe<CmsGame_GameTrailerEmbedId__EmbedId_Operator>;
  gameTrailerEmbedId__title?: InputMaybe<CmsGame_GameTrailerEmbedId__Title_Operator>;
  id?: InputMaybe<CmsGame_Id_Operator>;
  images__id?: InputMaybe<CmsGame_Images__Id_Operator>;
  images__image?: InputMaybe<CmsGame_Images__Image_Operator>;
  name?: InputMaybe<CmsGame_Name_Operator>;
  relatedGames?: InputMaybe<CmsGame_RelatedGames_Operator>;
  shortDescription?: InputMaybe<CmsGame_ShortDescription_Operator>;
  status?: InputMaybe<CmsGame_Status_Operator>;
  updatedAt?: InputMaybe<CmsGame_UpdatedAt_Operator>;
};

export type CmsGame_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsGame_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsGame_Where_Or>>>;
  avatar?: InputMaybe<CmsGame_Avatar_Operator>;
  company?: InputMaybe<CmsGame_Company_Operator>;
  content?: InputMaybe<CmsGame_Content_Operator>;
  createdAt?: InputMaybe<CmsGame_CreatedAt_Operator>;
  gameBanner?: InputMaybe<CmsGame_GameBanner_Operator>;
  gameLink?: InputMaybe<CmsGame_GameLink_Operator>;
  gameTrailerEmbedId__embedId?: InputMaybe<CmsGame_GameTrailerEmbedId__EmbedId_Operator>;
  gameTrailerEmbedId__title?: InputMaybe<CmsGame_GameTrailerEmbedId__Title_Operator>;
  id?: InputMaybe<CmsGame_Id_Operator>;
  images__id?: InputMaybe<CmsGame_Images__Id_Operator>;
  images__image?: InputMaybe<CmsGame_Images__Image_Operator>;
  name?: InputMaybe<CmsGame_Name_Operator>;
  relatedGames?: InputMaybe<CmsGame_RelatedGames_Operator>;
  shortDescription?: InputMaybe<CmsGame_ShortDescription_Operator>;
  status?: InputMaybe<CmsGame_Status_Operator>;
  updatedAt?: InputMaybe<CmsGame_UpdatedAt_Operator>;
};

export type CmsGame_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsGame_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsGame_Where_Or>>>;
  avatar?: InputMaybe<CmsGame_Avatar_Operator>;
  company?: InputMaybe<CmsGame_Company_Operator>;
  content?: InputMaybe<CmsGame_Content_Operator>;
  createdAt?: InputMaybe<CmsGame_CreatedAt_Operator>;
  gameBanner?: InputMaybe<CmsGame_GameBanner_Operator>;
  gameLink?: InputMaybe<CmsGame_GameLink_Operator>;
  gameTrailerEmbedId__embedId?: InputMaybe<CmsGame_GameTrailerEmbedId__EmbedId_Operator>;
  gameTrailerEmbedId__title?: InputMaybe<CmsGame_GameTrailerEmbedId__Title_Operator>;
  id?: InputMaybe<CmsGame_Id_Operator>;
  images__id?: InputMaybe<CmsGame_Images__Id_Operator>;
  images__image?: InputMaybe<CmsGame_Images__Image_Operator>;
  name?: InputMaybe<CmsGame_Name_Operator>;
  relatedGames?: InputMaybe<CmsGame_RelatedGames_Operator>;
  shortDescription?: InputMaybe<CmsGame_ShortDescription_Operator>;
  status?: InputMaybe<CmsGame_Status_Operator>;
  updatedAt?: InputMaybe<CmsGame_UpdatedAt_Operator>;
};

export type CmsGamer = {
  __typename: 'CmsGamer';
  avatar: CmsMedia;
  country: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  gamerSocialMedia: Maybe<Array<CmsGamer_GamerSocialMedia>>;
  id: Scalars['String'];
  name: Maybe<Scalars['String']>;
  nickname: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum CmsGamerUpdate_GamerSocialMedia_Platform_MutationInput {
  Discord = 'discord',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Messenger = 'messenger',
  Pinterest = 'pinterest',
  Reddit = 'reddit',
  Snapchat = 'snapchat',
  Steam = 'steam',
  Tiktok = 'tiktok',
  Twitch = 'twitch',
  Twitter = 'twitter',
  Whatsapp = 'whatsapp',
  Youtube = 'youtube'
}

export type CmsGamer_GamerSocialMedia = {
  __typename: 'CmsGamer_GamerSocialMedia';
  id: Maybe<Scalars['String']>;
  link: Maybe<Scalars['String']>;
  platform: Maybe<CmsGamer_GamerSocialMedia_Platform>;
};

export enum CmsGamer_GamerSocialMedia_Platform {
  Discord = 'discord',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Messenger = 'messenger',
  Pinterest = 'pinterest',
  Reddit = 'reddit',
  Snapchat = 'snapchat',
  Steam = 'steam',
  Tiktok = 'tiktok',
  Twitch = 'twitch',
  Twitter = 'twitter',
  Whatsapp = 'whatsapp',
  Youtube = 'youtube'
}

export enum CmsGamer_GamerSocialMedia_Platform_MutationInput {
  Discord = 'discord',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Messenger = 'messenger',
  Pinterest = 'pinterest',
  Reddit = 'reddit',
  Snapchat = 'snapchat',
  Steam = 'steam',
  Tiktok = 'tiktok',
  Twitch = 'twitch',
  Twitter = 'twitter',
  Whatsapp = 'whatsapp',
  Youtube = 'youtube'
}

export type CmsGamer_Avatar_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type CmsGamer_Country_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsGamer_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsGamer_Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type CmsGamer_GamerSocialMedia__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsGamer_GamerSocialMedia__Link_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum CmsGamer_GamerSocialMedia__Platform_Input {
  Discord = 'discord',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Messenger = 'messenger',
  Pinterest = 'pinterest',
  Reddit = 'reddit',
  Snapchat = 'snapchat',
  Steam = 'steam',
  Tiktok = 'tiktok',
  Twitch = 'twitch',
  Twitter = 'twitter',
  Whatsapp = 'whatsapp',
  Youtube = 'youtube'
}

export type CmsGamer_GamerSocialMedia__Platform_Operator = {
  all?: InputMaybe<Array<InputMaybe<CmsGamer_GamerSocialMedia__Platform_Input>>>;
  equals?: InputMaybe<CmsGamer_GamerSocialMedia__Platform_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<CmsGamer_GamerSocialMedia__Platform_Input>>>;
  not_equals?: InputMaybe<CmsGamer_GamerSocialMedia__Platform_Input>;
  not_in?: InputMaybe<Array<InputMaybe<CmsGamer_GamerSocialMedia__Platform_Input>>>;
};

export type CmsGamer_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsGamer_Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsGamer_Nickname_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsGamer_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsGamer_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsGamer_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsGamer_Where_Or>>>;
  avatar?: InputMaybe<CmsGamer_Avatar_Operator>;
  country?: InputMaybe<CmsGamer_Country_Operator>;
  createdAt?: InputMaybe<CmsGamer_CreatedAt_Operator>;
  description?: InputMaybe<CmsGamer_Description_Operator>;
  gamerSocialMedia__id?: InputMaybe<CmsGamer_GamerSocialMedia__Id_Operator>;
  gamerSocialMedia__link?: InputMaybe<CmsGamer_GamerSocialMedia__Link_Operator>;
  gamerSocialMedia__platform?: InputMaybe<CmsGamer_GamerSocialMedia__Platform_Operator>;
  id?: InputMaybe<CmsGamer_Id_Operator>;
  name?: InputMaybe<CmsGamer_Name_Operator>;
  nickname?: InputMaybe<CmsGamer_Nickname_Operator>;
  updatedAt?: InputMaybe<CmsGamer_UpdatedAt_Operator>;
};

export type CmsGamer_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsGamer_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsGamer_Where_Or>>>;
  avatar?: InputMaybe<CmsGamer_Avatar_Operator>;
  country?: InputMaybe<CmsGamer_Country_Operator>;
  createdAt?: InputMaybe<CmsGamer_CreatedAt_Operator>;
  description?: InputMaybe<CmsGamer_Description_Operator>;
  gamerSocialMedia__id?: InputMaybe<CmsGamer_GamerSocialMedia__Id_Operator>;
  gamerSocialMedia__link?: InputMaybe<CmsGamer_GamerSocialMedia__Link_Operator>;
  gamerSocialMedia__platform?: InputMaybe<CmsGamer_GamerSocialMedia__Platform_Operator>;
  id?: InputMaybe<CmsGamer_Id_Operator>;
  name?: InputMaybe<CmsGamer_Name_Operator>;
  nickname?: InputMaybe<CmsGamer_Nickname_Operator>;
  updatedAt?: InputMaybe<CmsGamer_UpdatedAt_Operator>;
};

export type CmsGamer_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsGamer_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsGamer_Where_Or>>>;
  avatar?: InputMaybe<CmsGamer_Avatar_Operator>;
  country?: InputMaybe<CmsGamer_Country_Operator>;
  createdAt?: InputMaybe<CmsGamer_CreatedAt_Operator>;
  description?: InputMaybe<CmsGamer_Description_Operator>;
  gamerSocialMedia__id?: InputMaybe<CmsGamer_GamerSocialMedia__Id_Operator>;
  gamerSocialMedia__link?: InputMaybe<CmsGamer_GamerSocialMedia__Link_Operator>;
  gamerSocialMedia__platform?: InputMaybe<CmsGamer_GamerSocialMedia__Platform_Operator>;
  id?: InputMaybe<CmsGamer_Id_Operator>;
  name?: InputMaybe<CmsGamer_Name_Operator>;
  nickname?: InputMaybe<CmsGamer_Nickname_Operator>;
  updatedAt?: InputMaybe<CmsGamer_UpdatedAt_Operator>;
};

export type CmsGamers = {
  __typename: 'CmsGamers';
  docs: Array<CmsGamer>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  nextPage: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  pagingCounter: Scalars['Int'];
  prevPage: Maybe<Scalars['Int']>;
  totalDocs: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type CmsGamersCreateAccess = {
  __typename: 'CmsGamersCreateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamersCreateDocAccess = {
  __typename: 'CmsGamersCreateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamersDeleteAccess = {
  __typename: 'CmsGamersDeleteAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamersDeleteDocAccess = {
  __typename: 'CmsGamersDeleteDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamersDocAccessFields = {
  __typename: 'CmsGamersDocAccessFields';
  avatar: Maybe<CmsGamersDocAccessFields_Avatar>;
  country: Maybe<CmsGamersDocAccessFields_Country>;
  createdAt: Maybe<CmsGamersDocAccessFields_CreatedAt>;
  description: Maybe<CmsGamersDocAccessFields_Description>;
  gamerSocialMedia: Maybe<CmsGamersDocAccessFields_GamerSocialMedia>;
  name: Maybe<CmsGamersDocAccessFields_Name>;
  nickname: Maybe<CmsGamersDocAccessFields_Nickname>;
  updatedAt: Maybe<CmsGamersDocAccessFields_UpdatedAt>;
};

export type CmsGamersDocAccessFields_Avatar = {
  __typename: 'CmsGamersDocAccessFields_avatar';
  create: Maybe<CmsGamersDocAccessFields_Avatar_Create>;
  delete: Maybe<CmsGamersDocAccessFields_Avatar_Delete>;
  read: Maybe<CmsGamersDocAccessFields_Avatar_Read>;
  update: Maybe<CmsGamersDocAccessFields_Avatar_Update>;
};

export type CmsGamersDocAccessFields_Avatar_Create = {
  __typename: 'CmsGamersDocAccessFields_avatar_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Avatar_Delete = {
  __typename: 'CmsGamersDocAccessFields_avatar_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Avatar_Read = {
  __typename: 'CmsGamersDocAccessFields_avatar_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Avatar_Update = {
  __typename: 'CmsGamersDocAccessFields_avatar_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Country = {
  __typename: 'CmsGamersDocAccessFields_country';
  create: Maybe<CmsGamersDocAccessFields_Country_Create>;
  delete: Maybe<CmsGamersDocAccessFields_Country_Delete>;
  read: Maybe<CmsGamersDocAccessFields_Country_Read>;
  update: Maybe<CmsGamersDocAccessFields_Country_Update>;
};

export type CmsGamersDocAccessFields_Country_Create = {
  __typename: 'CmsGamersDocAccessFields_country_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Country_Delete = {
  __typename: 'CmsGamersDocAccessFields_country_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Country_Read = {
  __typename: 'CmsGamersDocAccessFields_country_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Country_Update = {
  __typename: 'CmsGamersDocAccessFields_country_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_CreatedAt = {
  __typename: 'CmsGamersDocAccessFields_createdAt';
  create: Maybe<CmsGamersDocAccessFields_CreatedAt_Create>;
  delete: Maybe<CmsGamersDocAccessFields_CreatedAt_Delete>;
  read: Maybe<CmsGamersDocAccessFields_CreatedAt_Read>;
  update: Maybe<CmsGamersDocAccessFields_CreatedAt_Update>;
};

export type CmsGamersDocAccessFields_CreatedAt_Create = {
  __typename: 'CmsGamersDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_CreatedAt_Delete = {
  __typename: 'CmsGamersDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_CreatedAt_Read = {
  __typename: 'CmsGamersDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_CreatedAt_Update = {
  __typename: 'CmsGamersDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Description = {
  __typename: 'CmsGamersDocAccessFields_description';
  create: Maybe<CmsGamersDocAccessFields_Description_Create>;
  delete: Maybe<CmsGamersDocAccessFields_Description_Delete>;
  read: Maybe<CmsGamersDocAccessFields_Description_Read>;
  update: Maybe<CmsGamersDocAccessFields_Description_Update>;
};

export type CmsGamersDocAccessFields_Description_Create = {
  __typename: 'CmsGamersDocAccessFields_description_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Description_Delete = {
  __typename: 'CmsGamersDocAccessFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Description_Read = {
  __typename: 'CmsGamersDocAccessFields_description_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Description_Update = {
  __typename: 'CmsGamersDocAccessFields_description_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia';
  create: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Create>;
  delete: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Delete>;
  fields: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Fields>;
  read: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Read>;
  update: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Update>;
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Create = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Delete = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Fields = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_Fields';
  id: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Id>;
  link: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Link>;
  platform: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Platform>;
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Read = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Update = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Id = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_id';
  create: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Id_Create>;
  delete: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Id_Delete>;
  read: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Id_Read>;
  update: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Id_Update>;
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Id_Create = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_id_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Id_Delete = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_id_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Id_Read = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_id_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Id_Update = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_id_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Link = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_link';
  create: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Link_Create>;
  delete: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Link_Delete>;
  read: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Link_Read>;
  update: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Link_Update>;
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Link_Create = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_link_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Link_Delete = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_link_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Link_Read = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_link_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Link_Update = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_link_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Platform = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_platform';
  create: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Platform_Create>;
  delete: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Platform_Delete>;
  read: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Platform_Read>;
  update: Maybe<CmsGamersDocAccessFields_GamerSocialMedia_Platform_Update>;
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Platform_Create = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_platform_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Platform_Delete = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_platform_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Platform_Read = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_platform_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_GamerSocialMedia_Platform_Update = {
  __typename: 'CmsGamersDocAccessFields_gamerSocialMedia_platform_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Name = {
  __typename: 'CmsGamersDocAccessFields_name';
  create: Maybe<CmsGamersDocAccessFields_Name_Create>;
  delete: Maybe<CmsGamersDocAccessFields_Name_Delete>;
  read: Maybe<CmsGamersDocAccessFields_Name_Read>;
  update: Maybe<CmsGamersDocAccessFields_Name_Update>;
};

export type CmsGamersDocAccessFields_Name_Create = {
  __typename: 'CmsGamersDocAccessFields_name_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Name_Delete = {
  __typename: 'CmsGamersDocAccessFields_name_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Name_Read = {
  __typename: 'CmsGamersDocAccessFields_name_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Name_Update = {
  __typename: 'CmsGamersDocAccessFields_name_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Nickname = {
  __typename: 'CmsGamersDocAccessFields_nickname';
  create: Maybe<CmsGamersDocAccessFields_Nickname_Create>;
  delete: Maybe<CmsGamersDocAccessFields_Nickname_Delete>;
  read: Maybe<CmsGamersDocAccessFields_Nickname_Read>;
  update: Maybe<CmsGamersDocAccessFields_Nickname_Update>;
};

export type CmsGamersDocAccessFields_Nickname_Create = {
  __typename: 'CmsGamersDocAccessFields_nickname_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Nickname_Delete = {
  __typename: 'CmsGamersDocAccessFields_nickname_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Nickname_Read = {
  __typename: 'CmsGamersDocAccessFields_nickname_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_Nickname_Update = {
  __typename: 'CmsGamersDocAccessFields_nickname_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_UpdatedAt = {
  __typename: 'CmsGamersDocAccessFields_updatedAt';
  create: Maybe<CmsGamersDocAccessFields_UpdatedAt_Create>;
  delete: Maybe<CmsGamersDocAccessFields_UpdatedAt_Delete>;
  read: Maybe<CmsGamersDocAccessFields_UpdatedAt_Read>;
  update: Maybe<CmsGamersDocAccessFields_UpdatedAt_Update>;
};

export type CmsGamersDocAccessFields_UpdatedAt_Create = {
  __typename: 'CmsGamersDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_UpdatedAt_Delete = {
  __typename: 'CmsGamersDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_UpdatedAt_Read = {
  __typename: 'CmsGamersDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersDocAccessFields_UpdatedAt_Update = {
  __typename: 'CmsGamersDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields = {
  __typename: 'CmsGamersFields';
  avatar: Maybe<CmsGamersFields_Avatar>;
  country: Maybe<CmsGamersFields_Country>;
  createdAt: Maybe<CmsGamersFields_CreatedAt>;
  description: Maybe<CmsGamersFields_Description>;
  gamerSocialMedia: Maybe<CmsGamersFields_GamerSocialMedia>;
  name: Maybe<CmsGamersFields_Name>;
  nickname: Maybe<CmsGamersFields_Nickname>;
  updatedAt: Maybe<CmsGamersFields_UpdatedAt>;
};

export type CmsGamersFields_Avatar = {
  __typename: 'CmsGamersFields_avatar';
  create: Maybe<CmsGamersFields_Avatar_Create>;
  delete: Maybe<CmsGamersFields_Avatar_Delete>;
  read: Maybe<CmsGamersFields_Avatar_Read>;
  update: Maybe<CmsGamersFields_Avatar_Update>;
};

export type CmsGamersFields_Avatar_Create = {
  __typename: 'CmsGamersFields_avatar_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Avatar_Delete = {
  __typename: 'CmsGamersFields_avatar_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Avatar_Read = {
  __typename: 'CmsGamersFields_avatar_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Avatar_Update = {
  __typename: 'CmsGamersFields_avatar_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Country = {
  __typename: 'CmsGamersFields_country';
  create: Maybe<CmsGamersFields_Country_Create>;
  delete: Maybe<CmsGamersFields_Country_Delete>;
  read: Maybe<CmsGamersFields_Country_Read>;
  update: Maybe<CmsGamersFields_Country_Update>;
};

export type CmsGamersFields_Country_Create = {
  __typename: 'CmsGamersFields_country_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Country_Delete = {
  __typename: 'CmsGamersFields_country_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Country_Read = {
  __typename: 'CmsGamersFields_country_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Country_Update = {
  __typename: 'CmsGamersFields_country_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_CreatedAt = {
  __typename: 'CmsGamersFields_createdAt';
  create: Maybe<CmsGamersFields_CreatedAt_Create>;
  delete: Maybe<CmsGamersFields_CreatedAt_Delete>;
  read: Maybe<CmsGamersFields_CreatedAt_Read>;
  update: Maybe<CmsGamersFields_CreatedAt_Update>;
};

export type CmsGamersFields_CreatedAt_Create = {
  __typename: 'CmsGamersFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_CreatedAt_Delete = {
  __typename: 'CmsGamersFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_CreatedAt_Read = {
  __typename: 'CmsGamersFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_CreatedAt_Update = {
  __typename: 'CmsGamersFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Description = {
  __typename: 'CmsGamersFields_description';
  create: Maybe<CmsGamersFields_Description_Create>;
  delete: Maybe<CmsGamersFields_Description_Delete>;
  read: Maybe<CmsGamersFields_Description_Read>;
  update: Maybe<CmsGamersFields_Description_Update>;
};

export type CmsGamersFields_Description_Create = {
  __typename: 'CmsGamersFields_description_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Description_Delete = {
  __typename: 'CmsGamersFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Description_Read = {
  __typename: 'CmsGamersFields_description_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Description_Update = {
  __typename: 'CmsGamersFields_description_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia = {
  __typename: 'CmsGamersFields_gamerSocialMedia';
  create: Maybe<CmsGamersFields_GamerSocialMedia_Create>;
  delete: Maybe<CmsGamersFields_GamerSocialMedia_Delete>;
  fields: Maybe<CmsGamersFields_GamerSocialMedia_Fields>;
  read: Maybe<CmsGamersFields_GamerSocialMedia_Read>;
  update: Maybe<CmsGamersFields_GamerSocialMedia_Update>;
};

export type CmsGamersFields_GamerSocialMedia_Create = {
  __typename: 'CmsGamersFields_gamerSocialMedia_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Delete = {
  __typename: 'CmsGamersFields_gamerSocialMedia_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Fields = {
  __typename: 'CmsGamersFields_gamerSocialMedia_Fields';
  id: Maybe<CmsGamersFields_GamerSocialMedia_Id>;
  link: Maybe<CmsGamersFields_GamerSocialMedia_Link>;
  platform: Maybe<CmsGamersFields_GamerSocialMedia_Platform>;
};

export type CmsGamersFields_GamerSocialMedia_Read = {
  __typename: 'CmsGamersFields_gamerSocialMedia_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Update = {
  __typename: 'CmsGamersFields_gamerSocialMedia_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Id = {
  __typename: 'CmsGamersFields_gamerSocialMedia_id';
  create: Maybe<CmsGamersFields_GamerSocialMedia_Id_Create>;
  delete: Maybe<CmsGamersFields_GamerSocialMedia_Id_Delete>;
  read: Maybe<CmsGamersFields_GamerSocialMedia_Id_Read>;
  update: Maybe<CmsGamersFields_GamerSocialMedia_Id_Update>;
};

export type CmsGamersFields_GamerSocialMedia_Id_Create = {
  __typename: 'CmsGamersFields_gamerSocialMedia_id_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Id_Delete = {
  __typename: 'CmsGamersFields_gamerSocialMedia_id_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Id_Read = {
  __typename: 'CmsGamersFields_gamerSocialMedia_id_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Id_Update = {
  __typename: 'CmsGamersFields_gamerSocialMedia_id_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Link = {
  __typename: 'CmsGamersFields_gamerSocialMedia_link';
  create: Maybe<CmsGamersFields_GamerSocialMedia_Link_Create>;
  delete: Maybe<CmsGamersFields_GamerSocialMedia_Link_Delete>;
  read: Maybe<CmsGamersFields_GamerSocialMedia_Link_Read>;
  update: Maybe<CmsGamersFields_GamerSocialMedia_Link_Update>;
};

export type CmsGamersFields_GamerSocialMedia_Link_Create = {
  __typename: 'CmsGamersFields_gamerSocialMedia_link_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Link_Delete = {
  __typename: 'CmsGamersFields_gamerSocialMedia_link_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Link_Read = {
  __typename: 'CmsGamersFields_gamerSocialMedia_link_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Link_Update = {
  __typename: 'CmsGamersFields_gamerSocialMedia_link_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Platform = {
  __typename: 'CmsGamersFields_gamerSocialMedia_platform';
  create: Maybe<CmsGamersFields_GamerSocialMedia_Platform_Create>;
  delete: Maybe<CmsGamersFields_GamerSocialMedia_Platform_Delete>;
  read: Maybe<CmsGamersFields_GamerSocialMedia_Platform_Read>;
  update: Maybe<CmsGamersFields_GamerSocialMedia_Platform_Update>;
};

export type CmsGamersFields_GamerSocialMedia_Platform_Create = {
  __typename: 'CmsGamersFields_gamerSocialMedia_platform_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Platform_Delete = {
  __typename: 'CmsGamersFields_gamerSocialMedia_platform_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Platform_Read = {
  __typename: 'CmsGamersFields_gamerSocialMedia_platform_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_GamerSocialMedia_Platform_Update = {
  __typename: 'CmsGamersFields_gamerSocialMedia_platform_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Name = {
  __typename: 'CmsGamersFields_name';
  create: Maybe<CmsGamersFields_Name_Create>;
  delete: Maybe<CmsGamersFields_Name_Delete>;
  read: Maybe<CmsGamersFields_Name_Read>;
  update: Maybe<CmsGamersFields_Name_Update>;
};

export type CmsGamersFields_Name_Create = {
  __typename: 'CmsGamersFields_name_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Name_Delete = {
  __typename: 'CmsGamersFields_name_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Name_Read = {
  __typename: 'CmsGamersFields_name_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Name_Update = {
  __typename: 'CmsGamersFields_name_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Nickname = {
  __typename: 'CmsGamersFields_nickname';
  create: Maybe<CmsGamersFields_Nickname_Create>;
  delete: Maybe<CmsGamersFields_Nickname_Delete>;
  read: Maybe<CmsGamersFields_Nickname_Read>;
  update: Maybe<CmsGamersFields_Nickname_Update>;
};

export type CmsGamersFields_Nickname_Create = {
  __typename: 'CmsGamersFields_nickname_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Nickname_Delete = {
  __typename: 'CmsGamersFields_nickname_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Nickname_Read = {
  __typename: 'CmsGamersFields_nickname_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_Nickname_Update = {
  __typename: 'CmsGamersFields_nickname_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_UpdatedAt = {
  __typename: 'CmsGamersFields_updatedAt';
  create: Maybe<CmsGamersFields_UpdatedAt_Create>;
  delete: Maybe<CmsGamersFields_UpdatedAt_Delete>;
  read: Maybe<CmsGamersFields_UpdatedAt_Read>;
  update: Maybe<CmsGamersFields_UpdatedAt_Update>;
};

export type CmsGamersFields_UpdatedAt_Create = {
  __typename: 'CmsGamersFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_UpdatedAt_Delete = {
  __typename: 'CmsGamersFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_UpdatedAt_Read = {
  __typename: 'CmsGamersFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamersFields_UpdatedAt_Update = {
  __typename: 'CmsGamersFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamersReadAccess = {
  __typename: 'CmsGamersReadAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamersReadDocAccess = {
  __typename: 'CmsGamersReadDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamersUpdateAccess = {
  __typename: 'CmsGamersUpdateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamersUpdateDocAccess = {
  __typename: 'CmsGamersUpdateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGames = {
  __typename: 'CmsGames';
  docs: Array<CmsGame>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  nextPage: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  pagingCounter: Scalars['Int'];
  prevPage: Maybe<Scalars['Int']>;
  totalDocs: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type CmsGamesCreateAccess = {
  __typename: 'CmsGamesCreateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamesCreateDocAccess = {
  __typename: 'CmsGamesCreateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamesDeleteAccess = {
  __typename: 'CmsGamesDeleteAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamesDeleteDocAccess = {
  __typename: 'CmsGamesDeleteDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamesDocAccessFields = {
  __typename: 'CmsGamesDocAccessFields';
  avatar: Maybe<CmsGamesDocAccessFields_Avatar>;
  company: Maybe<CmsGamesDocAccessFields_Company>;
  content: Maybe<CmsGamesDocAccessFields_Content>;
  createdAt: Maybe<CmsGamesDocAccessFields_CreatedAt>;
  gameBanner: Maybe<CmsGamesDocAccessFields_GameBanner>;
  gameLink: Maybe<CmsGamesDocAccessFields_GameLink>;
  gameTrailerEmbedId: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId>;
  images: Maybe<CmsGamesDocAccessFields_Images>;
  name: Maybe<CmsGamesDocAccessFields_Name>;
  relatedGames: Maybe<CmsGamesDocAccessFields_RelatedGames>;
  shortDescription: Maybe<CmsGamesDocAccessFields_ShortDescription>;
  status: Maybe<CmsGamesDocAccessFields_Status>;
  updatedAt: Maybe<CmsGamesDocAccessFields_UpdatedAt>;
};

export type CmsGamesDocAccessFields_Avatar = {
  __typename: 'CmsGamesDocAccessFields_avatar';
  create: Maybe<CmsGamesDocAccessFields_Avatar_Create>;
  delete: Maybe<CmsGamesDocAccessFields_Avatar_Delete>;
  read: Maybe<CmsGamesDocAccessFields_Avatar_Read>;
  update: Maybe<CmsGamesDocAccessFields_Avatar_Update>;
};

export type CmsGamesDocAccessFields_Avatar_Create = {
  __typename: 'CmsGamesDocAccessFields_avatar_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Avatar_Delete = {
  __typename: 'CmsGamesDocAccessFields_avatar_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Avatar_Read = {
  __typename: 'CmsGamesDocAccessFields_avatar_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Avatar_Update = {
  __typename: 'CmsGamesDocAccessFields_avatar_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Company = {
  __typename: 'CmsGamesDocAccessFields_company';
  create: Maybe<CmsGamesDocAccessFields_Company_Create>;
  delete: Maybe<CmsGamesDocAccessFields_Company_Delete>;
  read: Maybe<CmsGamesDocAccessFields_Company_Read>;
  update: Maybe<CmsGamesDocAccessFields_Company_Update>;
};

export type CmsGamesDocAccessFields_Company_Create = {
  __typename: 'CmsGamesDocAccessFields_company_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Company_Delete = {
  __typename: 'CmsGamesDocAccessFields_company_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Company_Read = {
  __typename: 'CmsGamesDocAccessFields_company_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Company_Update = {
  __typename: 'CmsGamesDocAccessFields_company_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Content = {
  __typename: 'CmsGamesDocAccessFields_content';
  create: Maybe<CmsGamesDocAccessFields_Content_Create>;
  delete: Maybe<CmsGamesDocAccessFields_Content_Delete>;
  read: Maybe<CmsGamesDocAccessFields_Content_Read>;
  update: Maybe<CmsGamesDocAccessFields_Content_Update>;
};

export type CmsGamesDocAccessFields_Content_Create = {
  __typename: 'CmsGamesDocAccessFields_content_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Content_Delete = {
  __typename: 'CmsGamesDocAccessFields_content_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Content_Read = {
  __typename: 'CmsGamesDocAccessFields_content_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Content_Update = {
  __typename: 'CmsGamesDocAccessFields_content_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_CreatedAt = {
  __typename: 'CmsGamesDocAccessFields_createdAt';
  create: Maybe<CmsGamesDocAccessFields_CreatedAt_Create>;
  delete: Maybe<CmsGamesDocAccessFields_CreatedAt_Delete>;
  read: Maybe<CmsGamesDocAccessFields_CreatedAt_Read>;
  update: Maybe<CmsGamesDocAccessFields_CreatedAt_Update>;
};

export type CmsGamesDocAccessFields_CreatedAt_Create = {
  __typename: 'CmsGamesDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_CreatedAt_Delete = {
  __typename: 'CmsGamesDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_CreatedAt_Read = {
  __typename: 'CmsGamesDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_CreatedAt_Update = {
  __typename: 'CmsGamesDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameBanner = {
  __typename: 'CmsGamesDocAccessFields_gameBanner';
  create: Maybe<CmsGamesDocAccessFields_GameBanner_Create>;
  delete: Maybe<CmsGamesDocAccessFields_GameBanner_Delete>;
  read: Maybe<CmsGamesDocAccessFields_GameBanner_Read>;
  update: Maybe<CmsGamesDocAccessFields_GameBanner_Update>;
};

export type CmsGamesDocAccessFields_GameBanner_Create = {
  __typename: 'CmsGamesDocAccessFields_gameBanner_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameBanner_Delete = {
  __typename: 'CmsGamesDocAccessFields_gameBanner_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameBanner_Read = {
  __typename: 'CmsGamesDocAccessFields_gameBanner_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameBanner_Update = {
  __typename: 'CmsGamesDocAccessFields_gameBanner_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameLink = {
  __typename: 'CmsGamesDocAccessFields_gameLink';
  create: Maybe<CmsGamesDocAccessFields_GameLink_Create>;
  delete: Maybe<CmsGamesDocAccessFields_GameLink_Delete>;
  read: Maybe<CmsGamesDocAccessFields_GameLink_Read>;
  update: Maybe<CmsGamesDocAccessFields_GameLink_Update>;
};

export type CmsGamesDocAccessFields_GameLink_Create = {
  __typename: 'CmsGamesDocAccessFields_gameLink_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameLink_Delete = {
  __typename: 'CmsGamesDocAccessFields_gameLink_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameLink_Read = {
  __typename: 'CmsGamesDocAccessFields_gameLink_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameLink_Update = {
  __typename: 'CmsGamesDocAccessFields_gameLink_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId';
  create: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_Create>;
  delete: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_Delete>;
  fields: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_Fields>;
  read: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_Read>;
  update: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_Update>;
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_Create = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_Delete = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_Fields = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_Fields';
  embedId: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_EmbedId>;
  title: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_Title>;
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_Read = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_Update = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_EmbedId = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_embedId';
  create: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_EmbedId_Create>;
  delete: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_EmbedId_Delete>;
  read: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_EmbedId_Read>;
  update: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_EmbedId_Update>;
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_EmbedId_Create = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_EmbedId_Delete = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_EmbedId_Read = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_EmbedId_Update = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_Title = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_title';
  create: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_Title_Create>;
  delete: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_Title_Delete>;
  read: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_Title_Read>;
  update: Maybe<CmsGamesDocAccessFields_GameTrailerEmbedId_Title_Update>;
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_Title_Create = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_title_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_Title_Delete = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_title_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_Title_Read = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_title_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_GameTrailerEmbedId_Title_Update = {
  __typename: 'CmsGamesDocAccessFields_gameTrailerEmbedId_title_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Images = {
  __typename: 'CmsGamesDocAccessFields_images';
  create: Maybe<CmsGamesDocAccessFields_Images_Create>;
  delete: Maybe<CmsGamesDocAccessFields_Images_Delete>;
  fields: Maybe<CmsGamesDocAccessFields_Images_Fields>;
  read: Maybe<CmsGamesDocAccessFields_Images_Read>;
  update: Maybe<CmsGamesDocAccessFields_Images_Update>;
};

export type CmsGamesDocAccessFields_Images_Create = {
  __typename: 'CmsGamesDocAccessFields_images_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Images_Delete = {
  __typename: 'CmsGamesDocAccessFields_images_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Images_Fields = {
  __typename: 'CmsGamesDocAccessFields_images_Fields';
  id: Maybe<CmsGamesDocAccessFields_Images_Id>;
  image: Maybe<CmsGamesDocAccessFields_Images_Image>;
};

export type CmsGamesDocAccessFields_Images_Read = {
  __typename: 'CmsGamesDocAccessFields_images_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Images_Update = {
  __typename: 'CmsGamesDocAccessFields_images_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Images_Id = {
  __typename: 'CmsGamesDocAccessFields_images_id';
  create: Maybe<CmsGamesDocAccessFields_Images_Id_Create>;
  delete: Maybe<CmsGamesDocAccessFields_Images_Id_Delete>;
  read: Maybe<CmsGamesDocAccessFields_Images_Id_Read>;
  update: Maybe<CmsGamesDocAccessFields_Images_Id_Update>;
};

export type CmsGamesDocAccessFields_Images_Id_Create = {
  __typename: 'CmsGamesDocAccessFields_images_id_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Images_Id_Delete = {
  __typename: 'CmsGamesDocAccessFields_images_id_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Images_Id_Read = {
  __typename: 'CmsGamesDocAccessFields_images_id_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Images_Id_Update = {
  __typename: 'CmsGamesDocAccessFields_images_id_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Images_Image = {
  __typename: 'CmsGamesDocAccessFields_images_image';
  create: Maybe<CmsGamesDocAccessFields_Images_Image_Create>;
  delete: Maybe<CmsGamesDocAccessFields_Images_Image_Delete>;
  read: Maybe<CmsGamesDocAccessFields_Images_Image_Read>;
  update: Maybe<CmsGamesDocAccessFields_Images_Image_Update>;
};

export type CmsGamesDocAccessFields_Images_Image_Create = {
  __typename: 'CmsGamesDocAccessFields_images_image_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Images_Image_Delete = {
  __typename: 'CmsGamesDocAccessFields_images_image_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Images_Image_Read = {
  __typename: 'CmsGamesDocAccessFields_images_image_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Images_Image_Update = {
  __typename: 'CmsGamesDocAccessFields_images_image_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Name = {
  __typename: 'CmsGamesDocAccessFields_name';
  create: Maybe<CmsGamesDocAccessFields_Name_Create>;
  delete: Maybe<CmsGamesDocAccessFields_Name_Delete>;
  read: Maybe<CmsGamesDocAccessFields_Name_Read>;
  update: Maybe<CmsGamesDocAccessFields_Name_Update>;
};

export type CmsGamesDocAccessFields_Name_Create = {
  __typename: 'CmsGamesDocAccessFields_name_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Name_Delete = {
  __typename: 'CmsGamesDocAccessFields_name_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Name_Read = {
  __typename: 'CmsGamesDocAccessFields_name_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Name_Update = {
  __typename: 'CmsGamesDocAccessFields_name_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_RelatedGames = {
  __typename: 'CmsGamesDocAccessFields_relatedGames';
  create: Maybe<CmsGamesDocAccessFields_RelatedGames_Create>;
  delete: Maybe<CmsGamesDocAccessFields_RelatedGames_Delete>;
  read: Maybe<CmsGamesDocAccessFields_RelatedGames_Read>;
  update: Maybe<CmsGamesDocAccessFields_RelatedGames_Update>;
};

export type CmsGamesDocAccessFields_RelatedGames_Create = {
  __typename: 'CmsGamesDocAccessFields_relatedGames_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_RelatedGames_Delete = {
  __typename: 'CmsGamesDocAccessFields_relatedGames_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_RelatedGames_Read = {
  __typename: 'CmsGamesDocAccessFields_relatedGames_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_RelatedGames_Update = {
  __typename: 'CmsGamesDocAccessFields_relatedGames_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_ShortDescription = {
  __typename: 'CmsGamesDocAccessFields_shortDescription';
  create: Maybe<CmsGamesDocAccessFields_ShortDescription_Create>;
  delete: Maybe<CmsGamesDocAccessFields_ShortDescription_Delete>;
  read: Maybe<CmsGamesDocAccessFields_ShortDescription_Read>;
  update: Maybe<CmsGamesDocAccessFields_ShortDescription_Update>;
};

export type CmsGamesDocAccessFields_ShortDescription_Create = {
  __typename: 'CmsGamesDocAccessFields_shortDescription_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_ShortDescription_Delete = {
  __typename: 'CmsGamesDocAccessFields_shortDescription_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_ShortDescription_Read = {
  __typename: 'CmsGamesDocAccessFields_shortDescription_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_ShortDescription_Update = {
  __typename: 'CmsGamesDocAccessFields_shortDescription_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Status = {
  __typename: 'CmsGamesDocAccessFields_status';
  create: Maybe<CmsGamesDocAccessFields_Status_Create>;
  delete: Maybe<CmsGamesDocAccessFields_Status_Delete>;
  read: Maybe<CmsGamesDocAccessFields_Status_Read>;
  update: Maybe<CmsGamesDocAccessFields_Status_Update>;
};

export type CmsGamesDocAccessFields_Status_Create = {
  __typename: 'CmsGamesDocAccessFields_status_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Status_Delete = {
  __typename: 'CmsGamesDocAccessFields_status_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Status_Read = {
  __typename: 'CmsGamesDocAccessFields_status_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_Status_Update = {
  __typename: 'CmsGamesDocAccessFields_status_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_UpdatedAt = {
  __typename: 'CmsGamesDocAccessFields_updatedAt';
  create: Maybe<CmsGamesDocAccessFields_UpdatedAt_Create>;
  delete: Maybe<CmsGamesDocAccessFields_UpdatedAt_Delete>;
  read: Maybe<CmsGamesDocAccessFields_UpdatedAt_Read>;
  update: Maybe<CmsGamesDocAccessFields_UpdatedAt_Update>;
};

export type CmsGamesDocAccessFields_UpdatedAt_Create = {
  __typename: 'CmsGamesDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_UpdatedAt_Delete = {
  __typename: 'CmsGamesDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_UpdatedAt_Read = {
  __typename: 'CmsGamesDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesDocAccessFields_UpdatedAt_Update = {
  __typename: 'CmsGamesDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields = {
  __typename: 'CmsGamesFields';
  avatar: Maybe<CmsGamesFields_Avatar>;
  company: Maybe<CmsGamesFields_Company>;
  content: Maybe<CmsGamesFields_Content>;
  createdAt: Maybe<CmsGamesFields_CreatedAt>;
  gameBanner: Maybe<CmsGamesFields_GameBanner>;
  gameLink: Maybe<CmsGamesFields_GameLink>;
  gameTrailerEmbedId: Maybe<CmsGamesFields_GameTrailerEmbedId>;
  images: Maybe<CmsGamesFields_Images>;
  name: Maybe<CmsGamesFields_Name>;
  relatedGames: Maybe<CmsGamesFields_RelatedGames>;
  shortDescription: Maybe<CmsGamesFields_ShortDescription>;
  status: Maybe<CmsGamesFields_Status>;
  updatedAt: Maybe<CmsGamesFields_UpdatedAt>;
};

export type CmsGamesFields_Avatar = {
  __typename: 'CmsGamesFields_avatar';
  create: Maybe<CmsGamesFields_Avatar_Create>;
  delete: Maybe<CmsGamesFields_Avatar_Delete>;
  read: Maybe<CmsGamesFields_Avatar_Read>;
  update: Maybe<CmsGamesFields_Avatar_Update>;
};

export type CmsGamesFields_Avatar_Create = {
  __typename: 'CmsGamesFields_avatar_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Avatar_Delete = {
  __typename: 'CmsGamesFields_avatar_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Avatar_Read = {
  __typename: 'CmsGamesFields_avatar_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Avatar_Update = {
  __typename: 'CmsGamesFields_avatar_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Company = {
  __typename: 'CmsGamesFields_company';
  create: Maybe<CmsGamesFields_Company_Create>;
  delete: Maybe<CmsGamesFields_Company_Delete>;
  read: Maybe<CmsGamesFields_Company_Read>;
  update: Maybe<CmsGamesFields_Company_Update>;
};

export type CmsGamesFields_Company_Create = {
  __typename: 'CmsGamesFields_company_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Company_Delete = {
  __typename: 'CmsGamesFields_company_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Company_Read = {
  __typename: 'CmsGamesFields_company_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Company_Update = {
  __typename: 'CmsGamesFields_company_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Content = {
  __typename: 'CmsGamesFields_content';
  create: Maybe<CmsGamesFields_Content_Create>;
  delete: Maybe<CmsGamesFields_Content_Delete>;
  read: Maybe<CmsGamesFields_Content_Read>;
  update: Maybe<CmsGamesFields_Content_Update>;
};

export type CmsGamesFields_Content_Create = {
  __typename: 'CmsGamesFields_content_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Content_Delete = {
  __typename: 'CmsGamesFields_content_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Content_Read = {
  __typename: 'CmsGamesFields_content_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Content_Update = {
  __typename: 'CmsGamesFields_content_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_CreatedAt = {
  __typename: 'CmsGamesFields_createdAt';
  create: Maybe<CmsGamesFields_CreatedAt_Create>;
  delete: Maybe<CmsGamesFields_CreatedAt_Delete>;
  read: Maybe<CmsGamesFields_CreatedAt_Read>;
  update: Maybe<CmsGamesFields_CreatedAt_Update>;
};

export type CmsGamesFields_CreatedAt_Create = {
  __typename: 'CmsGamesFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_CreatedAt_Delete = {
  __typename: 'CmsGamesFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_CreatedAt_Read = {
  __typename: 'CmsGamesFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_CreatedAt_Update = {
  __typename: 'CmsGamesFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameBanner = {
  __typename: 'CmsGamesFields_gameBanner';
  create: Maybe<CmsGamesFields_GameBanner_Create>;
  delete: Maybe<CmsGamesFields_GameBanner_Delete>;
  read: Maybe<CmsGamesFields_GameBanner_Read>;
  update: Maybe<CmsGamesFields_GameBanner_Update>;
};

export type CmsGamesFields_GameBanner_Create = {
  __typename: 'CmsGamesFields_gameBanner_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameBanner_Delete = {
  __typename: 'CmsGamesFields_gameBanner_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameBanner_Read = {
  __typename: 'CmsGamesFields_gameBanner_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameBanner_Update = {
  __typename: 'CmsGamesFields_gameBanner_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameLink = {
  __typename: 'CmsGamesFields_gameLink';
  create: Maybe<CmsGamesFields_GameLink_Create>;
  delete: Maybe<CmsGamesFields_GameLink_Delete>;
  read: Maybe<CmsGamesFields_GameLink_Read>;
  update: Maybe<CmsGamesFields_GameLink_Update>;
};

export type CmsGamesFields_GameLink_Create = {
  __typename: 'CmsGamesFields_gameLink_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameLink_Delete = {
  __typename: 'CmsGamesFields_gameLink_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameLink_Read = {
  __typename: 'CmsGamesFields_gameLink_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameLink_Update = {
  __typename: 'CmsGamesFields_gameLink_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameTrailerEmbedId = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId';
  create: Maybe<CmsGamesFields_GameTrailerEmbedId_Create>;
  delete: Maybe<CmsGamesFields_GameTrailerEmbedId_Delete>;
  fields: Maybe<CmsGamesFields_GameTrailerEmbedId_Fields>;
  read: Maybe<CmsGamesFields_GameTrailerEmbedId_Read>;
  update: Maybe<CmsGamesFields_GameTrailerEmbedId_Update>;
};

export type CmsGamesFields_GameTrailerEmbedId_Create = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameTrailerEmbedId_Delete = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameTrailerEmbedId_Fields = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_Fields';
  embedId: Maybe<CmsGamesFields_GameTrailerEmbedId_EmbedId>;
  title: Maybe<CmsGamesFields_GameTrailerEmbedId_Title>;
};

export type CmsGamesFields_GameTrailerEmbedId_Read = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameTrailerEmbedId_Update = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameTrailerEmbedId_EmbedId = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_embedId';
  create: Maybe<CmsGamesFields_GameTrailerEmbedId_EmbedId_Create>;
  delete: Maybe<CmsGamesFields_GameTrailerEmbedId_EmbedId_Delete>;
  read: Maybe<CmsGamesFields_GameTrailerEmbedId_EmbedId_Read>;
  update: Maybe<CmsGamesFields_GameTrailerEmbedId_EmbedId_Update>;
};

export type CmsGamesFields_GameTrailerEmbedId_EmbedId_Create = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_embedId_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameTrailerEmbedId_EmbedId_Delete = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_embedId_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameTrailerEmbedId_EmbedId_Read = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_embedId_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameTrailerEmbedId_EmbedId_Update = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_embedId_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameTrailerEmbedId_Title = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_title';
  create: Maybe<CmsGamesFields_GameTrailerEmbedId_Title_Create>;
  delete: Maybe<CmsGamesFields_GameTrailerEmbedId_Title_Delete>;
  read: Maybe<CmsGamesFields_GameTrailerEmbedId_Title_Read>;
  update: Maybe<CmsGamesFields_GameTrailerEmbedId_Title_Update>;
};

export type CmsGamesFields_GameTrailerEmbedId_Title_Create = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_title_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameTrailerEmbedId_Title_Delete = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_title_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameTrailerEmbedId_Title_Read = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_title_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_GameTrailerEmbedId_Title_Update = {
  __typename: 'CmsGamesFields_gameTrailerEmbedId_title_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Images = {
  __typename: 'CmsGamesFields_images';
  create: Maybe<CmsGamesFields_Images_Create>;
  delete: Maybe<CmsGamesFields_Images_Delete>;
  fields: Maybe<CmsGamesFields_Images_Fields>;
  read: Maybe<CmsGamesFields_Images_Read>;
  update: Maybe<CmsGamesFields_Images_Update>;
};

export type CmsGamesFields_Images_Create = {
  __typename: 'CmsGamesFields_images_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Images_Delete = {
  __typename: 'CmsGamesFields_images_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Images_Fields = {
  __typename: 'CmsGamesFields_images_Fields';
  id: Maybe<CmsGamesFields_Images_Id>;
  image: Maybe<CmsGamesFields_Images_Image>;
};

export type CmsGamesFields_Images_Read = {
  __typename: 'CmsGamesFields_images_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Images_Update = {
  __typename: 'CmsGamesFields_images_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Images_Id = {
  __typename: 'CmsGamesFields_images_id';
  create: Maybe<CmsGamesFields_Images_Id_Create>;
  delete: Maybe<CmsGamesFields_Images_Id_Delete>;
  read: Maybe<CmsGamesFields_Images_Id_Read>;
  update: Maybe<CmsGamesFields_Images_Id_Update>;
};

export type CmsGamesFields_Images_Id_Create = {
  __typename: 'CmsGamesFields_images_id_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Images_Id_Delete = {
  __typename: 'CmsGamesFields_images_id_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Images_Id_Read = {
  __typename: 'CmsGamesFields_images_id_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Images_Id_Update = {
  __typename: 'CmsGamesFields_images_id_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Images_Image = {
  __typename: 'CmsGamesFields_images_image';
  create: Maybe<CmsGamesFields_Images_Image_Create>;
  delete: Maybe<CmsGamesFields_Images_Image_Delete>;
  read: Maybe<CmsGamesFields_Images_Image_Read>;
  update: Maybe<CmsGamesFields_Images_Image_Update>;
};

export type CmsGamesFields_Images_Image_Create = {
  __typename: 'CmsGamesFields_images_image_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Images_Image_Delete = {
  __typename: 'CmsGamesFields_images_image_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Images_Image_Read = {
  __typename: 'CmsGamesFields_images_image_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Images_Image_Update = {
  __typename: 'CmsGamesFields_images_image_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Name = {
  __typename: 'CmsGamesFields_name';
  create: Maybe<CmsGamesFields_Name_Create>;
  delete: Maybe<CmsGamesFields_Name_Delete>;
  read: Maybe<CmsGamesFields_Name_Read>;
  update: Maybe<CmsGamesFields_Name_Update>;
};

export type CmsGamesFields_Name_Create = {
  __typename: 'CmsGamesFields_name_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Name_Delete = {
  __typename: 'CmsGamesFields_name_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Name_Read = {
  __typename: 'CmsGamesFields_name_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Name_Update = {
  __typename: 'CmsGamesFields_name_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_RelatedGames = {
  __typename: 'CmsGamesFields_relatedGames';
  create: Maybe<CmsGamesFields_RelatedGames_Create>;
  delete: Maybe<CmsGamesFields_RelatedGames_Delete>;
  read: Maybe<CmsGamesFields_RelatedGames_Read>;
  update: Maybe<CmsGamesFields_RelatedGames_Update>;
};

export type CmsGamesFields_RelatedGames_Create = {
  __typename: 'CmsGamesFields_relatedGames_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_RelatedGames_Delete = {
  __typename: 'CmsGamesFields_relatedGames_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_RelatedGames_Read = {
  __typename: 'CmsGamesFields_relatedGames_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_RelatedGames_Update = {
  __typename: 'CmsGamesFields_relatedGames_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_ShortDescription = {
  __typename: 'CmsGamesFields_shortDescription';
  create: Maybe<CmsGamesFields_ShortDescription_Create>;
  delete: Maybe<CmsGamesFields_ShortDescription_Delete>;
  read: Maybe<CmsGamesFields_ShortDescription_Read>;
  update: Maybe<CmsGamesFields_ShortDescription_Update>;
};

export type CmsGamesFields_ShortDescription_Create = {
  __typename: 'CmsGamesFields_shortDescription_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_ShortDescription_Delete = {
  __typename: 'CmsGamesFields_shortDescription_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_ShortDescription_Read = {
  __typename: 'CmsGamesFields_shortDescription_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_ShortDescription_Update = {
  __typename: 'CmsGamesFields_shortDescription_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Status = {
  __typename: 'CmsGamesFields_status';
  create: Maybe<CmsGamesFields_Status_Create>;
  delete: Maybe<CmsGamesFields_Status_Delete>;
  read: Maybe<CmsGamesFields_Status_Read>;
  update: Maybe<CmsGamesFields_Status_Update>;
};

export type CmsGamesFields_Status_Create = {
  __typename: 'CmsGamesFields_status_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Status_Delete = {
  __typename: 'CmsGamesFields_status_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Status_Read = {
  __typename: 'CmsGamesFields_status_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_Status_Update = {
  __typename: 'CmsGamesFields_status_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_UpdatedAt = {
  __typename: 'CmsGamesFields_updatedAt';
  create: Maybe<CmsGamesFields_UpdatedAt_Create>;
  delete: Maybe<CmsGamesFields_UpdatedAt_Delete>;
  read: Maybe<CmsGamesFields_UpdatedAt_Read>;
  update: Maybe<CmsGamesFields_UpdatedAt_Update>;
};

export type CmsGamesFields_UpdatedAt_Create = {
  __typename: 'CmsGamesFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_UpdatedAt_Delete = {
  __typename: 'CmsGamesFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_UpdatedAt_Read = {
  __typename: 'CmsGamesFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsGamesFields_UpdatedAt_Update = {
  __typename: 'CmsGamesFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsGamesReadAccess = {
  __typename: 'CmsGamesReadAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamesReadDocAccess = {
  __typename: 'CmsGamesReadDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamesUpdateAccess = {
  __typename: 'CmsGamesUpdateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsGamesUpdateDocAccess = {
  __typename: 'CmsGamesUpdateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsMedia = {
  __typename: 'CmsMedia';
  createdAt: Maybe<Scalars['DateTime']>;
  filename: Maybe<Scalars['String']>;
  filesize: Maybe<Scalars['Float']>;
  focalX: Maybe<Scalars['Float']>;
  focalY: Maybe<Scalars['Float']>;
  height: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  mimeType: Maybe<Scalars['String']>;
  sizes: Maybe<CmsMedia_Sizes>;
  thumbnailURL: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  url: Maybe<Scalars['String']>;
  width: Maybe<Scalars['Float']>;
};

export type CmsMediaCreateAccess = {
  __typename: 'CmsMediaCreateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsMediaCreateDocAccess = {
  __typename: 'CmsMediaCreateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsMediaDeleteAccess = {
  __typename: 'CmsMediaDeleteAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsMediaDeleteDocAccess = {
  __typename: 'CmsMediaDeleteDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsMediaDocAccessFields = {
  __typename: 'CmsMediaDocAccessFields';
  createdAt: Maybe<CmsMediaDocAccessFields_CreatedAt>;
  filename: Maybe<CmsMediaDocAccessFields_Filename>;
  filesize: Maybe<CmsMediaDocAccessFields_Filesize>;
  focalX: Maybe<CmsMediaDocAccessFields_FocalX>;
  focalY: Maybe<CmsMediaDocAccessFields_FocalY>;
  height: Maybe<CmsMediaDocAccessFields_Height>;
  mimeType: Maybe<CmsMediaDocAccessFields_MimeType>;
  sizes: Maybe<CmsMediaDocAccessFields_Sizes>;
  thumbnailURL: Maybe<CmsMediaDocAccessFields_ThumbnailUrl>;
  updatedAt: Maybe<CmsMediaDocAccessFields_UpdatedAt>;
  url: Maybe<CmsMediaDocAccessFields_Url>;
  width: Maybe<CmsMediaDocAccessFields_Width>;
};

export type CmsMediaDocAccessFields_CreatedAt = {
  __typename: 'CmsMediaDocAccessFields_createdAt';
  create: Maybe<CmsMediaDocAccessFields_CreatedAt_Create>;
  delete: Maybe<CmsMediaDocAccessFields_CreatedAt_Delete>;
  read: Maybe<CmsMediaDocAccessFields_CreatedAt_Read>;
  update: Maybe<CmsMediaDocAccessFields_CreatedAt_Update>;
};

export type CmsMediaDocAccessFields_CreatedAt_Create = {
  __typename: 'CmsMediaDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_CreatedAt_Delete = {
  __typename: 'CmsMediaDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_CreatedAt_Read = {
  __typename: 'CmsMediaDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_CreatedAt_Update = {
  __typename: 'CmsMediaDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Filename = {
  __typename: 'CmsMediaDocAccessFields_filename';
  create: Maybe<CmsMediaDocAccessFields_Filename_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Filename_Delete>;
  read: Maybe<CmsMediaDocAccessFields_Filename_Read>;
  update: Maybe<CmsMediaDocAccessFields_Filename_Update>;
};

export type CmsMediaDocAccessFields_Filename_Create = {
  __typename: 'CmsMediaDocAccessFields_filename_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Filename_Delete = {
  __typename: 'CmsMediaDocAccessFields_filename_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Filename_Read = {
  __typename: 'CmsMediaDocAccessFields_filename_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Filename_Update = {
  __typename: 'CmsMediaDocAccessFields_filename_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Filesize = {
  __typename: 'CmsMediaDocAccessFields_filesize';
  create: Maybe<CmsMediaDocAccessFields_Filesize_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Filesize_Delete>;
  read: Maybe<CmsMediaDocAccessFields_Filesize_Read>;
  update: Maybe<CmsMediaDocAccessFields_Filesize_Update>;
};

export type CmsMediaDocAccessFields_Filesize_Create = {
  __typename: 'CmsMediaDocAccessFields_filesize_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Filesize_Delete = {
  __typename: 'CmsMediaDocAccessFields_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Filesize_Read = {
  __typename: 'CmsMediaDocAccessFields_filesize_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Filesize_Update = {
  __typename: 'CmsMediaDocAccessFields_filesize_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_FocalX = {
  __typename: 'CmsMediaDocAccessFields_focalX';
  create: Maybe<CmsMediaDocAccessFields_FocalX_Create>;
  delete: Maybe<CmsMediaDocAccessFields_FocalX_Delete>;
  read: Maybe<CmsMediaDocAccessFields_FocalX_Read>;
  update: Maybe<CmsMediaDocAccessFields_FocalX_Update>;
};

export type CmsMediaDocAccessFields_FocalX_Create = {
  __typename: 'CmsMediaDocAccessFields_focalX_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_FocalX_Delete = {
  __typename: 'CmsMediaDocAccessFields_focalX_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_FocalX_Read = {
  __typename: 'CmsMediaDocAccessFields_focalX_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_FocalX_Update = {
  __typename: 'CmsMediaDocAccessFields_focalX_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_FocalY = {
  __typename: 'CmsMediaDocAccessFields_focalY';
  create: Maybe<CmsMediaDocAccessFields_FocalY_Create>;
  delete: Maybe<CmsMediaDocAccessFields_FocalY_Delete>;
  read: Maybe<CmsMediaDocAccessFields_FocalY_Read>;
  update: Maybe<CmsMediaDocAccessFields_FocalY_Update>;
};

export type CmsMediaDocAccessFields_FocalY_Create = {
  __typename: 'CmsMediaDocAccessFields_focalY_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_FocalY_Delete = {
  __typename: 'CmsMediaDocAccessFields_focalY_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_FocalY_Read = {
  __typename: 'CmsMediaDocAccessFields_focalY_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_FocalY_Update = {
  __typename: 'CmsMediaDocAccessFields_focalY_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Height = {
  __typename: 'CmsMediaDocAccessFields_height';
  create: Maybe<CmsMediaDocAccessFields_Height_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Height_Delete>;
  read: Maybe<CmsMediaDocAccessFields_Height_Read>;
  update: Maybe<CmsMediaDocAccessFields_Height_Update>;
};

export type CmsMediaDocAccessFields_Height_Create = {
  __typename: 'CmsMediaDocAccessFields_height_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Height_Delete = {
  __typename: 'CmsMediaDocAccessFields_height_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Height_Read = {
  __typename: 'CmsMediaDocAccessFields_height_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Height_Update = {
  __typename: 'CmsMediaDocAccessFields_height_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_MimeType = {
  __typename: 'CmsMediaDocAccessFields_mimeType';
  create: Maybe<CmsMediaDocAccessFields_MimeType_Create>;
  delete: Maybe<CmsMediaDocAccessFields_MimeType_Delete>;
  read: Maybe<CmsMediaDocAccessFields_MimeType_Read>;
  update: Maybe<CmsMediaDocAccessFields_MimeType_Update>;
};

export type CmsMediaDocAccessFields_MimeType_Create = {
  __typename: 'CmsMediaDocAccessFields_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_MimeType_Delete = {
  __typename: 'CmsMediaDocAccessFields_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_MimeType_Read = {
  __typename: 'CmsMediaDocAccessFields_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_MimeType_Update = {
  __typename: 'CmsMediaDocAccessFields_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes = {
  __typename: 'CmsMediaDocAccessFields_sizes';
  create: Maybe<CmsMediaDocAccessFields_Sizes_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Sizes_Delete>;
  fields: Maybe<CmsMediaDocAccessFields_Sizes_Fields>;
  read: Maybe<CmsMediaDocAccessFields_Sizes_Read>;
  update: Maybe<CmsMediaDocAccessFields_Sizes_Update>;
};

export type CmsMediaDocAccessFields_Sizes_Create = {
  __typename: 'CmsMediaDocAccessFields_sizes_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Delete = {
  __typename: 'CmsMediaDocAccessFields_sizes_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Fields = {
  __typename: 'CmsMediaDocAccessFields_sizes_Fields';
  thumbnail: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail>;
};

export type CmsMediaDocAccessFields_Sizes_Read = {
  __typename: 'CmsMediaDocAccessFields_sizes_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Update = {
  __typename: 'CmsMediaDocAccessFields_sizes_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail';
  create: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Delete>;
  fields: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Fields>;
  read: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Read>;
  update: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Update>;
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Create = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Delete = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Fields = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_Fields';
  filename: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Filename>;
  filesize: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Filesize>;
  height: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Height>;
  mimeType: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_MimeType>;
  url: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Url>;
  width: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Width>;
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Read = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Update = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Filename = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_filename';
  create: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Filename_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Filename_Delete>;
  read: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Filename_Read>;
  update: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Filename_Update>;
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Filename_Create = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_filename_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Filename_Delete = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_filename_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Filename_Read = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_filename_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Filename_Update = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_filename_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Filesize = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_filesize';
  create: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Filesize_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Filesize_Delete>;
  read: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Filesize_Read>;
  update: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Filesize_Update>;
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Filesize_Create = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_filesize_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Filesize_Delete = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Filesize_Read = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_filesize_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Filesize_Update = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_filesize_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Height = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_height';
  create: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Height_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Height_Delete>;
  read: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Height_Read>;
  update: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Height_Update>;
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Height_Create = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_height_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Height_Delete = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_height_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Height_Read = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_height_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Height_Update = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_height_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_MimeType = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_mimeType';
  create: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_MimeType_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_MimeType_Delete>;
  read: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_MimeType_Read>;
  update: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_MimeType_Update>;
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_MimeType_Create = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_MimeType_Delete = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_MimeType_Read = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_MimeType_Update = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Url = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_url';
  create: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Url_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Url_Delete>;
  read: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Url_Read>;
  update: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Url_Update>;
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Url_Create = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_url_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Url_Delete = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_url_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Url_Read = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_url_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Url_Update = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_url_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Width = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_width';
  create: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Width_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Width_Delete>;
  read: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Width_Read>;
  update: Maybe<CmsMediaDocAccessFields_Sizes_Thumbnail_Width_Update>;
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Width_Create = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_width_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Width_Delete = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_width_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Width_Read = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_width_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Sizes_Thumbnail_Width_Update = {
  __typename: 'CmsMediaDocAccessFields_sizes_thumbnail_width_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_ThumbnailUrl = {
  __typename: 'CmsMediaDocAccessFields_thumbnailURL';
  create: Maybe<CmsMediaDocAccessFields_ThumbnailUrl_Create>;
  delete: Maybe<CmsMediaDocAccessFields_ThumbnailUrl_Delete>;
  read: Maybe<CmsMediaDocAccessFields_ThumbnailUrl_Read>;
  update: Maybe<CmsMediaDocAccessFields_ThumbnailUrl_Update>;
};

export type CmsMediaDocAccessFields_ThumbnailUrl_Create = {
  __typename: 'CmsMediaDocAccessFields_thumbnailURL_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_ThumbnailUrl_Delete = {
  __typename: 'CmsMediaDocAccessFields_thumbnailURL_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_ThumbnailUrl_Read = {
  __typename: 'CmsMediaDocAccessFields_thumbnailURL_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_ThumbnailUrl_Update = {
  __typename: 'CmsMediaDocAccessFields_thumbnailURL_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_UpdatedAt = {
  __typename: 'CmsMediaDocAccessFields_updatedAt';
  create: Maybe<CmsMediaDocAccessFields_UpdatedAt_Create>;
  delete: Maybe<CmsMediaDocAccessFields_UpdatedAt_Delete>;
  read: Maybe<CmsMediaDocAccessFields_UpdatedAt_Read>;
  update: Maybe<CmsMediaDocAccessFields_UpdatedAt_Update>;
};

export type CmsMediaDocAccessFields_UpdatedAt_Create = {
  __typename: 'CmsMediaDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_UpdatedAt_Delete = {
  __typename: 'CmsMediaDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_UpdatedAt_Read = {
  __typename: 'CmsMediaDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_UpdatedAt_Update = {
  __typename: 'CmsMediaDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Url = {
  __typename: 'CmsMediaDocAccessFields_url';
  create: Maybe<CmsMediaDocAccessFields_Url_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Url_Delete>;
  read: Maybe<CmsMediaDocAccessFields_Url_Read>;
  update: Maybe<CmsMediaDocAccessFields_Url_Update>;
};

export type CmsMediaDocAccessFields_Url_Create = {
  __typename: 'CmsMediaDocAccessFields_url_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Url_Delete = {
  __typename: 'CmsMediaDocAccessFields_url_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Url_Read = {
  __typename: 'CmsMediaDocAccessFields_url_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Url_Update = {
  __typename: 'CmsMediaDocAccessFields_url_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Width = {
  __typename: 'CmsMediaDocAccessFields_width';
  create: Maybe<CmsMediaDocAccessFields_Width_Create>;
  delete: Maybe<CmsMediaDocAccessFields_Width_Delete>;
  read: Maybe<CmsMediaDocAccessFields_Width_Read>;
  update: Maybe<CmsMediaDocAccessFields_Width_Update>;
};

export type CmsMediaDocAccessFields_Width_Create = {
  __typename: 'CmsMediaDocAccessFields_width_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Width_Delete = {
  __typename: 'CmsMediaDocAccessFields_width_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Width_Read = {
  __typename: 'CmsMediaDocAccessFields_width_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaDocAccessFields_Width_Update = {
  __typename: 'CmsMediaDocAccessFields_width_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields = {
  __typename: 'CmsMediaFields';
  createdAt: Maybe<CmsMediaFields_CreatedAt>;
  filename: Maybe<CmsMediaFields_Filename>;
  filesize: Maybe<CmsMediaFields_Filesize>;
  focalX: Maybe<CmsMediaFields_FocalX>;
  focalY: Maybe<CmsMediaFields_FocalY>;
  height: Maybe<CmsMediaFields_Height>;
  mimeType: Maybe<CmsMediaFields_MimeType>;
  sizes: Maybe<CmsMediaFields_Sizes>;
  thumbnailURL: Maybe<CmsMediaFields_ThumbnailUrl>;
  updatedAt: Maybe<CmsMediaFields_UpdatedAt>;
  url: Maybe<CmsMediaFields_Url>;
  width: Maybe<CmsMediaFields_Width>;
};

export type CmsMediaFields_CreatedAt = {
  __typename: 'CmsMediaFields_createdAt';
  create: Maybe<CmsMediaFields_CreatedAt_Create>;
  delete: Maybe<CmsMediaFields_CreatedAt_Delete>;
  read: Maybe<CmsMediaFields_CreatedAt_Read>;
  update: Maybe<CmsMediaFields_CreatedAt_Update>;
};

export type CmsMediaFields_CreatedAt_Create = {
  __typename: 'CmsMediaFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_CreatedAt_Delete = {
  __typename: 'CmsMediaFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_CreatedAt_Read = {
  __typename: 'CmsMediaFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_CreatedAt_Update = {
  __typename: 'CmsMediaFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Filename = {
  __typename: 'CmsMediaFields_filename';
  create: Maybe<CmsMediaFields_Filename_Create>;
  delete: Maybe<CmsMediaFields_Filename_Delete>;
  read: Maybe<CmsMediaFields_Filename_Read>;
  update: Maybe<CmsMediaFields_Filename_Update>;
};

export type CmsMediaFields_Filename_Create = {
  __typename: 'CmsMediaFields_filename_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Filename_Delete = {
  __typename: 'CmsMediaFields_filename_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Filename_Read = {
  __typename: 'CmsMediaFields_filename_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Filename_Update = {
  __typename: 'CmsMediaFields_filename_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Filesize = {
  __typename: 'CmsMediaFields_filesize';
  create: Maybe<CmsMediaFields_Filesize_Create>;
  delete: Maybe<CmsMediaFields_Filesize_Delete>;
  read: Maybe<CmsMediaFields_Filesize_Read>;
  update: Maybe<CmsMediaFields_Filesize_Update>;
};

export type CmsMediaFields_Filesize_Create = {
  __typename: 'CmsMediaFields_filesize_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Filesize_Delete = {
  __typename: 'CmsMediaFields_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Filesize_Read = {
  __typename: 'CmsMediaFields_filesize_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Filesize_Update = {
  __typename: 'CmsMediaFields_filesize_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_FocalX = {
  __typename: 'CmsMediaFields_focalX';
  create: Maybe<CmsMediaFields_FocalX_Create>;
  delete: Maybe<CmsMediaFields_FocalX_Delete>;
  read: Maybe<CmsMediaFields_FocalX_Read>;
  update: Maybe<CmsMediaFields_FocalX_Update>;
};

export type CmsMediaFields_FocalX_Create = {
  __typename: 'CmsMediaFields_focalX_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_FocalX_Delete = {
  __typename: 'CmsMediaFields_focalX_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_FocalX_Read = {
  __typename: 'CmsMediaFields_focalX_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_FocalX_Update = {
  __typename: 'CmsMediaFields_focalX_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_FocalY = {
  __typename: 'CmsMediaFields_focalY';
  create: Maybe<CmsMediaFields_FocalY_Create>;
  delete: Maybe<CmsMediaFields_FocalY_Delete>;
  read: Maybe<CmsMediaFields_FocalY_Read>;
  update: Maybe<CmsMediaFields_FocalY_Update>;
};

export type CmsMediaFields_FocalY_Create = {
  __typename: 'CmsMediaFields_focalY_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_FocalY_Delete = {
  __typename: 'CmsMediaFields_focalY_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_FocalY_Read = {
  __typename: 'CmsMediaFields_focalY_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_FocalY_Update = {
  __typename: 'CmsMediaFields_focalY_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Height = {
  __typename: 'CmsMediaFields_height';
  create: Maybe<CmsMediaFields_Height_Create>;
  delete: Maybe<CmsMediaFields_Height_Delete>;
  read: Maybe<CmsMediaFields_Height_Read>;
  update: Maybe<CmsMediaFields_Height_Update>;
};

export type CmsMediaFields_Height_Create = {
  __typename: 'CmsMediaFields_height_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Height_Delete = {
  __typename: 'CmsMediaFields_height_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Height_Read = {
  __typename: 'CmsMediaFields_height_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Height_Update = {
  __typename: 'CmsMediaFields_height_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_MimeType = {
  __typename: 'CmsMediaFields_mimeType';
  create: Maybe<CmsMediaFields_MimeType_Create>;
  delete: Maybe<CmsMediaFields_MimeType_Delete>;
  read: Maybe<CmsMediaFields_MimeType_Read>;
  update: Maybe<CmsMediaFields_MimeType_Update>;
};

export type CmsMediaFields_MimeType_Create = {
  __typename: 'CmsMediaFields_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_MimeType_Delete = {
  __typename: 'CmsMediaFields_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_MimeType_Read = {
  __typename: 'CmsMediaFields_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_MimeType_Update = {
  __typename: 'CmsMediaFields_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes = {
  __typename: 'CmsMediaFields_sizes';
  create: Maybe<CmsMediaFields_Sizes_Create>;
  delete: Maybe<CmsMediaFields_Sizes_Delete>;
  fields: Maybe<CmsMediaFields_Sizes_Fields>;
  read: Maybe<CmsMediaFields_Sizes_Read>;
  update: Maybe<CmsMediaFields_Sizes_Update>;
};

export type CmsMediaFields_Sizes_Create = {
  __typename: 'CmsMediaFields_sizes_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Delete = {
  __typename: 'CmsMediaFields_sizes_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Fields = {
  __typename: 'CmsMediaFields_sizes_Fields';
  thumbnail: Maybe<CmsMediaFields_Sizes_Thumbnail>;
};

export type CmsMediaFields_Sizes_Read = {
  __typename: 'CmsMediaFields_sizes_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Update = {
  __typename: 'CmsMediaFields_sizes_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail = {
  __typename: 'CmsMediaFields_sizes_thumbnail';
  create: Maybe<CmsMediaFields_Sizes_Thumbnail_Create>;
  delete: Maybe<CmsMediaFields_Sizes_Thumbnail_Delete>;
  fields: Maybe<CmsMediaFields_Sizes_Thumbnail_Fields>;
  read: Maybe<CmsMediaFields_Sizes_Thumbnail_Read>;
  update: Maybe<CmsMediaFields_Sizes_Thumbnail_Update>;
};

export type CmsMediaFields_Sizes_Thumbnail_Create = {
  __typename: 'CmsMediaFields_sizes_thumbnail_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Delete = {
  __typename: 'CmsMediaFields_sizes_thumbnail_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Fields = {
  __typename: 'CmsMediaFields_sizes_thumbnail_Fields';
  filename: Maybe<CmsMediaFields_Sizes_Thumbnail_Filename>;
  filesize: Maybe<CmsMediaFields_Sizes_Thumbnail_Filesize>;
  height: Maybe<CmsMediaFields_Sizes_Thumbnail_Height>;
  mimeType: Maybe<CmsMediaFields_Sizes_Thumbnail_MimeType>;
  url: Maybe<CmsMediaFields_Sizes_Thumbnail_Url>;
  width: Maybe<CmsMediaFields_Sizes_Thumbnail_Width>;
};

export type CmsMediaFields_Sizes_Thumbnail_Read = {
  __typename: 'CmsMediaFields_sizes_thumbnail_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Update = {
  __typename: 'CmsMediaFields_sizes_thumbnail_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Filename = {
  __typename: 'CmsMediaFields_sizes_thumbnail_filename';
  create: Maybe<CmsMediaFields_Sizes_Thumbnail_Filename_Create>;
  delete: Maybe<CmsMediaFields_Sizes_Thumbnail_Filename_Delete>;
  read: Maybe<CmsMediaFields_Sizes_Thumbnail_Filename_Read>;
  update: Maybe<CmsMediaFields_Sizes_Thumbnail_Filename_Update>;
};

export type CmsMediaFields_Sizes_Thumbnail_Filename_Create = {
  __typename: 'CmsMediaFields_sizes_thumbnail_filename_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Filename_Delete = {
  __typename: 'CmsMediaFields_sizes_thumbnail_filename_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Filename_Read = {
  __typename: 'CmsMediaFields_sizes_thumbnail_filename_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Filename_Update = {
  __typename: 'CmsMediaFields_sizes_thumbnail_filename_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Filesize = {
  __typename: 'CmsMediaFields_sizes_thumbnail_filesize';
  create: Maybe<CmsMediaFields_Sizes_Thumbnail_Filesize_Create>;
  delete: Maybe<CmsMediaFields_Sizes_Thumbnail_Filesize_Delete>;
  read: Maybe<CmsMediaFields_Sizes_Thumbnail_Filesize_Read>;
  update: Maybe<CmsMediaFields_Sizes_Thumbnail_Filesize_Update>;
};

export type CmsMediaFields_Sizes_Thumbnail_Filesize_Create = {
  __typename: 'CmsMediaFields_sizes_thumbnail_filesize_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Filesize_Delete = {
  __typename: 'CmsMediaFields_sizes_thumbnail_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Filesize_Read = {
  __typename: 'CmsMediaFields_sizes_thumbnail_filesize_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Filesize_Update = {
  __typename: 'CmsMediaFields_sizes_thumbnail_filesize_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Height = {
  __typename: 'CmsMediaFields_sizes_thumbnail_height';
  create: Maybe<CmsMediaFields_Sizes_Thumbnail_Height_Create>;
  delete: Maybe<CmsMediaFields_Sizes_Thumbnail_Height_Delete>;
  read: Maybe<CmsMediaFields_Sizes_Thumbnail_Height_Read>;
  update: Maybe<CmsMediaFields_Sizes_Thumbnail_Height_Update>;
};

export type CmsMediaFields_Sizes_Thumbnail_Height_Create = {
  __typename: 'CmsMediaFields_sizes_thumbnail_height_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Height_Delete = {
  __typename: 'CmsMediaFields_sizes_thumbnail_height_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Height_Read = {
  __typename: 'CmsMediaFields_sizes_thumbnail_height_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Height_Update = {
  __typename: 'CmsMediaFields_sizes_thumbnail_height_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_MimeType = {
  __typename: 'CmsMediaFields_sizes_thumbnail_mimeType';
  create: Maybe<CmsMediaFields_Sizes_Thumbnail_MimeType_Create>;
  delete: Maybe<CmsMediaFields_Sizes_Thumbnail_MimeType_Delete>;
  read: Maybe<CmsMediaFields_Sizes_Thumbnail_MimeType_Read>;
  update: Maybe<CmsMediaFields_Sizes_Thumbnail_MimeType_Update>;
};

export type CmsMediaFields_Sizes_Thumbnail_MimeType_Create = {
  __typename: 'CmsMediaFields_sizes_thumbnail_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_MimeType_Delete = {
  __typename: 'CmsMediaFields_sizes_thumbnail_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_MimeType_Read = {
  __typename: 'CmsMediaFields_sizes_thumbnail_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_MimeType_Update = {
  __typename: 'CmsMediaFields_sizes_thumbnail_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Url = {
  __typename: 'CmsMediaFields_sizes_thumbnail_url';
  create: Maybe<CmsMediaFields_Sizes_Thumbnail_Url_Create>;
  delete: Maybe<CmsMediaFields_Sizes_Thumbnail_Url_Delete>;
  read: Maybe<CmsMediaFields_Sizes_Thumbnail_Url_Read>;
  update: Maybe<CmsMediaFields_Sizes_Thumbnail_Url_Update>;
};

export type CmsMediaFields_Sizes_Thumbnail_Url_Create = {
  __typename: 'CmsMediaFields_sizes_thumbnail_url_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Url_Delete = {
  __typename: 'CmsMediaFields_sizes_thumbnail_url_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Url_Read = {
  __typename: 'CmsMediaFields_sizes_thumbnail_url_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Url_Update = {
  __typename: 'CmsMediaFields_sizes_thumbnail_url_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Width = {
  __typename: 'CmsMediaFields_sizes_thumbnail_width';
  create: Maybe<CmsMediaFields_Sizes_Thumbnail_Width_Create>;
  delete: Maybe<CmsMediaFields_Sizes_Thumbnail_Width_Delete>;
  read: Maybe<CmsMediaFields_Sizes_Thumbnail_Width_Read>;
  update: Maybe<CmsMediaFields_Sizes_Thumbnail_Width_Update>;
};

export type CmsMediaFields_Sizes_Thumbnail_Width_Create = {
  __typename: 'CmsMediaFields_sizes_thumbnail_width_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Width_Delete = {
  __typename: 'CmsMediaFields_sizes_thumbnail_width_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Width_Read = {
  __typename: 'CmsMediaFields_sizes_thumbnail_width_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Sizes_Thumbnail_Width_Update = {
  __typename: 'CmsMediaFields_sizes_thumbnail_width_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_ThumbnailUrl = {
  __typename: 'CmsMediaFields_thumbnailURL';
  create: Maybe<CmsMediaFields_ThumbnailUrl_Create>;
  delete: Maybe<CmsMediaFields_ThumbnailUrl_Delete>;
  read: Maybe<CmsMediaFields_ThumbnailUrl_Read>;
  update: Maybe<CmsMediaFields_ThumbnailUrl_Update>;
};

export type CmsMediaFields_ThumbnailUrl_Create = {
  __typename: 'CmsMediaFields_thumbnailURL_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_ThumbnailUrl_Delete = {
  __typename: 'CmsMediaFields_thumbnailURL_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_ThumbnailUrl_Read = {
  __typename: 'CmsMediaFields_thumbnailURL_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_ThumbnailUrl_Update = {
  __typename: 'CmsMediaFields_thumbnailURL_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_UpdatedAt = {
  __typename: 'CmsMediaFields_updatedAt';
  create: Maybe<CmsMediaFields_UpdatedAt_Create>;
  delete: Maybe<CmsMediaFields_UpdatedAt_Delete>;
  read: Maybe<CmsMediaFields_UpdatedAt_Read>;
  update: Maybe<CmsMediaFields_UpdatedAt_Update>;
};

export type CmsMediaFields_UpdatedAt_Create = {
  __typename: 'CmsMediaFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_UpdatedAt_Delete = {
  __typename: 'CmsMediaFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_UpdatedAt_Read = {
  __typename: 'CmsMediaFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_UpdatedAt_Update = {
  __typename: 'CmsMediaFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Url = {
  __typename: 'CmsMediaFields_url';
  create: Maybe<CmsMediaFields_Url_Create>;
  delete: Maybe<CmsMediaFields_Url_Delete>;
  read: Maybe<CmsMediaFields_Url_Read>;
  update: Maybe<CmsMediaFields_Url_Update>;
};

export type CmsMediaFields_Url_Create = {
  __typename: 'CmsMediaFields_url_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Url_Delete = {
  __typename: 'CmsMediaFields_url_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Url_Read = {
  __typename: 'CmsMediaFields_url_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Url_Update = {
  __typename: 'CmsMediaFields_url_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Width = {
  __typename: 'CmsMediaFields_width';
  create: Maybe<CmsMediaFields_Width_Create>;
  delete: Maybe<CmsMediaFields_Width_Delete>;
  read: Maybe<CmsMediaFields_Width_Read>;
  update: Maybe<CmsMediaFields_Width_Update>;
};

export type CmsMediaFields_Width_Create = {
  __typename: 'CmsMediaFields_width_Create';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Width_Delete = {
  __typename: 'CmsMediaFields_width_Delete';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Width_Read = {
  __typename: 'CmsMediaFields_width_Read';
  permission: Scalars['Boolean'];
};

export type CmsMediaFields_Width_Update = {
  __typename: 'CmsMediaFields_width_Update';
  permission: Scalars['Boolean'];
};

export type CmsMediaReadAccess = {
  __typename: 'CmsMediaReadAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsMediaReadDocAccess = {
  __typename: 'CmsMediaReadDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsMediaUpdateAccess = {
  __typename: 'CmsMediaUpdateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsMediaUpdateDocAccess = {
  __typename: 'CmsMediaUpdateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsMedia_Sizes = {
  __typename: 'CmsMedia_Sizes';
  thumbnail: Maybe<CmsMedia_Sizes_Thumbnail>;
};

export type CmsMedia_Sizes_Thumbnail = {
  __typename: 'CmsMedia_Sizes_Thumbnail';
  filename: Maybe<Scalars['String']>;
  filesize: Maybe<Scalars['Float']>;
  height: Maybe<Scalars['Float']>;
  mimeType: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
  width: Maybe<Scalars['Float']>;
};

export type CmsMedia_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsMedia_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsMedia_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type CmsMedia_FocalX_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type CmsMedia_FocalY_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type CmsMedia_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type CmsMedia_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsMedia_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsMedia_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsMedia_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type CmsMedia_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type CmsMedia_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsMedia_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsMedia_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type CmsMedia_ThumbnailUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsMedia_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsMedia_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsMedia_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsMedia_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsMedia_Where_Or>>>;
  createdAt?: InputMaybe<CmsMedia_CreatedAt_Operator>;
  filename?: InputMaybe<CmsMedia_Filename_Operator>;
  filesize?: InputMaybe<CmsMedia_Filesize_Operator>;
  focalX?: InputMaybe<CmsMedia_FocalX_Operator>;
  focalY?: InputMaybe<CmsMedia_FocalY_Operator>;
  height?: InputMaybe<CmsMedia_Height_Operator>;
  id?: InputMaybe<CmsMedia_Id_Operator>;
  mimeType?: InputMaybe<CmsMedia_MimeType_Operator>;
  sizes__thumbnail__filename?: InputMaybe<CmsMedia_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<CmsMedia_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<CmsMedia_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<CmsMedia_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<CmsMedia_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<CmsMedia_Sizes__Thumbnail__Width_Operator>;
  thumbnailURL?: InputMaybe<CmsMedia_ThumbnailUrl_Operator>;
  updatedAt?: InputMaybe<CmsMedia_UpdatedAt_Operator>;
  url?: InputMaybe<CmsMedia_Url_Operator>;
  width?: InputMaybe<CmsMedia_Width_Operator>;
};

export type CmsMedia_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsMedia_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsMedia_Where_Or>>>;
  createdAt?: InputMaybe<CmsMedia_CreatedAt_Operator>;
  filename?: InputMaybe<CmsMedia_Filename_Operator>;
  filesize?: InputMaybe<CmsMedia_Filesize_Operator>;
  focalX?: InputMaybe<CmsMedia_FocalX_Operator>;
  focalY?: InputMaybe<CmsMedia_FocalY_Operator>;
  height?: InputMaybe<CmsMedia_Height_Operator>;
  id?: InputMaybe<CmsMedia_Id_Operator>;
  mimeType?: InputMaybe<CmsMedia_MimeType_Operator>;
  sizes__thumbnail__filename?: InputMaybe<CmsMedia_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<CmsMedia_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<CmsMedia_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<CmsMedia_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<CmsMedia_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<CmsMedia_Sizes__Thumbnail__Width_Operator>;
  thumbnailURL?: InputMaybe<CmsMedia_ThumbnailUrl_Operator>;
  updatedAt?: InputMaybe<CmsMedia_UpdatedAt_Operator>;
  url?: InputMaybe<CmsMedia_Url_Operator>;
  width?: InputMaybe<CmsMedia_Width_Operator>;
};

export type CmsMedia_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsMedia_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsMedia_Where_Or>>>;
  createdAt?: InputMaybe<CmsMedia_CreatedAt_Operator>;
  filename?: InputMaybe<CmsMedia_Filename_Operator>;
  filesize?: InputMaybe<CmsMedia_Filesize_Operator>;
  focalX?: InputMaybe<CmsMedia_FocalX_Operator>;
  focalY?: InputMaybe<CmsMedia_FocalY_Operator>;
  height?: InputMaybe<CmsMedia_Height_Operator>;
  id?: InputMaybe<CmsMedia_Id_Operator>;
  mimeType?: InputMaybe<CmsMedia_MimeType_Operator>;
  sizes__thumbnail__filename?: InputMaybe<CmsMedia_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<CmsMedia_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<CmsMedia_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<CmsMedia_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<CmsMedia_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<CmsMedia_Sizes__Thumbnail__Width_Operator>;
  thumbnailURL?: InputMaybe<CmsMedia_ThumbnailUrl_Operator>;
  updatedAt?: InputMaybe<CmsMedia_UpdatedAt_Operator>;
  url?: InputMaybe<CmsMedia_Url_Operator>;
  width?: InputMaybe<CmsMedia_Width_Operator>;
};

export type CmsMedia_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type CmsMedias = {
  __typename: 'CmsMedias';
  docs: Array<CmsMedia>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  nextPage: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  pagingCounter: Scalars['Int'];
  prevPage: Maybe<Scalars['Int']>;
  totalDocs: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type CmsUser = {
  __typename: 'CmsUser';
  createdAt: Maybe<Scalars['DateTime']>;
  email: Scalars['EmailAddress'];
  hash: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lockUntil: Maybe<Scalars['DateTime']>;
  loginAttempts: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  resetPasswordExpiration: Maybe<Scalars['DateTime']>;
  resetPasswordToken: Maybe<Scalars['String']>;
  salt: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type CmsUser_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsUser_Email_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']>>>;
  contains?: InputMaybe<Scalars['EmailAddress']>;
  equals?: InputMaybe<Scalars['EmailAddress']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']>>>;
  like?: InputMaybe<Scalars['EmailAddress']>;
  not_equals?: InputMaybe<Scalars['EmailAddress']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']>>>;
};

export type CmsUser_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsUser_Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CmsUser_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type CmsUser_Where = {
  AND?: InputMaybe<Array<InputMaybe<CmsUser_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsUser_Where_Or>>>;
  createdAt?: InputMaybe<CmsUser_CreatedAt_Operator>;
  email?: InputMaybe<CmsUser_Email_Operator>;
  id?: InputMaybe<CmsUser_Id_Operator>;
  name?: InputMaybe<CmsUser_Name_Operator>;
  updatedAt?: InputMaybe<CmsUser_UpdatedAt_Operator>;
};

export type CmsUser_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<CmsUser_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsUser_Where_Or>>>;
  createdAt?: InputMaybe<CmsUser_CreatedAt_Operator>;
  email?: InputMaybe<CmsUser_Email_Operator>;
  id?: InputMaybe<CmsUser_Id_Operator>;
  name?: InputMaybe<CmsUser_Name_Operator>;
  updatedAt?: InputMaybe<CmsUser_UpdatedAt_Operator>;
};

export type CmsUser_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<CmsUser_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<CmsUser_Where_Or>>>;
  createdAt?: InputMaybe<CmsUser_CreatedAt_Operator>;
  email?: InputMaybe<CmsUser_Email_Operator>;
  id?: InputMaybe<CmsUser_Id_Operator>;
  name?: InputMaybe<CmsUser_Name_Operator>;
  updatedAt?: InputMaybe<CmsUser_UpdatedAt_Operator>;
};

export type CmsUsers = {
  __typename: 'CmsUsers';
  docs: Array<CmsUser>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  nextPage: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  pagingCounter: Scalars['Int'];
  prevPage: Maybe<Scalars['Int']>;
  totalDocs: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type CmsUsersAccess = {
  __typename: 'CmsUsersAccess';
  create: Maybe<CmsUsersCreateAccess>;
  delete: Maybe<CmsUsersDeleteAccess>;
  fields: Maybe<CmsUsersFields>;
  read: Maybe<CmsUsersReadAccess>;
  unlock: Maybe<CmsUsersUnlockAccess>;
  update: Maybe<CmsUsersUpdateAccess>;
};

export type CmsUsersCreateAccess = {
  __typename: 'CmsUsersCreateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsUsersCreateDocAccess = {
  __typename: 'CmsUsersCreateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsUsersDeleteAccess = {
  __typename: 'CmsUsersDeleteAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsUsersDeleteDocAccess = {
  __typename: 'CmsUsersDeleteDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsUsersDocAccess = {
  __typename: 'CmsUsersDocAccess';
  create: Maybe<CmsUsersCreateDocAccess>;
  delete: Maybe<CmsUsersDeleteDocAccess>;
  fields: Maybe<CmsUsersDocAccessFields>;
  read: Maybe<CmsUsersReadDocAccess>;
  unlock: Maybe<CmsUsersUnlockDocAccess>;
  update: Maybe<CmsUsersUpdateDocAccess>;
};

export type CmsUsersDocAccessFields = {
  __typename: 'CmsUsersDocAccessFields';
  createdAt: Maybe<CmsUsersDocAccessFields_CreatedAt>;
  email: Maybe<CmsUsersDocAccessFields_Email>;
  name: Maybe<CmsUsersDocAccessFields_Name>;
  updatedAt: Maybe<CmsUsersDocAccessFields_UpdatedAt>;
};

export type CmsUsersDocAccessFields_CreatedAt = {
  __typename: 'CmsUsersDocAccessFields_createdAt';
  create: Maybe<CmsUsersDocAccessFields_CreatedAt_Create>;
  delete: Maybe<CmsUsersDocAccessFields_CreatedAt_Delete>;
  read: Maybe<CmsUsersDocAccessFields_CreatedAt_Read>;
  update: Maybe<CmsUsersDocAccessFields_CreatedAt_Update>;
};

export type CmsUsersDocAccessFields_CreatedAt_Create = {
  __typename: 'CmsUsersDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_CreatedAt_Delete = {
  __typename: 'CmsUsersDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_CreatedAt_Read = {
  __typename: 'CmsUsersDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_CreatedAt_Update = {
  __typename: 'CmsUsersDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_Email = {
  __typename: 'CmsUsersDocAccessFields_email';
  create: Maybe<CmsUsersDocAccessFields_Email_Create>;
  delete: Maybe<CmsUsersDocAccessFields_Email_Delete>;
  read: Maybe<CmsUsersDocAccessFields_Email_Read>;
  update: Maybe<CmsUsersDocAccessFields_Email_Update>;
};

export type CmsUsersDocAccessFields_Email_Create = {
  __typename: 'CmsUsersDocAccessFields_email_Create';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_Email_Delete = {
  __typename: 'CmsUsersDocAccessFields_email_Delete';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_Email_Read = {
  __typename: 'CmsUsersDocAccessFields_email_Read';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_Email_Update = {
  __typename: 'CmsUsersDocAccessFields_email_Update';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_Name = {
  __typename: 'CmsUsersDocAccessFields_name';
  create: Maybe<CmsUsersDocAccessFields_Name_Create>;
  delete: Maybe<CmsUsersDocAccessFields_Name_Delete>;
  read: Maybe<CmsUsersDocAccessFields_Name_Read>;
  update: Maybe<CmsUsersDocAccessFields_Name_Update>;
};

export type CmsUsersDocAccessFields_Name_Create = {
  __typename: 'CmsUsersDocAccessFields_name_Create';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_Name_Delete = {
  __typename: 'CmsUsersDocAccessFields_name_Delete';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_Name_Read = {
  __typename: 'CmsUsersDocAccessFields_name_Read';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_Name_Update = {
  __typename: 'CmsUsersDocAccessFields_name_Update';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_UpdatedAt = {
  __typename: 'CmsUsersDocAccessFields_updatedAt';
  create: Maybe<CmsUsersDocAccessFields_UpdatedAt_Create>;
  delete: Maybe<CmsUsersDocAccessFields_UpdatedAt_Delete>;
  read: Maybe<CmsUsersDocAccessFields_UpdatedAt_Read>;
  update: Maybe<CmsUsersDocAccessFields_UpdatedAt_Update>;
};

export type CmsUsersDocAccessFields_UpdatedAt_Create = {
  __typename: 'CmsUsersDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_UpdatedAt_Delete = {
  __typename: 'CmsUsersDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_UpdatedAt_Read = {
  __typename: 'CmsUsersDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsUsersDocAccessFields_UpdatedAt_Update = {
  __typename: 'CmsUsersDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields = {
  __typename: 'CmsUsersFields';
  createdAt: Maybe<CmsUsersFields_CreatedAt>;
  email: Maybe<CmsUsersFields_Email>;
  name: Maybe<CmsUsersFields_Name>;
  updatedAt: Maybe<CmsUsersFields_UpdatedAt>;
};

export type CmsUsersFields_CreatedAt = {
  __typename: 'CmsUsersFields_createdAt';
  create: Maybe<CmsUsersFields_CreatedAt_Create>;
  delete: Maybe<CmsUsersFields_CreatedAt_Delete>;
  read: Maybe<CmsUsersFields_CreatedAt_Read>;
  update: Maybe<CmsUsersFields_CreatedAt_Update>;
};

export type CmsUsersFields_CreatedAt_Create = {
  __typename: 'CmsUsersFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_CreatedAt_Delete = {
  __typename: 'CmsUsersFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_CreatedAt_Read = {
  __typename: 'CmsUsersFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_CreatedAt_Update = {
  __typename: 'CmsUsersFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_Email = {
  __typename: 'CmsUsersFields_email';
  create: Maybe<CmsUsersFields_Email_Create>;
  delete: Maybe<CmsUsersFields_Email_Delete>;
  read: Maybe<CmsUsersFields_Email_Read>;
  update: Maybe<CmsUsersFields_Email_Update>;
};

export type CmsUsersFields_Email_Create = {
  __typename: 'CmsUsersFields_email_Create';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_Email_Delete = {
  __typename: 'CmsUsersFields_email_Delete';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_Email_Read = {
  __typename: 'CmsUsersFields_email_Read';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_Email_Update = {
  __typename: 'CmsUsersFields_email_Update';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_Name = {
  __typename: 'CmsUsersFields_name';
  create: Maybe<CmsUsersFields_Name_Create>;
  delete: Maybe<CmsUsersFields_Name_Delete>;
  read: Maybe<CmsUsersFields_Name_Read>;
  update: Maybe<CmsUsersFields_Name_Update>;
};

export type CmsUsersFields_Name_Create = {
  __typename: 'CmsUsersFields_name_Create';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_Name_Delete = {
  __typename: 'CmsUsersFields_name_Delete';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_Name_Read = {
  __typename: 'CmsUsersFields_name_Read';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_Name_Update = {
  __typename: 'CmsUsersFields_name_Update';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_UpdatedAt = {
  __typename: 'CmsUsersFields_updatedAt';
  create: Maybe<CmsUsersFields_UpdatedAt_Create>;
  delete: Maybe<CmsUsersFields_UpdatedAt_Delete>;
  read: Maybe<CmsUsersFields_UpdatedAt_Read>;
  update: Maybe<CmsUsersFields_UpdatedAt_Update>;
};

export type CmsUsersFields_UpdatedAt_Create = {
  __typename: 'CmsUsersFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_UpdatedAt_Delete = {
  __typename: 'CmsUsersFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_UpdatedAt_Read = {
  __typename: 'CmsUsersFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CmsUsersFields_UpdatedAt_Update = {
  __typename: 'CmsUsersFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CmsUsersJwt = {
  __typename: 'CmsUsersJWT';
  collection: Scalars['String'];
  email: Scalars['EmailAddress'];
};

export type CmsUsersLoginResult = {
  __typename: 'CmsUsersLoginResult';
  exp: Maybe<Scalars['Int']>;
  token: Maybe<Scalars['String']>;
  user: Maybe<CmsUser>;
};

export type CmsUsersMe = {
  __typename: 'CmsUsersMe';
  collection: Maybe<Scalars['String']>;
  exp: Maybe<Scalars['Int']>;
  strategy: Maybe<Scalars['String']>;
  token: Maybe<Scalars['String']>;
  user: Maybe<CmsUser>;
};

export type CmsUsersReadAccess = {
  __typename: 'CmsUsersReadAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsUsersReadDocAccess = {
  __typename: 'CmsUsersReadDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsUsersRefreshedCmsUser = {
  __typename: 'CmsUsersRefreshedCmsUser';
  exp: Maybe<Scalars['Int']>;
  refreshedToken: Maybe<Scalars['String']>;
  strategy: Maybe<Scalars['String']>;
  user: Maybe<CmsUsersJwt>;
};

export type CmsUsersResetPassword = {
  __typename: 'CmsUsersResetPassword';
  token: Maybe<Scalars['String']>;
  user: Maybe<CmsUser>;
};

export type CmsUsersUnlockAccess = {
  __typename: 'CmsUsersUnlockAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsUsersUnlockDocAccess = {
  __typename: 'CmsUsersUnlockDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsUsersUpdateAccess = {
  __typename: 'CmsUsersUpdateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type CmsUsersUpdateDocAccess = {
  __typename: 'CmsUsersUpdateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

/** A generic competition */
export type Competition = {
  competitionState: EventElementState;
  competitionTiming: Maybe<CompetitionTiming>;
  competitionType: CompetitionType;
  created: Scalars['Date'];
  event: Event;
  eventId: Scalars['String'];
  eventStageId: Scalars['String'];
  game: Game;
  gameId: Scalars['String'];
  id: Scalars['String'];
  participantType: ParticipantType;
  participants: Array<CompetitionParticipantReference>;
};

export enum CompetitionFormat {
  Basic = 'Basic',
  BattleRoyale = 'BattleRoyale',
  KingOfTheHill = 'KingOfTheHill',
  Ladder = 'Ladder',
  PrunedDoubleElimination = 'PrunedDoubleElimination',
  PrunedSingleElimination = 'PrunedSingleElimination',
  SingleElimination = 'SingleElimination',
  TopScore = 'TopScore'
}

/** Matches matches within a competition */
export type CompetitionMatch = {
  assets: Array<Tag>;
  gameSpecificDetails: Maybe<GameSpecificCompetitionDetails>;
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  startTime: Maybe<Scalars['Date']>;
};

export type CompetitionParticipantReference = ParticipantReference & {
  __typename: 'CompetitionParticipantReference';
  accountId: Scalars['String'];
  participant: Participant;
  participantId: Scalars['String'];
  result: Maybe<Result>;
};

export type CompetitionParticipantReferenceWithRoster = ParticipantReference & {
  __typename: 'CompetitionParticipantReferenceWithRoster';
  accountId: Scalars['String'];
  participant: Participant;
  participantId: Scalars['String'];
  result: Maybe<Result>;
  roster: Array<Scalars['String']>;
  seededFromCompetitionMatchId: Maybe<Scalars['String']>;
};

export type CompetitionSpecificDetails = {
  id: Scalars['String'];
};

export type CompetitionTiming = {
  __typename: 'CompetitionTiming';
  latestPreparationStartTime: Scalars['Date'];
  startTime: Scalars['Date'];
};

/** The type of competition */
export enum CompetitionType {
  Challenge = 'CHALLENGE',
  MatchUp = 'MATCH_UP',
  Tournament = 'TOURNAMENT'
}

export type Contact = {
  __typename: 'Contact';
  contactId: Scalars['ID'];
  contactNumber: Maybe<Scalars['String']>;
  countryCode: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
};

export type ContactInput = {
  contactId?: InputMaybe<Scalars['ID']>;
  contactNumber?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
};

/** ContentType name */
export enum ContentType {
  /** NORMAL */
  Normal = 'NORMAL',
  /** PREMIUM */
  Premium = 'PREMIUM'
}

export type ContextCompetitionUpdateRequest = {
  challenge?: InputMaybe<SingleChallengeUpdateRequest>;
  competitionId: Scalars['String'];
  matchUp?: InputMaybe<SingleMatchUpUpdateRequest>;
  tournament?: InputMaybe<SingleTournamentUpdateRequest>;
};

export type ContextEventStageUpdateRequest = {
  eventStageNumber: Scalars['Int'];
  eventStageUpdateRequest: EventStageUpdateRequest;
};

export enum ConversionRateOverriddenLevel {
  GlobalLevel = 'GLOBAL_LEVEL',
  ItemLevel = 'ITEM_LEVEL',
  PartnerLevel = 'PARTNER_LEVEL'
}

export type Cost = {
  amount: Scalars['Float'];
  costType: CostType;
  created: Scalars['DateTime'];
  frequency: PaymentFrequency;
  id: Scalars['String'];
};

export enum CostType {
  RealWorldCurrencyCostType = 'RealWorldCurrencyCostType'
}

export type CurrencyConversion = {
  __typename: 'CurrencyConversion';
  conversionRate: Maybe<Scalars['Float']>;
  conversionRateOverriddenLevel: Maybe<ConversionRateOverriddenLevel>;
  sourceCurrency: Maybe<Scalars['String']>;
  targetCurrency: Maybe<Scalars['String']>;
};

export type CurrencyItemCost = {
  cost: Scalars['Float'];
  created: Scalars['Date'];
  /** Swarmio Currency Item */
  currencyItem: SwarmioCurrencyItem;
  currencyItemCostType: CurrencyItemCostType;
  id: Scalars['String'];
  realWorldCurrencyType: RealWorldCurrency;
  swarmioCurrencyItemId: Scalars['String'];
  version: Scalars['Int'];
};

export type CurrencyItemCostArchive = {
  cost: Scalars['Float'];
  created: Scalars['Date'];
  /** Swarmio Currency Item */
  currencyItem: SwarmioCurrencyItem;
  currencyItemCostType: CurrencyItemCostType;
  id: Scalars['String'];
  realWorldCurrencyType: RealWorldCurrency;
  swarmioCurrencyItemId: Scalars['String'];
  version: Scalars['Int'];
};

/** The type of item cost */
export enum CurrencyItemCostType {
  /** Swarmio does not process the payment */
  ExternalCurrencyItemCost = 'ExternalCurrencyItemCost',
  /** Swarmio processes the payment */
  SwarmioCurrencyItemCost = 'SwarmioCurrencyItemCost'
}

export type CurrencyPrice = {
  __typename: 'CurrencyPrice';
  currency: Maybe<Scalars['String']>;
  markUpPrice: Maybe<Scalars['Float']>;
  markUpPriceForCurrency: Maybe<Scalars['Float']>;
};

export type CustomPrize = FixedPrize & Prize & {
  __typename: 'CustomPrize';
  id: Scalars['String'];
  localizedDescriptions: Array<LocalizedString>;
  prizeType: PrizeType;
};

export type CustomPrizeCreationRequest = {
  localizedDescriptions: Array<LocalizedStringInput>;
};

export type CustomPrizePayoutReceipt = PrizePayoutReceipt & {
  __typename: 'CustomPrizePayoutReceipt';
  accountId: Scalars['String'];
  created: Scalars['Date'];
  description: Scalars['String'];
  id: Scalars['String'];
  notes: Maybe<Scalars['String']>;
  prizePayoutReceiptType: BasicPrizePayoutReceiptType;
  prizeTierId: Scalars['String'];
  successful: Scalars['Boolean'];
};

export type DateAttribute = DateAttributeWithPossibleError & {
  __typename: 'DateAttribute';
  isError: Scalars['Boolean'];
  value: Scalars['Date'];
};

/** A DateAttribute or an error */
export type DateAttributeWithPossibleError = {
  isError: Scalars['Boolean'];
};

export type Deal = {
  __typename: 'Deal';
  createdBy: Maybe<Scalars['Int']>;
  createdDate: Maybe<Scalars['String']>;
  deactivatedDateTime: Maybe<Scalars['String']>;
  dealActivePartnerItems: Maybe<Array<Maybe<DealActivePartnerItem>>>;
  dealName: Maybe<Scalars['String']>;
  dealPaymentChannels: Maybe<Array<Maybe<DealPaymentChannel>>>;
  dealPercentage: Maybe<Scalars['Float']>;
  endDateTime: Maybe<Scalars['String']>;
  finalPriceRoundOffBoundary: Maybe<RoundOffBoundary>;
  finalPriceRoundOffDecimalPlace: Maybe<RoundOffPlace>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  selectedPartners: Maybe<Scalars['Object']>;
  startDateTime: Maybe<Scalars['String']>;
};

export type DealActivePartnerItem = {
  __typename: 'DealActivePartnerItem';
  catalog: Maybe<Catalog>;
  createdDateTime: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  item: Maybe<Item>;
};

export type DealActivePartnerItemDto = {
  catalogId?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
};

export type DealCategory = {
  __typename: 'DealCategory';
  categoryId: Maybe<Scalars['String']>;
  categoryName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  productGroups: Maybe<Array<Maybe<DealProductGroup>>>;
};

export type DealDateInputDto = {
  endDateTime?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['String']>;
};

export type DealDetailsDto = {
  __typename: 'DealDetailsDto';
  dealName: Maybe<Scalars['String']>;
  dealPercentage: Maybe<Scalars['Float']>;
  dealStatus: Maybe<DealStatus>;
  endDateTime: Maybe<Scalars['String']>;
  finalPriceRoundOffBoundary: Maybe<RoundOffBoundary>;
  finalPriceRoundOffDecimalPlace: Maybe<RoundOffPlace>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  startDateTime: Maybe<Scalars['String']>;
};

export type DealDto = {
  __typename: 'DealDto';
  dealActivePartnerItems: Maybe<Array<Maybe<DealActivePartnerItem>>>;
  dealName: Maybe<Scalars['String']>;
  dealPaymentChannel: Maybe<DealPaymentChannel>;
  dealPercentage: Maybe<Scalars['Float']>;
  endDateTime: Maybe<Scalars['String']>;
  finalPriceRoundOffBoundary: Maybe<RoundOffBoundary>;
  finalPriceRoundOffDecimalPlace: Maybe<RoundOffPlace>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  productCount: Maybe<Scalars['Int']>;
  selectedPartners: Maybe<Scalars['Object']>;
  startDateTime: Maybe<Scalars['String']>;
  status: Maybe<DealStatus>;
};

export type DealInput = {
  dealActivePartnerItems?: InputMaybe<Array<InputMaybe<DealActivePartnerItemDto>>>;
  dealName?: InputMaybe<Scalars['String']>;
  dealPercentage?: InputMaybe<Scalars['Float']>;
  endDateTime?: InputMaybe<Scalars['String']>;
  finalPriceRoundOffBoundary?: InputMaybe<RoundOffBoundary>;
  finalPriceRoundOffDecimalPlace?: InputMaybe<RoundOffPlace>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  paymentChannelIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  selectedPartnerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startDateTime?: InputMaybe<Scalars['String']>;
};

export type DealItem = {
  __typename: 'DealItem';
  displayName: Maybe<Scalars['String']>;
  gamePublisher: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isAlreadyInDeal: Maybe<Scalars['Boolean']>;
  itemId: Maybe<Scalars['String']>;
  itemName: Maybe<Scalars['String']>;
  sourceCurrency: Maybe<Scalars['String']>;
  unitPrice: Maybe<Scalars['Float']>;
  variantName: Maybe<Scalars['String']>;
};

export type DealLogDetailDto = {
  __typename: 'DealLogDetailDto';
  currentPage: Maybe<Scalars['Int']>;
  dealLogs: Maybe<Array<Maybe<DealLogDto>>>;
  totalFilteredDealLogs: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
};

export type DealLogDto = {
  __typename: 'DealLogDto';
  createdDate: Maybe<Scalars['String']>;
  dealId: Maybe<Scalars['ID']>;
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  initiatedBy: Maybe<Scalars['String']>;
  itemId: Maybe<Scalars['ID']>;
  itemName: Maybe<Scalars['String']>;
};

export type DealPartner = {
  __typename: 'DealPartner';
  catalogId: Maybe<Scalars['Int']>;
  catalogName: Maybe<Scalars['String']>;
  categories: Maybe<Array<Maybe<DealCategory>>>;
  id: Maybe<Scalars['ID']>;
  partnerId: Maybe<Scalars['String']>;
  partnerName: Maybe<Scalars['String']>;
};

export type DealPartnerDto = {
  __typename: 'DealPartnerDto';
  country: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  localCurrency: Maybe<Scalars['String']>;
  partnerId: Maybe<Scalars['ID']>;
  partnerName: Maybe<Scalars['String']>;
  partnerUrl: Maybe<Scalars['String']>;
};

export type DealPartnerItemDto = {
  __typename: 'DealPartnerItemDto';
  catalogId: Maybe<Scalars['ID']>;
  catalogName: Maybe<Scalars['String']>;
  itemId: Maybe<Scalars['ID']>;
  itemName: Maybe<Scalars['String']>;
};

export type DealPaymentChannel = {
  __typename: 'DealPaymentChannel';
  id: Maybe<Scalars['ID']>;
  paymentChannel: Maybe<PaymentChannel>;
};

export type DealPaymentChannelsDto = {
  __typename: 'DealPaymentChannelsDto';
  paymentChannels: Maybe<Array<Maybe<PaymentChannel>>>;
};

export type DealProductGroup = {
  __typename: 'DealProductGroup';
  id: Maybe<Scalars['ID']>;
  items: Maybe<Array<Maybe<DealItem>>>;
  productGroupId: Maybe<Scalars['String']>;
  productGroupName: Maybe<Scalars['String']>;
};

export enum DealStatus {
  Ended = 'ENDED',
  Ongoing = 'ONGOING',
  Scheduled = 'SCHEDULED'
}

export type DefaultPersonCreationRequest = {
  avatarURL?: InputMaybe<Scalars['String']>;
  bannerURL?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  isVIP?: InputMaybe<Scalars['Boolean']>;
  msisdn?: InputMaybe<Scalars['String']>;
  otherFields?: InputMaybe<Array<AccountTagInput>>;
  password: Scalars['String'];
  publicURL?: InputMaybe<Scalars['String']>;
  realName?: InputMaybe<Scalars['String']>;
  socialLinks?: InputMaybe<Array<SocialLinkInput>>;
};

export type DimensionMultiplier = {
  __typename: 'DimensionMultiplier';
  dimensionId: Scalars['String'];
  id: Scalars['String'];
  multiplier: Scalars['Float'];
};

export type DimensionMultiplierRequest = {
  dimensionId: Scalars['String'];
  multiplier: Scalars['Float'];
};

/** Channel type used to distribute the voucher */
export enum DistributionChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type DistributionInfo = {
  __typename: 'DistributionInfo';
  channel: DistributionChannel;
  date: Maybe<Scalars['Date']>;
  distributedTo: Maybe<Recipient>;
};

export type DistributionRequest = {
  code: Scalars['String'];
  distributionContact: Scalars['String'];
  recipientId: Scalars['String'];
};

export type DraftProduct = {
  __typename: 'DraftProduct';
  additionalData: Maybe<Scalars['String']>;
  availableStock: Maybe<Scalars['Int']>;
  costPrice: Maybe<Scalars['String']>;
  currency: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  productCode: Maybe<Scalars['String']>;
  productName: Maybe<Scalars['String']>;
  productType: Maybe<ProductType>;
  publisherName: Maybe<Scalars['String']>;
  sku: Maybe<Scalars['String']>;
  totalStock: Maybe<Scalars['Int']>;
  voucherCode: Maybe<Scalars['String']>;
  voucherExpiry: Maybe<Scalars['String']>;
  voucherPin: Maybe<Scalars['String']>;
  voucherSerial: Maybe<Scalars['String']>;
};

export type EmbeddedGame = {
  __typename: 'EmbeddedGame';
  availability: EmbeddedGameAvailabilityState;
  desc: Maybe<Scalars['String']>;
  embeddedGameURL: Maybe<Scalars['String']>;
  id: Scalars['String'];
  thumbnailURL: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum EmbeddedGameAvailabilityState {
  Free = 'Free',
  Premium = 'Premium'
}

export type EmbeddedGamesCreationRequest = {
  availability: EmbeddedGameAvailabilityState;
  desc?: InputMaybe<Scalars['String']>;
  embeddedGameURL?: InputMaybe<Scalars['String']>;
  thumbnailURL?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type EmbeddedGamesUpdateRequest = {
  availability?: InputMaybe<EmbeddedGameAvailabilityState>;
  desc?: InputMaybe<Scalars['String']>;
  embeddedGameURL?: InputMaybe<Scalars['String']>;
  thumbnailURL?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EnumMissingParticipantRequirement = MissingParticipantRequirement & {
  __typename: 'EnumMissingParticipantRequirement';
  entryName: Scalars['String'];
};

export type Event = {
  __typename: 'Event';
  category: EventCategory;
  created: Scalars['Date'];
  defaultLocale: Locale;
  disqualifiedParticipants: Array<Participant>;
  eventCurrencyExchanges: EventCurrencyExchanges;
  eventLimitations: Maybe<EventLimitations>;
  eventStages: Array<EventStage>;
  eventState: EventElementState;
  eventTeam: Array<EventTeamMember>;
  eventTiming: EventTiming;
  featured: Scalars['Boolean'];
  game: Game;
  gameAccountTypeIds: Array<Scalars['String']>;
  gameAccountTypes: Array<GameAccountType>;
  gameId: Scalars['String'];
  id: Scalars['String'];
  isSimulated: Scalars['Boolean'];
  localizedDescriptions: Array<LocalizedOptionalString>;
  localizedMediaContentDetails: Array<LocalizedMediaContentDetails>;
  localizedNames: Array<LocalizedString>;
  ownerId: Scalars['String'];
  participantCount: Scalars['Int'];
  participantType: ParticipantType;
  participants: Array<Participant>;
  region: Maybe<Region>;
  tags: Array<Tag>;
  unlisted: Scalars['Boolean'];
};


export type EventTagsArgs = {
  eventTagsFilter?: InputMaybe<EventTagsFilterQuery>;
};

export enum EventCategory {
  Challenge = 'Challenge',
  CommunityEvents = 'CommunityEvents',
  Tournament = 'Tournament'
}

export type EventCreationRequest = {
  category: EventCategory;
  defaultLocale: Locale;
  eventCurrencyExchanges?: InputMaybe<EventCurrencyExchangeCreationRequest>;
  eventLimitations?: InputMaybe<EventLimitationsCreationRequest>;
  eventStages: Array<EventStageCreationRequest>;
  eventTiming: EventTimingCreationRequest;
  featured: Scalars['Boolean'];
  gameAccountTypeIds: Array<Scalars['String']>;
  gameId: Scalars['String'];
  isSimulated: Scalars['Boolean'];
  localizedDescription?: InputMaybe<Array<LocalizedOptionalStringInput>>;
  localizedMediaContentDetails?: InputMaybe<Array<LocalizedMediaContentDetailsCreationRequest>>;
  localizedNames: Array<LocalizedStringInput>;
  ownerAccountId: Scalars['String'];
  participantType: ParticipantType;
  region?: InputMaybe<Region>;
  tags?: InputMaybe<Array<TagInput>>;
  unlisted: Scalars['Boolean'];
};

export type EventCurrencyExchangeCreationRequest = {
  prizeId?: InputMaybe<Scalars['String']>;
  prizeList?: InputMaybe<PrizeListCreationRequest>;
};

export type EventCurrencyExchangeUpdateRequest = {
  prizeId?: InputMaybe<Scalars['String']>;
  prizeList?: InputMaybe<PrizeListCreationRequest>;
};

export type EventCurrencyExchanges = {
  __typename: 'EventCurrencyExchanges';
  prizeList: Maybe<PrizeList>;
};

/** State the event (or competition, or...) is in  */
export enum EventElementState {
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  CompleteAndPaid = 'COMPLETE_AND_PAID',
  CompletingRegistration = 'COMPLETING_REGISTRATION',
  Created = 'CREATED',
  FinalScoring = 'FINAL_SCORING',
  InProgress = 'IN_PROGRESS',
  PendingFinalResults = 'PENDING_FINAL_RESULTS',
  PendingStart = 'PENDING_START',
  ReadyToJoin = 'READY_TO_JOIN',
  RegistrationClosed = 'REGISTRATION_CLOSED'
}

/** A set of entry rules */
export type EventEntryRules = {
  id: Scalars['String'];
};

export type EventLimitations = {
  __typename: 'EventLimitations';
  checkInMode: CheckInMode;
  eventEntryRules: Maybe<EventEntryRules>;
  localizedJoinInstructions: Array<LocalizedOptionalString>;
  localizedWrittenRules: Array<LocalizedOptionalString>;
  maximumParticipants: Maybe<Scalars['Int']>;
  minimumParticipants: Maybe<Scalars['Int']>;
  requiredAdditionalInformation: Maybe<Array<Scalars['String']>>;
};

export type EventLimitationsCreationRequest = {
  checkInMode: CheckInMode;
  localizedJoinInstructions?: InputMaybe<Array<LocalizedOptionalStringInput>>;
  localizedWrittenRules?: InputMaybe<Array<LocalizedOptionalStringInput>>;
  maximumParticipants?: InputMaybe<Scalars['Int']>;
  minimumParticipants?: InputMaybe<Scalars['Int']>;
  requiredAdditionalInformation?: InputMaybe<Array<Scalars['String']>>;
  teamEventEntryRules?: InputMaybe<TeamEventEntryRulesCreationRequest>;
};

export type EventLimitationsUpdateRequest = {
  checkInMode?: InputMaybe<CheckInMode>;
  localizedJoinInstructions?: InputMaybe<Array<LocalizedOptionalStringInput>>;
  localizedWrittenRules?: InputMaybe<Array<LocalizedOptionalStringInput>>;
  maximumParticipants?: InputMaybe<Scalars['Int']>;
  minimumParticipants?: InputMaybe<Scalars['Int']>;
  requiredAdditionalInformation?: InputMaybe<Array<Scalars['String']>>;
  teamEventEntryRules?: InputMaybe<TeamEventEntryRulesUpdateRequest>;
};

export type EventRequirement = {
  __typename: 'EventRequirement';
  playersMissingCheckIn: Scalars['Int'];
  playersMissingRegistration: Scalars['Int'];
  teamMissingPlayers: Scalars['Int'];
};

export enum EventSortField {
  Default = 'Default',
  StartTime = 'StartTime'
}

export type EventStage = {
  __typename: 'EventStage';
  advanceStrategy: Maybe<AdvanceStrategy>;
  breakStrategy: Maybe<BreakStrategy>;
  competitions: Array<Competition>;
  created: Scalars['Date'];
  eventId: Scalars['String'];
  eventStageState: EventElementState;
  game: Game;
  gameId: Scalars['String'];
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  isSimulated: Scalars['Boolean'];
  mustEndBy: Maybe<Scalars['Date']>;
  participantType: ParticipantType;
  participants: Array<EventStageParticipantReference>;
  stageNumber: Scalars['Int'];
  startTime: Maybe<Scalars['Date']>;
  startXMinutesAfterPreviousStage: Maybe<Scalars['Int']>;
};

export type EventStageCreationRequest = {
  atLeastPlacementAdvance?: InputMaybe<Scalars['Int']>;
  challenge?: InputMaybe<ChallengeCreationRequest>;
  exactPlacementAdvance?: InputMaybe<Scalars['Int']>;
  fixedNumberParticipantsBreak?: InputMaybe<Scalars['Int']>;
  matchUp?: InputMaybe<MatchUpCreationRequest>;
  maximumParticipantsBreak?: InputMaybe<Scalars['Int']>;
  stageNumber: Scalars['Int'];
  startTime?: InputMaybe<Scalars['Date']>;
  startXMinutesAfterPreviousStage?: InputMaybe<Scalars['Int']>;
  tournament?: InputMaybe<TournamentCreationRequest>;
};

export type EventStageParticipantReference = ParticipantReference & {
  __typename: 'EventStageParticipantReference';
  accountId: Scalars['String'];
  participant: Participant;
  participantId: Scalars['String'];
  result: Maybe<Result>;
};

export type EventStageUpdateRequest = {
  allEventStageCompetitionsUpdateRequest?: InputMaybe<AllEventStageCompetitionsUpdateRequest>;
  atLeastPlacementAdvance?: InputMaybe<Scalars['Int']>;
  eventStageCompetitionUpdateRequests?: InputMaybe<Array<ContextCompetitionUpdateRequest>>;
  exactPlacementAdvance?: InputMaybe<Scalars['Int']>;
  fixedNumberParticipantsBreak?: InputMaybe<Scalars['Int']>;
  maximumParticipantsBreak?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Date']>;
};

export type EventTagsFilterQuery = {
  locale?: InputMaybe<Locale>;
  names?: InputMaybe<Array<Scalars['String']>>;
};

/** A member of the event team */
export type EventTeamMember = {
  accountId: Scalars['String'];
  id: Scalars['String'];
  roles: Array<GamingRole>;
};

export type EventTiming = {
  __typename: 'EventTiming';
  completedAt: Maybe<Scalars['Date']>;
  registrationClose: Scalars['Date'];
  registrationOpen: Scalars['Date'];
  startTime: Scalars['Date'];
};

export type EventTimingCreationRequest = {
  registrationClose: Scalars['Date'];
  registrationOpen: Scalars['Date'];
  startTime: Scalars['Date'];
};

export type EventTimingUpdateRequest = {
  registrationClose?: InputMaybe<Scalars['Date']>;
  registrationOpen?: InputMaybe<Scalars['Date']>;
  shiftEverything: Scalars['Boolean'];
  startTime?: InputMaybe<Scalars['Date']>;
};

export type EventUpdateRequest = {
  category?: InputMaybe<EventCategory>;
  defaultLocale?: InputMaybe<Locale>;
  eventCurrencyExchanges?: InputMaybe<EventCurrencyExchangeUpdateRequest>;
  eventLimitations?: InputMaybe<EventLimitationsUpdateRequest>;
  eventStageUpdateRequests?: InputMaybe<Array<ContextEventStageUpdateRequest>>;
  eventTiming?: InputMaybe<EventTimingUpdateRequest>;
  featured?: InputMaybe<Scalars['Boolean']>;
  isSimulated?: InputMaybe<Scalars['Boolean']>;
  localizedDescriptions?: InputMaybe<Array<LocalizedOptionalStringInput>>;
  localizedMediaContentDetails?: InputMaybe<Array<LocalizedMediaContentDetailsUpdateRequest>>;
  localizedNames?: InputMaybe<Array<LocalizedStringInput>>;
  region?: InputMaybe<Region>;
  tags?: InputMaybe<Array<TagInput>>;
  tagsToDelete?: InputMaybe<Array<Scalars['String']>>;
  unlisted?: InputMaybe<Scalars['Boolean']>;
};

export type EventsQuery = {
  categories?: InputMaybe<Array<EventCategory>>;
  featured?: InputMaybe<Scalars['Boolean']>;
  gameIds?: InputMaybe<Array<Scalars['String']>>;
  showUnlisted?: InputMaybe<Scalars['Boolean']>;
  /** EventElementState */
  states?: InputMaybe<Array<EventElementState>>;
};

export type ExactPlacementAdvanceStrategy = AdvanceStrategy & {
  __typename: 'ExactPlacementAdvanceStrategy';
  advanceStrategyType: AdvanceStrategyType;
  placement: Scalars['Int'];
};

/** An Exchange of Swarmio Currency for various items */
export type ExchangedTransaction = SwarmioWalletTransactionWithMetadata & {
  __typename: 'ExchangedTransaction';
  amount: Scalars['Float'];
  created: Scalars['Date'];
  id: Scalars['String'];
  notes: Maybe<Scalars['String']>;
  otherWallet: SwarmioWallet;
  otherWalletId: Scalars['String'];
  swarmioCurrencyExchangeRateArchiveId: Scalars['String'];
  /** The type of transaction */
  transactionType: SwarmioWalletTransactionType;
  wallet: SwarmioWallet;
  walletId: Scalars['String'];
};

export type ExistingBracketUpdateRequest = {
  bracketName: TournamentBracketName;
  existingPhaseUpdateRequests: Array<ExistingPhaseUpdateRequest>;
};

export type ExistingMatchUpdateRequest = {
  assets?: InputMaybe<Array<TagInput>>;
  assetsToDelete?: InputMaybe<Array<Scalars['String']>>;
  matchId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['Date']>;
};

export type ExistingPhaseUpdateRequest = {
  existingMatchUpdateRequests: Array<ExistingMatchUpdateRequest>;
  phaseNumber: Scalars['Int'];
};

export type ExplicitEnrollment = {
  __typename: 'ExplicitEnrollment';
  costs: Array<Cost>;
  costsArchive: Array<Cost>;
  externalField: Maybe<ExternalField>;
  id: Scalars['String'];
};

export type ExplicitEnrollmentCreationRequest = {
  externalField?: InputMaybe<ExternalFieldInput>;
  realWorldCurrencyCosts: Array<RealWorldCurrencyCostCreationRequest>;
};

export type ExplicitEnrollmentUpdateRequest = {
  externalField?: InputMaybe<ExternalFieldInput>;
  newRealWorldCurrencyCosts: Array<RealWorldCurrencyCostCreationRequest>;
  removeCostIds: Array<Scalars['String']>;
};

export type ExplicitSubscription = SwarmioSubscription & {
  __typename: 'ExplicitSubscription';
  expiry: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isUsable: Scalars['Boolean'];
  lastPaymentDate: Maybe<Scalars['Date']>;
  nextExpectedPayment: Maybe<Scalars['Date']>;
  nextRewardDate: Maybe<Scalars['DateTime']>;
  payments: Array<InternalPayment>;
  secret: Maybe<Scalars['String']>;
  subscriptionImplementation: SubscriptionImplementation;
  subscriptionState: SubscriptionState;
  subscriptionType: SubscriptionType;
  subscriptionTypeCostId: Scalars['String'];
  subscriptionTypeId: Scalars['String'];
  unappliedPayments: Array<UnappliedPayment>;
};

export type ExportedItemsCsv = {
  __typename: 'ExportedItemsCSV';
  filePath: Maybe<Scalars['String']>;
};

export type ExternalCurrencyItemCost = CurrencyItemCost & {
  __typename: 'ExternalCurrencyItemCost';
  cost: Scalars['Float'];
  created: Scalars['Date'];
  /** Swarmio Currency Item */
  currencyItem: SwarmioCurrencyItem;
  currencyItemCostType: CurrencyItemCostType;
  externalId: Scalars['String'];
  id: Scalars['String'];
  realWorldCurrencyType: RealWorldCurrency;
  swarmioCurrencyItemId: Scalars['String'];
  version: Scalars['Int'];
};

export type ExternalCurrencyItemCostArchive = CurrencyItemCostArchive & {
  __typename: 'ExternalCurrencyItemCostArchive';
  cost: Scalars['Float'];
  created: Scalars['Date'];
  /** Swarmio Currency Item */
  currencyItem: SwarmioCurrencyItem;
  currencyItemCostType: CurrencyItemCostType;
  externalId: Scalars['String'];
  id: Scalars['String'];
  realWorldCurrencyType: RealWorldCurrency;
  swarmioCurrencyItemId: Scalars['String'];
  version: Scalars['Int'];
};

export type ExternalField = {
  __typename: 'ExternalField';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ExternalFieldInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ExternalSubscriptionPackage = {
  /** Boolean to check if the ExternalSubscriptionPackage is currently active or not */
  active: Scalars['Boolean'];
  /** Type of Costs associated with this package */
  costs: Array<Cost>;
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  /** Used for identifying a SubscriptionProvider uniquely */
  providerSubscriptionId: Scalars['String'];
  /** Subscription Partner of this External Subscription Package */
  subscriptionPartner: SubscriptionPartner;
  /** Type of Implicit Subscription Providers */
  subscriptionProvider: SubscriptionProvider;
  /** Subscription Type this package belongs to */
  subscriptionType: SubscriptionType;
  subscriptionTypeId: Scalars['String'];
};

export type FailedOrderFilterInput = {
  dateEndTimeMillis?: InputMaybe<Scalars['Float']>;
  dateStartTimeMillis?: InputMaybe<Scalars['Float']>;
};

export type FailedOrderTransaction = {
  __typename: 'FailedOrderTransaction';
  contentType: Maybe<ContentType>;
  createdDate: Maybe<Scalars['String']>;
  currencyConversionRate: Maybe<Scalars['Float']>;
  dealId: Maybe<Scalars['Int']>;
  dealPercentage: Maybe<Scalars['Float']>;
  dealValue: Maybe<Scalars['Float']>;
  errorCode: Maybe<Scalars['String']>;
  errorMessage: Maybe<Scalars['String']>;
  gamerEmail: Maybe<Scalars['String']>;
  gamerId: Maybe<Scalars['String']>;
  gamerName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  item: Maybe<Item>;
  markedUpPrice: Maybe<Scalars['Float']>;
  partner: Maybe<Partner>;
  pointsConversionRate: Maybe<Scalars['Float']>;
  pointsValue: Maybe<Scalars['Float']>;
  productSellPrice: Maybe<Scalars['Float']>;
  purchaseCurrency: Maybe<Scalars['String']>;
  purchaseMedium: Maybe<Scalars['String']>;
  purchasePaymentChannelName: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['Int']>;
  retryButtonDisabled: Maybe<Scalars['Boolean']>;
  status: Maybe<FailedOrderTransactionStatus>;
  totalPoints: Maybe<Scalars['Float']>;
  transactionId: Maybe<Scalars['String']>;
  unitPrice: Maybe<Scalars['Float']>;
};

export enum FailedOrderTransactionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type Feature = {
  __typename: 'Feature';
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updated: Maybe<Scalars['Date']>;
};

export type FeatureCreationRequest = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type FeatureFlag = {
  __typename: 'FeatureFlag';
  created: Scalars['Date'];
  feature: Feature;
  id: Scalars['String'];
  segments: Array<Segment>;
  state: FeatureFlagState;
  updated: Maybe<Scalars['Date']>;
};

export type FeatureFlagCreationRequest = {
  featureId: Scalars['String'];
  segments: Array<SegmentInput>;
  state: FeatureFlagState;
};

/** Feature flag state */
export enum FeatureFlagState {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

/** The FeatureFlagUpdateRequest replaces the current array with the new one so make sure to mutate the original and send it back. */
export type FeatureFlagUpdateRequest = {
  id: Scalars['String'];
  segments?: InputMaybe<Array<SegmentInput>>;
  state?: InputMaybe<FeatureFlagState>;
};

export type FeatureUpdateRequest = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum FileStatus {
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum FileUploadType {
  OrderFieldsUpload = 'ORDER_FIELDS_UPLOAD',
  ProductsUpload = 'PRODUCTS_UPLOAD'
}

export type FilterInput = {
  fileStatus?: InputMaybe<FileStatus>;
  fileUploadType?: InputMaybe<FileUploadType>;
  supplierId?: InputMaybe<Scalars['ID']>;
};

export type FinalPriceOverriddenDetails = {
  conversionRate?: InputMaybe<Scalars['Float']>;
  finalPriceOverridden?: InputMaybe<Scalars['Float']>;
  finalPriceOverriddenDCB?: InputMaybe<Scalars['Float']>;
  finalPriceOverriddenPSP?: InputMaybe<Scalars['Float']>;
  itemPoints?: InputMaybe<Scalars['Float']>;
  localPointsRate?: InputMaybe<Scalars['Float']>;
  markedUpPercentage?: InputMaybe<Scalars['Float']>;
  markedUpPercentageDCB?: InputMaybe<Scalars['Float']>;
  markedUpPercentagePSP?: InputMaybe<Scalars['Float']>;
  markedUpPrice?: InputMaybe<Scalars['Float']>;
  markedUpPriceDCB?: InputMaybe<Scalars['Float']>;
  markedUpPricePSP?: InputMaybe<Scalars['Float']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  roundedItemPoints?: InputMaybe<Scalars['Float']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
};

export type FinalPriceOverrideData = {
  overriddenFinalPrice: Scalars['Float'];
  paymentChannelId: Scalars['ID'];
  sourceCurrency: Scalars['String'];
  targetCurrency: Scalars['String'];
};

export type FixedNumberBreakStrategy = BreakStrategy & {
  __typename: 'FixedNumberBreakStrategy';
  breakStrategyType: BreakStrategyType;
  number: Scalars['Int'];
};

/** A fixed prize for a particular placement in an event */
export type FixedPrize = {
  id: Scalars['String'];
  prizeType: PrizeType;
};

/** Freebie Transaction */
export type FreebieTransaction = SwarmioWalletTransactionWithMetadata & {
  __typename: 'FreebieTransaction';
  amount: Scalars['Float'];
  approvedBy: Scalars['String'];
  created: Scalars['Date'];
  id: Scalars['String'];
  notes: Maybe<Scalars['String']>;
  /** The type of transaction */
  transactionType: SwarmioWalletTransactionType;
  wallet: SwarmioWallet;
  walletId: Scalars['String'];
};

export type Game = {
  __typename: 'Game';
  bufferTime: Scalars['DurationInMilliseconds'];
  description: Maybe<Scalars['String']>;
  estimatedRoundLength: Scalars['DurationInMilliseconds'];
  gameAccountTypeIds: Array<Scalars['String']>;
  gameAccountTypes: Array<GameAccountType>;
  id: Scalars['String'];
  image: Maybe<Scalars['String']>;
  integrated: Scalars['Boolean'];
  maxParticipantsPerRound: Maybe<Scalars['Float']>;
  prettyName: Scalars['String'];
  supportedCompetitionFormats: Array<CompetitionFormat>;
  supportedParticipantTypes: Array<ParticipantType>;
  typicalPlacingStrategyForRounds: PlacingStrategy;
  weight: Maybe<Scalars['Float']>;
};

export type GameAccount = {
  __typename: 'GameAccount';
  created: Scalars['Date'];
  externalAccountId: Maybe<Scalars['String']>;
  externalAccountName: Maybe<Scalars['String']>;
  gameAccountTypeId: Scalars['String'];
  gameIds: Array<Scalars['String']>;
  games: Array<Game>;
  id: Scalars['String'];
  updated: Scalars['Date'];
  verified: Scalars['Boolean'];
};

export type GameAccountType = {
  __typename: 'GameAccountType';
  accountIDLabel: Maybe<Scalars['String']>;
  accountNameLabel: Maybe<Scalars['String']>;
  games: Array<Game>;
  iconUrl: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl: Maybe<Scalars['String']>;
  implicitGameIds: Array<Scalars['String']>;
  integrated: Scalars['Boolean'];
  prettyName: Scalars['String'];
  requiresExternalAccountId: Scalars['Boolean'];
  requiresExternalAccountName: Scalars['Boolean'];
  unlisted: Scalars['Boolean'];
};

export type GameAccountTypeUpdateRequest = {
  accountIDLabel?: InputMaybe<Scalars['String']>;
  accountNameLabel?: InputMaybe<Scalars['String']>;
  addImplicitGameIds?: InputMaybe<Array<Scalars['String']>>;
  iconUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  prettyName?: InputMaybe<Scalars['String']>;
  removeImplicitGameIds?: InputMaybe<Array<Scalars['String']>>;
  requiresExternalAccountId?: InputMaybe<Scalars['Boolean']>;
  requiresExternalAccountName?: InputMaybe<Scalars['Boolean']>;
  unlisted?: InputMaybe<Scalars['Boolean']>;
};

export type GameAccountUpdateRequest = {
  externalAccountId?: InputMaybe<Scalars['String']>;
  externalAccountName?: InputMaybe<Scalars['String']>;
};

/** GameMode determines the CSGO game mode */
export enum GameModeType {
  /** Sets CSGO GameMode to casual */
  Casual = 'Casual',
  /** Sets CSGO GameMode to death match */
  DeathMatch = 'DeathMatch',
  /** Sets CSGO GameMode ladder */
  Ladder = 'Ladder',
  /** Sets CSGO GameMode retakes */
  Retakes = 'Retakes'
}

export type GameSpecificCompetitionDetails = {
  gameId: Scalars['String'];
};

export type GameSpecificDetails = {
  gameId: Scalars['String'];
};

export type GameUpdateRequest = {
  addCompetitionFormats?: InputMaybe<Array<CompetitionFormat>>;
  addGameAccountTypeIds?: InputMaybe<Array<Scalars['String']>>;
  bufferTimeInSeconds: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  estimatedRoundLengthInSeconds: Scalars['Int'];
  image?: InputMaybe<Scalars['String']>;
  maxParticipantsPerRound?: InputMaybe<Scalars['Float']>;
  prettyName?: InputMaybe<Scalars['String']>;
  removeCompetitionFormats?: InputMaybe<Array<CompetitionFormat>>;
  removeGameAccountTypeIds?: InputMaybe<Array<Scalars['String']>>;
  supportedParticipantTypes?: InputMaybe<Array<ParticipantType>>;
  typicalPlacingStrategyForRounds?: InputMaybe<PlacingStrategy>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type GameUserIdValidationRequest = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type GameUserIdValidationResponse = {
  __typename: 'GameUserIdValidationResponse';
  isValid: Maybe<Scalars['Boolean']>;
  responseMessage: Maybe<Scalars['String']>;
};

export enum GamingAccountNotificationType {
  ConfirmParticipationNotificationType = 'ConfirmParticipationNotificationType',
  EventEndedAccountNotificationType = 'EventEndedAccountNotificationType',
  EventStartingInXAccountNotificationType = 'EventStartingInXAccountNotificationType',
  EventTimeChangedAccountNotificationType = 'EventTimeChangedAccountNotificationType',
  KingOfTheHillSelectionAccountNotificationType = 'KingOfTheHillSelectionAccountNotificationType',
  MatchEndedAccountNotificationType = 'MatchEndedAccountNotificationType',
  MatchStartingInXAccountNotificationType = 'MatchStartingInXAccountNotificationType',
  MatchTimeChangedAccountNotificationType = 'MatchTimeChangedAccountNotificationType'
}

export enum GamingAction {
  Create = 'Create',
  Select = 'Select'
}

export type GamingActionable = {
  __typename: 'GamingActionable';
  action: GamingAction;
  id: Scalars['String'];
  scopeGroups: Array<GamingScopeGroup>;
  target: GamingPermissionTarget;
};

export enum GamingClientNotificationType {
  DidNotJoinEventNotificationType = 'DidNotJoinEventNotificationType',
  JoinedEventNotificationType = 'JoinedEventNotificationType',
  LeftEventNotificationNotificationType = 'LeftEventNotificationNotificationType',
  LinkedGameAccountNotificationType = 'LinkedGameAccountNotificationType',
  UpdatedEventNotificationType = 'UpdatedEventNotificationType'
}

export type GamingFullRole = GamingRole & {
  __typename: 'GamingFullRole';
  businessScope: Array<Scalars['String']>;
  id: Scalars['String'];
  permissions: Array<GamingActionable>;
  prettyName: Scalars['String'];
  roleDisplayName: Scalars['String'];
  roleId: Scalars['String'];
};

export enum GamingPermissionTarget {
  Event = 'Event',
  Participant = 'Participant'
}

/** A gaming-related role */
export type GamingRole = {
  businessScope: Array<Scalars['String']>;
  roleDisplayName: Scalars['String'];
  roleId: Scalars['String'];
};

export type GamingRoleFragment = GamingRole & {
  __typename: 'GamingRoleFragment';
  businessScope: Array<Scalars['String']>;
  roleDisplayName: Scalars['String'];
  roleId: Scalars['String'];
};

export type GamingScope = {
  __typename: 'GamingScope';
  scopeTarget: GamingScopeTarget;
  value: Scalars['String'];
};

export type GamingScopeGroup = {
  __typename: 'GamingScopeGroup';
  scopes: Array<GamingScope>;
};

export enum GamingScopeTarget {
  Location = 'Location'
}

export type Group = Account & GroupTrait & ObjectRepresentation & {
  __typename: 'Group';
  accountInvites: Array<AccountInviteWithPossibleError>;
  accountType: Scalars['String'];
  avatarURL: Maybe<Scalars['String']>;
  bannerURL: Maybe<Scalars['String']>;
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  groupInvites: Array<GroupInviteWithPossibleError>;
  groupMembers: Array<GroupMember>;
  groupMemberships: Array<GroupMembership>;
  groupType: Scalars['String'];
  id: Scalars['String'];
  isSupplier: Scalars['Boolean'];
  lastUpdated: Scalars['DateTime'];
  managedAccounts: Array<ManagedAccount>;
  name: Scalars['String'];
  otherFields: Maybe<Array<AccountTag>>;
  ownerId: Scalars['String'];
  payPurchaseTransactions: Array<PayPurchaseTransaction>;
  publicURL: Maybe<Scalars['String']>;
  purchaseTransactions: Array<PurchaseTransaction>;
  socialLinks: Array<SocialLink>;
  subscriptionProviderAccounts: Array<SubscriptionProviderAccount>;
  subscriptions: Array<SwarmioSubscription>;
  updated: Scalars['Date'];
  wallets: Array<SwarmioWallet>;
};

export type GroupCreationRequest = {
  avatarURL?: InputMaybe<Scalars['String']>;
  bannerURL?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  otherFields?: InputMaybe<Array<AccountTagInput>>;
  ownerId: Scalars['String'];
  publicURL?: InputMaybe<Scalars['String']>;
  socialLinks?: InputMaybe<Array<SocialLinkInput>>;
};

export type GroupInvite = GroupInviteWithPossibleError & {
  __typename: 'GroupInvite';
  created: Scalars['Date'];
  group: Maybe<GroupTrait>;
  groupId: Scalars['String'];
  id: Scalars['String'];
  isError: Scalars['Boolean'];
  roles: Array<Role>;
};

/** A GroupInvite or an error */
export type GroupInviteWithPossibleError = {
  isError: Scalars['Boolean'];
};

export type GroupMember = {
  __typename: 'GroupMember';
  account: Account;
  accountId: Scalars['String'];
  created: Scalars['Date'];
  id: Scalars['String'];
  inviteCode: Maybe<InviteCode>;
  roles: Array<Role>;
};

export type GroupMembership = {
  __typename: 'GroupMembership';
  created: Scalars['Date'];
  group: GroupTrait;
  groupId: Scalars['String'];
  id: Scalars['String'];
  roles: Array<Role>;
};

/** A group */
export type GroupTrait = {
  accountInvites: Array<AccountInviteWithPossibleError>;
  accountType: Scalars['String'];
  avatarURL: Maybe<Scalars['String']>;
  bannerURL: Maybe<Scalars['String']>;
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  groupInvites: Array<GroupInviteWithPossibleError>;
  groupMembers: Array<GroupMember>;
  groupMemberships: Array<GroupMembership>;
  groupType: Scalars['String'];
  id: Scalars['String'];
  managedAccounts: Array<ManagedAccountWithPossibleError>;
  name: Scalars['String'];
  otherFields: Maybe<Array<AccountTag>>;
  ownerId: Scalars['String'];
  publicURL: Maybe<Scalars['String']>;
  socialLinks: Array<SocialLink>;
  updated: Scalars['Date'];
  wallets: Array<SwarmioWallet>;
};

export type GroupUpdateRequest = {
  avatarURL?: InputMaybe<Scalars['String']>;
  bannerURL?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  otherFieldsToAdd?: InputMaybe<Array<AccountTagInput>>;
  otherFieldsToRemove?: InputMaybe<Array<Scalars['String']>>;
  publicURL?: InputMaybe<Scalars['String']>;
  removeAvatarURL?: InputMaybe<Scalars['Boolean']>;
  removeBannerURL?: InputMaybe<Scalars['Boolean']>;
  removePublicURL?: InputMaybe<Scalars['Boolean']>;
  socialLinks?: InputMaybe<Array<SocialLinkInput>>;
};

/** Contact point for an account */
export type HiveContact = {
  contact: Scalars['String'];
  contactType: HiveContactType;
  isError: Scalars['Boolean'];
  verified: Scalars['Boolean'];
};

/** Type of Contact */
export enum HiveContactType {
  NewContactType = 'NewContactType',
  UpdateContactRequestType = 'UpdateContactRequestType',
  VerifiedContactType = 'VerifiedContactType'
}

/** A Contact or an error */
export type HiveContactWithPossibleError = {
  isError: Scalars['Boolean'];
};

export type IdentityProvider = IdentityProviderWithPossibleError & {
  __typename: 'IdentityProvider';
  email: Scalars['String'];
  externalAccountId: Scalars['String'];
  isError: Scalars['Boolean'];
  providerType: IdentityProviderType;
};

/** Type of IdentityProvider */
export enum IdentityProviderType {
  Discord = 'DISCORD',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  Keycloak = 'KEYCLOAK',
  Password = 'PASSWORD',
  Twitch = 'TWITCH'
}

/** An IdentityProvider or an error */
export type IdentityProviderWithPossibleError = {
  isError: Scalars['Boolean'];
};

export type ImplicitEnrollment = {
  __typename: 'ImplicitEnrollment';
  externalSubscriptionPackage: ExternalSubscriptionPackage;
  externalSubscriptionPackageId: Scalars['String'];
  id: Scalars['String'];
  invalidateCacheAt: Scalars['DurationInSeconds'];
};

export type ImplicitEnrollmentCreationRequest = {
  externalSubscriptionPackageId: Scalars['String'];
  invalidateCacheAt: Scalars['DurationInSeconds'];
};

export type ImplicitSubscription = SwarmioSubscription & {
  __typename: 'ImplicitSubscription';
  cacheExpiry: Scalars['DateTime'];
  canUnsubscribe: Scalars['Boolean'];
  expiry: Maybe<Scalars['DateTime']>;
  externalSubscriptionPackage: ExternalSubscriptionPackage;
  externalSubscriptionPackageId: Scalars['String'];
  id: Scalars['String'];
  isUsable: Scalars['Boolean'];
  lastVerified: Scalars['DateTime'];
  nextRewardDate: Maybe<Scalars['DateTime']>;
  secret: Maybe<Scalars['String']>;
  subscriptionImplementation: SubscriptionImplementation;
  subscriptionProviderAccountId: Scalars['String'];
  subscriptionState: SubscriptionState;
  subscriptionType: SubscriptionType;
  subscriptionTypeId: Scalars['String'];
};

export type InGameResult = {
  __typename: 'InGameResult';
  id: Scalars['String'];
  matchId: Scalars['String'];
  scores: Array<ParticipantScore>;
};

export type IndividualCompetitionParticipantCreationRequest = {
  accountId: Scalars['String'];
  maybeGameAccountId?: InputMaybe<Scalars['String']>;
};

export type IndividualParticipant = {
  accountId: Scalars['String'];
  confirmed: Scalars['Boolean'];
  inviteLink: Maybe<IndividualParticipantInviteLink>;
  maybeGameAccountId: Maybe<Scalars['String']>;
  participantType: ParticipantType;
  requirementsNotMet: Array<ParticipantRequirementNotMet>;
  result: Maybe<Result>;
};

export type IndividualParticipantInviteLink = {
  __typename: 'IndividualParticipantInviteLink';
  code: Scalars['String'];
  id: Scalars['String'];
};

export type IntegratedVoucher = SwarmioVoucher & {
  __typename: 'IntegratedVoucher';
  code: Scalars['String'];
  distributionInfo: DistributionInfo;
  expirationDate: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  issueDate: Scalars['Date'];
  monetaryValue: Maybe<MonetaryValue>;
  redemption: Maybe<Redemption>;
  voucherType: VoucherType;
  whatYouGet: Scalars['String'];
};

export type IntegratedVoucherGenerationRequest = {
  distributionChannel: DistributionChannel;
  expirationDate?: InputMaybe<Scalars['Date']>;
  numberOfCodesToGenerate: Scalars['Int'];
  whatYouGet: Scalars['String'];
};

export type InternalPayment = {
  __typename: 'InternalPayment';
  amount: Scalars['Float'];
  cancelScheduledPaymentSupported: Maybe<Scalars['Boolean']>;
  currency: Scalars['String'];
  externalPaymentServiceId: Maybe<Scalars['String']>;
  forSubscriptionId: Scalars['String'];
  id: Scalars['String'];
  internalPaymentServiceId: Scalars['String'];
  paymentSchedule: Maybe<InternalSchedule>;
  paymentType: Scalars['String'];
  received: Scalars['DateTime'];
};

export type InternalSchedule = {
  __typename: 'InternalSchedule';
  endDate: Maybe<Scalars['String']>;
  every: Scalars['Int'];
  msisdn: Maybe<Scalars['String']>;
  nextPaymentDate: Maybe<Scalars['String']>;
  packageId: Maybe<Scalars['String']>;
  paymentMethod: Maybe<MerchantPaymentMethod>;
  period: Scalars['String'];
  scheduleId: Scalars['String'];
  startOn: Scalars['String'];
  status: Maybe<ScheduleStatus>;
};

export type InternalService = Account & ObjectRepresentation & User & {
  __typename: 'InternalService';
  accountManagers: Array<AccountManagerWithPossibleError>;
  accountType: Scalars['String'];
  avatarURL: Maybe<Scalars['String']>;
  bannerURL: Maybe<Scalars['String']>;
  contactIdentifier: StringAttributeWithPossibleError;
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  email: Maybe<StringAttributeWithPossibleError>;
  emailContact: Maybe<HiveContactWithPossibleError>;
  emailVerified: Scalars['Boolean'];
  groupInvites: Array<GroupInviteWithPossibleError>;
  groupMemberships: Array<GroupMembership>;
  hasValidContact: Scalars['Boolean'];
  id: Scalars['String'];
  isSupplier: Scalars['Boolean'];
  lastUpdated: Scalars['DateTime'];
  managedAccounts: Array<ManagedAccount>;
  msisdn: Maybe<StringAttributeWithPossibleError>;
  msisdnContact: Maybe<HiveContactWithPossibleError>;
  msisdnVerified: Scalars['Boolean'];
  otherFields: Maybe<Array<AccountTag>>;
  payPurchaseTransactions: Array<PayPurchaseTransaction>;
  publicURL: Maybe<Scalars['String']>;
  purchaseTransactions: Array<PurchaseTransaction>;
  socialLinks: Array<SocialLink>;
  subscriptionProviderAccounts: Array<SubscriptionProviderAccount>;
  subscriptions: Array<SwarmioSubscription>;
  updated: Scalars['Date'];
  userType: Scalars['String'];
  wallets: Array<SwarmioWallet>;
};

export type InternalServiceCreationRequest = {
  avatarURL?: InputMaybe<Scalars['String']>;
  bannerURL?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  msisdn?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  publicURL?: InputMaybe<Scalars['String']>;
  socialLinks?: InputMaybe<Array<SocialLinkInput>>;
};

export type InternalServiceUpdateRequest = {
  avatarURL?: InputMaybe<Scalars['String']>;
  bannerURL?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  msisdn?: InputMaybe<Scalars['String']>;
  publicURL?: InputMaybe<Scalars['String']>;
  removeAvatarURL?: InputMaybe<Scalars['Boolean']>;
  removeBannerURL?: InputMaybe<Scalars['Boolean']>;
  removeEmail?: InputMaybe<Scalars['Boolean']>;
  removeMsisdn?: InputMaybe<Scalars['Boolean']>;
  removePublicURL?: InputMaybe<Scalars['Boolean']>;
  socialLinks?: InputMaybe<Array<SocialLinkInput>>;
};

export enum InventoryStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type InviteCode = {
  __typename: 'InviteCode';
  code: Scalars['String'];
  expiry: Scalars['Date'];
};

export type Item = {
  __typename: 'Item';
  contentType: Maybe<ContentType>;
  createdBy: Maybe<Scalars['Int']>;
  createdDate: Maybe<Scalars['String']>;
  currencyConversionRate: Maybe<Scalars['Float']>;
  deliveryMethod: Maybe<ItemDeliveryMethod>;
  displayName: Maybe<Scalars['String']>;
  gamePublisher: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  /** itemCatalogCategory: [ItemCatalogCategory] */
  isStockAvailable: Maybe<Scalars['Boolean']>;
  itemDescBrief: Maybe<Scalars['String']>;
  itemDescDetail: Maybe<Scalars['String']>;
  itemGalleryUrls: Maybe<Array<Maybe<Scalars['String']>>>;
  itemId: Maybe<Scalars['String']>;
  itemImageUrl: Maybe<Scalars['String']>;
  itemName: Maybe<Scalars['String']>;
  itemPartnerPoints: Maybe<Array<Maybe<ItemPoints>>>;
  itemProductGroup: Maybe<ItemProductGroup>;
  itemStatus: Maybe<ItemStatus>;
  itemType: Maybe<ItemType>;
  outOfStockDate: Maybe<Scalars['String']>;
  outOfStockImageUrl: Maybe<Scalars['String']>;
  product: Maybe<Product>;
  safetyStockThreshold: Maybe<Scalars['Int']>;
  supplier: Maybe<Supplier>;
  unitPrice: Maybe<Scalars['Float']>;
  variantName: Maybe<Scalars['String']>;
};

export type ItemCatalogDto = {
  catalogId?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
};

export type ItemCost = {
  __typename: 'ItemCost';
  paymentChannelId: Scalars['String'];
  paymentChannelName: Scalars['String'];
  paymentMethod: PaymentMethod;
  targetCurrencyPrices: TargetCurrencyPrices;
};

export enum ItemDeliveryMethod {
  Redeem = 'REDEEM'
}

export type ItemFilterInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contentType?: InputMaybe<ContentType>;
  inStock?: InputMaybe<Scalars['Boolean']>;
  itemStatusList?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
  itemType?: InputMaybe<ItemType>;
  partner?: InputMaybe<Scalars['ID']>;
  partners?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  productType?: InputMaybe<ProductType>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ItemIdInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type ItemInput = {
  contentType?: InputMaybe<ContentType>;
  createdBy?: InputMaybe<Scalars['Int']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']>;
  deliveryMethod?: InputMaybe<ItemDeliveryMethod>;
  displayName?: InputMaybe<Scalars['String']>;
  gamePublisher?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  itemDescBrief?: InputMaybe<Scalars['String']>;
  itemDescDetail?: InputMaybe<Scalars['String']>;
  itemGalleryUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  itemId?: InputMaybe<Scalars['String']>;
  itemImageUrl?: InputMaybe<Scalars['String']>;
  itemName?: InputMaybe<Scalars['String']>;
  itemStatus?: InputMaybe<ItemStatus>;
  itemType?: InputMaybe<ItemType>;
  outOfStockImageUrl?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<ProductIdInput>;
  safetyStockThreshold?: InputMaybe<Scalars['Int']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
  variantName?: InputMaybe<Scalars['String']>;
};

export type ItemLanguageDto = {
  __typename: 'ItemLanguageDTO';
  id: Maybe<Scalars['ID']>;
  itemId: Maybe<Scalars['String']>;
  itemName: Maybe<Scalars['String']>;
  languages: Maybe<Array<Maybe<LanguageDto>>>;
  unConfiguredLanguageIds: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ItemLanguageData = {
  __typename: 'ItemLanguageData';
  countryCode: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  isDefault: Maybe<Scalars['Boolean']>;
  isLanguageConfigured: Maybe<Scalars['Boolean']>;
  itemDescBrief: Maybe<Scalars['String']>;
  itemDescDetail: Maybe<Scalars['String']>;
  itemName: Maybe<Scalars['String']>;
  languageCode: Maybe<Scalars['String']>;
  languageId: Maybe<Scalars['ID']>;
  languageName: Maybe<Scalars['String']>;
  mappedPartnerLanguage: Maybe<Scalars['Boolean']>;
};

export type ItemLanguageDataInput = {
  displayName?: InputMaybe<Scalars['String']>;
  itemDescBrief?: InputMaybe<Scalars['String']>;
  itemDescDetail?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['ID']>;
  itemName?: InputMaybe<Scalars['String']>;
  languageId?: InputMaybe<Scalars['ID']>;
};

export type ItemLanguageResponse = {
  __typename: 'ItemLanguageResponse';
  displayName: Maybe<Scalars['String']>;
  itemDescBrief: Maybe<Scalars['String']>;
  itemDescDetail: Maybe<Scalars['String']>;
  itemName: Maybe<Scalars['String']>;
};

export type ItemLanguagesResponse = {
  __typename: 'ItemLanguagesResponse';
  currentPage: Maybe<Scalars['Int']>;
  items: Maybe<Array<Maybe<ItemLanguageDto>>>;
  pageSize: Maybe<Scalars['Int']>;
  totalFilteredItems: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
};

export type ItemListInput = {
  itemId: Scalars['ID'];
  itemStatus?: InputMaybe<ItemStatus>;
};

export type ItemPartnerCurrencyConversionsInput = {
  conversionRate?: InputMaybe<Scalars['Float']>;
  resetLevelItem?: InputMaybe<Scalars['Boolean']>;
  sourceCurrency?: InputMaybe<Scalars['String']>;
  targetCurrency?: InputMaybe<Scalars['String']>;
};

export type ItemPoints = {
  __typename: 'ItemPoints';
  createdDate: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  item: Maybe<Item>;
  localCurrencyConversionRate: Maybe<Scalars['Float']>;
  markedUpPrice: Maybe<Scalars['Float']>;
  partner: Maybe<Partner>;
  pointsConversionRate: Maybe<Scalars['Float']>;
  pointsValue: Maybe<Scalars['Float']>;
};

export type ItemPointsInput = {
  finalPriceOverriddenDetails?: InputMaybe<FinalPriceOverriddenDetails>;
  item: ItemIdInput;
  localCurrencyConversionRate?: InputMaybe<Scalars['Float']>;
  markedUpPercentage?: InputMaybe<Scalars['Float']>;
  markedUpPrice?: InputMaybe<Scalars['Float']>;
  partner: PartnerIdInput;
  pointsConversionRate?: InputMaybe<Scalars['Float']>;
  pointsValue?: InputMaybe<Scalars['Float']>;
};

export type ItemProductGroup = {
  __typename: 'ItemProductGroup';
  item: Maybe<Item>;
  productGroup: Maybe<ProductGroup>;
};

export enum ItemStatus {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Live = 'LIVE',
  LiveReady = 'LIVE_READY',
  Published = 'PUBLISHED',
  Removed = 'REMOVED',
  Trashed = 'TRASHED',
  Unpublished = 'UNPUBLISHED',
  Validated = 'VALIDATED'
}

export enum ItemType {
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL'
}

export type JobInfo = {
  __typename: 'JobInfo';
  className: Maybe<Scalars['String']>;
  createdDate: Maybe<Scalars['String']>;
  cronDefinition: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  executionTime: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  jobId: Maybe<Scalars['String']>;
  jobName: Maybe<Scalars['String']>;
  jobType: Maybe<JobType>;
  lastTriggerStatus: Maybe<JobTriggerStatus>;
  lastTriggerTime: Maybe<Scalars['String']>;
  schedulerMethodType: Maybe<SchedulerMethodType>;
  supplier: Maybe<Supplier>;
};

export type JobInfoInput = {
  className?: InputMaybe<Scalars['String']>;
  cronDefinition: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  executionTime?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  jobId?: InputMaybe<Scalars['String']>;
  jobName: Scalars['String'];
  jobType: JobType;
  lastTriggerStatus?: InputMaybe<JobTriggerStatus>;
  lastTriggerTime?: InputMaybe<Scalars['String']>;
  /** schedulerMethodType: SchedulerMethodType, */
  productType?: InputMaybe<ProductType>;
};

export enum JobTriggerStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export enum JobType {
  CommonJob = 'COMMON_JOB',
  SupplierJob = 'SUPPLIER_JOB'
}

export type JoinEventAdminModifiers = {
  bypassRegistrationClosed: Scalars['Boolean'];
};

export type JoinIndividualEventRequest = {
  accountId: Scalars['String'];
  adminModifiers?: InputMaybe<JoinEventAdminModifiers>;
  eventId: Scalars['String'];
};

export type JoinTeamEventRequest = {
  adminModifiers?: InputMaybe<JoinEventAdminModifiers>;
  eventId: Scalars['String'];
  teamId: Scalars['String'];
  teamMembers: Array<Scalars['String']>;
};

export type KingOfTheHillCreationDetails = {
  individualHost?: InputMaybe<IndividualCompetitionParticipantCreationRequest>;
  maximumNumberOfPhases?: InputMaybe<Scalars['Int']>;
  phaseModifications?: InputMaybe<Array<PhaseModificationsCreationRequest>>;
  teamHost?: InputMaybe<TeamCompetitionParticipantCreationRequest>;
};

export type KingOfTheHillSpecificDetails = CompetitionSpecificDetails & MatchUpFormatSpecificDetails & PhasedCompetitionFormatSpecificDetails & {
  __typename: 'KingOfTheHillSpecificDetails';
  host: Participant;
  id: Scalars['String'];
  matchUpFormat: MatchUpFormat;
  maximumNumberOfPhases: Maybe<Scalars['Int']>;
  maybeMaxRoundParticipants: Maybe<Scalars['Int']>;
  maybeParticipantsInRound: Maybe<Scalars['Int']>;
  remainingParticipants: Array<UpcomingKingOfTheHillParticipant>;
};

export type KingOfTheHillUpdateDetails = {
  individualHost?: InputMaybe<IndividualCompetitionParticipantCreationRequest>;
  maximumNumberOfPhases?: InputMaybe<Scalars['Int']>;
  teamHost?: InputMaybe<TeamCompetitionParticipantCreationRequest>;
};

export type LadderDetailsCreationRequest = {
  durationInMinutes: Scalars['Int'];
  topResultsThreshold?: InputMaybe<Scalars['Int']>;
};

export type LadderSpecificDetails = ChallengeSpecificDetails & CompetitionSpecificDetails & {
  __typename: 'LadderSpecificDetails';
  ChallengeFormat: ChallengeFormat;
  duration: Scalars['DurationInMilliseconds'];
  id: Scalars['String'];
  topResultsThreshold: Maybe<Scalars['Int']>;
};

export type Language = {
  __typename: 'Language';
  countryCode: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isDefault: Maybe<Scalars['Boolean']>;
  languageName: Maybe<Scalars['String']>;
};

export type LanguageDto = {
  __typename: 'LanguageDto';
  countryCode: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isLanguageConfigured: Maybe<Scalars['Boolean']>;
  languageCode: Maybe<Scalars['String']>;
  languageName: Maybe<Scalars['String']>;
};

export type LanguageMappingFilter = {
  languageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type LeaveEventRequest = {
  eventId: Scalars['String'];
  participantId: Scalars['String'];
};

export enum Locale {
  ArAe = 'ar_AE',
  ArBh = 'ar_BH',
  ArSa = 'ar_SA',
  ArTn = 'ar_TN',
  EnUs = 'en_US',
  ThTh = 'th_TH'
}

export type LocalizedMediaContentDetails = {
  __typename: 'LocalizedMediaContentDetails';
  locale: Locale;
  value: MediaContentDetails;
};

export type LocalizedMediaContentDetailsCreationRequest = {
  locale: Locale;
  mediaContentDetails: MediaContentDetailsCreationRequest;
};

export type LocalizedMediaContentDetailsUpdateRequest = {
  locale: Locale;
  mediaContentDetails: MediaContentDetailsUpdateRequest;
};

export type LocalizedOptionalString = {
  __typename: 'LocalizedOptionalString';
  locale: Locale;
  value: Maybe<Scalars['String']>;
};

export type LocalizedOptionalStringInput = {
  locale: Locale;
  value?: InputMaybe<Scalars['String']>;
};

export type LocalizedString = {
  __typename: 'LocalizedString';
  locale: Locale;
  value: Scalars['String'];
};

export type LocalizedStringInput = {
  locale: Locale;
  value: Scalars['String'];
};

export type ManagedAccount = ManagedAccountWithPossibleError & {
  __typename: 'ManagedAccount';
  account: Maybe<Account>;
  accountId: Scalars['String'];
  isError: Scalars['Boolean'];
  roles: Array<Role>;
};

/** A ManagedAccount or an error */
export type ManagedAccountWithPossibleError = {
  isError: Scalars['Boolean'];
};

export type ManualResult = Result & {
  __typename: 'ManualResult';
  id: Scalars['String'];
  placement: Maybe<Scalars['Int']>;
  prizePayoutReceipt: Maybe<PrizePayoutReceipt>;
  resultImageURLs: Maybe<Array<Scalars['String']>>;
  score: Maybe<Scalars['Float']>;
  showed: Scalars['Boolean'];
};

export type ManuallyVerifiedResult = {
  __typename: 'ManuallyVerifiedResult';
  competitionId: Scalars['String'];
  created: Scalars['Date'];
  id: Scalars['String'];
  participantId: Scalars['String'];
  plzDelete: Scalars['Boolean'];
  roundId: Maybe<Scalars['String']>;
  unverifiedResult: Maybe<Result>;
};

export type ManuallyVerifiedResultWithMultiDimensionalBucketBasedResultRequest = {
  accountId: Scalars['String'];
  competitionId: Scalars['String'];
  roundId?: InputMaybe<Scalars['String']>;
  unverifiedResult: MultiDimensionalBucketBasedResultForVerificationRequest;
};

export enum MappedStatus {
  All = 'ALL',
  Mapped = 'MAPPED',
  Unmapped = 'UNMAPPED'
}

export type MatchModifications = {
  __typename: 'MatchModifications';
  assets: Array<Tag>;
  matchId: Scalars['String'];
  name: Maybe<Scalars['String']>;
  startTime: Maybe<Scalars['Date']>;
};

export type MatchModificationsCreationRequest = {
  assets?: InputMaybe<Array<TagInput>>;
  name?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['Date']>;
};

export type MatchModificationsUpdateRequest = {
  assets?: InputMaybe<Array<TagInput>>;
  assetsToDelete?: InputMaybe<Array<Scalars['String']>>;
  matchId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['Date']>;
};

/** A MatchUp */
export type MatchUp = Competition & {
  __typename: 'MatchUp';
  competitionState: EventElementState;
  competitionTiming: Maybe<CompetitionTiming>;
  competitionType: CompetitionType;
  created: Scalars['Date'];
  event: Event;
  eventId: Scalars['String'];
  eventStageId: Scalars['String'];
  game: Game;
  gameId: Scalars['String'];
  gameSpecificDetails: Maybe<GameSpecificCompetitionDetails>;
  id: Scalars['String'];
  isSimulated: Scalars['Boolean'];
  manualAdvancement: Scalars['Boolean'];
  matchUpFormat: MatchUpFormat;
  matchUpFormatSpecificDetails: Maybe<MatchUpFormatSpecificDetails>;
  numberOfRounds: Scalars['Int'];
  participantType: ParticipantType;
  participants: Array<CompetitionParticipantReference>;
  phaseBufferTime: Maybe<Scalars['DurationInMilliseconds']>;
  phaseModifications: Array<PhaseModifications>;
  phases: Array<MatchUpPhase>;
};

export type MatchUpCreationRequest = {
  battleRoyaleFormatDetails?: InputMaybe<BattleRoyaleFormatCreationDetails>;
  kingOfTheHillDetails?: InputMaybe<Array<KingOfTheHillCreationDetails>>;
  manualAdvancement: Scalars['Boolean'];
  matchUpFormat: MatchUpFormat;
  numberOfRounds: Scalars['Int'];
  phaseBufferTime?: InputMaybe<Scalars['DurationInMilliseconds']>;
  startTime?: InputMaybe<Scalars['Date']>;
};

export enum MatchUpFormat {
  BattleRoyale = 'BattleRoyale',
  KingOfTheHill = 'KingOfTheHill'
}

export type MatchUpFormatSpecificDetails = {
  id: Scalars['String'];
  matchUpFormat: MatchUpFormat;
  maybeMaxRoundParticipants: Maybe<Scalars['Int']>;
  maybeParticipantsInRound: Maybe<Scalars['Int']>;
};

/** A MatchUp match */
export type MatchUpMatch = {
  assets: Array<Tag>;
  gameSpecificDetails: Maybe<GameSpecificCompetitionDetails>;
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  startTime: Maybe<Scalars['Date']>;
};

export type MatchUpMatchBye = CompetitionMatch & MatchUpMatch & {
  __typename: 'MatchUpMatchBye';
  assets: Array<Tag>;
  gameSpecificDetails: Maybe<GameSpecificCompetitionDetails>;
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  participants: Array<CompetitionParticipantReferenceWithRoster>;
  startTime: Maybe<Scalars['Date']>;
};

/** A generic phase in a MatchUp */
export type MatchUpPhase = {
  __typename: 'MatchUpPhase';
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  matches: Array<MatchUpMatch>;
  phaseNumber: Scalars['Int'];
};

/** A generic round in a MatchUp */
export type MatchUpRound = {
  __typename: 'MatchUpRound';
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  participants: Array<CompetitionParticipantReference>;
  roundNumber: Scalars['Int'];
};

export type MaximumParticipantsBreakStrategy = BreakStrategy & {
  __typename: 'MaximumParticipantsBreakStrategy';
  breakStrategyType: BreakStrategyType;
  maxParticipants: Scalars['Int'];
};

export type MediaContentDetails = {
  __typename: 'MediaContentDetails';
  avatar: Maybe<Scalars['String']>;
  banner: Maybe<Scalars['String']>;
  descriptionImage: Maybe<Scalars['String']>;
  streams: Maybe<Array<Stream>>;
};

export type MediaContentDetailsCreationRequest = {
  avatarURL?: InputMaybe<Scalars['String']>;
  bannerURL?: InputMaybe<Scalars['String']>;
  descriptionImageURL?: InputMaybe<Scalars['String']>;
  twitchStreams?: InputMaybe<Array<TwitchStreamCreationRequest>>;
  youtubeStreams?: InputMaybe<Array<YouTubeStreamCreationRequest>>;
  youtubeVideos?: InputMaybe<Array<YouTubeVideoCreationRequest>>;
};

export type MediaContentDetailsUpdateRequest = {
  avatarURL?: InputMaybe<Scalars['String']>;
  bannerURL?: InputMaybe<Scalars['String']>;
  descriptionImageURL?: InputMaybe<Scalars['String']>;
  streamsToDelete?: InputMaybe<Array<Scalars['String']>>;
  twitchStreams?: InputMaybe<Array<TwitchStreamCreationRequest>>;
  youtubeStreams?: InputMaybe<Array<YouTubeStreamCreationRequest>>;
  youtubeVideos?: InputMaybe<Array<YouTubeVideoCreationRequest>>;
};

/** An Media Trait */
export type MediaTrait = {
  expiry: Scalars['Date'];
  id: Scalars['String'];
  mediaType: MediaType;
  weight: Maybe<Scalars['Float']>;
};

export type MediaTwitchStreamType = MediaTrait & ObjectRepresentation & Streams & UploadTrait & {
  __typename: 'MediaTwitchStreamType';
  expiry: Scalars['Date'];
  gameId: Maybe<Scalars['String']>;
  gameName: Maybe<Scalars['String']>;
  id: Scalars['String'];
  language: Maybe<Scalars['String']>;
  mediaType: MediaType;
  providerIdentifier: Scalars['String'];
  startedAt: Maybe<Scalars['String']>;
  status: StreamAvailabilityType;
  streamType: StreamType;
  streamUrl: Maybe<Scalars['String']>;
  thumbnailUrl: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  userLogin: Scalars['String'];
  userName: Maybe<Scalars['String']>;
  viewerCount: Maybe<Scalars['Int']>;
  weight: Maybe<Scalars['Float']>;
};

/** Type of Media */
export enum MediaType {
  AudioMediaType = 'AudioMediaType',
  AwsMediaType = 'AwsMediaType',
  ImageMediaType = 'ImageMediaType',
  StreamMediaType = 'StreamMediaType'
}

export type MerchantPaymentMethod = {
  __typename: 'MerchantPaymentMethod';
  cancelScheduledPaymentSupported: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  paymentMethodType: Scalars['String'];
  recurringPaymentSupported: Scalars['Boolean'];
  refundSupported: Scalars['Boolean'];
};

export type MissingParticipantRequirement = {
  entryName: Scalars['String'];
};

export type MonetaryValue = {
  __typename: 'MonetaryValue';
  currency: Scalars['String'];
  value: Scalars['Float'];
};

export type MultiDimensionalBucketBasedResult = Result & {
  __typename: 'MultiDimensionalBucketBasedResult';
  bucketValue: Scalars['Float'];
  calculatedScore: Scalars['Float'];
  id: Scalars['String'];
  maybeShowed: Maybe<Scalars['Boolean']>;
  multiDimensionalResults: Array<SingleDimensionResult>;
  placement: Maybe<Scalars['Int']>;
  prizePayoutReceipt: Maybe<PrizePayoutReceipt>;
  resultImageURLs: Maybe<Array<Scalars['String']>>;
  score: Maybe<Scalars['Float']>;
  showed: Scalars['Boolean'];
};

export type MultiDimensionalBucketBasedResultForVerificationRequest = {
  bucketValue: Scalars['Float'];
  multiDimensionalResults: Array<SingleDimensionResultInput>;
};

/** root */
export type Mutation = {
  __typename: 'Mutation';
  /** Accept the Group Invitation Where the group id exists, and if not included accepts all invitations for this account. */
  acceptAllGroupInvitations: Account;
  /** Accept the Group Invitation Where the group id exists, and if not included accepts all invitations for this account. */
  acceptGroupInvitation: Account;
  /** Update the result for a participant in a given match */
  addAutomaticallyVerifiedResultForRoundId: Scalars['Int'];
  /** Add new client notifications */
  addClientNotifications: Scalars['Int'];
  addEventTeamInviteCode: IndividualParticipantInviteLink;
  /** Link a manual game account */
  addGameToGameAccount: Person;
  /** Add IndividualParticipant to Event */
  addIndividualParticipant: Scalars['Int'];
  addInviteCode: InviteCode;
  /** Update the result for a participant in a given match */
  addMultiDimensionalBucketBasedResultForVerification: Scalars['Int'];
  /** Add new account notification */
  addNotifications: Scalars['Int'];
  /** Add a SubscriptionPartner to the given account ID */
  addSLTAccount: Account;
  /** Add TeamParticipant to Event */
  addTeamParticipant: Scalars['Int'];
  addToEventTeam: Scalars['Boolean'];
  /** Advance competition if able */
  advancePhasedCompetition: Competition;
  /** Cancel events */
  cancelEvents: Array<Event>;
  /** If a target explicit subscription is in the AwaitingPayment state, change it to Cancelled state */
  cancelPendingSubscription: SwarmioSubscription;
  /** Attempt to cancel a scheduled payment setup for an explicit subscription package */
  cancelScheduledSubscription: SwarmioSubscription;
  checkHealth: Maybe<AllServHealthCheck>;
  /** Complete competition if able */
  completeCompetition: Competition;
  completePayoutRequest: SwarmioCurrencyPayoutRequest;
  /** Confirm Participant for Event */
  confirmParticipant: Scalars['Int'];
  /** Create a new application config */
  createApplicationConfig: ApplicationConfig;
  /** Create a new banner */
  createBanner: Banner;
  createCmsBanner: Maybe<CmsBanner>;
  createCmsBlogPage: Maybe<CmsBlogPage>;
  createCmsBlogPost: Maybe<CmsBlogPost>;
  createCmsGame: Maybe<CmsGame>;
  createCmsGamer: Maybe<CmsGamer>;
  createCmsMedia: Maybe<CmsMedia>;
  createCmsUser: Maybe<CmsUser>;
  createEmbeddedGame: EmbeddedGame;
  /** Create a new team event */
  createEvent: Event;
  createExchangedTransaction: ExchangedTransaction;
  /** Create a new feature */
  createFeature: Feature;
  createFreebieTransaction: FreebieTransaction;
  createGroup: Group;
  createNonIntegratedEventsGame: Game;
  /** Creates a non-integrated Game Account Type(it assumes the user to add in the correct details) */
  createNonIntegratedGameAccountType: GameAccountType;
  createPayloadLockedDocument: Maybe<PayloadLockedDocument>;
  createPayloadPreference: Maybe<PayloadPreference>;
  /** Create a config for an existing payment method */
  createPaymentMethodConfig: PaymentMethodConfig;
  /** Create a new private server */
  createPrivateServer: PrivateGameServer;
  /** Create a new prize list */
  createPrizeList: PrizeList;
  /** Create a new public server */
  createPublicServer: PublicGameServer;
  /** Create a new SubscriptionType */
  createSubscriptionType: SubscriptionType;
  createSwarmioCurrencyExchangeBlock: SwarmioCurrencyExchangeBlock;
  createSwarmioCurrencyItem: SwarmioCurrencyItem;
  createSwarmioCurrencyPayout: SwarmioCurrencyPayout;
  createTeam: Team;
  createWallet: SwarmioWallet;
  createWalletsForUser: Array<SwarmioWallet>;
  createWatchStreams: Array<Streams>;
  /** Decline the Group Invitation where the group id exists, and if not included declines all invitations for this account. */
  declineAllGroupInvitations: Account;
  /** Decline the Group Invitation Where the group id exists, and if not included declines all invitations for this account. */
  declineGroupInvitation: Account;
  /** Delete a banner */
  deleteBanner: Banner;
  deleteCmsBanner: Maybe<CmsBanner>;
  deleteCmsBlogPage: Maybe<CmsBlogPage>;
  deleteCmsBlogPost: Maybe<CmsBlogPost>;
  deleteCmsGame: Maybe<CmsGame>;
  deleteCmsGamer: Maybe<CmsGamer>;
  deleteCmsMedia: Maybe<CmsMedia>;
  deleteCmsUser: Maybe<CmsUser>;
  /** Marking Embedded Game for deletion   */
  deleteEmbeddedGame: Scalars['Int'];
  deletePartnerCurrencyPreferenceById: Maybe<Scalars['Boolean']>;
  deletePayloadLockedDocument: Maybe<PayloadLockedDocument>;
  deletePayloadPreference: Maybe<PayloadPreference>;
  /** Delete a config for an existing payment method */
  deletePaymentMethodConfig: PaymentMethodConfig;
  deleteProductByID: Maybe<ProductDelete>;
  deleteProductByIDs: Maybe<Array<Maybe<ProductDelete>>>;
  /** deleteProductsByFileId(fileId: ID!): ProductDelete */
  deleteProductsByFileIds: Maybe<Array<Maybe<ProductDelete>>>;
  /** marking public server for deletion */
  deletePublicServer: Scalars['Int'];
  deleteSupplier: Maybe<Scalars['Boolean']>;
  deleteVoucherByID: Maybe<ProductVoucher>;
  deleteVoucherByIDs: Maybe<Array<Maybe<ProductVoucher>>>;
  /** Distribute a voucher */
  distributeVoucher: IntegratedVoucher;
  duplicateCmsBanner: Maybe<CmsBanner>;
  duplicateCmsBlogPage: Maybe<CmsBlogPage>;
  duplicateCmsBlogPost: Maybe<CmsBlogPost>;
  duplicateCmsGame: Maybe<CmsGame>;
  duplicateCmsGamer: Maybe<CmsGamer>;
  duplicateCmsMedia: Maybe<CmsMedia>;
  duplicatePayloadLockedDocument: Maybe<PayloadLockedDocument>;
  duplicatePayloadPreference: Maybe<PayloadPreference>;
  editSwarmioCurrencyItem: SwarmioCurrencyItem;
  /** Create an explicit subscription for the target account, and create the session for explicit payment through the payment gateway (Swarmio Pay) */
  enrollExplicitSubscription: Scalars['String'];
  /** Attempt to enroll an account in a target external (implicit) subscription package through the provider API */
  enrollExternalSubscriptionPackage: Account;
  exchangeCustomSwarmioCurrencyAmount: ExchangedTransaction;
  exchangeEntireSwarmioCurrencyWallet: ExchangedTransaction;
  forceVerifyPersonEmail: Person;
  forgotPasswordCmsUser: Scalars['Boolean'];
  /** Generate integrated vouchers */
  generateIntegratedVouchers: Array<IntegratedVoucher>;
  /** Generate non-integrated vouchers */
  generateNonIntegratedVouchers: Array<NonIntegratedVoucher>;
  /** For a target account, refresh all of their attached implicit subscriptions from the subscriptionProvider */
  hardRefreshSubscriptionsForAccountId: Account;
  /** Invite an Account as a regular group member */
  inviteToGroup: GroupTrait;
  joinEventByInvite: Scalars['Boolean'];
  joinGroupTraitByInvite: GroupTrait;
  leaveEventTeam: Scalars['Boolean'];
  /** Link a manual game account */
  linkNonIntegratedGameAccount: Person;
  loginCmsUser: Maybe<CmsUsersLoginResult>;
  logoutCmsUser: Maybe<Scalars['String']>;
  /** Manually pair latest competition phase if able */
  manuallyPairLatestCompetitionPhase: Competition;
  /** Mark specified notifications as read */
  markNotificationsAsRead: Scalars['Int'];
  multipleSwarmioCurrencyTransfers: Array<TransferTransaction>;
  overridePspMarkedUpPercentage: Maybe<Scalars['Boolean']>;
  partnerItemFinalPriceOverride: Maybe<Scalars['Boolean']>;
  /** For a target explicit subscription (already attached to an account), start a payment session with Swarmio Pay */
  paySubscriptionWithSwarmio: Scalars['String'];
  payoutEventPrizes: Event;
  processCSVFile: Maybe<Array<Maybe<DraftProduct>>>;
  processOrderFieldsCSVFile: Maybe<Array<Maybe<OrderFieldsProduct>>>;
  /** Promote a group member to admin */
  promoteToGroupAdmin: GroupTrait;
  /** Use real currency to purchase an item provided by another service. */
  purchaseExternalItem: SessionRequestResult;
  /** Use swarmio currency to purchase an item provided by another service. */
  purchaseExternalItemWithPoints: Account;
  purchaseItem: Maybe<PurchaseResponse>;
  purchaseSwarmioCurrencyItem: Scalars['String'];
  purchaseTagIdRegistration: Maybe<PurchaseTagIdRegistrationResponse>;
  /** Ready Participant for Event */
  readyIndividualParticipant: Scalars['Int'];
  /** Redeem a voucher */
  redeemVoucher: IntegratedVoucher;
  /** Asynchronously refresh the results for a ladder competition */
  refreshLadderCompetitionResults: Scalars['Boolean'];
  /** Get updated riot account data */
  refreshRiotAccount: Person;
  refreshTokenCmsUser: Maybe<CmsUsersRefreshedCmsUser>;
  /** Refresh all implicit subscriptions that have passed their expiry date from the linked providers (for all users) */
  refreshUsersSubscriptions: Scalars['Int'];
  /** Refresh the live streams */
  refreshWatchStreams: Array<Streams>;
  registerInternalService: InternalService;
  registerPerson: Person;
  registerPersonEmail: Person;
  registerPersonMSISDN: Person;
  removeFromEventTeam: Scalars['Boolean'];
  removeMemberFromGroup: GroupTrait;
  /** Remove Participant from Event */
  removeParticipant: Scalars['Int'];
  removeRolesFromGroupMember: GroupTrait;
  /** Remove a SubscriptionPartner with given ID from the given account ID */
  removeSubscriptionProviderAccount: Account;
  /** Removes an existing Watch Stream */
  removeWatchStream: Scalars['Int'];
  /** Replace group owner */
  replaceGroupOwner: GroupTrait;
  requestCustomPayout: SwarmioCurrencyPayoutRequest;
  requestPayout: SwarmioCurrencyPayoutRequest;
  /** Request a voucher for a recipient. This will pick a random code that has not been distributed and send it to the recipient. */
  requestVoucherForRecipient: NonIntegratedVoucher;
  resendVerificationEmail: Scalars['Boolean'];
  resendVerificationSMS: Scalars['Boolean'];
  /**
   * updateUniPinVoucherProducts(supplierId: ID!): [Product]
   * updateUniPinTopUpProducts(supplierId: ID!): [Product]
   */
  resetLocalConversionRate: Maybe<Scalars['Boolean']>;
  resetMarkedUpPrice: Maybe<Scalars['Boolean']>;
  resetOverriddenFinalPrice: Maybe<Scalars['Boolean']>;
  resetOverrideCurrencyMarkedUpPercentage: Maybe<Scalars['Boolean']>;
  resetOverrideFinalPrice: Maybe<Scalars['Boolean']>;
  resetOverridePointsMarkedUpPercentage: Maybe<Scalars['Boolean']>;
  resetOverridePspMarkedUpPercentage: Maybe<Scalars['Boolean']>;
  resetOverrideRate: Maybe<Scalars['Boolean']>;
  resetPartnerItemMarkedUpPercentage: Maybe<Scalars['Boolean']>;
  resetPartnerPaymentChannelMarkedUpPercentage: Maybe<Scalars['Boolean']>;
  resetPassword: Scalars['Boolean'];
  resetPasswordCmsUser: Maybe<CmsUsersResetPassword>;
  resetPasswordRequest: Scalars['Boolean'];
  resetPasswordRequestWithSpecialEmail: Scalars['Boolean'];
  retryFailedTransaction: Maybe<PurchaseResponse>;
  saveCSVFile: Maybe<CsvFile>;
  saveCategory: Maybe<Category>;
  saveCategoryLanguageData: Maybe<CategoryLanguageDataResponse>;
  saveDeal: Maybe<Deal>;
  saveGlobalPoints: Maybe<Points>;
  saveItem: Maybe<Item>;
  saveItemLanguageData: Maybe<ItemLanguageResponse>;
  saveItemPartnerCurrencyConversions: Maybe<Array<Maybe<CurrencyConversion>>>;
  saveItemPoints: Maybe<ItemPoints>;
  savePartnerCurrencyPreferences: Maybe<Array<Maybe<PartnerCurrencyPreference>>>;
  savePartnerPaymentChannelData: Maybe<Array<Maybe<PartnerPaymentChannelData>>>;
  savePaymentChannel: Maybe<PaymentChannel>;
  saveProductGroup: Maybe<ProductGroupResponse>;
  saveProductGroupLanguageData: Maybe<ProductGroupLanguageResponse>;
  saveSupplier: Maybe<Supplier>;
  sendTemplateEmail: Scalars['Boolean'];
  transferAllWallets: Array<TransferTransaction>;
  transferSwarmioCurrency: TransferTransaction;
  undoLastAdvance: Competition;
  /** Attempt to un-enroll an account in a target external (implicit) subscription package through the provider API */
  unenrollExternalSubscriptionPackage: Account;
  /** Unlink an external game account */
  unlinkGameAccount: Person;
  unlinkIdentityProvider: User;
  unlinkIdentityProviderByEmail: Maybe<User>;
  unlockCmsUser: Scalars['Boolean'];
  /** Create a new application config */
  updateApplicationConfig: ApplicationConfig;
  /** Update a banner */
  updateBanner: Banner;
  updateCatalog: Catalog;
  updateCategoryList: Maybe<Array<Maybe<Category>>>;
  /** Update Team event */
  updateChallenge: Competition;
  updateCmsBanner: Maybe<CmsBanner>;
  updateCmsBlogPage: Maybe<CmsBlogPage>;
  updateCmsBlogPost: Maybe<CmsBlogPost>;
  updateCmsGame: Maybe<CmsGame>;
  updateCmsGamer: Maybe<CmsGamer>;
  updateCmsMedia: Maybe<CmsMedia>;
  updateCmsUser: Maybe<CmsUser>;
  updateDisabledPaymentChannels: Maybe<UpdateDisabledPaymentChannelResponse>;
  updateEmbeddedGame: EmbeddedGame;
  /** Update event */
  updateEvent: Event;
  /** Update eventStage */
  updateEventStage: EventStage;
  updateEventsGame: Game;
  /** Update an existing feature */
  updateFeature: Feature;
  /** Update a game */
  updateGameAccountType: GameAccountType;
  updateGroup: Group;
  updateInternalService: InternalService;
  updateItemList: Maybe<Array<Maybe<Item>>>;
  /** Update a manual game account */
  updateManualGameAccount: Person;
  /** Update Team event */
  updateMatchUp: Competition;
  updateOrderList: Maybe<Array<Maybe<Order>>>;
  updatePartnerCurrencyConversionRate: Maybe<PartnerCurrencyPreference>;
  updatePartnerItemPaymentChannelData: Maybe<UpdatePartnerItemPaymentChannelResponse>;
  updatePartnerLocalCurrencyConversionRate: Maybe<Scalars['Boolean']>;
  updatePassword: User;
  updatePayloadLockedDocument: Maybe<PayloadLockedDocument>;
  updatePayloadPreference: Maybe<PayloadPreference>;
  /** Update a config for an existing payment method */
  updatePaymentMethodConfig: PaymentMethodConfig;
  updatePerson: Person;
  /** Create a new prize list */
  updatePrizeList: PrizeList;
  updateProductCodes: Maybe<Array<Maybe<Product>>>;
  updateProducts: Maybe<Array<Maybe<Product>>>;
  /** update existing public server */
  updatePublicServer: PublicGameServer;
  /** Update a purchase transaction's status and/or notes */
  updatePurchaseTransaction: Account;
  /** Update the result for a participant in a given Challenge */
  updateResultForChallengeId: Scalars['Int'];
  /** Update the result for a participant in a given round */
  updateResultForRoundId: Scalars['Int'];
  /** Update a SubscriptionType */
  updateSubscriptionType: SubscriptionType;
  updateTeam: Team;
  /** Update Team event */
  updateTournament: Competition;
  uploadDraftProducts: Maybe<Array<Maybe<Product>>>;
  uploadOrderFields: Maybe<Array<Maybe<Product>>>;
  validateBulkEmails: Scalars['Boolean'];
  verifyEmailCmsUser: Maybe<Scalars['Boolean']>;
  /** Update the result for a participant in a given match */
  verifyManuallyVerifiedResult: Scalars['Int'];
};


/** root */
export type MutationAcceptAllGroupInvitationsArgs = {
  accountId: Scalars['String'];
};


/** root */
export type MutationAcceptGroupInvitationArgs = {
  accountId: Scalars['String'];
  groupId: Scalars['String'];
};


/** root */
export type MutationAddAutomaticallyVerifiedResultForRoundIdArgs = {
  accountId: Scalars['String'];
  automaticallyVerifiedResultsForRoundFromParticipant: AutomaticallyVerifiedResultsForRoundFromParticipantInput;
};


/** root */
export type MutationAddClientNotificationsArgs = {
  clientNotificationsCreationRequests: Array<ClientNotificationCreationRequest>;
};


/** root */
export type MutationAddEventTeamInviteCodeArgs = {
  eventId: Scalars['String'];
  teamId: Scalars['String'];
  userId: Scalars['String'];
};


/** root */
export type MutationAddGameToGameAccountArgs = {
  gameAccountTypeId: Scalars['String'];
  gameId: Scalars['String'];
  personId: Scalars['String'];
};


/** root */
export type MutationAddIndividualParticipantArgs = {
  joinEventRequest: JoinIndividualEventRequest;
};


/** root */
export type MutationAddInviteCodeArgs = {
  accountId: Scalars['String'];
  groupId: Scalars['String'];
};


/** root */
export type MutationAddMultiDimensionalBucketBasedResultForVerificationArgs = {
  manuallyVerifiedResultWithMultiDimensionalBucketBasedResultRequest: ManuallyVerifiedResultWithMultiDimensionalBucketBasedResultRequest;
};


/** root */
export type MutationAddNotificationsArgs = {
  notificationsForPersonIdCreationRequests: Array<NotificationsForPersonIdCreationRequest>;
};


/** root */
export type MutationAddSltAccountArgs = {
  accountId: Scalars['String'];
  sltAccountCreationRequest: SltAccountCreationRequest;
};


/** root */
export type MutationAddTeamParticipantArgs = {
  joinEventRequest: JoinTeamEventRequest;
};


/** root */
export type MutationAddToEventTeamArgs = {
  eventId: Scalars['String'];
  teamId: Scalars['String'];
  userId: Scalars['String'];
};


/** root */
export type MutationAdvancePhasedCompetitionArgs = {
  competitionId: Scalars['String'];
  manualPairings?: InputMaybe<Array<Array<Scalars['String']>>>;
};


/** root */
export type MutationCancelEventsArgs = {
  eventIds: Array<Scalars['String']>;
};


/** root */
export type MutationCancelPendingSubscriptionArgs = {
  accountId: Scalars['String'];
  subscriptionId: Scalars['String'];
};


/** root */
export type MutationCancelScheduledSubscriptionArgs = {
  accountId: Scalars['String'];
  subscriptionTypeCostId: Scalars['String'];
};


/** root */
export type MutationCheckHealthArgs = {
  supplierId: Scalars['ID'];
};


/** root */
export type MutationCompleteCompetitionArgs = {
  competitionId: Scalars['String'];
};


/** root */
export type MutationCompletePayoutRequestArgs = {
  swarmioCurrencyPayoutRequestId: Scalars['String'];
};


/** root */
export type MutationConfirmParticipantArgs = {
  accountId: Scalars['String'];
  eventId: Scalars['String'];
};


/** root */
export type MutationCreateApplicationConfigArgs = {
  applicationConfigCreationRequest: ApplicationConfigCreationRequest;
};


/** root */
export type MutationCreateBannerArgs = {
  bannerCreationRequest: BannerCreationRequest;
};


/** root */
export type MutationCreateCmsBannerArgs = {
  data: MutationCmsBannerInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


/** root */
export type MutationCreateCmsBlogPageArgs = {
  data: MutationCmsBlogPageInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


/** root */
export type MutationCreateCmsBlogPostArgs = {
  data: MutationCmsBlogPostInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


/** root */
export type MutationCreateCmsGameArgs = {
  data: MutationCmsGameInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


/** root */
export type MutationCreateCmsGamerArgs = {
  data: MutationCmsGamerInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


/** root */
export type MutationCreateCmsMediaArgs = {
  data: MutationCmsMediaInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


/** root */
export type MutationCreateCmsUserArgs = {
  data: MutationCmsUserInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


/** root */
export type MutationCreateEmbeddedGameArgs = {
  embeddedGamesCreationRequest: EmbeddedGamesCreationRequest;
};


/** root */
export type MutationCreateEventArgs = {
  createEventRequest: EventCreationRequest;
};


/** root */
export type MutationCreateExchangedTransactionArgs = {
  notes?: InputMaybe<Scalars['String']>;
  ownerId: Scalars['String'];
  swarmioCurrencyExchangeBlockId: Scalars['String'];
};


/** root */
export type MutationCreateFeatureArgs = {
  featureCreationRequest: FeatureCreationRequest;
};


/** root */
export type MutationCreateFreebieTransactionArgs = {
  amount: Scalars['Float'];
  notes?: InputMaybe<Scalars['String']>;
  ownerId: Scalars['String'];
  swarmioCurrencyId: Scalars['String'];
};


/** root */
export type MutationCreateGroupArgs = {
  createGroupRequest: GroupCreationRequest;
};


/** root */
export type MutationCreateNonIntegratedEventsGameArgs = {
  nonIntegratedGameCreationRequest: NonIntegratedGameCreationRequest;
};


/** root */
export type MutationCreateNonIntegratedGameAccountTypeArgs = {
  nonIntegratedGameAccountTypeCreationRequest: NonIntegratedGameAccountTypeCreationRequest;
};


/** root */
export type MutationCreatePayloadLockedDocumentArgs = {
  data: MutationPayloadLockedDocumentInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


/** root */
export type MutationCreatePayloadPreferenceArgs = {
  data: MutationPayloadPreferenceInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


/** root */
export type MutationCreatePaymentMethodConfigArgs = {
  paymentMethodConfigCreationRequest: PaymentMethodConfigCreationRequest;
};


/** root */
export type MutationCreatePrivateServerArgs = {
  serverCreationRequest: PrivateServerCreationRequest;
};


/** root */
export type MutationCreatePrizeListArgs = {
  prizeListCreationRequest: PrizeListCreationRequest;
};


/** root */
export type MutationCreatePublicServerArgs = {
  serverCreationRequest: PublicServerCreationRequest;
};


/** root */
export type MutationCreateSubscriptionTypeArgs = {
  subscriptionTypeCreationRequest: SubscriptionTypeCreationRequest;
};


/** root */
export type MutationCreateSwarmioCurrencyExchangeBlockArgs = {
  active: Scalars['Boolean'];
  amount: Scalars['Float'];
  forSwarmioCurrencyId: Scalars['String'];
  maybeDescription?: InputMaybe<Scalars['String']>;
  maybeName?: InputMaybe<Scalars['String']>;
  thisSwarmioCurrencyId: Scalars['String'];
};


/** root */
export type MutationCreateSwarmioCurrencyItemArgs = {
  amount: Scalars['Float'];
  dealTagline?: InputMaybe<Scalars['String']>;
  maybeName?: InputMaybe<Scalars['String']>;
  swarmioCurrencyId: Scalars['String'];
  swarmioCurrencyItemCostRequests: Array<SwarmioCurrencyItemCostRequest>;
};


/** root */
export type MutationCreateSwarmioCurrencyPayoutArgs = {
  amount: Scalars['Float'];
  maybeName?: InputMaybe<Scalars['String']>;
  swarmioCurrencyId: Scalars['String'];
  swarmioCurrencyPayoutCostRequests: Array<SwarmioCurrencyPayoutCostRequest>;
};


/** root */
export type MutationCreateTeamArgs = {
  createTeamRequest: TeamCreationRequest;
};


/** root */
export type MutationCreateWalletArgs = {
  ownerId: Scalars['String'];
  swarmioCurrencyId: Scalars['String'];
};


/** root */
export type MutationCreateWalletsForUserArgs = {
  ownerId: Scalars['String'];
  swarmioCurrencyIds: Array<Scalars['String']>;
};


/** root */
export type MutationCreateWatchStreamsArgs = {
  createStreamRequest: StreamsCreationRequest;
};


/** root */
export type MutationDeclineAllGroupInvitationsArgs = {
  accountId: Scalars['String'];
};


/** root */
export type MutationDeclineGroupInvitationArgs = {
  accountId: Scalars['String'];
  groupId: Scalars['String'];
};


/** root */
export type MutationDeleteBannerArgs = {
  bannerId: Scalars['String'];
};


/** root */
export type MutationDeleteCmsBannerArgs = {
  id: Scalars['String'];
};


/** root */
export type MutationDeleteCmsBlogPageArgs = {
  id: Scalars['String'];
};


/** root */
export type MutationDeleteCmsBlogPostArgs = {
  id: Scalars['String'];
};


/** root */
export type MutationDeleteCmsGameArgs = {
  id: Scalars['String'];
};


/** root */
export type MutationDeleteCmsGamerArgs = {
  id: Scalars['String'];
};


/** root */
export type MutationDeleteCmsMediaArgs = {
  id: Scalars['String'];
};


/** root */
export type MutationDeleteCmsUserArgs = {
  id: Scalars['String'];
};


/** root */
export type MutationDeleteEmbeddedGameArgs = {
  embeddedGameIds: Array<Scalars['String']>;
};


/** root */
export type MutationDeletePartnerCurrencyPreferenceByIdArgs = {
  currencyPreferenceId: Scalars['ID'];
};


/** root */
export type MutationDeletePayloadLockedDocumentArgs = {
  id: Scalars['String'];
};


/** root */
export type MutationDeletePayloadPreferenceArgs = {
  id: Scalars['String'];
};


/** root */
export type MutationDeletePaymentMethodConfigArgs = {
  paymentMethodConfigId: Scalars['String'];
};


/** root */
export type MutationDeleteProductByIdArgs = {
  productId: Scalars['ID'];
};


/** root */
export type MutationDeleteProductByIDsArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** root */
export type MutationDeleteProductsByFileIdsArgs = {
  fileIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** root */
export type MutationDeletePublicServerArgs = {
  serverIds: Array<Scalars['String']>;
};


/** root */
export type MutationDeleteSupplierArgs = {
  supplierId: Scalars['ID'];
};


/** root */
export type MutationDeleteVoucherByIdArgs = {
  voucherId: Scalars['ID'];
};


/** root */
export type MutationDeleteVoucherByIDsArgs = {
  voucherIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** root */
export type MutationDistributeVoucherArgs = {
  distributionRequest: DistributionRequest;
};


/** root */
export type MutationDuplicateCmsBannerArgs = {
  data: MutationCmsBannerInput;
  id: Scalars['String'];
};


/** root */
export type MutationDuplicateCmsBlogPageArgs = {
  data: MutationCmsBlogPageInput;
  id: Scalars['String'];
};


/** root */
export type MutationDuplicateCmsBlogPostArgs = {
  data: MutationCmsBlogPostInput;
  id: Scalars['String'];
};


/** root */
export type MutationDuplicateCmsGameArgs = {
  data: MutationCmsGameInput;
  id: Scalars['String'];
};


/** root */
export type MutationDuplicateCmsGamerArgs = {
  data: MutationCmsGamerInput;
  id: Scalars['String'];
};


/** root */
export type MutationDuplicateCmsMediaArgs = {
  data: MutationCmsMediaInput;
  id: Scalars['String'];
};


/** root */
export type MutationDuplicatePayloadLockedDocumentArgs = {
  data: MutationPayloadLockedDocumentInput;
  id: Scalars['String'];
};


/** root */
export type MutationDuplicatePayloadPreferenceArgs = {
  data: MutationPayloadPreferenceInput;
  id: Scalars['String'];
};


/** root */
export type MutationEditSwarmioCurrencyItemArgs = {
  dealTagline?: InputMaybe<Scalars['String']>;
  maybeActive?: InputMaybe<Scalars['Boolean']>;
  maybeAmount?: InputMaybe<Scalars['Float']>;
  maybeName?: InputMaybe<Scalars['String']>;
  swarmioCurrencyItemCostRequests: Array<SwarmioCurrencyItemCostRequest>;
  swarmioCurrencyItemId: Scalars['String'];
};


/** root */
export type MutationEnrollExplicitSubscriptionArgs = {
  accountId: Scalars['String'];
  subscriptionTypeCostId: Scalars['String'];
};


/** root */
export type MutationEnrollExternalSubscriptionPackageArgs = {
  accountId: Scalars['String'];
  externalSubscriptionPackageId: Scalars['String'];
};


/** root */
export type MutationExchangeCustomSwarmioCurrencyAmountArgs = {
  amount: Scalars['Float'];
  fromSwarmioCurrencyId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  ownerId: Scalars['String'];
  toSwarmioCurrencyId: Scalars['String'];
};


/** root */
export type MutationExchangeEntireSwarmioCurrencyWalletArgs = {
  toSwarmioCurrencyId: Scalars['String'];
  walletId: Scalars['String'];
};


/** root */
export type MutationForceVerifyPersonEmailArgs = {
  email: Scalars['String'];
};


/** root */
export type MutationForgotPasswordCmsUserArgs = {
  disableEmail?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  expiration?: InputMaybe<Scalars['Int']>;
};


/** root */
export type MutationGenerateIntegratedVouchersArgs = {
  integratedVoucherGenerationRequest: IntegratedVoucherGenerationRequest;
};


/** root */
export type MutationGenerateNonIntegratedVouchersArgs = {
  nonIntegratedVoucherGenerationRequest: NonIntegratedVoucherGenerationRequest;
};


/** root */
export type MutationHardRefreshSubscriptionsForAccountIdArgs = {
  accountId: Scalars['String'];
};


/** root */
export type MutationInviteToGroupArgs = {
  accountId: Scalars['String'];
  groupId: Scalars['String'];
  roleAlias?: InputMaybe<Scalars['String']>;
};


/** root */
export type MutationJoinEventByInviteArgs = {
  inviteCode: Scalars['String'];
  userId: Scalars['String'];
};


/** root */
export type MutationJoinGroupTraitByInviteArgs = {
  accountId: Scalars['String'];
  code: Scalars['String'];
};


/** root */
export type MutationLeaveEventTeamArgs = {
  eventId: Scalars['String'];
  teamId: Scalars['String'];
  userId: Scalars['String'];
};


/** root */
export type MutationLinkNonIntegratedGameAccountArgs = {
  gameAccountId?: InputMaybe<Scalars['String']>;
  gameAccountName?: InputMaybe<Scalars['String']>;
  gameAccountTypeId: Scalars['String'];
  personId: Scalars['String'];
};


/** root */
export type MutationLoginCmsUserArgs = {
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
};


/** root */
export type MutationManuallyPairLatestCompetitionPhaseArgs = {
  competitionId: Scalars['String'];
  manualPairings: Array<Array<Scalars['String']>>;
};


/** root */
export type MutationMarkNotificationsAsReadArgs = {
  accountId: Scalars['String'];
  notificationIds: Array<Scalars['String']>;
};


/** root */
export type MutationMultipleSwarmioCurrencyTransfersArgs = {
  fromWalletId: Scalars['String'];
  transferTransactionRequests: Array<TransferTransactionRequest>;
};


/** root */
export type MutationOverridePspMarkedUpPercentageArgs = {
  itemId: Scalars['ID'];
  markedUpPercentageForPsp?: InputMaybe<Scalars['Float']>;
  partnerId: Scalars['ID'];
};


/** root */
export type MutationPartnerItemFinalPriceOverrideArgs = {
  finalPriceOverrideDataList?: InputMaybe<Array<InputMaybe<FinalPriceOverrideData>>>;
  itemId: Scalars['ID'];
  partnerId: Scalars['ID'];
};


/** root */
export type MutationPaySubscriptionWithSwarmioArgs = {
  subscriptionId: Scalars['String'];
};


/** root */
export type MutationPayoutEventPrizesArgs = {
  eventId: Scalars['String'];
};


/** root */
export type MutationProcessCsvFileArgs = {
  fileId: Scalars['ID'];
};


/** root */
export type MutationProcessOrderFieldsCsvFileArgs = {
  fileId: Scalars['ID'];
};


/** root */
export type MutationPromoteToGroupAdminArgs = {
  accountId: Scalars['String'];
  groupId: Scalars['String'];
  roleAlias?: InputMaybe<Scalars['String']>;
};


/** root */
export type MutationPurchaseExternalItemArgs = {
  country?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Scalars['String']>;
  gamerAddress?: InputMaybe<Scalars['String']>;
  gamerEmail: Scalars['String'];
  gamerFirstName?: InputMaybe<Scalars['String']>;
  gamerIPAddress?: InputMaybe<Scalars['String']>;
  gamerId?: InputMaybe<Scalars['String']>;
  gamerLastName?: InputMaybe<Scalars['String']>;
  gamerMobileNumber?: InputMaybe<Scalars['String']>;
  itemId: Scalars['String'];
  maxitJWT?: InputMaybe<Scalars['String']>;
  maybePosthogId?: InputMaybe<Scalars['String']>;
  merchantPaymentMethodId: Scalars['String'];
  merchantPaymentMethodType: Scalars['String'];
  quantity: Scalars['Int'];
  tagId: Scalars['String'];
};


/** root */
export type MutationPurchaseExternalItemWithPointsArgs = {
  country?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Scalars['String']>;
  gamerAddress?: InputMaybe<Scalars['String']>;
  gamerEmail?: InputMaybe<Scalars['String']>;
  gamerFirstName?: InputMaybe<Scalars['String']>;
  gamerIPAddress?: InputMaybe<Scalars['String']>;
  gamerId?: InputMaybe<Scalars['String']>;
  gamerLastName?: InputMaybe<Scalars['String']>;
  gamerMobileNumber?: InputMaybe<Scalars['String']>;
  itemId: Scalars['String'];
  maybePosthogId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  tagId: Scalars['String'];
};


/** root */
export type MutationPurchaseItemArgs = {
  purchase: PurchaseItemInput;
};


/** root */
export type MutationPurchaseSwarmioCurrencyItemArgs = {
  maybeCustomerName?: InputMaybe<Scalars['String']>;
  maybeEmail?: InputMaybe<Scalars['String']>;
  paymentType: PaymentType;
  swarmioCurrencyItemCostId: Scalars['String'];
};


/** root */
export type MutationPurchaseTagIdRegistrationArgs = {
  purchaseTagIdRegistrationInput: PurchaseTagIdRegistrationInput;
};


/** root */
export type MutationReadyIndividualParticipantArgs = {
  accountId: Scalars['String'];
  additionalInformation?: InputMaybe<Array<AdditionalInformationInput>>;
  eventId: Scalars['String'];
  gameAccountId: Scalars['String'];
};


/** root */
export type MutationRedeemVoucherArgs = {
  redeemVoucherRequest: RedeemVoucherRequest;
};


/** root */
export type MutationRefreshLadderCompetitionResultsArgs = {
  competitionId: Scalars['String'];
};


/** root */
export type MutationRefreshRiotAccountArgs = {
  gameAccountId: Scalars['String'];
};


/** root */
export type MutationRefreshWatchStreamsArgs = {
  streamsType: StreamType;
};


/** root */
export type MutationRegisterInternalServiceArgs = {
  internalCreationRequest: InternalServiceCreationRequest;
};


/** root */
export type MutationRegisterPersonArgs = {
  acceptTerms: Scalars['Boolean'];
  meta?: InputMaybe<RegistrationMeta>;
  personCreationRequest: DefaultPersonCreationRequest;
};


/** root */
export type MutationRegisterPersonEmailArgs = {
  email: Scalars['String'];
  meta?: InputMaybe<RegistrationMeta>;
};


/** root */
export type MutationRegisterPersonMsisdnArgs = {
  MSISDN: Scalars['String'];
  meta?: InputMaybe<RegistrationMeta>;
};


/** root */
export type MutationRemoveFromEventTeamArgs = {
  eventId: Scalars['String'];
  teamId: Scalars['String'];
  userId: Scalars['String'];
};


/** root */
export type MutationRemoveMemberFromGroupArgs = {
  accountId: Scalars['String'];
  groupId: Scalars['String'];
};


/** root */
export type MutationRemoveParticipantArgs = {
  leaveEventRequest: LeaveEventRequest;
};


/** root */
export type MutationRemoveRolesFromGroupMemberArgs = {
  accountId: Scalars['String'];
  groupId: Scalars['String'];
  roleIds: Array<Scalars['String']>;
};


/** root */
export type MutationRemoveSubscriptionProviderAccountArgs = {
  accountId: Scalars['String'];
  subscriptionProvider: SubscriptionProvider;
};


/** root */
export type MutationRemoveWatchStreamArgs = {
  ids: Array<Scalars['String']>;
};


/** root */
export type MutationReplaceGroupOwnerArgs = {
  accountId: Scalars['String'];
  groupId: Scalars['String'];
  ownerId: Scalars['String'];
  roleAlias?: InputMaybe<Scalars['String']>;
};


/** root */
export type MutationRequestCustomPayoutArgs = {
  amount: Scalars['Float'];
  notes?: InputMaybe<Scalars['String']>;
  toOwnerId: Scalars['String'];
};


/** root */
export type MutationRequestPayoutArgs = {
  notes?: InputMaybe<Scalars['String']>;
  ownerId: Scalars['String'];
  swarmioCurrencyPayoutCostId: Scalars['String'];
};


/** root */
export type MutationRequestVoucherForRecipientArgs = {
  requestVoucherForRecipientRequest: RequestVoucherForRecipientRequest;
};


/** root */
export type MutationResendVerificationEmailArgs = {
  userId: Scalars['String'];
};


/** root */
export type MutationResendVerificationSmsArgs = {
  userId: Scalars['String'];
};


/** root */
export type MutationResetLocalConversionRateArgs = {
  itemId: Scalars['ID'];
  partnerId: Scalars['ID'];
};


/** root */
export type MutationResetMarkedUpPriceArgs = {
  itemId: Scalars['ID'];
  partnerId: Scalars['ID'];
};


/** root */
export type MutationResetOverriddenFinalPriceArgs = {
  itemId: Scalars['ID'];
  partnerId: Scalars['ID'];
  paymentChannelId: Scalars['ID'];
  sourceCurrency: Scalars['String'];
  targetCurrency: Scalars['String'];
};


/** root */
export type MutationResetOverrideCurrencyMarkedUpPercentageArgs = {
  itemId?: InputMaybe<Scalars['ID']>;
  partnerId: Scalars['ID'];
};


/** root */
export type MutationResetOverrideFinalPriceArgs = {
  itemId: Scalars['ID'];
  partnerId: Scalars['ID'];
  paymentMethod: Scalars['String'];
  sourceCurrency: Scalars['String'];
  targetCurrency: Scalars['String'];
};


/** root */
export type MutationResetOverridePointsMarkedUpPercentageArgs = {
  itemId?: InputMaybe<Scalars['ID']>;
  partnerId: Scalars['ID'];
};


/** root */
export type MutationResetOverridePspMarkedUpPercentageArgs = {
  itemId?: InputMaybe<Scalars['ID']>;
  partnerId: Scalars['ID'];
};


/** root */
export type MutationResetOverrideRateArgs = {
  conversion?: InputMaybe<ItemPartnerCurrencyConversionsInput>;
  itemId?: InputMaybe<Scalars['ID']>;
  partnerId: Scalars['ID'];
};


/** root */
export type MutationResetPartnerItemMarkedUpPercentageArgs = {
  itemId: Scalars['ID'];
  partnerId: Scalars['ID'];
  paymentChannelId: Scalars['ID'];
};


/** root */
export type MutationResetPartnerPaymentChannelMarkedUpPercentageArgs = {
  partnerId: Scalars['ID'];
  paymentChannelId: Scalars['ID'];
};


/** root */
export type MutationResetPasswordArgs = {
  ContactIdentifier: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};


/** root */
export type MutationResetPasswordCmsUserArgs = {
  password?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


/** root */
export type MutationResetPasswordRequestArgs = {
  ContactIdentifier: Scalars['String'];
};


/** root */
export type MutationResetPasswordRequestWithSpecialEmailArgs = {
  ContactIdentifier: Scalars['String'];
};


/** root */
export type MutationRetryFailedTransactionArgs = {
  failedOrderId: Scalars['ID'];
};


/** root */
export type MutationSaveCsvFileArgs = {
  fileName?: InputMaybe<Scalars['String']>;
  fileUploadType?: InputMaybe<FileUploadType>;
  fileUrl?: InputMaybe<Scalars['String']>;
  supplierId: Scalars['ID'];
};


/** root */
export type MutationSaveCategoryArgs = {
  category: CategoryInput;
};


/** root */
export type MutationSaveCategoryLanguageDataArgs = {
  categoryLanguageDataInput: CategoryLanguageDataInput;
};


/** root */
export type MutationSaveDealArgs = {
  dealInput: DealInput;
};


/** root */
export type MutationSaveGlobalPointsArgs = {
  globalPoints: PointsInput;
};


/** root */
export type MutationSaveItemArgs = {
  item: ItemInput;
};


/** root */
export type MutationSaveItemLanguageDataArgs = {
  itemLanguageDataInput: ItemLanguageDataInput;
};


/** root */
export type MutationSaveItemPartnerCurrencyConversionsArgs = {
  conversions: Array<InputMaybe<ItemPartnerCurrencyConversionsInput>>;
  itemId: Scalars['ID'];
  partnerId: Scalars['ID'];
};


/** root */
export type MutationSaveItemPointsArgs = {
  itemPoints: ItemPointsInput;
};


/** root */
export type MutationSavePartnerCurrencyPreferencesArgs = {
  currencies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partnerId: Scalars['ID'];
};


/** root */
export type MutationSavePartnerPaymentChannelDataArgs = {
  partnerPaymentChannelDataInput?: InputMaybe<PartnerPaymentChannelDataInput>;
};


/** root */
export type MutationSavePaymentChannelArgs = {
  paymentChannel?: InputMaybe<PaymentChannelInput>;
};


/** root */
export type MutationSaveProductGroupArgs = {
  productGroup?: InputMaybe<ProductGroupInput>;
};


/** root */
export type MutationSaveProductGroupLanguageDataArgs = {
  productGroupLanguageDataInput: ProductGroupLanguageDataInput;
};


/** root */
export type MutationSaveSupplierArgs = {
  supplier: SupplierInput;
};


/** root */
export type MutationSendTemplateEmailArgs = {
  argumentsJson: Scalars['String'];
  templateId: Scalars['String'];
  userId: Scalars['String'];
};


/** root */
export type MutationTransferAllWalletsArgs = {
  notes?: InputMaybe<Scalars['String']>;
  ownerId: Scalars['String'];
  toOwnerId: Scalars['String'];
};


/** root */
export type MutationTransferSwarmioCurrencyArgs = {
  amount: Scalars['Float'];
  fromWalletId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  toOwnerId: Scalars['String'];
};


/** root */
export type MutationUndoLastAdvanceArgs = {
  competitionId: Scalars['String'];
};


/** root */
export type MutationUnenrollExternalSubscriptionPackageArgs = {
  accountId: Scalars['String'];
  externalSubscriptionPackageId: Scalars['String'];
};


/** root */
export type MutationUnlinkGameAccountArgs = {
  gameAccountId: Scalars['String'];
};


/** root */
export type MutationUnlinkIdentityProviderArgs = {
  IdentityProviderType: IdentityProviderType;
  userId: Scalars['String'];
};


/** root */
export type MutationUnlinkIdentityProviderByEmailArgs = {
  email: Scalars['String'];
};


/** root */
export type MutationUnlockCmsUserArgs = {
  email: Scalars['String'];
};


/** root */
export type MutationUpdateApplicationConfigArgs = {
  applicationConfigId: Scalars['String'];
  applicationConfigUpdateRequest: ApplicationConfigUpdateRequest;
};


/** root */
export type MutationUpdateBannerArgs = {
  bannerId: Scalars['String'];
  bannerUpdateRequest: BannerUpdateRequest;
};


/** root */
export type MutationUpdateCatalogArgs = {
  catalogInput: CatalogInput;
};


/** root */
export type MutationUpdateCategoryListArgs = {
  categoryIds: Array<InputMaybe<Scalars['ID']>>;
  categoryListInput: CategoryListInput;
};


/** root */
export type MutationUpdateChallengeArgs = {
  challengeUpdateRequest: SingleChallengeUpdateRequest;
  competitionId: Scalars['String'];
};


/** root */
export type MutationUpdateCmsBannerArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationCmsBannerUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type MutationUpdateCmsBlogPageArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationCmsBlogPageUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type MutationUpdateCmsBlogPostArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationCmsBlogPostUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type MutationUpdateCmsGameArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationCmsGameUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type MutationUpdateCmsGamerArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationCmsGamerUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type MutationUpdateCmsMediaArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationCmsMediaUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type MutationUpdateCmsUserArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationCmsUserUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type MutationUpdateDisabledPaymentChannelsArgs = {
  updateDisabledPaymentChannelInput?: InputMaybe<UpdateDisabledPaymentChannelInput>;
};


/** root */
export type MutationUpdateEmbeddedGameArgs = {
  embeddedGameId: Scalars['String'];
  embeddedGamesUpdateRequest: EmbeddedGamesUpdateRequest;
};


/** root */
export type MutationUpdateEventArgs = {
  eventId: Scalars['String'];
  updateEventRequest: EventUpdateRequest;
};


/** root */
export type MutationUpdateEventStageArgs = {
  eventStageId: Scalars['String'];
  updateEventStageRequest: EventStageUpdateRequest;
};


/** root */
export type MutationUpdateEventsGameArgs = {
  gameId: Scalars['String'];
  gameUpdateRequest: GameUpdateRequest;
};


/** root */
export type MutationUpdateFeatureArgs = {
  featureId: Scalars['String'];
  featureUpdateRequest: FeatureUpdateRequest;
};


/** root */
export type MutationUpdateGameAccountTypeArgs = {
  gameAccountTypeId: Scalars['String'];
  gameAccountTypeUpdateRequest: GameAccountTypeUpdateRequest;
};


/** root */
export type MutationUpdateGroupArgs = {
  id: Scalars['String'];
  updateGroupRequest: GroupUpdateRequest;
};


/** root */
export type MutationUpdateInternalServiceArgs = {
  id: Scalars['String'];
  internalUpdateRequest: InternalServiceUpdateRequest;
};


/** root */
export type MutationUpdateItemListArgs = {
  itemListInput?: InputMaybe<Array<ItemListInput>>;
};


/** root */
export type MutationUpdateManualGameAccountArgs = {
  gameAccountId: Scalars['String'];
  gameAccountUpdateRequest: GameAccountUpdateRequest;
};


/** root */
export type MutationUpdateMatchUpArgs = {
  competitionId: Scalars['String'];
  matchUpUpdateRequest: SingleMatchUpUpdateRequest;
};


/** root */
export type MutationUpdateOrderListArgs = {
  orderIds: Array<InputMaybe<Scalars['ID']>>;
  orderListInput: OrderListInput;
};


/** root */
export type MutationUpdatePartnerCurrencyConversionRateArgs = {
  currencyPreference?: InputMaybe<PartnerCurrencyPreferenceInput>;
  partnerId: Scalars['ID'];
};


/** root */
export type MutationUpdatePartnerItemPaymentChannelDataArgs = {
  updatePartnerItemPaymentChannelInput: UpdatePartnerItemPaymentChannelInput;
};


/** root */
export type MutationUpdatePartnerLocalCurrencyConversionRateArgs = {
  localCurrencyConversion?: InputMaybe<PartnerLocalCurrencyConversionInput>;
  partnerId: Scalars['ID'];
};


/** root */
export type MutationUpdatePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
  userId: Scalars['String'];
};


/** root */
export type MutationUpdatePayloadLockedDocumentArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationPayloadLockedDocumentUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type MutationUpdatePayloadPreferenceArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationPayloadPreferenceUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type MutationUpdatePaymentMethodConfigArgs = {
  paymentMethodConfigId: Scalars['String'];
  paymentMethodConfigUpdateRequest: PaymentMethodConfigUpdateRequest;
};


/** root */
export type MutationUpdatePersonArgs = {
  id: Scalars['String'];
  personUpdateRequest: PersonUpdateRequest;
};


/** root */
export type MutationUpdatePrizeListArgs = {
  prizeListId: Scalars['String'];
  prizeListUpdateRequest: PrizeListUpdateRequest;
};


/** root */
export type MutationUpdateProductCodesArgs = {
  productCodes: Array<InputMaybe<ProductCode>>;
  supplierId: Scalars['ID'];
};


/** root */
export type MutationUpdateProductsArgs = {
  productType: ProductType;
  supplierId: Scalars['ID'];
};


/** root */
export type MutationUpdatePublicServerArgs = {
  serverId: Scalars['String'];
  serverUpdateRequest: PublicServerUpdateRequest;
};


/** root */
export type MutationUpdatePurchaseTransactionArgs = {
  notes?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
  transactionStatus?: InputMaybe<PurchaseTransactionStatus>;
};


/** root */
export type MutationUpdateResultForChallengeIdArgs = {
  challengeId: Scalars['String'];
  participantBasicResultSubmissions: Array<ParticipantBasicResultSubmission>;
};


/** root */
export type MutationUpdateResultForRoundIdArgs = {
  participantId: Scalars['String'];
  placement?: InputMaybe<Scalars['Int']>;
  roundId: Scalars['String'];
  score?: InputMaybe<Scalars['Float']>;
  showed?: InputMaybe<Scalars['Boolean']>;
};


/** root */
export type MutationUpdateSubscriptionTypeArgs = {
  subscriptionTypeId: Scalars['String'];
  subscriptionTypeUpdateRequest: SubscriptionTypeUpdateRequest;
};


/** root */
export type MutationUpdateTeamArgs = {
  id: Scalars['String'];
  updateTeamRequest: TeamUpdateRequest;
};


/** root */
export type MutationUpdateTournamentArgs = {
  competitionId: Scalars['String'];
  tournamentUpdateRequest: SingleTournamentUpdateRequest;
};


/** root */
export type MutationUploadDraftProductsArgs = {
  fileId: Scalars['ID'];
};


/** root */
export type MutationUploadOrderFieldsArgs = {
  fileId: Scalars['ID'];
};


/** root */
export type MutationValidateBulkEmailsArgs = {
  emails: Array<Scalars['String']>;
};


/** root */
export type MutationVerifyEmailCmsUserArgs = {
  token?: InputMaybe<Scalars['String']>;
};


/** root */
export type MutationVerifyManuallyVerifiedResultArgs = {
  manuallyVerifiedResultId: Scalars['String'];
};

export type NewHiveContact = HiveContact & HiveContactWithPossibleError & WithUnverifiedHiveContact & {
  __typename: 'NewHiveContact';
  contact: Scalars['String'];
  contactType: HiveContactType;
  isError: Scalars['Boolean'];
  newContact: Scalars['String'];
  verified: Scalars['Boolean'];
};

export type NonIntegratedGameAccountTypeCreationRequest = {
  accountIDLabel?: InputMaybe<Scalars['String']>;
  accountNameLabel?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  implicitGameIds?: InputMaybe<Array<Scalars['String']>>;
  prettyName: Scalars['String'];
  requiresExternalAccountId: Scalars['Boolean'];
  requiresExternalAccountName: Scalars['Boolean'];
  unlisted: Scalars['Boolean'];
};

export type NonIntegratedGameCreationRequest = {
  bufferTimeInSeconds: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  estimatedRoundLengthInSeconds: Scalars['Int'];
  gameAccountTypeIds: Array<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  maxParticipantsPerRound?: InputMaybe<Scalars['Float']>;
  prettyName: Scalars['String'];
  supportedCompetitionFormats: Array<CompetitionFormat>;
  supportedParticipantTypes: Array<ParticipantType>;
  typicalPlacingStrategyForRounds: PlacingStrategy;
  weight: Scalars['Float'];
};

export type NonIntegratedVoucher = SwarmioVoucher & {
  __typename: 'NonIntegratedVoucher';
  code: Scalars['String'];
  distributionInfo: DistributionInfo;
  expirationDate: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  issueDate: Scalars['Date'];
  voucherType: VoucherType;
  whatYouGet: Scalars['String'];
};

export type NonIntegratedVoucherGenerationRequest = {
  distributionChannel: DistributionChannel;
  expirationDate?: InputMaybe<Scalars['Date']>;
  numberOfCodesToGenerate: Scalars['Int'];
  whatYouGet: Scalars['String'];
};

export type NotEnoughTeamMembers = MissingParticipantRequirement & {
  __typename: 'NotEnoughTeamMembers';
  entryName: Scalars['String'];
  needsMore: Scalars['Int'];
};

export type NotificationCreationRequest = {
  defaultMessage: Scalars['String'];
  expiry?: InputMaybe<Scalars['Date']>;
  fields?: InputMaybe<Scalars['JsonObject']>;
  notificationType: Scalars['String'];
};

export type NotificationsForPersonIdCreationRequest = {
  notifications: Array<NotificationCreationRequest>;
  personId: Scalars['String'];
};

/** Generic object interface */
export type ObjectRepresentation = {
  id: Scalars['String'];
};

export type Order = {
  __typename: 'Order';
  billingAddress: Maybe<Scalars['String']>;
  cancellationNote: Maybe<Scalars['String']>;
  contentType: Maybe<ContentType>;
  createdBy: Maybe<Scalars['Int']>;
  createdDate: Maybe<Scalars['String']>;
  dealId: Maybe<Scalars['Int']>;
  dealPercentage: Maybe<Scalars['Float']>;
  dealValue: Maybe<Scalars['Float']>;
  formattedItemId: Maybe<Scalars['String']>;
  gamerEmail: Maybe<Scalars['String']>;
  gamerId: Maybe<Scalars['String']>;
  gamerName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  item: Maybe<Item>;
  itemName: Maybe<Scalars['String']>;
  markedUpPrice: Maybe<Scalars['Float']>;
  modifiedBy: Maybe<Scalars['Int']>;
  modifiedDate: Maybe<Scalars['String']>;
  orderDate: Maybe<Scalars['String']>;
  orderId: Maybe<Scalars['String']>;
  orderStatus: Maybe<OrderStatus>;
  orderTransaction: Maybe<OrderTransaction>;
  partner: Maybe<Partner>;
  payment: Maybe<Payment>;
  pointsValue: Maybe<Scalars['Float']>;
  purchaseMedium: Maybe<Scalars['String']>;
  purchasePaymentChannelName: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['Int']>;
  retriedTransactionId: Maybe<Scalars['String']>;
  shipment: Maybe<Shipment>;
  targetCurrency: Maybe<Scalars['String']>;
  totalPoints: Maybe<Scalars['Float']>;
  transaction: Maybe<Scalars['Object']>;
  transactionId: Maybe<Scalars['String']>;
  vouchers: Maybe<Array<Maybe<ProductVoucher>>>;
};

export type OrderFieldsProduct = {
  __typename: 'OrderFieldsProduct';
  isProductAvailable: Maybe<Scalars['Boolean']>;
  productCode: Maybe<Scalars['String']>;
  productName: Maybe<Scalars['String']>;
};

export type OrderFilterInput = {
  dateEndTimeMillis?: InputMaybe<Scalars['Float']>;
  dateStartTimeMillis?: InputMaybe<Scalars['Float']>;
  itemStatus?: InputMaybe<ItemStatus>;
  orderStatus?: InputMaybe<OrderStatus>;
  partners?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type OrderListInput = {
  cancellationNote?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<OrderStatus>;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED'
}

/** OrderStrategy name */
export enum OrderStrategy {
  /** ALLSERV_API_TOPUP */
  AllservApiTopup = 'ALLSERV_API_TOPUP',
  /** ALLSERV_EPIN_API */
  AllservEpinApi = 'ALLSERV_EPIN_API',
  /** BUKALAPAK_API_TOPUP */
  BukalapakApiTopup = 'BUKALAPAK_API_TOPUP',
  /** BUKALAPAK_API_VOUCHER */
  BukalapakApiVoucher = 'BUKALAPAK_API_VOUCHER',
  /** CSV_VOUCHERS */
  CsvVouchers = 'CSV_VOUCHERS',
  /** SEAGM_API_VOUCHERS */
  SeagmApiVouchers = 'SEAGM_API_VOUCHERS',
  /** UNIPIN_API_TOPUP */
  UnipinApiTopup = 'UNIPIN_API_TOPUP',
  /** UNIPIN_API_VOUCHER */
  UnipinApiVoucher = 'UNIPIN_API_VOUCHER'
}

export type OrderTransaction = {
  __typename: 'OrderTransaction';
  id: Maybe<Scalars['ID']>;
  productRedemptionInstructions: Maybe<Scalars['String']>;
  transactionId: Maybe<Scalars['ID']>;
  voucherQuantity: Maybe<Scalars['Int']>;
  vouchers: Maybe<Array<Maybe<Voucher>>>;
};

/** Matches out of the context of their phase and bracket */
export type OutOfContextCompetitionMatches = {
  competitionId: Scalars['String'];
  competitionType: Scalars['String'];
  isSimulated: Scalars['Boolean'];
  matches: Array<CompetitionMatch>;
};

export type OutOfContextMatchUpMatches = OutOfContextCompetitionMatches & {
  __typename: 'OutOfContextMatchUpMatches';
  competitionId: Scalars['String'];
  competitionType: Scalars['String'];
  isSimulated: Scalars['Boolean'];
  matches: Array<CompetitionMatch>;
};

export type OutOfContextPurchaseTransaction = {
  __typename: 'OutOfContextPurchaseTransaction';
  account: Account;
  accountId: Scalars['String'];
  created: Scalars['Date'];
  fields: Scalars['String'];
  itemId: Scalars['String'];
  order: RootCode_Order;
  purchaseTransactionId: Scalars['String'];
  status: PurchaseTransactionStatus;
};

export type OutOfContextTournamentMatches = OutOfContextCompetitionMatches & {
  __typename: 'OutOfContextTournamentMatches';
  competitionId: Scalars['String'];
  competitionType: Scalars['String'];
  isSimulated: Scalars['Boolean'];
  matches: Array<CompetitionMatch>;
};

export type PaginatedBoughtTransaction = {
  __typename: 'PaginatedBoughtTransaction';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<BoughtTransaction>;
  totalCount: Scalars['Int'];
};

export type PaginatedCsvFiles = {
  __typename: 'PaginatedCSVFiles';
  currentPage: Maybe<Scalars['Int']>;
  files: Maybe<Array<Maybe<CsvFile>>>;
  totalFiles: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
};

export type PaginatedCashOutTransaction = {
  __typename: 'PaginatedCashOutTransaction';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<CashOutTransaction>;
  totalCount: Scalars['Int'];
};

export type PaginatedCatalogItems = {
  __typename: 'PaginatedCatalogItems';
  currentPage: Maybe<Scalars['Int']>;
  items: Maybe<Array<Maybe<CatalogItem>>>;
  totalItems: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
};

export type PaginatedCategoryLanguage = {
  __typename: 'PaginatedCategoryLanguage';
  categories: Maybe<Array<Maybe<CategoryLanguage>>>;
  currentPage: Maybe<Scalars['Int']>;
  totalCategories: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
};

export type PaginatedCategoryProductGroups = {
  __typename: 'PaginatedCategoryProductGroups';
  categoryCoverImage: Maybe<Scalars['String']>;
  categoryDescription: Maybe<Scalars['String']>;
  categoryIcon: Maybe<Scalars['String']>;
  categoryId: Maybe<Scalars['String']>;
  categoryImage: Maybe<Scalars['String']>;
  categoryName: Maybe<Scalars['String']>;
  currentPage: Maybe<Scalars['Int']>;
  featured: Maybe<Scalars['Boolean']>;
  productGroups: Maybe<Array<Maybe<CategoryProductGroupResponse>>>;
  totalPages: Maybe<Scalars['Int']>;
  totalProductGroups: Maybe<Scalars['Int']>;
  urlMask: Maybe<Scalars['String']>;
};

export type PaginatedDeal = {
  __typename: 'PaginatedDeal';
  currentPage: Maybe<Scalars['Int']>;
  deals: Maybe<Array<Maybe<DealDto>>>;
  totalDeals: Maybe<Scalars['Int']>;
  totalEndedDeals: Maybe<Scalars['Int']>;
  totalFilteredDeals: Maybe<Scalars['Int']>;
  totalOngoingDeals: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
  totalScheduledDeals: Maybe<Scalars['Int']>;
};

export type PaginatedEmbeddedGame = {
  __typename: 'PaginatedEmbeddedGame';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<EmbeddedGame>;
  totalCount: Scalars['Int'];
};

export type PaginatedEvent = {
  __typename: 'PaginatedEvent';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<Event>;
  totalCount: Scalars['Int'];
};

export type PaginatedExchangedTransaction = {
  __typename: 'PaginatedExchangedTransaction';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<ExchangedTransaction>;
  totalCount: Scalars['Int'];
};

export type PaginatedFailedOrderTransaction = {
  __typename: 'PaginatedFailedOrderTransaction';
  currentPage: Maybe<Scalars['Int']>;
  failedTransactions: Maybe<Array<Maybe<FailedOrderTransaction>>>;
  totalFailedTransactions: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
  totalRetriedSuccessOrders: Maybe<Scalars['Int']>;
};

export type PaginatedFreebieTransaction = {
  __typename: 'PaginatedFreebieTransaction';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<FreebieTransaction>;
  totalCount: Scalars['Int'];
};

export type PaginatedItems = {
  __typename: 'PaginatedItems';
  currentPage: Maybe<Scalars['Int']>;
  items: Maybe<Array<Maybe<Item>>>;
  totalCreatedItems: Maybe<Scalars['Int']>;
  totalItemStatusCount: Maybe<Scalars['Int']>;
  totalItems: Maybe<Scalars['Int']>;
  totalLiveItems: Maybe<Scalars['Int']>;
  totalLiveReadyItems: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
  totalRemovedItems: Maybe<Scalars['Int']>;
  totalTrashedItems: Maybe<Scalars['Int']>;
  totalValidatedItems: Maybe<Scalars['Int']>;
};

export type PaginatedOrder = {
  __typename: 'PaginatedOrder';
  currentPage: Maybe<Scalars['Int']>;
  orders: Maybe<Array<Maybe<Order>>>;
  totalCancelledOrders: Maybe<Scalars['Int']>;
  totalCompletedOrders: Maybe<Scalars['Int']>;
  totalDeletedOrders: Maybe<Scalars['Int']>;
  totalOrders: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
  totalProcessingOrders: Maybe<Scalars['Int']>;
  totalRefundedOrders: Maybe<Scalars['Int']>;
};

export type PaginatedPartnerLanguage = {
  __typename: 'PaginatedPartnerLanguage';
  currentPage: Maybe<Scalars['Int']>;
  partners: Maybe<Array<Maybe<PartnerLanguage>>>;
  totalPages: Maybe<Scalars['Int']>;
  totalPartners: Maybe<Scalars['Int']>;
};

export type PaginatedPartnerProductGroups = {
  __typename: 'PaginatedPartnerProductGroups';
  currentPage: Maybe<Scalars['Int']>;
  productGroups: Maybe<Array<Maybe<CategoryProductGroupResponse>>>;
  totalPages: Maybe<Scalars['Int']>;
  totalProductGroups: Maybe<Scalars['Int']>;
};

export type PaginatedPaymentChannel = {
  __typename: 'PaginatedPaymentChannel';
  currentPage: Maybe<Scalars['Int']>;
  paymentChannels: Maybe<Array<Maybe<PaymentChannel>>>;
  totalActivePaymentChannels: Maybe<Scalars['Int']>;
  totalFilteredPaymentChannels: Maybe<Scalars['Int']>;
  totalInactivePaymentChannels: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
  totalPaymentChannels: Maybe<Scalars['Int']>;
};

export type PaginatedProductGroup = {
  __typename: 'PaginatedProductGroup';
  currentPage: Maybe<Scalars['Int']>;
  productGroups: Maybe<Array<Maybe<ProductGroupResponse>>>;
  totalActiveProductGroups: Maybe<Scalars['Int']>;
  totalDeletedProductGroups: Maybe<Scalars['Int']>;
  totalFilteredProductGroups: Maybe<Scalars['Int']>;
  totalInactiveProductGroups: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
  totalProductGroups: Maybe<Scalars['Int']>;
};

export type PaginatedProducts = {
  __typename: 'PaginatedProducts';
  currentPage: Maybe<Scalars['Int']>;
  products: Maybe<Array<Maybe<Product>>>;
  totalPages: Maybe<Scalars['Int']>;
  totalProducts: Maybe<Scalars['Int']>;
};

export type PaginatedSwarmioCurrency = {
  __typename: 'PaginatedSwarmioCurrency';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<SwarmioCurrency>;
  totalCount: Scalars['Int'];
};

export type PaginatedSwarmioCurrencyExchangeBlock = {
  __typename: 'PaginatedSwarmioCurrencyExchangeBlock';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<SwarmioCurrencyExchangeBlock>;
  totalCount: Scalars['Int'];
};

export type PaginatedSwarmioCurrencyItem = {
  __typename: 'PaginatedSwarmioCurrencyItem';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<SwarmioCurrencyItem>;
  totalCount: Scalars['Int'];
};

export type PaginatedSwarmioCurrencyPayout = {
  __typename: 'PaginatedSwarmioCurrencyPayout';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<SwarmioCurrencyPayout>;
  totalCount: Scalars['Int'];
};

export type PaginatedSwarmioWalletTransactionWithMetadata = {
  __typename: 'PaginatedSwarmioWalletTransactionWithMetadata';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<SwarmioWalletTransactionWithMetadata>;
  totalCount: Scalars['Int'];
};

export type PaginatedTransferTransaction = {
  __typename: 'PaginatedTransferTransaction';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<TransferTransaction>;
  totalCount: Scalars['Int'];
};

export type PaginatedUser = {
  __typename: 'PaginatedUser';
  hasNextPage: Scalars['Boolean'];
  nodes: Array<User>;
  totalCount: Scalars['Int'];
};

export type PaginatedVouchers = {
  __typename: 'PaginatedVouchers';
  currentPage: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
  totalVouchers: Maybe<Scalars['Int']>;
  vouchers: Maybe<Array<Maybe<ProductVoucher>>>;
};

/** A participant in an event or various parts of an event */
export type Participant = {
  accountId: Scalars['String'];
  confirmed: Scalars['Boolean'];
  participantType: ParticipantType;
  requirementsNotMet: Array<ParticipantRequirementNotMet>;
  result: Maybe<Result>;
};

export type ParticipantBasicResultSubmission = {
  participantId: Scalars['String'];
  placement?: InputMaybe<Scalars['Int']>;
  score?: InputMaybe<Scalars['Float']>;
  showed: Scalars['Boolean'];
};

/** A reference to a participant */
export type ParticipantReference = {
  accountId: Scalars['String'];
  participant: Participant;
  participantId: Scalars['String'];
  result: Maybe<Result>;
};

export type ParticipantRequirementNotMet = {
  __typename: 'ParticipantRequirementNotMet';
  missingParticipantRequirement: Maybe<MissingParticipantRequirement>;
  participantID: Scalars['String'];
};

export type ParticipantScore = {
  __typename: 'ParticipantScore';
  id: Scalars['String'];
  score: Scalars['Int'];
};

export enum ParticipantType {
  IndividualParticipantType = 'IndividualParticipantType',
  TeamParticipantType = 'TeamParticipantType'
}

export type ParticipationData = {
  __typename: 'ParticipationData';
  disqualified: Scalars['Boolean'];
  eliminated: Maybe<Scalars['Boolean']>;
  eventId: Scalars['String'];
  participant: Participant;
};

export type Partner = {
  __typename: 'Partner';
  catalog: Maybe<Catalog>;
  createdBy: Maybe<Scalars['Int']>;
  createdDate: Maybe<Scalars['String']>;
  creditLimit: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  localCurrency: Maybe<Scalars['String']>;
  markedUpPercentage: Maybe<Scalars['Float']>;
  markedUpPercentageForCurrency: Maybe<Scalars['Float']>;
  markedUpPercentageForPsp: Maybe<Scalars['Float']>;
  modifiedBy: Maybe<Scalars['Int']>;
  modifiedDate: Maybe<Scalars['String']>;
  partnerId: Maybe<Scalars['ID']>;
  partnerName: Maybe<Scalars['String']>;
  partnerUrl: Maybe<Scalars['String']>;
};

export type PartnerConversion = {
  __typename: 'PartnerConversion';
  currencyPrices: Maybe<Array<Maybe<CurrencyPrice>>>;
  finalRetailPrice: Maybe<Scalars['Float']>;
  finalRetailPriceOverridden: Maybe<Scalars['Boolean']>;
  finalRoundedPointsValue: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['ID']>;
  isPartnerCurrencyMarkedUpPercentageOverridden: Maybe<Scalars['Boolean']>;
  isPartnerPointsMarkedUpPercentageOverridden: Maybe<Scalars['Boolean']>;
  isPartnerPspMarkedUpPercentageOverridden: Maybe<Scalars['Boolean']>;
  localCurrency: Maybe<Scalars['String']>;
  localCurrencyConversionRate: Maybe<Scalars['Float']>;
  localCurrencyConversionRateOverridden: Maybe<Scalars['Boolean']>;
  markedUpPercentage: Maybe<Scalars['Float']>;
  markedUpPercentageForCurrency: Maybe<Scalars['Float']>;
  markedUpPercentageForPsp: Maybe<Scalars['Float']>;
  markedUpPrice: Maybe<Scalars['Float']>;
  markedUpPriceForCurrency: Maybe<Scalars['Float']>;
  markedUpPriceForPsp: Maybe<Scalars['Float']>;
  markedUpPriceOverridden: Maybe<Scalars['Boolean']>;
  overriddenMarkedUpPriceForCurrency: Maybe<Scalars['Float']>;
  overriddenMarkedUpPriceForPsp: Maybe<Scalars['Float']>;
  partnerId: Maybe<Scalars['ID']>;
  partnerName: Maybe<Scalars['String']>;
  productsAvailable: Maybe<Scalars['Boolean']>;
};

export type PartnerCurrencyPreference = {
  __typename: 'PartnerCurrencyPreference';
  conversionRate: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['ID']>;
  overridePartner: Maybe<Scalars['Boolean']>;
  sourceCurrency: Maybe<Scalars['String']>;
  targetCurrency: Maybe<Scalars['String']>;
};

export type PartnerCurrencyPreferenceInput = {
  conversionRate?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type PartnerIdInput = {
  id: Scalars['ID'];
};

export type PartnerItemPaymentChannelInput = {
  channelId?: InputMaybe<Scalars['String']>;
  globallyEnabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  paymentName?: InputMaybe<Scalars['String']>;
};

export type PartnerItemPaymentChannelResponse = {
  __typename: 'PartnerItemPaymentChannelResponse';
  channelId: Maybe<Scalars['String']>;
  globallyEnabled: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['ID']>;
  isEnabled: Maybe<Scalars['Boolean']>;
  paymentName: Maybe<Scalars['String']>;
};

export type PartnerLanguage = {
  __typename: 'PartnerLanguage';
  id: Maybe<Scalars['Int']>;
  languages: Maybe<Array<Maybe<LanguageDto>>>;
  partnerId: Maybe<Scalars['String']>;
  partnerName: Maybe<Scalars['String']>;
};

export type PartnerLocalCurrencyConversion = {
  __typename: 'PartnerLocalCurrencyConversion';
  conversionRate: Maybe<Scalars['Float']>;
  localCurrency: Maybe<Scalars['String']>;
};

export type PartnerLocalCurrencyConversionInput = {
  conversionRate?: InputMaybe<Scalars['Float']>;
  localCurrency?: InputMaybe<Scalars['String']>;
};

export type PartnerPaymentChannel = {
  __typename: 'PartnerPaymentChannel';
  active: Maybe<Scalars['Boolean']>;
  channelName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  markedUpPercentage: Maybe<Scalars['Float']>;
  overridden: Maybe<Scalars['Boolean']>;
};

export type PartnerPaymentChannelData = {
  __typename: 'PartnerPaymentChannelData';
  partnerId: Maybe<Scalars['Int']>;
  paymentChannelId: Maybe<Scalars['Int']>;
};

export type PartnerPaymentChannelDataDto = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  markedUpPercentage?: InputMaybe<Scalars['Float']>;
  paymentChannelId?: InputMaybe<Scalars['Int']>;
};

export type PartnerPaymentChannelDataInput = {
  partnerId?: InputMaybe<Scalars['Int']>;
  partnerPaymentChannels?: InputMaybe<Array<InputMaybe<PartnerPaymentChannelDataDto>>>;
};

export type PayPurchaseTransaction = {
  __typename: 'PayPurchaseTransaction';
  alternateTransactionId: Maybe<Scalars['String']>;
  created: Scalars['Date'];
  fields: Maybe<Scalars['String']>;
  id: Scalars['String'];
  itemId: Scalars['String'];
  merchantPaymentMethodId: Scalars['String'];
  merchantPaymentMethodType: Scalars['String'];
  notes: Array<Scalars['String']>;
  order: Maybe<RootCode_Order>;
  payment: Maybe<BeedlePayment>;
  purchaserData: PurchaserData;
  quantity: Scalars['Int'];
  status: PurchaseTransactionStatus;
  tagId: Scalars['String'];
};

export type PayloadLockedDocument = {
  __typename: 'PayloadLockedDocument';
  createdAt: Maybe<Scalars['DateTime']>;
  document: Maybe<PayloadLockedDocument_Document_Relationship>;
  globalSlug: Maybe<Scalars['String']>;
  id: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
  user: PayloadLockedDocument_User_Relationship;
};

export type PayloadLockedDocumentUpdate_DocumentRelationshipInput = {
  relationTo?: InputMaybe<PayloadLockedDocumentUpdate_DocumentRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadLockedDocumentUpdate_DocumentRelationshipInputRelationTo {
  CmsUsers = 'CmsUsers',
  CmsBanners = 'cms_banners',
  CmsBlogPages = 'cms_blog_pages',
  CmsBlogPosts = 'cms_blog_posts',
  CmsGamers = 'cms_gamers',
  CmsGames = 'cms_games',
  CmsMedia = 'cms_media'
}

export type PayloadLockedDocumentUpdate_UserRelationshipInput = {
  relationTo?: InputMaybe<PayloadLockedDocumentUpdate_UserRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadLockedDocumentUpdate_UserRelationshipInputRelationTo {
  CmsUsers = 'CmsUsers'
}

export type PayloadLockedDocument_Document = CmsBanner | CmsBlogPage | CmsBlogPost | CmsGame | CmsGamer | CmsMedia | CmsUser;

export type PayloadLockedDocument_DocumentRelationshipInput = {
  relationTo?: InputMaybe<PayloadLockedDocument_DocumentRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadLockedDocument_DocumentRelationshipInputRelationTo {
  CmsUsers = 'CmsUsers',
  CmsBanners = 'cms_banners',
  CmsBlogPages = 'cms_blog_pages',
  CmsBlogPosts = 'cms_blog_posts',
  CmsGamers = 'cms_gamers',
  CmsGames = 'cms_games',
  CmsMedia = 'cms_media'
}

export enum PayloadLockedDocument_Document_RelationTo {
  CmsUsers = 'CmsUsers',
  CmsBanners = 'cms_banners',
  CmsBlogPages = 'cms_blog_pages',
  CmsBlogPosts = 'cms_blog_posts',
  CmsGamers = 'cms_gamers',
  CmsGames = 'cms_games',
  CmsMedia = 'cms_media'
}

export type PayloadLockedDocument_Document_Relationship = {
  __typename: 'PayloadLockedDocument_Document_Relationship';
  relationTo: Maybe<PayloadLockedDocument_Document_RelationTo>;
  value: Maybe<PayloadLockedDocument_Document>;
};

export type PayloadLockedDocument_User = CmsUser;

export type PayloadLockedDocument_UserRelationshipInput = {
  relationTo?: InputMaybe<PayloadLockedDocument_UserRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadLockedDocument_UserRelationshipInputRelationTo {
  CmsUsers = 'CmsUsers'
}

export enum PayloadLockedDocument_User_RelationTo {
  CmsUsers = 'CmsUsers'
}

export type PayloadLockedDocument_User_Relationship = {
  __typename: 'PayloadLockedDocument_User_Relationship';
  relationTo: Maybe<PayloadLockedDocument_User_RelationTo>;
  value: Maybe<PayloadLockedDocument_User>;
};

export type PayloadLockedDocument_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PayloadLockedDocument_Document_Relation = {
  relationTo?: InputMaybe<PayloadLockedDocument_Document_Relation_RelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadLockedDocument_Document_Relation_RelationTo {
  CmsUsers = 'CmsUsers',
  CmsBanners = 'cms_banners',
  CmsBlogPages = 'cms_blog_pages',
  CmsBlogPosts = 'cms_blog_posts',
  CmsGamers = 'cms_gamers',
  CmsGames = 'cms_games',
  CmsMedia = 'cms_media'
}

export type PayloadLockedDocument_GlobalSlug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PayloadLockedDocument_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PayloadLockedDocument_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PayloadLockedDocument_User_Relation = {
  relationTo?: InputMaybe<PayloadLockedDocument_User_Relation_RelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadLockedDocument_User_Relation_RelationTo {
  CmsUsers = 'CmsUsers'
}

export type PayloadLockedDocument_Where = {
  AND?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_Or>>>;
  createdAt?: InputMaybe<PayloadLockedDocument_CreatedAt_Operator>;
  document?: InputMaybe<PayloadLockedDocument_Document_Relation>;
  globalSlug?: InputMaybe<PayloadLockedDocument_GlobalSlug_Operator>;
  id?: InputMaybe<PayloadLockedDocument_Id_Operator>;
  updatedAt?: InputMaybe<PayloadLockedDocument_UpdatedAt_Operator>;
  user?: InputMaybe<PayloadLockedDocument_User_Relation>;
};

export type PayloadLockedDocument_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_Or>>>;
  createdAt?: InputMaybe<PayloadLockedDocument_CreatedAt_Operator>;
  document?: InputMaybe<PayloadLockedDocument_Document_Relation>;
  globalSlug?: InputMaybe<PayloadLockedDocument_GlobalSlug_Operator>;
  id?: InputMaybe<PayloadLockedDocument_Id_Operator>;
  updatedAt?: InputMaybe<PayloadLockedDocument_UpdatedAt_Operator>;
  user?: InputMaybe<PayloadLockedDocument_User_Relation>;
};

export type PayloadLockedDocument_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_Or>>>;
  createdAt?: InputMaybe<PayloadLockedDocument_CreatedAt_Operator>;
  document?: InputMaybe<PayloadLockedDocument_Document_Relation>;
  globalSlug?: InputMaybe<PayloadLockedDocument_GlobalSlug_Operator>;
  id?: InputMaybe<PayloadLockedDocument_Id_Operator>;
  updatedAt?: InputMaybe<PayloadLockedDocument_UpdatedAt_Operator>;
  user?: InputMaybe<PayloadLockedDocument_User_Relation>;
};

export type PayloadLockedDocuments = {
  __typename: 'PayloadLockedDocuments';
  docs: Array<PayloadLockedDocument>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  nextPage: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  pagingCounter: Scalars['Int'];
  prevPage: Maybe<Scalars['Int']>;
  totalDocs: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PayloadLockedDocumentsCreateAccess = {
  __typename: 'PayloadLockedDocumentsCreateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsCreateDocAccess = {
  __typename: 'PayloadLockedDocumentsCreateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsDeleteAccess = {
  __typename: 'PayloadLockedDocumentsDeleteAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsDeleteDocAccess = {
  __typename: 'PayloadLockedDocumentsDeleteDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsDocAccessFields = {
  __typename: 'PayloadLockedDocumentsDocAccessFields';
  createdAt: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt>;
  document: Maybe<PayloadLockedDocumentsDocAccessFields_Document>;
  globalSlug: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug>;
  updatedAt: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt>;
  user: Maybe<PayloadLockedDocumentsDocAccessFields_User>;
};

export type PayloadLockedDocumentsDocAccessFields_CreatedAt = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_createdAt';
  create: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt_Create>;
  delete: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt_Delete>;
  read: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt_Read>;
  update: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt_Update>;
};

export type PayloadLockedDocumentsDocAccessFields_CreatedAt_Create = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_CreatedAt_Delete = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_CreatedAt_Read = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_CreatedAt_Update = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_Document = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_document';
  create: Maybe<PayloadLockedDocumentsDocAccessFields_Document_Create>;
  delete: Maybe<PayloadLockedDocumentsDocAccessFields_Document_Delete>;
  read: Maybe<PayloadLockedDocumentsDocAccessFields_Document_Read>;
  update: Maybe<PayloadLockedDocumentsDocAccessFields_Document_Update>;
};

export type PayloadLockedDocumentsDocAccessFields_Document_Create = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_document_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_Document_Delete = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_document_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_Document_Read = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_document_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_Document_Update = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_document_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_globalSlug';
  create: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug_Create>;
  delete: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug_Delete>;
  read: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug_Read>;
  update: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug_Update>;
};

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug_Create = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_globalSlug_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug_Delete = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_globalSlug_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug_Read = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_globalSlug_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug_Update = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_globalSlug_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_updatedAt';
  create: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt_Create>;
  delete: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt_Delete>;
  read: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt_Read>;
  update: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt_Update>;
};

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt_Create = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt_Delete = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt_Read = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt_Update = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_User = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_user';
  create: Maybe<PayloadLockedDocumentsDocAccessFields_User_Create>;
  delete: Maybe<PayloadLockedDocumentsDocAccessFields_User_Delete>;
  read: Maybe<PayloadLockedDocumentsDocAccessFields_User_Read>;
  update: Maybe<PayloadLockedDocumentsDocAccessFields_User_Update>;
};

export type PayloadLockedDocumentsDocAccessFields_User_Create = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_user_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_User_Delete = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_user_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_User_Read = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_user_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_User_Update = {
  __typename: 'PayloadLockedDocumentsDocAccessFields_user_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields = {
  __typename: 'PayloadLockedDocumentsFields';
  createdAt: Maybe<PayloadLockedDocumentsFields_CreatedAt>;
  document: Maybe<PayloadLockedDocumentsFields_Document>;
  globalSlug: Maybe<PayloadLockedDocumentsFields_GlobalSlug>;
  updatedAt: Maybe<PayloadLockedDocumentsFields_UpdatedAt>;
  user: Maybe<PayloadLockedDocumentsFields_User>;
};

export type PayloadLockedDocumentsFields_CreatedAt = {
  __typename: 'PayloadLockedDocumentsFields_createdAt';
  create: Maybe<PayloadLockedDocumentsFields_CreatedAt_Create>;
  delete: Maybe<PayloadLockedDocumentsFields_CreatedAt_Delete>;
  read: Maybe<PayloadLockedDocumentsFields_CreatedAt_Read>;
  update: Maybe<PayloadLockedDocumentsFields_CreatedAt_Update>;
};

export type PayloadLockedDocumentsFields_CreatedAt_Create = {
  __typename: 'PayloadLockedDocumentsFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_CreatedAt_Delete = {
  __typename: 'PayloadLockedDocumentsFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_CreatedAt_Read = {
  __typename: 'PayloadLockedDocumentsFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_CreatedAt_Update = {
  __typename: 'PayloadLockedDocumentsFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_Document = {
  __typename: 'PayloadLockedDocumentsFields_document';
  create: Maybe<PayloadLockedDocumentsFields_Document_Create>;
  delete: Maybe<PayloadLockedDocumentsFields_Document_Delete>;
  read: Maybe<PayloadLockedDocumentsFields_Document_Read>;
  update: Maybe<PayloadLockedDocumentsFields_Document_Update>;
};

export type PayloadLockedDocumentsFields_Document_Create = {
  __typename: 'PayloadLockedDocumentsFields_document_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_Document_Delete = {
  __typename: 'PayloadLockedDocumentsFields_document_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_Document_Read = {
  __typename: 'PayloadLockedDocumentsFields_document_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_Document_Update = {
  __typename: 'PayloadLockedDocumentsFields_document_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_GlobalSlug = {
  __typename: 'PayloadLockedDocumentsFields_globalSlug';
  create: Maybe<PayloadLockedDocumentsFields_GlobalSlug_Create>;
  delete: Maybe<PayloadLockedDocumentsFields_GlobalSlug_Delete>;
  read: Maybe<PayloadLockedDocumentsFields_GlobalSlug_Read>;
  update: Maybe<PayloadLockedDocumentsFields_GlobalSlug_Update>;
};

export type PayloadLockedDocumentsFields_GlobalSlug_Create = {
  __typename: 'PayloadLockedDocumentsFields_globalSlug_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_GlobalSlug_Delete = {
  __typename: 'PayloadLockedDocumentsFields_globalSlug_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_GlobalSlug_Read = {
  __typename: 'PayloadLockedDocumentsFields_globalSlug_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_GlobalSlug_Update = {
  __typename: 'PayloadLockedDocumentsFields_globalSlug_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_UpdatedAt = {
  __typename: 'PayloadLockedDocumentsFields_updatedAt';
  create: Maybe<PayloadLockedDocumentsFields_UpdatedAt_Create>;
  delete: Maybe<PayloadLockedDocumentsFields_UpdatedAt_Delete>;
  read: Maybe<PayloadLockedDocumentsFields_UpdatedAt_Read>;
  update: Maybe<PayloadLockedDocumentsFields_UpdatedAt_Update>;
};

export type PayloadLockedDocumentsFields_UpdatedAt_Create = {
  __typename: 'PayloadLockedDocumentsFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_UpdatedAt_Delete = {
  __typename: 'PayloadLockedDocumentsFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_UpdatedAt_Read = {
  __typename: 'PayloadLockedDocumentsFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_UpdatedAt_Update = {
  __typename: 'PayloadLockedDocumentsFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_User = {
  __typename: 'PayloadLockedDocumentsFields_user';
  create: Maybe<PayloadLockedDocumentsFields_User_Create>;
  delete: Maybe<PayloadLockedDocumentsFields_User_Delete>;
  read: Maybe<PayloadLockedDocumentsFields_User_Read>;
  update: Maybe<PayloadLockedDocumentsFields_User_Update>;
};

export type PayloadLockedDocumentsFields_User_Create = {
  __typename: 'PayloadLockedDocumentsFields_user_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_User_Delete = {
  __typename: 'PayloadLockedDocumentsFields_user_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_User_Read = {
  __typename: 'PayloadLockedDocumentsFields_user_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_User_Update = {
  __typename: 'PayloadLockedDocumentsFields_user_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsReadAccess = {
  __typename: 'PayloadLockedDocumentsReadAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsReadDocAccess = {
  __typename: 'PayloadLockedDocumentsReadDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsUpdateAccess = {
  __typename: 'PayloadLockedDocumentsUpdateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsUpdateDocAccess = {
  __typename: 'PayloadLockedDocumentsUpdateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreference = {
  __typename: 'PayloadPreference';
  createdAt: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  key: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  user: PayloadPreference_User_Relationship;
  value: Maybe<Scalars['JSON']>;
};

export type PayloadPreferenceUpdate_UserRelationshipInput = {
  relationTo?: InputMaybe<PayloadPreferenceUpdate_UserRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadPreferenceUpdate_UserRelationshipInputRelationTo {
  CmsUsers = 'CmsUsers'
}

export type PayloadPreference_User = CmsUser;

export type PayloadPreference_UserRelationshipInput = {
  relationTo?: InputMaybe<PayloadPreference_UserRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadPreference_UserRelationshipInputRelationTo {
  CmsUsers = 'CmsUsers'
}

export enum PayloadPreference_User_RelationTo {
  CmsUsers = 'CmsUsers'
}

export type PayloadPreference_User_Relationship = {
  __typename: 'PayloadPreference_User_Relationship';
  relationTo: Maybe<PayloadPreference_User_RelationTo>;
  value: Maybe<PayloadPreference_User>;
};

export type PayloadPreference_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PayloadPreference_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PayloadPreference_Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PayloadPreference_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PayloadPreference_User_Relation = {
  relationTo?: InputMaybe<PayloadPreference_User_Relation_RelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadPreference_User_Relation_RelationTo {
  CmsUsers = 'CmsUsers'
}

export type PayloadPreference_Value_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  intersects?: InputMaybe<Scalars['JSON']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  within?: InputMaybe<Scalars['JSON']>;
};

export type PayloadPreference_Where = {
  AND?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_Or>>>;
  createdAt?: InputMaybe<PayloadPreference_CreatedAt_Operator>;
  id?: InputMaybe<PayloadPreference_Id_Operator>;
  key?: InputMaybe<PayloadPreference_Key_Operator>;
  updatedAt?: InputMaybe<PayloadPreference_UpdatedAt_Operator>;
  user?: InputMaybe<PayloadPreference_User_Relation>;
  value?: InputMaybe<PayloadPreference_Value_Operator>;
};

export type PayloadPreference_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_Or>>>;
  createdAt?: InputMaybe<PayloadPreference_CreatedAt_Operator>;
  id?: InputMaybe<PayloadPreference_Id_Operator>;
  key?: InputMaybe<PayloadPreference_Key_Operator>;
  updatedAt?: InputMaybe<PayloadPreference_UpdatedAt_Operator>;
  user?: InputMaybe<PayloadPreference_User_Relation>;
  value?: InputMaybe<PayloadPreference_Value_Operator>;
};

export type PayloadPreference_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_Or>>>;
  createdAt?: InputMaybe<PayloadPreference_CreatedAt_Operator>;
  id?: InputMaybe<PayloadPreference_Id_Operator>;
  key?: InputMaybe<PayloadPreference_Key_Operator>;
  updatedAt?: InputMaybe<PayloadPreference_UpdatedAt_Operator>;
  user?: InputMaybe<PayloadPreference_User_Relation>;
  value?: InputMaybe<PayloadPreference_Value_Operator>;
};

export type PayloadPreferences = {
  __typename: 'PayloadPreferences';
  docs: Array<PayloadPreference>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  nextPage: Maybe<Scalars['Int']>;
  offset: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  pagingCounter: Scalars['Int'];
  prevPage: Maybe<Scalars['Int']>;
  totalDocs: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PayloadPreferencesCreateAccess = {
  __typename: 'PayloadPreferencesCreateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesCreateDocAccess = {
  __typename: 'PayloadPreferencesCreateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesDeleteAccess = {
  __typename: 'PayloadPreferencesDeleteAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesDeleteDocAccess = {
  __typename: 'PayloadPreferencesDeleteDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesDocAccessFields = {
  __typename: 'PayloadPreferencesDocAccessFields';
  createdAt: Maybe<PayloadPreferencesDocAccessFields_CreatedAt>;
  key: Maybe<PayloadPreferencesDocAccessFields_Key>;
  updatedAt: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt>;
  user: Maybe<PayloadPreferencesDocAccessFields_User>;
  value: Maybe<PayloadPreferencesDocAccessFields_Value>;
};

export type PayloadPreferencesDocAccessFields_CreatedAt = {
  __typename: 'PayloadPreferencesDocAccessFields_createdAt';
  create: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Create>;
  delete: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Delete>;
  read: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Read>;
  update: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Update>;
};

export type PayloadPreferencesDocAccessFields_CreatedAt_Create = {
  __typename: 'PayloadPreferencesDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_CreatedAt_Delete = {
  __typename: 'PayloadPreferencesDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_CreatedAt_Read = {
  __typename: 'PayloadPreferencesDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_CreatedAt_Update = {
  __typename: 'PayloadPreferencesDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Key = {
  __typename: 'PayloadPreferencesDocAccessFields_key';
  create: Maybe<PayloadPreferencesDocAccessFields_Key_Create>;
  delete: Maybe<PayloadPreferencesDocAccessFields_Key_Delete>;
  read: Maybe<PayloadPreferencesDocAccessFields_Key_Read>;
  update: Maybe<PayloadPreferencesDocAccessFields_Key_Update>;
};

export type PayloadPreferencesDocAccessFields_Key_Create = {
  __typename: 'PayloadPreferencesDocAccessFields_key_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Key_Delete = {
  __typename: 'PayloadPreferencesDocAccessFields_key_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Key_Read = {
  __typename: 'PayloadPreferencesDocAccessFields_key_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Key_Update = {
  __typename: 'PayloadPreferencesDocAccessFields_key_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_UpdatedAt = {
  __typename: 'PayloadPreferencesDocAccessFields_updatedAt';
  create: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Create>;
  delete: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Delete>;
  read: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Read>;
  update: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Update>;
};

export type PayloadPreferencesDocAccessFields_UpdatedAt_Create = {
  __typename: 'PayloadPreferencesDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_UpdatedAt_Delete = {
  __typename: 'PayloadPreferencesDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_UpdatedAt_Read = {
  __typename: 'PayloadPreferencesDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_UpdatedAt_Update = {
  __typename: 'PayloadPreferencesDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_User = {
  __typename: 'PayloadPreferencesDocAccessFields_user';
  create: Maybe<PayloadPreferencesDocAccessFields_User_Create>;
  delete: Maybe<PayloadPreferencesDocAccessFields_User_Delete>;
  read: Maybe<PayloadPreferencesDocAccessFields_User_Read>;
  update: Maybe<PayloadPreferencesDocAccessFields_User_Update>;
};

export type PayloadPreferencesDocAccessFields_User_Create = {
  __typename: 'PayloadPreferencesDocAccessFields_user_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_User_Delete = {
  __typename: 'PayloadPreferencesDocAccessFields_user_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_User_Read = {
  __typename: 'PayloadPreferencesDocAccessFields_user_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_User_Update = {
  __typename: 'PayloadPreferencesDocAccessFields_user_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Value = {
  __typename: 'PayloadPreferencesDocAccessFields_value';
  create: Maybe<PayloadPreferencesDocAccessFields_Value_Create>;
  delete: Maybe<PayloadPreferencesDocAccessFields_Value_Delete>;
  read: Maybe<PayloadPreferencesDocAccessFields_Value_Read>;
  update: Maybe<PayloadPreferencesDocAccessFields_Value_Update>;
};

export type PayloadPreferencesDocAccessFields_Value_Create = {
  __typename: 'PayloadPreferencesDocAccessFields_value_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Value_Delete = {
  __typename: 'PayloadPreferencesDocAccessFields_value_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Value_Read = {
  __typename: 'PayloadPreferencesDocAccessFields_value_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Value_Update = {
  __typename: 'PayloadPreferencesDocAccessFields_value_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields = {
  __typename: 'PayloadPreferencesFields';
  createdAt: Maybe<PayloadPreferencesFields_CreatedAt>;
  key: Maybe<PayloadPreferencesFields_Key>;
  updatedAt: Maybe<PayloadPreferencesFields_UpdatedAt>;
  user: Maybe<PayloadPreferencesFields_User>;
  value: Maybe<PayloadPreferencesFields_Value>;
};

export type PayloadPreferencesFields_CreatedAt = {
  __typename: 'PayloadPreferencesFields_createdAt';
  create: Maybe<PayloadPreferencesFields_CreatedAt_Create>;
  delete: Maybe<PayloadPreferencesFields_CreatedAt_Delete>;
  read: Maybe<PayloadPreferencesFields_CreatedAt_Read>;
  update: Maybe<PayloadPreferencesFields_CreatedAt_Update>;
};

export type PayloadPreferencesFields_CreatedAt_Create = {
  __typename: 'PayloadPreferencesFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_CreatedAt_Delete = {
  __typename: 'PayloadPreferencesFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_CreatedAt_Read = {
  __typename: 'PayloadPreferencesFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_CreatedAt_Update = {
  __typename: 'PayloadPreferencesFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Key = {
  __typename: 'PayloadPreferencesFields_key';
  create: Maybe<PayloadPreferencesFields_Key_Create>;
  delete: Maybe<PayloadPreferencesFields_Key_Delete>;
  read: Maybe<PayloadPreferencesFields_Key_Read>;
  update: Maybe<PayloadPreferencesFields_Key_Update>;
};

export type PayloadPreferencesFields_Key_Create = {
  __typename: 'PayloadPreferencesFields_key_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Key_Delete = {
  __typename: 'PayloadPreferencesFields_key_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Key_Read = {
  __typename: 'PayloadPreferencesFields_key_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Key_Update = {
  __typename: 'PayloadPreferencesFields_key_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_UpdatedAt = {
  __typename: 'PayloadPreferencesFields_updatedAt';
  create: Maybe<PayloadPreferencesFields_UpdatedAt_Create>;
  delete: Maybe<PayloadPreferencesFields_UpdatedAt_Delete>;
  read: Maybe<PayloadPreferencesFields_UpdatedAt_Read>;
  update: Maybe<PayloadPreferencesFields_UpdatedAt_Update>;
};

export type PayloadPreferencesFields_UpdatedAt_Create = {
  __typename: 'PayloadPreferencesFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_UpdatedAt_Delete = {
  __typename: 'PayloadPreferencesFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_UpdatedAt_Read = {
  __typename: 'PayloadPreferencesFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_UpdatedAt_Update = {
  __typename: 'PayloadPreferencesFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_User = {
  __typename: 'PayloadPreferencesFields_user';
  create: Maybe<PayloadPreferencesFields_User_Create>;
  delete: Maybe<PayloadPreferencesFields_User_Delete>;
  read: Maybe<PayloadPreferencesFields_User_Read>;
  update: Maybe<PayloadPreferencesFields_User_Update>;
};

export type PayloadPreferencesFields_User_Create = {
  __typename: 'PayloadPreferencesFields_user_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_User_Delete = {
  __typename: 'PayloadPreferencesFields_user_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_User_Read = {
  __typename: 'PayloadPreferencesFields_user_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_User_Update = {
  __typename: 'PayloadPreferencesFields_user_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Value = {
  __typename: 'PayloadPreferencesFields_value';
  create: Maybe<PayloadPreferencesFields_Value_Create>;
  delete: Maybe<PayloadPreferencesFields_Value_Delete>;
  read: Maybe<PayloadPreferencesFields_Value_Read>;
  update: Maybe<PayloadPreferencesFields_Value_Update>;
};

export type PayloadPreferencesFields_Value_Create = {
  __typename: 'PayloadPreferencesFields_value_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Value_Delete = {
  __typename: 'PayloadPreferencesFields_value_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Value_Read = {
  __typename: 'PayloadPreferencesFields_value_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Value_Update = {
  __typename: 'PayloadPreferencesFields_value_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesReadAccess = {
  __typename: 'PayloadPreferencesReadAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesReadDocAccess = {
  __typename: 'PayloadPreferencesReadDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesUpdateAccess = {
  __typename: 'PayloadPreferencesUpdateAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesUpdateDocAccess = {
  __typename: 'PayloadPreferencesUpdateDocAccess';
  permission: Scalars['Boolean'];
  where: Maybe<Scalars['JSONObject']>;
};

export type Payment = {
  __typename: 'Payment';
  paymentAmount: Maybe<Scalars['Float']>;
  paymentDate: Maybe<Scalars['String']>;
  paymentId: Maybe<Scalars['ID']>;
  paymentMethod: Maybe<Scalars['String']>;
};

export type PaymentChannel = {
  __typename: 'PaymentChannel';
  channelId: Maybe<Scalars['String']>;
  channelName: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  markedUpPercentage: Maybe<Scalars['Float']>;
  paymentMethod: Maybe<Scalars['String']>;
};

export type PaymentChannelFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  paymentChannelMethod?: InputMaybe<Scalars['String']>;
};

export type PaymentChannelInput = {
  channelId?: InputMaybe<Scalars['String']>;
  channelName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  markedUpPercentage?: InputMaybe<Scalars['Float']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
};

export type PaymentChannelPricing = {
  __typename: 'PaymentChannelPricing';
  channelId: Maybe<Scalars['Int']>;
  channelName: Maybe<Scalars['String']>;
  conversionRate: Maybe<Scalars['Float']>;
  conversionRateOverriddenLevel: Maybe<ConversionRateOverriddenLevel>;
  finalPrice: Maybe<Scalars['Float']>;
  finalPriceOverridden: Maybe<Scalars['Boolean']>;
  isChannelActive: Maybe<Scalars['Boolean']>;
  localPointsRate: Maybe<Scalars['Float']>;
  localPointsRateOverriddenLevel: Maybe<ConversionRateOverriddenLevel>;
  markedUpPercentage: Maybe<Scalars['Float']>;
  markedUpPercentageOverriddenLevel: Maybe<ConversionRateOverriddenLevel>;
  markedUpPrice: Maybe<Scalars['Float']>;
  price: Maybe<Scalars['Float']>;
  roundedPointsValue: Maybe<Scalars['Float']>;
  sourceCurrency: Maybe<Scalars['String']>;
  targetCurrency: Maybe<Scalars['String']>;
};

export enum PaymentFrequency {
  Annual = 'Annual',
  BiAnnual = 'BiAnnual',
  BiMonthly = 'BiMonthly',
  Daily = 'Daily',
  Monthly = 'Monthly',
  SemiAnnual = 'SemiAnnual',
  Weekly = 'Weekly'
}

export enum PaymentMethod {
  Dcb = 'DCB',
  Points = 'POINTS',
  Psp = 'PSP'
}

export type PaymentMethodConfig = {
  __typename: 'PaymentMethodConfig';
  created: Scalars['Date'];
  disabled: Scalars['Boolean'];
  id: Scalars['String'];
  imageUrl: Maybe<Scalars['String']>;
  paymentMethodId: Scalars['String'];
  updated: Maybe<Scalars['Date']>;
};

export type PaymentMethodConfigCreationRequest = {
  disabled: Scalars['Boolean'];
  imageUrl?: InputMaybe<Scalars['String']>;
  paymentMethodId: Scalars['String'];
};

export type PaymentMethodConfigUpdateRequest = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
};

export enum PaymentSortField {
  DateReceived = 'DateReceived',
  Default = 'Default'
}

export enum PaymentStatus {
  Cancelled = 'Cancelled',
  Chargeback = 'Chargeback',
  Failed = 'Failed',
  Initiated = 'Initiated',
  Pending = 'Pending',
  Success = 'Success',
  Unknown = 'Unknown'
}

/** The type of payment */
export enum PaymentType {
  /** SwarmioPay */
  SwarmioPay = 'SwarmioPay'
}

export type Person = Account & ObjectRepresentation & User & {
  __typename: 'Person';
  accountManagers: Array<AccountManagerWithPossibleError>;
  accountType: Scalars['String'];
  additionalInformation: Maybe<Array<AdditionalInformation>>;
  avatarURL: Maybe<Scalars['String']>;
  bannerURL: Maybe<Scalars['String']>;
  birthday: Maybe<DateAttributeWithPossibleError>;
  contactIdentifier: StringAttributeWithPossibleError;
  country: Maybe<Scalars['String']>;
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  email: Maybe<StringAttributeWithPossibleError>;
  emailContact: Maybe<HiveContactWithPossibleError>;
  emailVerified: Scalars['Boolean'];
  eventParticipations: Array<Event>;
  gameAccounts: Array<GameAccount>;
  groupInvites: Array<GroupInviteWithPossibleError>;
  groupMemberships: Array<GroupMembership>;
  hasValidContact: Scalars['Boolean'];
  id: Scalars['String'];
  isSupplier: Scalars['Boolean'];
  isVIP: Scalars['Boolean'];
  lastUpdated: Scalars['DateTime'];
  linkedAccounts: Array<IdentityProviderWithPossibleError>;
  managedAccounts: Array<ManagedAccount>;
  msisdn: Maybe<StringAttributeWithPossibleError>;
  msisdnContact: Maybe<HiveContactWithPossibleError>;
  msisdnVerified: Scalars['Boolean'];
  otherFields: Maybe<Array<AccountTag>>;
  payPurchaseTransactions: Array<PayPurchaseTransaction>;
  publicURL: Maybe<Scalars['String']>;
  purchaseTransactions: Array<PurchaseTransaction>;
  realName: Maybe<StringAttributeWithPossibleError>;
  servers: Array<Server>;
  socialLinks: Array<SocialLink>;
  subscriptionProviderAccounts: Array<SubscriptionProviderAccount>;
  subscriptions: Array<SwarmioSubscription>;
  updated: Scalars['Date'];
  userType: Scalars['String'];
  wallets: Array<SwarmioWallet>;
};


export type PersonServersArgs = {
  serverId?: InputMaybe<Scalars['String']>;
};

export type PersonUpdateRequest = {
  avatarURL?: InputMaybe<Scalars['String']>;
  bannerURL?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  isVIP?: InputMaybe<Scalars['Boolean']>;
  msisdn?: InputMaybe<Scalars['String']>;
  otherFieldsToAdd?: InputMaybe<Array<AccountTagInput>>;
  otherFieldsToRemove?: InputMaybe<Array<Scalars['String']>>;
  publicURL?: InputMaybe<Scalars['String']>;
  realName?: InputMaybe<Scalars['String']>;
  removeAvatarURL?: InputMaybe<Scalars['Boolean']>;
  removeBannerURL?: InputMaybe<Scalars['Boolean']>;
  removeEmail?: InputMaybe<Scalars['Boolean']>;
  removeMsisdn?: InputMaybe<Scalars['Boolean']>;
  removePublicURL?: InputMaybe<Scalars['Boolean']>;
  socialLinks?: InputMaybe<Array<SocialLinkInput>>;
};

export type PhaseModifications = {
  __typename: 'PhaseModifications';
  defaultMatchStartTime: Maybe<Scalars['Date']>;
  matchModifications: Array<MatchModifications>;
  numberOfRounds: Maybe<Scalars['Int']>;
  phaseNumber: Scalars['Int'];
};

export type PhaseModificationsCreationRequest = {
  defaultMatchStartTime?: InputMaybe<Scalars['Date']>;
  matchModifications?: InputMaybe<Array<MatchModificationsCreationRequest>>;
  numberOfRounds?: InputMaybe<Scalars['Int']>;
  phaseNumber: Scalars['Int'];
};

export type PhaseModificationsUpdateRequest = {
  defaultMatchStartTime?: InputMaybe<Scalars['Date']>;
  newMatchModifications?: InputMaybe<Array<MatchModificationsCreationRequest>>;
  numberOfRounds?: InputMaybe<Scalars['Int']>;
  phaseNumber: Scalars['Int'];
  updateMatchModifications?: InputMaybe<Array<MatchModificationsUpdateRequest>>;
};

export type PhasedCompetitionFormatSpecificDetails = {
  id: Scalars['String'];
  maybeMaxRoundParticipants: Maybe<Scalars['Int']>;
  maybeParticipantsInRound: Maybe<Scalars['Int']>;
};

export enum PlacingStrategy {
  HighestAverageScore = 'HighestAverageScore',
  HighestScore = 'HighestScore',
  LowestScore = 'LowestScore',
  MostFirstPlaces = 'MostFirstPlaces',
  Stay = 'Stay'
}

export type PlayableMatchUpMatch = CompetitionMatch & MatchUpMatch & {
  __typename: 'PlayableMatchUpMatch';
  assets: Array<Tag>;
  gameSpecificDetails: Maybe<GameSpecificCompetitionDetails>;
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  participants: Array<CompetitionParticipantReferenceWithRoster>;
  rounds: Array<MatchUpRound>;
  startTime: Maybe<Scalars['Date']>;
};

export type PlayableTournamentMatch = CompetitionMatch & TournamentMatch & {
  __typename: 'PlayableTournamentMatch';
  assets: Array<Tag>;
  gameSpecificDetails: Maybe<GameSpecificCompetitionDetails>;
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  participants: Array<CompetitionParticipantReferenceWithRoster>;
  rounds: Array<TournamentRound>;
  startTime: Maybe<Scalars['Date']>;
};

export type Points = {
  __typename: 'Points';
  archive: Maybe<Array<Maybe<PointsArchive>>>;
  createdDate: Maybe<Scalars['String']>;
  defaultValue: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['ID']>;
  modifiedDate: Maybe<Scalars['String']>;
  overriddenValue: Maybe<Scalars['Float']>;
  partner: Maybe<Partner>;
  supplier: Maybe<Supplier>;
};

export type PointsArchive = {
  __typename: 'PointsArchive';
  archivedDate: Maybe<Scalars['String']>;
  value: Maybe<Scalars['Float']>;
};

export type PointsInput = {
  defaultValue: Scalars['Float'];
  overriddenValue?: InputMaybe<Scalars['Float']>;
  partner?: InputMaybe<PartnerIdInput>;
  supplier?: InputMaybe<SupplierIdInput>;
};

export type PrivateGameServer = ObjectRepresentation & Server & {
  __typename: 'PrivateGameServer';
  autoKick: Scalars['Boolean'];
  bots: Maybe<Bots>;
  friendlyFire: Scalars['Boolean'];
  gameId: Scalars['String'];
  gameMode: GameModeType;
  id: Scalars['String'];
  ip: Maybe<Scalars['String']>;
  maps: Array<Scalars['String']>;
  maxNumberOfPlayers: Scalars['Int'];
  numberOfPlayers: Scalars['Int'];
  ownerId: Scalars['String'];
  password: Maybe<Scalars['String']>;
  port: Maybe<Scalars['Int']>;
  rconPassword: Maybe<Scalars['String']>;
  region: Maybe<Scalars['String']>;
  serverType: Scalars['String'];
  status: ServerStatusType;
  timeAcquired: Maybe<Scalars['Date']>;
  timeDestroyed: Maybe<Scalars['Date']>;
  timeRequested: Scalars['Date'];
};

export type PrivateServerCreationRequest = {
  autoKick: Scalars['Boolean'];
  botDifficulty: BotDifficultyType;
  botQuota: Scalars['Int'];
  friendlyFire: Scalars['Boolean'];
  gameId: Scalars['String'];
  gameMode: GameModeType;
  maps: Array<Scalars['String']>;
  maxNumberOfPlayers: Scalars['Int'];
  ownerId: Scalars['String'];
};

/** The prize for a particular placement in an event */
export type Prize = {
  id: Scalars['String'];
  prizeType: PrizeType;
};

export type PrizeList = {
  __typename: 'PrizeList';
  id: Scalars['String'];
  prizeTiers: Array<PrizeTier>;
};

export type PrizeListCreationRequest = {
  prizeTiers: Array<PrizeTierCreationRequest>;
};

export type PrizeListUpdateRequest = {
  prizeTiers: Array<PrizeTierCreationRequest>;
  prizeTiersToRemove: Array<Scalars['String']>;
};

/** A receipt for a prize payout */
export type PrizePayoutReceipt = {
  accountId: Scalars['String'];
  created: Scalars['Date'];
  id: Scalars['String'];
  notes: Maybe<Scalars['String']>;
  prizePayoutReceiptType: BasicPrizePayoutReceiptType;
  prizeTierId: Scalars['String'];
  successful: Scalars['Boolean'];
};

export type PrizeTier = {
  __typename: 'PrizeTier';
  id: Scalars['String'];
  placement: Scalars['Int'];
  placementRange: Maybe<Scalars['Int']>;
  prize: Prize;
};

export type PrizeTierCreationRequest = {
  customPrize?: InputMaybe<CustomPrizeCreationRequest>;
  placement: Scalars['Int'];
  placementRange?: InputMaybe<Scalars['Int']>;
  swarmioCurrencyPayoutPrize?: InputMaybe<SwarmioCurrencyPayoutPrizeCreationRequest>;
  variablePrize?: InputMaybe<VariablePrizeCreationRequest>;
};

/** The type of prize */
export enum PrizeType {
  CustomPrizeType = 'CustomPrizeType',
  SwarmioCurrencyPayoutPrizeType = 'SwarmioCurrencyPayoutPrizeType',
  VariablePrizeType = 'VariablePrizeType'
}

export type Product = {
  __typename: 'Product';
  availableStock: Maybe<Scalars['Int']>;
  createdDate: Maybe<Scalars['String']>;
  currency: Maybe<Scalars['String']>;
  currencySymbol: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  item: Maybe<Item>;
  manufacturerBrandId: Maybe<Scalars['Int']>;
  manufacturerBrandName: Maybe<Scalars['String']>;
  manufacturerBrandProductFields: Maybe<Scalars['String']>;
  manufacturerBrandProductFormatDesc: Maybe<Scalars['String']>;
  manufacturerBrandProductFormatId: Maybe<Scalars['Int']>;
  manufacturerId: Maybe<Scalars['ID']>;
  manufacturerName: Maybe<Scalars['String']>;
  modifiedDate: Maybe<Scalars['String']>;
  orderFields: Maybe<Scalars['Object']>;
  orderStrategy: Maybe<OrderStrategy>;
  productCode: Maybe<Scalars['String']>;
  productId: Maybe<Scalars['ID']>;
  productImageUrl: Maybe<Scalars['String']>;
  productName: Maybe<Scalars['String']>;
  productRedemptionInstructions: Maybe<Scalars['String']>;
  productStatus: Maybe<ItemStatus>;
  productType: Maybe<ProductType>;
  productVouchers: Maybe<Array<Maybe<ProductVoucher>>>;
  productVvssku: Maybe<Scalars['String']>;
  purchaseNote: Maybe<Scalars['String']>;
  sellPrice: Maybe<Scalars['Float']>;
  totalStock: Maybe<Scalars['Int']>;
  unitPrice: Maybe<Scalars['Float']>;
  voucherInventories: Maybe<Array<Maybe<VoucherInventory>>>;
};

export type ProductCode = {
  productCode?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
};

export type ProductDelete = {
  __typename: 'ProductDelete';
  itemsUnpublishedTotal: Maybe<Scalars['Int']>;
  voucherDeletedTotal: Maybe<Scalars['Int']>;
};

export type ProductGroup = {
  __typename: 'ProductGroup';
  bannerImage: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  featured: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  itemOrder: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  productGroupCatalogCategories: Maybe<Array<Maybe<ProductGroupCatalogCategory>>>;
  productGroupId: Maybe<Scalars['String']>;
  productType: Maybe<ProductType>;
  thumbnail: Maybe<Scalars['String']>;
  urlMask: Maybe<Scalars['String']>;
};

export type ProductGroupCatalogCategory = {
  __typename: 'ProductGroupCatalogCategory';
  catalog: Maybe<Catalog>;
  category: Maybe<Category>;
  productGroup: Maybe<ProductGroup>;
};

export type ProductGroupCatalogCategoryInfo = {
  __typename: 'ProductGroupCatalogCategoryInfo';
  catalog: Maybe<Catalog>;
  category: Maybe<Category>;
  productGroup: Maybe<ProductGroupInfo>;
};

export type ProductGroupCatalogCategoryInput = {
  catalogId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  groupId?: InputMaybe<Scalars['ID']>;
};

export type ProductGroupFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  partners?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  productType?: InputMaybe<ProductType>;
};

export type ProductGroupInfo = {
  __typename: 'ProductGroupInfo';
  bannerImage: Maybe<Scalars['String']>;
  deals: Maybe<Array<Maybe<Deal>>>;
  description: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  featured: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  itemOrder: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  productGroupCatalogCategories: Maybe<Array<Maybe<ProductGroupCatalogCategory>>>;
  productGroupId: Maybe<Scalars['String']>;
  productType: Maybe<ProductType>;
  thumbnail: Maybe<Scalars['String']>;
  urlMask: Maybe<Scalars['String']>;
};

export type ProductGroupInput = {
  bannerImage?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  itemCatalogs?: InputMaybe<Array<InputMaybe<ItemCatalogDto>>>;
  itemOrder?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  productType?: InputMaybe<ProductType>;
  thumbnail?: InputMaybe<Scalars['String']>;
  urlMask?: InputMaybe<Scalars['String']>;
};

export type ProductGroupItem = {
  __typename: 'ProductGroupItem';
  contentType: Maybe<ContentType>;
  createdBy: Maybe<Scalars['Int']>;
  createdDate: Maybe<Scalars['String']>;
  currencyConversionRate: Maybe<Scalars['Float']>;
  deals: Maybe<Array<Maybe<Deal>>>;
  deliveryMethod: Maybe<ItemDeliveryMethod>;
  displayName: Maybe<Scalars['String']>;
  gamePublisher: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  isStockAvailable: Maybe<Scalars['Boolean']>;
  itemDescBrief: Maybe<Scalars['String']>;
  itemDescDetail: Maybe<Scalars['String']>;
  itemGalleryUrls: Maybe<Array<Maybe<Scalars['String']>>>;
  itemId: Maybe<Scalars['String']>;
  itemImageUrl: Maybe<Scalars['String']>;
  itemName: Maybe<Scalars['String']>;
  itemPartnerPoints: Maybe<Array<Maybe<ItemPoints>>>;
  itemProductGroup: Maybe<ItemProductGroup>;
  itemStatus: Maybe<ItemStatus>;
  itemType: Maybe<ItemType>;
  mappedCatalogs: Maybe<Array<Maybe<CatalogMappingDto>>>;
  outOfStockDate: Maybe<Scalars['String']>;
  outOfStockImageUrl: Maybe<Scalars['String']>;
  product: Maybe<Product>;
  safetyStockThreshold: Maybe<Scalars['Int']>;
  supplier: Maybe<Supplier>;
  unitPrice: Maybe<Scalars['Float']>;
  variantName: Maybe<Scalars['String']>;
};

export type ProductGroupLanguageDto = {
  __typename: 'ProductGroupLanguageDTO';
  id: Maybe<Scalars['ID']>;
  languages: Maybe<Array<Maybe<LanguageDto>>>;
  name: Maybe<Scalars['String']>;
  productGroupId: Maybe<Scalars['String']>;
  unConfiguredLanguageIds: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ProductGroupLanguageData = {
  __typename: 'ProductGroupLanguageData';
  countryCode: Maybe<Scalars['String']>;
  isDefault: Maybe<Scalars['Boolean']>;
  isLanguageConfigured: Maybe<Scalars['Boolean']>;
  languageCode: Maybe<Scalars['String']>;
  languageId: Maybe<Scalars['ID']>;
  languageName: Maybe<Scalars['String']>;
  mappedPartnerLanguage: Maybe<Scalars['Boolean']>;
  productGroupDescription: Maybe<Scalars['String']>;
  productGroupDisplayName: Maybe<Scalars['String']>;
  productGroupName: Maybe<Scalars['String']>;
};

export type ProductGroupLanguageDataInput = {
  languageId?: InputMaybe<Scalars['ID']>;
  productGroupDescription?: InputMaybe<Scalars['String']>;
  productGroupDisplayName?: InputMaybe<Scalars['String']>;
  productGroupId?: InputMaybe<Scalars['ID']>;
  productGroupName?: InputMaybe<Scalars['String']>;
};

export type ProductGroupLanguageResponse = {
  __typename: 'ProductGroupLanguageResponse';
  productGroupDescription: Maybe<Scalars['String']>;
  productGroupDisplayName: Maybe<Scalars['String']>;
  productGroupName: Maybe<Scalars['String']>;
};

export type ProductGroupLanguagesResponse = {
  __typename: 'ProductGroupLanguagesResponse';
  currentPage: Maybe<Scalars['Int']>;
  pageSize: Maybe<Scalars['Int']>;
  productGroups: Maybe<Array<Maybe<ProductGroupLanguageDto>>>;
  totalFilteredProductGroups: Maybe<Scalars['Int']>;
  totalPages: Maybe<Scalars['Int']>;
};

export type ProductGroupResponse = {
  __typename: 'ProductGroupResponse';
  bannerImage: Maybe<Scalars['String']>;
  catalogs: Maybe<Array<Maybe<CatalogMappingDto>>>;
  categories: Maybe<Array<Maybe<Category>>>;
  description: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  featured: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  itemOrder: Maybe<Scalars['String']>;
  items: Maybe<Array<Maybe<ProductGroupItem>>>;
  mappedPartners: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
  productGroupId: Maybe<Scalars['String']>;
  productType: Maybe<ProductType>;
  productsCount: Maybe<Scalars['Int']>;
  thumbnail: Maybe<Scalars['String']>;
  urlMask: Maybe<Scalars['String']>;
};

export type ProductIdInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type ProductPrice = {
  __typename: 'ProductPrice';
  paymentChannelId: Maybe<Scalars['String']>;
  paymentChannelName: Maybe<Scalars['String']>;
  paymentMethod: Maybe<Scalars['String']>;
  targetCurrencyPrices: Maybe<Array<Maybe<TargetCurrencyPrice>>>;
};

/** ProductType name */
export enum ProductType {
  /** TOPUP */
  Topup = 'TOPUP',
  /** VOUCHER */
  Voucher = 'VOUCHER'
}

export type ProductVoucher = {
  __typename: 'ProductVoucher';
  createdDate: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: Maybe<VoucherStatus>;
  voucherCode: Maybe<Scalars['String']>;
  voucherExpiry: Maybe<Scalars['String']>;
  voucherPin: Maybe<Scalars['String']>;
  voucherSerial: Maybe<Scalars['String']>;
  voucherSerial2: Maybe<Scalars['String']>;
};

export type ProductsFilterInput = {
  csvFileId?: InputMaybe<Scalars['ID']>;
  excludeDeletedProducts?: InputMaybe<Scalars['Boolean']>;
  productStatus?: InputMaybe<ItemStatus>;
  productType?: InputMaybe<ProductType>;
  status?: InputMaybe<MappedStatus>;
};

/** Provisioner name */
export enum Provisioner {
  /** RootCode */
  RootCode = 'RootCode'
}

export type PrunedDoubleEliminationDetailsCreationRequest = {
  accountIdsImmuneToPruning?: InputMaybe<Array<Scalars['String']>>;
  bracketModifications?: InputMaybe<Array<BracketModificationsCreationRequest>>;
};

export type PrunedDoubleEliminationDetailsUpdateRequest = {
  accountIdsImmuneToPruning?: InputMaybe<Array<Scalars['String']>>;
};

export type PrunedDoubleEliminationSpecificDetails = CompetitionSpecificDetails & PhasedCompetitionFormatSpecificDetails & TournamentSpecificDetails & {
  __typename: 'PrunedDoubleEliminationSpecificDetails';
  accountsIdsWithPruningImmunity: Array<Scalars['String']>;
  id: Scalars['String'];
  lowerBracketParticipantsInHold: Array<CompetitionParticipantReferenceWithRoster>;
  maybeMaxRoundParticipants: Maybe<Scalars['Int']>;
  maybeParticipantsInRound: Maybe<Scalars['Int']>;
  participantsInHold: Array<CompetitionParticipantReferenceWithRoster>;
  tournamentFormat: TournamentFormat;
};

export type PrunedSingleEliminationDetailsCreationRequest = {
  accountIdsImmuneToPruning?: InputMaybe<Array<Scalars['String']>>;
  bracketModifications?: InputMaybe<Array<BracketModificationsCreationRequest>>;
};

export type PrunedSingleEliminationDetailsUpdateRequest = {
  accountIdsImmuneToPruning?: InputMaybe<Array<Scalars['String']>>;
};

export type PrunedSingleEliminationSpecificDetails = CompetitionSpecificDetails & PhasedCompetitionFormatSpecificDetails & TournamentSpecificDetails & {
  __typename: 'PrunedSingleEliminationSpecificDetails';
  accountsIdsWithPruningImmunity: Array<Scalars['String']>;
  id: Scalars['String'];
  maybeMaxRoundParticipants: Maybe<Scalars['Int']>;
  maybeParticipantsInRound: Maybe<Scalars['Int']>;
  participantsInHold: Array<CompetitionParticipantReferenceWithRoster>;
  tournamentFormat: TournamentFormat;
};

export type PublicGameServer = ObjectRepresentation & Server & {
  __typename: 'PublicGameServer';
  connectString: Maybe<Scalars['String']>;
  description: Scalars['String'];
  featured: Scalars['Boolean'];
  id: Scalars['String'];
  imageURL: Scalars['String'];
  ip: Maybe<Scalars['String']>;
  maxNumberOfPlayers: Scalars['Int'];
  name: Scalars['String'];
  port: Maybe<Scalars['Int']>;
  rconPassword: Maybe<Scalars['String']>;
  region: Maybe<Scalars['String']>;
  serverType: Scalars['String'];
  status: ServerStatusType;
  steamURL: Maybe<Scalars['String']>;
  timeAcquired: Maybe<Scalars['Date']>;
  timeDestroyed: Maybe<Scalars['Date']>;
  timeRequested: Scalars['Date'];
};

export type PublicServerCreationRequest = {
  connectString?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  featured: Scalars['Boolean'];
  id: Scalars['String'];
  imageURL: Scalars['String'];
  ip: Scalars['String'];
  maxNumberOfPlayers: Scalars['Int'];
  name: Scalars['String'];
  port: Scalars['Int'];
  region: Scalars['String'];
  steamURL?: InputMaybe<Scalars['String']>;
};

export type PublicServerUpdateRequest = {
  connectString?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  imageURL?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  maxNumberOfPlayers?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  port?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  steamURL?: InputMaybe<Scalars['String']>;
};

export type PurchaseItemInput = {
  callbackURL?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Scalars['Object']>;
  gamerAddress?: InputMaybe<Scalars['String']>;
  gamerEmail?: InputMaybe<Scalars['String']>;
  gamerFirstName?: InputMaybe<Scalars['String']>;
  gamerIPAddress?: InputMaybe<Scalars['String']>;
  gamerId?: InputMaybe<Scalars['String']>;
  gamerLastName?: InputMaybe<Scalars['String']>;
  gamerMobileNumber?: InputMaybe<Scalars['String']>;
  gamerName?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  orderDate?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  tagId: Scalars['ID'];
  transactionId: Scalars['String'];
};

export type PurchaseResponse = {
  __typename: 'PurchaseResponse';
  billingAddress: Maybe<Scalars['String']>;
  cancellationNote: Maybe<Scalars['String']>;
  contentType: Maybe<ContentType>;
  createdBy: Maybe<Scalars['Int']>;
  createdDate: Maybe<Scalars['String']>;
  formattedItemId: Maybe<Scalars['String']>;
  gamerEmail: Maybe<Scalars['String']>;
  gamerId: Maybe<Scalars['String']>;
  gamerName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  item: Maybe<Item>;
  itemName: Maybe<Scalars['String']>;
  modifiedBy: Maybe<Scalars['Int']>;
  modifiedDate: Maybe<Scalars['String']>;
  orderDate: Maybe<Scalars['String']>;
  orderId: Maybe<Scalars['String']>;
  orderStatus: Maybe<OrderStatus>;
  orderTransaction: Maybe<OrderTransaction>;
  partner: Maybe<Partner>;
  payment: Maybe<Payment>;
  pointsValue: Maybe<Scalars['Float']>;
  purchaseCurrency: Maybe<Scalars['String']>;
  purchaseCurrencyPrice: Maybe<Scalars['Float']>;
  purchaseMedium: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['Int']>;
  shipment: Maybe<Shipment>;
  totalPoints: Maybe<Scalars['Float']>;
  transaction: Maybe<Scalars['Object']>;
  transactionId: Maybe<Scalars['String']>;
  vouchers: Maybe<Array<Maybe<ProductVoucher>>>;
};

export type PurchaseTagIdRegistrationInput = {
  dealId?: InputMaybe<Scalars['Int']>;
  dealPurchase?: InputMaybe<Scalars['Boolean']>;
  itemId: Scalars['ID'];
  tagId: Scalars['ID'];
  transactionId: Scalars['String'];
};

export type PurchaseTagIdRegistrationResponse = {
  __typename: 'PurchaseTagIdRegistrationResponse';
  createdDate: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  itemId: Maybe<Scalars['String']>;
  purchaseMedium: Maybe<Scalars['String']>;
  transactionId: Maybe<Scalars['String']>;
};

export type PurchaseTransaction = {
  __typename: 'PurchaseTransaction';
  alternateTransactionId: Maybe<Scalars['String']>;
  created: Scalars['Date'];
  fields: Maybe<Scalars['String']>;
  id: Scalars['String'];
  item: SwarmioItem;
  itemId: Scalars['String'];
  notes: Array<Scalars['String']>;
  order: Maybe<RootCode_Order>;
  paymentTransactionId: Scalars['String'];
  status: PurchaseTransactionStatus;
};

/** Purchase Transaction status */
export enum PurchaseTransactionStatus {
  /** A PurchaseTransaction was cancelled */
  Cancelled = 'Cancelled',
  /** A PurchaseTransaction could not be fulfilled due to some issue */
  Error = 'Error',
  /** A PurchaseTransaction has been successfully fulfilled */
  Fulfilled = 'Fulfilled',
  /** A PurchaseTransaction has been created */
  Open = 'Open',
  /** A PurchaseTransaction is pending fulfillment */
  Pending = 'Pending',
  /** A PurchaseTransaction could not be fulfilled due to some issue and was refunded. */
  Refunded = 'Refunded'
}

export type PurchaserData = {
  __typename: 'PurchaserData';
  address: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Maybe<Scalars['String']>;
  hasAccount: Scalars['Boolean'];
  id: Scalars['String'];
  ipAddress: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  maxitMSISDN: Maybe<Scalars['String']>;
  mobileNumber: Maybe<Scalars['String']>;
  posthogId: Maybe<Scalars['String']>;
};

/** root */
export type Query = {
  __typename: 'Query';
  Access: Maybe<Access>;
  CmsBanner: Maybe<CmsBanner>;
  CmsBanners: Maybe<CmsBanners>;
  CmsBlogPage: Maybe<CmsBlogPage>;
  CmsBlogPages: Maybe<CmsBlogPages>;
  CmsBlogPost: Maybe<CmsBlogPost>;
  CmsBlogPosts: Maybe<CmsBlogPosts>;
  CmsGame: Maybe<CmsGame>;
  CmsGamer: Maybe<CmsGamer>;
  CmsGamers: Maybe<CmsGamers>;
  CmsGames: Maybe<CmsGames>;
  CmsMedia: Maybe<CmsMedia>;
  CmsMedias: Maybe<CmsMedias>;
  CmsUser: Maybe<CmsUser>;
  CmsUsers: Maybe<CmsUsers>;
  /** Retrieve in game results */
  InGameResults: Array<InGameResult>;
  PayloadLockedDocument: Maybe<PayloadLockedDocument>;
  PayloadLockedDocuments: Maybe<PayloadLockedDocuments>;
  PayloadPreference: Maybe<PayloadPreference>;
  PayloadPreferences: Maybe<PayloadPreferences>;
  /** Returns an account with specific `id`. */
  account: Maybe<Account>;
  /** Returns an account with the specific publicURL */
  accountByPublicURL: Maybe<Account>;
  /** Account data */
  accounts: Array<Account>;
  /** Get all active servers */
  allActivePublicServers: Array<PublicGameServer>;
  /** Retrieve all supported event games on the platform */
  allEventGames: Array<Game>;
  /** Retrieve all events */
  allEvents: PaginatedEvent;
  /** Retrieve all supported game account types on the platform */
  allGameAccountTypes: Array<GameAccountType>;
  /** Get all servers */
  allServers: Array<Server>;
  /** Retrieve all registered users */
  allUsers: PaginatedUser;
  /** A Swarmio application config */
  applicationConfig: Maybe<ApplicationConfig>;
  /** A Swarmio application config */
  applicationConfigByName: Maybe<ApplicationConfig>;
  /** All Swarmio application Configs */
  applicationConfigs: Array<ApplicationConfig>;
  /** Health check */
  areYouStillThere: Scalars['Boolean'];
  automaticallyVerifiedResultsForRoundAndFromParticipantId: Maybe<AutomaticallyVerifiedResultsForRoundFromParticipant>;
  automaticallyVerifiedResultsForRoundId: Array<AutomaticallyVerifiedResultsForRoundFromParticipant>;
  /** A Swarmio application config */
  banner: Maybe<Banner>;
  /** All Swarmio banners */
  banners: Array<Banner>;
  catalog: Catalog;
  catalogItem: Maybe<CatalogItem>;
  catalogItems: Maybe<PaginatedCatalogItems>;
  catalogs: Maybe<Array<Maybe<Catalog>>>;
  categories: Maybe<Array<Maybe<CategoryDto>>>;
  category: CategoryInfo;
  categoryCatalog: Maybe<CategoryCatalogResponse>;
  categoryCatalogAdmin: Maybe<Array<Maybe<CategoryCatalog>>>;
  categoryLanguageData: Maybe<Array<Maybe<CategoryLanguageDetails>>>;
  categoryLanguages: Maybe<PaginatedCategoryLanguage>;
  categoryProductGroups: Maybe<PaginatedCategoryProductGroups>;
  /** Checks if a MSISDN confirmation code is valid */
  checkMSISDNVerificationCode: Scalars['Boolean'];
  countCmsBanners: Maybe<CountCmsBanners>;
  countCmsBlogPages: Maybe<CountCmsBlogPages>;
  countCmsBlogPosts: Maybe<CountCmsBlogPosts>;
  countCmsGamers: Maybe<CountCmsGamers>;
  countCmsGames: Maybe<CountCmsGames>;
  countCmsMedias: Maybe<CountCmsMedias>;
  countCmsUsers: Maybe<CountCmsUsers>;
  countPayloadLockedDocuments: Maybe<CountPayloadLockedDocuments>;
  countPayloadPreferences: Maybe<CountPayloadPreferences>;
  csvFiles: Maybe<PaginatedCsvFiles>;
  currencyConversions: Maybe<Array<Maybe<CurrencyConversion>>>;
  deal: Maybe<DealDetailsDto>;
  dealItemsByPartnerIdsAndPaymentChannelIds: Maybe<Array<Maybe<DealPartner>>>;
  dealLog: Maybe<Array<Maybe<DealLogDetailDto>>>;
  dealSelectedPartnerItems: Maybe<Array<Maybe<DealPartnerItemDto>>>;
  dealSelectedPartners: Maybe<Array<Maybe<DealPartnerDto>>>;
  dealSelectedPaymentChannels: Maybe<DealPaymentChannelsDto>;
  deals: Maybe<PaginatedDeal>;
  distinctPaymentMethods: Maybe<Array<Maybe<Scalars['String']>>>;
  docAccessCmsBanner: Maybe<Cms_BannersDocAccess>;
  docAccessCmsBlogPage: Maybe<Cms_Blog_PagesDocAccess>;
  docAccessCmsBlogPost: Maybe<Cms_Blog_PostsDocAccess>;
  docAccessCmsGame: Maybe<Cms_GamesDocAccess>;
  docAccessCmsGamer: Maybe<Cms_GamersDocAccess>;
  docAccessCmsMedia: Maybe<Cms_MediaDocAccess>;
  docAccessCmsUser: Maybe<CmsUsersDocAccess>;
  docAccessPayloadLockedDocument: Maybe<Payload_Locked_DocumentsDocAccess>;
  docAccessPayloadPreference: Maybe<Payload_PreferencesDocAccess>;
  /** Retrieve all embedded games on the platform */
  embeddedGame: Maybe<EmbeddedGame>;
  /** Get event by Id */
  event: Maybe<Event>;
  /** Retrieve a Match */
  eventMatch: Maybe<OutOfContextCompetitionMatches>;
  /** Retrieve an EventParticipant */
  eventParticipant: Maybe<Participant>;
  /** Retrieve the participation data on an Event for an accountId */
  eventParticipantByAccount: Maybe<ParticipationData>;
  /** Filter events by tags */
  eventsByTags: Array<Event>;
  exportItems: Maybe<ExportedItemsCsv>;
  failedOrderTransactions: Maybe<PaginatedFailedOrderTransaction>;
  /** Feature by id */
  feature: Maybe<Feature>;
  /** All Features */
  features: Array<Feature>;
  gameUserIdValidation: Maybe<GameUserIdValidationResponse>;
  /** Retrieves all the active matches in an Event */
  getActiveMatches: Array<OutOfContextCompetitionMatches>;
  /** Retrieve all events with Category */
  getAllEventsWithCategory: Array<Event>;
  getAllPayPurchaseTransactions: Array<PayPurchaseTransaction>;
  getAllPaymentMethodsAvailableForMerchant: Array<StoreMerchantPaymentMethod>;
  /** Return all subscriptionTypes defined in the database */
  getAllSubscriptionTypes: Array<SubscriptionType>;
  getAllSwarmioCurrencies: Array<SwarmioCurrency>;
  getAllSwarmioCurrencyItems: Array<SwarmioCurrencyItem>;
  /** Get all currently active Swarmio Currency Payouts */
  getAllSwarmioCurrencyPayouts: Array<SwarmioCurrencyPayout>;
  getCurrencyPurchaseHistoryByOwnerId: Array<SwarmioPayPayment>;
  /** Retrieve all embedded games on the platform */
  getEmbeddedGames: PaginatedEmbeddedGame;
  /** Retrieve all event requirements */
  getEventRequirements: EventRequirement;
  /** Return all external subscription package details for a target subscriptionPartner */
  getExternalSubscriptionPackagesBySubscriptionPartner: Array<ExternalSubscriptionPackage>;
  /** Retrieve match-ups and tournaments that need score attention */
  getMatchUpsAndTournamentsRequiringScoreAttention: Array<Competition>;
  getMismatchedOrderFieldsProductsList: Maybe<Array<Maybe<OrderFieldsProduct>>>;
  /** Retrieves all upcoming matches for an account */
  getNextMatches: Array<OutOfContextCompetitionMatches>;
  /** Get all notifications for a given user ID */
  getNotifications: Array<AccountNotification>;
  getPayPurchaseTransaction: Maybe<PayPurchaseTransaction>;
  getPayPurchaseTransactionsByEmail: Array<PayPurchaseTransaction>;
  getPayTransactionsWithError: Array<PayPurchaseTransaction>;
  getPaymentMethodsAvailableForMerchant: Array<StoreMerchantPaymentMethod>;
  /** Health check */
  getSomething: Scalars['Boolean'];
  /** Query to get the streamers  by  Type */
  getStreamers: Array<Scalars['String']>;
  /** Get Streams  by Ids */
  getStreamsByIds: Array<Streams>;
  /** Get Streams By Type */
  getStreamsbyType: Array<Streams>;
  /** Return all subscriptions matching the IDs submitted */
  getSubscriptionsByIds: Array<SwarmioSubscription>;
  /** Return all implicitSubscriptions attached to a target account, refreshing them from the provider if their cacheExpiry has expired */
  getSubscriptionsForAccountId: Maybe<Account>;
  /** Return all implicitSubscriptions (as a list) attached to a target account list, refreshing them from the provider if their cacheExpiry has expired */
  getSubscriptionsForAccountIds: Maybe<Array<Account>>;
  getSwarmioCurrencies: PaginatedSwarmioCurrency;
  getSwarmioCurrencyExchangeBlocks: PaginatedSwarmioCurrencyExchangeBlock;
  getSwarmioCurrencyItem: SwarmioCurrencyItem;
  getSwarmioCurrencyItems: PaginatedSwarmioCurrencyItem;
  getSwarmioCurrencyPayouts: PaginatedSwarmioCurrencyPayout;
  /** Returns a SwarmioWallet with specific `walletId`. */
  getWallet: Maybe<SwarmioWallet>;
  /** Returns all SwarmioWallets for a specific `ownerId`. */
  getWalletsForOwner: Array<SwarmioWallet>;
  /** Retrieve the predicted structure of a competition */
  ghostCompetition: Competition;
  globalPoints: Points;
  globalPointsList: Maybe<Array<Maybe<Points>>>;
  /** Returns a GroupTrait with specific `id`. */
  groupTrait: Maybe<GroupTrait>;
  /** Returns whether or not the given GroupTrait name is unique */
  groupTraitNameIsUnique: Scalars['Boolean'];
  /** GroupTrait data */
  groupTraits: Array<GroupTrait>;
  initializedCmsUser: Maybe<Scalars['Boolean']>;
  isDealNameExists: Maybe<Scalars['Boolean']>;
  item: Item;
  itemLanguageData: Maybe<Array<Maybe<ItemLanguageData>>>;
  itemLanguages: Maybe<ItemLanguagesResponse>;
  itemSearchSuggestions: Maybe<Array<Maybe<Scalars['String']>>>;
  items: Maybe<PaginatedItems>;
  itemsByPartner: Maybe<Array<Maybe<Item>>>;
  languages: Maybe<Array<Maybe<Language>>>;
  manuallyVerifiedResultsForCompetitionId: Array<ManuallyVerifiedResult>;
  manuallyVerifiedResultsForRoundId: Array<ManuallyVerifiedResult>;
  manuallyVerifiedResultsForRoundIdAndParticipantId: Array<ManuallyVerifiedResult>;
  me: Account;
  meCmsUser: Maybe<CmsUsersMe>;
  nonTrashedProductGroups: Maybe<Array<Maybe<ProductGroupResponse>>>;
  order: Maybe<Order>;
  orderByTransactionId: Maybe<Order>;
  orderSearchSuggestions: Maybe<Array<Maybe<Scalars['String']>>>;
  orders: Maybe<PaginatedOrder>;
  ordersByGamer: Maybe<PaginatedOrder>;
  paginatedCategories: Maybe<CategoryResponseData>;
  partnerCategoryByURLMask: Maybe<PaginatedCategoryProductGroups>;
  partnerConversions: Maybe<Array<Maybe<PartnerConversion>>>;
  partnerConversionsByItemAndPartnerId: Maybe<PartnerConversion>;
  partnerCurrencyPreferences: Maybe<Array<Maybe<PartnerCurrencyPreference>>>;
  partnerItemPaymentChannels: Maybe<Array<Maybe<PartnerItemPaymentChannelResponse>>>;
  partnerItemPricingDetails: Maybe<Array<Maybe<PaymentChannelPricing>>>;
  partnerLanguages: Maybe<PaginatedPartnerLanguage>;
  partnerLocalCurrencyConversionRate: Maybe<Array<Maybe<PartnerLocalCurrencyConversion>>>;
  partnerProductGroup: Maybe<CategoryProductGroupResponse>;
  partnerProductGroupByURLMask: Maybe<CategoryProductGroupResponse>;
  partnerProductGroups: Maybe<PaginatedPartnerProductGroups>;
  partnerTargetCurrencyPreferences: Maybe<Array<Maybe<Scalars['String']>>>;
  partnersByItemId: Maybe<Array<Maybe<PartnerDataForItem>>>;
  paymentChannel: Maybe<PaymentChannel>;
  paymentChannels: Maybe<PaginatedPaymentChannel>;
  paymentChannelsByPartners: Maybe<PaginatedPaymentChannel>;
  paymentChannelsDataByPartnerId: Maybe<Array<Maybe<PartnerPaymentChannel>>>;
  /** Some additional config that extend a Payment Method configured in the payments service */
  paymentMethodConfig: Maybe<PaymentMethodConfig>;
  /** All additional configs that extends the Payment Methods configured in the payments service */
  paymentMethodConfigs: Array<PaymentMethodConfig>;
  /** Premade prize package */
  prize: Maybe<PrizeList>;
  /** Premade prize packages */
  prizes: Array<PrizeList>;
  product: Maybe<Product>;
  productGroup: Maybe<ProductGroupResponse>;
  productGroupLanguageData: Maybe<Array<Maybe<ProductGroupLanguageData>>>;
  productGroups: Maybe<PaginatedProductGroup>;
  productGroupsByCategory: Maybe<Array<Maybe<ProductGroupResponse>>>;
  productGroupsLanguages: Maybe<ProductGroupLanguagesResponse>;
  products: Maybe<Array<Maybe<Product>>>;
  productsBySupplier: Maybe<PaginatedProducts>;
  /** Get a purchase transaction from an account record by id */
  purchaseTransaction: Maybe<OutOfContextPurchaseTransaction>;
  /** Get a list purchase transactions */
  purchaseTransactions: Array<OutOfContextPurchaseTransaction>;
  retriedFailedOrderTransactions: Maybe<Array<Maybe<RetriedFailedTransactions>>>;
  retriedSuccessOrders: Maybe<PaginatedOrder>;
  /** Get Server by Id */
  server: Maybe<Server>;
  supplier: Supplier;
  supplierConfigurations: Maybe<Array<Maybe<SupplierConfiguration>>>;
  suppliers: Maybe<Array<Maybe<Supplier>>>;
  /** Returns a user with specific `id`. */
  user: Maybe<User>;
  /** Returns a user with the specific displayName */
  userByDisplayName: Maybe<User>;
  /** Returns a user with the specific email */
  userByEmail: Maybe<User>;
  /** Returns a list of account projections that match the given display name prefix */
  userSuggestions: Array<AccountProjection>;
  /** User data */
  users: Array<User>;
  validatePartnerDeal: Maybe<Scalars['Boolean']>;
  /** Validate an SLT partner account request without actually adding it to an account */
  validateSLTAccount: Scalars['Boolean'];
  voucherCodesBySupplier: Maybe<PaginatedVouchers>;
};


/** root */
export type QueryCmsBannerArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type QueryCmsBannersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CmsBanner_Where>;
};


/** root */
export type QueryCmsBlogPageArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type QueryCmsBlogPagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CmsBlogPage_Where>;
};


/** root */
export type QueryCmsBlogPostArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type QueryCmsBlogPostsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CmsBlogPost_Where>;
};


/** root */
export type QueryCmsGameArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type QueryCmsGamerArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type QueryCmsGamersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CmsGamer_Where>;
};


/** root */
export type QueryCmsGamesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CmsGame_Where>;
};


/** root */
export type QueryCmsMediaArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type QueryCmsMediasArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CmsMedia_Where>;
};


/** root */
export type QueryCmsUserArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type QueryCmsUsersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<CmsUser_Where>;
};


/** root */
export type QueryInGameResultsArgs = {
  matchIds: Array<Scalars['String']>;
};


/** root */
export type QueryPayloadLockedDocumentArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type QueryPayloadLockedDocumentsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PayloadLockedDocument_Where>;
};


/** root */
export type QueryPayloadPreferenceArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


/** root */
export type QueryPayloadPreferencesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PayloadPreference_Where>;
};


/** root */
export type QueryAccountArgs = {
  id: Scalars['String'];
};


/** root */
export type QueryAccountByPublicUrlArgs = {
  publicURL: Scalars['String'];
};


/** root */
export type QueryAccountsArgs = {
  ids: Array<Scalars['String']>;
};


/** root */
export type QueryAllActivePublicServersArgs = {
  featured?: InputMaybe<Scalars['Boolean']>;
};


/** root */
export type QueryAllEventGamesArgs = {
  weightLimit?: InputMaybe<Scalars['Int']>;
};


/** root */
export type QueryAllEventsArgs = {
  eventSortField?: EventSortField;
  eventsQuery: EventsQuery;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  sortOrder?: SortOrder;
};


/** root */
export type QueryAllUsersArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


/** root */
export type QueryApplicationConfigArgs = {
  applicationConfigId: Scalars['String'];
};


/** root */
export type QueryApplicationConfigByNameArgs = {
  applicationConfigName: Scalars['String'];
};


/** root */
export type QueryAutomaticallyVerifiedResultsForRoundAndFromParticipantIdArgs = {
  participantId: Scalars['String'];
  roundId: Scalars['String'];
};


/** root */
export type QueryAutomaticallyVerifiedResultsForRoundIdArgs = {
  roundId: Scalars['String'];
};


/** root */
export type QueryBannerArgs = {
  bannerId: Scalars['String'];
};


/** root */
export type QueryCatalogArgs = {
  catalogId: Scalars['ID'];
};


/** root */
export type QueryCatalogItemArgs = {
  itemId: Scalars['ID'];
  languageCode?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['ID'];
};


/** root */
export type QueryCatalogItemsArgs = {
  filter?: InputMaybe<CatalogFilterInput>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  partnerId: Scalars['ID'];
  sort?: InputMaybe<CatalogSortInput>;
};


/** root */
export type QueryCategoryArgs = {
  categoryId: Scalars['ID'];
};


/** root */
export type QueryCategoryCatalogArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  partnerId: Scalars['ID'];
};


/** root */
export type QueryCategoryCatalogAdminArgs = {
  partnerId: Scalars['ID'];
};


/** root */
export type QueryCategoryLanguageDataArgs = {
  categoryId: Scalars['ID'];
};


/** root */
export type QueryCategoryLanguagesArgs = {
  languageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  searchText?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryCategoryProductGroupsArgs = {
  categoryId: Scalars['ID'];
  languageCode?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  partnerId: Scalars['ID'];
};


/** root */
export type QueryCheckMsisdnVerificationCodeArgs = {
  MSISDN: Scalars['String'];
  token: Scalars['String'];
};


/** root */
export type QueryCountCmsBannersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CmsBanner_Where>;
};


/** root */
export type QueryCountCmsBlogPagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CmsBlogPage_Where>;
};


/** root */
export type QueryCountCmsBlogPostsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CmsBlogPost_Where>;
};


/** root */
export type QueryCountCmsGamersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CmsGamer_Where>;
};


/** root */
export type QueryCountCmsGamesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CmsGame_Where>;
};


/** root */
export type QueryCountCmsMediasArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CmsMedia_Where>;
};


/** root */
export type QueryCountCmsUsersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CmsUser_Where>;
};


/** root */
export type QueryCountPayloadLockedDocumentsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PayloadLockedDocument_Where>;
};


/** root */
export type QueryCountPayloadPreferencesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PayloadPreference_Where>;
};


/** root */
export type QueryCsvFilesArgs = {
  filter?: InputMaybe<FilterInput>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryCurrencyConversionsArgs = {
  itemId?: InputMaybe<Scalars['ID']>;
  partnerId: Scalars['ID'];
};


/** root */
export type QueryDealArgs = {
  dealId: Scalars['ID'];
};


/** root */
export type QueryDealItemsByPartnerIdsAndPaymentChannelIdsArgs = {
  dealDateInput?: InputMaybe<DealDateInputDto>;
  partnerIds: Array<InputMaybe<Scalars['ID']>>;
  paymentChannelIds: Array<InputMaybe<Scalars['ID']>>;
  searchText?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryDealLogArgs = {
  dealId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** root */
export type QueryDealSelectedPartnerItemsArgs = {
  dealId: Scalars['ID'];
};


/** root */
export type QueryDealSelectedPartnersArgs = {
  dealId: Scalars['ID'];
};


/** root */
export type QueryDealSelectedPaymentChannelsArgs = {
  dealId: Scalars['ID'];
};


/** root */
export type QueryDealsArgs = {
  filter?: InputMaybe<AllDealInput>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryDocAccessCmsBannerArgs = {
  id: Scalars['String'];
};


/** root */
export type QueryDocAccessCmsBlogPageArgs = {
  id: Scalars['String'];
};


/** root */
export type QueryDocAccessCmsBlogPostArgs = {
  id: Scalars['String'];
};


/** root */
export type QueryDocAccessCmsGameArgs = {
  id: Scalars['String'];
};


/** root */
export type QueryDocAccessCmsGamerArgs = {
  id: Scalars['String'];
};


/** root */
export type QueryDocAccessCmsMediaArgs = {
  id: Scalars['String'];
};


/** root */
export type QueryDocAccessCmsUserArgs = {
  id: Scalars['String'];
};


/** root */
export type QueryDocAccessPayloadLockedDocumentArgs = {
  id: Scalars['String'];
};


/** root */
export type QueryDocAccessPayloadPreferenceArgs = {
  id: Scalars['String'];
};


/** root */
export type QueryEmbeddedGameArgs = {
  embeddedGameId: Scalars['String'];
};


/** root */
export type QueryEventArgs = {
  eventId: Scalars['String'];
};


/** root */
export type QueryEventMatchArgs = {
  matchId: Scalars['String'];
};


/** root */
export type QueryEventParticipantArgs = {
  participantId: Scalars['String'];
};


/** root */
export type QueryEventParticipantByAccountArgs = {
  accountId: Scalars['String'];
  eventId: Scalars['String'];
};


/** root */
export type QueryEventsByTagsArgs = {
  eventTagsFilter: EventTagsFilterQuery;
};


/** root */
export type QueryExportItemsArgs = {
  filter?: InputMaybe<ItemFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  sort?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryFailedOrderTransactionsArgs = {
  filter?: InputMaybe<FailedOrderFilterInput>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryFeatureArgs = {
  featureId: Scalars['String'];
};


/** root */
export type QueryGameUserIdValidationArgs = {
  gameUserIdValidationRequest?: InputMaybe<GameUserIdValidationRequest>;
};


/** root */
export type QueryGetActiveMatchesArgs = {
  maybeAccountId?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryGetAllEventsWithCategoryArgs = {
  eventCategory: EventCategory;
  eventSortField?: EventSortField;
  sortOrder?: SortOrder;
};


/** root */
export type QueryGetAllSwarmioCurrencyPayoutsArgs = {
  swarmioCurrencyId: Scalars['String'];
};


/** root */
export type QueryGetCurrencyPurchaseHistoryByOwnerIdArgs = {
  ownerId: Scalars['String'];
  paymentSortField?: PaymentSortField;
  sortOrder?: SortOrder;
};


/** root */
export type QueryGetEmbeddedGamesArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


/** root */
export type QueryGetExternalSubscriptionPackagesBySubscriptionPartnerArgs = {
  subscriptionPartnerType: SubscriptionPartner;
};


/** root */
export type QueryGetMismatchedOrderFieldsProductsListArgs = {
  supplierId: Scalars['ID'];
};


/** root */
export type QueryGetNextMatchesArgs = {
  accountId: Scalars['String'];
  maybeEventId?: InputMaybe<Scalars['String']>;
  onlyActiveMatches: Scalars['Boolean'];
};


/** root */
export type QueryGetNotificationsArgs = {
  personId: Scalars['String'];
};


/** root */
export type QueryGetPayPurchaseTransactionArgs = {
  transactionId: Scalars['String'];
};


/** root */
export type QueryGetPayPurchaseTransactionsByEmailArgs = {
  email: Scalars['String'];
};


/** root */
export type QueryGetPaymentMethodsAvailableForMerchantArgs = {
  amount: Scalars['Float'];
  country: Scalars['Int'];
  currency: Scalars['String'];
};


/** root */
export type QueryGetStreamersArgs = {
  filterByAvailability?: StreamAvailabilityFilterType;
  streamsType: StreamType;
};


/** root */
export type QueryGetStreamsByIdsArgs = {
  ids: Array<Scalars['String']>;
};


/** root */
export type QueryGetStreamsbyTypeArgs = {
  filterByAvailability?: StreamAvailabilityFilterType;
  showExpiredFlag?: Scalars['Boolean'];
  streamsType: StreamType;
};


/** root */
export type QueryGetSubscriptionsByIdsArgs = {
  subscriptionIds: Array<Scalars['String']>;
};


/** root */
export type QueryGetSubscriptionsForAccountIdArgs = {
  accountId: Scalars['String'];
};


/** root */
export type QueryGetSubscriptionsForAccountIdsArgs = {
  accountIds: Array<Scalars['String']>;
};


/** root */
export type QueryGetSwarmioCurrenciesArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


/** root */
export type QueryGetSwarmioCurrencyExchangeBlocksArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


/** root */
export type QueryGetSwarmioCurrencyItemArgs = {
  swarmioCurrencyItemId: Scalars['String'];
};


/** root */
export type QueryGetSwarmioCurrencyItemsArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


/** root */
export type QueryGetSwarmioCurrencyPayoutsArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


/** root */
export type QueryGetWalletArgs = {
  walletId: Scalars['String'];
};


/** root */
export type QueryGetWalletsForOwnerArgs = {
  ownerId: Scalars['String'];
  swarmioCurrencyId?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryGhostCompetitionArgs = {
  competitionId: Scalars['String'];
  maybeNumberOfParticipants?: InputMaybe<Scalars['Int']>;
};


/** root */
export type QueryGlobalPointsArgs = {
  globalPointsId: Scalars['ID'];
};


/** root */
export type QueryGroupTraitArgs = {
  id: Scalars['String'];
};


/** root */
export type QueryGroupTraitNameIsUniqueArgs = {
  name: Scalars['String'];
};


/** root */
export type QueryGroupTraitsArgs = {
  ids: Array<Scalars['String']>;
};


/** root */
export type QueryIsDealNameExistsArgs = {
  dealName: Scalars['String'];
};


/** root */
export type QueryItemArgs = {
  itemId: Scalars['ID'];
};


/** root */
export type QueryItemLanguageDataArgs = {
  itemId: Scalars['ID'];
};


/** root */
export type QueryItemLanguagesArgs = {
  filter?: InputMaybe<LanguageMappingFilter>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryItemSearchSuggestionsArgs = {
  key?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryItemsArgs = {
  filter?: InputMaybe<ItemFilterInput>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryItemsByPartnerArgs = {
  partnerId: Scalars['ID'];
};


/** root */
export type QueryManuallyVerifiedResultsForCompetitionIdArgs = {
  competitionId: Scalars['String'];
};


/** root */
export type QueryManuallyVerifiedResultsForRoundIdArgs = {
  roundId: Scalars['String'];
};


/** root */
export type QueryManuallyVerifiedResultsForRoundIdAndParticipantIdArgs = {
  participantId: Scalars['String'];
  roundId: Scalars['String'];
};


/** root */
export type QueryOrderArgs = {
  orderId: Scalars['ID'];
};


/** root */
export type QueryOrderByTransactionIdArgs = {
  transactionId: Scalars['ID'];
};


/** root */
export type QueryOrderSearchSuggestionsArgs = {
  key?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryOrdersByGamerArgs = {
  gamerEmail?: InputMaybe<Scalars['ID']>;
  gamerId?: InputMaybe<Scalars['ID']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  sort?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryPaginatedCategoriesArgs = {
  categoryFilterDto?: InputMaybe<CategoryFilterInput>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryPartnerCategoryByUrlMaskArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  partnerId: Scalars['ID'];
  urlMask: Scalars['String'];
};


/** root */
export type QueryPartnerConversionsArgs = {
  itemId: Scalars['ID'];
};


/** root */
export type QueryPartnerConversionsByItemAndPartnerIdArgs = {
  itemId: Scalars['ID'];
  partnerId: Scalars['ID'];
};


/** root */
export type QueryPartnerCurrencyPreferencesArgs = {
  partnerId: Scalars['ID'];
};


/** root */
export type QueryPartnerItemPaymentChannelsArgs = {
  itemId: Scalars['ID'];
  partnerId: Scalars['ID'];
  paymentType?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryPartnerItemPricingDetailsArgs = {
  itemId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
};


/** root */
export type QueryPartnerLanguagesArgs = {
  languageIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryPartnerLocalCurrencyConversionRateArgs = {
  partnerId: Scalars['ID'];
};


/** root */
export type QueryPartnerProductGroupArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['ID'];
  productGroupId: Scalars['ID'];
};


/** root */
export type QueryPartnerProductGroupByUrlMaskArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['ID'];
  urlMask: Scalars['String'];
};


/** root */
export type QueryPartnerProductGroupsArgs = {
  languageCode?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  partnerId: Scalars['ID'];
  search?: InputMaybe<CatalogSearchInput>;
  sort?: InputMaybe<CatalogSortInput>;
};


/** root */
export type QueryPartnerTargetCurrencyPreferencesArgs = {
  partnerId: Scalars['ID'];
};


/** root */
export type QueryPartnersByItemIdArgs = {
  itemId?: InputMaybe<Scalars['ID']>;
};


/** root */
export type QueryPaymentChannelArgs = {
  paymentChannelId: Scalars['ID'];
};


/** root */
export type QueryPaymentChannelsArgs = {
  filter?: InputMaybe<PaymentChannelFilterInput>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryPaymentChannelsByPartnersArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryPaymentChannelsDataByPartnerIdArgs = {
  partnerId?: InputMaybe<Scalars['ID']>;
};


/** root */
export type QueryPaymentMethodConfigArgs = {
  paymentMethodConfigId: Scalars['String'];
};


/** root */
export type QueryPrizeArgs = {
  prizeId: Scalars['String'];
};


/** root */
export type QueryProductArgs = {
  productId: Scalars['ID'];
};


/** root */
export type QueryProductGroupArgs = {
  productGroupId: Scalars['ID'];
};


/** root */
export type QueryProductGroupLanguageDataArgs = {
  productGroupId: Scalars['ID'];
};


/** root */
export type QueryProductGroupsArgs = {
  filter?: InputMaybe<ProductGroupFilterInput>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryProductGroupsByCategoryArgs = {
  categoryId: Scalars['ID'];
};


/** root */
export type QueryProductGroupsLanguagesArgs = {
  filter?: InputMaybe<LanguageMappingFilter>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryProductsBySupplierArgs = {
  filter?: InputMaybe<ProductsFilterInput>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  supplierId: Scalars['ID'];
};


/** root */
export type QueryPurchaseTransactionArgs = {
  transactionId: Scalars['String'];
};


/** root */
export type QueryPurchaseTransactionsArgs = {
  transactionStatus?: InputMaybe<PurchaseTransactionStatus>;
};


/** root */
export type QueryRetriedFailedOrderTransactionsArgs = {
  transactionId: Scalars['String'];
};


/** root */
export type QueryRetriedSuccessOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


/** root */
export type QueryServerArgs = {
  serverId: Scalars['String'];
};


/** root */
export type QuerySupplierArgs = {
  supplierId: Scalars['ID'];
};


/** root */
export type QueryUserArgs = {
  id: Scalars['String'];
};


/** root */
export type QueryUserByDisplayNameArgs = {
  displayName: Scalars['String'];
};


/** root */
export type QueryUserByEmailArgs = {
  email: Scalars['String'];
};


/** root */
export type QueryUserSuggestionsArgs = {
  displayNamePrefix: Scalars['String'];
};


/** root */
export type QueryUsersArgs = {
  ids: Array<Scalars['String']>;
};


/** root */
export type QueryValidatePartnerDealArgs = {
  catalogId: Scalars['ID'];
};


/** root */
export type QueryValidateSltAccountArgs = {
  accountId: Scalars['String'];
  sltAccountCreationRequest: SltAccountCreationRequest;
};


/** root */
export type QueryVoucherCodesBySupplierArgs = {
  filter?: InputMaybe<VoucherFilterInput>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  order?: InputMaybe<SortOrder>;
  searchText?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  supplierId: Scalars['ID'];
};

export type ReadyIndividualParticipant = IndividualParticipant & Participant & {
  __typename: 'ReadyIndividualParticipant';
  accountId: Scalars['String'];
  confirmed: Scalars['Boolean'];
  created: Scalars['Date'];
  gameAccount: Maybe<GameAccount>;
  gameAccountId: Scalars['String'];
  id: Scalars['String'];
  inviteLink: Maybe<IndividualParticipantInviteLink>;
  maybeGameAccountId: Maybe<Scalars['String']>;
  participantType: ParticipantType;
  person: Maybe<Person>;
  requirementsNotMet: Array<ParticipantRequirementNotMet>;
  result: Maybe<Result>;
};

/** The type of currency */
export enum RealWorldCurrency {
  /** AED */
  Aed = 'AED',
  /** BHD */
  Bhd = 'BHD',
  /** CAD */
  Cad = 'CAD',
  /** EGP */
  Egp = 'EGP',
  /** LKR */
  Lkr = 'LKR',
  /** MYR */
  Myr = 'MYR',
  /** PHP */
  Php = 'PHP',
  /** SAR */
  Sar = 'SAR',
  /** THB */
  Thb = 'THB',
  /** TND */
  Tnd = 'TND',
  /** USD */
  Usd = 'USD'
}

export type RealWorldCurrencyCost = Cost & {
  __typename: 'RealWorldCurrencyCost';
  amount: Scalars['Float'];
  costType: CostType;
  created: Scalars['DateTime'];
  currency: RealWorldCurrencyTypeFinalMix;
  frequency: PaymentFrequency;
  id: Scalars['String'];
  updated: Maybe<Scalars['DateTime']>;
};

export type RealWorldCurrencyCostCreationRequest = {
  amount: Scalars['Float'];
  frequency: PaymentFrequency;
  realWorldCurrency: RealWorldCurrencyTypeFinalMix;
};

export enum RealWorldCurrencyTypeFinalMix {
  Aed = 'AED',
  Bhd = 'BHD',
  Inr = 'INR',
  Lkr = 'LKR',
  Php = 'PHP',
  Sar = 'SAR',
  Thb = 'THB',
  Tnd = 'TND',
  Usd = 'USD'
}

export type Recipient = {
  __typename: 'Recipient';
  contact: Scalars['String'];
  id: Scalars['String'];
};

export type RecurringReward = {
  __typename: 'RecurringReward';
  amount: Scalars['Float'];
  id: Scalars['String'];
  paymentFrequency: PaymentFrequency;
  swarmioCurrencyId: Scalars['String'];
};

export type RecurringRewardCreationRequest = {
  amount: Scalars['Float'];
  paymentFrequency: PaymentFrequency;
  swarmioCurrencyId: Scalars['String'];
};

export type RedeemVoucherRequest = {
  code: Scalars['String'];
  redeemerId: Scalars['String'];
};

export type Redemption = {
  __typename: 'Redemption';
  date: Scalars['Date'];
  id: Scalars['String'];
  redeemedBy: Scalars['String'];
};

export enum Region {
  Apac = 'APAC',
  Asia = 'Asia',
  Asia1 = 'Asia1',
  Br = 'BR',
  Bahrain = 'Bahrain',
  Dubai = 'Dubai',
  Eune = 'EUNE',
  Europe = 'EUROPE',
  Euw = 'EUW',
  Jp = 'JP',
  Kr = 'KR',
  Lan = 'LAN',
  Las = 'LAS',
  Me = 'ME',
  Mena = 'MENA',
  Na = 'NA',
  Oce = 'OCE',
  Ru = 'RU',
  Sea = 'SEA',
  Singapore = 'Singapore',
  SouthAsia = 'SouthAsia',
  Th = 'TH',
  Tr = 'TR',
  Uae = 'UAE',
  Uk = 'UK'
}

export type RegistrationMeta = {
  baseUrl?: InputMaybe<Scalars['String']>;
  clientName?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
};

export type RequestVoucherForRecipientRequest = {
  distributionContact: Scalars['String'];
  recipientId: Scalars['String'];
};

export type Result = {
  placement: Maybe<Scalars['Int']>;
  score: Maybe<Scalars['Float']>;
  showed: Scalars['Boolean'];
};

export type ResultBucket = {
  __typename: 'ResultBucket';
  bucketBottom: Maybe<Scalars['Float']>;
  bucketTop: Scalars['Float'];
  id: Scalars['String'];
};

export type ResultBucketRequest = {
  bucketBottom?: InputMaybe<Scalars['Float']>;
  bucketTop: Scalars['Float'];
};

export type RetriedFailedTransactions = {
  __typename: 'RetriedFailedTransactions';
  createdDate: Maybe<Scalars['String']>;
  errorMessage: Maybe<Scalars['String']>;
  retriedTransactionId: Maybe<Scalars['String']>;
  status: Maybe<FailedOrderTransactionStatus>;
  transactionId: Maybe<Scalars['String']>;
};

export type Role = {
  __typename: 'Role';
  roleDisplayName: Scalars['String'];
  roleId: Scalars['String'];
};

export type RootCode_Order = {
  __typename: 'RootCode_Order';
  createdDate: Scalars['String'];
  gamerId: Scalars['String'];
  id: Scalars['String'];
  orderDate: Scalars['String'];
  orderStatus: Scalars['String'];
  quantity: Scalars['Int'];
  transaction: Maybe<Scalars['String']>;
  transactionId: Scalars['String'];
  vouchers: Maybe<Array<RootCode_ProductVoucher>>;
};

export type RootCode_ProductVoucher = {
  __typename: 'RootCode_ProductVoucher';
  voucherCode: Maybe<Scalars['String']>;
  voucherExpiry: Maybe<Scalars['String']>;
  voucherPin: Maybe<Scalars['String']>;
  voucherSerial: Maybe<Scalars['String']>;
};

export enum RoundOffBoundary {
  LowerBoundary = 'LOWER_BOUNDARY',
  NotSelected = 'NOT_SELECTED',
  UpperBoundary = 'UPPER_BOUNDARY'
}

export enum RoundOffPlace {
  FirstDecimal = 'FIRST_DECIMAL',
  NotSelected = 'NOT_SELECTED',
  SecondDecimal = 'SECOND_DECIMAL',
  WholeNumber = 'WHOLE_NUMBER'
}

export type Rule = {
  __typename: 'Rule';
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updated: Maybe<Scalars['Date']>;
};

export type RuleInput = {
  created: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updated?: InputMaybe<Scalars['Date']>;
};

export type SltAccountCreationRequest = {
  password: Scalars['String'];
  subscriberId: Scalars['String'];
};

export type SltExternalSubscriptionPackage = {
  /** Boolean to check if the ExternalSubscriptionPackage is currently active or not */
  active: Scalars['Boolean'];
  /** Type of Costs associated with this package */
  costs: Array<Cost>;
  dataQuota: Maybe<Scalars['Float']>;
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  packageId: Scalars['String'];
  /** Used for identifying a SubscriptionProvider uniquely */
  providerSubscriptionId: Scalars['String'];
  /** Subscription Partner of this External Subscription Package */
  subscriptionPartner: SubscriptionPartner;
  /** Type of Implicit Subscription Providers */
  subscriptionProvider: SubscriptionProvider;
  /** Subscription Type this package belongs to */
  subscriptionType: SubscriptionType;
  subscriptionTypeId: Scalars['String'];
};

export type SltProviderAccount = SubscriptionProviderAccount & {
  __typename: 'SLTProviderAccount';
  doNotRefreshUntil: Maybe<Scalars['DateTime']>;
  externalSubscriptionProviderAccountId: Scalars['String'];
  id: Scalars['String'];
  sltAccountId: Scalars['String'];
  subscriptionProvider: SubscriptionProvider;
  subscriptionProviderAccountState: SubscriptionProviderAccountState;
};

export type SltProviderExternalSubscriptionPackage = ExternalSubscriptionPackage & SltExternalSubscriptionPackage & {
  __typename: 'SLTProviderExternalSubscriptionPackage';
  active: Scalars['Boolean'];
  costs: Array<Cost>;
  dataQuota: Maybe<Scalars['Float']>;
  defaultLocale: Locale;
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  localizedDescriptions: Array<LocalizedOptionalString>;
  localizedNames: Array<LocalizedString>;
  name: Scalars['String'];
  packageId: Scalars['String'];
  providerSubscriptionId: Scalars['String'];
  /** Subscription Partner of this External Subscription Package */
  subscriptionPartner: SubscriptionPartner;
  /** Type of Implicit Subscription Providers */
  subscriptionProvider: SubscriptionProvider;
  /** Subscription Type this package belongs to */
  subscriptionType: SubscriptionType;
  subscriptionTypeId: Scalars['String'];
};

export enum ScheduleStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Pending = 'PENDING',
  PendingRetry = 'PENDING_RETRY',
  Unknown = 'UNKNOWN'
}

export enum SchedulerMethodType {
  ApiBukalapakTopupUpdate = 'API_BUKALAPAK_TOPUP_UPDATE',
  ApiBukalapakVoucherUpdate = 'API_BUKALAPAK_VOUCHER_UPDATE',
  ApiUnipinTopupUpdate = 'API_UNIPIN_TOPUP_UPDATE',
  ApiUnipinVoucherUpdate = 'API_UNIPIN_VOUCHER_UPDATE'
}

export type SearchInput = {
  searchField?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type Segment = {
  __typename: 'Segment';
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rules: Array<Rule>;
  updated: Maybe<Scalars['Date']>;
};

export type SegmentInput = {
  created: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rules: Array<RuleInput>;
  updated?: InputMaybe<Scalars['Date']>;
};

/** A server */
export type Server = {
  id: Scalars['String'];
  ip: Maybe<Scalars['String']>;
  maxNumberOfPlayers: Scalars['Int'];
  port: Maybe<Scalars['Int']>;
  rconPassword: Maybe<Scalars['String']>;
  region: Maybe<Scalars['String']>;
  serverType: Scalars['String'];
  status: ServerStatusType;
  timeAcquired: Maybe<Scalars['Date']>;
  timeDestroyed: Maybe<Scalars['Date']>;
  timeRequested: Scalars['Date'];
};

export type ServerDetails = {
  __typename: 'ServerDetails';
  password: Maybe<Scalars['String']>;
  serverUrl: Scalars['String'];
};

/** Server status */
export enum ServerStatusType {
  /** A server is being created */
  Creating = 'Creating',
  /** A server has been deleted */
  Deleted = 'Deleted',
  /** A server has players connected */
  PlayersConnected = 'PlayersConnected',
  /** A server is ready */
  Ready = 'Ready',
  /** A server has been requested */
  Requested = 'Requested'
}

/** Result of a Pay session request (including transaction ID for status updates) */
export type SessionRequestResult = {
  __typename: 'SessionRequestResult';
  /** The gateway session ID */
  gatewaySessionId: Scalars['String'];
  /** The transaction ID */
  transactionId: Scalars['String'];
};

export type Shipment = {
  __typename: 'Shipment';
  shipmentAddress: Maybe<Scalars['String']>;
  shipmentDate: Maybe<Scalars['String']>;
  shipmentId: Maybe<Scalars['String']>;
  shipmentMethod: Maybe<Scalars['String']>;
};

export type SingleChallengeUpdateRequest = {
  manualAdvancement?: InputMaybe<Scalars['Boolean']>;
  startTime?: InputMaybe<Scalars['Date']>;
};

export type SingleDimensionResult = {
  __typename: 'SingleDimensionResult';
  dimensionId: Scalars['String'];
  value: Scalars['Float'];
};

export type SingleDimensionResultInput = {
  dimensionId: Scalars['String'];
  value: Scalars['Float'];
};

export type SingleEliminationDetailsCreationRequest = {
  bracketModifications?: InputMaybe<Array<BracketModificationsCreationRequest>>;
};

export type SingleEliminationSpecificDetails = CompetitionSpecificDetails & PhasedCompetitionFormatSpecificDetails & TournamentSpecificDetails & {
  __typename: 'SingleEliminationSpecificDetails';
  id: Scalars['String'];
  maybeMaxRoundParticipants: Maybe<Scalars['Int']>;
  maybeParticipantsInRound: Maybe<Scalars['Int']>;
  tournamentFormat: TournamentFormat;
};

export type SingleMatchUpUpdateRequest = {
  battleRoyaleFormatDetails?: InputMaybe<BattleRoyaleFormatUpdateDetails>;
  existingPhaseUpdateRequests?: InputMaybe<Array<ExistingPhaseUpdateRequest>>;
  kingOfTheHillDetails?: InputMaybe<KingOfTheHillUpdateDetails>;
  manualAdvancement?: InputMaybe<Scalars['Boolean']>;
  numberOfRounds?: InputMaybe<Scalars['Int']>;
  phaseBufferTime?: InputMaybe<Scalars['DurationInMilliseconds']>;
  phaseModifications?: InputMaybe<Array<PhaseModificationsUpdateRequest>>;
  startTime?: InputMaybe<Scalars['Date']>;
};

export type SingleTournamentUpdateRequest = {
  bracketModifications?: InputMaybe<Array<BracketModificationsUpdateRequest>>;
  existingBracketUpdateRequests?: InputMaybe<Array<ExistingBracketUpdateRequest>>;
  manualAdvancement?: InputMaybe<Scalars['Boolean']>;
  numberOfRounds?: InputMaybe<Scalars['Int']>;
  phaseBufferTime?: InputMaybe<Scalars['DurationInMilliseconds']>;
  prunedDoubleEliminationSpecificDetails?: InputMaybe<PrunedDoubleEliminationDetailsUpdateRequest>;
  prunedSingleEliminationSpecificDetails?: InputMaybe<PrunedSingleEliminationDetailsUpdateRequest>;
  startTime?: InputMaybe<Scalars['Date']>;
};

export type SocialLink = {
  __typename: 'SocialLink';
  link: Scalars['String'];
  socialLinkType: SocialLinkType;
};

export type SocialLinkInput = {
  link: Scalars['String'];
  socialLinkType: SocialLinkType;
};

/** Type of SocialLink */
export enum SocialLinkType {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Snapchat = 'SNAPCHAT',
  Twitter = 'TWITTER'
}

export enum SortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export type SpecificSubscriptionPrizeCondition = VariablePrizeCondition & {
  __typename: 'SpecificSubscriptionPrizeCondition';
  description: Scalars['String'];
  id: Scalars['String'];
  order: Scalars['Int'];
  prize: FixedPrize;
  subscriptionTypeId: Scalars['String'];
  variablePrizeConditionType: VariablePrizeConditionType;
};

export type SpecificSubscriptionPrizeConditionCreationRequest = {
  customPrize?: InputMaybe<CustomPrizeCreationRequest>;
  order: Scalars['Int'];
  subscriptionTypeId: Scalars['String'];
  swarmioCurrencyPayoutPrize?: InputMaybe<SwarmioCurrencyPayoutPrizeCreationRequest>;
};

export type StoreMerchantPaymentMethod = ObjectRepresentation & {
  __typename: 'StoreMerchantPaymentMethod';
  cancelScheduledPaymentSupported: Scalars['Boolean'];
  disabled: Scalars['Boolean'];
  id: Scalars['String'];
  imageUrl: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paymentMethodType: Scalars['String'];
  recurringPaymentSupported: Scalars['Boolean'];
  refundSupported: Scalars['Boolean'];
};

export type Stream = {
  id: Scalars['String'];
  url: Scalars['String'];
};

/** Filters Streams by their availability */
export enum StreamAvailabilityFilterType {
  All = 'All',
  Offline = 'Offline',
  Online = 'Online'
}

/** Indicates the availability of a stream is it online or offline */
export enum StreamAvailabilityType {
  Offline = 'Offline',
  Online = 'Online'
}

/** Type of Stream */
export enum StreamType {
  TwitchStreamType = 'TwitchStreamType'
}

export type StreamingEvent = {
  created: Scalars['Date'];
  defaultMessage: Scalars['String'];
  expiry: Scalars['Date'];
  id: Scalars['String'];
  notificationType: Scalars['String'];
};

/** Streams */
export type Streams = {
  expiry: Scalars['Date'];
  id: Scalars['String'];
  mediaType: MediaType;
  providerIdentifier: Scalars['String'];
  status: StreamAvailabilityType;
  streamType: StreamType;
  streamUrl: Maybe<Scalars['String']>;
  weight: Maybe<Scalars['Float']>;
};

export type StreamsCreationRequest = {
  names: Array<Scalars['String']>;
  streamType: StreamType;
  weights?: InputMaybe<Array<Scalars['Float']>>;
};

export type StringAttribute = StringAttributeWithPossibleError & {
  __typename: 'StringAttribute';
  isError: Scalars['Boolean'];
  value: Scalars['String'];
};

/** A StringAttribute or an error */
export type StringAttributeWithPossibleError = {
  isError: Scalars['Boolean'];
};

export type Subscription = {
  __typename: 'Subscription';
  AccountNotification: StreamingEvent;
  ClientNotification: StreamingEvent;
};


export type SubscriptionAccountNotificationArgs = {
  notificationTypes: Array<Scalars['String']>;
  personId: Scalars['String'];
};


export type SubscriptionClientNotificationArgs = {
  maybeTargetId?: InputMaybe<Scalars['String']>;
  notificationType: Scalars['String'];
};

export enum SubscriptionImplementation {
  ImplicitSubscriptionImplementation = 'ImplicitSubscriptionImplementation'
}

export enum SubscriptionPartner {
  Slt = 'SLT'
}

export type SubscriptionPrizeCondition = VariablePrizeCondition & {
  __typename: 'SubscriptionPrizeCondition';
  description: Scalars['String'];
  id: Scalars['String'];
  order: Scalars['Int'];
  prize: FixedPrize;
  variablePrizeConditionType: VariablePrizeConditionType;
};

export type SubscriptionPrizeConditionCreationRequest = {
  customPrize?: InputMaybe<CustomPrizeCreationRequest>;
  order: Scalars['Int'];
  swarmioCurrencyPayoutPrize?: InputMaybe<SwarmioCurrencyPayoutPrizeCreationRequest>;
};

export enum SubscriptionProvider {
  PayPal = 'PayPal',
  Slt = 'SLT'
}

export type SubscriptionProviderAccount = {
  externalSubscriptionProviderAccountId: Scalars['String'];
  id: Scalars['String'];
  subscriptionProvider: SubscriptionProvider;
  subscriptionProviderAccountState: SubscriptionProviderAccountState;
};

export enum SubscriptionProviderAccountState {
  AwaitingConfirmation = 'AwaitingConfirmation',
  Confirmed = 'Confirmed',
  Invalid = 'Invalid',
  Removed = 'Removed'
}

export enum SubscriptionState {
  Active = 'Active',
  AwaitingConfirmation = 'AwaitingConfirmation',
  AwaitingInitialPayment = 'AwaitingInitialPayment',
  AwaitingPayment = 'AwaitingPayment',
  AwaitingPaymentGracePeriod = 'AwaitingPaymentGracePeriod',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
  IncorrectCurrencyOnPayment = 'IncorrectCurrencyOnPayment',
  NeedsReviewNotUsable = 'NeedsReviewNotUsable',
  NeedsReviewUsable = 'NeedsReviewUsable',
  New = 'New',
  PartialPayment = 'PartialPayment',
  PaymentError = 'PaymentError',
  PreparingToCancel = 'PreparingToCancel',
  PreparingToCancelUnusable = 'PreparingToCancelUnusable',
  Refunded = 'Refunded',
  Suspended = 'Suspended',
  VerificationError = 'VerificationError'
}

export type SubscriptionType = {
  __typename: 'SubscriptionType';
  conflictSubscriptionTypeIds: Array<Scalars['String']>;
  defaultLocale: Locale;
  description: Maybe<Scalars['String']>;
  enrollable: Scalars['Boolean'];
  explicitEnrollment: Maybe<ExplicitEnrollment>;
  id: Scalars['String'];
  implicitEnrollments: Array<ImplicitEnrollment>;
  initialSwarmioCurrencyReward: Maybe<SwarmioCurrencyReward>;
  localizedDescriptions: Array<LocalizedOptionalString>;
  localizedNames: Array<LocalizedString>;
  name: Scalars['String'];
  recurringPayoutBonus: Maybe<RecurringReward>;
  weight: Maybe<Scalars['Float']>;
};

export type SubscriptionTypeCreationRequest = {
  conflictSubscriptionTypeIds: Array<Scalars['String']>;
  defaultLocale: Locale;
  enrollable: Scalars['Boolean'];
  explicitEnrollment?: InputMaybe<ExplicitEnrollmentCreationRequest>;
  implicitEnrollments: Array<ImplicitEnrollmentCreationRequest>;
  initialSwarmioCurrencyReward?: InputMaybe<SwarmioCurrencyRewardCreationRequest>;
  localizedDescriptions: Array<LocalizedOptionalStringInput>;
  localizedNames: Array<LocalizedStringInput>;
  recurringPayoutBonus?: InputMaybe<RecurringRewardCreationRequest>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type SubscriptionTypeUpdateRequest = {
  conflictSubscriptionTypeIds?: InputMaybe<Array<Scalars['String']>>;
  enrollable?: InputMaybe<Scalars['Boolean']>;
  explicitEnrollmentUpdate?: InputMaybe<ExplicitEnrollmentUpdateRequest>;
  implicitEnrollmentCreationRequests: Array<ImplicitEnrollmentCreationRequest>;
  initialSwarmioCurrencyReward?: InputMaybe<SwarmioCurrencyRewardCreationRequest>;
  localizedDescriptions?: InputMaybe<Array<LocalizedOptionalStringInput>>;
  localizedNames?: InputMaybe<Array<LocalizedStringInput>>;
  newExplicitEnrollment?: InputMaybe<ExplicitEnrollmentCreationRequest>;
  recurringPayoutBonus?: InputMaybe<RecurringRewardCreationRequest>;
  removeConflictSubscriptionTypeIds?: InputMaybe<Array<Scalars['String']>>;
  removeImplicitEnrollmentIds: Array<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type Supplier = {
  __typename: 'Supplier';
  configuration: Maybe<SupplierConfiguration>;
  contact: Contact;
  createdBy: Maybe<Scalars['Int']>;
  createdDate: Maybe<Scalars['String']>;
  creditLimit: Maybe<Scalars['String']>;
  endpointUrl: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  isActive: Maybe<Scalars['Boolean']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  itemCount: Maybe<Scalars['Int']>;
  job: Maybe<JobInfo>;
  productCount: Maybe<Scalars['Int']>;
  products: Maybe<Array<Maybe<Product>>>;
  supplierId: Maybe<Scalars['String']>;
  supplierMainType: Maybe<SupplierMainType>;
  supplierName: Maybe<Scalars['String']>;
};

export type SupplierConfiguration = {
  __typename: 'SupplierConfiguration';
  config: Maybe<Scalars['Object']>;
  createdDate: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  modifiedDate: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  supplierType: Maybe<SupplierType>;
};

export type SupplierConfigurationInput = {
  config?: InputMaybe<Scalars['Object']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  supplierType?: InputMaybe<SupplierType>;
};

export type SupplierIdInput = {
  id: Scalars['ID'];
};

export type SupplierInput = {
  configuration?: InputMaybe<SupplierConfigurationInput>;
  contact?: InputMaybe<ContactInput>;
  createdBy?: InputMaybe<Scalars['Int']>;
  creditLimit?: InputMaybe<Scalars['String']>;
  endpointUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  job?: InputMaybe<JobInfoInput>;
  supplierId?: InputMaybe<Scalars['String']>;
  supplierName?: InputMaybe<Scalars['String']>;
};

export enum SupplierMainType {
  Allserv = 'ALLSERV',
  Api = 'API',
  Csv = 'CSV'
}

export enum SupplierType {
  Allserv = 'ALLSERV',
  Bukalapak = 'BUKALAPAK',
  Csv = 'CSV',
  Seagm = 'SEAGM',
  Unipin = 'UNIPIN'
}

export type SwarmioCurrency = ObjectRepresentation & {
  __typename: 'SwarmioCurrency';
  active: Scalars['Boolean'];
  cashable: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  prettyName: Scalars['String'];
};

export type SwarmioCurrencyExchangeBlock = {
  __typename: 'SwarmioCurrencyExchangeBlock';
  active: Scalars['Boolean'];
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  forThisAmount: Maybe<Scalars['Float']>;
  forThisSwarmioCurrency: SwarmioCurrency;
  forThisSwarmioCurrencyId: Scalars['String'];
  id: Scalars['String'];
  name: Maybe<Scalars['String']>;
  thisAmount: Scalars['Float'];
  thisSwarmioCurrency: SwarmioCurrency;
  thisSwarmioCurrencyId: Scalars['String'];
};

export type SwarmioCurrencyFixedPrizePayoutReceipt = PrizePayoutReceipt & {
  __typename: 'SwarmioCurrencyFixedPrizePayoutReceipt';
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  created: Scalars['Date'];
  id: Scalars['String'];
  notes: Maybe<Scalars['String']>;
  prizePayoutReceiptType: BasicPrizePayoutReceiptType;
  prizeTierId: Scalars['String'];
  successful: Scalars['Boolean'];
  swarmioCurrencyId: Scalars['String'];
};

export type SwarmioCurrencyItem = {
  __typename: 'SwarmioCurrencyItem';
  active: Scalars['Boolean'];
  amount: Scalars['Float'];
  costs: Array<CurrencyItemCost>;
  created: Scalars['Date'];
  dealTagline: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Maybe<Scalars['String']>;
  /** Swarmio Currency */
  swarmioCurrency: SwarmioCurrency;
  swarmioCurrencyId: Scalars['String'];
};

export type SwarmioCurrencyItemCost = CurrencyItemCost & {
  __typename: 'SwarmioCurrencyItemCost';
  cost: Scalars['Float'];
  created: Scalars['Date'];
  /** Swarmio Currency Item */
  currencyItem: SwarmioCurrencyItem;
  currencyItemCostType: CurrencyItemCostType;
  id: Scalars['String'];
  realWorldCurrencyType: RealWorldCurrency;
  swarmioCurrencyItemId: Scalars['String'];
  version: Scalars['Int'];
};

export type SwarmioCurrencyItemCostArchive = CurrencyItemCostArchive & {
  __typename: 'SwarmioCurrencyItemCostArchive';
  cost: Scalars['Float'];
  created: Scalars['Date'];
  /** Swarmio Currency Item */
  currencyItem: SwarmioCurrencyItem;
  currencyItemCostType: CurrencyItemCostType;
  id: Scalars['String'];
  realWorldCurrencyType: RealWorldCurrency;
  swarmioCurrencyItemId: Scalars['String'];
  version: Scalars['Int'];
};

export type SwarmioCurrencyItemCostPurchaseRequest = {
  __typename: 'SwarmioCurrencyItemCostPurchaseRequest';
  created: Scalars['Date'];
  id: Scalars['String'];
  requesterId: Scalars['String'];
  swarmioCurrencyItemCostArchive: SwarmioCurrencyItemCostArchive;
  swarmioCurrencyItemCostArchiveId: Scalars['String'];
};

export type SwarmioCurrencyItemCostRequest = {
  cost: Scalars['Float'];
  maybeExternalId?: InputMaybe<Scalars['String']>;
  realWorldCurrencyType: RealWorldCurrency;
};

export type SwarmioCurrencyPayout = {
  __typename: 'SwarmioCurrencyPayout';
  active: Scalars['Boolean'];
  amount: Scalars['Float'];
  costs: Array<SwarmioCurrencyPayoutCost>;
  created: Scalars['Date'];
  id: Scalars['String'];
  name: Maybe<Scalars['String']>;
  /** Swarmio Currency */
  swarmioCurrency: SwarmioCurrency;
  swarmioCurrencyId: Scalars['String'];
};

export type SwarmioCurrencyPayoutCost = {
  __typename: 'SwarmioCurrencyPayoutCost';
  cost: Scalars['Float'];
  created: Scalars['Date'];
  id: Scalars['String'];
  realWorldCurrencyType: RealWorldCurrency;
  /** Swarmio Currency Payout */
  swarmioCurrencyPayout: SwarmioCurrencyPayout;
  swarmioCurrencyPayoutId: Scalars['String'];
  version: Scalars['Int'];
};

export type SwarmioCurrencyPayoutCostArchive = {
  __typename: 'SwarmioCurrencyPayoutCostArchive';
  cost: Scalars['Float'];
  created: Scalars['Date'];
  id: Scalars['String'];
  realWorldCurrencyType: RealWorldCurrency;
  /** Swarmio Currency Payout */
  swarmioCurrencyPayout: SwarmioCurrencyPayout;
  swarmioCurrencyPayoutId: Scalars['String'];
  version: Scalars['Int'];
};

export type SwarmioCurrencyPayoutCostRequest = {
  cost: Scalars['Float'];
  realWorldCurrencyType: RealWorldCurrency;
};

export type SwarmioCurrencyPayoutPrize = FixedPrize & Prize & {
  __typename: 'SwarmioCurrencyPayoutPrize';
  amount: Scalars['Float'];
  id: Scalars['String'];
  prizeType: PrizeType;
  swarmioCurrencyId: Scalars['String'];
};

export type SwarmioCurrencyPayoutPrizeCreationRequest = {
  amount: Scalars['Float'];
  swarmioCurrencyId: Scalars['String'];
};

export type SwarmioCurrencyPayoutRequest = {
  __typename: 'SwarmioCurrencyPayoutRequest';
  completed: Scalars['Boolean'];
  completedBy: Maybe<Scalars['String']>;
  dateCompleted: Maybe<Scalars['Date']>;
  dateRequested: Scalars['Date'];
  id: Scalars['String'];
  requesterId: Scalars['String'];
  /** The cost at the time of purchase */
  swarmioCurrencyPayoutArchiveCost: SwarmioCurrencyPayoutCostArchive;
  swarmioCurrencyPayoutCostArchiveId: Scalars['String'];
};

export type SwarmioCurrencyReward = {
  __typename: 'SwarmioCurrencyReward';
  amount: Scalars['Float'];
  id: Scalars['String'];
  swarmioCurrencyId: Scalars['String'];
};

export type SwarmioCurrencyRewardCreationRequest = {
  amount: Scalars['Float'];
  swarmioCurrencyId: Scalars['String'];
};

export type SwarmioItem = {
  __typename: 'SwarmioItem';
  active: Scalars['Boolean'];
  catalogIds: Array<Scalars['String']>;
  categoryIds: Array<Scalars['String']>;
  contentType: Maybe<ContentType>;
  costs: Array<ItemCost>;
  description: Maybe<Scalars['String']>;
  externalSKU: Maybe<Scalars['String']>;
  fields: Maybe<Scalars['Object']>;
  id: Scalars['String'];
  images: Array<Scalars['String']>;
  name: Scalars['String'];
  productOrigin: Maybe<OrderStrategy>;
  productType: Maybe<ProductType>;
  provisioner: Provisioner;
  stock: Maybe<Scalars['Int']>;
};

export type SwarmioPayPayment = ObjectRepresentation & {
  __typename: 'SwarmioPayPayment';
  dateReceived: Scalars['Date'];
  /** The amount of currency */
  destinationService: Maybe<Scalars['String']>;
  id: Scalars['String'];
  internalTransactionId: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
  itemId: Maybe<Scalars['String']>;
  paymentProviderTransactionId: Maybe<Scalars['String']>;
  paymentStatus: PaymentStatus;
  /** The type of transaction */
  paymentType: PaymentType;
  receivedAmount: Maybe<Scalars['Float']>;
  receivedCurrency: Maybe<RealWorldCurrency>;
  requestedAmount: Maybe<Scalars['Float']>;
  requestedCurrency: Maybe<RealWorldCurrency>;
};

export type SwarmioSubscription = {
  expiry: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isUsable: Scalars['Boolean'];
  secret: Maybe<Scalars['String']>;
  subscriptionImplementation: SubscriptionImplementation;
  subscriptionState: SubscriptionState;
  subscriptionType: SubscriptionType;
  subscriptionTypeId: Scalars['String'];
};

/** A voucher */
export type SwarmioVoucher = {
  code: Scalars['String'];
  expirationDate: Maybe<Scalars['Date']>;
  id: Scalars['String'];
  issueDate: Scalars['Date'];
  voucherType: VoucherType;
};

/** Swarmio Wallet */
export type SwarmioWallet = {
  __typename: 'SwarmioWallet';
  balance: Scalars['Float'];
  boughtTransactions: PaginatedBoughtTransaction;
  cashOutTransactions: PaginatedCashOutTransaction;
  created: Scalars['Date'];
  exchangedTransactions: PaginatedExchangedTransaction;
  freebieTransactions: PaginatedFreebieTransaction;
  id: Scalars['String'];
  ownerId: Scalars['String'];
  swarmioCurrency: SwarmioCurrency;
  swarmioCurrencyId: Scalars['String'];
  transactions: PaginatedSwarmioWalletTransactionWithMetadata;
  transferTransactions: PaginatedTransferTransaction;
};


/** Swarmio Wallet */
export type SwarmioWalletBoughtTransactionsArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


/** Swarmio Wallet */
export type SwarmioWalletCashOutTransactionsArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


/** Swarmio Wallet */
export type SwarmioWalletExchangedTransactionsArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


/** Swarmio Wallet */
export type SwarmioWalletFreebieTransactionsArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


/** Swarmio Wallet */
export type SwarmioWalletTransactionsArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


/** Swarmio Wallet */
export type SwarmioWalletTransferTransactionsArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};

/** The type of transaction */
export enum SwarmioWalletTransactionType {
  /** Currency purchased with real world currency */
  Bought = 'BOUGHT',
  /** Currency cashed out to real world currency */
  CashOut = 'CASH_OUT',
  /** An Exchange of Currency for other items */
  Exchanged = 'EXCHANGED',
  /** Currency transferred in for free */
  Freebie = 'FREEBIE',
  /** Transfer currency to another wallet */
  Transfer = 'TRANSFER'
}

export type SwarmioWalletTransactionWithMetadata = {
  /** The amount of currency */
  amount: Scalars['Float'];
  /** The date and time of the transaction */
  created: Scalars['Date'];
  /** The transaction object */
  id: Scalars['String'];
  /** The type of transaction */
  transactionType: SwarmioWalletTransactionType;
  wallet: SwarmioWallet;
  /** The ID of the associated Swarmio wallet */
  walletId: Scalars['String'];
};

/** Used to identify objects in our application and provide friendly vanity names supplied by our admins to improve our UX */
export type Tag = {
  __typename: 'Tag';
  localizations: Array<LocalizedString>;
  /** Name of the tag ie "format" */
  name: Scalars['String'];
};

export type TagInput = {
  localizations: Array<LocalizedStringInput>;
  name: Scalars['String'];
};

export type TargetCurrencyPrice = {
  __typename: 'TargetCurrencyPrice';
  currency: Maybe<Scalars['String']>;
  dealPrice: Maybe<Scalars['Float']>;
  dealTagId: Maybe<Scalars['String']>;
  price: Maybe<Scalars['Float']>;
  tagId: Maybe<Scalars['String']>;
};

export type TargetCurrencyPrices = {
  __typename: 'TargetCurrencyPrices';
  currency: Scalars['String'];
  dealPrice: Maybe<Scalars['Float']>;
  dealTagId: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  tagId: Scalars['String'];
};

export type Team = Account & GroupTrait & ObjectRepresentation & {
  __typename: 'Team';
  accountInvites: Array<AccountInviteWithPossibleError>;
  accountType: Scalars['String'];
  avatarURL: Maybe<Scalars['String']>;
  bannerURL: Maybe<Scalars['String']>;
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  eventParticipations: Array<Event>;
  groupInvites: Array<GroupInviteWithPossibleError>;
  groupMembers: Array<GroupMember>;
  groupMemberships: Array<GroupMembership>;
  groupType: Scalars['String'];
  id: Scalars['String'];
  isSupplier: Scalars['Boolean'];
  lastUpdated: Scalars['DateTime'];
  managedAccounts: Array<ManagedAccount>;
  name: Scalars['String'];
  otherFields: Maybe<Array<AccountTag>>;
  ownerId: Scalars['String'];
  payPurchaseTransactions: Array<PayPurchaseTransaction>;
  publicURL: Maybe<Scalars['String']>;
  purchaseTransactions: Array<PurchaseTransaction>;
  socialLinks: Array<SocialLink>;
  subscriptionProviderAccounts: Array<SubscriptionProviderAccount>;
  subscriptions: Array<SwarmioSubscription>;
  updated: Scalars['Date'];
  wallets: Array<SwarmioWallet>;
};

export type TeamCompetitionParticipantCreationRequest = {
  teamId: Scalars['String'];
  teamMembers: Array<IndividualCompetitionParticipantCreationRequest>;
};

export type TeamCreationRequest = {
  avatarURL?: InputMaybe<Scalars['String']>;
  bannerURL?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  otherFields?: InputMaybe<Array<AccountTagInput>>;
  ownerId: Scalars['String'];
  publicURL?: InputMaybe<Scalars['String']>;
  socialLinks?: InputMaybe<Array<SocialLinkInput>>;
};

export type TeamEventEntryRules = EventEntryRules & {
  __typename: 'TeamEventEntryRules';
  id: Scalars['String'];
  maximumTeamMembers: Maybe<Scalars['Int']>;
  minimumTeamMembers: Maybe<Scalars['Int']>;
};

export type TeamEventEntryRulesCreationRequest = {
  exactTeamSize?: InputMaybe<Scalars['Int']>;
  maximumTeamMembers?: InputMaybe<Scalars['Int']>;
  minimumTeamMembers?: InputMaybe<Scalars['Int']>;
};

export type TeamEventEntryRulesUpdateRequest = {
  exactTeamSize?: InputMaybe<Scalars['Int']>;
  maximumTeamMembers?: InputMaybe<Scalars['Int']>;
  minimumTeamMembers?: InputMaybe<Scalars['Int']>;
};

export type TeamParticipant = Participant & {
  __typename: 'TeamParticipant';
  accountId: Scalars['String'];
  confirmed: Scalars['Boolean'];
  created: Scalars['Date'];
  id: Scalars['String'];
  participantType: ParticipantType;
  requirementsNotMet: Array<ParticipantRequirementNotMet>;
  result: Maybe<Result>;
  team: Maybe<Team>;
  teamId: Scalars['String'];
  teamMemberRequirementsNotMet: Array<ParticipantRequirementNotMet>;
  teamMembers: Array<IndividualParticipant>;
};

export type TeamUpdateRequest = {
  avatarURL?: InputMaybe<Scalars['String']>;
  bannerURL?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  otherFieldsToAdd?: InputMaybe<Array<AccountTagInput>>;
  otherFieldsToRemove?: InputMaybe<Array<Scalars['String']>>;
  publicURL?: InputMaybe<Scalars['String']>;
  removeAvatarURL?: InputMaybe<Scalars['Boolean']>;
  removeBannerURL?: InputMaybe<Scalars['Boolean']>;
  removePublicURL?: InputMaybe<Scalars['Boolean']>;
  socialLinks?: InputMaybe<Array<SocialLinkInput>>;
};

export type TechnicalParticipant = EventTeamMember & {
  __typename: 'TechnicalParticipant';
  accountId: Scalars['String'];
  id: Scalars['String'];
  participant: Participant;
  roles: Array<GamingRole>;
};

/** A tournament */
export type Tournament = Competition & {
  __typename: 'Tournament';
  bracketModifications: Array<BracketModifications>;
  brackets: Array<TournamentBracket>;
  competitionState: EventElementState;
  competitionTiming: Maybe<CompetitionTiming>;
  competitionType: CompetitionType;
  created: Scalars['Date'];
  event: Event;
  eventId: Scalars['String'];
  eventStageId: Scalars['String'];
  game: Game;
  gameId: Scalars['String'];
  gameSpecificDetails: Maybe<GameSpecificCompetitionDetails>;
  id: Scalars['String'];
  isSimulated: Scalars['Boolean'];
  manualAdvancement: Scalars['Boolean'];
  numberOfRounds: Scalars['Int'];
  participantType: ParticipantType;
  participants: Array<CompetitionParticipantReference>;
  phaseBufferTime: Maybe<Scalars['DurationInMilliseconds']>;
  tournamentFormat: TournamentFormat;
  tournamentFormatSpecificDetails: Maybe<TournamentSpecificDetails>;
};

/** A generic bracket in a tournament */
export type TournamentBracket = {
  __typename: 'TournamentBracket';
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  name: TournamentBracketName;
  phases: Array<TournamentPhase>;
};

export enum TournamentBracketName {
  LowerBracket = 'LowerBracket',
  SingleElimination = 'SingleElimination',
  UpperBracket = 'UpperBracket'
}

export type TournamentCreationRequest = {
  manualAdvancement: Scalars['Boolean'];
  numberOfRounds: Scalars['Int'];
  phaseBufferTime?: InputMaybe<Scalars['DurationInMilliseconds']>;
  prunedDoubleEliminationSpecificDetails?: InputMaybe<PrunedDoubleEliminationDetailsCreationRequest>;
  prunedSingleEliminationSpecificDetails?: InputMaybe<PrunedSingleEliminationDetailsCreationRequest>;
  singleEliminationSpecificDetails?: InputMaybe<SingleEliminationDetailsCreationRequest>;
  startTime?: InputMaybe<Scalars['Date']>;
  tournamentFormat: TournamentFormat;
};

export enum TournamentFormat {
  PrunedDoubleElimination = 'PrunedDoubleElimination',
  PrunedSingleElimination = 'PrunedSingleElimination',
  SingleElimination = 'SingleElimination'
}

/** A tournament match */
export type TournamentMatch = {
  assets: Array<Tag>;
  gameSpecificDetails: Maybe<GameSpecificCompetitionDetails>;
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  startTime: Maybe<Scalars['Date']>;
};

export type TournamentMatchBye = CompetitionMatch & TournamentMatch & {
  __typename: 'TournamentMatchBye';
  assets: Array<Tag>;
  gameSpecificDetails: Maybe<GameSpecificCompetitionDetails>;
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  participants: Array<CompetitionParticipantReferenceWithRoster>;
  startTime: Maybe<Scalars['Date']>;
};

/** A generic phase in a tournament */
export type TournamentPhase = {
  __typename: 'TournamentPhase';
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  matches: Array<TournamentMatch>;
  phaseNumber: Scalars['Int'];
};

/** A generic round in a tournament */
export type TournamentRound = {
  __typename: 'TournamentRound';
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  participants: Array<CompetitionParticipantReference>;
  roundNumber: Scalars['Int'];
};

export type TournamentSpecificDetails = {
  id: Scalars['String'];
  maybeMaxRoundParticipants: Maybe<Scalars['Int']>;
  maybeParticipantsInRound: Maybe<Scalars['Int']>;
  tournamentFormat: TournamentFormat;
};

/** Transfer currency from one wallet to another */
export type TransferTransaction = SwarmioWalletTransactionWithMetadata & {
  __typename: 'TransferTransaction';
  amount: Scalars['Float'];
  created: Scalars['Date'];
  id: Scalars['String'];
  notes: Maybe<Scalars['String']>;
  otherWalletId: Scalars['String'];
  /** The type of transaction */
  transactionType: SwarmioWalletTransactionType;
  wallet: SwarmioWallet;
  walletId: Scalars['String'];
};

export type TransferTransactionRequest = {
  amount: Scalars['Float'];
  notes?: InputMaybe<Scalars['String']>;
  toOwnerId: Scalars['String'];
};

export type TwitchStream = Stream & {
  __typename: 'TwitchStream';
  id: Scalars['String'];
  url: Scalars['String'];
  username: Scalars['String'];
  weight: Maybe<Scalars['Int']>;
};

export type TwitchStreamCreationRequest = {
  username: Scalars['String'];
  weight?: InputMaybe<Scalars['Int']>;
};

export type UnappliedPayment = {
  __typename: 'UnappliedPayment';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  id: Scalars['String'];
  notes: Maybe<Scalars['String']>;
  received: Scalars['DateTime'];
  state: UnappliedPaymentState;
};

export enum UnappliedPaymentState {
  Excess = 'Excess',
  Invalid = 'Invalid',
  NotEnough = 'NotEnough',
  OverRefund = 'OverRefund',
  TooEarly = 'TooEarly',
  WrongCurrency = 'WrongCurrency'
}

export type UnreadyIndividualParticipant = IndividualParticipant & Participant & {
  __typename: 'UnreadyIndividualParticipant';
  accountId: Scalars['String'];
  confirmed: Scalars['Boolean'];
  created: Scalars['Date'];
  id: Scalars['String'];
  inviteLink: Maybe<IndividualParticipantInviteLink>;
  maybeGameAccountId: Maybe<Scalars['String']>;
  participantType: ParticipantType;
  person: Maybe<Person>;
  requirementsNotMet: Array<ParticipantRequirementNotMet>;
  result: Maybe<Result>;
};

export type UpcomingKingOfTheHillParticipant = {
  __typename: 'UpcomingKingOfTheHillParticipant';
  display: Scalars['Boolean'];
  expectedStartTime: Maybe<Scalars['Date']>;
  order: Maybe<Scalars['Int']>;
  participant: CompetitionParticipantReferenceWithRoster;
};

export type UpdateDisabledPaymentChannelInput = {
  disabledPaymentChannels?: InputMaybe<Array<InputMaybe<PartnerItemPaymentChannelInput>>>;
  itemId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  paymentType?: InputMaybe<Scalars['String']>;
};

export type UpdateDisabledPaymentChannelResponse = {
  __typename: 'UpdateDisabledPaymentChannelResponse';
  disabledPaymentChannels: Maybe<Array<Maybe<PartnerItemPaymentChannelResponse>>>;
  itemId: Maybe<Scalars['ID']>;
  partnerId: Maybe<Scalars['ID']>;
  paymentType: Maybe<Scalars['String']>;
};

export type UpdateHiveContactRequest = HiveContact & HiveContactWithPossibleError & WithUnverifiedHiveContact & {
  __typename: 'UpdateHiveContactRequest';
  contact: Scalars['String'];
  contactType: HiveContactType;
  isError: Scalars['Boolean'];
  newContact: Scalars['String'];
  verified: Scalars['Boolean'];
};

export type UpdatePartnerItemPaymentChannelInput = {
  itemId: Scalars['ID'];
  partnerId: Scalars['ID'];
  updatedPartnerItemPaymentChannels?: InputMaybe<Array<InputMaybe<UpdatedPartnerItemPaymentChannelInput>>>;
};

export type UpdatePartnerItemPaymentChannelResponse = {
  __typename: 'UpdatePartnerItemPaymentChannelResponse';
  itemId: Maybe<Scalars['ID']>;
  partnerId: Maybe<Scalars['ID']>;
  updatedPartnerItemPaymentChannels: Maybe<Array<Maybe<UpdatedPartnerItemPaymentChannelResponse>>>;
};

export type UpdatedPartnerItemPaymentChannelInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  markedUpPercentage?: InputMaybe<Scalars['Float']>;
  paymentChannelId?: InputMaybe<Scalars['Int']>;
};

export type UpdatedPartnerItemPaymentChannelResponse = {
  __typename: 'UpdatedPartnerItemPaymentChannelResponse';
  channelId: Maybe<Scalars['String']>;
  channelName: Maybe<Scalars['String']>;
  isEnabled: Maybe<Scalars['Boolean']>;
  markedUpPercentage: Maybe<Scalars['Float']>;
};

/** An Upload Trait */
export type UploadTrait = {
  expiry: Scalars['Date'];
  id: Scalars['String'];
  mediaType: MediaType;
  weight: Maybe<Scalars['Float']>;
};

/** A user */
export type User = {
  accountManagers: Array<AccountManagerWithPossibleError>;
  accountType: Scalars['String'];
  avatarURL: Maybe<Scalars['String']>;
  bannerURL: Maybe<Scalars['String']>;
  contactIdentifier: StringAttributeWithPossibleError;
  created: Scalars['Date'];
  description: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  email: Maybe<StringAttributeWithPossibleError>;
  emailContact: Maybe<HiveContactWithPossibleError>;
  emailVerified: Scalars['Boolean'];
  groupInvites: Array<GroupInviteWithPossibleError>;
  groupMemberships: Array<GroupMembership>;
  hasValidContact: Scalars['Boolean'];
  id: Scalars['String'];
  managedAccounts: Array<ManagedAccountWithPossibleError>;
  msisdn: Maybe<StringAttributeWithPossibleError>;
  msisdnContact: Maybe<HiveContactWithPossibleError>;
  msisdnVerified: Scalars['Boolean'];
  otherFields: Maybe<Array<AccountTag>>;
  publicURL: Maybe<Scalars['String']>;
  socialLinks: Array<SocialLink>;
  updated: Scalars['Date'];
  userType: Scalars['String'];
  wallets: Array<SwarmioWallet>;
};

export type ValorantCompetitionDetails = GameSpecificCompetitionDetails & GameSpecificDetails & {
  __typename: 'ValorantCompetitionDetails';
  gameId: Scalars['String'];
  matchType: ValorantMatchType;
};

export type ValorantCompetitionDetailsCreationRequest = {
  matchType: ValorantMatchType;
};

export enum ValorantMatchType {
  Competitive = 'Competitive',
  Unrated = 'Unrated'
}

export type VariablePrize = Prize & {
  __typename: 'VariablePrize';
  conditionalPrizes: Array<VariablePrizeCondition>;
  defaultPrize: FixedPrize;
  id: Scalars['String'];
  prizeType: PrizeType;
};

/** The criteria for qualifying for this prize variation */
export type VariablePrizeCondition = {
  description: Scalars['String'];
  id: Scalars['String'];
  order: Scalars['Int'];
  prize: FixedPrize;
  variablePrizeConditionType: VariablePrizeConditionType;
};

/** The type of variable prize condition */
export enum VariablePrizeConditionType {
  SpecificSubscriptionPrizeConditionType = 'SpecificSubscriptionPrizeConditionType',
  SubscriptionPrizeConditionType = 'SubscriptionPrizeConditionType'
}

export type VariablePrizeCreationRequest = {
  customDefaultPrize?: InputMaybe<CustomPrizeCreationRequest>;
  specificSubscriptionConditionalPrizes?: InputMaybe<Array<SpecificSubscriptionPrizeConditionCreationRequest>>;
  subscriptionConditionalPrizes?: InputMaybe<Array<SubscriptionPrizeConditionCreationRequest>>;
  swarmioCurrencyPayoutDefaultPrize?: InputMaybe<SwarmioCurrencyPayoutPrizeCreationRequest>;
};

export type VerifiedHiveContact = HiveContact & HiveContactWithPossibleError & {
  __typename: 'VerifiedHiveContact';
  contact: Scalars['String'];
  contactType: HiveContactType;
  isError: Scalars['Boolean'];
  verified: Scalars['Boolean'];
};

export type Voucher = {
  __typename: 'Voucher';
  expirationDate: Maybe<Scalars['String']>;
  pin: Maybe<Scalars['String']>;
  serial: Maybe<Scalars['String']>;
  voucherId: Maybe<Scalars['ID']>;
};

export type VoucherFilterInput = {
  status?: InputMaybe<VoucherStatus>;
};

export type VoucherInventory = {
  __typename: 'VoucherInventory';
  batchId: Maybe<Scalars['ID']>;
  createdDate: Maybe<Scalars['String']>;
  currency: Maybe<Scalars['String']>;
  id: Maybe<Scalars['ID']>;
  modifiedDate: Maybe<Scalars['String']>;
  status: Maybe<InventoryStatus>;
  stockCount: Maybe<Scalars['Int']>;
  unitPrice: Maybe<Scalars['Float']>;
};

export enum VoucherStatus {
  Deleted = 'DELETED',
  Sold = 'SOLD',
  Unsold = 'UNSOLD'
}

/** The type of voucher */
export enum VoucherType {
  Integrated = 'INTEGRATED',
  NonIntegrated = 'NON_INTEGRATED'
}

/** A contact with an unverified element */
export type WithUnverifiedHiveContact = {
  contact: Scalars['String'];
  contactType: HiveContactType;
  isError: Scalars['Boolean'];
  newContact: Scalars['String'];
  verified: Scalars['Boolean'];
};

export type YouTubeStream = Stream & {
  __typename: 'YouTubeStream';
  channelId: Scalars['String'];
  id: Scalars['String'];
  url: Scalars['String'];
  weight: Maybe<Scalars['Int']>;
};

export type YouTubeStreamCreationRequest = {
  channelId: Scalars['String'];
  weight?: InputMaybe<Scalars['Int']>;
};

export type YouTubeVideo = Stream & {
  __typename: 'YouTubeVideo';
  id: Scalars['String'];
  url: Scalars['String'];
  videoId: Scalars['String'];
  weight: Maybe<Scalars['Int']>;
};

export type YouTubeVideoCreationRequest = {
  videoId: Scalars['String'];
  weight?: InputMaybe<Scalars['Int']>;
};

export type CategoryInput = {
  categoryCoverImage?: InputMaybe<Scalars['String']>;
  categoryDescription?: InputMaybe<Scalars['String']>;
  categoryIcon?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  categoryImage?: InputMaybe<Scalars['String']>;
  categoryName?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  groupOrder?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  parentCategory?: InputMaybe<Scalars['Int']>;
  productGroupCatalogCategory?: InputMaybe<Array<InputMaybe<ProductGroupCatalogCategoryInput>>>;
  urlMask?: InputMaybe<Scalars['String']>;
};

export type Cms_BannersAccess = {
  __typename: 'cms_bannersAccess';
  create: Maybe<CmsBannersCreateAccess>;
  delete: Maybe<CmsBannersDeleteAccess>;
  fields: Maybe<CmsBannersFields>;
  read: Maybe<CmsBannersReadAccess>;
  update: Maybe<CmsBannersUpdateAccess>;
};

export type Cms_BannersDocAccess = {
  __typename: 'cms_bannersDocAccess';
  create: Maybe<CmsBannersCreateDocAccess>;
  delete: Maybe<CmsBannersDeleteDocAccess>;
  fields: Maybe<CmsBannersDocAccessFields>;
  read: Maybe<CmsBannersReadDocAccess>;
  update: Maybe<CmsBannersUpdateDocAccess>;
};

export type Cms_Blog_PagesAccess = {
  __typename: 'cms_blog_pagesAccess';
  create: Maybe<CmsBlogPagesCreateAccess>;
  delete: Maybe<CmsBlogPagesDeleteAccess>;
  fields: Maybe<CmsBlogPagesFields>;
  read: Maybe<CmsBlogPagesReadAccess>;
  update: Maybe<CmsBlogPagesUpdateAccess>;
};

export type Cms_Blog_PagesDocAccess = {
  __typename: 'cms_blog_pagesDocAccess';
  create: Maybe<CmsBlogPagesCreateDocAccess>;
  delete: Maybe<CmsBlogPagesDeleteDocAccess>;
  fields: Maybe<CmsBlogPagesDocAccessFields>;
  read: Maybe<CmsBlogPagesReadDocAccess>;
  update: Maybe<CmsBlogPagesUpdateDocAccess>;
};

export type Cms_Blog_PostsAccess = {
  __typename: 'cms_blog_postsAccess';
  create: Maybe<CmsBlogPostsCreateAccess>;
  delete: Maybe<CmsBlogPostsDeleteAccess>;
  fields: Maybe<CmsBlogPostsFields>;
  read: Maybe<CmsBlogPostsReadAccess>;
  update: Maybe<CmsBlogPostsUpdateAccess>;
};

export type Cms_Blog_PostsDocAccess = {
  __typename: 'cms_blog_postsDocAccess';
  create: Maybe<CmsBlogPostsCreateDocAccess>;
  delete: Maybe<CmsBlogPostsDeleteDocAccess>;
  fields: Maybe<CmsBlogPostsDocAccessFields>;
  read: Maybe<CmsBlogPostsReadDocAccess>;
  update: Maybe<CmsBlogPostsUpdateDocAccess>;
};

export type Cms_GamersAccess = {
  __typename: 'cms_gamersAccess';
  create: Maybe<CmsGamersCreateAccess>;
  delete: Maybe<CmsGamersDeleteAccess>;
  fields: Maybe<CmsGamersFields>;
  read: Maybe<CmsGamersReadAccess>;
  update: Maybe<CmsGamersUpdateAccess>;
};

export type Cms_GamersDocAccess = {
  __typename: 'cms_gamersDocAccess';
  create: Maybe<CmsGamersCreateDocAccess>;
  delete: Maybe<CmsGamersDeleteDocAccess>;
  fields: Maybe<CmsGamersDocAccessFields>;
  read: Maybe<CmsGamersReadDocAccess>;
  update: Maybe<CmsGamersUpdateDocAccess>;
};

export type Cms_GamesAccess = {
  __typename: 'cms_gamesAccess';
  create: Maybe<CmsGamesCreateAccess>;
  delete: Maybe<CmsGamesDeleteAccess>;
  fields: Maybe<CmsGamesFields>;
  read: Maybe<CmsGamesReadAccess>;
  update: Maybe<CmsGamesUpdateAccess>;
};

export type Cms_GamesDocAccess = {
  __typename: 'cms_gamesDocAccess';
  create: Maybe<CmsGamesCreateDocAccess>;
  delete: Maybe<CmsGamesDeleteDocAccess>;
  fields: Maybe<CmsGamesDocAccessFields>;
  read: Maybe<CmsGamesReadDocAccess>;
  update: Maybe<CmsGamesUpdateDocAccess>;
};

export type Cms_MediaAccess = {
  __typename: 'cms_mediaAccess';
  create: Maybe<CmsMediaCreateAccess>;
  delete: Maybe<CmsMediaDeleteAccess>;
  fields: Maybe<CmsMediaFields>;
  read: Maybe<CmsMediaReadAccess>;
  update: Maybe<CmsMediaUpdateAccess>;
};

export type Cms_MediaDocAccess = {
  __typename: 'cms_mediaDocAccess';
  create: Maybe<CmsMediaCreateDocAccess>;
  delete: Maybe<CmsMediaDeleteDocAccess>;
  fields: Maybe<CmsMediaDocAccessFields>;
  read: Maybe<CmsMediaReadDocAccess>;
  update: Maybe<CmsMediaUpdateDocAccess>;
};

export type CountCmsBanners = {
  __typename: 'countCmsBanners';
  totalDocs: Maybe<Scalars['Int']>;
};

export type CountCmsBlogPages = {
  __typename: 'countCmsBlogPages';
  totalDocs: Maybe<Scalars['Int']>;
};

export type CountCmsBlogPosts = {
  __typename: 'countCmsBlogPosts';
  totalDocs: Maybe<Scalars['Int']>;
};

export type CountCmsGamers = {
  __typename: 'countCmsGamers';
  totalDocs: Maybe<Scalars['Int']>;
};

export type CountCmsGames = {
  __typename: 'countCmsGames';
  totalDocs: Maybe<Scalars['Int']>;
};

export type CountCmsMedias = {
  __typename: 'countCmsMedias';
  totalDocs: Maybe<Scalars['Int']>;
};

export type CountCmsUsers = {
  __typename: 'countCmsUsers';
  totalDocs: Maybe<Scalars['Int']>;
};

export type CountPayloadLockedDocuments = {
  __typename: 'countPayloadLockedDocuments';
  totalDocs: Maybe<Scalars['Int']>;
};

export type CountPayloadPreferences = {
  __typename: 'countPayloadPreferences';
  totalDocs: Maybe<Scalars['Int']>;
};

export type MutationCmsBannerInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  relatedPost?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCmsBannerUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  relatedPost?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCmsBlogPageInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<Array<InputMaybe<MutationCmsBlogPage_SectionsInput>>>;
  slug: Scalars['String'];
  status?: InputMaybe<CmsBlogPage_Status_MutationInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCmsBlogPageUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<Array<InputMaybe<MutationCmsBlogPageUpdate_SectionsInput>>>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CmsBlogPageUpdate_Status_MutationInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCmsBlogPageUpdate_SectionsInput = {
  featuredBanners?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuredBlogPosts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuredGamers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuredGames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  sectionTitle?: InputMaybe<Scalars['String']>;
  sectionType: CmsBlogPageUpdate_Sections_SectionType_MutationInput;
};

export type MutationCmsBlogPage_SectionsInput = {
  featuredBanners?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuredBlogPosts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuredGamers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  featuredGames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  sectionTitle?: InputMaybe<Scalars['String']>;
  sectionType: CmsBlogPage_Sections_SectionType_MutationInput;
};

export type MutationCmsBlogPostInput = {
  content: Scalars['JSON'];
  createdAt?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  featuredImage?: InputMaybe<Scalars['String']>;
  relatedPosts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<Array<InputMaybe<MutationCmsBlogPost_VideosInput>>>;
};

export type MutationCmsBlogPostUpdateInput = {
  content?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  relatedPosts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<Array<InputMaybe<MutationCmsBlogPostUpdate_VideosInput>>>;
};

export type MutationCmsBlogPostUpdate_VideosInput = {
  embedId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type MutationCmsBlogPost_VideosInput = {
  embedId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type MutationCmsGameInput = {
  avatar?: InputMaybe<Scalars['String']>;
  company: Scalars['String'];
  content: Scalars['JSON'];
  createdAt?: InputMaybe<Scalars['String']>;
  gameBanner?: InputMaybe<Scalars['String']>;
  gameLink: Scalars['String'];
  gameTrailerEmbedId: MutationCmsGame_GameTrailerEmbedIdInput;
  images?: InputMaybe<Array<InputMaybe<MutationCmsGame_ImagesInput>>>;
  name: Scalars['String'];
  relatedGames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CmsGame_Status_MutationInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCmsGameUpdateInput = {
  avatar?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['String']>;
  gameBanner?: InputMaybe<Scalars['String']>;
  gameLink?: InputMaybe<Scalars['String']>;
  gameTrailerEmbedId: MutationCmsGameUpdate_GameTrailerEmbedIdInput;
  images?: InputMaybe<Array<InputMaybe<MutationCmsGameUpdate_ImagesInput>>>;
  name?: InputMaybe<Scalars['String']>;
  relatedGames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CmsGameUpdate_Status_MutationInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCmsGameUpdate_GameTrailerEmbedIdInput = {
  embedId: Scalars['String'];
  title: Scalars['String'];
};

export type MutationCmsGameUpdate_ImagesInput = {
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
};

export type MutationCmsGame_GameTrailerEmbedIdInput = {
  embedId: Scalars['String'];
  title: Scalars['String'];
};

export type MutationCmsGame_ImagesInput = {
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
};

export type MutationCmsGamerInput = {
  avatar?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  gamerSocialMedia?: InputMaybe<Array<InputMaybe<MutationCmsGamer_GamerSocialMediaInput>>>;
  name?: InputMaybe<Scalars['String']>;
  nickname: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCmsGamerUpdateInput = {
  avatar?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  gamerSocialMedia?: InputMaybe<Array<InputMaybe<MutationCmsGamerUpdate_GamerSocialMediaInput>>>;
  name?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCmsGamerUpdate_GamerSocialMediaInput = {
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<CmsGamerUpdate_GamerSocialMedia_Platform_MutationInput>;
};

export type MutationCmsGamer_GamerSocialMediaInput = {
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<CmsGamer_GamerSocialMedia_Platform_MutationInput>;
};

export type MutationCmsMediaInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  focalX?: InputMaybe<Scalars['Float']>;
  focalY?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  sizes?: InputMaybe<MutationCmsMedia_SizesInput>;
  thumbnailURL?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationCmsMediaUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  focalX?: InputMaybe<Scalars['Float']>;
  focalY?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  sizes?: InputMaybe<MutationCmsMediaUpdate_SizesInput>;
  thumbnailURL?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationCmsMediaUpdate_SizesInput = {
  thumbnail?: InputMaybe<MutationCmsMediaUpdate_Sizes_ThumbnailInput>;
};

export type MutationCmsMediaUpdate_Sizes_ThumbnailInput = {
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationCmsMedia_SizesInput = {
  thumbnail?: InputMaybe<MutationCmsMedia_Sizes_ThumbnailInput>;
};

export type MutationCmsMedia_Sizes_ThumbnailInput = {
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationCmsUserInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  hash?: InputMaybe<Scalars['String']>;
  lockUntil?: InputMaybe<Scalars['String']>;
  loginAttempts?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  password: Scalars['String'];
  resetPasswordExpiration?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  salt?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCmsUserUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  hash?: InputMaybe<Scalars['String']>;
  lockUntil?: InputMaybe<Scalars['String']>;
  loginAttempts?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  resetPasswordExpiration?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  salt?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationPayloadLockedDocumentInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  document?: InputMaybe<PayloadLockedDocument_DocumentRelationshipInput>;
  globalSlug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PayloadLockedDocument_UserRelationshipInput>;
};

export type MutationPayloadLockedDocumentUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  document?: InputMaybe<PayloadLockedDocumentUpdate_DocumentRelationshipInput>;
  globalSlug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PayloadLockedDocumentUpdate_UserRelationshipInput>;
};

export type MutationPayloadPreferenceInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PayloadPreference_UserRelationshipInput>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type MutationPayloadPreferenceUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PayloadPreferenceUpdate_UserRelationshipInput>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type PartnerDataForItem = {
  __typename: 'partnerDataForItem';
  id: Maybe<Scalars['ID']>;
  isPartnerMappedToItem: Maybe<Scalars['Boolean']>;
  partnerId: Maybe<Scalars['ID']>;
  partnerName: Maybe<Scalars['String']>;
};

export type Payload_Locked_DocumentsAccess = {
  __typename: 'payload_locked_documentsAccess';
  create: Maybe<PayloadLockedDocumentsCreateAccess>;
  delete: Maybe<PayloadLockedDocumentsDeleteAccess>;
  fields: Maybe<PayloadLockedDocumentsFields>;
  read: Maybe<PayloadLockedDocumentsReadAccess>;
  update: Maybe<PayloadLockedDocumentsUpdateAccess>;
};

export type Payload_Locked_DocumentsDocAccess = {
  __typename: 'payload_locked_documentsDocAccess';
  create: Maybe<PayloadLockedDocumentsCreateDocAccess>;
  delete: Maybe<PayloadLockedDocumentsDeleteDocAccess>;
  fields: Maybe<PayloadLockedDocumentsDocAccessFields>;
  read: Maybe<PayloadLockedDocumentsReadDocAccess>;
  update: Maybe<PayloadLockedDocumentsUpdateDocAccess>;
};

export type Payload_PreferencesAccess = {
  __typename: 'payload_preferencesAccess';
  create: Maybe<PayloadPreferencesCreateAccess>;
  delete: Maybe<PayloadPreferencesDeleteAccess>;
  fields: Maybe<PayloadPreferencesFields>;
  read: Maybe<PayloadPreferencesReadAccess>;
  update: Maybe<PayloadPreferencesUpdateAccess>;
};

export type Payload_PreferencesDocAccess = {
  __typename: 'payload_preferencesDocAccess';
  create: Maybe<PayloadPreferencesCreateDocAccess>;
  delete: Maybe<PayloadPreferencesDeleteDocAccess>;
  fields: Maybe<PayloadPreferencesDocAccessFields>;
  read: Maybe<PayloadPreferencesReadDocAccess>;
  update: Maybe<PayloadPreferencesUpdateDocAccess>;
};

export type AddSltAccountMutationVariables = Exact<{
  accountId: Scalars['String'];
  sltAccountCreationRequest: SltAccountCreationRequest;
}>;


export type AddSltAccountMutation = { addSLTAccount: (
    { __typename: 'Group', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> }
    & UserProviderAccounts_Group_Fragment
  ) | (
    { __typename: 'InternalService', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> }
    & UserProviderAccounts_InternalService_Fragment
  ) | (
    { __typename: 'Person', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> }
    & UserProviderAccounts_Person_Fragment
  ) | (
    { __typename: 'Team', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> }
    & UserProviderAccounts_Team_Fragment
  ) };

export type ValidateSltAccountQueryVariables = Exact<{
  accountId: Scalars['String'];
  sltAccountCreationRequest: SltAccountCreationRequest;
}>;


export type ValidateSltAccountQuery = { validateSLTAccount: boolean };

export type GetUserForLinkedGamesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserForLinkedGamesQuery = { user: { __typename: 'InternalService', id: string } | { __typename: 'Person', id: string, gameAccounts: Array<(
      { __typename: 'GameAccount' }
      & GameAccountFragment
    )> } | null };

export type AccountNotificationFragment = { __typename: 'AccountNotification', id: string, read: boolean, expiry: string, created: string, defaultMessage: string, notificationType: string, fields: { [key: string]: any } | null };

export type GetNotificationsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetNotificationsQuery = { getNotifications: Array<(
    { __typename: 'AccountNotification' }
    & AccountNotificationFragment
  )> };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  accountId: Scalars['String'];
  notificationIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type MarkNotificationsAsReadMutation = { markNotificationsAsRead: number };

export type NewNotificationSubscriptionVariables = Exact<{
  personId: Scalars['String'];
  notificationTypes: Array<Scalars['String']> | Scalars['String'];
}>;


export type NewNotificationSubscription = { AccountNotification: { __typename: 'AccountNotificationEvent', read: boolean, fields: { [key: string]: any } | null, id: string, created: string, expiry: string, defaultMessage: string, notificationType: string } | { __typename: 'ClientNotificationEvent', id: string, created: string, expiry: string, defaultMessage: string, notificationType: string } };

export type GroupMembershipOnMinimalUserFragment = { __typename: 'GroupMembership', id: string, group: { __typename: 'Group', id: string, publicURL: string | null } | { __typename: 'Team', id: string, publicURL: string | null } };

type Msisdn_ActionNotAllowedError_Fragment = { __typename: 'ActionNotAllowedError' };

type Msisdn_StringAttribute_Fragment = { __typename: 'StringAttribute', value: string };

export type MsisdnFragment = Msisdn_ActionNotAllowedError_Fragment | Msisdn_StringAttribute_Fragment;

export type GameAccountOnMinimalUserFragment = { __typename: 'GameAccount', id: string, gameIds: Array<string>, gameAccountTypeId: string };

export type GetMinimalUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMinimalUserQuery = { user: { __typename: 'InternalService', id: string, displayName: string | null, msisdnVerified: boolean, avatarURL: string | null, email: { __typename: 'ActionNotAllowedError', isError: boolean } | { __typename: 'StringAttribute', value: string, isError: boolean } | null, msisdn: (
      { __typename: 'ActionNotAllowedError' }
      & Msisdn_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'StringAttribute' }
      & Msisdn_StringAttribute_Fragment
    ) | null, wallets: Array<{ __typename: 'SwarmioWallet', id: string, balance: number, swarmioCurrency: { __typename: 'SwarmioCurrency', id: string } }>, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipOnMinimalUserFragment
    )> } | { __typename: 'Person', id: string, displayName: string | null, msisdnVerified: boolean, avatarURL: string | null, gameAccounts: Array<(
      { __typename: 'GameAccount' }
      & GameAccountOnMinimalUserFragment
    )>, email: { __typename: 'ActionNotAllowedError', isError: boolean } | { __typename: 'StringAttribute', value: string, isError: boolean } | null, msisdn: (
      { __typename: 'ActionNotAllowedError' }
      & Msisdn_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'StringAttribute' }
      & Msisdn_StringAttribute_Fragment
    ) | null, wallets: Array<{ __typename: 'SwarmioWallet', id: string, balance: number, swarmioCurrency: { __typename: 'SwarmioCurrency', id: string } }>, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipOnMinimalUserFragment
    )> } | null };

export type GetUserForPermissionsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserForPermissionsQuery = { user: { __typename: 'InternalService', id: string } | { __typename: 'Person', id: string } | null };

export type ProductGroupFragment = { __typename: 'CategoryProductGroupResponse', id: string | null, productGroupId: string | null, description: string | null, bannerImage: string | null, thumbnail: string | null, featured: boolean | null, urlMask: string | null, productGroupName: string | null, name: string | null, items: Array<{ __typename: 'CatalogItem', id: string | null, itemId: string, displayName: string | null, itemName: string | null, itemType: ItemType | null, itemDescBrief: string | null, itemDescDetail: string | null, stock: number | null, isActive: boolean | null, itemImageUrl: string | null, itemGalleryUrls: Array<string | null> | null, fields: { [key: string]: any } | null, productType: ProductType | null, productOrigin: OrderStrategy | null, outOfStockImageUrl: string | null, productId: string | null, contentType: ContentType | null, availablePaymentChannels: Array<string | null> | null, productPrices: Array<{ __typename: 'ProductPrice', paymentChannelId: string | null, paymentChannelName: string | null, paymentMethod: string | null, targetCurrencyPrices: Array<{ __typename: 'TargetCurrencyPrice', currency: string | null, dealPrice: number | null, dealTagId: string | null, price: number | null, tagId: string | null } | null> | null } | null> | null } | null> | null };

export type CatalogItemProductPriceFragment = { __typename: 'ProductPrice', paymentChannelId: string | null, paymentChannelName: string | null, paymentMethod: string | null, targetCurrencyPrices: Array<(
    { __typename: 'TargetCurrencyPrice' }
    & CatalogItemTargetCurrencyPriceFragment
  ) | null> | null };

export type CatalogItemTargetCurrencyPriceFragment = { __typename: 'TargetCurrencyPrice', currency: string | null, price: number | null, tagId: string | null, dealPrice: number | null, dealTagId: string | null };

export type CatalogItemFragment = { __typename: 'CatalogItem', isActive: boolean | null, itemDescBrief: string | null, itemDescDetail: string | null, itemGalleryUrls: Array<string | null> | null, itemId: string, itemImageUrl: string | null, outOfStockImageUrl: string | null, displayName: string | null, itemName: string | null, itemType: ItemType | null, stock: number | null, productOrigin: OrderStrategy | null, productType: ProductType | null, fields: { [key: string]: any } | null, contentType: ContentType | null, availablePaymentChannels: Array<string | null> | null, productPrices: Array<(
    { __typename: 'ProductPrice' }
    & CatalogItemProductPriceFragment
  ) | null> | null };

export type EventParticipationsFragment = { __typename: 'Person', eventParticipations: Array<{ __typename: 'Event', id: string }> };

export type ChallengeFragment = { __typename: 'Challenge', id: string, challengeFormat: ChallengeFormat };

export type RoundParticipantReferenceFragment = { __typename: 'CompetitionParticipantReference', participant: (
    { __typename: 'ReadyIndividualParticipant' }
    & RoundIndividualParticipant_ReadyIndividualParticipant_Fragment
  ) | (
    { __typename: 'TeamParticipant' }
    & RoundTeamParticipantFragment
  ) | (
    { __typename: 'UnreadyIndividualParticipant' }
    & RoundIndividualParticipant_UnreadyIndividualParticipant_Fragment
  ) };

export type RoundTeamParticipantFragment = { __typename: 'TeamParticipant', id: string, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', id: string, gameAccount: { __typename: 'GameAccount', id: string, externalAccountName: string | null, externalAccountId: string | null, gameAccountTypeId: string } | null, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null } | { __typename: 'UnreadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null }>, team: { __typename: 'Team', id: string, name: string, publicURL: string | null, avatarURL: string | null, groupMembers: Array<(
      { __typename: 'GroupMember' }
      & GroupMemberFragment
    )> } | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

type RoundIndividualParticipant_ReadyIndividualParticipant_Fragment = { __typename: 'ReadyIndividualParticipant', id: string, gameAccount: { __typename: 'GameAccount', id: string, externalAccountName: string | null, externalAccountId: string | null, gameAccountTypeId: string } | null, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

type RoundIndividualParticipant_UnreadyIndividualParticipant_Fragment = { __typename: 'UnreadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

export type RoundIndividualParticipantFragment = RoundIndividualParticipant_ReadyIndividualParticipant_Fragment | RoundIndividualParticipant_UnreadyIndividualParticipant_Fragment;

type Competition_Challenge_Fragment = (
  { __typename: 'Challenge', id: string, competitionType: CompetitionType, competitionState: EventElementState, participants: Array<{ __typename: 'CompetitionParticipantReference', participant: { __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'TeamParticipant', accountId: string, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }> } | { __typename: 'UnreadyIndividualParticipant', accountId: string } }> }
  & ChallengeFragment
);

type Competition_MatchUp_Fragment = (
  { __typename: 'MatchUp', id: string, competitionType: CompetitionType, competitionState: EventElementState, participants: Array<{ __typename: 'CompetitionParticipantReference', participant: { __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'TeamParticipant', accountId: string, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }> } | { __typename: 'UnreadyIndividualParticipant', accountId: string } }> }
  & MatchUpFragment
);

type Competition_Tournament_Fragment = (
  { __typename: 'Tournament', id: string, competitionType: CompetitionType, competitionState: EventElementState, participants: Array<{ __typename: 'CompetitionParticipantReference', participant: { __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'TeamParticipant', accountId: string, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }> } | { __typename: 'UnreadyIndividualParticipant', accountId: string } }> }
  & TournamentFragment
);

export type CompetitionFragment = Competition_Challenge_Fragment | Competition_MatchUp_Fragment | Competition_Tournament_Fragment;

export type CsgoMatchDetailsFragment = { __typename: 'CSGOMatchDetails', serverDetails: { __typename: 'ServerDetails', serverUrl: string, password: string | null } };

export type GroupMemberFragment = { __typename: 'GroupMember', id: string, account: { __typename: 'Group', id: string } | { __typename: 'InternalService', id: string } | { __typename: 'Person', id: string } | { __typename: 'Team', id: string }, roles: Array<(
    { __typename: 'Role' }
    & RoleIdFragment
  )> };

export type BattleRoyaleSpecificDetailsFragment = { __typename: 'BattleRoyaleSpecificDetails', maxRoundParticipants: number, advanceFraction: number, definedBucketDimensionsMap: { __typename: 'BucketDimensionsMap', id: string, bucketLabel: string, allBucketMultipliers: Array<{ __typename: 'BucketMultipliers', id: string, staticValue: number | null, resultBucket: { __typename: 'ResultBucket', id: string, bucketTop: number, bucketBottom: number | null }, dimensionMultipliers: Array<{ __typename: 'DimensionMultiplier', id: string, dimensionId: string, multiplier: number }> }> } };

export type RemainingParticipantReferenceFragment = { __typename: 'CompetitionParticipantReferenceWithRoster', participant: (
    { __typename: 'ReadyIndividualParticipant' }
    & MatchUpIndividualParticipant_ReadyIndividualParticipant_Fragment
  ) | (
    { __typename: 'TeamParticipant' }
    & MatchUpTeamParticipantFragment
  ) | (
    { __typename: 'UnreadyIndividualParticipant' }
    & MatchUpIndividualParticipant_UnreadyIndividualParticipant_Fragment
  ) };

export type UpcomingKingOfTheHillParticipantFragment = { __typename: 'UpcomingKingOfTheHillParticipant', order: number | null, expectedStartTime: string | null, display: boolean, participant: (
    { __typename: 'CompetitionParticipantReferenceWithRoster' }
    & RemainingParticipantReferenceFragment
  ) };

type KingOfTheHillHostIndividualParticipant_ReadyIndividualParticipant_Fragment = (
  { __typename: 'ReadyIndividualParticipant' }
  & MatchUpIndividualParticipant_ReadyIndividualParticipant_Fragment
);

type KingOfTheHillHostIndividualParticipant_UnreadyIndividualParticipant_Fragment = (
  { __typename: 'UnreadyIndividualParticipant' }
  & MatchUpIndividualParticipant_UnreadyIndividualParticipant_Fragment
);

export type KingOfTheHillHostIndividualParticipantFragment = KingOfTheHillHostIndividualParticipant_ReadyIndividualParticipant_Fragment | KingOfTheHillHostIndividualParticipant_UnreadyIndividualParticipant_Fragment;

export type KingOfTheHillHostTeamParticipantFragment = (
  { __typename: 'TeamParticipant' }
  & MatchUpTeamParticipantFragment
);

export type KingOfTheHillSpecificDetailsFragment = { __typename: 'KingOfTheHillSpecificDetails', host: (
    { __typename: 'ReadyIndividualParticipant', accountId: string }
    & KingOfTheHillHostIndividualParticipant_ReadyIndividualParticipant_Fragment
  ) | (
    { __typename: 'TeamParticipant', accountId: string }
    & KingOfTheHillHostTeamParticipantFragment
  ) | (
    { __typename: 'UnreadyIndividualParticipant', accountId: string }
    & KingOfTheHillHostIndividualParticipant_UnreadyIndividualParticipant_Fragment
  ), remainingParticipants: Array<(
    { __typename: 'UpcomingKingOfTheHillParticipant' }
    & UpcomingKingOfTheHillParticipantFragment
  )> };

export type CsgoCompetitionDetailsFragment = { __typename: 'CSGOCompetitionDetails', maxOvertimeRounds: number | null, maxRounds: number | null };

export type MatchUpRoundFragment = { __typename: 'MatchUpRound', id: string, roundNumber: number, isComplete: boolean, participants: Array<(
    { __typename: 'CompetitionParticipantReference' }
    & RoundParticipantReferenceFragment
  )> };

type MatchUpIndividualParticipant_ReadyIndividualParticipant_Fragment = { __typename: 'ReadyIndividualParticipant', id: string, gameAccount: { __typename: 'GameAccount', id: string, externalAccountName: string | null, externalAccountId: string | null, gameAccountTypeId: string } | null, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

type MatchUpIndividualParticipant_UnreadyIndividualParticipant_Fragment = { __typename: 'UnreadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

export type MatchUpIndividualParticipantFragment = MatchUpIndividualParticipant_ReadyIndividualParticipant_Fragment | MatchUpIndividualParticipant_UnreadyIndividualParticipant_Fragment;

export type MatchUpTeamParticipantFragment = { __typename: 'TeamParticipant', id: string, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', id: string, gameAccount: { __typename: 'GameAccount', id: string, externalAccountName: string | null, externalAccountId: string | null, gameAccountTypeId: string } | null, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null } | { __typename: 'UnreadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null }>, team: { __typename: 'Team', id: string, name: string, publicURL: string | null, avatarURL: string | null, groupMembers: Array<{ __typename: 'GroupMember', id: string, account: { __typename: 'Group', id: string } | { __typename: 'InternalService', id: string } | { __typename: 'Person', id: string } | { __typename: 'Team', id: string }, roles: Array<{ __typename: 'Role', roleId: string }> }> } | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

export type PlayableMatchUpMatchFragment = { __typename: 'PlayableMatchUpMatch', id: string, startTime: string | null, isComplete: boolean, gameSpecificDetails: (
    { __typename: 'CSGOCompetitionDetails' }
    & CsgoCompetitionDetailsFragment
  ) | (
    { __typename: 'CSGOMatchDetails' }
    & CsgoMatchDetailsFragment
  ) | { __typename: 'ValorantCompetitionDetails' } | null, rounds: Array<(
    { __typename: 'MatchUpRound' }
    & MatchUpRoundFragment
  )>, participants: Array<{ __typename: 'CompetitionParticipantReferenceWithRoster', participant: (
      { __typename: 'ReadyIndividualParticipant' }
      & MatchUpIndividualParticipant_ReadyIndividualParticipant_Fragment
    ) | (
      { __typename: 'TeamParticipant' }
      & MatchUpTeamParticipantFragment
    ) | (
      { __typename: 'UnreadyIndividualParticipant' }
      & MatchUpIndividualParticipant_UnreadyIndividualParticipant_Fragment
    ) }> };

export type MatchUpPhaseFragment = { __typename: 'MatchUpPhase', id: string, phaseNumber: number, isComplete: boolean, matches: Array<{ __typename: 'MatchUpMatchBye', id: string } | (
    { __typename: 'PlayableMatchUpMatch', id: string }
    & PlayableMatchUpMatchFragment
  )> };

export type MatchUpFragment = { __typename: 'MatchUp', id: string, matchUpFormat: MatchUpFormat, matchUpFormatSpecificDetails: (
    { __typename: 'BattleRoyaleSpecificDetails' }
    & BattleRoyaleSpecificDetailsFragment
  ) | (
    { __typename: 'KingOfTheHillSpecificDetails' }
    & KingOfTheHillSpecificDetailsFragment
  ) | null, phases: Array<(
    { __typename: 'MatchUpPhase' }
    & MatchUpPhaseFragment
  )> };

type PrizePayoutReceipt_CustomPrizePayoutReceipt_Fragment = { __typename: 'CustomPrizePayoutReceipt', id: string, prizeTierId: string };

type PrizePayoutReceipt_SwarmioCurrencyFixedPrizePayoutReceipt_Fragment = { __typename: 'SwarmioCurrencyFixedPrizePayoutReceipt', id: string, prizeTierId: string };

export type PrizePayoutReceiptFragment = PrizePayoutReceipt_CustomPrizePayoutReceipt_Fragment | PrizePayoutReceipt_SwarmioCurrencyFixedPrizePayoutReceipt_Fragment;

export type BasicResultFragment = { __typename: 'BasicResult', id: string, resultImageURLs: Array<string> | null, prizePayoutReceipt: (
    { __typename: 'CustomPrizePayoutReceipt' }
    & PrizePayoutReceipt_CustomPrizePayoutReceipt_Fragment
  ) | (
    { __typename: 'SwarmioCurrencyFixedPrizePayoutReceipt' }
    & PrizePayoutReceipt_SwarmioCurrencyFixedPrizePayoutReceipt_Fragment
  ) | null };

export type ManualResultFragment = { __typename: 'ManualResult', id: string, resultImageURLs: Array<string> | null, prizePayoutReceipt: (
    { __typename: 'CustomPrizePayoutReceipt' }
    & PrizePayoutReceipt_CustomPrizePayoutReceipt_Fragment
  ) | (
    { __typename: 'SwarmioCurrencyFixedPrizePayoutReceipt' }
    & PrizePayoutReceipt_SwarmioCurrencyFixedPrizePayoutReceipt_Fragment
  ) | null };

export type MultiDimensionalBucketBasedResultFragment = { __typename: 'MultiDimensionalBucketBasedResult', id: string, bucketValue: number, calculatedScore: number, resultImageURLs: Array<string> | null, multiDimensionalResults: Array<{ __typename: 'SingleDimensionResult', dimensionId: string, value: number }>, prizePayoutReceipt: (
    { __typename: 'CustomPrizePayoutReceipt' }
    & PrizePayoutReceipt_CustomPrizePayoutReceipt_Fragment
  ) | (
    { __typename: 'SwarmioCurrencyFixedPrizePayoutReceipt' }
    & PrizePayoutReceipt_SwarmioCurrencyFixedPrizePayoutReceipt_Fragment
  ) | null };

type Result_BasicResult_Fragment = (
  { __typename: 'BasicResult', score: number | null, placement: number | null, showed: boolean }
  & BasicResultFragment
);

type Result_ManualResult_Fragment = (
  { __typename: 'ManualResult', score: number | null, placement: number | null, showed: boolean }
  & ManualResultFragment
);

type Result_MultiDimensionalBucketBasedResult_Fragment = (
  { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null, showed: boolean }
  & MultiDimensionalBucketBasedResultFragment
);

export type ResultFragment = Result_BasicResult_Fragment | Result_ManualResult_Fragment | Result_MultiDimensionalBucketBasedResult_Fragment;

export type TournamentFragment = { __typename: 'Tournament', id: string, tournamentFormat: TournamentFormat, phaseBufferTime: number | null };

export type EventStageFragment = { __typename: 'EventStage', id: string, stageNumber: number, competitions: Array<(
    { __typename: 'Challenge' }
    & Competition_Challenge_Fragment
  ) | (
    { __typename: 'MatchUp' }
    & Competition_MatchUp_Fragment
  ) | (
    { __typename: 'Tournament' }
    & Competition_Tournament_Fragment
  )> };

export type TeamEventEntryRulesFragment = { __typename: 'TeamEventEntryRules', id: string, minimumTeamMembers: number | null, maximumTeamMembers: number | null };

export type TeamEventGameFragment = { __typename: 'Game', id: string, estimatedRoundLength: number, bufferTime: number, prettyName: string };

export type EventGameAccountTypesFragment = { __typename: 'GameAccountType', id: string, prettyName: string, imageUrl: string | null, integrated: boolean, accountNameLabel: string | null, requiresExternalAccountId: boolean, accountIDLabel: string | null };

export type EventFragment = { __typename: 'Event', id: string, category: EventCategory, participantType: ParticipantType, eventState: EventElementState, participantCount: number, region: Region | null, localizedDescriptions: Array<{ __typename: 'LocalizedOptionalString', locale: Locale, value: string | null }>, localizedMediaContentDetails: Array<{ __typename: 'LocalizedMediaContentDetails', locale: Locale, value: { __typename: 'MediaContentDetails', avatar: string | null, banner: string | null, descriptionImage: string | null, streams: Array<(
        { __typename: 'TwitchStream' }
        & TwitchStreamFragment
      ) | (
        { __typename: 'YouTubeStream' }
        & YouTubeStreamFragment
      ) | (
        { __typename: 'YouTubeVideo' }
        & YouTubeVideoFragment
      )> | null } }>, localizedNames: Array<{ __typename: 'LocalizedString', value: string, locale: Locale }>, gameAccountTypes: Array<(
    { __typename: 'GameAccountType' }
    & EventGameAccountTypesFragment
  )>, game: (
    { __typename: 'Game' }
    & TeamEventGameFragment
  ), eventTiming: { __typename: 'EventTiming', startTime: string, registrationOpen: string, registrationClose: string }, eventLimitations: { __typename: 'EventLimitations', maximumParticipants: number | null, minimumParticipants: number | null, checkInMode: CheckInMode, requiredAdditionalInformation: Array<string> | null, localizedWrittenRules: Array<{ __typename: 'LocalizedOptionalString', locale: Locale, value: string | null }>, localizedJoinInstructions: Array<{ __typename: 'LocalizedOptionalString', locale: Locale, value: string | null }>, eventEntryRules: (
      { __typename: 'TeamEventEntryRules' }
      & TeamEventEntryRulesFragment
    ) | null } | null, eventStages: Array<(
    { __typename: 'EventStage' }
    & EventStageFragment
  )>, eventCurrencyExchanges: { __typename: 'EventCurrencyExchanges', prizeList: (
      { __typename: 'PrizeList' }
      & PrizeListFragment
    ) | null }, tags: Array<(
    { __typename: 'Tag' }
    & TagFragment
  )> };

export type SltExternalSubscriptionPackageFragment = { __typename: 'SLTProviderExternalSubscriptionPackage', dataQuota: number | null };

export type ExternalSubscriptionPackageFragment = (
  { __typename: 'SLTProviderExternalSubscriptionPackage', id: string, subscriptionPartner: SubscriptionPartner, subscriptionProvider: SubscriptionProvider, subscriptionType: { __typename: 'SubscriptionType', id: string }, costs: Array<{ __typename: 'RealWorldCurrencyCost', currency: RealWorldCurrencyTypeFinalMix, id: string, amount: number, frequency: PaymentFrequency }> }
  & SltExternalSubscriptionPackageFragment
);

export type GameAccountTypeFragment = { __typename: 'GameAccountType', id: string, prettyName: string, integrated: boolean, accountIDLabel: string | null, accountNameLabel: string | null, implicitGameIds: Array<string>, requiresExternalAccountId: boolean, imageUrl: string | null, iconUrl: string | null };

export type GameAccountFragment = { __typename: 'GameAccount', id: string, gameIds: Array<string>, gameAccountTypeId: string, externalAccountName: string | null, externalAccountId: string | null };

export type GameFragment = { __typename: 'Game', id: string, prettyName: string, description: string | null, image: string | null, integrated: boolean, gameAccountTypeIds: Array<string>, weight: number | null, gameAccountTypes: Array<(
    { __typename: 'GameAccountType' }
    & GameAccountTypeFragment
  )> };

export type GroupInviteFragment = { __typename: 'GroupInvite', id: string, group: { __typename: 'Group', id: string, name: string, avatarURL: string | null, publicURL: string | null } | { __typename: 'Team', id: string, name: string, avatarURL: string | null, publicURL: string | null } | null };

type GroupInviteWithPossibleError_ActionNotAllowedError_Fragment = { __typename: 'ActionNotAllowedError' };

type GroupInviteWithPossibleError_GroupInvite_Fragment = (
  { __typename: 'GroupInvite' }
  & GroupInviteFragment
);

export type GroupInviteWithPossibleErrorFragment = GroupInviteWithPossibleError_ActionNotAllowedError_Fragment | GroupInviteWithPossibleError_GroupInvite_Fragment;

export type GroupMemberOnGroupMembershipFragment = { __typename: 'GroupMember', id: string, roles: Array<{ __typename: 'Role', roleId: string }>, account: { __typename: 'Group', id: string } | { __typename: 'InternalService', id: string } | { __typename: 'Person', displayName: string | null, avatarURL: string | null, publicURL: string | null, id: string } | { __typename: 'Team', id: string } };

type GroupTrait_Group_Fragment = { __typename: 'Group', id: string, avatarURL: string | null, bannerURL: string | null, name: string, ownerId: string, publicURL: string | null, groupMembers: Array<(
    { __typename: 'GroupMember' }
    & GroupMemberOnGroupMembershipFragment
  )> };

type GroupTrait_Team_Fragment = { __typename: 'Team', id: string, avatarURL: string | null, bannerURL: string | null, name: string, ownerId: string, publicURL: string | null, groupMembers: Array<(
    { __typename: 'GroupMember' }
    & GroupMemberOnGroupMembershipFragment
  )> };

export type GroupTraitFragment = GroupTrait_Group_Fragment | GroupTrait_Team_Fragment;

export type GroupMembershipFragment = { __typename: 'GroupMembership', id: string, roles: Array<{ __typename: 'Role', roleId: string }>, group: (
    { __typename: 'Group' }
    & GroupTrait_Group_Fragment
  ) | (
    { __typename: 'Team' }
    & GroupTrait_Team_Fragment
  ) };

export type SwarmioCurrencyPayoutPrizeFragment = { __typename: 'SwarmioCurrencyPayoutPrize', id: string, swarmioCurrencyId: string, amount: number, prizeType: PrizeType };

export type CustomPrizeFragment = { __typename: 'CustomPrize', id: string, prizeType: PrizeType, localizedDescriptions: Array<{ __typename: 'LocalizedString', locale: Locale, value: string }> };

type FixedPrize_CustomPrize_Fragment = (
  { __typename: 'CustomPrize', id: string, prizeType: PrizeType }
  & CustomPrizeFragment
);

type FixedPrize_SwarmioCurrencyPayoutPrize_Fragment = (
  { __typename: 'SwarmioCurrencyPayoutPrize', id: string, prizeType: PrizeType }
  & SwarmioCurrencyPayoutPrizeFragment
);

export type FixedPrizeFragment = FixedPrize_CustomPrize_Fragment | FixedPrize_SwarmioCurrencyPayoutPrize_Fragment;

type VariablePrizeCondition_SpecificSubscriptionPrizeCondition_Fragment = { __typename: 'SpecificSubscriptionPrizeCondition', subscriptionTypeId: string, id: string, description: string, order: number, variablePrizeConditionType: VariablePrizeConditionType, prize: (
    { __typename: 'CustomPrize' }
    & FixedPrize_CustomPrize_Fragment
  ) | (
    { __typename: 'SwarmioCurrencyPayoutPrize' }
    & FixedPrize_SwarmioCurrencyPayoutPrize_Fragment
  ) };

type VariablePrizeCondition_SubscriptionPrizeCondition_Fragment = { __typename: 'SubscriptionPrizeCondition', id: string, description: string, order: number, variablePrizeConditionType: VariablePrizeConditionType, prize: (
    { __typename: 'CustomPrize' }
    & FixedPrize_CustomPrize_Fragment
  ) | (
    { __typename: 'SwarmioCurrencyPayoutPrize' }
    & FixedPrize_SwarmioCurrencyPayoutPrize_Fragment
  ) };

export type VariablePrizeConditionFragment = VariablePrizeCondition_SpecificSubscriptionPrizeCondition_Fragment | VariablePrizeCondition_SubscriptionPrizeCondition_Fragment;

export type VariablePrizeFragment = { __typename: 'VariablePrize', id: string, prizeType: PrizeType, conditionalPrizes: Array<(
    { __typename: 'SpecificSubscriptionPrizeCondition' }
    & VariablePrizeCondition_SpecificSubscriptionPrizeCondition_Fragment
  ) | (
    { __typename: 'SubscriptionPrizeCondition' }
    & VariablePrizeCondition_SubscriptionPrizeCondition_Fragment
  )>, defaultPrize: (
    { __typename: 'CustomPrize' }
    & FixedPrize_CustomPrize_Fragment
  ) | (
    { __typename: 'SwarmioCurrencyPayoutPrize' }
    & FixedPrize_SwarmioCurrencyPayoutPrize_Fragment
  ) };

type Prize_CustomPrize_Fragment = (
  { __typename: 'CustomPrize', id: string, prizeType: PrizeType }
  & CustomPrizeFragment
);

type Prize_SwarmioCurrencyPayoutPrize_Fragment = (
  { __typename: 'SwarmioCurrencyPayoutPrize', id: string, prizeType: PrizeType }
  & SwarmioCurrencyPayoutPrizeFragment
);

type Prize_VariablePrize_Fragment = (
  { __typename: 'VariablePrize', id: string, prizeType: PrizeType }
  & VariablePrizeFragment
);

export type PrizeFragment = Prize_CustomPrize_Fragment | Prize_SwarmioCurrencyPayoutPrize_Fragment | Prize_VariablePrize_Fragment;

export type PrizeTierFragment = { __typename: 'PrizeTier', id: string, placement: number, placementRange: number | null, prize: (
    { __typename: 'CustomPrize' }
    & Prize_CustomPrize_Fragment
  ) | (
    { __typename: 'SwarmioCurrencyPayoutPrize' }
    & Prize_SwarmioCurrencyPayoutPrize_Fragment
  ) | (
    { __typename: 'VariablePrize' }
    & Prize_VariablePrize_Fragment
  ) };

export type PrizeListFragment = { __typename: 'PrizeList', id: string, prizeTiers: Array<(
    { __typename: 'PrizeTier' }
    & PrizeTierFragment
  )> };

export type PublicEventParticipationFragment = { __typename: 'Event', id: string, category: EventCategory, participantType: ParticipantType, localizedNames: Array<{ __typename: 'LocalizedString', locale: Locale, value: string }>, game: { __typename: 'Game', prettyName: string }, eventStages: Array<{ __typename: 'EventStage', competitions: Array<{ __typename: 'Challenge', id: string, competitionType: CompetitionType } | { __typename: 'MatchUp', id: string, competitionType: CompetitionType } | { __typename: 'Tournament', id: string, competitionType: CompetitionType }> }>, eventTiming: { __typename: 'EventTiming', startTime: string, completedAt: string | null }, participants: Array<{ __typename: 'ReadyIndividualParticipant', person: { __typename: 'Person', id: string } | null, result: (
      { __typename: 'BasicResult', score: number | null, placement: number | null }
      & Result_BasicResult_Fragment
    ) | (
      { __typename: 'ManualResult', score: number | null, placement: number | null }
      & Result_ManualResult_Fragment
    ) | (
      { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null }
      & Result_MultiDimensionalBucketBasedResult_Fragment
    ) | null } | { __typename: 'TeamParticipant', teamId: string, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', person: { __typename: 'Person', id: string } | null, result: (
        { __typename: 'BasicResult' }
        & Result_BasicResult_Fragment
      ) | (
        { __typename: 'ManualResult' }
        & Result_ManualResult_Fragment
      ) | (
        { __typename: 'MultiDimensionalBucketBasedResult' }
        & Result_MultiDimensionalBucketBasedResult_Fragment
      ) | null } | { __typename: 'UnreadyIndividualParticipant', person: { __typename: 'Person', id: string } | null, result: (
        { __typename: 'BasicResult' }
        & Result_BasicResult_Fragment
      ) | (
        { __typename: 'ManualResult' }
        & Result_ManualResult_Fragment
      ) | (
        { __typename: 'MultiDimensionalBucketBasedResult' }
        & Result_MultiDimensionalBucketBasedResult_Fragment
      ) | null }>, result: { __typename: 'BasicResult', score: number | null, placement: number | null } | { __typename: 'ManualResult', score: number | null, placement: number | null } | { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null } | null } | { __typename: 'UnreadyIndividualParticipant', person: { __typename: 'Person', id: string } | null, result: (
      { __typename: 'BasicResult', score: number | null, placement: number | null }
      & Result_BasicResult_Fragment
    ) | (
      { __typename: 'ManualResult', score: number | null, placement: number | null }
      & Result_ManualResult_Fragment
    ) | (
      { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null }
      & Result_MultiDimensionalBucketBasedResult_Fragment
    ) | null }>, eventCurrencyExchanges: { __typename: 'EventCurrencyExchanges', prizeList: (
      { __typename: 'PrizeList' }
      & PrizeListFragment
    ) | null } };

export type RoleIdFragment = { __typename: 'Role', roleId: string };

export type StoreCategoryFragment = { __typename: 'CategoryCatalog', id: string | null, categoryName: string | null, categoryIcon: string | null, categoryCoverImage: string | null, categoryImage: string | null, featured: boolean | null };

export type StoreItemFragment = { __typename: 'SwarmioItem', id: string, name: string, categoryIds: Array<string>, productType: ProductType | null, productOrigin: OrderStrategy | null, provisioner: Provisioner, images: Array<string>, costs: Array<{ __typename: 'ItemCost', targetCurrencyPrices: { __typename: 'TargetCurrencyPrices', price: number } }> };

export type SubscriptionTypeForEventDetailsFragment = { __typename: 'SubscriptionType', id: string, localizedNames: Array<{ __typename: 'LocalizedString', locale: Locale, value: string }> };

export type SubscriptionTypeFragment = { __typename: 'SubscriptionType', id: string, enrollable: boolean, weight: number | null, localizedDescriptions: Array<{ __typename: 'LocalizedOptionalString', locale: Locale, value: string | null }>, localizedNames: Array<{ __typename: 'LocalizedString', locale: Locale, value: string }>, implicitEnrollments: Array<{ __typename: 'ImplicitEnrollment', id: string, externalSubscriptionPackage: (
      { __typename: 'SLTProviderExternalSubscriptionPackage' }
      & ExternalSubscriptionPackageFragment
    ) }>, explicitEnrollment: { __typename: 'ExplicitEnrollment', id: string, costs: Array<{ __typename: 'RealWorldCurrencyCost', currency: RealWorldCurrencyTypeFinalMix, id: string, amount: number, frequency: PaymentFrequency, created: string, costType: CostType }>, costsArchive: Array<{ __typename: 'RealWorldCurrencyCost', currency: RealWorldCurrencyTypeFinalMix, id: string, amount: number, frequency: PaymentFrequency }> } | null, initialSwarmioCurrencyReward: { __typename: 'SwarmioCurrencyReward', id: string, swarmioCurrencyId: string, amount: number } | null, recurringPayoutBonus: { __typename: 'RecurringReward', id: string, paymentFrequency: PaymentFrequency, swarmioCurrencyId: string, amount: number } | null };

export type SubscriptionTypeWithExternalPackagesFragment = (
  { __typename: 'SubscriptionType' }
  & SubscriptionTypeFragment
);

type SwarmioSubscription_ExplicitSubscription_Fragment = { __typename: 'ExplicitSubscription', subscriptionTypeCostId: string, id: string, subscriptionTypeId: string, subscriptionState: SubscriptionState, subscriptionType: (
    { __typename: 'SubscriptionType' }
    & SubscriptionTypeFragment
  ) };

type SwarmioSubscription_ImplicitSubscription_Fragment = { __typename: 'ImplicitSubscription', id: string, subscriptionTypeId: string, subscriptionState: SubscriptionState, externalSubscriptionPackage: (
    { __typename: 'SLTProviderExternalSubscriptionPackage' }
    & ExternalSubscriptionPackageFragment
  ), subscriptionType: (
    { __typename: 'SubscriptionType' }
    & SubscriptionTypeFragment
  ) };

export type SwarmioSubscriptionFragment = SwarmioSubscription_ExplicitSubscription_Fragment | SwarmioSubscription_ImplicitSubscription_Fragment;

export type TagFragment = { __typename: 'Tag', name: string, localizations: Array<{ __typename: 'LocalizedString', locale: Locale, value: string }> };

export type TwitchStreamFragment = { __typename: 'TwitchStream', id: string, username: string, weight: number | null };

export type UpdateUserAvatarFragment = { __typename: 'Person', id: string, avatarURL: string | null };

export type UpdateUserBannerFragment = { __typename: 'Person', id: string, bannerURL: string | null };

export type SubscriptionProviderAccountFragment = { __typename: 'SLTProviderAccount', id: string, subscriptionProvider: SubscriptionProvider, externalSubscriptionProviderAccountId: string, subscriptionProviderAccountState: SubscriptionProviderAccountState };

type UserProviderAccounts_Group_Fragment = { __typename: 'Group', id: string };

type UserProviderAccounts_InternalService_Fragment = { __typename: 'InternalService', id: string };

type UserProviderAccounts_Person_Fragment = { __typename: 'Person', id: string, subscriptionProviderAccounts: Array<(
    { __typename: 'SLTProviderAccount' }
    & SubscriptionProviderAccountFragment
  )> };

type UserProviderAccounts_Team_Fragment = { __typename: 'Team', id: string };

export type UserProviderAccountsFragment = UserProviderAccounts_Group_Fragment | UserProviderAccounts_InternalService_Fragment | UserProviderAccounts_Person_Fragment | UserProviderAccounts_Team_Fragment;

export type YouTubeStreamFragment = { __typename: 'YouTubeStream', id: string, channelId: string, weight: number | null };

export type YouTubeVideoFragment = { __typename: 'YouTubeVideo', id: string, videoId: string, weight: number | null };

export type CancelScheduledSubscriptionMutationVariables = Exact<{
  accountId: Scalars['String'];
  subscriptionTypeCostId: Scalars['String'];
}>;


export type CancelScheduledSubscriptionMutation = { cancelScheduledSubscription: { __typename: 'ExplicitSubscription', id: string } | { __typename: 'ImplicitSubscription', id: string } };

export type EnrollExplicitSubscriptionMutationVariables = Exact<{
  accountId: Scalars['String'];
  subscriptionTypeCostId: Scalars['String'];
}>;


export type EnrollExplicitSubscriptionMutation = { enrollExplicitSubscription: string };

export type EnrollExternalSubscriptionPackageMutationVariables = Exact<{
  accountId: Scalars['String'];
  packageId: Scalars['String'];
}>;


export type EnrollExternalSubscriptionPackageMutation = { enrollExternalSubscriptionPackage: { __typename: 'Group', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> } | { __typename: 'InternalService', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> } | { __typename: 'Person', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> } | { __typename: 'Team', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> } };

export type GetAllEventGamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEventGamesQuery = { allEventGames: Array<(
    { __typename: 'Game' }
    & GameFragment
  )> };

export type GameAccountTypeWithGamesFragment = (
  { __typename: 'GameAccountType', games: Array<(
    { __typename: 'Game' }
    & GameFragment
  )> }
  & GameAccountTypeFragment
);

export type AllGameAccountTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGameAccountTypesQuery = { allGameAccountTypes: Array<(
    { __typename: 'GameAccountType' }
    & GameAccountTypeWithGamesFragment
  )> };

export type GetAllSubscriptionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSubscriptionTypesQuery = { getAllSubscriptionTypes: Array<(
    { __typename: 'SubscriptionType' }
    & SubscriptionTypeWithExternalPackagesFragment
  )> };

export type GetEventParticipationSummaryQueryVariables = Exact<{
  eventId: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type GetEventParticipationSummaryQuery = { eventParticipantByAccount: { __typename: 'ParticipationData', disqualified: boolean, participant: { __typename: 'ReadyIndividualParticipant', confirmed: boolean } | { __typename: 'TeamParticipant', confirmed: boolean } | { __typename: 'UnreadyIndividualParticipant', confirmed: boolean } } | null };

export type GetEventParticipationsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetEventParticipationsQuery = { user: { __typename: 'InternalService', id: string } | (
    { __typename: 'Person', id: string }
    & EventParticipationsFragment
  ) | null };

export type GetGroupMembershipsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGroupMembershipsQuery = { user: { __typename: 'InternalService', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )> } | { __typename: 'Person', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )> } | null };

export type GetSubscriptionTypesForEventDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionTypesForEventDetailsQuery = { getAllSubscriptionTypes: Array<(
    { __typename: 'SubscriptionType' }
    & SubscriptionTypeForEventDetailsFragment
  )> };

export type GetSubscriptionsForAccountIdQueryVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type GetSubscriptionsForAccountIdQuery = { getSubscriptionsForAccountId: { __typename: 'Group', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> } | { __typename: 'InternalService', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> } | { __typename: 'Person', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> } | { __typename: 'Team', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> } | null };

export type GameAccountOnGroupMemberForEventJoinFragment = { __typename: 'GameAccount', id: string, gameAccountTypeId: string, gameIds: Array<string>, externalAccountId: string | null, externalAccountName: string | null };

type AccountOnGroupMemberForEventJoin_Group_Fragment = { __typename: 'Group', id: string, avatarURL: string | null, publicURL: string | null };

type AccountOnGroupMemberForEventJoin_InternalService_Fragment = { __typename: 'InternalService', id: string, avatarURL: string | null, publicURL: string | null };

type AccountOnGroupMemberForEventJoin_Person_Fragment = { __typename: 'Person', isVIP: boolean, displayName: string | null, id: string, avatarURL: string | null, publicURL: string | null, gameAccounts: Array<(
    { __typename: 'GameAccount' }
    & GameAccountOnGroupMemberForEventJoinFragment
  )> };

type AccountOnGroupMemberForEventJoin_Team_Fragment = { __typename: 'Team', id: string, avatarURL: string | null, publicURL: string | null };

export type AccountOnGroupMemberForEventJoinFragment = AccountOnGroupMemberForEventJoin_Group_Fragment | AccountOnGroupMemberForEventJoin_InternalService_Fragment | AccountOnGroupMemberForEventJoin_Person_Fragment | AccountOnGroupMemberForEventJoin_Team_Fragment;

export type GroupMemberOnTeamForEventJoinFragment = { __typename: 'GroupMember', id: string, account: (
    { __typename: 'Group' }
    & AccountOnGroupMemberForEventJoin_Group_Fragment
  ) | (
    { __typename: 'InternalService' }
    & AccountOnGroupMemberForEventJoin_InternalService_Fragment
  ) | (
    { __typename: 'Person' }
    & AccountOnGroupMemberForEventJoin_Person_Fragment
  ) | (
    { __typename: 'Team' }
    & AccountOnGroupMemberForEventJoin_Team_Fragment
  ) };

export type TeamGroupMembersForEventJoinFragment = { __typename: 'Team', groupMembers: Array<(
    { __typename: 'GroupMember' }
    & GroupMemberOnTeamForEventJoinFragment
  )> };

export type TeamForEventJoinFragment = (
  { __typename: 'Team', id: string, ownerId: string, name: string, description: string | null, bannerURL: string | null, avatarURL: string | null, publicURL: string | null }
  & TeamGroupMembersForEventJoinFragment
);

export type GetTeamForEventJoinQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTeamForEventJoinQuery = { account: { __typename: 'Group' } | { __typename: 'InternalService' } | { __typename: 'Person' } | (
    { __typename: 'Team' }
    & TeamForEventJoinFragment
  ) | null };

export type GameAccountOnAccountForEventJoinFragment = { __typename: 'GameAccount', id: string, gameAccountTypeId: string, gameIds: Array<string>, externalAccountId: string | null, externalAccountName: string | null };

type AccountForEventJoin_Group_Fragment = { __typename: 'Group', id: string, avatarURL: string | null, publicURL: string | null };

type AccountForEventJoin_InternalService_Fragment = { __typename: 'InternalService', id: string, avatarURL: string | null, publicURL: string | null };

type AccountForEventJoin_Person_Fragment = { __typename: 'Person', isVIP: boolean, displayName: string | null, id: string, avatarURL: string | null, publicURL: string | null, gameAccounts: Array<(
    { __typename: 'GameAccount' }
    & GameAccountOnAccountForEventJoinFragment
  )> };

type AccountForEventJoin_Team_Fragment = { __typename: 'Team', id: string, avatarURL: string | null, publicURL: string | null };

export type AccountForEventJoinFragment = AccountForEventJoin_Group_Fragment | AccountForEventJoin_InternalService_Fragment | AccountForEventJoin_Person_Fragment | AccountForEventJoin_Team_Fragment;

export type GetUserForEventJoinQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserForEventJoinQuery = { account: (
    { __typename: 'Group' }
    & AccountForEventJoin_Group_Fragment
  ) | (
    { __typename: 'InternalService' }
    & AccountForEventJoin_InternalService_Fragment
  ) | (
    { __typename: 'Person' }
    & AccountForEventJoin_Person_Fragment
  ) | (
    { __typename: 'Team' }
    & AccountForEventJoin_Team_Fragment
  ) | null };

export type GetUserProviderAccountsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserProviderAccountsQuery = { user: (
    { __typename: 'InternalService' }
    & UserProviderAccounts_InternalService_Fragment
  ) | (
    { __typename: 'Person' }
    & UserProviderAccounts_Person_Fragment
  ) | null };

export type RemoveSubscriptionProviderAccountMutationVariables = Exact<{
  accountId: Scalars['String'];
  subscriptionProvider: SubscriptionProvider;
}>;


export type RemoveSubscriptionProviderAccountMutation = { removeSubscriptionProviderAccount: (
    { __typename: 'Group', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> }
    & UserProviderAccounts_Group_Fragment
  ) | (
    { __typename: 'InternalService', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> }
    & UserProviderAccounts_InternalService_Fragment
  ) | (
    { __typename: 'Person', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> }
    & UserProviderAccounts_Person_Fragment
  ) | (
    { __typename: 'Team', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> }
    & UserProviderAccounts_Team_Fragment
  ) };

export type ResendVerificationSmsMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ResendVerificationSmsMutation = { resendVerificationSMS: boolean };

export type UnenrollExternalSubscriptionPackageMutationVariables = Exact<{
  accountId: Scalars['String'];
  packageId: Scalars['String'];
}>;


export type UnenrollExternalSubscriptionPackageMutation = { unenrollExternalSubscriptionPackage: { __typename: 'Group', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> } | { __typename: 'InternalService', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> } | { __typename: 'Person', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> } | { __typename: 'Team', id: string, subscriptions: Array<(
      { __typename: 'ExplicitSubscription' }
      & SwarmioSubscription_ExplicitSubscription_Fragment
    ) | (
      { __typename: 'ImplicitSubscription' }
      & SwarmioSubscription_ImplicitSubscription_Fragment
    )> } };

export type CancelPendingSubscriptionMutationVariables = Exact<{
  accountId: Scalars['String'];
  subscriptionId: Scalars['String'];
}>;


export type CancelPendingSubscriptionMutation = { cancelPendingSubscription: { __typename: 'ExplicitSubscription', id: string } | { __typename: 'ImplicitSubscription', id: string } };

export type MyInvitationsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MyInvitationsQuery = { user: { __typename: 'InternalService', id: string, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'Person', id: string, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | null };

export type PaySubscriptionWithSwarmioMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type PaySubscriptionWithSwarmioMutation = { paySubscriptionWithSwarmio: string };

export type GetEmbeddedGamesQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetEmbeddedGamesQuery = { getEmbeddedGames: { __typename: 'PaginatedEmbeddedGame', totalCount: number, hasNextPage: boolean, nodes: Array<{ __typename: 'EmbeddedGame', id: string, title: string, desc: string | null, thumbnailURL: string | null, embeddedGameURL: string | null, availability: EmbeddedGameAvailabilityState }> } };

export type CheckMsisdnCodeQueryVariables = Exact<{
  msisdn: Scalars['String'];
  token: Scalars['String'];
}>;


export type CheckMsisdnCodeQuery = { checkMSISDNVerificationCode: boolean };

export type CompleteAccountMutationVariables = Exact<{
  id: Scalars['String'];
  updatePersonRequest: PersonUpdateRequest;
}>;


export type CompleteAccountMutation = { updatePerson: { __typename: 'Person', id: string, displayName: string | null } };

export type ResetPasswordRequestMutationVariables = Exact<{
  contactIdentifier: Scalars['String'];
}>;


export type ResetPasswordRequestMutation = { resetPasswordRequest: boolean };

export type RegisterPersonEmailMutationVariables = Exact<{
  email: Scalars['String'];
  meta?: InputMaybe<RegistrationMeta>;
}>;


export type RegisterPersonEmailMutation = { registerPersonEmail: { __typename: 'Person', id: string } };

export type RegisterPersonMsisdnMutationVariables = Exact<{
  msisdn: Scalars['String'];
  meta?: InputMaybe<RegistrationMeta>;
}>;


export type RegisterPersonMsisdnMutation = { registerPersonMSISDN: { __typename: 'Person', id: string } };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
  contactIdentifier: Scalars['String'];
}>;


export type ResetPasswordMutation = { resetPassword: boolean };

export type GetBlogGameQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBlogGameQuery = { CmsGame: { __typename: 'CmsGame', id: string, name: string, company: string, gameLink: string, content: { [key: string]: any }, gameTrailerEmbedId: { __typename: 'CmsGame_GameTrailerEmbedId', embedId: string | null, title: string | null } | null, images: Array<{ __typename: 'CmsGame_Images', image: { __typename: 'CmsMedia', url: string | null } | null }> | null, gameBanner: { __typename: 'CmsMedia', url: string | null } | null, relatedGames: Array<{ __typename: 'CmsGame', id: string, name: string, shortDescription: string | null, avatar: { __typename: 'CmsMedia', thumbnailURL: string | null } }> | null } | null };

export type GetBlogGamerQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBlogGamerQuery = { CmsGamer: { __typename: 'CmsGamer', id: string, nickname: string, name: string | null, description: string, country: string | null, gamerSocialMedia: Array<{ __typename: 'CmsGamer_GamerSocialMedia', platform: CmsGamer_GamerSocialMedia_Platform | null, link: string | null }> | null, avatar: { __typename: 'CmsMedia', thumbnailURL: string | null } } | null };

export type GetBlogPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBlogPageQuery = { CmsBlogPages: { __typename: 'CmsBlogPages', docs: Array<{ __typename: 'CmsBlogPage', id: string, title: string, slug: string, sections: Array<{ __typename: 'CmsBlogPage_Sections', sectionType: CmsBlogPage_Sections_SectionType | null, sectionTitle: string | null, featuredBanners: Array<{ __typename: 'CmsBanner', id: string, title: string, link: string | null, featuredImage: { __typename: 'CmsMedia', url: string | null }, relatedPost: { __typename: 'CmsBlogPost', id: string } | null }> | null, featuredGames: Array<{ __typename: 'CmsGame', id: string, name: string, avatar: { __typename: 'CmsMedia', thumbnailURL: string | null } }> | null, featuredGamers: Array<{ __typename: 'CmsGamer', id: string, nickname: string, avatar: { __typename: 'CmsMedia', thumbnailURL: string | null } }> | null, featuredBlogPosts: Array<{ __typename: 'CmsBlogPost', id: string, title: string, description: string, featuredImage: { __typename: 'CmsMedia', url: string | null } }> | null }> | null }> } | null };

export type GetBlogPostQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBlogPostQuery = { CmsBlogPost: { __typename: 'CmsBlogPost', id: string, title: string, description: string, content: { [key: string]: any }, updatedAt: string | null, createdAt: string | null, featuredImage: { __typename: 'CmsMedia', url: string | null }, videos: Array<{ __typename: 'CmsBlogPost_Videos', embedId: string | null, id: string | null }> | null, relatedPosts: Array<{ __typename: 'CmsBlogPost', id: string, title: string, description: string, featuredImage: { __typename: 'CmsMedia', url: string | null } }> | null } | null };

export type AddGameToGameAccountMutationVariables = Exact<{
  personId: Scalars['String'];
  gameAccountTypeId: Scalars['String'];
  gameId: Scalars['String'];
}>;


export type AddGameToGameAccountMutation = { addGameToGameAccount: { __typename: 'Person', id: string, gameAccounts: Array<(
      { __typename: 'GameAccount' }
      & GameAccountFragment
    )> } };

export type LinkNonIntegratedGameAccountMutationVariables = Exact<{
  gameAccountName: Scalars['String'];
  personId: Scalars['String'];
  gameAccountTypeId: Scalars['String'];
  gameAccountId?: InputMaybe<Scalars['String']>;
}>;


export type LinkNonIntegratedGameAccountMutation = { linkNonIntegratedGameAccount: { __typename: 'Person', id: string, gameAccounts: Array<(
      { __typename: 'GameAccount' }
      & GameAccountFragment
    )> } };

export type GroupMemberOnCreateTeamFragment = { __typename: 'GroupMember', id: string, account: { __typename: 'Group', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )> } | { __typename: 'InternalService', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )> } | { __typename: 'Person', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )> } | { __typename: 'Team', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )> } };

export type CreateTeamMutationVariables = Exact<{
  createTeamRequest: TeamCreationRequest;
}>;


export type CreateTeamMutation = { createTeam: { __typename: 'Team', id: string, name: string, avatarURL: string | null, ownerId: string, publicURL: string | null, groupMembers: Array<(
      { __typename: 'GroupMember' }
      & GroupMemberOnCreateTeamFragment
    )> } };

export type AddMultiDimensionalBucketBasedResultForVerificationMutationVariables = Exact<{
  manuallyVerifiedResultWithMultiDimensionalBucketBasedResultRequest: ManuallyVerifiedResultWithMultiDimensionalBucketBasedResultRequest;
}>;


export type AddMultiDimensionalBucketBasedResultForVerificationMutation = { addMultiDimensionalBucketBasedResultForVerification: number };

export type ManuallyVerifiedResultsForRoundIdAndParticipantIdQueryVariables = Exact<{
  roundId: Scalars['String'];
  participantId: Scalars['String'];
}>;


export type ManuallyVerifiedResultsForRoundIdAndParticipantIdQuery = { manuallyVerifiedResultsForRoundIdAndParticipantId: Array<{ __typename: 'ManuallyVerifiedResult', id: string, roundId: string | null, participantId: string, competitionId: string, unverifiedResult: { __typename: 'BasicResult' } | { __typename: 'ManualResult' } | (
      { __typename: 'MultiDimensionalBucketBasedResult' }
      & MultiDimensionalBucketBasedResultFragment
    ) | null }> };

export type ConfirmParticipantMutationVariables = Exact<{
  eventId: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type ConfirmParticipantMutation = { confirmParticipant: number };

type IndividualParticipantsForParticipantConfirmation_ReadyIndividualParticipant_Fragment = { __typename: 'ReadyIndividualParticipant', id: string, confirmed: boolean, person: { __typename: 'Person', id: string } | null };

type IndividualParticipantsForParticipantConfirmation_UnreadyIndividualParticipant_Fragment = { __typename: 'UnreadyIndividualParticipant', id: string, confirmed: boolean, person: { __typename: 'Person', id: string } | null };

export type IndividualParticipantsForParticipantConfirmationFragment = IndividualParticipantsForParticipantConfirmation_ReadyIndividualParticipant_Fragment | IndividualParticipantsForParticipantConfirmation_UnreadyIndividualParticipant_Fragment;

export type TeamParticipantsForParticipantConfirmationFragment = { __typename: 'TeamParticipant', id: string, confirmed: boolean, team: { __typename: 'Team', id: string, groupMembers: Array<{ __typename: 'GroupMember', id: string, account: { __typename: 'Group', id: string } | { __typename: 'InternalService', id: string } | { __typename: 'Person', id: string } | { __typename: 'Team', id: string }, roles: Array<{ __typename: 'Role', roleDisplayName: string, roleId: string }> }> } | null, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string } | null } | { __typename: 'UnreadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string } | null }> };

export type TechnicalParticipantForParticipantConfirmationFragment = { __typename: 'TechnicalParticipant', id: string, accountId: string, participant: (
    { __typename: 'ReadyIndividualParticipant' }
    & IndividualParticipantsForParticipantConfirmation_ReadyIndividualParticipant_Fragment
  ) | (
    { __typename: 'TeamParticipant' }
    & TeamParticipantsForParticipantConfirmationFragment
  ) | (
    { __typename: 'UnreadyIndividualParticipant' }
    & IndividualParticipantsForParticipantConfirmation_UnreadyIndividualParticipant_Fragment
  ), roles: Array<{ __typename: 'GamingFullRole', roleDisplayName: string } | { __typename: 'GamingRoleFragment', roleDisplayName: string }> };

export type GetParticipantsForParticipantConfirmationQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetParticipantsForParticipantConfirmationQuery = { event: { __typename: 'Event', id: string, participants: Array<(
      { __typename: 'ReadyIndividualParticipant' }
      & IndividualParticipantsForParticipantConfirmation_ReadyIndividualParticipant_Fragment
    ) | (
      { __typename: 'TeamParticipant' }
      & TeamParticipantsForParticipantConfirmationFragment
    ) | (
      { __typename: 'UnreadyIndividualParticipant' }
      & IndividualParticipantsForParticipantConfirmation_UnreadyIndividualParticipant_Fragment
    )>, eventTeam: Array<{ __typename: 'BaseEventTeamMember', id: string } | (
      { __typename: 'TechnicalParticipant', id: string }
      & TechnicalParticipantForParticipantConfirmationFragment
    )> } | null };

export type GetLaddersTimelineQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetLaddersTimelineQuery = { event: { __typename: 'Event', id: string, eventState: EventElementState, eventTiming: { __typename: 'EventTiming', registrationClose: string } } | null };

export type AddIndividualParticipantMutationVariables = Exact<{
  joinEventRequest: JoinIndividualEventRequest;
}>;


export type AddIndividualParticipantMutation = { addIndividualParticipant: number };

export type AddTeamParticipantMutationVariables = Exact<{
  joinEventRequest: JoinTeamEventRequest;
}>;


export type AddTeamParticipantMutation = { addTeamParticipant: number };

export type GetParticipantsForJoinEventModalQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetParticipantsForJoinEventModalQuery = { event: { __typename: 'Event', id: string, participants: Array<{ __typename: 'ReadyIndividualParticipant', person: { __typename: 'Person', id: string } | null } | { __typename: 'TeamParticipant', team: { __typename: 'Team', id: string } | null } | { __typename: 'UnreadyIndividualParticipant', person: { __typename: 'Person', id: string } | null }> } | null };

export type GetParticipantsForLeaveEventModalQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetParticipantsForLeaveEventModalQuery = { event: { __typename: 'Event', id: string, participants: Array<{ __typename: 'ReadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, avatarURL: string | null, displayName: string | null } | null } | { __typename: 'TeamParticipant', id: string, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, avatarURL: string | null, displayName: string | null } | null } | { __typename: 'UnreadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, avatarURL: string | null, displayName: string | null } | null }>, team: { __typename: 'Team', id: string, name: string, avatarURL: string | null, groupMembers: Array<{ __typename: 'GroupMember', id: string, account: { __typename: 'Group', id: string } | { __typename: 'InternalService', id: string } | { __typename: 'Person', id: string } | { __typename: 'Team', id: string }, roles: Array<{ __typename: 'Role', roleId: string }> }> } | null } | { __typename: 'UnreadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, avatarURL: string | null, displayName: string | null } | null }> } | null };

export type RemoveParticipantMutationVariables = Exact<{
  leaveEventRequest: LeaveEventRequest;
}>;


export type RemoveParticipantMutation = { removeParticipant: number };

export type AddAutomaticallyVerifiedResultForRoundMutationVariables = Exact<{
  accountId: Scalars['String'];
  automaticallyVerifiedResultsForRoundFromParticipant: AutomaticallyVerifiedResultsForRoundFromParticipantInput;
}>;


export type AddAutomaticallyVerifiedResultForRoundMutation = { addAutomaticallyVerifiedResultForRoundId: number };

export type AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQueryVariables = Exact<{
  roundId: Scalars['String'];
  participantId: Scalars['String'];
}>;


export type AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery = { automaticallyVerifiedResultsForRoundAndFromParticipantId: { __typename: 'AutomaticallyVerifiedResultsForRoundFromParticipant', competitionId: string, roundId: string, unverifiedResults: Array<{ __typename: 'BasicAutomaticallyVerifiedResult', score: number, participantId: string }> } | null };

export type EventToMatchUpFragment = { __typename: 'Event', eventState: EventElementState, participantType: ParticipantType, eventStages: Array<(
    { __typename: 'EventStage' }
    & EventStageFragment
  )>, game: { __typename: 'Game', id: string }, eventLimitations: { __typename: 'EventLimitations', localizedJoinInstructions: Array<{ __typename: 'LocalizedOptionalString', locale: Locale, value: string | null }> } | null };

export type GetEventToMatchUpQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetEventToMatchUpQuery = { event: (
    { __typename: 'Event' }
    & EventToMatchUpFragment
  ) | null };

export type MinimalDataForStandingListFragment = { __typename: 'EventStage', id: string, competitions: Array<{ __typename: 'Challenge', challengeFormat: ChallengeFormat, competitionType: CompetitionType, participants: Array<{ __typename: 'CompetitionParticipantReference', accountId: string, result: { __typename: 'BasicResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'ManualResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null, showed: boolean } | null, participant: { __typename: 'ReadyIndividualParticipant', gameAccount: { __typename: 'GameAccount', externalAccountName: string | null } | null, person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } | { __typename: 'TeamParticipant', teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }>, team: { __typename: 'Team', avatarURL: string | null, name: string } | null } | { __typename: 'UnreadyIndividualParticipant', person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } }> } | { __typename: 'MatchUp', competitionType: CompetitionType, participants: Array<{ __typename: 'CompetitionParticipantReference', accountId: string, result: { __typename: 'BasicResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'ManualResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null, showed: boolean } | null, participant: { __typename: 'ReadyIndividualParticipant', gameAccount: { __typename: 'GameAccount', externalAccountName: string | null } | null, person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } | { __typename: 'TeamParticipant', teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }>, team: { __typename: 'Team', avatarURL: string | null, name: string } | null } | { __typename: 'UnreadyIndividualParticipant', person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } }> } | { __typename: 'Tournament', competitionType: CompetitionType, participants: Array<{ __typename: 'CompetitionParticipantReference', accountId: string, result: { __typename: 'BasicResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'ManualResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null, showed: boolean } | null, participant: { __typename: 'ReadyIndividualParticipant', gameAccount: { __typename: 'GameAccount', externalAccountName: string | null } | null, person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } | { __typename: 'TeamParticipant', teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }>, team: { __typename: 'Team', avatarURL: string | null, name: string } | null } | { __typename: 'UnreadyIndividualParticipant', person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } }> }> };

export type CompetitionParticipantReferenceWithSeededMatchIdFragment = { __typename: 'CompetitionParticipantReferenceWithRoster', seededFromCompetitionMatchId: string | null };

export type PersonOnMatchParticipantFragment = { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null };

type MatchIndividualParticipant_ReadyIndividualParticipant_Fragment = { __typename: 'ReadyIndividualParticipant', id: string, accountId: string, person: (
    { __typename: 'Person' }
    & PersonOnMatchParticipantFragment
  ) | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

type MatchIndividualParticipant_UnreadyIndividualParticipant_Fragment = { __typename: 'UnreadyIndividualParticipant', id: string, accountId: string, person: (
    { __typename: 'Person' }
    & PersonOnMatchParticipantFragment
  ) | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

export type MatchIndividualParticipantFragment = MatchIndividualParticipant_ReadyIndividualParticipant_Fragment | MatchIndividualParticipant_UnreadyIndividualParticipant_Fragment;

export type TeamOnMatchParticipantFragment = { __typename: 'Team', id: string, name: string, avatarURL: string | null, groupMembers: Array<{ __typename: 'GroupMember', id: string, account: { __typename: 'Group', id: string } | { __typename: 'InternalService', id: string } | { __typename: 'Person', id: string } | { __typename: 'Team', id: string }, roles: Array<{ __typename: 'Role', roleId: string }> }> };

export type MatchTeamParticipantFragment = { __typename: 'TeamParticipant', id: string, team: (
    { __typename: 'Team' }
    & TeamOnMatchParticipantFragment
  ) | null, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', id: string, accountId: string } | { __typename: 'UnreadyIndividualParticipant', id: string, accountId: string }>, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

type MatchParticipantReference_CompetitionParticipantReference_Fragment = { __typename: 'CompetitionParticipantReference', participant: (
    { __typename: 'ReadyIndividualParticipant' }
    & MatchIndividualParticipant_ReadyIndividualParticipant_Fragment
  ) | (
    { __typename: 'TeamParticipant' }
    & MatchTeamParticipantFragment
  ) | (
    { __typename: 'UnreadyIndividualParticipant' }
    & MatchIndividualParticipant_UnreadyIndividualParticipant_Fragment
  ) };

type MatchParticipantReference_CompetitionParticipantReferenceWithRoster_Fragment = (
  { __typename: 'CompetitionParticipantReferenceWithRoster', participant: (
    { __typename: 'ReadyIndividualParticipant' }
    & MatchIndividualParticipant_ReadyIndividualParticipant_Fragment
  ) | (
    { __typename: 'TeamParticipant' }
    & MatchTeamParticipantFragment
  ) | (
    { __typename: 'UnreadyIndividualParticipant' }
    & MatchIndividualParticipant_UnreadyIndividualParticipant_Fragment
  ) }
  & CompetitionParticipantReferenceWithSeededMatchIdFragment
);

type MatchParticipantReference_EventStageParticipantReference_Fragment = { __typename: 'EventStageParticipantReference', participant: (
    { __typename: 'ReadyIndividualParticipant' }
    & MatchIndividualParticipant_ReadyIndividualParticipant_Fragment
  ) | (
    { __typename: 'TeamParticipant' }
    & MatchTeamParticipantFragment
  ) | (
    { __typename: 'UnreadyIndividualParticipant' }
    & MatchIndividualParticipant_UnreadyIndividualParticipant_Fragment
  ) };

export type MatchParticipantReferenceFragment = MatchParticipantReference_CompetitionParticipantReference_Fragment | MatchParticipantReference_CompetitionParticipantReferenceWithRoster_Fragment | MatchParticipantReference_EventStageParticipantReference_Fragment;

export type TournamentMatchByeFragment = { __typename: 'TournamentMatchBye', id: string, startTime: string | null, participants: Array<(
    { __typename: 'CompetitionParticipantReferenceWithRoster' }
    & MatchParticipantReference_CompetitionParticipantReferenceWithRoster_Fragment
  )> };

export type TournamentRoundFragment = { __typename: 'TournamentRound', id: string };

export type PlayableTournamentMatchFragment = { __typename: 'PlayableTournamentMatch', id: string, startTime: string | null, isComplete: boolean, rounds: Array<(
    { __typename: 'TournamentRound' }
    & TournamentRoundFragment
  )>, gameSpecificDetails: { __typename: 'CSGOCompetitionDetails' } | (
    { __typename: 'CSGOMatchDetails' }
    & CsgoMatchDetailsFragment
  ) | { __typename: 'ValorantCompetitionDetails' } | null, participants: Array<(
    { __typename: 'CompetitionParticipantReferenceWithRoster' }
    & MatchParticipantReference_CompetitionParticipantReferenceWithRoster_Fragment
  )> };

export type TournamentPhaseFragment = { __typename: 'TournamentPhase', id: string, phaseNumber: number, matches: Array<(
    { __typename: 'PlayableTournamentMatch', id: string }
    & PlayableTournamentMatchFragment
  ) | (
    { __typename: 'TournamentMatchBye', id: string }
    & TournamentMatchByeFragment
  )> };

export type TournamentBracketFragment = { __typename: 'TournamentBracket', id: string, name: TournamentBracketName, phases: Array<(
    { __typename: 'TournamentPhase' }
    & TournamentPhaseFragment
  )> };

export type PhaseModificationsFragment = { __typename: 'PhaseModifications', defaultMatchStartTime: string | null, numberOfRounds: number | null, phaseNumber: number, matchModifications: Array<{ __typename: 'MatchModifications', matchId: string, name: string | null, startTime: string | null, assets: Array<{ __typename: 'Tag', name: string }> }> };

export type BracketModificationsFragment = { __typename: 'BracketModifications', bracketName: TournamentBracketName, phaseModifications: Array<(
    { __typename: 'PhaseModifications' }
    & PhaseModificationsFragment
  )> };

export type CompetitionOnBracketsForEventFragment = { __typename: 'Tournament', phaseBufferTime: number | null, numberOfRounds: number, id: string, brackets: Array<(
    { __typename: 'TournamentBracket' }
    & TournamentBracketFragment
  )>, bracketModifications: Array<(
    { __typename: 'BracketModifications' }
    & BracketModificationsFragment
  )> };

export type EventStageOnBracketsForEventFragment = { __typename: 'EventStage', id: string, competitions: Array<{ __typename: 'Challenge' } | { __typename: 'MatchUp' } | (
    { __typename: 'Tournament' }
    & CompetitionOnBracketsForEventFragment
  )> };

export type BracketsForEventFragment = { __typename: 'Event', id: string, eventState: EventElementState, participantCount: number, game: (
    { __typename: 'Game' }
    & TeamEventGameFragment
  ), eventStages: Array<(
    { __typename: 'EventStage' }
    & EventStageOnBracketsForEventFragment
  )> };

export type BracketsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type BracketsQuery = { event: (
    { __typename: 'Event' }
    & BracketsForEventFragment
  ) | null };

type TeamMemberOnMatchParticipant_ReadyIndividualParticipant_Fragment = { __typename: 'ReadyIndividualParticipant', id: string, gameAccount: { __typename: 'GameAccount', id: string, externalAccountName: string | null, externalAccountId: string | null, gameAccountTypeId: string } | null, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null } | null };

type TeamMemberOnMatchParticipant_UnreadyIndividualParticipant_Fragment = { __typename: 'UnreadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null } | null };

export type TeamMemberOnMatchParticipantFragment = TeamMemberOnMatchParticipant_ReadyIndividualParticipant_Fragment | TeamMemberOnMatchParticipant_UnreadyIndividualParticipant_Fragment;

export type ParticipantOnEventMatchFragment = { __typename: 'TeamParticipant', id: string, teamMembers: Array<(
    { __typename: 'ReadyIndividualParticipant' }
    & TeamMemberOnMatchParticipant_ReadyIndividualParticipant_Fragment
  ) | (
    { __typename: 'UnreadyIndividualParticipant' }
    & TeamMemberOnMatchParticipant_UnreadyIndividualParticipant_Fragment
  )>, team: (
    { __typename: 'Team' }
    & TeamOnMatchParticipantFragment
  ) | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

export type PlayableTournamentMatchOnMatchDetailsFragment = { __typename: 'PlayableTournamentMatch', id: string, isComplete: boolean, startTime: string | null, rounds: Array<{ __typename: 'TournamentRound', id: string, participants: Array<(
      { __typename: 'CompetitionParticipantReference' }
      & RoundParticipantReferenceFragment
    )> }>, participants: Array<{ __typename: 'CompetitionParticipantReferenceWithRoster', participant: { __typename: 'ReadyIndividualParticipant' } | (
      { __typename: 'TeamParticipant' }
      & ParticipantOnEventMatchFragment
    ) | { __typename: 'UnreadyIndividualParticipant' } }>, gameSpecificDetails: { __typename: 'CSGOCompetitionDetails' } | (
    { __typename: 'CSGOMatchDetails' }
    & CsgoMatchDetailsFragment
  ) | { __typename: 'ValorantCompetitionDetails' } | null };

export type EventMatchQueryVariables = Exact<{
  matchId: Scalars['String'];
}>;


export type EventMatchQuery = { eventMatch: { __typename: 'OutOfContextMatchUpMatches', competitionId: string, matches: Array<{ __typename: 'MatchUpMatchBye' } | (
      { __typename: 'PlayableMatchUpMatch' }
      & PlayableMatchUpMatchFragment
    ) | (
      { __typename: 'PlayableTournamentMatch' }
      & PlayableTournamentMatchOnMatchDetailsFragment
    ) | { __typename: 'TournamentMatchBye' }> } | { __typename: 'OutOfContextTournamentMatches', competitionId: string, matches: Array<{ __typename: 'MatchUpMatchBye' } | (
      { __typename: 'PlayableMatchUpMatch' }
      & PlayableMatchUpMatchFragment
    ) | (
      { __typename: 'PlayableTournamentMatch' }
      & PlayableTournamentMatchOnMatchDetailsFragment
    ) | { __typename: 'TournamentMatchBye' }> } | null };

export type UnmatchedParticipantsQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type UnmatchedParticipantsQuery = { event: { __typename: 'Event', id: string, participants: Array<{ __typename: 'ReadyIndividualParticipant' } | { __typename: 'TeamParticipant', id: string, team: { __typename: 'Team', id: string, name: string, avatarURL: string | null, publicURL: string | null } | null } | { __typename: 'UnreadyIndividualParticipant' }> } | null };

export type GetEventLaddersDashboardQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetEventLaddersDashboardQuery = { event: { __typename: 'Event', id: string, participantType: ParticipantType, eventState: EventElementState, eventStages: Array<{ __typename: 'EventStage', id: string, competitions: Array<{ __typename: 'Challenge', challengeFormat: ChallengeFormat, competitionType: CompetitionType, participants: Array<{ __typename: 'CompetitionParticipantReference', accountId: string, result: { __typename: 'BasicResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'ManualResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null, showed: boolean } | null, participant: { __typename: 'ReadyIndividualParticipant', gameAccount: { __typename: 'GameAccount', externalAccountName: string | null } | null, person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } | { __typename: 'TeamParticipant', teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }>, team: { __typename: 'Team', avatarURL: string | null, name: string } | null } | { __typename: 'UnreadyIndividualParticipant', person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } }> } | { __typename: 'MatchUp', competitionType: CompetitionType, participants: Array<{ __typename: 'CompetitionParticipantReference', accountId: string, result: { __typename: 'BasicResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'ManualResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null, showed: boolean } | null, participant: { __typename: 'ReadyIndividualParticipant', gameAccount: { __typename: 'GameAccount', externalAccountName: string | null } | null, person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } | { __typename: 'TeamParticipant', teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }>, team: { __typename: 'Team', avatarURL: string | null, name: string } | null } | { __typename: 'UnreadyIndividualParticipant', person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } }> } | { __typename: 'Tournament', competitionType: CompetitionType, participants: Array<{ __typename: 'CompetitionParticipantReference', accountId: string, result: { __typename: 'BasicResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'ManualResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null, showed: boolean } | null, participant: { __typename: 'ReadyIndividualParticipant', gameAccount: { __typename: 'GameAccount', externalAccountName: string | null } | null, person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } | { __typename: 'TeamParticipant', teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }>, team: { __typename: 'Team', avatarURL: string | null, name: string } | null } | { __typename: 'UnreadyIndividualParticipant', person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } }> }> }>, eventTiming: { __typename: 'EventTiming', registrationOpen: string, registrationClose: string, startTime: string, completedAt: string | null } } | null };

export type ReadyParticipantMutationVariables = Exact<{
  eventId: Scalars['String'];
  accountId: Scalars['String'];
  gameAccountId: Scalars['String'];
  additionalInformation?: InputMaybe<Array<AdditionalInformationInput> | AdditionalInformationInput>;
}>;


export type ReadyParticipantMutation = { readyIndividualParticipant: number };

export type AddEventTeamInviteCodeMutationVariables = Exact<{
  eventId: Scalars['String'];
  teamId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type AddEventTeamInviteCodeMutation = { addEventTeamInviteCode: { __typename: 'IndividualParticipantInviteLink', id: string, code: string } };

export type AddToEventTeamMutationVariables = Exact<{
  eventId: Scalars['String'];
  teamId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type AddToEventTeamMutation = { addToEventTeam: boolean };

type MissingParticipantRequirements_EnumMissingParticipantRequirement_Fragment = { __typename: 'EnumMissingParticipantRequirement', entryName: string };

type MissingParticipantRequirements_NotEnoughTeamMembers_Fragment = { __typename: 'NotEnoughTeamMembers', needsMore: number, entryName: string };

export type MissingParticipantRequirementsFragment = MissingParticipantRequirements_EnumMissingParticipantRequirement_Fragment | MissingParticipantRequirements_NotEnoughTeamMembers_Fragment;

type IndividualParticipantMissingRequirements_ReadyIndividualParticipant_Fragment = { __typename: 'ReadyIndividualParticipant', accountId: string, participantType: ParticipantType, requirementsNotMet: Array<{ __typename: 'ParticipantRequirementNotMet', participantID: string, missingParticipantRequirement: (
      { __typename: 'EnumMissingParticipantRequirement' }
      & MissingParticipantRequirements_EnumMissingParticipantRequirement_Fragment
    ) | (
      { __typename: 'NotEnoughTeamMembers' }
      & MissingParticipantRequirements_NotEnoughTeamMembers_Fragment
    ) | null }> };

type IndividualParticipantMissingRequirements_TeamParticipant_Fragment = { __typename: 'TeamParticipant', accountId: string, participantType: ParticipantType, requirementsNotMet: Array<{ __typename: 'ParticipantRequirementNotMet', participantID: string, missingParticipantRequirement: (
      { __typename: 'EnumMissingParticipantRequirement' }
      & MissingParticipantRequirements_EnumMissingParticipantRequirement_Fragment
    ) | (
      { __typename: 'NotEnoughTeamMembers' }
      & MissingParticipantRequirements_NotEnoughTeamMembers_Fragment
    ) | null }> };

type IndividualParticipantMissingRequirements_UnreadyIndividualParticipant_Fragment = { __typename: 'UnreadyIndividualParticipant', accountId: string, participantType: ParticipantType, requirementsNotMet: Array<{ __typename: 'ParticipantRequirementNotMet', participantID: string, missingParticipantRequirement: (
      { __typename: 'EnumMissingParticipantRequirement' }
      & MissingParticipantRequirements_EnumMissingParticipantRequirement_Fragment
    ) | (
      { __typename: 'NotEnoughTeamMembers' }
      & MissingParticipantRequirements_NotEnoughTeamMembers_Fragment
    ) | null }> };

export type IndividualParticipantMissingRequirementsFragment = IndividualParticipantMissingRequirements_ReadyIndividualParticipant_Fragment | IndividualParticipantMissingRequirements_TeamParticipant_Fragment | IndividualParticipantMissingRequirements_UnreadyIndividualParticipant_Fragment;

export type TeamParticipantMissingRequirementsFragment = { __typename: 'TeamParticipant', requirementsNotMet: Array<{ __typename: 'ParticipantRequirementNotMet', participantID: string, missingParticipantRequirement: (
      { __typename: 'EnumMissingParticipantRequirement' }
      & MissingParticipantRequirements_EnumMissingParticipantRequirement_Fragment
    ) | (
      { __typename: 'NotEnoughTeamMembers' }
      & MissingParticipantRequirements_NotEnoughTeamMembers_Fragment
    ) | null }>, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string, participantType: ParticipantType, requirementsNotMet: Array<{ __typename: 'ParticipantRequirementNotMet', participantID: string, missingParticipantRequirement: (
        { __typename: 'EnumMissingParticipantRequirement' }
        & MissingParticipantRequirements_EnumMissingParticipantRequirement_Fragment
      ) | (
        { __typename: 'NotEnoughTeamMembers' }
        & MissingParticipantRequirements_NotEnoughTeamMembers_Fragment
      ) | null }> } | { __typename: 'UnreadyIndividualParticipant', accountId: string, participantType: ParticipantType, requirementsNotMet: Array<{ __typename: 'ParticipantRequirementNotMet', participantID: string, missingParticipantRequirement: (
        { __typename: 'EnumMissingParticipantRequirement' }
        & MissingParticipantRequirements_EnumMissingParticipantRequirement_Fragment
      ) | (
        { __typename: 'NotEnoughTeamMembers' }
        & MissingParticipantRequirements_NotEnoughTeamMembers_Fragment
      ) | null }> }> };

type EventUsersParticipants_ReadyIndividualParticipant_Fragment = { __typename: 'ReadyIndividualParticipant', id: string, accountId: string, confirmed: boolean, participantType: ParticipantType, requirementsNotMet: Array<{ __typename: 'ParticipantRequirementNotMet', participantID: string, missingParticipantRequirement: (
      { __typename: 'EnumMissingParticipantRequirement' }
      & MissingParticipantRequirements_EnumMissingParticipantRequirement_Fragment
    ) | (
      { __typename: 'NotEnoughTeamMembers' }
      & MissingParticipantRequirements_NotEnoughTeamMembers_Fragment
    ) | null }>, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null, inviteLink: { __typename: 'IndividualParticipantInviteLink', id: string, code: string } | null };

type EventUsersParticipants_UnreadyIndividualParticipant_Fragment = { __typename: 'UnreadyIndividualParticipant', id: string, accountId: string, confirmed: boolean, participantType: ParticipantType, requirementsNotMet: Array<{ __typename: 'ParticipantRequirementNotMet', participantID: string, missingParticipantRequirement: (
      { __typename: 'EnumMissingParticipantRequirement' }
      & MissingParticipantRequirements_EnumMissingParticipantRequirement_Fragment
    ) | (
      { __typename: 'NotEnoughTeamMembers' }
      & MissingParticipantRequirements_NotEnoughTeamMembers_Fragment
    ) | null }>, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null, inviteLink: { __typename: 'IndividualParticipantInviteLink', id: string, code: string } | null };

export type EventUsersParticipantsFragment = EventUsersParticipants_ReadyIndividualParticipant_Fragment | EventUsersParticipants_UnreadyIndividualParticipant_Fragment;

export type GroupMembersTeamEventFragment = { __typename: 'GroupMember', id: string, account: { __typename: 'Group', id: string } | { __typename: 'InternalService', id: string } | { __typename: 'Person', displayName: string | null, avatarURL: string | null, id: string } | { __typename: 'Team', id: string }, roles: Array<{ __typename: 'Role', roleId: string }> };

export type TeamEventDataFragment = { __typename: 'Team', id: string, name: string, ownerId: string, groupMembers: Array<(
    { __typename: 'GroupMember' }
    & GroupMembersTeamEventFragment
  )> };

export type GetEventParticipantByAccountIdQueryVariables = Exact<{
  accountId: Scalars['String'];
  eventId: Scalars['String'];
}>;


export type GetEventParticipantByAccountIdQuery = { eventParticipantByAccount: { __typename: 'ParticipationData', disqualified: boolean, eliminated: boolean | null, participant: (
      { __typename: 'ReadyIndividualParticipant', participantType: ParticipantType }
      & EventUsersParticipants_ReadyIndividualParticipant_Fragment
    ) | { __typename: 'TeamParticipant', id: string, participantType: ParticipantType, team: (
        { __typename: 'Team' }
        & TeamEventDataFragment
      ) | null, teamMembers: Array<(
        { __typename: 'ReadyIndividualParticipant' }
        & EventUsersParticipants_ReadyIndividualParticipant_Fragment
      ) | (
        { __typename: 'UnreadyIndividualParticipant' }
        & EventUsersParticipants_UnreadyIndividualParticipant_Fragment
      )>, requirementsNotMet: Array<{ __typename: 'ParticipantRequirementNotMet', participantID: string, missingParticipantRequirement: (
          { __typename: 'EnumMissingParticipantRequirement' }
          & MissingParticipantRequirements_EnumMissingParticipantRequirement_Fragment
        ) | (
          { __typename: 'NotEnoughTeamMembers' }
          & MissingParticipantRequirements_NotEnoughTeamMembers_Fragment
        ) | null }> } | (
      { __typename: 'UnreadyIndividualParticipant', participantType: ParticipantType }
      & EventUsersParticipants_UnreadyIndividualParticipant_Fragment
    ) } | null };

export type GetEventToDashboardQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetEventToDashboardQuery = { event: { __typename: 'Event', id: string, eventState: EventElementState, participantType: ParticipantType, eventTiming: { __typename: 'EventTiming', startTime: string, registrationClose: string, registrationOpen: string }, eventLimitations: { __typename: 'EventLimitations', checkInMode: CheckInMode } | null } | null };

export type GetEventToReadyToJoinQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetEventToReadyToJoinQuery = { event: { __typename: 'Event', id: string, eventLimitations: { __typename: 'EventLimitations', eventEntryRules: { __typename: 'TeamEventEntryRules', minimumTeamMembers: number | null, maximumTeamMembers: number | null } | null } | null } | null };

export type TeamMembersForEditLineupFragment = { __typename: 'Team', groupMembers: Array<{ __typename: 'GroupMember', id: string, account: { __typename: 'Group', avatarURL: string | null } | { __typename: 'InternalService', avatarURL: string | null } | { __typename: 'Person', displayName: string | null, avatarURL: string | null } | { __typename: 'Team', avatarURL: string | null } }> };

export type TeamForEditLineupFragment = (
  { __typename: 'Team', id: string }
  & TeamMembersForEditLineupFragment
);

export type GetTeamForEditLineupQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;


export type GetTeamForEditLineupQuery = { account: { __typename: 'Group' } | { __typename: 'InternalService' } | { __typename: 'Person' } | (
    { __typename: 'Team' }
    & TeamForEditLineupFragment
  ) | null };

export type RemoveFromEventTeamMutationVariables = Exact<{
  eventId: Scalars['String'];
  teamId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type RemoveFromEventTeamMutation = { removeFromEventTeam: boolean };

export type MakeGhostQueryVariables = Exact<{ [key: string]: never; }>;


export type MakeGhostQuery = { ghostCompetition: { __typename: 'Challenge' } | { __typename: 'MatchUp' } | { __typename: 'Tournament', eventId: string, eventStageId: string, event: { __typename: 'Event', localizedNames: Array<{ __typename: 'LocalizedString', value: string }> }, brackets: Array<{ __typename: 'TournamentBracket', id: string, phases: Array<{ __typename: 'TournamentPhase', id: string, phaseNumber: number, matches: Array<{ __typename: 'PlayableTournamentMatch', id: string, participants: Array<{ __typename: 'CompetitionParticipantReferenceWithRoster', participantId: string, accountId: string }> } | { __typename: 'TournamentMatchBye', id: string }> }> }> } };

export type GetEventDefaultOverviewQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetEventDefaultOverviewQuery = { event: { __typename: 'Event', id: string, participantType: ParticipantType, eventState: EventElementState, region: Region | null, participantCount: number, game: { __typename: 'Game', prettyName: string }, localizedDescriptions: Array<{ __typename: 'LocalizedOptionalString', locale: Locale, value: string | null }>, eventLimitations: { __typename: 'EventLimitations', minimumParticipants: number | null, maximumParticipants: number | null } | null, tags: Array<(
      { __typename: 'Tag' }
      & TagFragment
    )>, eventStages: Array<{ __typename: 'EventStage', competitions: Array<{ __typename: 'Challenge', challengeFormat: ChallengeFormat } | { __typename: 'MatchUp', matchUpFormat: MatchUpFormat } | { __typename: 'Tournament', tournamentFormat: TournamentFormat }> }>, eventTiming: { __typename: 'EventTiming', startTime: string, completedAt: string | null } } | null };

export type GetEventLaddersOverviewQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetEventLaddersOverviewQuery = { event: { __typename: 'Event', id: string, participantType: ParticipantType, eventState: EventElementState, region: Region | null, participantCount: number, game: { __typename: 'Game', prettyName: string }, eventLimitations: { __typename: 'EventLimitations', minimumParticipants: number | null, maximumParticipants: number | null } | null, eventTiming: { __typename: 'EventTiming', startTime: string, completedAt: string | null }, eventStages: Array<{ __typename: 'EventStage', id: string, competitions: Array<{ __typename: 'Challenge', challengeFormat: ChallengeFormat, competitionType: CompetitionType, competitionSpecificDetails: { __typename: 'LadderSpecificDetails', duration: number } | null, gameSpecificDetails: { __typename: 'CSGOCompetitionDetails' } | { __typename: 'CSGOMatchDetails' } | { __typename: 'ValorantCompetitionDetails', matchType: ValorantMatchType } | null, participants: Array<{ __typename: 'CompetitionParticipantReference', accountId: string, result: { __typename: 'BasicResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'ManualResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null, showed: boolean } | null, participant: { __typename: 'ReadyIndividualParticipant', gameAccount: { __typename: 'GameAccount', externalAccountName: string | null } | null, person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } | { __typename: 'TeamParticipant', teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }>, team: { __typename: 'Team', avatarURL: string | null, name: string } | null } | { __typename: 'UnreadyIndividualParticipant', person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } }> } | { __typename: 'MatchUp', competitionType: CompetitionType, participants: Array<{ __typename: 'CompetitionParticipantReference', accountId: string, result: { __typename: 'BasicResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'ManualResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null, showed: boolean } | null, participant: { __typename: 'ReadyIndividualParticipant', gameAccount: { __typename: 'GameAccount', externalAccountName: string | null } | null, person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } | { __typename: 'TeamParticipant', teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }>, team: { __typename: 'Team', avatarURL: string | null, name: string } | null } | { __typename: 'UnreadyIndividualParticipant', person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } }> } | { __typename: 'Tournament', competitionType: CompetitionType, participants: Array<{ __typename: 'CompetitionParticipantReference', accountId: string, result: { __typename: 'BasicResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'ManualResult', score: number | null, placement: number | null, showed: boolean } | { __typename: 'MultiDimensionalBucketBasedResult', score: number | null, placement: number | null, showed: boolean } | null, participant: { __typename: 'ReadyIndividualParticipant', gameAccount: { __typename: 'GameAccount', externalAccountName: string | null } | null, person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } | { __typename: 'TeamParticipant', teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }>, team: { __typename: 'Team', avatarURL: string | null, name: string } | null } | { __typename: 'UnreadyIndividualParticipant', person: { __typename: 'Person', avatarURL: string | null, displayName: string | null } | null } }> }> }> } | null };

export type GetEventParticipantQueryVariables = Exact<{
  participantId: Scalars['String'];
}>;


export type GetEventParticipantQuery = { eventParticipant: { __typename: 'ReadyIndividualParticipant' } | { __typename: 'TeamParticipant', id: string, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, displayName: string | null, publicURL: string | null, avatarURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null, gameAccount: { __typename: 'GameAccount', id: string, externalAccountId: string | null, externalAccountName: string | null, gameAccountTypeId: string } | null } | { __typename: 'UnreadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, displayName: string | null, publicURL: string | null, avatarURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null }> } | { __typename: 'UnreadyIndividualParticipant' } | null };

export type GetParticipantsForParticipantTabQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetParticipantsForParticipantTabQuery = { event: { __typename: 'Event', id: string, participants: Array<(
      { __typename: 'ReadyIndividualParticipant' }
      & IndividualParticipantsForParticipantTab_ReadyIndividualParticipant_Fragment
    ) | (
      { __typename: 'TeamParticipant' }
      & TeamParticipantsForParticipantTabFragment
    ) | (
      { __typename: 'UnreadyIndividualParticipant' }
      & IndividualParticipantsForParticipantTab_UnreadyIndividualParticipant_Fragment
    )>, disqualifiedParticipants: Array<(
      { __typename: 'ReadyIndividualParticipant' }
      & IndividualParticipantsForParticipantTab_ReadyIndividualParticipant_Fragment
    ) | (
      { __typename: 'TeamParticipant' }
      & TeamParticipantsForParticipantTabFragment
    ) | (
      { __typename: 'UnreadyIndividualParticipant' }
      & IndividualParticipantsForParticipantTab_UnreadyIndividualParticipant_Fragment
    )> } | null };

type IndividualParticipantsForParticipantTab_ReadyIndividualParticipant_Fragment = { __typename: 'ReadyIndividualParticipant', id: string, confirmed: boolean, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null, gameAccount: { __typename: 'GameAccount', id: string, externalAccountName: string | null, externalAccountId: string | null, gameAccountTypeId: string } | null };

type IndividualParticipantsForParticipantTab_UnreadyIndividualParticipant_Fragment = { __typename: 'UnreadyIndividualParticipant', id: string, confirmed: boolean, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null };

export type IndividualParticipantsForParticipantTabFragment = IndividualParticipantsForParticipantTab_ReadyIndividualParticipant_Fragment | IndividualParticipantsForParticipantTab_UnreadyIndividualParticipant_Fragment;

export type TeamParticipantsForParticipantTabFragment = { __typename: 'TeamParticipant', id: string, confirmed: boolean, team: { __typename: 'Team', id: string, name: string, avatarURL: string | null, publicURL: string | null } | null, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', id: string, confirmed: boolean, gameAccount: { __typename: 'GameAccount', id: string, externalAccountName: string | null, externalAccountId: string | null, gameAccountTypeId: string } | null, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null } | { __typename: 'UnreadyIndividualParticipant', id: string, confirmed: boolean, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null, additionalInformation: Array<{ __typename: 'AdditionalInformation', key: string, value: string }> | null } | null }> };

export type TeamParticipantForPrizesTabFragment = { __typename: 'TeamParticipant', id: string, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', id: string, result: (
      { __typename: 'BasicResult' }
      & Result_BasicResult_Fragment
    ) | (
      { __typename: 'ManualResult' }
      & Result_ManualResult_Fragment
    ) | (
      { __typename: 'MultiDimensionalBucketBasedResult' }
      & Result_MultiDimensionalBucketBasedResult_Fragment
    ) | null } | { __typename: 'UnreadyIndividualParticipant', id: string, result: (
      { __typename: 'BasicResult' }
      & Result_BasicResult_Fragment
    ) | (
      { __typename: 'ManualResult' }
      & Result_ManualResult_Fragment
    ) | (
      { __typename: 'MultiDimensionalBucketBasedResult' }
      & Result_MultiDimensionalBucketBasedResult_Fragment
    ) | null }>, team: { __typename: 'Team', id: string, name: string, avatarURL: string | null, publicURL: string | null } | null };

type IndividualParticipantForPrizesTab_ReadyIndividualParticipant_Fragment = { __typename: 'ReadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null } | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

type IndividualParticipantForPrizesTab_UnreadyIndividualParticipant_Fragment = { __typename: 'UnreadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null } | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

export type IndividualParticipantForPrizesTabFragment = IndividualParticipantForPrizesTab_ReadyIndividualParticipant_Fragment | IndividualParticipantForPrizesTab_UnreadyIndividualParticipant_Fragment;

export type GetParticipantsForPrizesTabQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetParticipantsForPrizesTabQuery = { event: { __typename: 'Event', id: string, participants: Array<(
      { __typename: 'ReadyIndividualParticipant' }
      & IndividualParticipantForPrizesTab_ReadyIndividualParticipant_Fragment
    ) | (
      { __typename: 'TeamParticipant' }
      & TeamParticipantForPrizesTabFragment
    ) | (
      { __typename: 'UnreadyIndividualParticipant' }
      & IndividualParticipantForPrizesTab_UnreadyIndividualParticipant_Fragment
    )> } | null };

export type EventForGetFormatFragment = { __typename: 'Event', tags: Array<(
    { __typename: 'Tag' }
    & TagFragment
  )>, eventStages: Array<{ __typename: 'EventStage', competitions: Array<{ __typename: 'Challenge', challengeFormat: ChallengeFormat } | { __typename: 'MatchUp', matchUpFormat: MatchUpFormat } | { __typename: 'Tournament', tournamentFormat: TournamentFormat }> }> };

export type TeamParticipantOnActiveMatchFragment = { __typename: 'TeamParticipant', id: string, teamMembers: Array<(
    { __typename: 'ReadyIndividualParticipant' }
    & TeamMemberOnMatchParticipant_ReadyIndividualParticipant_Fragment
  ) | (
    { __typename: 'UnreadyIndividualParticipant' }
    & TeamMemberOnMatchParticipant_UnreadyIndividualParticipant_Fragment
  )>, team: { __typename: 'Team', id: string, name: string, avatarURL: string | null, publicURL: string | null, groupMembers: Array<{ __typename: 'GroupMember', id: string, account: { __typename: 'Group', id: string } | { __typename: 'InternalService', id: string } | { __typename: 'Person', id: string } | { __typename: 'Team', id: string }, roles: Array<{ __typename: 'Role', roleId: string }> }> } | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

type IndividualParticipantOnActiveMatch_ReadyIndividualParticipant_Fragment = { __typename: 'ReadyIndividualParticipant', id: string, gameAccount: { __typename: 'GameAccount', id: string, externalAccountName: string | null, externalAccountId: string | null, gameAccountTypeId: string } | null, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null } | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

type IndividualParticipantOnActiveMatch_UnreadyIndividualParticipant_Fragment = { __typename: 'UnreadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null } | null, result: (
    { __typename: 'BasicResult' }
    & Result_BasicResult_Fragment
  ) | (
    { __typename: 'ManualResult' }
    & Result_ManualResult_Fragment
  ) | (
    { __typename: 'MultiDimensionalBucketBasedResult' }
    & Result_MultiDimensionalBucketBasedResult_Fragment
  ) | null };

export type IndividualParticipantOnActiveMatchFragment = IndividualParticipantOnActiveMatch_ReadyIndividualParticipant_Fragment | IndividualParticipantOnActiveMatch_UnreadyIndividualParticipant_Fragment;

export type PlayableTournamentMatchOnActiveMatchesFragment = { __typename: 'PlayableTournamentMatch', id: string, startTime: string | null, isComplete: boolean, participants: Array<{ __typename: 'CompetitionParticipantReferenceWithRoster', participant: (
      { __typename: 'ReadyIndividualParticipant' }
      & IndividualParticipantOnActiveMatch_ReadyIndividualParticipant_Fragment
    ) | (
      { __typename: 'TeamParticipant' }
      & TeamParticipantOnActiveMatchFragment
    ) | (
      { __typename: 'UnreadyIndividualParticipant' }
      & IndividualParticipantOnActiveMatch_UnreadyIndividualParticipant_Fragment
    ) }> };

export type PlayableMatchUpMatchOnActiveMatchesFragment = { __typename: 'PlayableMatchUpMatch', id: string, startTime: string | null, isComplete: boolean, participants: Array<{ __typename: 'CompetitionParticipantReferenceWithRoster', participant: (
      { __typename: 'ReadyIndividualParticipant' }
      & IndividualParticipantOnActiveMatch_ReadyIndividualParticipant_Fragment
    ) | (
      { __typename: 'TeamParticipant' }
      & TeamParticipantOnActiveMatchFragment
    ) | (
      { __typename: 'UnreadyIndividualParticipant' }
      & IndividualParticipantOnActiveMatch_UnreadyIndividualParticipant_Fragment
    ) }> };

export type GetActiveMatchesQueryVariables = Exact<{
  maybeAccountId?: InputMaybe<Scalars['String']>;
}>;


export type GetActiveMatchesQuery = { getActiveMatches: Array<{ __typename: 'OutOfContextMatchUpMatches', competitionId: string, matches: Array<{ __typename: 'MatchUpMatchBye' } | (
      { __typename: 'PlayableMatchUpMatch' }
      & PlayableMatchUpMatchOnActiveMatchesFragment
    ) | (
      { __typename: 'PlayableTournamentMatch' }
      & PlayableTournamentMatchOnActiveMatchesFragment
    ) | { __typename: 'TournamentMatchBye' }> } | { __typename: 'OutOfContextTournamentMatches', competitionId: string, matches: Array<{ __typename: 'MatchUpMatchBye' } | (
      { __typename: 'PlayableMatchUpMatch' }
      & PlayableMatchUpMatchOnActiveMatchesFragment
    ) | (
      { __typename: 'PlayableTournamentMatch' }
      & PlayableTournamentMatchOnActiveMatchesFragment
    ) | { __typename: 'TournamentMatchBye' }> }> };

export type KothDetailsForAllEventsFragment = { __typename: 'KingOfTheHillSpecificDetails', id: string, host: { __typename: 'ReadyIndividualParticipant', accountId: string, person: { __typename: 'Person', id: string } | null } | { __typename: 'TeamParticipant', accountId: string, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string } | null } | { __typename: 'UnreadyIndividualParticipant', id: string, person: { __typename: 'Person', id: string } | null }> } | { __typename: 'UnreadyIndividualParticipant', accountId: string, person: { __typename: 'Person', id: string } | null } };

type AllEventsCompetition_Challenge_Fragment = { __typename: 'Challenge', challengeFormat: ChallengeFormat, id: string, competitionType: CompetitionType, competitionState: EventElementState };

type AllEventsCompetition_MatchUp_Fragment = { __typename: 'MatchUp', matchUpFormat: MatchUpFormat, id: string, competitionType: CompetitionType, competitionState: EventElementState, matchUpFormatSpecificDetails: { __typename: 'BattleRoyaleSpecificDetails', id: string, matchUpFormat: MatchUpFormat } | (
    { __typename: 'KingOfTheHillSpecificDetails' }
    & KothDetailsForAllEventsFragment
  ) | null };

type AllEventsCompetition_Tournament_Fragment = { __typename: 'Tournament', tournamentFormat: TournamentFormat, id: string, competitionType: CompetitionType, competitionState: EventElementState };

export type AllEventsCompetitionFragment = AllEventsCompetition_Challenge_Fragment | AllEventsCompetition_MatchUp_Fragment | AllEventsCompetition_Tournament_Fragment;

export type AllEventsEventFragment = { __typename: 'Event', id: string, featured: boolean, category: EventCategory, region: Region | null, gameId: string, participantType: ParticipantType, participantCount: number, eventState: EventElementState, localizedMediaContentDetails: Array<{ __typename: 'LocalizedMediaContentDetails', locale: Locale, value: { __typename: 'MediaContentDetails', avatar: string | null, banner: string | null, streams: Array<(
        { __typename: 'TwitchStream' }
        & TwitchStreamFragment
      ) | (
        { __typename: 'YouTubeStream' }
        & YouTubeStreamFragment
      ) | (
        { __typename: 'YouTubeVideo' }
        & YouTubeVideoFragment
      )> | null } }>, eventLimitations: { __typename: 'EventLimitations', maximumParticipants: number | null, minimumParticipants: number | null, eventEntryRules: { __typename: 'TeamEventEntryRules', minimumTeamMembers: number | null, maximumTeamMembers: number | null, id: string } | null } | null, eventStages: Array<{ __typename: 'EventStage', id: string, competitions: Array<(
      { __typename: 'Challenge' }
      & AllEventsCompetition_Challenge_Fragment
    ) | (
      { __typename: 'MatchUp' }
      & AllEventsCompetition_MatchUp_Fragment
    ) | (
      { __typename: 'Tournament' }
      & AllEventsCompetition_Tournament_Fragment
    )> }>, eventTiming: { __typename: 'EventTiming', startTime: string, registrationClose: string }, localizedNames: Array<{ __typename: 'LocalizedString', locale: Locale, value: string }>, gameAccountTypes: Array<{ __typename: 'GameAccountType', id: string, prettyName: string }>, game: { __typename: 'Game', id: string, prettyName: string }, tags: Array<(
    { __typename: 'Tag' }
    & TagFragment
  )> };

export type GetAllEventsQueryVariables = Exact<{
  eventsQuery: EventsQuery;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  eventSortField?: InputMaybe<EventSortField>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type GetAllEventsQuery = { allEvents: { __typename: 'PaginatedEvent', totalCount: number, hasNextPage: boolean, nodes: Array<(
      { __typename: 'Event' }
      & AllEventsEventFragment
    )> } };

export type GetEventQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetEventQuery = { event: (
    { __typename: 'Event' }
    & EventFragment
  ) | null };

export type InGameResultFragment = { __typename: 'InGameResult', id: string, matchId: string, scores: Array<{ __typename: 'ParticipantScore', id: string, score: number }> };

export type InGameResultsQueryVariables = Exact<{
  matchIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type InGameResultsQuery = { InGameResults: Array<(
    { __typename: 'InGameResult' }
    & InGameResultFragment
  )> };

export type UpdatedEventSubscriptionVariables = Exact<{
  notificationType: Scalars['String'];
  targetId?: InputMaybe<Scalars['String']>;
}>;


export type UpdatedEventSubscription = { ClientNotification: { __typename: 'AccountNotificationEvent', id: string, created: string, expiry: string, defaultMessage: string, notificationType: string } | { __typename: 'ClientNotificationEvent', targetId: string | null, fields: { [key: string]: any } | null, id: string, created: string, expiry: string, defaultMessage: string, notificationType: string } };

export type GetEventToInvitePageQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type GetEventToInvitePageQuery = { event: { __typename: 'Event', id: string, participants: Array<{ __typename: 'ReadyIndividualParticipant' } | { __typename: 'TeamParticipant', teamId: string, teamMembers: Array<{ __typename: 'ReadyIndividualParticipant', accountId: string } | { __typename: 'UnreadyIndividualParticipant', accountId: string }> } | { __typename: 'UnreadyIndividualParticipant' }>, game: { __typename: 'Game', id: string, prettyName: string }, eventTiming: { __typename: 'EventTiming', startTime: string }, localizedNames: Array<{ __typename: 'LocalizedString', locale: Locale, value: string }> } | null };

export type GetTeamForInvitePageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTeamForInvitePageQuery = { account: { __typename: 'Group' } | { __typename: 'InternalService' } | { __typename: 'Person' } | { __typename: 'Team', id: string, name: string, avatarURL: string | null, groupMembers: Array<{ __typename: 'GroupMember', account: { __typename: 'Group', id: string } | { __typename: 'InternalService', id: string } | { __typename: 'Person', id: string } | { __typename: 'Team', id: string } }> } | null };

export type GetTeamProfileForInvitePageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTeamProfileForInvitePageQuery = { account: { __typename: 'Group' } | { __typename: 'InternalService' } | { __typename: 'Person' } | (
    { __typename: 'Team' }
    & TeamProfileFragment
  ) | null };

export type JoinEventByInviteMutationVariables = Exact<{
  inviteCode: Scalars['String'];
  userId: Scalars['String'];
}>;


export type JoinEventByInviteMutation = { joinEventByInvite: boolean };

export type JoinTeamByInviteMutationVariables = Exact<{
  inviteCode: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type JoinTeamByInviteMutation = { joinGroupTraitByInvite: { __typename: 'Group', id: string } | { __typename: 'Team', id: string } };

export type DeleteGroupAvatarMutationVariables = Exact<{
  groupId: Scalars['String'];
}>;


export type DeleteGroupAvatarMutation = { updateGroup: { __typename: 'Group', id: string, bannerURL: string | null } };

export type DeleteGroupBannerMutationVariables = Exact<{
  groupId: Scalars['String'];
}>;


export type DeleteGroupBannerMutation = { updateGroup: { __typename: 'Group', id: string, bannerURL: string | null } };

export type AddTeamInviteCodeMutationVariables = Exact<{
  groupId: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type AddTeamInviteCodeMutation = { addInviteCode: { __typename: 'InviteCode', code: string, expiry: string } };

export type PromoteToGroupAdminMutationVariables = Exact<{
  groupId: Scalars['String'];
  accountId: Scalars['String'];
  roleAlias?: InputMaybe<Scalars['String']>;
}>;


export type PromoteToGroupAdminMutation = { promoteToGroupAdmin: (
    { __typename: 'Group' }
    & ChangeRolesMutationResponse_Group_Fragment
  ) | (
    { __typename: 'Team' }
    & ChangeRolesMutationResponse_Team_Fragment
  ) };

export type GroupMembershipOnChangeRolesMutationFragment = { __typename: 'GroupMembership', id: string, roles: Array<{ __typename: 'Role', roleId: string }> };

export type GroupMemberOnChangeRolesMutationFragment = { __typename: 'GroupMember', id: string, roles: Array<{ __typename: 'Role', roleId: string }>, account: { __typename: 'Group', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipOnChangeRolesMutationFragment
    )> } | { __typename: 'InternalService', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipOnChangeRolesMutationFragment
    )> } | { __typename: 'Person', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipOnChangeRolesMutationFragment
    )> } | { __typename: 'Team', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipOnChangeRolesMutationFragment
    )> } };

type ChangeRolesMutationResponse_Group_Fragment = { __typename: 'Group', id: string, ownerId: string, groupMembers: Array<(
    { __typename: 'GroupMember' }
    & GroupMemberOnChangeRolesMutationFragment
  )> };

type ChangeRolesMutationResponse_Team_Fragment = { __typename: 'Team', id: string, ownerId: string, groupMembers: Array<(
    { __typename: 'GroupMember' }
    & GroupMemberOnChangeRolesMutationFragment
  )> };

export type ChangeRolesMutationResponseFragment = ChangeRolesMutationResponse_Group_Fragment | ChangeRolesMutationResponse_Team_Fragment;

export type RemoveMemberFromGroupMutationVariables = Exact<{
  groupId: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type RemoveMemberFromGroupMutation = { removeMemberFromGroup: (
    { __typename: 'Group' }
    & ChangeRolesMutationResponse_Group_Fragment
  ) | (
    { __typename: 'Team' }
    & ChangeRolesMutationResponse_Team_Fragment
  ) };

export type RemoveRolesFromGroupMemberMutationVariables = Exact<{
  groupId: Scalars['String'];
  accountId: Scalars['String'];
  roleIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type RemoveRolesFromGroupMemberMutation = { removeRolesFromGroupMember: (
    { __typename: 'Group' }
    & ChangeRolesMutationResponse_Group_Fragment
  ) | (
    { __typename: 'Team' }
    & ChangeRolesMutationResponse_Team_Fragment
  ) };

export type ReplaceGroupOwnerMutationVariables = Exact<{
  groupId: Scalars['String'];
  ownerId: Scalars['String'];
  accountId: Scalars['String'];
  roleAlias?: InputMaybe<Scalars['String']>;
}>;


export type ReplaceGroupOwnerMutation = { replaceGroupOwner: (
    { __typename: 'Group' }
    & ChangeRolesMutationResponse_Group_Fragment
  ) | (
    { __typename: 'Team' }
    & ChangeRolesMutationResponse_Team_Fragment
  ) };

export type InviteToGroupMutationVariables = Exact<{
  groupId: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type InviteToGroupMutation = { inviteToGroup: { __typename: 'Group', id: string } | { __typename: 'Team', id: string } };

export type AccountProjectionFragment = { __typename: 'AccountProjection', id: string, displayName: string | null, avatarURL: string | null, publicURL: string | null };

export type UserSuggestionsQueryVariables = Exact<{
  displayNamePrefix: Scalars['String'];
}>;


export type UserSuggestionsQuery = { userSuggestions: Array<(
    { __typename: 'AccountProjection' }
    & AccountProjectionFragment
  )> };

export type UpdateTeamMutationVariables = Exact<{
  id: Scalars['String'];
  updateTeamRequest: TeamUpdateRequest;
}>;


export type UpdateTeamMutation = { updateTeam: { __typename: 'Team', id: string, name: string, description: string | null, bannerURL: string | null, avatarURL: string | null, created: string, updated: string, ownerId: string, groupType: string, accountType: string, publicURL: string | null, socialLinks: Array<{ __typename: 'SocialLink', link: string, socialLinkType: SocialLinkType }> } };

export type AcceptAllGroupInvitationsMutationVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type AcceptAllGroupInvitationsMutation = { acceptAllGroupInvitations: { __typename: 'Group', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'InternalService', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'Person', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'Team', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } };

export type AcceptGroupInvitationMutationVariables = Exact<{
  groupId: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type AcceptGroupInvitationMutation = { acceptGroupInvitation: { __typename: 'Group', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'InternalService', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'Person', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'Team', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } };

export type DeclineAllGroupInvitationsMutationVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type DeclineAllGroupInvitationsMutation = { declineAllGroupInvitations: { __typename: 'Group', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'InternalService', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'Person', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'Team', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } };

export type DeclineGroupInvitationMutationVariables = Exact<{
  groupId: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type DeclineGroupInvitationMutation = { declineGroupInvitation: { __typename: 'Group', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'InternalService', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'Person', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'Team', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } };

export type NewTeamInvitationSubscriptionVariables = Exact<{
  notificationType: Scalars['String'];
  targetId: Scalars['String'];
}>;


export type NewTeamInvitationSubscription = { ClientNotification: { __typename: 'AccountNotificationEvent', id: string, created: string, expiry: string, defaultMessage: string, notificationType: string } | { __typename: 'ClientNotificationEvent', targetId: string | null, fields: { [key: string]: any } | null, id: string, created: string, expiry: string, defaultMessage: string, notificationType: string } };

export type MyTeamsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MyTeamsQuery = { user: { __typename: 'InternalService', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | { __typename: 'Person', id: string, groupMemberships: Array<(
      { __typename: 'GroupMembership' }
      & GroupMembershipFragment
    )>, groupInvites: Array<(
      { __typename: 'ActionNotAllowedError' }
      & GroupInviteWithPossibleError_ActionNotAllowedError_Fragment
    ) | (
      { __typename: 'GroupInvite' }
      & GroupInviteWithPossibleError_GroupInvite_Fragment
    )> } | null };

export type PublicUserFragment = { __typename: 'Person', id: string, displayName: string | null, description: string | null, avatarURL: string | null, bannerURL: string | null, isVIP: boolean, socialLinks: Array<{ __typename: 'SocialLink', socialLinkType: SocialLinkType, link: string }>, groupMemberships: Array<{ __typename: 'GroupMembership', id: string, created: string, roles: Array<{ __typename: 'Role', roleId: string }>, group: { __typename: 'Group', id: string, name: string, description: string | null, bannerURL: string | null, avatarURL: string | null, publicURL: string | null, socialLinks: Array<{ __typename: 'SocialLink', link: string, socialLinkType: SocialLinkType }> } | { __typename: 'Team', id: string, name: string, description: string | null, bannerURL: string | null, avatarURL: string | null, publicURL: string | null, socialLinks: Array<{ __typename: 'SocialLink', link: string, socialLinkType: SocialLinkType }> } }>, eventParticipations: Array<(
    { __typename: 'Event' }
    & PublicEventParticipationFragment
  )> };

export type GetUserProfileQueryVariables = Exact<{
  idOrPublicURL: Scalars['String'];
}>;


export type GetUserProfileQuery = { user: { __typename: 'InternalService' } | (
    { __typename: 'Person' }
    & PublicUserFragment
  ) | null, accountByPublicURL: { __typename: 'Group' } | { __typename: 'InternalService' } | (
    { __typename: 'Person' }
    & PublicUserFragment
  ) | { __typename: 'Team' } | null };

export type MyProfileQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MyProfileQuery = { user: { __typename: 'InternalService', id: string, avatarURL: string | null, bannerURL: string | null, description: string | null, displayName: string | null, socialLinks: Array<{ __typename: 'SocialLink', socialLinkType: SocialLinkType, link: string }>, groupMemberships: Array<{ __typename: 'GroupMembership', id: string, group: { __typename: 'Group', id: string, name: string, avatarURL: string | null, publicURL: string | null } | { __typename: 'Team', id: string, name: string, avatarURL: string | null, publicURL: string | null } }> } | { __typename: 'Person', isVIP: boolean, id: string, avatarURL: string | null, bannerURL: string | null, description: string | null, displayName: string | null, socialLinks: Array<{ __typename: 'SocialLink', socialLinkType: SocialLinkType, link: string }>, groupMemberships: Array<{ __typename: 'GroupMembership', id: string, group: { __typename: 'Group', id: string, name: string, avatarURL: string | null, publicURL: string | null } | { __typename: 'Team', id: string, name: string, avatarURL: string | null, publicURL: string | null } }> } | null };

export type GetEventsForSeriesQueryVariables = Exact<{
  locale: Locale;
}>;


export type GetEventsForSeriesQuery = { eventsByTags: Array<(
    { __typename: 'Event' }
    & AllEventsEventFragment
  )> };

export type PublicGameServerFragment = { __typename: 'PublicGameServer', id: string, ip: string | null, port: number | null, name: string, description: string, imageURL: string, connectString: string | null, steamURL: string | null, status: ServerStatusType, serverType: string, timeRequested: string, timeAcquired: string | null, timeDestroyed: string | null, region: string | null, maxNumberOfPlayers: number, featured: boolean };

export type AllActivePublicServersQueryVariables = Exact<{
  featured?: InputMaybe<Scalars['Boolean']>;
}>;


export type AllActivePublicServersQuery = { allActivePublicServers: Array<(
    { __typename: 'PublicGameServer' }
    & PublicGameServerFragment
  )> };

export type GetUserAvatarQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserAvatarQuery = { user: { __typename: 'InternalService', avatarURL: string | null, bannerURL: string | null, id: string } | { __typename: 'Person', avatarURL: string | null, bannerURL: string | null, id: string } | null };

export type UnlinkIdentityProviderMutationVariables = Exact<{
  IdentityProviderType: IdentityProviderType;
  userId: Scalars['String'];
}>;


export type UnlinkIdentityProviderMutation = { unlinkIdentityProvider: { __typename: 'InternalService', id: string } | (
    { __typename: 'Person', id: string }
    & LinkedAccountsFragment
  ) };

export type DeleteUserAvatarMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type DeleteUserAvatarMutation = { updatePerson: { __typename: 'Person', id: string, avatarURL: string | null } };

export type DeleteUserBannerMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type DeleteUserBannerMutation = { updatePerson: { __typename: 'Person', id: string, avatarURL: string | null } };

export type IdentityProviderFragment = { __typename: 'IdentityProvider', providerType: IdentityProviderType, externalAccountId: string };

export type LinkedAccountsFragment = { __typename: 'Person', linkedAccounts: Array<{ __typename: 'ActionNotAllowedError', isError: boolean } | (
    { __typename: 'IdentityProvider', isError: boolean }
    & IdentityProviderFragment
  )> };

export type MySettingsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MySettingsQuery = { user: { __typename: 'InternalService', id: string, displayName: string | null, avatarURL: string | null, description: string | null, bannerURL: string | null, publicURL: string | null, email: { __typename: 'ActionNotAllowedError', isError: boolean } | { __typename: 'StringAttribute', value: string, isError: boolean } | null, socialLinks: Array<{ __typename: 'SocialLink', socialLinkType: SocialLinkType, link: string }> } | (
    { __typename: 'Person', msisdnVerified: boolean, id: string, displayName: string | null, avatarURL: string | null, description: string | null, bannerURL: string | null, publicURL: string | null, msisdn: { __typename: 'ActionNotAllowedError', isError: boolean } | { __typename: 'StringAttribute', value: string, isError: boolean } | null, gameAccounts: Array<(
      { __typename: 'GameAccount' }
      & GameAccountFragment
    )>, email: { __typename: 'ActionNotAllowedError', isError: boolean } | { __typename: 'StringAttribute', value: string, isError: boolean } | null, socialLinks: Array<{ __typename: 'SocialLink', socialLinkType: SocialLinkType, link: string }> }
    & LinkedAccountsFragment
  ) | null };

export type UpdatePasswordMutationVariables = Exact<{
  id: Scalars['String'];
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type UpdatePasswordMutation = { updatePassword: { __typename: 'InternalService', id: string } | { __typename: 'Person', id: string } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String'];
  personUpdateRequest: PersonUpdateRequest;
}>;


export type UpdateUserMutation = { updatePerson: { __typename: 'Person', id: string, displayName: string | null, publicURL: string | null, description: string | null, msisdnVerified: boolean, msisdn: { __typename: 'ActionNotAllowedError', isError: boolean } | { __typename: 'StringAttribute', value: string, isError: boolean } | null, socialLinks: Array<{ __typename: 'SocialLink', socialLinkType: SocialLinkType, link: string }> } };

export type PurchaseTransactionFragment = { __typename: 'PurchaseTransaction', id: string, created: string, status: PurchaseTransactionStatus, paymentTransactionId: string, item: (
    { __typename: 'SwarmioItem' }
    & StoreItemFragment
  ), order: (
    { __typename: 'RootCode_Order' }
    & RootCode_OrderFragment
  ) | null };

export type RootCode_OrderFragment = { __typename: 'RootCode_Order', id: string, gamerId: string, transactionId: string, vouchers: Array<{ __typename: 'RootCode_ProductVoucher', voucherCode: string | null, voucherSerial: string | null, voucherPin: string | null }> | null };

export type GetMyOrdersQueryVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type GetMyOrdersQuery = { account: { __typename: 'Group', id: string, purchaseTransactions: Array<(
      { __typename: 'PurchaseTransaction' }
      & PurchaseTransactionFragment
    )> } | { __typename: 'InternalService', id: string, purchaseTransactions: Array<(
      { __typename: 'PurchaseTransaction' }
      & PurchaseTransactionFragment
    )> } | { __typename: 'Person', id: string, purchaseTransactions: Array<(
      { __typename: 'PurchaseTransaction' }
      & PurchaseTransactionFragment
    )> } | { __typename: 'Team', id: string, purchaseTransactions: Array<(
      { __typename: 'PurchaseTransaction' }
      & PurchaseTransactionFragment
    )> } | null };

export type GetPayPurchaseTransactionQueryVariables = Exact<{
  transactionId: Scalars['String'];
}>;


export type GetPayPurchaseTransactionQuery = { getPayPurchaseTransaction: { __typename: 'PayPurchaseTransaction', id: string, created: string, status: PurchaseTransactionStatus, itemId: string, fields: string | null, merchantPaymentMethodId: string, merchantPaymentMethodType: string, purchaserData: { __typename: 'PurchaserData', email: string }, payment: { __typename: 'BeedlePayment', id: string, internalPaymentServiceId: string, purchaseTransactionId: string, externalPaymentServiceId: string | null, paymentType: string, amount: number, currency: string, received: string } | null, order: (
      { __typename: 'RootCode_Order' }
      & RootCode_OrderFragment
    ) | null } | null };

export type PurchaseTransactionQueryVariables = Exact<{
  transactionId: Scalars['String'];
}>;


export type PurchaseTransactionQuery = { purchaseTransaction: { __typename: 'OutOfContextPurchaseTransaction', accountId: string, itemId: string, fields: string, purchaseTransactionId: string, status: PurchaseTransactionStatus, created: string, order: (
      { __typename: 'RootCode_Order' }
      & RootCode_OrderFragment
    ) } | null };

export type ProductGroupItemsQueryVariables = Exact<{
  partnerId: Scalars['ID'];
  productGroupId: Scalars['ID'];
  languageCode: Scalars['String'];
}>;


export type ProductGroupItemsQuery = { partnerProductGroup: { __typename: 'CategoryProductGroupResponse', bannerImage: string | null, description: string | null, name: string | null, items: Array<(
      { __typename: 'CatalogItem' }
      & CatalogItemFragment
    ) | null> | null } | null };

export type CategoryProductGroupsQueryVariables = Exact<{
  categoryId: Scalars['ID'];
  partnerId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  languageCode: Scalars['String'];
}>;


export type CategoryProductGroupsQuery = { categoryProductGroups: { __typename: 'PaginatedCategoryProductGroups', totalPages: number | null, totalProductGroups: number | null, currentPage: number | null, productGroups: Array<(
      { __typename: 'CategoryProductGroupResponse' }
      & ProductGroupFragment
    ) | null> | null } | null };

export type CatalogItemQueryVariables = Exact<{
  partnerId: Scalars['ID'];
  itemId: Scalars['ID'];
  languageCode: Scalars['String'];
}>;


export type CatalogItemQuery = { catalogItem: (
    { __typename: 'CatalogItem' }
    & CatalogItemFragment
  ) | null };

export type CatalogItemsQueryVariables = Exact<{
  filter: CatalogFilterInput;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  partnerId: Scalars['ID'];
  sort?: InputMaybe<CatalogSortInput>;
}>;


export type CatalogItemsQuery = { catalogItems: { __typename: 'PaginatedCatalogItems', totalPages: number | null, totalItems: number | null, currentPage: number | null, items: Array<(
      { __typename: 'CatalogItem' }
      & CatalogItemFragment
    ) | null> | null } | null };

export type CategoryCatalogQueryVariables = Exact<{
  partnerId: Scalars['ID'];
  languageCode: Scalars['String'];
}>;


export type CategoryCatalogQuery = { categoryCatalog: { __typename: 'CategoryCatalogResponse', categories: Array<(
      { __typename: 'CategoryCatalog' }
      & StoreCategoryFragment
    ) | null> | null } | null };

export type GetStoreMerchantPaymentMethodsQueryVariables = Exact<{
  amount: Scalars['Float'];
  currency: Scalars['String'];
  country: Scalars['Int'];
}>;


export type GetStoreMerchantPaymentMethodsQuery = { getPaymentMethodsAvailableForMerchant: Array<{ __typename: 'StoreMerchantPaymentMethod', id: string, name: string, paymentMethodType: string, refundSupported: boolean, imageUrl: string | null, disabled: boolean }> };

export type ItemSearchSuggestionsQueryVariables = Exact<{
  itemName: Scalars['String'];
}>;


export type ItemSearchSuggestionsQuery = { itemSearchSuggestions: Array<string | null> | null };

export type PartnerProductGroupsQueryVariables = Exact<{
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  partnerId: Scalars['ID'];
  search?: InputMaybe<CatalogSearchInput>;
  sort?: InputMaybe<CatalogSortInput>;
  languageCode: Scalars['String'];
}>;


export type PartnerProductGroupsQuery = { partnerProductGroups: { __typename: 'PaginatedPartnerProductGroups', totalPages: number | null, currentPage: number | null, totalProductGroups: number | null, productGroups: Array<{ __typename: 'CategoryProductGroupResponse', id: string | null, productGroupId: string | null, name: string | null, displayName: string | null, bannerImage: string | null, thumbnail: string | null, items: Array<(
        { __typename: 'CatalogItem' }
        & CatalogItemFragment
      ) | null> | null } | null> | null } | null };

export type PurchaseStoreItemWithPointsMutationVariables = Exact<{
  gamerId?: InputMaybe<Scalars['String']>;
  gamerEmail?: InputMaybe<Scalars['String']>;
  gamerFirstName?: InputMaybe<Scalars['String']>;
  gamerLastName?: InputMaybe<Scalars['String']>;
  gamerAddress?: InputMaybe<Scalars['String']>;
  gamerIPAddress?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  gamerMobileNumber?: InputMaybe<Scalars['String']>;
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
  tagId: Scalars['String'];
  fields?: InputMaybe<Scalars['String']>;
}>;


export type PurchaseStoreItemWithPointsMutation = { purchaseExternalItemWithPoints: { __typename: 'Group', id: string, purchaseTransactions: Array<(
      { __typename: 'PurchaseTransaction' }
      & PurchaseTransactionFragment
    )> } | { __typename: 'InternalService', id: string, purchaseTransactions: Array<(
      { __typename: 'PurchaseTransaction' }
      & PurchaseTransactionFragment
    )> } | { __typename: 'Person', id: string, purchaseTransactions: Array<(
      { __typename: 'PurchaseTransaction' }
      & PurchaseTransactionFragment
    )> } | { __typename: 'Team', id: string, purchaseTransactions: Array<(
      { __typename: 'PurchaseTransaction' }
      & PurchaseTransactionFragment
    )> } };

export type PurchaseStoreItemMutationVariables = Exact<{
  gamerId?: InputMaybe<Scalars['String']>;
  gamerEmail: Scalars['String'];
  gamerFirstName?: InputMaybe<Scalars['String']>;
  gamerLastName?: InputMaybe<Scalars['String']>;
  gamerAddress?: InputMaybe<Scalars['String']>;
  gamerIPAddress?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  gamerMobileNumber?: InputMaybe<Scalars['String']>;
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
  tagId: Scalars['String'];
  fields?: InputMaybe<Scalars['String']>;
  merchantPaymentMethodType: Scalars['String'];
  merchantPaymentMethodId: Scalars['String'];
  maybeMaxitJWT?: InputMaybe<Scalars['String']>;
}>;


export type PurchaseStoreItemMutation = { purchaseExternalItem: { __typename: 'SessionRequestResult', gatewaySessionId: string, transactionId: string } };

export type StoreBannersQueryVariables = Exact<{ [key: string]: never; }>;


export type StoreBannersQuery = { banners: Array<{ __typename: 'Banner', id: string, primaryImageUrl: string, secondaryImageUrl: string, redirectUrl: string }> };

export type GroupMemberOnTeamFragment = { __typename: 'GroupMember', id: string, created: string, inviteCode: { __typename: 'InviteCode', code: string, expiry: string } | null, roles: Array<{ __typename: 'Role', roleId: string }>, account: { __typename: 'Group', id: string, avatarURL: string | null, publicURL: string | null } | { __typename: 'InternalService', id: string, avatarURL: string | null, publicURL: string | null } | { __typename: 'Person', isVIP: boolean, displayName: string | null, id: string, avatarURL: string | null, publicURL: string | null } | { __typename: 'Team', id: string, avatarURL: string | null, publicURL: string | null } };

export type TeamGroupMembersFragment = { __typename: 'Team', groupMembers: Array<(
    { __typename: 'GroupMember' }
    & GroupMemberOnTeamFragment
  )> };

export type SocialLinkFragment = { __typename: 'SocialLink', socialLinkType: SocialLinkType, link: string };

export type SocialLinksFragment = { __typename: 'Team', socialLinks: Array<(
    { __typename: 'SocialLink' }
    & SocialLinkFragment
  )> };

export type TeamProfileFragment = (
  { __typename: 'Team', id: string, ownerId: string, name: string, description: string | null, bannerURL: string | null, avatarURL: string | null, publicURL: string | null, eventParticipations: Array<(
    { __typename: 'Event' }
    & PublicEventParticipationFragment
  )> }
  & SocialLinksFragment
  & TeamGroupMembersFragment
);

export type GetTeamProfileQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTeamProfileQuery = { teamById: { __typename: 'Group' } | { __typename: 'InternalService' } | { __typename: 'Person' } | (
    { __typename: 'Team' }
    & TeamProfileFragment
  ) | null, teamByPublicURL: { __typename: 'Group' } | { __typename: 'InternalService' } | { __typename: 'Person' } | (
    { __typename: 'Team' }
    & TeamProfileFragment
  ) | null };

export type PurchaseSwarmioCurrencyItemMutationVariables = Exact<{
  maybeEmail?: InputMaybe<Scalars['String']>;
  maybeCustomerName?: InputMaybe<Scalars['String']>;
  swarmioCurrencyItemCostId: Scalars['String'];
  paymentType: PaymentType;
}>;


export type PurchaseSwarmioCurrencyItemMutation = { purchaseSwarmioCurrencyItem: string };

export type CreateWalletsMutationVariables = Exact<{
  ownerId: Scalars['String'];
  swarmioCurrencyIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateWalletsMutation = { createWalletsForUser: Array<{ __typename: 'SwarmioWallet', id: string }> };

export type GetAllSwarmioCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSwarmioCurrenciesQuery = { getAllSwarmioCurrencies: Array<{ __typename: 'SwarmioCurrency', id: string, name: string, cashable: boolean }> };

export type SwarmioCurrencyItemFragment = { __typename: 'SwarmioCurrencyItem', id: string, amount: number, dealTagline: string | null, swarmioCurrencyId: string, active: boolean, created: string, costs: Array<{ __typename: 'ExternalCurrencyItemCost', id: string, swarmioCurrencyItemId: string, cost: number, realWorldCurrencyType: RealWorldCurrency, created: string, version: number } | { __typename: 'SwarmioCurrencyItemCost', id: string, swarmioCurrencyItemId: string, cost: number, realWorldCurrencyType: RealWorldCurrency, created: string, version: number }> };

export type GetAllSwarmioCurrencyItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSwarmioCurrencyItemsQuery = { getAllSwarmioCurrencyItems: Array<(
    { __typename: 'SwarmioCurrencyItem' }
    & SwarmioCurrencyItemFragment
  )> };

export type SwarmioPayPaymentOnPurchaseHistoryFragment = { __typename: 'SwarmioPayPayment', id: string, paymentStatus: PaymentStatus, dateReceived: string, itemId: string | null, internalTransactionId: string | null, paymentProviderTransactionId: string | null };

export type GetCurrencyPurchaseHistoryByOwnerIdQueryVariables = Exact<{
  ownerId: Scalars['String'];
}>;


export type GetCurrencyPurchaseHistoryByOwnerIdQuery = { getCurrencyPurchaseHistoryByOwnerId: Array<(
    { __typename: 'SwarmioPayPayment' }
    & SwarmioPayPaymentOnPurchaseHistoryFragment
  )> };

export type SwarmioCurrencyOnWalletsForOwnerFragment = { __typename: 'SwarmioCurrency', id: string, name: string, cashable: boolean };

type NodeOnSwarmioWalletTransaction_BoughtTransaction_Fragment = { __typename: 'BoughtTransaction', id: string, transactionType: SwarmioWalletTransactionType, walletId: string, amount: number, created: string };

type NodeOnSwarmioWalletTransaction_CashOutTransaction_Fragment = { __typename: 'CashOutTransaction', id: string, transactionType: SwarmioWalletTransactionType, walletId: string, amount: number, created: string };

type NodeOnSwarmioWalletTransaction_ExchangedTransaction_Fragment = { __typename: 'ExchangedTransaction', id: string, transactionType: SwarmioWalletTransactionType, walletId: string, amount: number, created: string };

type NodeOnSwarmioWalletTransaction_FreebieTransaction_Fragment = { __typename: 'FreebieTransaction', notes: string | null, id: string, transactionType: SwarmioWalletTransactionType, walletId: string, amount: number, created: string };

type NodeOnSwarmioWalletTransaction_TransferTransaction_Fragment = { __typename: 'TransferTransaction', id: string, transactionType: SwarmioWalletTransactionType, walletId: string, amount: number, created: string };

export type NodeOnSwarmioWalletTransactionFragment = NodeOnSwarmioWalletTransaction_BoughtTransaction_Fragment | NodeOnSwarmioWalletTransaction_CashOutTransaction_Fragment | NodeOnSwarmioWalletTransaction_ExchangedTransaction_Fragment | NodeOnSwarmioWalletTransaction_FreebieTransaction_Fragment | NodeOnSwarmioWalletTransaction_TransferTransaction_Fragment;

export type TransactionsOnWalletsForOwnerFragment = { __typename: 'PaginatedSwarmioWalletTransactionWithMetadata', totalCount: number, hasNextPage: boolean, nodes: Array<(
    { __typename: 'BoughtTransaction' }
    & NodeOnSwarmioWalletTransaction_BoughtTransaction_Fragment
  ) | (
    { __typename: 'CashOutTransaction' }
    & NodeOnSwarmioWalletTransaction_CashOutTransaction_Fragment
  ) | (
    { __typename: 'ExchangedTransaction' }
    & NodeOnSwarmioWalletTransaction_ExchangedTransaction_Fragment
  ) | (
    { __typename: 'FreebieTransaction' }
    & NodeOnSwarmioWalletTransaction_FreebieTransaction_Fragment
  ) | (
    { __typename: 'TransferTransaction' }
    & NodeOnSwarmioWalletTransaction_TransferTransaction_Fragment
  )> };

export type GetWalletsForOwnerQueryVariables = Exact<{
  ownerId: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetWalletsForOwnerQuery = { getWalletsForOwner: Array<{ __typename: 'SwarmioWallet', id: string, ownerId: string, balance: number, created: string, swarmioCurrency: (
      { __typename: 'SwarmioCurrency' }
      & SwarmioCurrencyOnWalletsForOwnerFragment
    ), transactions: (
      { __typename: 'PaginatedSwarmioWalletTransactionWithMetadata' }
      & TransactionsOnWalletsForOwnerFragment
    ) }> };

export type GetStreamsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetStreamsByIdsQuery = { getStreamsByIds: Array<(
    { __typename: 'MediaTwitchStreamType', id: string, streamUrl: string | null, streamType: StreamType, mediaType: MediaType }
    & TwitchStream_V2Fragment
  )> };

export type GetStreamsByTypeQueryVariables = Exact<{
  streamsType: StreamType;
}>;


export type GetStreamsByTypeQuery = { getStreamsbyType: Array<(
    { __typename: 'MediaTwitchStreamType', id: string, streamUrl: string | null, streamType: StreamType, mediaType: MediaType }
    & TwitchStream_V2Fragment
  )> };

export type TwitchStream_V2Fragment = { __typename: 'MediaTwitchStreamType', expiry: string, gameId: string | null, gameName: string | null, weight: number | null, thumbnailUrl: string | null, title: string | null, userName: string | null, userLogin: string, viewerCount: number | null, startedAt: string | null, providerIdentifier: string, language: string | null };

export type FeatureFlagFragment = { __typename: 'FeatureFlag', id: string, state: FeatureFlagState, feature: { __typename: 'Feature', id: string, name: string }, segments: Array<(
    { __typename: 'Segment' }
    & SegmentFragment
  )> };

export type RuleFragment = { __typename: 'Rule', id: string, name: string };

export type SegmentFragment = { __typename: 'Segment', id: string, name: string, rules: Array<(
    { __typename: 'Rule' }
    & RuleFragment
  )> };

export type GetApplicationConfigByNameQueryVariables = Exact<{
  applicationConfigName: Scalars['String'];
}>;


export type GetApplicationConfigByNameQuery = { applicationConfigByName: { __typename: 'ApplicationConfig', id: string, name: string, featureFlags: Array<(
      { __typename: 'FeatureFlag' }
      & FeatureFlagFragment
    )> } | null };

export type UniqueDisplayNameQueryVariables = Exact<{
  displayName: Scalars['String'];
}>;


export type UniqueDisplayNameQuery = { userByDisplayName: { __typename: 'InternalService', id: string } | { __typename: 'Person', id: string } | null };

export type UniquePublicUrlQueryVariables = Exact<{
  publicURL: Scalars['String'];
}>;


export type UniquePublicUrlQuery = { accountByPublicURL: { __typename: 'Group', id: string, accountType: string } | { __typename: 'InternalService', id: string, accountType: string } | { __typename: 'Person', id: string, accountType: string } | { __typename: 'Team', id: string, accountType: string } | null };

export type UniqueTeamNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type UniqueTeamNameQuery = { groupTraitNameIsUnique: boolean };

export const AccountNotificationFragmentDoc = gql`
    fragment AccountNotification on AccountNotification {
  id
  read
  expiry
  created
  defaultMessage
  notificationType
  fields
}
    `;
export const GroupMembershipOnMinimalUserFragmentDoc = gql`
    fragment GroupMembershipOnMinimalUser on GroupMembership {
  id
  group {
    id
    publicURL
  }
}
    `;
export const MsisdnFragmentDoc = gql`
    fragment Msisdn on StringAttributeWithPossibleError {
  ... on StringAttribute {
    value
  }
}
    `;
export const GameAccountOnMinimalUserFragmentDoc = gql`
    fragment GameAccountOnMinimalUser on GameAccount {
  id
  gameIds
  gameAccountTypeId
}
    `;
export const ProductGroupFragmentDoc = gql`
    fragment ProductGroup on CategoryProductGroupResponse {
  id
  productGroupId
  productGroupName: name
  name: displayName
  description
  bannerImage
  thumbnail
  featured
  urlMask
  items {
    id
    itemId
    displayName
    itemName
    itemType
    itemDescBrief
    itemDescDetail
    stock
    isActive
    itemImageUrl
    itemGalleryUrls
    fields
    productType
    productOrigin
    outOfStockImageUrl
    productPrices {
      paymentChannelId
      paymentChannelName
      paymentMethod
      targetCurrencyPrices {
        currency
        dealPrice
        dealTagId
        price
        tagId
      }
    }
    productId
    contentType
    availablePaymentChannels
  }
}
    `;
export const CatalogItemTargetCurrencyPriceFragmentDoc = gql`
    fragment CatalogItemTargetCurrencyPrice on TargetCurrencyPrice {
  currency
  price
  tagId
  dealPrice
  dealTagId
}
    `;
export const CatalogItemProductPriceFragmentDoc = gql`
    fragment CatalogItemProductPrice on ProductPrice {
  paymentChannelId
  paymentChannelName
  paymentMethod
  targetCurrencyPrices {
    ...CatalogItemTargetCurrencyPrice
  }
}
    ${CatalogItemTargetCurrencyPriceFragmentDoc}`;
export const CatalogItemFragmentDoc = gql`
    fragment CatalogItem on CatalogItem {
  isActive
  itemDescBrief
  itemDescDetail
  itemGalleryUrls
  itemId
  itemImageUrl
  outOfStockImageUrl
  displayName
  itemName
  itemType
  stock
  productOrigin
  productType
  fields
  productPrices {
    ...CatalogItemProductPrice
  }
  contentType
  availablePaymentChannels
}
    ${CatalogItemProductPriceFragmentDoc}`;
export const EventParticipationsFragmentDoc = gql`
    fragment EventParticipations on Person {
  eventParticipations {
    id
  }
}
    `;
export const TwitchStreamFragmentDoc = gql`
    fragment TwitchStream on TwitchStream {
  id
  username
  weight
}
    `;
export const YouTubeStreamFragmentDoc = gql`
    fragment YouTubeStream on YouTubeStream {
  id
  channelId
  weight
}
    `;
export const YouTubeVideoFragmentDoc = gql`
    fragment YouTubeVideo on YouTubeVideo {
  id
  videoId
  weight
}
    `;
export const EventGameAccountTypesFragmentDoc = gql`
    fragment EventGameAccountTypes on GameAccountType {
  id
  prettyName
  imageUrl
  integrated
  accountNameLabel
  requiresExternalAccountId
  accountIDLabel
}
    `;
export const TeamEventGameFragmentDoc = gql`
    fragment TeamEventGame on Game {
  id
  estimatedRoundLength
  bufferTime
  prettyName
}
    `;
export const TeamEventEntryRulesFragmentDoc = gql`
    fragment TeamEventEntryRules on TeamEventEntryRules {
  id
  minimumTeamMembers
  maximumTeamMembers
}
    `;
export const TournamentFragmentDoc = gql`
    fragment Tournament on Tournament {
  id
  tournamentFormat
  phaseBufferTime
}
    `;
export const PrizePayoutReceiptFragmentDoc = gql`
    fragment PrizePayoutReceipt on PrizePayoutReceipt {
  id
  prizeTierId
}
    `;
export const ManualResultFragmentDoc = gql`
    fragment ManualResult on ManualResult {
  id
  resultImageURLs
  prizePayoutReceipt {
    ...PrizePayoutReceipt
  }
}
    ${PrizePayoutReceiptFragmentDoc}`;
export const BasicResultFragmentDoc = gql`
    fragment BasicResult on BasicResult {
  id
  resultImageURLs
  prizePayoutReceipt {
    ...PrizePayoutReceipt
  }
}
    ${PrizePayoutReceiptFragmentDoc}`;
export const MultiDimensionalBucketBasedResultFragmentDoc = gql`
    fragment MultiDimensionalBucketBasedResult on MultiDimensionalBucketBasedResult {
  id
  bucketValue
  calculatedScore
  resultImageURLs
  multiDimensionalResults {
    dimensionId
    value
  }
  prizePayoutReceipt {
    ...PrizePayoutReceipt
  }
}
    ${PrizePayoutReceiptFragmentDoc}`;
export const ResultFragmentDoc = gql`
    fragment Result on Result {
  score
  placement
  showed
  ...ManualResult
  ...BasicResult
  ...MultiDimensionalBucketBasedResult
}
    ${ManualResultFragmentDoc}
${BasicResultFragmentDoc}
${MultiDimensionalBucketBasedResultFragmentDoc}`;
export const MatchUpIndividualParticipantFragmentDoc = gql`
    fragment MatchUpIndividualParticipant on IndividualParticipant {
  ... on ReadyIndividualParticipant {
    id
    gameAccount {
      id
      externalAccountName
      externalAccountId
      gameAccountTypeId
    }
    person {
      id
      displayName
      avatarURL
      publicURL
      additionalInformation {
        key
        value
      }
    }
  }
  ... on UnreadyIndividualParticipant {
    id
    person {
      id
      displayName
      avatarURL
      publicURL
      additionalInformation {
        key
        value
      }
    }
  }
  result {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export const KingOfTheHillHostIndividualParticipantFragmentDoc = gql`
    fragment KingOfTheHillHostIndividualParticipant on IndividualParticipant {
  ...MatchUpIndividualParticipant
}
    ${MatchUpIndividualParticipantFragmentDoc}`;
export const MatchUpTeamParticipantFragmentDoc = gql`
    fragment MatchUpTeamParticipant on TeamParticipant {
  id
  teamMembers {
    ... on ReadyIndividualParticipant {
      id
      gameAccount {
        id
        externalAccountName
        externalAccountId
        gameAccountTypeId
      }
      person {
        id
        displayName
        avatarURL
        publicURL
        additionalInformation {
          key
          value
        }
      }
    }
    ... on UnreadyIndividualParticipant {
      id
      person {
        id
        displayName
        avatarURL
        publicURL
        additionalInformation {
          key
          value
        }
      }
    }
  }
  team {
    id
    name
    publicURL
    avatarURL
    groupMembers {
      id
      account {
        id
      }
      roles {
        roleId
      }
    }
  }
  result {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export const KingOfTheHillHostTeamParticipantFragmentDoc = gql`
    fragment KingOfTheHillHostTeamParticipant on TeamParticipant {
  ...MatchUpTeamParticipant
}
    ${MatchUpTeamParticipantFragmentDoc}`;
export const RemainingParticipantReferenceFragmentDoc = gql`
    fragment RemainingParticipantReference on CompetitionParticipantReferenceWithRoster {
  participant {
    ...MatchUpTeamParticipant
    ...MatchUpIndividualParticipant
  }
}
    ${MatchUpTeamParticipantFragmentDoc}
${MatchUpIndividualParticipantFragmentDoc}`;
export const UpcomingKingOfTheHillParticipantFragmentDoc = gql`
    fragment UpcomingKingOfTheHillParticipant on UpcomingKingOfTheHillParticipant {
  order
  expectedStartTime
  display
  participant {
    ...RemainingParticipantReference
  }
}
    ${RemainingParticipantReferenceFragmentDoc}`;
export const KingOfTheHillSpecificDetailsFragmentDoc = gql`
    fragment KingOfTheHillSpecificDetails on KingOfTheHillSpecificDetails {
  host {
    accountId
    ...KingOfTheHillHostIndividualParticipant
    ...KingOfTheHillHostTeamParticipant
  }
  remainingParticipants {
    ...UpcomingKingOfTheHillParticipant
  }
}
    ${KingOfTheHillHostIndividualParticipantFragmentDoc}
${KingOfTheHillHostTeamParticipantFragmentDoc}
${UpcomingKingOfTheHillParticipantFragmentDoc}`;
export const BattleRoyaleSpecificDetailsFragmentDoc = gql`
    fragment BattleRoyaleSpecificDetails on BattleRoyaleSpecificDetails {
  maxRoundParticipants
  advanceFraction
  definedBucketDimensionsMap {
    id
    bucketLabel
    allBucketMultipliers {
      id
      resultBucket {
        id
        bucketTop
        bucketBottom
      }
      dimensionMultipliers {
        id
        dimensionId
        multiplier
      }
      staticValue
    }
  }
}
    `;
export const CsgoMatchDetailsFragmentDoc = gql`
    fragment CSGOMatchDetails on CSGOMatchDetails {
  serverDetails {
    serverUrl
    password
  }
}
    `;
export const CsgoCompetitionDetailsFragmentDoc = gql`
    fragment CSGOCompetitionDetails on CSGOCompetitionDetails {
  maxOvertimeRounds
  maxRounds
}
    `;
export const RoleIdFragmentDoc = gql`
    fragment RoleId on Role {
  roleId
}
    `;
export const GroupMemberFragmentDoc = gql`
    fragment GroupMember on GroupMember {
  id
  account {
    id
  }
  roles {
    ...RoleId
  }
}
    ${RoleIdFragmentDoc}`;
export const RoundTeamParticipantFragmentDoc = gql`
    fragment RoundTeamParticipant on TeamParticipant {
  id
  teamMembers {
    ... on ReadyIndividualParticipant {
      id
      gameAccount {
        id
        externalAccountName
        externalAccountId
        gameAccountTypeId
      }
      person {
        id
        displayName
        avatarURL
        publicURL
        additionalInformation {
          key
          value
        }
      }
    }
    ... on UnreadyIndividualParticipant {
      id
      person {
        id
        displayName
        avatarURL
        publicURL
        additionalInformation {
          key
          value
        }
      }
    }
  }
  team {
    id
    name
    publicURL
    avatarURL
    groupMembers {
      ...GroupMember
    }
  }
  result {
    ...Result
  }
}
    ${GroupMemberFragmentDoc}
${ResultFragmentDoc}`;
export const RoundIndividualParticipantFragmentDoc = gql`
    fragment RoundIndividualParticipant on IndividualParticipant {
  ... on ReadyIndividualParticipant {
    id
    gameAccount {
      id
      externalAccountName
      externalAccountId
      gameAccountTypeId
    }
    person {
      id
      displayName
      avatarURL
      publicURL
      additionalInformation {
        key
        value
      }
    }
  }
  ... on UnreadyIndividualParticipant {
    id
    person {
      id
      displayName
      avatarURL
      publicURL
      additionalInformation {
        key
        value
      }
    }
  }
  result {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export const RoundParticipantReferenceFragmentDoc = gql`
    fragment RoundParticipantReference on CompetitionParticipantReference {
  participant {
    ...RoundTeamParticipant
    ...RoundIndividualParticipant
  }
}
    ${RoundTeamParticipantFragmentDoc}
${RoundIndividualParticipantFragmentDoc}`;
export const MatchUpRoundFragmentDoc = gql`
    fragment MatchUpRound on MatchUpRound {
  id
  roundNumber
  isComplete
  participants {
    ...RoundParticipantReference
  }
}
    ${RoundParticipantReferenceFragmentDoc}`;
export const PlayableMatchUpMatchFragmentDoc = gql`
    fragment PlayableMatchUpMatch on PlayableMatchUpMatch {
  id
  startTime
  isComplete
  gameSpecificDetails {
    ...CSGOMatchDetails
    ...CSGOCompetitionDetails
  }
  rounds {
    ...MatchUpRound
  }
  participants {
    participant {
      ...MatchUpTeamParticipant
      ...MatchUpIndividualParticipant
    }
  }
}
    ${CsgoMatchDetailsFragmentDoc}
${CsgoCompetitionDetailsFragmentDoc}
${MatchUpRoundFragmentDoc}
${MatchUpTeamParticipantFragmentDoc}
${MatchUpIndividualParticipantFragmentDoc}`;
export const MatchUpPhaseFragmentDoc = gql`
    fragment MatchUpPhase on MatchUpPhase {
  id
  phaseNumber
  isComplete
  matches {
    id
    ...PlayableMatchUpMatch
  }
}
    ${PlayableMatchUpMatchFragmentDoc}`;
export const MatchUpFragmentDoc = gql`
    fragment MatchUp on MatchUp {
  id
  matchUpFormat
  matchUpFormatSpecificDetails {
    ...KingOfTheHillSpecificDetails
    ...BattleRoyaleSpecificDetails
  }
  phases {
    ...MatchUpPhase
  }
}
    ${KingOfTheHillSpecificDetailsFragmentDoc}
${BattleRoyaleSpecificDetailsFragmentDoc}
${MatchUpPhaseFragmentDoc}`;
export const ChallengeFragmentDoc = gql`
    fragment Challenge on Challenge {
  id
  challengeFormat
}
    `;
export const CompetitionFragmentDoc = gql`
    fragment Competition on Competition {
  id
  competitionType
  competitionState
  participants {
    participant {
      accountId
      ... on TeamParticipant {
        teamMembers {
          accountId
        }
      }
    }
  }
  ...Tournament
  ...MatchUp
  ...Challenge
}
    ${TournamentFragmentDoc}
${MatchUpFragmentDoc}
${ChallengeFragmentDoc}`;
export const EventStageFragmentDoc = gql`
    fragment EventStage on EventStage {
  id
  stageNumber
  competitions {
    ...Competition
  }
}
    ${CompetitionFragmentDoc}`;
export const SwarmioCurrencyPayoutPrizeFragmentDoc = gql`
    fragment SwarmioCurrencyPayoutPrize on SwarmioCurrencyPayoutPrize {
  id
  swarmioCurrencyId
  amount
  prizeType
}
    `;
export const CustomPrizeFragmentDoc = gql`
    fragment CustomPrize on CustomPrize {
  id
  localizedDescriptions {
    locale
    value
  }
  prizeType
}
    `;
export const FixedPrizeFragmentDoc = gql`
    fragment FixedPrize on FixedPrize {
  id
  prizeType
  ... on SwarmioCurrencyPayoutPrize {
    ...SwarmioCurrencyPayoutPrize
  }
  ... on CustomPrize {
    ...CustomPrize
  }
}
    ${SwarmioCurrencyPayoutPrizeFragmentDoc}
${CustomPrizeFragmentDoc}`;
export const VariablePrizeConditionFragmentDoc = gql`
    fragment VariablePrizeCondition on VariablePrizeCondition {
  id
  description
  order
  prize {
    ...FixedPrize
  }
  variablePrizeConditionType
  ... on SpecificSubscriptionPrizeCondition {
    subscriptionTypeId
  }
}
    ${FixedPrizeFragmentDoc}`;
export const VariablePrizeFragmentDoc = gql`
    fragment VariablePrize on VariablePrize {
  id
  conditionalPrizes {
    ...VariablePrizeCondition
  }
  defaultPrize {
    ...FixedPrize
  }
  prizeType
}
    ${VariablePrizeConditionFragmentDoc}
${FixedPrizeFragmentDoc}`;
export const PrizeFragmentDoc = gql`
    fragment Prize on Prize {
  id
  prizeType
  ... on SwarmioCurrencyPayoutPrize {
    ...SwarmioCurrencyPayoutPrize
  }
  ... on VariablePrize {
    ...VariablePrize
  }
  ... on CustomPrize {
    ...CustomPrize
  }
}
    ${SwarmioCurrencyPayoutPrizeFragmentDoc}
${VariablePrizeFragmentDoc}
${CustomPrizeFragmentDoc}`;
export const PrizeTierFragmentDoc = gql`
    fragment PrizeTier on PrizeTier {
  id
  placement
  placementRange
  prize {
    ...Prize
  }
}
    ${PrizeFragmentDoc}`;
export const PrizeListFragmentDoc = gql`
    fragment PrizeList on PrizeList {
  id
  prizeTiers {
    ...PrizeTier
  }
}
    ${PrizeTierFragmentDoc}`;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  localizations {
    locale
    value
  }
  name
}
    `;
export const EventFragmentDoc = gql`
    fragment Event on Event {
  id
  localizedDescriptions {
    locale
    value
  }
  localizedMediaContentDetails {
    locale
    value {
      avatar
      banner
      descriptionImage
      streams {
        ...TwitchStream
        ...YouTubeStream
        ...YouTubeVideo
      }
    }
  }
  localizedNames {
    value
    locale
  }
  category
  participantType
  eventState
  participantCount
  region
  gameAccountTypes {
    ...EventGameAccountTypes
  }
  game {
    ...TeamEventGame
  }
  eventTiming {
    startTime
    registrationOpen
    registrationClose
  }
  eventLimitations {
    maximumParticipants
    minimumParticipants
    localizedWrittenRules {
      locale
      value
    }
    localizedJoinInstructions {
      locale
      value
    }
    eventEntryRules {
      ...TeamEventEntryRules
    }
    checkInMode
    requiredAdditionalInformation
  }
  eventStages {
    ...EventStage
  }
  eventCurrencyExchanges {
    prizeList {
      ...PrizeList
    }
  }
  tags {
    ...Tag
  }
}
    ${TwitchStreamFragmentDoc}
${YouTubeStreamFragmentDoc}
${YouTubeVideoFragmentDoc}
${EventGameAccountTypesFragmentDoc}
${TeamEventGameFragmentDoc}
${TeamEventEntryRulesFragmentDoc}
${EventStageFragmentDoc}
${PrizeListFragmentDoc}
${TagFragmentDoc}`;
export const GameAccountFragmentDoc = gql`
    fragment GameAccount on GameAccount {
  id
  gameIds
  gameAccountTypeId
  externalAccountName
  externalAccountId
}
    `;
export const GroupInviteFragmentDoc = gql`
    fragment GroupInvite on GroupInvite {
  id
  group {
    id
    name
    avatarURL
    publicURL
  }
}
    `;
export const GroupInviteWithPossibleErrorFragmentDoc = gql`
    fragment GroupInviteWithPossibleError on GroupInviteWithPossibleError {
  ...GroupInvite
}
    ${GroupInviteFragmentDoc}`;
export const StoreCategoryFragmentDoc = gql`
    fragment StoreCategory on CategoryCatalog {
  id
  categoryName
  categoryIcon
  categoryCoverImage
  categoryImage
  featured
}
    `;
export const SubscriptionTypeForEventDetailsFragmentDoc = gql`
    fragment SubscriptionTypeForEventDetails on SubscriptionType {
  id
  localizedNames {
    locale
    value
  }
}
    `;
export const SltExternalSubscriptionPackageFragmentDoc = gql`
    fragment SLTExternalSubscriptionPackage on SLTExternalSubscriptionPackage {
  dataQuota
}
    `;
export const ExternalSubscriptionPackageFragmentDoc = gql`
    fragment ExternalSubscriptionPackage on ExternalSubscriptionPackage {
  id
  subscriptionPartner
  subscriptionProvider
  subscriptionType {
    id
  }
  costs {
    id
    amount
    frequency
    ... on RealWorldCurrencyCost {
      currency
    }
  }
  ...SLTExternalSubscriptionPackage
}
    ${SltExternalSubscriptionPackageFragmentDoc}`;
export const SubscriptionTypeFragmentDoc = gql`
    fragment SubscriptionType on SubscriptionType {
  id
  enrollable
  localizedDescriptions {
    locale
    value
  }
  localizedNames {
    locale
    value
  }
  weight
  implicitEnrollments {
    id
    externalSubscriptionPackage {
      ...ExternalSubscriptionPackage
    }
  }
  explicitEnrollment {
    id
    costs {
      id
      amount
      frequency
      created
      costType
      ... on RealWorldCurrencyCost {
        currency
      }
    }
    costsArchive {
      id
      amount
      frequency
      ... on RealWorldCurrencyCost {
        currency
      }
    }
  }
  initialSwarmioCurrencyReward {
    id
    swarmioCurrencyId
    amount
  }
  recurringPayoutBonus {
    id
    paymentFrequency
    swarmioCurrencyId
    amount
  }
}
    ${ExternalSubscriptionPackageFragmentDoc}`;
export const SubscriptionTypeWithExternalPackagesFragmentDoc = gql`
    fragment SubscriptionTypeWithExternalPackages on SubscriptionType {
  ...SubscriptionType
}
    ${SubscriptionTypeFragmentDoc}`;
export const SwarmioSubscriptionFragmentDoc = gql`
    fragment SwarmioSubscription on SwarmioSubscription {
  id
  subscriptionTypeId
  subscriptionType {
    ...SubscriptionType
  }
  subscriptionState
  ... on ImplicitSubscription {
    externalSubscriptionPackage {
      ...ExternalSubscriptionPackage
    }
  }
  ... on ExplicitSubscription {
    subscriptionTypeCostId
  }
}
    ${SubscriptionTypeFragmentDoc}
${ExternalSubscriptionPackageFragmentDoc}`;
export const UpdateUserAvatarFragmentDoc = gql`
    fragment UpdateUserAvatar on Person {
  id
  avatarURL
}
    `;
export const UpdateUserBannerFragmentDoc = gql`
    fragment UpdateUserBanner on Person {
  id
  bannerURL
}
    `;
export const SubscriptionProviderAccountFragmentDoc = gql`
    fragment SubscriptionProviderAccount on SubscriptionProviderAccount {
  id
  subscriptionProvider
  externalSubscriptionProviderAccountId
  subscriptionProviderAccountState
}
    `;
export const UserProviderAccountsFragmentDoc = gql`
    fragment UserProviderAccounts on Account {
  id
  ... on Person {
    subscriptionProviderAccounts {
      ...SubscriptionProviderAccount
    }
  }
}
    ${SubscriptionProviderAccountFragmentDoc}`;
export const GameAccountTypeFragmentDoc = gql`
    fragment GameAccountType on GameAccountType {
  id
  prettyName
  integrated
  accountIDLabel
  accountNameLabel
  implicitGameIds
  requiresExternalAccountId
  imageUrl
  iconUrl
}
    `;
export const GameFragmentDoc = gql`
    fragment Game on Game {
  id
  prettyName
  description
  image
  integrated
  gameAccountTypeIds
  weight
  gameAccountTypes {
    ...GameAccountType
  }
}
    ${GameAccountTypeFragmentDoc}`;
export const GameAccountTypeWithGamesFragmentDoc = gql`
    fragment GameAccountTypeWithGames on GameAccountType {
  ...GameAccountType
  games {
    ...Game
  }
}
    ${GameAccountTypeFragmentDoc}
${GameFragmentDoc}`;
export const GameAccountOnGroupMemberForEventJoinFragmentDoc = gql`
    fragment GameAccountOnGroupMemberForEventJoin on GameAccount {
  id
  gameAccountTypeId
  gameIds
  externalAccountId
  externalAccountName
}
    `;
export const AccountOnGroupMemberForEventJoinFragmentDoc = gql`
    fragment AccountOnGroupMemberForEventJoin on Account {
  id
  avatarURL
  publicURL
  ... on Person {
    isVIP
    displayName
    gameAccounts {
      ...GameAccountOnGroupMemberForEventJoin
    }
  }
}
    ${GameAccountOnGroupMemberForEventJoinFragmentDoc}`;
export const GroupMemberOnTeamForEventJoinFragmentDoc = gql`
    fragment GroupMemberOnTeamForEventJoin on GroupMember {
  id
  account {
    ...AccountOnGroupMemberForEventJoin
  }
}
    ${AccountOnGroupMemberForEventJoinFragmentDoc}`;
export const TeamGroupMembersForEventJoinFragmentDoc = gql`
    fragment TeamGroupMembersForEventJoin on Team {
  groupMembers {
    ...GroupMemberOnTeamForEventJoin
  }
}
    ${GroupMemberOnTeamForEventJoinFragmentDoc}`;
export const TeamForEventJoinFragmentDoc = gql`
    fragment TeamForEventJoin on Team {
  id
  ownerId
  name
  description
  bannerURL
  avatarURL
  publicURL
  ...TeamGroupMembersForEventJoin
}
    ${TeamGroupMembersForEventJoinFragmentDoc}`;
export const GameAccountOnAccountForEventJoinFragmentDoc = gql`
    fragment GameAccountOnAccountForEventJoin on GameAccount {
  id
  gameAccountTypeId
  gameIds
  externalAccountId
  externalAccountName
}
    `;
export const AccountForEventJoinFragmentDoc = gql`
    fragment AccountForEventJoin on Account {
  id
  avatarURL
  publicURL
  ... on Person {
    isVIP
    displayName
    gameAccounts {
      ...GameAccountOnAccountForEventJoin
    }
  }
}
    ${GameAccountOnAccountForEventJoinFragmentDoc}`;
export const GroupMemberOnGroupMembershipFragmentDoc = gql`
    fragment GroupMemberOnGroupMembership on GroupMember {
  id
  roles {
    roleId
  }
  account {
    id
    ... on Person {
      displayName
      avatarURL
      publicURL
    }
  }
}
    `;
export const GroupTraitFragmentDoc = gql`
    fragment GroupTrait on GroupTrait {
  id
  avatarURL
  bannerURL
  name
  ownerId
  publicURL
  groupMembers {
    ...GroupMemberOnGroupMembership
  }
}
    ${GroupMemberOnGroupMembershipFragmentDoc}`;
export const GroupMembershipFragmentDoc = gql`
    fragment GroupMembership on GroupMembership {
  id
  roles {
    roleId
  }
  group {
    ...GroupTrait
  }
}
    ${GroupTraitFragmentDoc}`;
export const GroupMemberOnCreateTeamFragmentDoc = gql`
    fragment GroupMemberOnCreateTeam on GroupMember {
  id
  account {
    id
    groupMemberships {
      ...GroupMembership
    }
  }
}
    ${GroupMembershipFragmentDoc}`;
export const TeamParticipantsForParticipantConfirmationFragmentDoc = gql`
    fragment TeamParticipantsForParticipantConfirmation on TeamParticipant {
  id
  confirmed
  team {
    id
    groupMembers {
      id
      account {
        id
      }
      roles {
        roleDisplayName
        roleId
      }
    }
  }
  teamMembers {
    ... on ReadyIndividualParticipant {
      id
      person {
        id
      }
    }
    ... on UnreadyIndividualParticipant {
      id
      person {
        id
      }
    }
  }
}
    `;
export const IndividualParticipantsForParticipantConfirmationFragmentDoc = gql`
    fragment IndividualParticipantsForParticipantConfirmation on IndividualParticipant {
  confirmed
  ... on ReadyIndividualParticipant {
    id
    person {
      id
    }
  }
  ... on UnreadyIndividualParticipant {
    id
    person {
      id
    }
  }
}
    `;
export const TechnicalParticipantForParticipantConfirmationFragmentDoc = gql`
    fragment TechnicalParticipantForParticipantConfirmation on TechnicalParticipant {
  id
  accountId
  participant {
    ...TeamParticipantsForParticipantConfirmation
    ...IndividualParticipantsForParticipantConfirmation
  }
  roles {
    roleDisplayName
  }
}
    ${TeamParticipantsForParticipantConfirmationFragmentDoc}
${IndividualParticipantsForParticipantConfirmationFragmentDoc}`;
export const EventToMatchUpFragmentDoc = gql`
    fragment EventToMatchUp on Event {
  eventStages {
    ...EventStage
  }
  game {
    id
  }
  eventState
  eventLimitations {
    localizedJoinInstructions {
      locale
      value
    }
  }
  participantType
}
    ${EventStageFragmentDoc}`;
export const MinimalDataForStandingListFragmentDoc = gql`
    fragment MinimalDataForStandingList on EventStage {
  id
  competitions {
    participants {
      accountId
      result {
        score
        placement
        showed
      }
      participant {
        ... on TeamParticipant {
          teamMembers {
            accountId
          }
          team {
            avatarURL
            name
          }
        }
        ... on ReadyIndividualParticipant {
          gameAccount {
            externalAccountName
          }
          person {
            avatarURL
            displayName
          }
        }
        ... on UnreadyIndividualParticipant {
          person {
            avatarURL
            displayName
          }
        }
      }
    }
    ... on Challenge {
      challengeFormat
    }
    competitionType
  }
}
    `;
export const TournamentRoundFragmentDoc = gql`
    fragment TournamentRound on TournamentRound {
  id
}
    `;
export const TeamOnMatchParticipantFragmentDoc = gql`
    fragment TeamOnMatchParticipant on Team {
  id
  name
  avatarURL
  groupMembers {
    id
    account {
      id
    }
    roles {
      roleId
    }
  }
}
    `;
export const MatchTeamParticipantFragmentDoc = gql`
    fragment MatchTeamParticipant on TeamParticipant {
  id
  team {
    ...TeamOnMatchParticipant
  }
  teamMembers {
    ... on ReadyIndividualParticipant {
      id
    }
    ... on UnreadyIndividualParticipant {
      id
    }
    accountId
  }
  result {
    ...Result
  }
}
    ${TeamOnMatchParticipantFragmentDoc}
${ResultFragmentDoc}`;
export const PersonOnMatchParticipantFragmentDoc = gql`
    fragment PersonOnMatchParticipant on Person {
  id
  displayName
  avatarURL
}
    `;
export const MatchIndividualParticipantFragmentDoc = gql`
    fragment MatchIndividualParticipant on IndividualParticipant {
  accountId
  ... on ReadyIndividualParticipant {
    id
    person {
      ...PersonOnMatchParticipant
    }
  }
  ... on UnreadyIndividualParticipant {
    id
    person {
      ...PersonOnMatchParticipant
    }
  }
  result {
    ...Result
  }
}
    ${PersonOnMatchParticipantFragmentDoc}
${ResultFragmentDoc}`;
export const CompetitionParticipantReferenceWithSeededMatchIdFragmentDoc = gql`
    fragment CompetitionParticipantReferenceWithSeededMatchId on CompetitionParticipantReferenceWithRoster {
  seededFromCompetitionMatchId
}
    `;
export const MatchParticipantReferenceFragmentDoc = gql`
    fragment MatchParticipantReference on ParticipantReference {
  participant {
    ...MatchTeamParticipant
    ...MatchIndividualParticipant
  }
  ...CompetitionParticipantReferenceWithSeededMatchId
}
    ${MatchTeamParticipantFragmentDoc}
${MatchIndividualParticipantFragmentDoc}
${CompetitionParticipantReferenceWithSeededMatchIdFragmentDoc}`;
export const PlayableTournamentMatchFragmentDoc = gql`
    fragment PlayableTournamentMatch on PlayableTournamentMatch {
  id
  startTime
  isComplete
  rounds {
    ...TournamentRound
  }
  gameSpecificDetails {
    ...CSGOMatchDetails
  }
  participants {
    ...MatchParticipantReference
  }
}
    ${TournamentRoundFragmentDoc}
${CsgoMatchDetailsFragmentDoc}
${MatchParticipantReferenceFragmentDoc}`;
export const TournamentMatchByeFragmentDoc = gql`
    fragment TournamentMatchBye on TournamentMatchBye {
  id
  startTime
  participants {
    ...MatchParticipantReference
  }
}
    ${MatchParticipantReferenceFragmentDoc}`;
export const TournamentPhaseFragmentDoc = gql`
    fragment TournamentPhase on TournamentPhase {
  id
  phaseNumber
  matches {
    id
    ...PlayableTournamentMatch
    ...TournamentMatchBye
  }
}
    ${PlayableTournamentMatchFragmentDoc}
${TournamentMatchByeFragmentDoc}`;
export const TournamentBracketFragmentDoc = gql`
    fragment TournamentBracket on TournamentBracket {
  id
  name
  phases {
    ...TournamentPhase
  }
}
    ${TournamentPhaseFragmentDoc}`;
export const PhaseModificationsFragmentDoc = gql`
    fragment PhaseModifications on PhaseModifications {
  defaultMatchStartTime
  matchModifications {
    assets {
      name
    }
    matchId
    name
    startTime
  }
  numberOfRounds
  phaseNumber
}
    `;
export const BracketModificationsFragmentDoc = gql`
    fragment BracketModifications on BracketModifications {
  bracketName
  phaseModifications {
    ...PhaseModifications
  }
}
    ${PhaseModificationsFragmentDoc}`;
export const CompetitionOnBracketsForEventFragmentDoc = gql`
    fragment CompetitionOnBracketsForEvent on Tournament {
  id
  ... on Tournament {
    phaseBufferTime
    numberOfRounds
    brackets {
      ...TournamentBracket
    }
    bracketModifications {
      ...BracketModifications
    }
  }
}
    ${TournamentBracketFragmentDoc}
${BracketModificationsFragmentDoc}`;
export const EventStageOnBracketsForEventFragmentDoc = gql`
    fragment EventStageOnBracketsForEvent on EventStage {
  id
  competitions {
    ...CompetitionOnBracketsForEvent
  }
}
    ${CompetitionOnBracketsForEventFragmentDoc}`;
export const BracketsForEventFragmentDoc = gql`
    fragment BracketsForEvent on Event {
  id
  eventState
  game {
    ...TeamEventGame
  }
  eventStages {
    ...EventStageOnBracketsForEvent
  }
  participantCount
}
    ${TeamEventGameFragmentDoc}
${EventStageOnBracketsForEventFragmentDoc}`;
export const TeamMemberOnMatchParticipantFragmentDoc = gql`
    fragment TeamMemberOnMatchParticipant on IndividualParticipant {
  ... on ReadyIndividualParticipant {
    id
    gameAccount {
      id
      externalAccountName
      externalAccountId
      gameAccountTypeId
    }
    person {
      id
      displayName
      avatarURL
      publicURL
    }
  }
  ... on UnreadyIndividualParticipant {
    id
    person {
      id
      displayName
      avatarURL
      publicURL
    }
  }
}
    `;
export const ParticipantOnEventMatchFragmentDoc = gql`
    fragment ParticipantOnEventMatch on TeamParticipant {
  id
  teamMembers {
    ...TeamMemberOnMatchParticipant
  }
  team {
    ...TeamOnMatchParticipant
  }
  result {
    ...Result
  }
}
    ${TeamMemberOnMatchParticipantFragmentDoc}
${TeamOnMatchParticipantFragmentDoc}
${ResultFragmentDoc}`;
export const PlayableTournamentMatchOnMatchDetailsFragmentDoc = gql`
    fragment PlayableTournamentMatchOnMatchDetails on PlayableTournamentMatch {
  id
  isComplete
  startTime
  rounds {
    id
    participants {
      ...RoundParticipantReference
    }
  }
  participants {
    participant {
      ...ParticipantOnEventMatch
    }
  }
  gameSpecificDetails {
    ...CSGOMatchDetails
  }
}
    ${RoundParticipantReferenceFragmentDoc}
${ParticipantOnEventMatchFragmentDoc}
${CsgoMatchDetailsFragmentDoc}`;
export const MissingParticipantRequirementsFragmentDoc = gql`
    fragment MissingParticipantRequirements on MissingParticipantRequirement {
  entryName
  ... on NotEnoughTeamMembers {
    needsMore
  }
}
    `;
export const IndividualParticipantMissingRequirementsFragmentDoc = gql`
    fragment IndividualParticipantMissingRequirements on Participant {
  accountId
  participantType
  requirementsNotMet {
    participantID
    missingParticipantRequirement {
      ...MissingParticipantRequirements
    }
  }
}
    ${MissingParticipantRequirementsFragmentDoc}`;
export const TeamParticipantMissingRequirementsFragmentDoc = gql`
    fragment TeamParticipantMissingRequirements on TeamParticipant {
  requirementsNotMet {
    participantID
    missingParticipantRequirement {
      ...MissingParticipantRequirements
    }
  }
  teamMembers {
    accountId
    participantType
    requirementsNotMet {
      participantID
      missingParticipantRequirement {
        ...MissingParticipantRequirements
      }
    }
  }
}
    ${MissingParticipantRequirementsFragmentDoc}`;
export const EventUsersParticipantsFragmentDoc = gql`
    fragment EventUsersParticipants on IndividualParticipant {
  participantType
  ... on ReadyIndividualParticipant {
    id
    requirementsNotMet {
      participantID
      missingParticipantRequirement {
        ...MissingParticipantRequirements
      }
    }
    accountId
    person {
      id
      displayName
      avatarURL
      additionalInformation {
        key
        value
      }
    }
    confirmed
    inviteLink {
      id
      code
    }
  }
  ... on UnreadyIndividualParticipant {
    id
    requirementsNotMet {
      participantID
      missingParticipantRequirement {
        ...MissingParticipantRequirements
      }
    }
    accountId
    person {
      id
      displayName
      avatarURL
      additionalInformation {
        key
        value
      }
    }
    confirmed
    inviteLink {
      id
      code
    }
  }
}
    ${MissingParticipantRequirementsFragmentDoc}`;
export const GroupMembersTeamEventFragmentDoc = gql`
    fragment GroupMembersTeamEvent on GroupMember {
  id
  account {
    id
    ... on Person {
      displayName
      avatarURL
    }
  }
  roles {
    roleId
  }
}
    `;
export const TeamEventDataFragmentDoc = gql`
    fragment TeamEventData on Team {
  id
  name
  ownerId
  groupMembers {
    ...GroupMembersTeamEvent
  }
}
    ${GroupMembersTeamEventFragmentDoc}`;
export const TeamMembersForEditLineupFragmentDoc = gql`
    fragment TeamMembersForEditLineup on Team {
  groupMembers {
    id
    account {
      avatarURL
      ... on Person {
        displayName
      }
    }
  }
}
    `;
export const TeamForEditLineupFragmentDoc = gql`
    fragment TeamForEditLineup on Team {
  id
  ...TeamMembersForEditLineup
}
    ${TeamMembersForEditLineupFragmentDoc}`;
export const IndividualParticipantsForParticipantTabFragmentDoc = gql`
    fragment IndividualParticipantsForParticipantTab on IndividualParticipant {
  confirmed
  ... on ReadyIndividualParticipant {
    id
    person {
      id
      displayName
      avatarURL
      additionalInformation {
        key
        value
      }
    }
    gameAccount {
      id
      externalAccountName
      externalAccountId
      gameAccountTypeId
    }
  }
  ... on UnreadyIndividualParticipant {
    id
    person {
      id
      displayName
      avatarURL
      additionalInformation {
        key
        value
      }
    }
  }
}
    `;
export const TeamParticipantsForParticipantTabFragmentDoc = gql`
    fragment TeamParticipantsForParticipantTab on TeamParticipant {
  id
  confirmed
  team {
    id
    name
    avatarURL
    publicURL
  }
  teamMembers {
    ... on ReadyIndividualParticipant {
      id
      gameAccount {
        id
        externalAccountName
        externalAccountId
        gameAccountTypeId
      }
      person {
        id
        displayName
        avatarURL
        publicURL
        additionalInformation {
          key
          value
        }
      }
    }
    ... on UnreadyIndividualParticipant {
      id
      person {
        id
        displayName
        avatarURL
        publicURL
        additionalInformation {
          key
          value
        }
      }
    }
    confirmed
  }
}
    `;
export const TeamParticipantForPrizesTabFragmentDoc = gql`
    fragment TeamParticipantForPrizesTab on TeamParticipant {
  id
  teamMembers {
    ... on ReadyIndividualParticipant {
      id
    }
    ... on UnreadyIndividualParticipant {
      id
    }
    result {
      ...Result
    }
  }
  team {
    id
    name
    avatarURL
    publicURL
  }
}
    ${ResultFragmentDoc}`;
export const IndividualParticipantForPrizesTabFragmentDoc = gql`
    fragment IndividualParticipantForPrizesTab on IndividualParticipant {
  ... on ReadyIndividualParticipant {
    id
    person {
      id
      displayName
      avatarURL
      publicURL
    }
  }
  ... on UnreadyIndividualParticipant {
    id
    person {
      id
      displayName
      avatarURL
      publicURL
    }
  }
  result {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export const EventForGetFormatFragmentDoc = gql`
    fragment EventForGetFormat on Event {
  tags {
    ...Tag
  }
  eventStages {
    competitions {
      ... on Challenge {
        challengeFormat
      }
      ... on MatchUp {
        matchUpFormat
      }
      ... on Tournament {
        tournamentFormat
      }
    }
  }
}
    ${TagFragmentDoc}`;
export const TeamParticipantOnActiveMatchFragmentDoc = gql`
    fragment TeamParticipantOnActiveMatch on TeamParticipant {
  id
  teamMembers {
    ...TeamMemberOnMatchParticipant
  }
  team {
    id
    name
    avatarURL
    publicURL
    groupMembers {
      id
      account {
        id
      }
      roles {
        roleId
      }
    }
  }
  result {
    ...Result
  }
}
    ${TeamMemberOnMatchParticipantFragmentDoc}
${ResultFragmentDoc}`;
export const IndividualParticipantOnActiveMatchFragmentDoc = gql`
    fragment IndividualParticipantOnActiveMatch on IndividualParticipant {
  ... on ReadyIndividualParticipant {
    id
    gameAccount {
      id
      externalAccountName
      externalAccountId
      gameAccountTypeId
    }
    person {
      id
      displayName
      avatarURL
      publicURL
    }
  }
  ... on UnreadyIndividualParticipant {
    id
    person {
      id
      displayName
      avatarURL
      publicURL
    }
  }
  result {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export const PlayableTournamentMatchOnActiveMatchesFragmentDoc = gql`
    fragment PlayableTournamentMatchOnActiveMatches on PlayableTournamentMatch {
  id
  startTime
  isComplete
  participants {
    participant {
      ...TeamParticipantOnActiveMatch
      ...IndividualParticipantOnActiveMatch
    }
  }
}
    ${TeamParticipantOnActiveMatchFragmentDoc}
${IndividualParticipantOnActiveMatchFragmentDoc}`;
export const PlayableMatchUpMatchOnActiveMatchesFragmentDoc = gql`
    fragment PlayableMatchUpMatchOnActiveMatches on PlayableMatchUpMatch {
  id
  startTime
  isComplete
  participants {
    participant {
      ...TeamParticipantOnActiveMatch
      ...IndividualParticipantOnActiveMatch
    }
  }
}
    ${TeamParticipantOnActiveMatchFragmentDoc}
${IndividualParticipantOnActiveMatchFragmentDoc}`;
export const KothDetailsForAllEventsFragmentDoc = gql`
    fragment KothDetailsForAllEvents on KingOfTheHillSpecificDetails {
  id
  host {
    accountId
    ... on TeamParticipant {
      teamMembers {
        ... on ReadyIndividualParticipant {
          id
          person {
            id
          }
        }
        ... on UnreadyIndividualParticipant {
          id
          person {
            id
          }
        }
      }
    }
    ... on ReadyIndividualParticipant {
      person {
        id
      }
    }
    ... on UnreadyIndividualParticipant {
      person {
        id
      }
    }
  }
}
    `;
export const AllEventsCompetitionFragmentDoc = gql`
    fragment AllEventsCompetition on Competition {
  id
  ... on Tournament {
    tournamentFormat
  }
  ... on MatchUp {
    matchUpFormat
    matchUpFormatSpecificDetails {
      ...KothDetailsForAllEvents
      ... on BattleRoyaleSpecificDetails {
        id
        matchUpFormat
      }
    }
  }
  ... on Challenge {
    challengeFormat
  }
  competitionType
  competitionState
}
    ${KothDetailsForAllEventsFragmentDoc}`;
export const AllEventsEventFragmentDoc = gql`
    fragment AllEventsEvent on Event {
  id
  featured
  category
  region
  gameId
  localizedMediaContentDetails {
    locale
    value {
      avatar
      banner
      streams {
        ...TwitchStream
        ...YouTubeVideo
        ...YouTubeStream
      }
    }
  }
  eventLimitations {
    maximumParticipants
    minimumParticipants
    eventEntryRules {
      id
      ... on TeamEventEntryRules {
        minimumTeamMembers
        maximumTeamMembers
      }
    }
  }
  eventStages {
    id
    competitions {
      ...AllEventsCompetition
    }
  }
  eventTiming {
    startTime
    registrationClose
  }
  participantType
  participantCount
  eventState
  localizedNames {
    locale
    value
  }
  gameAccountTypes {
    id
    prettyName
  }
  game {
    id
    prettyName
  }
  tags {
    ...Tag
  }
}
    ${TwitchStreamFragmentDoc}
${YouTubeVideoFragmentDoc}
${YouTubeStreamFragmentDoc}
${AllEventsCompetitionFragmentDoc}
${TagFragmentDoc}`;
export const InGameResultFragmentDoc = gql`
    fragment InGameResult on InGameResult {
  id
  matchId
  scores {
    id
    score
  }
}
    `;
export const GroupMembershipOnChangeRolesMutationFragmentDoc = gql`
    fragment GroupMembershipOnChangeRolesMutation on GroupMembership {
  id
  roles {
    roleId
  }
}
    `;
export const GroupMemberOnChangeRolesMutationFragmentDoc = gql`
    fragment GroupMemberOnChangeRolesMutation on GroupMember {
  id
  roles {
    roleId
  }
  account {
    id
    groupMemberships {
      ...GroupMembershipOnChangeRolesMutation
    }
  }
}
    ${GroupMembershipOnChangeRolesMutationFragmentDoc}`;
export const ChangeRolesMutationResponseFragmentDoc = gql`
    fragment ChangeRolesMutationResponse on GroupTrait {
  id
  ownerId
  groupMembers {
    ...GroupMemberOnChangeRolesMutation
  }
}
    ${GroupMemberOnChangeRolesMutationFragmentDoc}`;
export const AccountProjectionFragmentDoc = gql`
    fragment AccountProjection on AccountProjection {
  id
  displayName
  avatarURL
  publicURL
}
    `;
export const PublicEventParticipationFragmentDoc = gql`
    fragment PublicEventParticipation on Event {
  id
  category
  participantType
  localizedNames {
    locale
    value
  }
  game {
    prettyName
  }
  eventStages {
    competitions {
      id
      competitionType
    }
  }
  eventTiming {
    startTime
    completedAt
  }
  participants {
    result {
      score
      placement
    }
    ... on TeamParticipant {
      teamId
      teamMembers {
        ... on ReadyIndividualParticipant {
          person {
            id
          }
        }
        ... on UnreadyIndividualParticipant {
          person {
            id
          }
        }
        result {
          ...Result
        }
      }
    }
    ... on ReadyIndividualParticipant {
      person {
        id
      }
      result {
        ...Result
      }
    }
    ... on UnreadyIndividualParticipant {
      person {
        id
      }
      result {
        ...Result
      }
    }
  }
  eventCurrencyExchanges {
    prizeList {
      ...PrizeList
    }
  }
}
    ${ResultFragmentDoc}
${PrizeListFragmentDoc}`;
export const PublicUserFragmentDoc = gql`
    fragment PublicUser on Person {
  id
  displayName
  description
  avatarURL
  bannerURL
  avatarURL
  isVIP
  socialLinks {
    socialLinkType
    link
  }
  groupMemberships {
    id
    roles {
      roleId
    }
    created
    group {
      id
      name
      description
      bannerURL
      avatarURL
      publicURL
      socialLinks {
        link
        socialLinkType
      }
    }
  }
  eventParticipations {
    ...PublicEventParticipation
  }
}
    ${PublicEventParticipationFragmentDoc}`;
export const PublicGameServerFragmentDoc = gql`
    fragment PublicGameServer on PublicGameServer {
  id
  ip
  port
  name
  description
  imageURL
  connectString
  steamURL
  status
  serverType
  timeRequested
  timeAcquired
  timeDestroyed
  region
  status
  serverType
  maxNumberOfPlayers
  featured
}
    `;
export const IdentityProviderFragmentDoc = gql`
    fragment IdentityProvider on IdentityProvider {
  providerType
  externalAccountId
}
    `;
export const LinkedAccountsFragmentDoc = gql`
    fragment LinkedAccounts on Person {
  linkedAccounts {
    ...IdentityProvider
    isError
  }
}
    ${IdentityProviderFragmentDoc}`;
export const StoreItemFragmentDoc = gql`
    fragment StoreItem on SwarmioItem {
  id
  name
  categoryIds
  costs {
    targetCurrencyPrices {
      price
    }
  }
  productType
  productOrigin
  provisioner
  images
}
    `;
export const RootCode_OrderFragmentDoc = gql`
    fragment RootCode_Order on RootCode_Order {
  id
  gamerId
  transactionId
  vouchers {
    voucherCode
    voucherSerial
    voucherPin
  }
}
    `;
export const PurchaseTransactionFragmentDoc = gql`
    fragment PurchaseTransaction on PurchaseTransaction {
  id
  created
  status
  paymentTransactionId
  item {
    ...StoreItem
  }
  order {
    ...RootCode_Order
  }
}
    ${StoreItemFragmentDoc}
${RootCode_OrderFragmentDoc}`;
export const SocialLinkFragmentDoc = gql`
    fragment SocialLink on SocialLink {
  socialLinkType
  link
}
    `;
export const SocialLinksFragmentDoc = gql`
    fragment SocialLinks on Team {
  socialLinks {
    ...SocialLink
  }
}
    ${SocialLinkFragmentDoc}`;
export const GroupMemberOnTeamFragmentDoc = gql`
    fragment GroupMemberOnTeam on GroupMember {
  id
  inviteCode {
    code
    expiry
  }
  roles {
    roleId
  }
  created
  account {
    id
    avatarURL
    publicURL
    ... on Person {
      isVIP
      displayName
    }
  }
}
    `;
export const TeamGroupMembersFragmentDoc = gql`
    fragment TeamGroupMembers on Team {
  groupMembers {
    ...GroupMemberOnTeam
  }
}
    ${GroupMemberOnTeamFragmentDoc}`;
export const TeamProfileFragmentDoc = gql`
    fragment TeamProfile on Team {
  id
  ownerId
  name
  description
  bannerURL
  avatarURL
  publicURL
  ...SocialLinks
  ...TeamGroupMembers
  eventParticipations {
    ...PublicEventParticipation
  }
}
    ${SocialLinksFragmentDoc}
${TeamGroupMembersFragmentDoc}
${PublicEventParticipationFragmentDoc}`;
export const SwarmioCurrencyItemFragmentDoc = gql`
    fragment SwarmioCurrencyItem on SwarmioCurrencyItem {
  id
  amount
  dealTagline
  swarmioCurrencyId
  active
  created
  costs {
    id
    swarmioCurrencyItemId
    cost
    realWorldCurrencyType
    created
    version
  }
}
    `;
export const SwarmioPayPaymentOnPurchaseHistoryFragmentDoc = gql`
    fragment SwarmioPayPaymentOnPurchaseHistory on SwarmioPayPayment {
  id
  paymentStatus
  dateReceived
  itemId
  internalTransactionId
  paymentProviderTransactionId
}
    `;
export const SwarmioCurrencyOnWalletsForOwnerFragmentDoc = gql`
    fragment SwarmioCurrencyOnWalletsForOwner on SwarmioCurrency {
  id
  name
  cashable
}
    `;
export const NodeOnSwarmioWalletTransactionFragmentDoc = gql`
    fragment NodeOnSwarmioWalletTransaction on SwarmioWalletTransactionWithMetadata {
  id
  transactionType
  walletId
  amount
  created
  ... on FreebieTransaction {
    notes
  }
}
    `;
export const TransactionsOnWalletsForOwnerFragmentDoc = gql`
    fragment TransactionsOnWalletsForOwner on PaginatedSwarmioWalletTransactionWithMetadata {
  totalCount
  hasNextPage
  nodes {
    ...NodeOnSwarmioWalletTransaction
  }
}
    ${NodeOnSwarmioWalletTransactionFragmentDoc}`;
export const TwitchStream_V2FragmentDoc = gql`
    fragment TwitchStream_v2 on MediaTwitchStreamType {
  expiry
  gameId
  gameName
  weight
  thumbnailUrl
  title
  userName
  userLogin
  viewerCount
  startedAt
  providerIdentifier
  language
}
    `;
export const RuleFragmentDoc = gql`
    fragment Rule on Rule {
  id
  name
}
    `;
export const SegmentFragmentDoc = gql`
    fragment Segment on Segment {
  id
  name
  rules {
    ...Rule
  }
}
    ${RuleFragmentDoc}`;
export const FeatureFlagFragmentDoc = gql`
    fragment FeatureFlag on FeatureFlag {
  id
  feature {
    id
    name
  }
  state
  segments {
    ...Segment
  }
}
    ${SegmentFragmentDoc}`;
export const AddSltAccountDocument = gql`
    mutation addSLTAccount($accountId: String!, $sltAccountCreationRequest: SLTAccountCreationRequest!) {
  addSLTAccount(
    accountId: $accountId
    sltAccountCreationRequest: $sltAccountCreationRequest
  ) {
    id
    ...UserProviderAccounts
    subscriptions {
      ...SwarmioSubscription
    }
  }
}
    ${UserProviderAccountsFragmentDoc}
${SwarmioSubscriptionFragmentDoc}`;
export type AddSltAccountMutationFn = Apollo.MutationFunction<AddSltAccountMutation, AddSltAccountMutationVariables>;

/**
 * __useAddSltAccountMutation__
 *
 * To run a mutation, you first call `useAddSltAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSltAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSltAccountMutation, { data, loading, error }] = useAddSltAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      sltAccountCreationRequest: // value for 'sltAccountCreationRequest'
 *   },
 * });
 */
export function useAddSltAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddSltAccountMutation, AddSltAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSltAccountMutation, AddSltAccountMutationVariables>(AddSltAccountDocument, options);
      }
export type AddSltAccountMutationHookResult = ReturnType<typeof useAddSltAccountMutation>;
export type AddSltAccountMutationResult = Apollo.MutationResult<AddSltAccountMutation>;
export type AddSltAccountMutationOptions = Apollo.BaseMutationOptions<AddSltAccountMutation, AddSltAccountMutationVariables>;
export const ValidateSltAccountDocument = gql`
    query validateSLTAccount($accountId: String!, $sltAccountCreationRequest: SLTAccountCreationRequest!) {
  validateSLTAccount(
    accountId: $accountId
    sltAccountCreationRequest: $sltAccountCreationRequest
  )
}
    `;

/**
 * __useValidateSltAccountQuery__
 *
 * To run a query within a React component, call `useValidateSltAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSltAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSltAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      sltAccountCreationRequest: // value for 'sltAccountCreationRequest'
 *   },
 * });
 */
export function useValidateSltAccountQuery(baseOptions: Apollo.QueryHookOptions<ValidateSltAccountQuery, ValidateSltAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateSltAccountQuery, ValidateSltAccountQueryVariables>(ValidateSltAccountDocument, options);
      }
export function useValidateSltAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateSltAccountQuery, ValidateSltAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateSltAccountQuery, ValidateSltAccountQueryVariables>(ValidateSltAccountDocument, options);
        }
export type ValidateSltAccountQueryHookResult = ReturnType<typeof useValidateSltAccountQuery>;
export type ValidateSltAccountLazyQueryHookResult = ReturnType<typeof useValidateSltAccountLazyQuery>;
export type ValidateSltAccountQueryResult = Apollo.QueryResult<ValidateSltAccountQuery, ValidateSltAccountQueryVariables>;
export const GetUserForLinkedGamesDocument = gql`
    query getUserForLinkedGames($id: String!) {
  user(id: $id) {
    id
    ... on Person {
      gameAccounts {
        ...GameAccount
      }
    }
  }
}
    ${GameAccountFragmentDoc}`;

/**
 * __useGetUserForLinkedGamesQuery__
 *
 * To run a query within a React component, call `useGetUserForLinkedGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForLinkedGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForLinkedGamesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserForLinkedGamesQuery(baseOptions: Apollo.QueryHookOptions<GetUserForLinkedGamesQuery, GetUserForLinkedGamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserForLinkedGamesQuery, GetUserForLinkedGamesQueryVariables>(GetUserForLinkedGamesDocument, options);
      }
export function useGetUserForLinkedGamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserForLinkedGamesQuery, GetUserForLinkedGamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserForLinkedGamesQuery, GetUserForLinkedGamesQueryVariables>(GetUserForLinkedGamesDocument, options);
        }
export type GetUserForLinkedGamesQueryHookResult = ReturnType<typeof useGetUserForLinkedGamesQuery>;
export type GetUserForLinkedGamesLazyQueryHookResult = ReturnType<typeof useGetUserForLinkedGamesLazyQuery>;
export type GetUserForLinkedGamesQueryResult = Apollo.QueryResult<GetUserForLinkedGamesQuery, GetUserForLinkedGamesQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($id: String!) {
  getNotifications(personId: $id) {
    ...AccountNotification
  }
}
    ${AccountNotificationFragmentDoc}`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const MarkNotificationsAsReadDocument = gql`
    mutation markNotificationsAsRead($accountId: String!, $notificationIds: [String!]!) {
  markNotificationsAsRead(
    accountId: $accountId
    notificationIds: $notificationIds
  )
}
    `;
export type MarkNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;

/**
 * __useMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsReadMutation, { data, loading, error }] = useMarkNotificationsAsReadMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useMarkNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>(MarkNotificationsAsReadDocument, options);
      }
export type MarkNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationResult = Apollo.MutationResult<MarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const NewNotificationDocument = gql`
    subscription NewNotification($personId: String!, $notificationTypes: [String!]!) {
  AccountNotification(personId: $personId, notificationTypes: $notificationTypes) {
    id
    created
    expiry
    defaultMessage
    notificationType
    ... on AccountNotificationEvent {
      read
      fields
    }
  }
}
    `;

/**
 * __useNewNotificationSubscription__
 *
 * To run a query within a React component, call `useNewNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewNotificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewNotificationSubscription({
 *   variables: {
 *      personId: // value for 'personId'
 *      notificationTypes: // value for 'notificationTypes'
 *   },
 * });
 */
export function useNewNotificationSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewNotificationSubscription, NewNotificationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewNotificationSubscription, NewNotificationSubscriptionVariables>(NewNotificationDocument, options);
      }
export type NewNotificationSubscriptionHookResult = ReturnType<typeof useNewNotificationSubscription>;
export type NewNotificationSubscriptionResult = Apollo.SubscriptionResult<NewNotificationSubscription>;
export const GetMinimalUserDocument = gql`
    query getMinimalUser($id: String!) {
  user(id: $id) {
    id
    displayName
    email {
      ... on StringAttribute {
        value
      }
      isError
    }
    msisdn {
      ...Msisdn
    }
    msisdnVerified
    wallets {
      id
      balance
      swarmioCurrency {
        id
      }
    }
    avatarURL
    ... on Person {
      gameAccounts {
        ...GameAccountOnMinimalUser
      }
    }
    groupMemberships {
      ...GroupMembershipOnMinimalUser
    }
  }
}
    ${MsisdnFragmentDoc}
${GameAccountOnMinimalUserFragmentDoc}
${GroupMembershipOnMinimalUserFragmentDoc}`;

/**
 * __useGetMinimalUserQuery__
 *
 * To run a query within a React component, call `useGetMinimalUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMinimalUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMinimalUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMinimalUserQuery(baseOptions: Apollo.QueryHookOptions<GetMinimalUserQuery, GetMinimalUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMinimalUserQuery, GetMinimalUserQueryVariables>(GetMinimalUserDocument, options);
      }
export function useGetMinimalUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMinimalUserQuery, GetMinimalUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMinimalUserQuery, GetMinimalUserQueryVariables>(GetMinimalUserDocument, options);
        }
export type GetMinimalUserQueryHookResult = ReturnType<typeof useGetMinimalUserQuery>;
export type GetMinimalUserLazyQueryHookResult = ReturnType<typeof useGetMinimalUserLazyQuery>;
export type GetMinimalUserQueryResult = Apollo.QueryResult<GetMinimalUserQuery, GetMinimalUserQueryVariables>;
export const GetUserForPermissionsDocument = gql`
    query getUserForPermissions($id: String!) {
  user(id: $id) {
    id
  }
}
    `;

/**
 * __useGetUserForPermissionsQuery__
 *
 * To run a query within a React component, call `useGetUserForPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForPermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserForPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetUserForPermissionsQuery, GetUserForPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserForPermissionsQuery, GetUserForPermissionsQueryVariables>(GetUserForPermissionsDocument, options);
      }
export function useGetUserForPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserForPermissionsQuery, GetUserForPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserForPermissionsQuery, GetUserForPermissionsQueryVariables>(GetUserForPermissionsDocument, options);
        }
export type GetUserForPermissionsQueryHookResult = ReturnType<typeof useGetUserForPermissionsQuery>;
export type GetUserForPermissionsLazyQueryHookResult = ReturnType<typeof useGetUserForPermissionsLazyQuery>;
export type GetUserForPermissionsQueryResult = Apollo.QueryResult<GetUserForPermissionsQuery, GetUserForPermissionsQueryVariables>;
export const CancelScheduledSubscriptionDocument = gql`
    mutation cancelScheduledSubscription($accountId: String!, $subscriptionTypeCostId: String!) {
  cancelScheduledSubscription(
    accountId: $accountId
    subscriptionTypeCostId: $subscriptionTypeCostId
  ) {
    id
  }
}
    `;
export type CancelScheduledSubscriptionMutationFn = Apollo.MutationFunction<CancelScheduledSubscriptionMutation, CancelScheduledSubscriptionMutationVariables>;

/**
 * __useCancelScheduledSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelScheduledSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledSubscriptionMutation, { data, loading, error }] = useCancelScheduledSubscriptionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      subscriptionTypeCostId: // value for 'subscriptionTypeCostId'
 *   },
 * });
 */
export function useCancelScheduledSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelScheduledSubscriptionMutation, CancelScheduledSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelScheduledSubscriptionMutation, CancelScheduledSubscriptionMutationVariables>(CancelScheduledSubscriptionDocument, options);
      }
export type CancelScheduledSubscriptionMutationHookResult = ReturnType<typeof useCancelScheduledSubscriptionMutation>;
export type CancelScheduledSubscriptionMutationResult = Apollo.MutationResult<CancelScheduledSubscriptionMutation>;
export type CancelScheduledSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelScheduledSubscriptionMutation, CancelScheduledSubscriptionMutationVariables>;
export const EnrollExplicitSubscriptionDocument = gql`
    mutation enrollExplicitSubscription($accountId: String!, $subscriptionTypeCostId: String!) {
  enrollExplicitSubscription(
    accountId: $accountId
    subscriptionTypeCostId: $subscriptionTypeCostId
  )
}
    `;
export type EnrollExplicitSubscriptionMutationFn = Apollo.MutationFunction<EnrollExplicitSubscriptionMutation, EnrollExplicitSubscriptionMutationVariables>;

/**
 * __useEnrollExplicitSubscriptionMutation__
 *
 * To run a mutation, you first call `useEnrollExplicitSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollExplicitSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollExplicitSubscriptionMutation, { data, loading, error }] = useEnrollExplicitSubscriptionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      subscriptionTypeCostId: // value for 'subscriptionTypeCostId'
 *   },
 * });
 */
export function useEnrollExplicitSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<EnrollExplicitSubscriptionMutation, EnrollExplicitSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollExplicitSubscriptionMutation, EnrollExplicitSubscriptionMutationVariables>(EnrollExplicitSubscriptionDocument, options);
      }
export type EnrollExplicitSubscriptionMutationHookResult = ReturnType<typeof useEnrollExplicitSubscriptionMutation>;
export type EnrollExplicitSubscriptionMutationResult = Apollo.MutationResult<EnrollExplicitSubscriptionMutation>;
export type EnrollExplicitSubscriptionMutationOptions = Apollo.BaseMutationOptions<EnrollExplicitSubscriptionMutation, EnrollExplicitSubscriptionMutationVariables>;
export const EnrollExternalSubscriptionPackageDocument = gql`
    mutation enrollExternalSubscriptionPackage($accountId: String!, $packageId: String!) {
  enrollExternalSubscriptionPackage(
    accountId: $accountId
    externalSubscriptionPackageId: $packageId
  ) {
    id
    subscriptions {
      ...SwarmioSubscription
    }
  }
}
    ${SwarmioSubscriptionFragmentDoc}`;
export type EnrollExternalSubscriptionPackageMutationFn = Apollo.MutationFunction<EnrollExternalSubscriptionPackageMutation, EnrollExternalSubscriptionPackageMutationVariables>;

/**
 * __useEnrollExternalSubscriptionPackageMutation__
 *
 * To run a mutation, you first call `useEnrollExternalSubscriptionPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollExternalSubscriptionPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollExternalSubscriptionPackageMutation, { data, loading, error }] = useEnrollExternalSubscriptionPackageMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useEnrollExternalSubscriptionPackageMutation(baseOptions?: Apollo.MutationHookOptions<EnrollExternalSubscriptionPackageMutation, EnrollExternalSubscriptionPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollExternalSubscriptionPackageMutation, EnrollExternalSubscriptionPackageMutationVariables>(EnrollExternalSubscriptionPackageDocument, options);
      }
export type EnrollExternalSubscriptionPackageMutationHookResult = ReturnType<typeof useEnrollExternalSubscriptionPackageMutation>;
export type EnrollExternalSubscriptionPackageMutationResult = Apollo.MutationResult<EnrollExternalSubscriptionPackageMutation>;
export type EnrollExternalSubscriptionPackageMutationOptions = Apollo.BaseMutationOptions<EnrollExternalSubscriptionPackageMutation, EnrollExternalSubscriptionPackageMutationVariables>;
export const GetAllEventGamesDocument = gql`
    query getAllEventGames {
  allEventGames(weightLimit: 0) {
    ...Game
  }
}
    ${GameFragmentDoc}`;

/**
 * __useGetAllEventGamesQuery__
 *
 * To run a query within a React component, call `useGetAllEventGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEventGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEventGamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEventGamesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEventGamesQuery, GetAllEventGamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEventGamesQuery, GetAllEventGamesQueryVariables>(GetAllEventGamesDocument, options);
      }
export function useGetAllEventGamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEventGamesQuery, GetAllEventGamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEventGamesQuery, GetAllEventGamesQueryVariables>(GetAllEventGamesDocument, options);
        }
export type GetAllEventGamesQueryHookResult = ReturnType<typeof useGetAllEventGamesQuery>;
export type GetAllEventGamesLazyQueryHookResult = ReturnType<typeof useGetAllEventGamesLazyQuery>;
export type GetAllEventGamesQueryResult = Apollo.QueryResult<GetAllEventGamesQuery, GetAllEventGamesQueryVariables>;
export const AllGameAccountTypesDocument = gql`
    query allGameAccountTypes {
  allGameAccountTypes {
    ...GameAccountTypeWithGames
  }
}
    ${GameAccountTypeWithGamesFragmentDoc}`;

/**
 * __useAllGameAccountTypesQuery__
 *
 * To run a query within a React component, call `useAllGameAccountTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGameAccountTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGameAccountTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllGameAccountTypesQuery(baseOptions?: Apollo.QueryHookOptions<AllGameAccountTypesQuery, AllGameAccountTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllGameAccountTypesQuery, AllGameAccountTypesQueryVariables>(AllGameAccountTypesDocument, options);
      }
export function useAllGameAccountTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllGameAccountTypesQuery, AllGameAccountTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllGameAccountTypesQuery, AllGameAccountTypesQueryVariables>(AllGameAccountTypesDocument, options);
        }
export type AllGameAccountTypesQueryHookResult = ReturnType<typeof useAllGameAccountTypesQuery>;
export type AllGameAccountTypesLazyQueryHookResult = ReturnType<typeof useAllGameAccountTypesLazyQuery>;
export type AllGameAccountTypesQueryResult = Apollo.QueryResult<AllGameAccountTypesQuery, AllGameAccountTypesQueryVariables>;
export const GetAllSubscriptionTypesDocument = gql`
    query getAllSubscriptionTypes {
  getAllSubscriptionTypes {
    ...SubscriptionTypeWithExternalPackages
  }
}
    ${SubscriptionTypeWithExternalPackagesFragmentDoc}`;

/**
 * __useGetAllSubscriptionTypesQuery__
 *
 * To run a query within a React component, call `useGetAllSubscriptionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSubscriptionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSubscriptionTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSubscriptionTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSubscriptionTypesQuery, GetAllSubscriptionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSubscriptionTypesQuery, GetAllSubscriptionTypesQueryVariables>(GetAllSubscriptionTypesDocument, options);
      }
export function useGetAllSubscriptionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSubscriptionTypesQuery, GetAllSubscriptionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSubscriptionTypesQuery, GetAllSubscriptionTypesQueryVariables>(GetAllSubscriptionTypesDocument, options);
        }
export type GetAllSubscriptionTypesQueryHookResult = ReturnType<typeof useGetAllSubscriptionTypesQuery>;
export type GetAllSubscriptionTypesLazyQueryHookResult = ReturnType<typeof useGetAllSubscriptionTypesLazyQuery>;
export type GetAllSubscriptionTypesQueryResult = Apollo.QueryResult<GetAllSubscriptionTypesQuery, GetAllSubscriptionTypesQueryVariables>;
export const GetEventParticipationSummaryDocument = gql`
    query getEventParticipationSummary($eventId: String!, $accountId: String!) {
  eventParticipantByAccount(eventId: $eventId, accountId: $accountId) {
    disqualified
    participant {
      confirmed
    }
  }
}
    `;

/**
 * __useGetEventParticipationSummaryQuery__
 *
 * To run a query within a React component, call `useGetEventParticipationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventParticipationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventParticipationSummaryQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetEventParticipationSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetEventParticipationSummaryQuery, GetEventParticipationSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventParticipationSummaryQuery, GetEventParticipationSummaryQueryVariables>(GetEventParticipationSummaryDocument, options);
      }
export function useGetEventParticipationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventParticipationSummaryQuery, GetEventParticipationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventParticipationSummaryQuery, GetEventParticipationSummaryQueryVariables>(GetEventParticipationSummaryDocument, options);
        }
export type GetEventParticipationSummaryQueryHookResult = ReturnType<typeof useGetEventParticipationSummaryQuery>;
export type GetEventParticipationSummaryLazyQueryHookResult = ReturnType<typeof useGetEventParticipationSummaryLazyQuery>;
export type GetEventParticipationSummaryQueryResult = Apollo.QueryResult<GetEventParticipationSummaryQuery, GetEventParticipationSummaryQueryVariables>;
export const GetEventParticipationsDocument = gql`
    query getEventParticipations($userId: String!) {
  user(id: $userId) {
    id
    ...EventParticipations
  }
}
    ${EventParticipationsFragmentDoc}`;

/**
 * __useGetEventParticipationsQuery__
 *
 * To run a query within a React component, call `useGetEventParticipationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventParticipationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventParticipationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetEventParticipationsQuery(baseOptions: Apollo.QueryHookOptions<GetEventParticipationsQuery, GetEventParticipationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventParticipationsQuery, GetEventParticipationsQueryVariables>(GetEventParticipationsDocument, options);
      }
export function useGetEventParticipationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventParticipationsQuery, GetEventParticipationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventParticipationsQuery, GetEventParticipationsQueryVariables>(GetEventParticipationsDocument, options);
        }
export type GetEventParticipationsQueryHookResult = ReturnType<typeof useGetEventParticipationsQuery>;
export type GetEventParticipationsLazyQueryHookResult = ReturnType<typeof useGetEventParticipationsLazyQuery>;
export type GetEventParticipationsQueryResult = Apollo.QueryResult<GetEventParticipationsQuery, GetEventParticipationsQueryVariables>;
export const GetGroupMembershipsDocument = gql`
    query getGroupMemberships($id: String!) {
  user(id: $id) {
    id
    groupMemberships {
      ...GroupMembership
    }
  }
}
    ${GroupMembershipFragmentDoc}`;

/**
 * __useGetGroupMembershipsQuery__
 *
 * To run a query within a React component, call `useGetGroupMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupMembershipsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupMembershipsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupMembershipsQuery, GetGroupMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupMembershipsQuery, GetGroupMembershipsQueryVariables>(GetGroupMembershipsDocument, options);
      }
export function useGetGroupMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupMembershipsQuery, GetGroupMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupMembershipsQuery, GetGroupMembershipsQueryVariables>(GetGroupMembershipsDocument, options);
        }
export type GetGroupMembershipsQueryHookResult = ReturnType<typeof useGetGroupMembershipsQuery>;
export type GetGroupMembershipsLazyQueryHookResult = ReturnType<typeof useGetGroupMembershipsLazyQuery>;
export type GetGroupMembershipsQueryResult = Apollo.QueryResult<GetGroupMembershipsQuery, GetGroupMembershipsQueryVariables>;
export const GetSubscriptionTypesForEventDetailsDocument = gql`
    query getSubscriptionTypesForEventDetails {
  getAllSubscriptionTypes {
    ...SubscriptionTypeForEventDetails
  }
}
    ${SubscriptionTypeForEventDetailsFragmentDoc}`;

/**
 * __useGetSubscriptionTypesForEventDetailsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionTypesForEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionTypesForEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionTypesForEventDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionTypesForEventDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionTypesForEventDetailsQuery, GetSubscriptionTypesForEventDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionTypesForEventDetailsQuery, GetSubscriptionTypesForEventDetailsQueryVariables>(GetSubscriptionTypesForEventDetailsDocument, options);
      }
export function useGetSubscriptionTypesForEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionTypesForEventDetailsQuery, GetSubscriptionTypesForEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionTypesForEventDetailsQuery, GetSubscriptionTypesForEventDetailsQueryVariables>(GetSubscriptionTypesForEventDetailsDocument, options);
        }
export type GetSubscriptionTypesForEventDetailsQueryHookResult = ReturnType<typeof useGetSubscriptionTypesForEventDetailsQuery>;
export type GetSubscriptionTypesForEventDetailsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionTypesForEventDetailsLazyQuery>;
export type GetSubscriptionTypesForEventDetailsQueryResult = Apollo.QueryResult<GetSubscriptionTypesForEventDetailsQuery, GetSubscriptionTypesForEventDetailsQueryVariables>;
export const GetSubscriptionsForAccountIdDocument = gql`
    query getSubscriptionsForAccountId($accountId: String!) {
  getSubscriptionsForAccountId(accountId: $accountId) {
    id
    subscriptions {
      ...SwarmioSubscription
    }
  }
}
    ${SwarmioSubscriptionFragmentDoc}`;

/**
 * __useGetSubscriptionsForAccountIdQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsForAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsForAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsForAccountIdQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetSubscriptionsForAccountIdQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionsForAccountIdQuery, GetSubscriptionsForAccountIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionsForAccountIdQuery, GetSubscriptionsForAccountIdQueryVariables>(GetSubscriptionsForAccountIdDocument, options);
      }
export function useGetSubscriptionsForAccountIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionsForAccountIdQuery, GetSubscriptionsForAccountIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionsForAccountIdQuery, GetSubscriptionsForAccountIdQueryVariables>(GetSubscriptionsForAccountIdDocument, options);
        }
export type GetSubscriptionsForAccountIdQueryHookResult = ReturnType<typeof useGetSubscriptionsForAccountIdQuery>;
export type GetSubscriptionsForAccountIdLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsForAccountIdLazyQuery>;
export type GetSubscriptionsForAccountIdQueryResult = Apollo.QueryResult<GetSubscriptionsForAccountIdQuery, GetSubscriptionsForAccountIdQueryVariables>;
export const GetTeamForEventJoinDocument = gql`
    query getTeamForEventJoin($id: String!) {
  account(id: $id) {
    ...TeamForEventJoin
  }
}
    ${TeamForEventJoinFragmentDoc}`;

/**
 * __useGetTeamForEventJoinQuery__
 *
 * To run a query within a React component, call `useGetTeamForEventJoinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamForEventJoinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamForEventJoinQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamForEventJoinQuery(baseOptions: Apollo.QueryHookOptions<GetTeamForEventJoinQuery, GetTeamForEventJoinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamForEventJoinQuery, GetTeamForEventJoinQueryVariables>(GetTeamForEventJoinDocument, options);
      }
export function useGetTeamForEventJoinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamForEventJoinQuery, GetTeamForEventJoinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamForEventJoinQuery, GetTeamForEventJoinQueryVariables>(GetTeamForEventJoinDocument, options);
        }
export type GetTeamForEventJoinQueryHookResult = ReturnType<typeof useGetTeamForEventJoinQuery>;
export type GetTeamForEventJoinLazyQueryHookResult = ReturnType<typeof useGetTeamForEventJoinLazyQuery>;
export type GetTeamForEventJoinQueryResult = Apollo.QueryResult<GetTeamForEventJoinQuery, GetTeamForEventJoinQueryVariables>;
export const GetUserForEventJoinDocument = gql`
    query getUserForEventJoin($id: String!) {
  account(id: $id) {
    ...AccountForEventJoin
  }
}
    ${AccountForEventJoinFragmentDoc}`;

/**
 * __useGetUserForEventJoinQuery__
 *
 * To run a query within a React component, call `useGetUserForEventJoinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForEventJoinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForEventJoinQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserForEventJoinQuery(baseOptions: Apollo.QueryHookOptions<GetUserForEventJoinQuery, GetUserForEventJoinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserForEventJoinQuery, GetUserForEventJoinQueryVariables>(GetUserForEventJoinDocument, options);
      }
export function useGetUserForEventJoinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserForEventJoinQuery, GetUserForEventJoinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserForEventJoinQuery, GetUserForEventJoinQueryVariables>(GetUserForEventJoinDocument, options);
        }
export type GetUserForEventJoinQueryHookResult = ReturnType<typeof useGetUserForEventJoinQuery>;
export type GetUserForEventJoinLazyQueryHookResult = ReturnType<typeof useGetUserForEventJoinLazyQuery>;
export type GetUserForEventJoinQueryResult = Apollo.QueryResult<GetUserForEventJoinQuery, GetUserForEventJoinQueryVariables>;
export const GetUserProviderAccountsDocument = gql`
    query getUserProviderAccounts($id: String!) {
  user(id: $id) {
    ...UserProviderAccounts
  }
}
    ${UserProviderAccountsFragmentDoc}`;

/**
 * __useGetUserProviderAccountsQuery__
 *
 * To run a query within a React component, call `useGetUserProviderAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProviderAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProviderAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserProviderAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetUserProviderAccountsQuery, GetUserProviderAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProviderAccountsQuery, GetUserProviderAccountsQueryVariables>(GetUserProviderAccountsDocument, options);
      }
export function useGetUserProviderAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProviderAccountsQuery, GetUserProviderAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProviderAccountsQuery, GetUserProviderAccountsQueryVariables>(GetUserProviderAccountsDocument, options);
        }
export type GetUserProviderAccountsQueryHookResult = ReturnType<typeof useGetUserProviderAccountsQuery>;
export type GetUserProviderAccountsLazyQueryHookResult = ReturnType<typeof useGetUserProviderAccountsLazyQuery>;
export type GetUserProviderAccountsQueryResult = Apollo.QueryResult<GetUserProviderAccountsQuery, GetUserProviderAccountsQueryVariables>;
export const RemoveSubscriptionProviderAccountDocument = gql`
    mutation removeSubscriptionProviderAccount($accountId: String!, $subscriptionProvider: SubscriptionProvider!) {
  removeSubscriptionProviderAccount(
    accountId: $accountId
    subscriptionProvider: $subscriptionProvider
  ) {
    id
    ...UserProviderAccounts
    subscriptions {
      ...SwarmioSubscription
    }
  }
}
    ${UserProviderAccountsFragmentDoc}
${SwarmioSubscriptionFragmentDoc}`;
export type RemoveSubscriptionProviderAccountMutationFn = Apollo.MutationFunction<RemoveSubscriptionProviderAccountMutation, RemoveSubscriptionProviderAccountMutationVariables>;

/**
 * __useRemoveSubscriptionProviderAccountMutation__
 *
 * To run a mutation, you first call `useRemoveSubscriptionProviderAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSubscriptionProviderAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSubscriptionProviderAccountMutation, { data, loading, error }] = useRemoveSubscriptionProviderAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      subscriptionProvider: // value for 'subscriptionProvider'
 *   },
 * });
 */
export function useRemoveSubscriptionProviderAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSubscriptionProviderAccountMutation, RemoveSubscriptionProviderAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSubscriptionProviderAccountMutation, RemoveSubscriptionProviderAccountMutationVariables>(RemoveSubscriptionProviderAccountDocument, options);
      }
export type RemoveSubscriptionProviderAccountMutationHookResult = ReturnType<typeof useRemoveSubscriptionProviderAccountMutation>;
export type RemoveSubscriptionProviderAccountMutationResult = Apollo.MutationResult<RemoveSubscriptionProviderAccountMutation>;
export type RemoveSubscriptionProviderAccountMutationOptions = Apollo.BaseMutationOptions<RemoveSubscriptionProviderAccountMutation, RemoveSubscriptionProviderAccountMutationVariables>;
export const ResendVerificationSmsDocument = gql`
    mutation resendVerificationSMS($userId: String!) {
  resendVerificationSMS(userId: $userId)
}
    `;
export type ResendVerificationSmsMutationFn = Apollo.MutationFunction<ResendVerificationSmsMutation, ResendVerificationSmsMutationVariables>;

/**
 * __useResendVerificationSmsMutation__
 *
 * To run a mutation, you first call `useResendVerificationSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationSmsMutation, { data, loading, error }] = useResendVerificationSmsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResendVerificationSmsMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationSmsMutation, ResendVerificationSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationSmsMutation, ResendVerificationSmsMutationVariables>(ResendVerificationSmsDocument, options);
      }
export type ResendVerificationSmsMutationHookResult = ReturnType<typeof useResendVerificationSmsMutation>;
export type ResendVerificationSmsMutationResult = Apollo.MutationResult<ResendVerificationSmsMutation>;
export type ResendVerificationSmsMutationOptions = Apollo.BaseMutationOptions<ResendVerificationSmsMutation, ResendVerificationSmsMutationVariables>;
export const UnenrollExternalSubscriptionPackageDocument = gql`
    mutation unenrollExternalSubscriptionPackage($accountId: String!, $packageId: String!) {
  unenrollExternalSubscriptionPackage(
    accountId: $accountId
    externalSubscriptionPackageId: $packageId
  ) {
    id
    subscriptions {
      ...SwarmioSubscription
    }
  }
}
    ${SwarmioSubscriptionFragmentDoc}`;
export type UnenrollExternalSubscriptionPackageMutationFn = Apollo.MutationFunction<UnenrollExternalSubscriptionPackageMutation, UnenrollExternalSubscriptionPackageMutationVariables>;

/**
 * __useUnenrollExternalSubscriptionPackageMutation__
 *
 * To run a mutation, you first call `useUnenrollExternalSubscriptionPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnenrollExternalSubscriptionPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unenrollExternalSubscriptionPackageMutation, { data, loading, error }] = useUnenrollExternalSubscriptionPackageMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useUnenrollExternalSubscriptionPackageMutation(baseOptions?: Apollo.MutationHookOptions<UnenrollExternalSubscriptionPackageMutation, UnenrollExternalSubscriptionPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnenrollExternalSubscriptionPackageMutation, UnenrollExternalSubscriptionPackageMutationVariables>(UnenrollExternalSubscriptionPackageDocument, options);
      }
export type UnenrollExternalSubscriptionPackageMutationHookResult = ReturnType<typeof useUnenrollExternalSubscriptionPackageMutation>;
export type UnenrollExternalSubscriptionPackageMutationResult = Apollo.MutationResult<UnenrollExternalSubscriptionPackageMutation>;
export type UnenrollExternalSubscriptionPackageMutationOptions = Apollo.BaseMutationOptions<UnenrollExternalSubscriptionPackageMutation, UnenrollExternalSubscriptionPackageMutationVariables>;
export const CancelPendingSubscriptionDocument = gql`
    mutation cancelPendingSubscription($accountId: String!, $subscriptionId: String!) {
  cancelPendingSubscription(
    accountId: $accountId
    subscriptionId: $subscriptionId
  ) {
    id
  }
}
    `;
export type CancelPendingSubscriptionMutationFn = Apollo.MutationFunction<CancelPendingSubscriptionMutation, CancelPendingSubscriptionMutationVariables>;

/**
 * __useCancelPendingSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelPendingSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPendingSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPendingSubscriptionMutation, { data, loading, error }] = useCancelPendingSubscriptionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useCancelPendingSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelPendingSubscriptionMutation, CancelPendingSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPendingSubscriptionMutation, CancelPendingSubscriptionMutationVariables>(CancelPendingSubscriptionDocument, options);
      }
export type CancelPendingSubscriptionMutationHookResult = ReturnType<typeof useCancelPendingSubscriptionMutation>;
export type CancelPendingSubscriptionMutationResult = Apollo.MutationResult<CancelPendingSubscriptionMutation>;
export type CancelPendingSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelPendingSubscriptionMutation, CancelPendingSubscriptionMutationVariables>;
export const MyInvitationsDocument = gql`
    query myInvitations($id: String!) {
  user(id: $id) {
    id
    groupInvites {
      ...GroupInviteWithPossibleError
    }
  }
}
    ${GroupInviteWithPossibleErrorFragmentDoc}`;

/**
 * __useMyInvitationsQuery__
 *
 * To run a query within a React component, call `useMyInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyInvitationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyInvitationsQuery(baseOptions: Apollo.QueryHookOptions<MyInvitationsQuery, MyInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyInvitationsQuery, MyInvitationsQueryVariables>(MyInvitationsDocument, options);
      }
export function useMyInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyInvitationsQuery, MyInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyInvitationsQuery, MyInvitationsQueryVariables>(MyInvitationsDocument, options);
        }
export type MyInvitationsQueryHookResult = ReturnType<typeof useMyInvitationsQuery>;
export type MyInvitationsLazyQueryHookResult = ReturnType<typeof useMyInvitationsLazyQuery>;
export type MyInvitationsQueryResult = Apollo.QueryResult<MyInvitationsQuery, MyInvitationsQueryVariables>;
export const PaySubscriptionWithSwarmioDocument = gql`
    mutation paySubscriptionWithSwarmio($subscriptionId: String!) {
  paySubscriptionWithSwarmio(subscriptionId: $subscriptionId)
}
    `;
export type PaySubscriptionWithSwarmioMutationFn = Apollo.MutationFunction<PaySubscriptionWithSwarmioMutation, PaySubscriptionWithSwarmioMutationVariables>;

/**
 * __usePaySubscriptionWithSwarmioMutation__
 *
 * To run a mutation, you first call `usePaySubscriptionWithSwarmioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaySubscriptionWithSwarmioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paySubscriptionWithSwarmioMutation, { data, loading, error }] = usePaySubscriptionWithSwarmioMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function usePaySubscriptionWithSwarmioMutation(baseOptions?: Apollo.MutationHookOptions<PaySubscriptionWithSwarmioMutation, PaySubscriptionWithSwarmioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaySubscriptionWithSwarmioMutation, PaySubscriptionWithSwarmioMutationVariables>(PaySubscriptionWithSwarmioDocument, options);
      }
export type PaySubscriptionWithSwarmioMutationHookResult = ReturnType<typeof usePaySubscriptionWithSwarmioMutation>;
export type PaySubscriptionWithSwarmioMutationResult = Apollo.MutationResult<PaySubscriptionWithSwarmioMutation>;
export type PaySubscriptionWithSwarmioMutationOptions = Apollo.BaseMutationOptions<PaySubscriptionWithSwarmioMutation, PaySubscriptionWithSwarmioMutationVariables>;
export const GetEmbeddedGamesDocument = gql`
    query getEmbeddedGames($offset: Int!, $limit: Int!) {
  getEmbeddedGames(offset: $offset, limit: $limit) {
    nodes {
      id
      title
      desc
      thumbnailURL
      embeddedGameURL
      availability
    }
    totalCount
    hasNextPage
  }
}
    `;

/**
 * __useGetEmbeddedGamesQuery__
 *
 * To run a query within a React component, call `useGetEmbeddedGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmbeddedGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmbeddedGamesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetEmbeddedGamesQuery(baseOptions: Apollo.QueryHookOptions<GetEmbeddedGamesQuery, GetEmbeddedGamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmbeddedGamesQuery, GetEmbeddedGamesQueryVariables>(GetEmbeddedGamesDocument, options);
      }
export function useGetEmbeddedGamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmbeddedGamesQuery, GetEmbeddedGamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmbeddedGamesQuery, GetEmbeddedGamesQueryVariables>(GetEmbeddedGamesDocument, options);
        }
export type GetEmbeddedGamesQueryHookResult = ReturnType<typeof useGetEmbeddedGamesQuery>;
export type GetEmbeddedGamesLazyQueryHookResult = ReturnType<typeof useGetEmbeddedGamesLazyQuery>;
export type GetEmbeddedGamesQueryResult = Apollo.QueryResult<GetEmbeddedGamesQuery, GetEmbeddedGamesQueryVariables>;
export const CheckMsisdnCodeDocument = gql`
    query checkMsisdnCode($msisdn: String!, $token: String!) {
  checkMSISDNVerificationCode(MSISDN: $msisdn, token: $token)
}
    `;

/**
 * __useCheckMsisdnCodeQuery__
 *
 * To run a query within a React component, call `useCheckMsisdnCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckMsisdnCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckMsisdnCodeQuery({
 *   variables: {
 *      msisdn: // value for 'msisdn'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCheckMsisdnCodeQuery(baseOptions: Apollo.QueryHookOptions<CheckMsisdnCodeQuery, CheckMsisdnCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckMsisdnCodeQuery, CheckMsisdnCodeQueryVariables>(CheckMsisdnCodeDocument, options);
      }
export function useCheckMsisdnCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckMsisdnCodeQuery, CheckMsisdnCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckMsisdnCodeQuery, CheckMsisdnCodeQueryVariables>(CheckMsisdnCodeDocument, options);
        }
export type CheckMsisdnCodeQueryHookResult = ReturnType<typeof useCheckMsisdnCodeQuery>;
export type CheckMsisdnCodeLazyQueryHookResult = ReturnType<typeof useCheckMsisdnCodeLazyQuery>;
export type CheckMsisdnCodeQueryResult = Apollo.QueryResult<CheckMsisdnCodeQuery, CheckMsisdnCodeQueryVariables>;
export const CompleteAccountDocument = gql`
    mutation completeAccount($id: String!, $updatePersonRequest: PersonUpdateRequest!) {
  updatePerson(id: $id, personUpdateRequest: $updatePersonRequest) {
    id
    displayName
  }
}
    `;
export type CompleteAccountMutationFn = Apollo.MutationFunction<CompleteAccountMutation, CompleteAccountMutationVariables>;

/**
 * __useCompleteAccountMutation__
 *
 * To run a mutation, you first call `useCompleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAccountMutation, { data, loading, error }] = useCompleteAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatePersonRequest: // value for 'updatePersonRequest'
 *   },
 * });
 */
export function useCompleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAccountMutation, CompleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAccountMutation, CompleteAccountMutationVariables>(CompleteAccountDocument, options);
      }
export type CompleteAccountMutationHookResult = ReturnType<typeof useCompleteAccountMutation>;
export type CompleteAccountMutationResult = Apollo.MutationResult<CompleteAccountMutation>;
export type CompleteAccountMutationOptions = Apollo.BaseMutationOptions<CompleteAccountMutation, CompleteAccountMutationVariables>;
export const ResetPasswordRequestDocument = gql`
    mutation resetPasswordRequest($contactIdentifier: String!) {
  resetPasswordRequest(ContactIdentifier: $contactIdentifier)
}
    `;
export type ResetPasswordRequestMutationFn = Apollo.MutationFunction<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>;

/**
 * __useResetPasswordRequestMutation__
 *
 * To run a mutation, you first call `useResetPasswordRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordRequestMutation, { data, loading, error }] = useResetPasswordRequestMutation({
 *   variables: {
 *      contactIdentifier: // value for 'contactIdentifier'
 *   },
 * });
 */
export function useResetPasswordRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>(ResetPasswordRequestDocument, options);
      }
export type ResetPasswordRequestMutationHookResult = ReturnType<typeof useResetPasswordRequestMutation>;
export type ResetPasswordRequestMutationResult = Apollo.MutationResult<ResetPasswordRequestMutation>;
export type ResetPasswordRequestMutationOptions = Apollo.BaseMutationOptions<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>;
export const RegisterPersonEmailDocument = gql`
    mutation registerPersonEmail($email: String!, $meta: RegistrationMeta) {
  registerPersonEmail(email: $email, meta: $meta) {
    id
  }
}
    `;
export type RegisterPersonEmailMutationFn = Apollo.MutationFunction<RegisterPersonEmailMutation, RegisterPersonEmailMutationVariables>;

/**
 * __useRegisterPersonEmailMutation__
 *
 * To run a mutation, you first call `useRegisterPersonEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPersonEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPersonEmailMutation, { data, loading, error }] = useRegisterPersonEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useRegisterPersonEmailMutation(baseOptions?: Apollo.MutationHookOptions<RegisterPersonEmailMutation, RegisterPersonEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterPersonEmailMutation, RegisterPersonEmailMutationVariables>(RegisterPersonEmailDocument, options);
      }
export type RegisterPersonEmailMutationHookResult = ReturnType<typeof useRegisterPersonEmailMutation>;
export type RegisterPersonEmailMutationResult = Apollo.MutationResult<RegisterPersonEmailMutation>;
export type RegisterPersonEmailMutationOptions = Apollo.BaseMutationOptions<RegisterPersonEmailMutation, RegisterPersonEmailMutationVariables>;
export const RegisterPersonMsisdnDocument = gql`
    mutation registerPersonMSISDN($msisdn: String!, $meta: RegistrationMeta) {
  registerPersonMSISDN(MSISDN: $msisdn, meta: $meta) {
    id
  }
}
    `;
export type RegisterPersonMsisdnMutationFn = Apollo.MutationFunction<RegisterPersonMsisdnMutation, RegisterPersonMsisdnMutationVariables>;

/**
 * __useRegisterPersonMsisdnMutation__
 *
 * To run a mutation, you first call `useRegisterPersonMsisdnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPersonMsisdnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPersonMsisdnMutation, { data, loading, error }] = useRegisterPersonMsisdnMutation({
 *   variables: {
 *      msisdn: // value for 'msisdn'
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useRegisterPersonMsisdnMutation(baseOptions?: Apollo.MutationHookOptions<RegisterPersonMsisdnMutation, RegisterPersonMsisdnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterPersonMsisdnMutation, RegisterPersonMsisdnMutationVariables>(RegisterPersonMsisdnDocument, options);
      }
export type RegisterPersonMsisdnMutationHookResult = ReturnType<typeof useRegisterPersonMsisdnMutation>;
export type RegisterPersonMsisdnMutationResult = Apollo.MutationResult<RegisterPersonMsisdnMutation>;
export type RegisterPersonMsisdnMutationOptions = Apollo.BaseMutationOptions<RegisterPersonMsisdnMutation, RegisterPersonMsisdnMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($token: String!, $password: String!, $contactIdentifier: String!) {
  resetPassword(
    token: $token
    password: $password
    ContactIdentifier: $contactIdentifier
  )
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *      contactIdentifier: // value for 'contactIdentifier'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const GetBlogGameDocument = gql`
    query getBlogGame($id: String!) {
  CmsGame(id: $id) {
    id
    name
    gameTrailerEmbedId {
      embedId
      title
    }
    company
    gameLink
    content
    images {
      image {
        url
      }
    }
    gameBanner {
      url
    }
    relatedGames {
      id
      avatar {
        thumbnailURL
      }
      name
      shortDescription
    }
  }
}
    `;

/**
 * __useGetBlogGameQuery__
 *
 * To run a query within a React component, call `useGetBlogGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlogGameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlogGameQuery(baseOptions: Apollo.QueryHookOptions<GetBlogGameQuery, GetBlogGameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlogGameQuery, GetBlogGameQueryVariables>(GetBlogGameDocument, options);
      }
export function useGetBlogGameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlogGameQuery, GetBlogGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlogGameQuery, GetBlogGameQueryVariables>(GetBlogGameDocument, options);
        }
export type GetBlogGameQueryHookResult = ReturnType<typeof useGetBlogGameQuery>;
export type GetBlogGameLazyQueryHookResult = ReturnType<typeof useGetBlogGameLazyQuery>;
export type GetBlogGameQueryResult = Apollo.QueryResult<GetBlogGameQuery, GetBlogGameQueryVariables>;
export const GetBlogGamerDocument = gql`
    query getBlogGamer($id: String!) {
  CmsGamer(id: $id) {
    id
    nickname
    name
    description
    gamerSocialMedia {
      platform
      link
    }
    country
    avatar {
      thumbnailURL
    }
  }
}
    `;

/**
 * __useGetBlogGamerQuery__
 *
 * To run a query within a React component, call `useGetBlogGamerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogGamerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlogGamerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlogGamerQuery(baseOptions: Apollo.QueryHookOptions<GetBlogGamerQuery, GetBlogGamerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlogGamerQuery, GetBlogGamerQueryVariables>(GetBlogGamerDocument, options);
      }
export function useGetBlogGamerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlogGamerQuery, GetBlogGamerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlogGamerQuery, GetBlogGamerQueryVariables>(GetBlogGamerDocument, options);
        }
export type GetBlogGamerQueryHookResult = ReturnType<typeof useGetBlogGamerQuery>;
export type GetBlogGamerLazyQueryHookResult = ReturnType<typeof useGetBlogGamerLazyQuery>;
export type GetBlogGamerQueryResult = Apollo.QueryResult<GetBlogGamerQuery, GetBlogGamerQueryVariables>;
export const GetBlogPageDocument = gql`
    query getBlogPage {
  CmsBlogPages(where: {status: {equals: published}}) {
    docs {
      id
      title
      slug
      sections {
        sectionType
        sectionTitle
        featuredBanners {
          id
          title
          featuredImage {
            url
          }
          link
          relatedPost {
            id
          }
        }
        featuredGames {
          id
          name
          avatar {
            thumbnailURL
          }
        }
        featuredGamers {
          id
          nickname
          avatar {
            thumbnailURL
          }
        }
        featuredBlogPosts {
          id
          title
          description
          featuredImage {
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBlogPageQuery__
 *
 * To run a query within a React component, call `useGetBlogPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlogPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBlogPageQuery(baseOptions?: Apollo.QueryHookOptions<GetBlogPageQuery, GetBlogPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlogPageQuery, GetBlogPageQueryVariables>(GetBlogPageDocument, options);
      }
export function useGetBlogPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlogPageQuery, GetBlogPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlogPageQuery, GetBlogPageQueryVariables>(GetBlogPageDocument, options);
        }
export type GetBlogPageQueryHookResult = ReturnType<typeof useGetBlogPageQuery>;
export type GetBlogPageLazyQueryHookResult = ReturnType<typeof useGetBlogPageLazyQuery>;
export type GetBlogPageQueryResult = Apollo.QueryResult<GetBlogPageQuery, GetBlogPageQueryVariables>;
export const GetBlogPostDocument = gql`
    query getBlogPost($id: String!) {
  CmsBlogPost(id: $id) {
    id
    title
    description
    content
    featuredImage {
      url
    }
    videos {
      embedId
      id
    }
    relatedPosts {
      id
      title
      description
      featuredImage {
        url
      }
    }
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useGetBlogPostQuery__
 *
 * To run a query within a React component, call `useGetBlogPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlogPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlogPostQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlogPostQuery(baseOptions: Apollo.QueryHookOptions<GetBlogPostQuery, GetBlogPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlogPostQuery, GetBlogPostQueryVariables>(GetBlogPostDocument, options);
      }
export function useGetBlogPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlogPostQuery, GetBlogPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlogPostQuery, GetBlogPostQueryVariables>(GetBlogPostDocument, options);
        }
export type GetBlogPostQueryHookResult = ReturnType<typeof useGetBlogPostQuery>;
export type GetBlogPostLazyQueryHookResult = ReturnType<typeof useGetBlogPostLazyQuery>;
export type GetBlogPostQueryResult = Apollo.QueryResult<GetBlogPostQuery, GetBlogPostQueryVariables>;
export const AddGameToGameAccountDocument = gql`
    mutation addGameToGameAccount($personId: String!, $gameAccountTypeId: String!, $gameId: String!) {
  addGameToGameAccount(
    personId: $personId
    gameAccountTypeId: $gameAccountTypeId
    gameId: $gameId
  ) {
    id
    gameAccounts {
      ...GameAccount
    }
  }
}
    ${GameAccountFragmentDoc}`;
export type AddGameToGameAccountMutationFn = Apollo.MutationFunction<AddGameToGameAccountMutation, AddGameToGameAccountMutationVariables>;

/**
 * __useAddGameToGameAccountMutation__
 *
 * To run a mutation, you first call `useAddGameToGameAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGameToGameAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGameToGameAccountMutation, { data, loading, error }] = useAddGameToGameAccountMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      gameAccountTypeId: // value for 'gameAccountTypeId'
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useAddGameToGameAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddGameToGameAccountMutation, AddGameToGameAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGameToGameAccountMutation, AddGameToGameAccountMutationVariables>(AddGameToGameAccountDocument, options);
      }
export type AddGameToGameAccountMutationHookResult = ReturnType<typeof useAddGameToGameAccountMutation>;
export type AddGameToGameAccountMutationResult = Apollo.MutationResult<AddGameToGameAccountMutation>;
export type AddGameToGameAccountMutationOptions = Apollo.BaseMutationOptions<AddGameToGameAccountMutation, AddGameToGameAccountMutationVariables>;
export const LinkNonIntegratedGameAccountDocument = gql`
    mutation linkNonIntegratedGameAccount($gameAccountName: String!, $personId: String!, $gameAccountTypeId: String!, $gameAccountId: String) {
  linkNonIntegratedGameAccount(
    gameAccountName: $gameAccountName
    personId: $personId
    gameAccountTypeId: $gameAccountTypeId
    gameAccountId: $gameAccountId
  ) {
    id
    gameAccounts {
      ...GameAccount
    }
  }
}
    ${GameAccountFragmentDoc}`;
export type LinkNonIntegratedGameAccountMutationFn = Apollo.MutationFunction<LinkNonIntegratedGameAccountMutation, LinkNonIntegratedGameAccountMutationVariables>;

/**
 * __useLinkNonIntegratedGameAccountMutation__
 *
 * To run a mutation, you first call `useLinkNonIntegratedGameAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkNonIntegratedGameAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkNonIntegratedGameAccountMutation, { data, loading, error }] = useLinkNonIntegratedGameAccountMutation({
 *   variables: {
 *      gameAccountName: // value for 'gameAccountName'
 *      personId: // value for 'personId'
 *      gameAccountTypeId: // value for 'gameAccountTypeId'
 *      gameAccountId: // value for 'gameAccountId'
 *   },
 * });
 */
export function useLinkNonIntegratedGameAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkNonIntegratedGameAccountMutation, LinkNonIntegratedGameAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkNonIntegratedGameAccountMutation, LinkNonIntegratedGameAccountMutationVariables>(LinkNonIntegratedGameAccountDocument, options);
      }
export type LinkNonIntegratedGameAccountMutationHookResult = ReturnType<typeof useLinkNonIntegratedGameAccountMutation>;
export type LinkNonIntegratedGameAccountMutationResult = Apollo.MutationResult<LinkNonIntegratedGameAccountMutation>;
export type LinkNonIntegratedGameAccountMutationOptions = Apollo.BaseMutationOptions<LinkNonIntegratedGameAccountMutation, LinkNonIntegratedGameAccountMutationVariables>;
export const CreateTeamDocument = gql`
    mutation createTeam($createTeamRequest: TeamCreationRequest!) {
  createTeam(createTeamRequest: $createTeamRequest) {
    id
    name
    avatarURL
    ownerId
    publicURL
    groupMembers {
      ...GroupMemberOnCreateTeam
    }
  }
}
    ${GroupMemberOnCreateTeamFragmentDoc}`;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      createTeamRequest: // value for 'createTeamRequest'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const AddMultiDimensionalBucketBasedResultForVerificationDocument = gql`
    mutation addMultiDimensionalBucketBasedResultForVerification($manuallyVerifiedResultWithMultiDimensionalBucketBasedResultRequest: ManuallyVerifiedResultWithMultiDimensionalBucketBasedResultRequest!) {
  addMultiDimensionalBucketBasedResultForVerification(
    manuallyVerifiedResultWithMultiDimensionalBucketBasedResultRequest: $manuallyVerifiedResultWithMultiDimensionalBucketBasedResultRequest
  )
}
    `;
export type AddMultiDimensionalBucketBasedResultForVerificationMutationFn = Apollo.MutationFunction<AddMultiDimensionalBucketBasedResultForVerificationMutation, AddMultiDimensionalBucketBasedResultForVerificationMutationVariables>;

/**
 * __useAddMultiDimensionalBucketBasedResultForVerificationMutation__
 *
 * To run a mutation, you first call `useAddMultiDimensionalBucketBasedResultForVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMultiDimensionalBucketBasedResultForVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMultiDimensionalBucketBasedResultForVerificationMutation, { data, loading, error }] = useAddMultiDimensionalBucketBasedResultForVerificationMutation({
 *   variables: {
 *      manuallyVerifiedResultWithMultiDimensionalBucketBasedResultRequest: // value for 'manuallyVerifiedResultWithMultiDimensionalBucketBasedResultRequest'
 *   },
 * });
 */
export function useAddMultiDimensionalBucketBasedResultForVerificationMutation(baseOptions?: Apollo.MutationHookOptions<AddMultiDimensionalBucketBasedResultForVerificationMutation, AddMultiDimensionalBucketBasedResultForVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMultiDimensionalBucketBasedResultForVerificationMutation, AddMultiDimensionalBucketBasedResultForVerificationMutationVariables>(AddMultiDimensionalBucketBasedResultForVerificationDocument, options);
      }
export type AddMultiDimensionalBucketBasedResultForVerificationMutationHookResult = ReturnType<typeof useAddMultiDimensionalBucketBasedResultForVerificationMutation>;
export type AddMultiDimensionalBucketBasedResultForVerificationMutationResult = Apollo.MutationResult<AddMultiDimensionalBucketBasedResultForVerificationMutation>;
export type AddMultiDimensionalBucketBasedResultForVerificationMutationOptions = Apollo.BaseMutationOptions<AddMultiDimensionalBucketBasedResultForVerificationMutation, AddMultiDimensionalBucketBasedResultForVerificationMutationVariables>;
export const ManuallyVerifiedResultsForRoundIdAndParticipantIdDocument = gql`
    query manuallyVerifiedResultsForRoundIdAndParticipantId($roundId: String!, $participantId: String!) {
  manuallyVerifiedResultsForRoundIdAndParticipantId(
    roundId: $roundId
    participantId: $participantId
  ) {
    id
    roundId
    participantId
    competitionId
    unverifiedResult {
      ...MultiDimensionalBucketBasedResult
    }
  }
}
    ${MultiDimensionalBucketBasedResultFragmentDoc}`;

/**
 * __useManuallyVerifiedResultsForRoundIdAndParticipantIdQuery__
 *
 * To run a query within a React component, call `useManuallyVerifiedResultsForRoundIdAndParticipantIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useManuallyVerifiedResultsForRoundIdAndParticipantIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManuallyVerifiedResultsForRoundIdAndParticipantIdQuery({
 *   variables: {
 *      roundId: // value for 'roundId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useManuallyVerifiedResultsForRoundIdAndParticipantIdQuery(baseOptions: Apollo.QueryHookOptions<ManuallyVerifiedResultsForRoundIdAndParticipantIdQuery, ManuallyVerifiedResultsForRoundIdAndParticipantIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManuallyVerifiedResultsForRoundIdAndParticipantIdQuery, ManuallyVerifiedResultsForRoundIdAndParticipantIdQueryVariables>(ManuallyVerifiedResultsForRoundIdAndParticipantIdDocument, options);
      }
export function useManuallyVerifiedResultsForRoundIdAndParticipantIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManuallyVerifiedResultsForRoundIdAndParticipantIdQuery, ManuallyVerifiedResultsForRoundIdAndParticipantIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManuallyVerifiedResultsForRoundIdAndParticipantIdQuery, ManuallyVerifiedResultsForRoundIdAndParticipantIdQueryVariables>(ManuallyVerifiedResultsForRoundIdAndParticipantIdDocument, options);
        }
export type ManuallyVerifiedResultsForRoundIdAndParticipantIdQueryHookResult = ReturnType<typeof useManuallyVerifiedResultsForRoundIdAndParticipantIdQuery>;
export type ManuallyVerifiedResultsForRoundIdAndParticipantIdLazyQueryHookResult = ReturnType<typeof useManuallyVerifiedResultsForRoundIdAndParticipantIdLazyQuery>;
export type ManuallyVerifiedResultsForRoundIdAndParticipantIdQueryResult = Apollo.QueryResult<ManuallyVerifiedResultsForRoundIdAndParticipantIdQuery, ManuallyVerifiedResultsForRoundIdAndParticipantIdQueryVariables>;
export const ConfirmParticipantDocument = gql`
    mutation confirmParticipant($eventId: String!, $accountId: String!) {
  confirmParticipant(eventId: $eventId, accountId: $accountId)
}
    `;
export type ConfirmParticipantMutationFn = Apollo.MutationFunction<ConfirmParticipantMutation, ConfirmParticipantMutationVariables>;

/**
 * __useConfirmParticipantMutation__
 *
 * To run a mutation, you first call `useConfirmParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmParticipantMutation, { data, loading, error }] = useConfirmParticipantMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useConfirmParticipantMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmParticipantMutation, ConfirmParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmParticipantMutation, ConfirmParticipantMutationVariables>(ConfirmParticipantDocument, options);
      }
export type ConfirmParticipantMutationHookResult = ReturnType<typeof useConfirmParticipantMutation>;
export type ConfirmParticipantMutationResult = Apollo.MutationResult<ConfirmParticipantMutation>;
export type ConfirmParticipantMutationOptions = Apollo.BaseMutationOptions<ConfirmParticipantMutation, ConfirmParticipantMutationVariables>;
export const GetParticipantsForParticipantConfirmationDocument = gql`
    query getParticipantsForParticipantConfirmation($eventId: String!) {
  event(eventId: $eventId) {
    id
    participants {
      ...TeamParticipantsForParticipantConfirmation
      ...IndividualParticipantsForParticipantConfirmation
    }
    eventTeam {
      id
      ...TechnicalParticipantForParticipantConfirmation
    }
  }
}
    ${TeamParticipantsForParticipantConfirmationFragmentDoc}
${IndividualParticipantsForParticipantConfirmationFragmentDoc}
${TechnicalParticipantForParticipantConfirmationFragmentDoc}`;

/**
 * __useGetParticipantsForParticipantConfirmationQuery__
 *
 * To run a query within a React component, call `useGetParticipantsForParticipantConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsForParticipantConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantsForParticipantConfirmationQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetParticipantsForParticipantConfirmationQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantsForParticipantConfirmationQuery, GetParticipantsForParticipantConfirmationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantsForParticipantConfirmationQuery, GetParticipantsForParticipantConfirmationQueryVariables>(GetParticipantsForParticipantConfirmationDocument, options);
      }
export function useGetParticipantsForParticipantConfirmationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantsForParticipantConfirmationQuery, GetParticipantsForParticipantConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantsForParticipantConfirmationQuery, GetParticipantsForParticipantConfirmationQueryVariables>(GetParticipantsForParticipantConfirmationDocument, options);
        }
export type GetParticipantsForParticipantConfirmationQueryHookResult = ReturnType<typeof useGetParticipantsForParticipantConfirmationQuery>;
export type GetParticipantsForParticipantConfirmationLazyQueryHookResult = ReturnType<typeof useGetParticipantsForParticipantConfirmationLazyQuery>;
export type GetParticipantsForParticipantConfirmationQueryResult = Apollo.QueryResult<GetParticipantsForParticipantConfirmationQuery, GetParticipantsForParticipantConfirmationQueryVariables>;
export const GetLaddersTimelineDocument = gql`
    query getLaddersTimeline($eventId: String!) {
  event(eventId: $eventId) {
    id
    eventState
    eventTiming {
      registrationClose
    }
  }
}
    `;

/**
 * __useGetLaddersTimelineQuery__
 *
 * To run a query within a React component, call `useGetLaddersTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaddersTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaddersTimelineQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetLaddersTimelineQuery(baseOptions: Apollo.QueryHookOptions<GetLaddersTimelineQuery, GetLaddersTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaddersTimelineQuery, GetLaddersTimelineQueryVariables>(GetLaddersTimelineDocument, options);
      }
export function useGetLaddersTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaddersTimelineQuery, GetLaddersTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaddersTimelineQuery, GetLaddersTimelineQueryVariables>(GetLaddersTimelineDocument, options);
        }
export type GetLaddersTimelineQueryHookResult = ReturnType<typeof useGetLaddersTimelineQuery>;
export type GetLaddersTimelineLazyQueryHookResult = ReturnType<typeof useGetLaddersTimelineLazyQuery>;
export type GetLaddersTimelineQueryResult = Apollo.QueryResult<GetLaddersTimelineQuery, GetLaddersTimelineQueryVariables>;
export const AddIndividualParticipantDocument = gql`
    mutation addIndividualParticipant($joinEventRequest: JoinIndividualEventRequest!) {
  addIndividualParticipant(joinEventRequest: $joinEventRequest)
}
    `;
export type AddIndividualParticipantMutationFn = Apollo.MutationFunction<AddIndividualParticipantMutation, AddIndividualParticipantMutationVariables>;

/**
 * __useAddIndividualParticipantMutation__
 *
 * To run a mutation, you first call `useAddIndividualParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIndividualParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIndividualParticipantMutation, { data, loading, error }] = useAddIndividualParticipantMutation({
 *   variables: {
 *      joinEventRequest: // value for 'joinEventRequest'
 *   },
 * });
 */
export function useAddIndividualParticipantMutation(baseOptions?: Apollo.MutationHookOptions<AddIndividualParticipantMutation, AddIndividualParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddIndividualParticipantMutation, AddIndividualParticipantMutationVariables>(AddIndividualParticipantDocument, options);
      }
export type AddIndividualParticipantMutationHookResult = ReturnType<typeof useAddIndividualParticipantMutation>;
export type AddIndividualParticipantMutationResult = Apollo.MutationResult<AddIndividualParticipantMutation>;
export type AddIndividualParticipantMutationOptions = Apollo.BaseMutationOptions<AddIndividualParticipantMutation, AddIndividualParticipantMutationVariables>;
export const AddTeamParticipantDocument = gql`
    mutation addTeamParticipant($joinEventRequest: JoinTeamEventRequest!) {
  addTeamParticipant(joinEventRequest: $joinEventRequest)
}
    `;
export type AddTeamParticipantMutationFn = Apollo.MutationFunction<AddTeamParticipantMutation, AddTeamParticipantMutationVariables>;

/**
 * __useAddTeamParticipantMutation__
 *
 * To run a mutation, you first call `useAddTeamParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamParticipantMutation, { data, loading, error }] = useAddTeamParticipantMutation({
 *   variables: {
 *      joinEventRequest: // value for 'joinEventRequest'
 *   },
 * });
 */
export function useAddTeamParticipantMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamParticipantMutation, AddTeamParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamParticipantMutation, AddTeamParticipantMutationVariables>(AddTeamParticipantDocument, options);
      }
export type AddTeamParticipantMutationHookResult = ReturnType<typeof useAddTeamParticipantMutation>;
export type AddTeamParticipantMutationResult = Apollo.MutationResult<AddTeamParticipantMutation>;
export type AddTeamParticipantMutationOptions = Apollo.BaseMutationOptions<AddTeamParticipantMutation, AddTeamParticipantMutationVariables>;
export const GetParticipantsForJoinEventModalDocument = gql`
    query getParticipantsForJoinEventModal($eventId: String!) {
  event(eventId: $eventId) {
    id
    participants {
      ... on TeamParticipant {
        team {
          id
        }
      }
      ... on ReadyIndividualParticipant {
        person {
          id
        }
      }
      ... on UnreadyIndividualParticipant {
        person {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetParticipantsForJoinEventModalQuery__
 *
 * To run a query within a React component, call `useGetParticipantsForJoinEventModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsForJoinEventModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantsForJoinEventModalQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetParticipantsForJoinEventModalQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantsForJoinEventModalQuery, GetParticipantsForJoinEventModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantsForJoinEventModalQuery, GetParticipantsForJoinEventModalQueryVariables>(GetParticipantsForJoinEventModalDocument, options);
      }
export function useGetParticipantsForJoinEventModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantsForJoinEventModalQuery, GetParticipantsForJoinEventModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantsForJoinEventModalQuery, GetParticipantsForJoinEventModalQueryVariables>(GetParticipantsForJoinEventModalDocument, options);
        }
export type GetParticipantsForJoinEventModalQueryHookResult = ReturnType<typeof useGetParticipantsForJoinEventModalQuery>;
export type GetParticipantsForJoinEventModalLazyQueryHookResult = ReturnType<typeof useGetParticipantsForJoinEventModalLazyQuery>;
export type GetParticipantsForJoinEventModalQueryResult = Apollo.QueryResult<GetParticipantsForJoinEventModalQuery, GetParticipantsForJoinEventModalQueryVariables>;
export const GetParticipantsForLeaveEventModalDocument = gql`
    query getParticipantsForLeaveEventModal($eventId: String!) {
  event(eventId: $eventId) {
    id
    participants {
      ... on TeamParticipant {
        id
        teamMembers {
          ... on ReadyIndividualParticipant {
            id
            person {
              id
              avatarURL
              displayName
            }
          }
          ... on UnreadyIndividualParticipant {
            id
            person {
              id
              avatarURL
              displayName
            }
          }
        }
        team {
          id
          name
          avatarURL
          groupMembers {
            id
            account {
              id
            }
            roles {
              roleId
            }
          }
        }
      }
      ... on ReadyIndividualParticipant {
        id
        person {
          id
          avatarURL
          displayName
        }
      }
      ... on UnreadyIndividualParticipant {
        id
        person {
          id
          avatarURL
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useGetParticipantsForLeaveEventModalQuery__
 *
 * To run a query within a React component, call `useGetParticipantsForLeaveEventModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsForLeaveEventModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantsForLeaveEventModalQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetParticipantsForLeaveEventModalQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantsForLeaveEventModalQuery, GetParticipantsForLeaveEventModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantsForLeaveEventModalQuery, GetParticipantsForLeaveEventModalQueryVariables>(GetParticipantsForLeaveEventModalDocument, options);
      }
export function useGetParticipantsForLeaveEventModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantsForLeaveEventModalQuery, GetParticipantsForLeaveEventModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantsForLeaveEventModalQuery, GetParticipantsForLeaveEventModalQueryVariables>(GetParticipantsForLeaveEventModalDocument, options);
        }
export type GetParticipantsForLeaveEventModalQueryHookResult = ReturnType<typeof useGetParticipantsForLeaveEventModalQuery>;
export type GetParticipantsForLeaveEventModalLazyQueryHookResult = ReturnType<typeof useGetParticipantsForLeaveEventModalLazyQuery>;
export type GetParticipantsForLeaveEventModalQueryResult = Apollo.QueryResult<GetParticipantsForLeaveEventModalQuery, GetParticipantsForLeaveEventModalQueryVariables>;
export const RemoveParticipantDocument = gql`
    mutation removeParticipant($leaveEventRequest: LeaveEventRequest!) {
  removeParticipant(leaveEventRequest: $leaveEventRequest)
}
    `;
export type RemoveParticipantMutationFn = Apollo.MutationFunction<RemoveParticipantMutation, RemoveParticipantMutationVariables>;

/**
 * __useRemoveParticipantMutation__
 *
 * To run a mutation, you first call `useRemoveParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeParticipantMutation, { data, loading, error }] = useRemoveParticipantMutation({
 *   variables: {
 *      leaveEventRequest: // value for 'leaveEventRequest'
 *   },
 * });
 */
export function useRemoveParticipantMutation(baseOptions?: Apollo.MutationHookOptions<RemoveParticipantMutation, RemoveParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveParticipantMutation, RemoveParticipantMutationVariables>(RemoveParticipantDocument, options);
      }
export type RemoveParticipantMutationHookResult = ReturnType<typeof useRemoveParticipantMutation>;
export type RemoveParticipantMutationResult = Apollo.MutationResult<RemoveParticipantMutation>;
export type RemoveParticipantMutationOptions = Apollo.BaseMutationOptions<RemoveParticipantMutation, RemoveParticipantMutationVariables>;
export const AddAutomaticallyVerifiedResultForRoundDocument = gql`
    mutation addAutomaticallyVerifiedResultForRound($accountId: String!, $automaticallyVerifiedResultsForRoundFromParticipant: AutomaticallyVerifiedResultsForRoundFromParticipantInput!) {
  addAutomaticallyVerifiedResultForRoundId(
    accountId: $accountId
    automaticallyVerifiedResultsForRoundFromParticipant: $automaticallyVerifiedResultsForRoundFromParticipant
  )
}
    `;
export type AddAutomaticallyVerifiedResultForRoundMutationFn = Apollo.MutationFunction<AddAutomaticallyVerifiedResultForRoundMutation, AddAutomaticallyVerifiedResultForRoundMutationVariables>;

/**
 * __useAddAutomaticallyVerifiedResultForRoundMutation__
 *
 * To run a mutation, you first call `useAddAutomaticallyVerifiedResultForRoundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAutomaticallyVerifiedResultForRoundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAutomaticallyVerifiedResultForRoundMutation, { data, loading, error }] = useAddAutomaticallyVerifiedResultForRoundMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      automaticallyVerifiedResultsForRoundFromParticipant: // value for 'automaticallyVerifiedResultsForRoundFromParticipant'
 *   },
 * });
 */
export function useAddAutomaticallyVerifiedResultForRoundMutation(baseOptions?: Apollo.MutationHookOptions<AddAutomaticallyVerifiedResultForRoundMutation, AddAutomaticallyVerifiedResultForRoundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAutomaticallyVerifiedResultForRoundMutation, AddAutomaticallyVerifiedResultForRoundMutationVariables>(AddAutomaticallyVerifiedResultForRoundDocument, options);
      }
export type AddAutomaticallyVerifiedResultForRoundMutationHookResult = ReturnType<typeof useAddAutomaticallyVerifiedResultForRoundMutation>;
export type AddAutomaticallyVerifiedResultForRoundMutationResult = Apollo.MutationResult<AddAutomaticallyVerifiedResultForRoundMutation>;
export type AddAutomaticallyVerifiedResultForRoundMutationOptions = Apollo.BaseMutationOptions<AddAutomaticallyVerifiedResultForRoundMutation, AddAutomaticallyVerifiedResultForRoundMutationVariables>;
export const AutomaticallyVerifiedResultsForRoundAndFromParticipantIdDocument = gql`
    query automaticallyVerifiedResultsForRoundAndFromParticipantId($roundId: String!, $participantId: String!) {
  automaticallyVerifiedResultsForRoundAndFromParticipantId(
    roundId: $roundId
    participantId: $participantId
  ) {
    competitionId
    roundId
    unverifiedResults {
      score
      participantId
    }
  }
}
    `;

/**
 * __useAutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery__
 *
 * To run a query within a React component, call `useAutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery({
 *   variables: {
 *      roundId: // value for 'roundId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useAutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery(baseOptions: Apollo.QueryHookOptions<AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery, AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery, AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQueryVariables>(AutomaticallyVerifiedResultsForRoundAndFromParticipantIdDocument, options);
      }
export function useAutomaticallyVerifiedResultsForRoundAndFromParticipantIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery, AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery, AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQueryVariables>(AutomaticallyVerifiedResultsForRoundAndFromParticipantIdDocument, options);
        }
export type AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQueryHookResult = ReturnType<typeof useAutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery>;
export type AutomaticallyVerifiedResultsForRoundAndFromParticipantIdLazyQueryHookResult = ReturnType<typeof useAutomaticallyVerifiedResultsForRoundAndFromParticipantIdLazyQuery>;
export type AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQueryResult = Apollo.QueryResult<AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery, AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQueryVariables>;
export const GetEventToMatchUpDocument = gql`
    query getEventToMatchUp($eventId: String!) {
  event(eventId: $eventId) {
    ...EventToMatchUp
  }
}
    ${EventToMatchUpFragmentDoc}`;

/**
 * __useGetEventToMatchUpQuery__
 *
 * To run a query within a React component, call `useGetEventToMatchUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventToMatchUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventToMatchUpQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventToMatchUpQuery(baseOptions: Apollo.QueryHookOptions<GetEventToMatchUpQuery, GetEventToMatchUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventToMatchUpQuery, GetEventToMatchUpQueryVariables>(GetEventToMatchUpDocument, options);
      }
export function useGetEventToMatchUpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventToMatchUpQuery, GetEventToMatchUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventToMatchUpQuery, GetEventToMatchUpQueryVariables>(GetEventToMatchUpDocument, options);
        }
export type GetEventToMatchUpQueryHookResult = ReturnType<typeof useGetEventToMatchUpQuery>;
export type GetEventToMatchUpLazyQueryHookResult = ReturnType<typeof useGetEventToMatchUpLazyQuery>;
export type GetEventToMatchUpQueryResult = Apollo.QueryResult<GetEventToMatchUpQuery, GetEventToMatchUpQueryVariables>;
export const BracketsDocument = gql`
    query brackets($eventId: String!) {
  event(eventId: $eventId) {
    ...BracketsForEvent
  }
}
    ${BracketsForEventFragmentDoc}`;

/**
 * __useBracketsQuery__
 *
 * To run a query within a React component, call `useBracketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBracketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBracketsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useBracketsQuery(baseOptions: Apollo.QueryHookOptions<BracketsQuery, BracketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BracketsQuery, BracketsQueryVariables>(BracketsDocument, options);
      }
export function useBracketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BracketsQuery, BracketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BracketsQuery, BracketsQueryVariables>(BracketsDocument, options);
        }
export type BracketsQueryHookResult = ReturnType<typeof useBracketsQuery>;
export type BracketsLazyQueryHookResult = ReturnType<typeof useBracketsLazyQuery>;
export type BracketsQueryResult = Apollo.QueryResult<BracketsQuery, BracketsQueryVariables>;
export const EventMatchDocument = gql`
    query eventMatch($matchId: String!) {
  eventMatch(matchId: $matchId) {
    competitionId
    matches {
      ...PlayableMatchUpMatch
      ...PlayableTournamentMatchOnMatchDetails
    }
  }
}
    ${PlayableMatchUpMatchFragmentDoc}
${PlayableTournamentMatchOnMatchDetailsFragmentDoc}`;

/**
 * __useEventMatchQuery__
 *
 * To run a query within a React component, call `useEventMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useEventMatchQuery(baseOptions: Apollo.QueryHookOptions<EventMatchQuery, EventMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventMatchQuery, EventMatchQueryVariables>(EventMatchDocument, options);
      }
export function useEventMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventMatchQuery, EventMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventMatchQuery, EventMatchQueryVariables>(EventMatchDocument, options);
        }
export type EventMatchQueryHookResult = ReturnType<typeof useEventMatchQuery>;
export type EventMatchLazyQueryHookResult = ReturnType<typeof useEventMatchLazyQuery>;
export type EventMatchQueryResult = Apollo.QueryResult<EventMatchQuery, EventMatchQueryVariables>;
export const UnmatchedParticipantsDocument = gql`
    query unmatchedParticipants($eventId: String!) {
  event(eventId: $eventId) {
    id
    participants {
      ... on TeamParticipant {
        id
        team {
          id
          name
          avatarURL
          publicURL
        }
      }
    }
  }
}
    `;

/**
 * __useUnmatchedParticipantsQuery__
 *
 * To run a query within a React component, call `useUnmatchedParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnmatchedParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnmatchedParticipantsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useUnmatchedParticipantsQuery(baseOptions: Apollo.QueryHookOptions<UnmatchedParticipantsQuery, UnmatchedParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnmatchedParticipantsQuery, UnmatchedParticipantsQueryVariables>(UnmatchedParticipantsDocument, options);
      }
export function useUnmatchedParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnmatchedParticipantsQuery, UnmatchedParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnmatchedParticipantsQuery, UnmatchedParticipantsQueryVariables>(UnmatchedParticipantsDocument, options);
        }
export type UnmatchedParticipantsQueryHookResult = ReturnType<typeof useUnmatchedParticipantsQuery>;
export type UnmatchedParticipantsLazyQueryHookResult = ReturnType<typeof useUnmatchedParticipantsLazyQuery>;
export type UnmatchedParticipantsQueryResult = Apollo.QueryResult<UnmatchedParticipantsQuery, UnmatchedParticipantsQueryVariables>;
export const GetEventLaddersDashboardDocument = gql`
    query getEventLaddersDashboard($eventId: String!) {
  event(eventId: $eventId) {
    id
    participantType
    eventState
    eventStages {
      id
      competitions {
        participants {
          accountId
          result {
            score
            placement
            showed
          }
          participant {
            ... on TeamParticipant {
              teamMembers {
                accountId
              }
              team {
                avatarURL
                name
              }
            }
            ... on ReadyIndividualParticipant {
              gameAccount {
                externalAccountName
              }
              person {
                avatarURL
                displayName
              }
            }
            ... on UnreadyIndividualParticipant {
              person {
                avatarURL
                displayName
              }
            }
          }
        }
        ... on Challenge {
          challengeFormat
        }
        competitionType
      }
    }
    eventTiming {
      registrationOpen
      registrationClose
      startTime
      completedAt
    }
  }
}
    `;

/**
 * __useGetEventLaddersDashboardQuery__
 *
 * To run a query within a React component, call `useGetEventLaddersDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventLaddersDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventLaddersDashboardQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventLaddersDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetEventLaddersDashboardQuery, GetEventLaddersDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventLaddersDashboardQuery, GetEventLaddersDashboardQueryVariables>(GetEventLaddersDashboardDocument, options);
      }
export function useGetEventLaddersDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventLaddersDashboardQuery, GetEventLaddersDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventLaddersDashboardQuery, GetEventLaddersDashboardQueryVariables>(GetEventLaddersDashboardDocument, options);
        }
export type GetEventLaddersDashboardQueryHookResult = ReturnType<typeof useGetEventLaddersDashboardQuery>;
export type GetEventLaddersDashboardLazyQueryHookResult = ReturnType<typeof useGetEventLaddersDashboardLazyQuery>;
export type GetEventLaddersDashboardQueryResult = Apollo.QueryResult<GetEventLaddersDashboardQuery, GetEventLaddersDashboardQueryVariables>;
export const ReadyParticipantDocument = gql`
    mutation readyParticipant($eventId: String!, $accountId: String!, $gameAccountId: String!, $additionalInformation: [AdditionalInformationInput!]) {
  readyIndividualParticipant(
    eventId: $eventId
    accountId: $accountId
    gameAccountId: $gameAccountId
    additionalInformation: $additionalInformation
  )
}
    `;
export type ReadyParticipantMutationFn = Apollo.MutationFunction<ReadyParticipantMutation, ReadyParticipantMutationVariables>;

/**
 * __useReadyParticipantMutation__
 *
 * To run a mutation, you first call `useReadyParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadyParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readyParticipantMutation, { data, loading, error }] = useReadyParticipantMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      accountId: // value for 'accountId'
 *      gameAccountId: // value for 'gameAccountId'
 *      additionalInformation: // value for 'additionalInformation'
 *   },
 * });
 */
export function useReadyParticipantMutation(baseOptions?: Apollo.MutationHookOptions<ReadyParticipantMutation, ReadyParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadyParticipantMutation, ReadyParticipantMutationVariables>(ReadyParticipantDocument, options);
      }
export type ReadyParticipantMutationHookResult = ReturnType<typeof useReadyParticipantMutation>;
export type ReadyParticipantMutationResult = Apollo.MutationResult<ReadyParticipantMutation>;
export type ReadyParticipantMutationOptions = Apollo.BaseMutationOptions<ReadyParticipantMutation, ReadyParticipantMutationVariables>;
export const AddEventTeamInviteCodeDocument = gql`
    mutation addEventTeamInviteCode($eventId: String!, $teamId: String!, $userId: String!) {
  addEventTeamInviteCode(eventId: $eventId, teamId: $teamId, userId: $userId) {
    id
    code
  }
}
    `;
export type AddEventTeamInviteCodeMutationFn = Apollo.MutationFunction<AddEventTeamInviteCodeMutation, AddEventTeamInviteCodeMutationVariables>;

/**
 * __useAddEventTeamInviteCodeMutation__
 *
 * To run a mutation, you first call `useAddEventTeamInviteCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventTeamInviteCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventTeamInviteCodeMutation, { data, loading, error }] = useAddEventTeamInviteCodeMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddEventTeamInviteCodeMutation(baseOptions?: Apollo.MutationHookOptions<AddEventTeamInviteCodeMutation, AddEventTeamInviteCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventTeamInviteCodeMutation, AddEventTeamInviteCodeMutationVariables>(AddEventTeamInviteCodeDocument, options);
      }
export type AddEventTeamInviteCodeMutationHookResult = ReturnType<typeof useAddEventTeamInviteCodeMutation>;
export type AddEventTeamInviteCodeMutationResult = Apollo.MutationResult<AddEventTeamInviteCodeMutation>;
export type AddEventTeamInviteCodeMutationOptions = Apollo.BaseMutationOptions<AddEventTeamInviteCodeMutation, AddEventTeamInviteCodeMutationVariables>;
export const AddToEventTeamDocument = gql`
    mutation addToEventTeam($eventId: String!, $teamId: String!, $userId: String!) {
  addToEventTeam(eventId: $eventId, teamId: $teamId, userId: $userId)
}
    `;
export type AddToEventTeamMutationFn = Apollo.MutationFunction<AddToEventTeamMutation, AddToEventTeamMutationVariables>;

/**
 * __useAddToEventTeamMutation__
 *
 * To run a mutation, you first call `useAddToEventTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToEventTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToEventTeamMutation, { data, loading, error }] = useAddToEventTeamMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddToEventTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddToEventTeamMutation, AddToEventTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToEventTeamMutation, AddToEventTeamMutationVariables>(AddToEventTeamDocument, options);
      }
export type AddToEventTeamMutationHookResult = ReturnType<typeof useAddToEventTeamMutation>;
export type AddToEventTeamMutationResult = Apollo.MutationResult<AddToEventTeamMutation>;
export type AddToEventTeamMutationOptions = Apollo.BaseMutationOptions<AddToEventTeamMutation, AddToEventTeamMutationVariables>;
export const GetEventParticipantByAccountIdDocument = gql`
    query getEventParticipantByAccountId($accountId: String!, $eventId: String!) {
  eventParticipantByAccount(accountId: $accountId, eventId: $eventId) {
    disqualified
    participant {
      participantType
      ... on TeamParticipant {
        id
        team {
          ...TeamEventData
        }
        teamMembers {
          ...EventUsersParticipants
        }
        requirementsNotMet {
          participantID
          missingParticipantRequirement {
            ...MissingParticipantRequirements
          }
        }
      }
      ...EventUsersParticipants
    }
    eliminated
  }
}
    ${TeamEventDataFragmentDoc}
${EventUsersParticipantsFragmentDoc}
${MissingParticipantRequirementsFragmentDoc}`;

/**
 * __useGetEventParticipantByAccountIdQuery__
 *
 * To run a query within a React component, call `useGetEventParticipantByAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventParticipantByAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventParticipantByAccountIdQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventParticipantByAccountIdQuery(baseOptions: Apollo.QueryHookOptions<GetEventParticipantByAccountIdQuery, GetEventParticipantByAccountIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventParticipantByAccountIdQuery, GetEventParticipantByAccountIdQueryVariables>(GetEventParticipantByAccountIdDocument, options);
      }
export function useGetEventParticipantByAccountIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventParticipantByAccountIdQuery, GetEventParticipantByAccountIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventParticipantByAccountIdQuery, GetEventParticipantByAccountIdQueryVariables>(GetEventParticipantByAccountIdDocument, options);
        }
export type GetEventParticipantByAccountIdQueryHookResult = ReturnType<typeof useGetEventParticipantByAccountIdQuery>;
export type GetEventParticipantByAccountIdLazyQueryHookResult = ReturnType<typeof useGetEventParticipantByAccountIdLazyQuery>;
export type GetEventParticipantByAccountIdQueryResult = Apollo.QueryResult<GetEventParticipantByAccountIdQuery, GetEventParticipantByAccountIdQueryVariables>;
export const GetEventToDashboardDocument = gql`
    query getEventToDashboard($eventId: String!) {
  event(eventId: $eventId) {
    id
    eventTiming {
      startTime
      registrationClose
      registrationOpen
    }
    eventState
    participantType
    eventLimitations {
      checkInMode
    }
  }
}
    `;

/**
 * __useGetEventToDashboardQuery__
 *
 * To run a query within a React component, call `useGetEventToDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventToDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventToDashboardQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventToDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetEventToDashboardQuery, GetEventToDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventToDashboardQuery, GetEventToDashboardQueryVariables>(GetEventToDashboardDocument, options);
      }
export function useGetEventToDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventToDashboardQuery, GetEventToDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventToDashboardQuery, GetEventToDashboardQueryVariables>(GetEventToDashboardDocument, options);
        }
export type GetEventToDashboardQueryHookResult = ReturnType<typeof useGetEventToDashboardQuery>;
export type GetEventToDashboardLazyQueryHookResult = ReturnType<typeof useGetEventToDashboardLazyQuery>;
export type GetEventToDashboardQueryResult = Apollo.QueryResult<GetEventToDashboardQuery, GetEventToDashboardQueryVariables>;
export const GetEventToReadyToJoinDocument = gql`
    query getEventToReadyToJoin($eventId: String!) {
  event(eventId: $eventId) {
    id
    eventLimitations {
      eventEntryRules {
        ... on TeamEventEntryRules {
          minimumTeamMembers
          maximumTeamMembers
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventToReadyToJoinQuery__
 *
 * To run a query within a React component, call `useGetEventToReadyToJoinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventToReadyToJoinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventToReadyToJoinQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventToReadyToJoinQuery(baseOptions: Apollo.QueryHookOptions<GetEventToReadyToJoinQuery, GetEventToReadyToJoinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventToReadyToJoinQuery, GetEventToReadyToJoinQueryVariables>(GetEventToReadyToJoinDocument, options);
      }
export function useGetEventToReadyToJoinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventToReadyToJoinQuery, GetEventToReadyToJoinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventToReadyToJoinQuery, GetEventToReadyToJoinQueryVariables>(GetEventToReadyToJoinDocument, options);
        }
export type GetEventToReadyToJoinQueryHookResult = ReturnType<typeof useGetEventToReadyToJoinQuery>;
export type GetEventToReadyToJoinLazyQueryHookResult = ReturnType<typeof useGetEventToReadyToJoinLazyQuery>;
export type GetEventToReadyToJoinQueryResult = Apollo.QueryResult<GetEventToReadyToJoinQuery, GetEventToReadyToJoinQueryVariables>;
export const GetTeamForEditLineupDocument = gql`
    query getTeamForEditLineup($teamId: String!) {
  account(id: $teamId) {
    ...TeamForEditLineup
  }
}
    ${TeamForEditLineupFragmentDoc}`;

/**
 * __useGetTeamForEditLineupQuery__
 *
 * To run a query within a React component, call `useGetTeamForEditLineupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamForEditLineupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamForEditLineupQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamForEditLineupQuery(baseOptions: Apollo.QueryHookOptions<GetTeamForEditLineupQuery, GetTeamForEditLineupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamForEditLineupQuery, GetTeamForEditLineupQueryVariables>(GetTeamForEditLineupDocument, options);
      }
export function useGetTeamForEditLineupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamForEditLineupQuery, GetTeamForEditLineupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamForEditLineupQuery, GetTeamForEditLineupQueryVariables>(GetTeamForEditLineupDocument, options);
        }
export type GetTeamForEditLineupQueryHookResult = ReturnType<typeof useGetTeamForEditLineupQuery>;
export type GetTeamForEditLineupLazyQueryHookResult = ReturnType<typeof useGetTeamForEditLineupLazyQuery>;
export type GetTeamForEditLineupQueryResult = Apollo.QueryResult<GetTeamForEditLineupQuery, GetTeamForEditLineupQueryVariables>;
export const RemoveFromEventTeamDocument = gql`
    mutation removeFromEventTeam($eventId: String!, $teamId: String!, $userId: String!) {
  removeFromEventTeam(eventId: $eventId, teamId: $teamId, userId: $userId)
}
    `;
export type RemoveFromEventTeamMutationFn = Apollo.MutationFunction<RemoveFromEventTeamMutation, RemoveFromEventTeamMutationVariables>;

/**
 * __useRemoveFromEventTeamMutation__
 *
 * To run a mutation, you first call `useRemoveFromEventTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromEventTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromEventTeamMutation, { data, loading, error }] = useRemoveFromEventTeamMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveFromEventTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFromEventTeamMutation, RemoveFromEventTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFromEventTeamMutation, RemoveFromEventTeamMutationVariables>(RemoveFromEventTeamDocument, options);
      }
export type RemoveFromEventTeamMutationHookResult = ReturnType<typeof useRemoveFromEventTeamMutation>;
export type RemoveFromEventTeamMutationResult = Apollo.MutationResult<RemoveFromEventTeamMutation>;
export type RemoveFromEventTeamMutationOptions = Apollo.BaseMutationOptions<RemoveFromEventTeamMutation, RemoveFromEventTeamMutationVariables>;
export const MakeGhostDocument = gql`
    query makeGhost {
  ghostCompetition(
    competitionId: "46abdc2f-d071-46cc-87c6-cc7dd95e4a07"
    maybeNumberOfParticipants: 8
  ) {
    ... on Tournament {
      eventId
      event {
        localizedNames {
          value
        }
      }
      eventStageId
      brackets {
        id
        phases {
          id
          phaseNumber
          matches {
            id
            ... on PlayableTournamentMatch {
              participants {
                participantId
                accountId
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMakeGhostQuery__
 *
 * To run a query within a React component, call `useMakeGhostQuery` and pass it any options that fit your needs.
 * When your component renders, `useMakeGhostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMakeGhostQuery({
 *   variables: {
 *   },
 * });
 */
export function useMakeGhostQuery(baseOptions?: Apollo.QueryHookOptions<MakeGhostQuery, MakeGhostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MakeGhostQuery, MakeGhostQueryVariables>(MakeGhostDocument, options);
      }
export function useMakeGhostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MakeGhostQuery, MakeGhostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MakeGhostQuery, MakeGhostQueryVariables>(MakeGhostDocument, options);
        }
export type MakeGhostQueryHookResult = ReturnType<typeof useMakeGhostQuery>;
export type MakeGhostLazyQueryHookResult = ReturnType<typeof useMakeGhostLazyQuery>;
export type MakeGhostQueryResult = Apollo.QueryResult<MakeGhostQuery, MakeGhostQueryVariables>;
export const GetEventDefaultOverviewDocument = gql`
    query getEventDefaultOverview($eventId: String!) {
  event(eventId: $eventId) {
    id
    game {
      prettyName
    }
    localizedDescriptions {
      locale
      value
    }
    participantType
    eventLimitations {
      minimumParticipants
      maximumParticipants
    }
    eventState
    tags {
      ...Tag
    }
    eventStages {
      competitions {
        ... on Challenge {
          challengeFormat
        }
        ... on MatchUp {
          matchUpFormat
        }
        ... on Tournament {
          tournamentFormat
        }
      }
    }
    eventTiming {
      startTime
      completedAt
    }
    region
    participantCount
  }
}
    ${TagFragmentDoc}`;

/**
 * __useGetEventDefaultOverviewQuery__
 *
 * To run a query within a React component, call `useGetEventDefaultOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDefaultOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDefaultOverviewQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventDefaultOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetEventDefaultOverviewQuery, GetEventDefaultOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventDefaultOverviewQuery, GetEventDefaultOverviewQueryVariables>(GetEventDefaultOverviewDocument, options);
      }
export function useGetEventDefaultOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventDefaultOverviewQuery, GetEventDefaultOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventDefaultOverviewQuery, GetEventDefaultOverviewQueryVariables>(GetEventDefaultOverviewDocument, options);
        }
export type GetEventDefaultOverviewQueryHookResult = ReturnType<typeof useGetEventDefaultOverviewQuery>;
export type GetEventDefaultOverviewLazyQueryHookResult = ReturnType<typeof useGetEventDefaultOverviewLazyQuery>;
export type GetEventDefaultOverviewQueryResult = Apollo.QueryResult<GetEventDefaultOverviewQuery, GetEventDefaultOverviewQueryVariables>;
export const GetEventLaddersOverviewDocument = gql`
    query getEventLaddersOverview($eventId: String!) {
  event(eventId: $eventId) {
    id
    game {
      prettyName
    }
    participantType
    eventLimitations {
      minimumParticipants
      maximumParticipants
    }
    eventState
    eventTiming {
      startTime
      completedAt
    }
    region
    participantCount
    eventStages {
      id
      competitions {
        ... on Challenge {
          competitionSpecificDetails {
            ... on LadderSpecificDetails {
              duration
            }
          }
          gameSpecificDetails {
            ... on ValorantCompetitionDetails {
              matchType
            }
          }
        }
        participants {
          accountId
          result {
            score
            placement
            showed
          }
          participant {
            ... on TeamParticipant {
              teamMembers {
                accountId
              }
              team {
                avatarURL
                name
              }
            }
            ... on ReadyIndividualParticipant {
              gameAccount {
                externalAccountName
              }
              person {
                avatarURL
                displayName
              }
            }
            ... on UnreadyIndividualParticipant {
              person {
                avatarURL
                displayName
              }
            }
          }
        }
        ... on Challenge {
          challengeFormat
        }
        competitionType
      }
    }
  }
}
    `;

/**
 * __useGetEventLaddersOverviewQuery__
 *
 * To run a query within a React component, call `useGetEventLaddersOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventLaddersOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventLaddersOverviewQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventLaddersOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetEventLaddersOverviewQuery, GetEventLaddersOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventLaddersOverviewQuery, GetEventLaddersOverviewQueryVariables>(GetEventLaddersOverviewDocument, options);
      }
export function useGetEventLaddersOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventLaddersOverviewQuery, GetEventLaddersOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventLaddersOverviewQuery, GetEventLaddersOverviewQueryVariables>(GetEventLaddersOverviewDocument, options);
        }
export type GetEventLaddersOverviewQueryHookResult = ReturnType<typeof useGetEventLaddersOverviewQuery>;
export type GetEventLaddersOverviewLazyQueryHookResult = ReturnType<typeof useGetEventLaddersOverviewLazyQuery>;
export type GetEventLaddersOverviewQueryResult = Apollo.QueryResult<GetEventLaddersOverviewQuery, GetEventLaddersOverviewQueryVariables>;
export const GetEventParticipantDocument = gql`
    query getEventParticipant($participantId: String!) {
  eventParticipant(participantId: $participantId) {
    ... on TeamParticipant {
      id
      teamMembers {
        ... on ReadyIndividualParticipant {
          id
          person {
            id
            displayName
            publicURL
            avatarURL
            additionalInformation {
              key
              value
            }
          }
          gameAccount {
            id
            externalAccountId
            externalAccountName
            gameAccountTypeId
          }
        }
        ... on UnreadyIndividualParticipant {
          id
          person {
            id
            displayName
            publicURL
            avatarURL
            additionalInformation {
              key
              value
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventParticipantQuery__
 *
 * To run a query within a React component, call `useGetEventParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventParticipantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventParticipantQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetEventParticipantQuery(baseOptions: Apollo.QueryHookOptions<GetEventParticipantQuery, GetEventParticipantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventParticipantQuery, GetEventParticipantQueryVariables>(GetEventParticipantDocument, options);
      }
export function useGetEventParticipantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventParticipantQuery, GetEventParticipantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventParticipantQuery, GetEventParticipantQueryVariables>(GetEventParticipantDocument, options);
        }
export type GetEventParticipantQueryHookResult = ReturnType<typeof useGetEventParticipantQuery>;
export type GetEventParticipantLazyQueryHookResult = ReturnType<typeof useGetEventParticipantLazyQuery>;
export type GetEventParticipantQueryResult = Apollo.QueryResult<GetEventParticipantQuery, GetEventParticipantQueryVariables>;
export const GetParticipantsForParticipantTabDocument = gql`
    query getParticipantsForParticipantTab($eventId: String!) {
  event(eventId: $eventId) {
    id
    participants {
      ...TeamParticipantsForParticipantTab
      ...IndividualParticipantsForParticipantTab
    }
    disqualifiedParticipants {
      ...TeamParticipantsForParticipantTab
      ...IndividualParticipantsForParticipantTab
    }
  }
}
    ${TeamParticipantsForParticipantTabFragmentDoc}
${IndividualParticipantsForParticipantTabFragmentDoc}`;

/**
 * __useGetParticipantsForParticipantTabQuery__
 *
 * To run a query within a React component, call `useGetParticipantsForParticipantTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsForParticipantTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantsForParticipantTabQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetParticipantsForParticipantTabQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantsForParticipantTabQuery, GetParticipantsForParticipantTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantsForParticipantTabQuery, GetParticipantsForParticipantTabQueryVariables>(GetParticipantsForParticipantTabDocument, options);
      }
export function useGetParticipantsForParticipantTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantsForParticipantTabQuery, GetParticipantsForParticipantTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantsForParticipantTabQuery, GetParticipantsForParticipantTabQueryVariables>(GetParticipantsForParticipantTabDocument, options);
        }
export type GetParticipantsForParticipantTabQueryHookResult = ReturnType<typeof useGetParticipantsForParticipantTabQuery>;
export type GetParticipantsForParticipantTabLazyQueryHookResult = ReturnType<typeof useGetParticipantsForParticipantTabLazyQuery>;
export type GetParticipantsForParticipantTabQueryResult = Apollo.QueryResult<GetParticipantsForParticipantTabQuery, GetParticipantsForParticipantTabQueryVariables>;
export const GetParticipantsForPrizesTabDocument = gql`
    query getParticipantsForPrizesTab($eventId: String!) {
  event(eventId: $eventId) {
    id
    participants {
      ...TeamParticipantForPrizesTab
      ...IndividualParticipantForPrizesTab
    }
  }
}
    ${TeamParticipantForPrizesTabFragmentDoc}
${IndividualParticipantForPrizesTabFragmentDoc}`;

/**
 * __useGetParticipantsForPrizesTabQuery__
 *
 * To run a query within a React component, call `useGetParticipantsForPrizesTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantsForPrizesTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantsForPrizesTabQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetParticipantsForPrizesTabQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantsForPrizesTabQuery, GetParticipantsForPrizesTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantsForPrizesTabQuery, GetParticipantsForPrizesTabQueryVariables>(GetParticipantsForPrizesTabDocument, options);
      }
export function useGetParticipantsForPrizesTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantsForPrizesTabQuery, GetParticipantsForPrizesTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantsForPrizesTabQuery, GetParticipantsForPrizesTabQueryVariables>(GetParticipantsForPrizesTabDocument, options);
        }
export type GetParticipantsForPrizesTabQueryHookResult = ReturnType<typeof useGetParticipantsForPrizesTabQuery>;
export type GetParticipantsForPrizesTabLazyQueryHookResult = ReturnType<typeof useGetParticipantsForPrizesTabLazyQuery>;
export type GetParticipantsForPrizesTabQueryResult = Apollo.QueryResult<GetParticipantsForPrizesTabQuery, GetParticipantsForPrizesTabQueryVariables>;
export const GetActiveMatchesDocument = gql`
    query getActiveMatches($maybeAccountId: String) {
  getActiveMatches(maybeAccountId: $maybeAccountId) {
    competitionId
    matches {
      ...PlayableTournamentMatchOnActiveMatches
      ...PlayableMatchUpMatchOnActiveMatches
    }
  }
}
    ${PlayableTournamentMatchOnActiveMatchesFragmentDoc}
${PlayableMatchUpMatchOnActiveMatchesFragmentDoc}`;

/**
 * __useGetActiveMatchesQuery__
 *
 * To run a query within a React component, call `useGetActiveMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveMatchesQuery({
 *   variables: {
 *      maybeAccountId: // value for 'maybeAccountId'
 *   },
 * });
 */
export function useGetActiveMatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveMatchesQuery, GetActiveMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveMatchesQuery, GetActiveMatchesQueryVariables>(GetActiveMatchesDocument, options);
      }
export function useGetActiveMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveMatchesQuery, GetActiveMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveMatchesQuery, GetActiveMatchesQueryVariables>(GetActiveMatchesDocument, options);
        }
export type GetActiveMatchesQueryHookResult = ReturnType<typeof useGetActiveMatchesQuery>;
export type GetActiveMatchesLazyQueryHookResult = ReturnType<typeof useGetActiveMatchesLazyQuery>;
export type GetActiveMatchesQueryResult = Apollo.QueryResult<GetActiveMatchesQuery, GetActiveMatchesQueryVariables>;
export const GetAllEventsDocument = gql`
    query getAllEvents($eventsQuery: EventsQuery!, $limit: Int!, $offset: Int!, $eventSortField: EventSortField = StartTime, $sortOrder: SortOrder = Ascending) {
  allEvents(
    eventsQuery: $eventsQuery
    eventSortField: $eventSortField
    limit: $limit
    offset: $offset
    sortOrder: $sortOrder
  ) {
    totalCount
    hasNextPage
    nodes {
      ...AllEventsEvent
    }
  }
}
    ${AllEventsEventFragmentDoc}`;

/**
 * __useGetAllEventsQuery__
 *
 * To run a query within a React component, call `useGetAllEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEventsQuery({
 *   variables: {
 *      eventsQuery: // value for 'eventsQuery'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      eventSortField: // value for 'eventSortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetAllEventsQuery(baseOptions: Apollo.QueryHookOptions<GetAllEventsQuery, GetAllEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEventsQuery, GetAllEventsQueryVariables>(GetAllEventsDocument, options);
      }
export function useGetAllEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEventsQuery, GetAllEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEventsQuery, GetAllEventsQueryVariables>(GetAllEventsDocument, options);
        }
export type GetAllEventsQueryHookResult = ReturnType<typeof useGetAllEventsQuery>;
export type GetAllEventsLazyQueryHookResult = ReturnType<typeof useGetAllEventsLazyQuery>;
export type GetAllEventsQueryResult = Apollo.QueryResult<GetAllEventsQuery, GetAllEventsQueryVariables>;
export const GetEventDocument = gql`
    query getEvent($eventId: String!) {
  event(eventId: $eventId) {
    ...Event
  }
}
    ${EventFragmentDoc}`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const InGameResultsDocument = gql`
    query InGameResults($matchIds: [String!]!) {
  InGameResults(matchIds: $matchIds) {
    ...InGameResult
  }
}
    ${InGameResultFragmentDoc}`;

/**
 * __useInGameResultsQuery__
 *
 * To run a query within a React component, call `useInGameResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInGameResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInGameResultsQuery({
 *   variables: {
 *      matchIds: // value for 'matchIds'
 *   },
 * });
 */
export function useInGameResultsQuery(baseOptions: Apollo.QueryHookOptions<InGameResultsQuery, InGameResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InGameResultsQuery, InGameResultsQueryVariables>(InGameResultsDocument, options);
      }
export function useInGameResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InGameResultsQuery, InGameResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InGameResultsQuery, InGameResultsQueryVariables>(InGameResultsDocument, options);
        }
export type InGameResultsQueryHookResult = ReturnType<typeof useInGameResultsQuery>;
export type InGameResultsLazyQueryHookResult = ReturnType<typeof useInGameResultsLazyQuery>;
export type InGameResultsQueryResult = Apollo.QueryResult<InGameResultsQuery, InGameResultsQueryVariables>;
export const UpdatedEventDocument = gql`
    subscription UpdatedEvent($notificationType: String!, $targetId: String) {
  ClientNotification(
    notificationType: $notificationType
    maybeTargetId: $targetId
  ) {
    id
    created
    expiry
    defaultMessage
    notificationType
    ... on ClientNotificationEvent {
      targetId
      fields
    }
  }
}
    `;

/**
 * __useUpdatedEventSubscription__
 *
 * To run a query within a React component, call `useUpdatedEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedEventSubscription({
 *   variables: {
 *      notificationType: // value for 'notificationType'
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useUpdatedEventSubscription(baseOptions: Apollo.SubscriptionHookOptions<UpdatedEventSubscription, UpdatedEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedEventSubscription, UpdatedEventSubscriptionVariables>(UpdatedEventDocument, options);
      }
export type UpdatedEventSubscriptionHookResult = ReturnType<typeof useUpdatedEventSubscription>;
export type UpdatedEventSubscriptionResult = Apollo.SubscriptionResult<UpdatedEventSubscription>;
export const GetEventToInvitePageDocument = gql`
    query getEventToInvitePage($eventId: String!) {
  event(eventId: $eventId) {
    id
    participants {
      ... on TeamParticipant {
        teamId
        teamMembers {
          accountId
        }
      }
    }
    game {
      id
      prettyName
    }
    eventTiming {
      startTime
    }
    localizedNames {
      locale
      value
    }
  }
}
    `;

/**
 * __useGetEventToInvitePageQuery__
 *
 * To run a query within a React component, call `useGetEventToInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventToInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventToInvitePageQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventToInvitePageQuery(baseOptions: Apollo.QueryHookOptions<GetEventToInvitePageQuery, GetEventToInvitePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventToInvitePageQuery, GetEventToInvitePageQueryVariables>(GetEventToInvitePageDocument, options);
      }
export function useGetEventToInvitePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventToInvitePageQuery, GetEventToInvitePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventToInvitePageQuery, GetEventToInvitePageQueryVariables>(GetEventToInvitePageDocument, options);
        }
export type GetEventToInvitePageQueryHookResult = ReturnType<typeof useGetEventToInvitePageQuery>;
export type GetEventToInvitePageLazyQueryHookResult = ReturnType<typeof useGetEventToInvitePageLazyQuery>;
export type GetEventToInvitePageQueryResult = Apollo.QueryResult<GetEventToInvitePageQuery, GetEventToInvitePageQueryVariables>;
export const GetTeamForInvitePageDocument = gql`
    query getTeamForInvitePage($id: String!) {
  account(id: $id) {
    ... on Team {
      id
      name
      avatarURL
      groupMembers {
        account {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetTeamForInvitePageQuery__
 *
 * To run a query within a React component, call `useGetTeamForInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamForInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamForInvitePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamForInvitePageQuery(baseOptions: Apollo.QueryHookOptions<GetTeamForInvitePageQuery, GetTeamForInvitePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamForInvitePageQuery, GetTeamForInvitePageQueryVariables>(GetTeamForInvitePageDocument, options);
      }
export function useGetTeamForInvitePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamForInvitePageQuery, GetTeamForInvitePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamForInvitePageQuery, GetTeamForInvitePageQueryVariables>(GetTeamForInvitePageDocument, options);
        }
export type GetTeamForInvitePageQueryHookResult = ReturnType<typeof useGetTeamForInvitePageQuery>;
export type GetTeamForInvitePageLazyQueryHookResult = ReturnType<typeof useGetTeamForInvitePageLazyQuery>;
export type GetTeamForInvitePageQueryResult = Apollo.QueryResult<GetTeamForInvitePageQuery, GetTeamForInvitePageQueryVariables>;
export const GetTeamProfileForInvitePageDocument = gql`
    query getTeamProfileForInvitePage($id: String!) {
  account(id: $id) {
    ...TeamProfile
  }
}
    ${TeamProfileFragmentDoc}`;

/**
 * __useGetTeamProfileForInvitePageQuery__
 *
 * To run a query within a React component, call `useGetTeamProfileForInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamProfileForInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamProfileForInvitePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamProfileForInvitePageQuery(baseOptions: Apollo.QueryHookOptions<GetTeamProfileForInvitePageQuery, GetTeamProfileForInvitePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamProfileForInvitePageQuery, GetTeamProfileForInvitePageQueryVariables>(GetTeamProfileForInvitePageDocument, options);
      }
export function useGetTeamProfileForInvitePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamProfileForInvitePageQuery, GetTeamProfileForInvitePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamProfileForInvitePageQuery, GetTeamProfileForInvitePageQueryVariables>(GetTeamProfileForInvitePageDocument, options);
        }
export type GetTeamProfileForInvitePageQueryHookResult = ReturnType<typeof useGetTeamProfileForInvitePageQuery>;
export type GetTeamProfileForInvitePageLazyQueryHookResult = ReturnType<typeof useGetTeamProfileForInvitePageLazyQuery>;
export type GetTeamProfileForInvitePageQueryResult = Apollo.QueryResult<GetTeamProfileForInvitePageQuery, GetTeamProfileForInvitePageQueryVariables>;
export const JoinEventByInviteDocument = gql`
    mutation joinEventByInvite($inviteCode: String!, $userId: String!) {
  joinEventByInvite(inviteCode: $inviteCode, userId: $userId)
}
    `;
export type JoinEventByInviteMutationFn = Apollo.MutationFunction<JoinEventByInviteMutation, JoinEventByInviteMutationVariables>;

/**
 * __useJoinEventByInviteMutation__
 *
 * To run a mutation, you first call `useJoinEventByInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinEventByInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinEventByInviteMutation, { data, loading, error }] = useJoinEventByInviteMutation({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useJoinEventByInviteMutation(baseOptions?: Apollo.MutationHookOptions<JoinEventByInviteMutation, JoinEventByInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinEventByInviteMutation, JoinEventByInviteMutationVariables>(JoinEventByInviteDocument, options);
      }
export type JoinEventByInviteMutationHookResult = ReturnType<typeof useJoinEventByInviteMutation>;
export type JoinEventByInviteMutationResult = Apollo.MutationResult<JoinEventByInviteMutation>;
export type JoinEventByInviteMutationOptions = Apollo.BaseMutationOptions<JoinEventByInviteMutation, JoinEventByInviteMutationVariables>;
export const JoinTeamByInviteDocument = gql`
    mutation joinTeamByInvite($inviteCode: String!, $accountId: String!) {
  joinGroupTraitByInvite(code: $inviteCode, accountId: $accountId) {
    id
  }
}
    `;
export type JoinTeamByInviteMutationFn = Apollo.MutationFunction<JoinTeamByInviteMutation, JoinTeamByInviteMutationVariables>;

/**
 * __useJoinTeamByInviteMutation__
 *
 * To run a mutation, you first call `useJoinTeamByInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinTeamByInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinTeamByInviteMutation, { data, loading, error }] = useJoinTeamByInviteMutation({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useJoinTeamByInviteMutation(baseOptions?: Apollo.MutationHookOptions<JoinTeamByInviteMutation, JoinTeamByInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinTeamByInviteMutation, JoinTeamByInviteMutationVariables>(JoinTeamByInviteDocument, options);
      }
export type JoinTeamByInviteMutationHookResult = ReturnType<typeof useJoinTeamByInviteMutation>;
export type JoinTeamByInviteMutationResult = Apollo.MutationResult<JoinTeamByInviteMutation>;
export type JoinTeamByInviteMutationOptions = Apollo.BaseMutationOptions<JoinTeamByInviteMutation, JoinTeamByInviteMutationVariables>;
export const DeleteGroupAvatarDocument = gql`
    mutation deleteGroupAvatar($groupId: String!) {
  updateGroup(id: $groupId, updateGroupRequest: {removeAvatarURL: true}) {
    id
    bannerURL
  }
}
    `;
export type DeleteGroupAvatarMutationFn = Apollo.MutationFunction<DeleteGroupAvatarMutation, DeleteGroupAvatarMutationVariables>;

/**
 * __useDeleteGroupAvatarMutation__
 *
 * To run a mutation, you first call `useDeleteGroupAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupAvatarMutation, { data, loading, error }] = useDeleteGroupAvatarMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteGroupAvatarMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupAvatarMutation, DeleteGroupAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupAvatarMutation, DeleteGroupAvatarMutationVariables>(DeleteGroupAvatarDocument, options);
      }
export type DeleteGroupAvatarMutationHookResult = ReturnType<typeof useDeleteGroupAvatarMutation>;
export type DeleteGroupAvatarMutationResult = Apollo.MutationResult<DeleteGroupAvatarMutation>;
export type DeleteGroupAvatarMutationOptions = Apollo.BaseMutationOptions<DeleteGroupAvatarMutation, DeleteGroupAvatarMutationVariables>;
export const DeleteGroupBannerDocument = gql`
    mutation deleteGroupBanner($groupId: String!) {
  updateGroup(id: $groupId, updateGroupRequest: {removeBannerURL: true}) {
    id
    bannerURL
  }
}
    `;
export type DeleteGroupBannerMutationFn = Apollo.MutationFunction<DeleteGroupBannerMutation, DeleteGroupBannerMutationVariables>;

/**
 * __useDeleteGroupBannerMutation__
 *
 * To run a mutation, you first call `useDeleteGroupBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupBannerMutation, { data, loading, error }] = useDeleteGroupBannerMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteGroupBannerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupBannerMutation, DeleteGroupBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupBannerMutation, DeleteGroupBannerMutationVariables>(DeleteGroupBannerDocument, options);
      }
export type DeleteGroupBannerMutationHookResult = ReturnType<typeof useDeleteGroupBannerMutation>;
export type DeleteGroupBannerMutationResult = Apollo.MutationResult<DeleteGroupBannerMutation>;
export type DeleteGroupBannerMutationOptions = Apollo.BaseMutationOptions<DeleteGroupBannerMutation, DeleteGroupBannerMutationVariables>;
export const AddTeamInviteCodeDocument = gql`
    mutation addTeamInviteCode($groupId: String!, $accountId: String!) {
  addInviteCode(groupId: $groupId, accountId: $accountId) {
    code
    expiry
  }
}
    `;
export type AddTeamInviteCodeMutationFn = Apollo.MutationFunction<AddTeamInviteCodeMutation, AddTeamInviteCodeMutationVariables>;

/**
 * __useAddTeamInviteCodeMutation__
 *
 * To run a mutation, you first call `useAddTeamInviteCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamInviteCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamInviteCodeMutation, { data, loading, error }] = useAddTeamInviteCodeMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAddTeamInviteCodeMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamInviteCodeMutation, AddTeamInviteCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamInviteCodeMutation, AddTeamInviteCodeMutationVariables>(AddTeamInviteCodeDocument, options);
      }
export type AddTeamInviteCodeMutationHookResult = ReturnType<typeof useAddTeamInviteCodeMutation>;
export type AddTeamInviteCodeMutationResult = Apollo.MutationResult<AddTeamInviteCodeMutation>;
export type AddTeamInviteCodeMutationOptions = Apollo.BaseMutationOptions<AddTeamInviteCodeMutation, AddTeamInviteCodeMutationVariables>;
export const PromoteToGroupAdminDocument = gql`
    mutation promoteToGroupAdmin($groupId: String!, $accountId: String!, $roleAlias: String) {
  promoteToGroupAdmin(
    groupId: $groupId
    accountId: $accountId
    roleAlias: $roleAlias
  ) {
    ...ChangeRolesMutationResponse
  }
}
    ${ChangeRolesMutationResponseFragmentDoc}`;
export type PromoteToGroupAdminMutationFn = Apollo.MutationFunction<PromoteToGroupAdminMutation, PromoteToGroupAdminMutationVariables>;

/**
 * __usePromoteToGroupAdminMutation__
 *
 * To run a mutation, you first call `usePromoteToGroupAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteToGroupAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteToGroupAdminMutation, { data, loading, error }] = usePromoteToGroupAdminMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      accountId: // value for 'accountId'
 *      roleAlias: // value for 'roleAlias'
 *   },
 * });
 */
export function usePromoteToGroupAdminMutation(baseOptions?: Apollo.MutationHookOptions<PromoteToGroupAdminMutation, PromoteToGroupAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoteToGroupAdminMutation, PromoteToGroupAdminMutationVariables>(PromoteToGroupAdminDocument, options);
      }
export type PromoteToGroupAdminMutationHookResult = ReturnType<typeof usePromoteToGroupAdminMutation>;
export type PromoteToGroupAdminMutationResult = Apollo.MutationResult<PromoteToGroupAdminMutation>;
export type PromoteToGroupAdminMutationOptions = Apollo.BaseMutationOptions<PromoteToGroupAdminMutation, PromoteToGroupAdminMutationVariables>;
export const RemoveMemberFromGroupDocument = gql`
    mutation removeMemberFromGroup($groupId: String!, $accountId: String!) {
  removeMemberFromGroup(groupId: $groupId, accountId: $accountId) {
    ...ChangeRolesMutationResponse
  }
}
    ${ChangeRolesMutationResponseFragmentDoc}`;
export type RemoveMemberFromGroupMutationFn = Apollo.MutationFunction<RemoveMemberFromGroupMutation, RemoveMemberFromGroupMutationVariables>;

/**
 * __useRemoveMemberFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveMemberFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberFromGroupMutation, { data, loading, error }] = useRemoveMemberFromGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRemoveMemberFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberFromGroupMutation, RemoveMemberFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberFromGroupMutation, RemoveMemberFromGroupMutationVariables>(RemoveMemberFromGroupDocument, options);
      }
export type RemoveMemberFromGroupMutationHookResult = ReturnType<typeof useRemoveMemberFromGroupMutation>;
export type RemoveMemberFromGroupMutationResult = Apollo.MutationResult<RemoveMemberFromGroupMutation>;
export type RemoveMemberFromGroupMutationOptions = Apollo.BaseMutationOptions<RemoveMemberFromGroupMutation, RemoveMemberFromGroupMutationVariables>;
export const RemoveRolesFromGroupMemberDocument = gql`
    mutation removeRolesFromGroupMember($groupId: String!, $accountId: String!, $roleIds: [String!]!) {
  removeRolesFromGroupMember(
    groupId: $groupId
    accountId: $accountId
    roleIds: $roleIds
  ) {
    ...ChangeRolesMutationResponse
  }
}
    ${ChangeRolesMutationResponseFragmentDoc}`;
export type RemoveRolesFromGroupMemberMutationFn = Apollo.MutationFunction<RemoveRolesFromGroupMemberMutation, RemoveRolesFromGroupMemberMutationVariables>;

/**
 * __useRemoveRolesFromGroupMemberMutation__
 *
 * To run a mutation, you first call `useRemoveRolesFromGroupMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRolesFromGroupMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRolesFromGroupMemberMutation, { data, loading, error }] = useRemoveRolesFromGroupMemberMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      accountId: // value for 'accountId'
 *      roleIds: // value for 'roleIds'
 *   },
 * });
 */
export function useRemoveRolesFromGroupMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRolesFromGroupMemberMutation, RemoveRolesFromGroupMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRolesFromGroupMemberMutation, RemoveRolesFromGroupMemberMutationVariables>(RemoveRolesFromGroupMemberDocument, options);
      }
export type RemoveRolesFromGroupMemberMutationHookResult = ReturnType<typeof useRemoveRolesFromGroupMemberMutation>;
export type RemoveRolesFromGroupMemberMutationResult = Apollo.MutationResult<RemoveRolesFromGroupMemberMutation>;
export type RemoveRolesFromGroupMemberMutationOptions = Apollo.BaseMutationOptions<RemoveRolesFromGroupMemberMutation, RemoveRolesFromGroupMemberMutationVariables>;
export const ReplaceGroupOwnerDocument = gql`
    mutation replaceGroupOwner($groupId: String!, $ownerId: String!, $accountId: String!, $roleAlias: String) {
  replaceGroupOwner(
    groupId: $groupId
    ownerId: $ownerId
    accountId: $accountId
    roleAlias: $roleAlias
  ) {
    ...ChangeRolesMutationResponse
  }
}
    ${ChangeRolesMutationResponseFragmentDoc}`;
export type ReplaceGroupOwnerMutationFn = Apollo.MutationFunction<ReplaceGroupOwnerMutation, ReplaceGroupOwnerMutationVariables>;

/**
 * __useReplaceGroupOwnerMutation__
 *
 * To run a mutation, you first call `useReplaceGroupOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceGroupOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceGroupOwnerMutation, { data, loading, error }] = useReplaceGroupOwnerMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      ownerId: // value for 'ownerId'
 *      accountId: // value for 'accountId'
 *      roleAlias: // value for 'roleAlias'
 *   },
 * });
 */
export function useReplaceGroupOwnerMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceGroupOwnerMutation, ReplaceGroupOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceGroupOwnerMutation, ReplaceGroupOwnerMutationVariables>(ReplaceGroupOwnerDocument, options);
      }
export type ReplaceGroupOwnerMutationHookResult = ReturnType<typeof useReplaceGroupOwnerMutation>;
export type ReplaceGroupOwnerMutationResult = Apollo.MutationResult<ReplaceGroupOwnerMutation>;
export type ReplaceGroupOwnerMutationOptions = Apollo.BaseMutationOptions<ReplaceGroupOwnerMutation, ReplaceGroupOwnerMutationVariables>;
export const InviteToGroupDocument = gql`
    mutation inviteToGroup($groupId: String!, $accountId: String!) {
  inviteToGroup(groupId: $groupId, accountId: $accountId) {
    id
  }
}
    `;
export type InviteToGroupMutationFn = Apollo.MutationFunction<InviteToGroupMutation, InviteToGroupMutationVariables>;

/**
 * __useInviteToGroupMutation__
 *
 * To run a mutation, you first call `useInviteToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToGroupMutation, { data, loading, error }] = useInviteToGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useInviteToGroupMutation(baseOptions?: Apollo.MutationHookOptions<InviteToGroupMutation, InviteToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteToGroupMutation, InviteToGroupMutationVariables>(InviteToGroupDocument, options);
      }
export type InviteToGroupMutationHookResult = ReturnType<typeof useInviteToGroupMutation>;
export type InviteToGroupMutationResult = Apollo.MutationResult<InviteToGroupMutation>;
export type InviteToGroupMutationOptions = Apollo.BaseMutationOptions<InviteToGroupMutation, InviteToGroupMutationVariables>;
export const UserSuggestionsDocument = gql`
    query userSuggestions($displayNamePrefix: String!) {
  userSuggestions(displayNamePrefix: $displayNamePrefix) {
    ...AccountProjection
  }
}
    ${AccountProjectionFragmentDoc}`;

/**
 * __useUserSuggestionsQuery__
 *
 * To run a query within a React component, call `useUserSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSuggestionsQuery({
 *   variables: {
 *      displayNamePrefix: // value for 'displayNamePrefix'
 *   },
 * });
 */
export function useUserSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<UserSuggestionsQuery, UserSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSuggestionsQuery, UserSuggestionsQueryVariables>(UserSuggestionsDocument, options);
      }
export function useUserSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSuggestionsQuery, UserSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSuggestionsQuery, UserSuggestionsQueryVariables>(UserSuggestionsDocument, options);
        }
export type UserSuggestionsQueryHookResult = ReturnType<typeof useUserSuggestionsQuery>;
export type UserSuggestionsLazyQueryHookResult = ReturnType<typeof useUserSuggestionsLazyQuery>;
export type UserSuggestionsQueryResult = Apollo.QueryResult<UserSuggestionsQuery, UserSuggestionsQueryVariables>;
export const UpdateTeamDocument = gql`
    mutation updateTeam($id: String!, $updateTeamRequest: TeamUpdateRequest!) {
  updateTeam(id: $id, updateTeamRequest: $updateTeamRequest) {
    id
    name
    description
    bannerURL
    avatarURL
    created
    updated
    ownerId
    groupType
    accountType
    socialLinks {
      link
      socialLinkType
    }
    publicURL
  }
}
    `;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateTeamRequest: // value for 'updateTeamRequest'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const AcceptAllGroupInvitationsDocument = gql`
    mutation acceptAllGroupInvitations($accountId: String!) {
  acceptAllGroupInvitations(accountId: $accountId) {
    id
    groupMemberships {
      ...GroupMembership
    }
    groupInvites {
      ...GroupInviteWithPossibleError
    }
  }
}
    ${GroupMembershipFragmentDoc}
${GroupInviteWithPossibleErrorFragmentDoc}`;
export type AcceptAllGroupInvitationsMutationFn = Apollo.MutationFunction<AcceptAllGroupInvitationsMutation, AcceptAllGroupInvitationsMutationVariables>;

/**
 * __useAcceptAllGroupInvitationsMutation__
 *
 * To run a mutation, you first call `useAcceptAllGroupInvitationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAllGroupInvitationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAllGroupInvitationsMutation, { data, loading, error }] = useAcceptAllGroupInvitationsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAcceptAllGroupInvitationsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptAllGroupInvitationsMutation, AcceptAllGroupInvitationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptAllGroupInvitationsMutation, AcceptAllGroupInvitationsMutationVariables>(AcceptAllGroupInvitationsDocument, options);
      }
export type AcceptAllGroupInvitationsMutationHookResult = ReturnType<typeof useAcceptAllGroupInvitationsMutation>;
export type AcceptAllGroupInvitationsMutationResult = Apollo.MutationResult<AcceptAllGroupInvitationsMutation>;
export type AcceptAllGroupInvitationsMutationOptions = Apollo.BaseMutationOptions<AcceptAllGroupInvitationsMutation, AcceptAllGroupInvitationsMutationVariables>;
export const AcceptGroupInvitationDocument = gql`
    mutation acceptGroupInvitation($groupId: String!, $accountId: String!) {
  acceptGroupInvitation(groupId: $groupId, accountId: $accountId) {
    id
    groupMemberships {
      ...GroupMembership
    }
    groupInvites {
      ...GroupInviteWithPossibleError
    }
  }
}
    ${GroupMembershipFragmentDoc}
${GroupInviteWithPossibleErrorFragmentDoc}`;
export type AcceptGroupInvitationMutationFn = Apollo.MutationFunction<AcceptGroupInvitationMutation, AcceptGroupInvitationMutationVariables>;

/**
 * __useAcceptGroupInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptGroupInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptGroupInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptGroupInvitationMutation, { data, loading, error }] = useAcceptGroupInvitationMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAcceptGroupInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptGroupInvitationMutation, AcceptGroupInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptGroupInvitationMutation, AcceptGroupInvitationMutationVariables>(AcceptGroupInvitationDocument, options);
      }
export type AcceptGroupInvitationMutationHookResult = ReturnType<typeof useAcceptGroupInvitationMutation>;
export type AcceptGroupInvitationMutationResult = Apollo.MutationResult<AcceptGroupInvitationMutation>;
export type AcceptGroupInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptGroupInvitationMutation, AcceptGroupInvitationMutationVariables>;
export const DeclineAllGroupInvitationsDocument = gql`
    mutation declineAllGroupInvitations($accountId: String!) {
  declineAllGroupInvitations(accountId: $accountId) {
    id
    groupMemberships {
      ...GroupMembership
    }
    groupInvites {
      ...GroupInviteWithPossibleError
    }
  }
}
    ${GroupMembershipFragmentDoc}
${GroupInviteWithPossibleErrorFragmentDoc}`;
export type DeclineAllGroupInvitationsMutationFn = Apollo.MutationFunction<DeclineAllGroupInvitationsMutation, DeclineAllGroupInvitationsMutationVariables>;

/**
 * __useDeclineAllGroupInvitationsMutation__
 *
 * To run a mutation, you first call `useDeclineAllGroupInvitationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineAllGroupInvitationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineAllGroupInvitationsMutation, { data, loading, error }] = useDeclineAllGroupInvitationsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeclineAllGroupInvitationsMutation(baseOptions?: Apollo.MutationHookOptions<DeclineAllGroupInvitationsMutation, DeclineAllGroupInvitationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineAllGroupInvitationsMutation, DeclineAllGroupInvitationsMutationVariables>(DeclineAllGroupInvitationsDocument, options);
      }
export type DeclineAllGroupInvitationsMutationHookResult = ReturnType<typeof useDeclineAllGroupInvitationsMutation>;
export type DeclineAllGroupInvitationsMutationResult = Apollo.MutationResult<DeclineAllGroupInvitationsMutation>;
export type DeclineAllGroupInvitationsMutationOptions = Apollo.BaseMutationOptions<DeclineAllGroupInvitationsMutation, DeclineAllGroupInvitationsMutationVariables>;
export const DeclineGroupInvitationDocument = gql`
    mutation declineGroupInvitation($groupId: String!, $accountId: String!) {
  declineGroupInvitation(groupId: $groupId, accountId: $accountId) {
    id
    groupMemberships {
      ...GroupMembership
    }
    groupInvites {
      ...GroupInviteWithPossibleError
    }
  }
}
    ${GroupMembershipFragmentDoc}
${GroupInviteWithPossibleErrorFragmentDoc}`;
export type DeclineGroupInvitationMutationFn = Apollo.MutationFunction<DeclineGroupInvitationMutation, DeclineGroupInvitationMutationVariables>;

/**
 * __useDeclineGroupInvitationMutation__
 *
 * To run a mutation, you first call `useDeclineGroupInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineGroupInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineGroupInvitationMutation, { data, loading, error }] = useDeclineGroupInvitationMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeclineGroupInvitationMutation(baseOptions?: Apollo.MutationHookOptions<DeclineGroupInvitationMutation, DeclineGroupInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineGroupInvitationMutation, DeclineGroupInvitationMutationVariables>(DeclineGroupInvitationDocument, options);
      }
export type DeclineGroupInvitationMutationHookResult = ReturnType<typeof useDeclineGroupInvitationMutation>;
export type DeclineGroupInvitationMutationResult = Apollo.MutationResult<DeclineGroupInvitationMutation>;
export type DeclineGroupInvitationMutationOptions = Apollo.BaseMutationOptions<DeclineGroupInvitationMutation, DeclineGroupInvitationMutationVariables>;
export const NewTeamInvitationDocument = gql`
    subscription NewTeamInvitation($notificationType: String!, $targetId: String!) {
  ClientNotification(
    notificationType: $notificationType
    maybeTargetId: $targetId
  ) {
    id
    created
    expiry
    defaultMessage
    notificationType
    ... on ClientNotificationEvent {
      targetId
      fields
    }
  }
}
    `;

/**
 * __useNewTeamInvitationSubscription__
 *
 * To run a query within a React component, call `useNewTeamInvitationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewTeamInvitationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewTeamInvitationSubscription({
 *   variables: {
 *      notificationType: // value for 'notificationType'
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useNewTeamInvitationSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewTeamInvitationSubscription, NewTeamInvitationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewTeamInvitationSubscription, NewTeamInvitationSubscriptionVariables>(NewTeamInvitationDocument, options);
      }
export type NewTeamInvitationSubscriptionHookResult = ReturnType<typeof useNewTeamInvitationSubscription>;
export type NewTeamInvitationSubscriptionResult = Apollo.SubscriptionResult<NewTeamInvitationSubscription>;
export const MyTeamsDocument = gql`
    query myTeams($id: String!) {
  user(id: $id) {
    id
    groupMemberships {
      ...GroupMembership
    }
    groupInvites {
      ...GroupInviteWithPossibleError
    }
  }
}
    ${GroupMembershipFragmentDoc}
${GroupInviteWithPossibleErrorFragmentDoc}`;

/**
 * __useMyTeamsQuery__
 *
 * To run a query within a React component, call `useMyTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyTeamsQuery(baseOptions: Apollo.QueryHookOptions<MyTeamsQuery, MyTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamsQuery, MyTeamsQueryVariables>(MyTeamsDocument, options);
      }
export function useMyTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamsQuery, MyTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamsQuery, MyTeamsQueryVariables>(MyTeamsDocument, options);
        }
export type MyTeamsQueryHookResult = ReturnType<typeof useMyTeamsQuery>;
export type MyTeamsLazyQueryHookResult = ReturnType<typeof useMyTeamsLazyQuery>;
export type MyTeamsQueryResult = Apollo.QueryResult<MyTeamsQuery, MyTeamsQueryVariables>;
export const GetUserProfileDocument = gql`
    query getUserProfile($idOrPublicURL: String!) {
  user(id: $idOrPublicURL) {
    ...PublicUser
  }
  accountByPublicURL(publicURL: $idOrPublicURL) {
    ...PublicUser
  }
}
    ${PublicUserFragmentDoc}`;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *      idOrPublicURL: // value for 'idOrPublicURL'
 *   },
 * });
 */
export function useGetUserProfileQuery(baseOptions: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
      }
export function useGetUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(GetUserProfileDocument, options);
        }
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileQueryResult = Apollo.QueryResult<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const MyProfileDocument = gql`
    query myProfile($id: String!) {
  user(id: $id) {
    id
    avatarURL
    bannerURL
    description
    displayName
    socialLinks {
      socialLinkType
      link
    }
    groupMemberships {
      id
      group {
        id
        name
        avatarURL
        publicURL
      }
    }
    ... on Person {
      isVIP
    }
  }
}
    `;

/**
 * __useMyProfileQuery__
 *
 * To run a query within a React component, call `useMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyProfileQuery(baseOptions: Apollo.QueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
      }
export function useMyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
        }
export type MyProfileQueryHookResult = ReturnType<typeof useMyProfileQuery>;
export type MyProfileLazyQueryHookResult = ReturnType<typeof useMyProfileLazyQuery>;
export type MyProfileQueryResult = Apollo.QueryResult<MyProfileQuery, MyProfileQueryVariables>;
export const GetEventsForSeriesDocument = gql`
    query getEventsForSeries($locale: Locale!) {
  eventsByTags(eventTagsFilter: {names: ["series"]}) {
    ...AllEventsEvent
  }
}
    ${AllEventsEventFragmentDoc}`;

/**
 * __useGetEventsForSeriesQuery__
 *
 * To run a query within a React component, call `useGetEventsForSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsForSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsForSeriesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetEventsForSeriesQuery(baseOptions: Apollo.QueryHookOptions<GetEventsForSeriesQuery, GetEventsForSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsForSeriesQuery, GetEventsForSeriesQueryVariables>(GetEventsForSeriesDocument, options);
      }
export function useGetEventsForSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsForSeriesQuery, GetEventsForSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsForSeriesQuery, GetEventsForSeriesQueryVariables>(GetEventsForSeriesDocument, options);
        }
export type GetEventsForSeriesQueryHookResult = ReturnType<typeof useGetEventsForSeriesQuery>;
export type GetEventsForSeriesLazyQueryHookResult = ReturnType<typeof useGetEventsForSeriesLazyQuery>;
export type GetEventsForSeriesQueryResult = Apollo.QueryResult<GetEventsForSeriesQuery, GetEventsForSeriesQueryVariables>;
export const AllActivePublicServersDocument = gql`
    query allActivePublicServers($featured: Boolean) {
  allActivePublicServers(featured: $featured) {
    ...PublicGameServer
  }
}
    ${PublicGameServerFragmentDoc}`;

/**
 * __useAllActivePublicServersQuery__
 *
 * To run a query within a React component, call `useAllActivePublicServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActivePublicServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActivePublicServersQuery({
 *   variables: {
 *      featured: // value for 'featured'
 *   },
 * });
 */
export function useAllActivePublicServersQuery(baseOptions?: Apollo.QueryHookOptions<AllActivePublicServersQuery, AllActivePublicServersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllActivePublicServersQuery, AllActivePublicServersQueryVariables>(AllActivePublicServersDocument, options);
      }
export function useAllActivePublicServersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllActivePublicServersQuery, AllActivePublicServersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllActivePublicServersQuery, AllActivePublicServersQueryVariables>(AllActivePublicServersDocument, options);
        }
export type AllActivePublicServersQueryHookResult = ReturnType<typeof useAllActivePublicServersQuery>;
export type AllActivePublicServersLazyQueryHookResult = ReturnType<typeof useAllActivePublicServersLazyQuery>;
export type AllActivePublicServersQueryResult = Apollo.QueryResult<AllActivePublicServersQuery, AllActivePublicServersQueryVariables>;
export const GetUserAvatarDocument = gql`
    query getUserAvatar($id: String!) {
  user(id: $id) {
    avatarURL
    bannerURL
    id
  }
}
    `;

/**
 * __useGetUserAvatarQuery__
 *
 * To run a query within a React component, call `useGetUserAvatarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAvatarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAvatarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserAvatarQuery(baseOptions: Apollo.QueryHookOptions<GetUserAvatarQuery, GetUserAvatarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAvatarQuery, GetUserAvatarQueryVariables>(GetUserAvatarDocument, options);
      }
export function useGetUserAvatarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAvatarQuery, GetUserAvatarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAvatarQuery, GetUserAvatarQueryVariables>(GetUserAvatarDocument, options);
        }
export type GetUserAvatarQueryHookResult = ReturnType<typeof useGetUserAvatarQuery>;
export type GetUserAvatarLazyQueryHookResult = ReturnType<typeof useGetUserAvatarLazyQuery>;
export type GetUserAvatarQueryResult = Apollo.QueryResult<GetUserAvatarQuery, GetUserAvatarQueryVariables>;
export const UnlinkIdentityProviderDocument = gql`
    mutation unlinkIdentityProvider($IdentityProviderType: IdentityProviderType!, $userId: String!) {
  unlinkIdentityProvider(
    IdentityProviderType: $IdentityProviderType
    userId: $userId
  ) {
    id
    ...LinkedAccounts
  }
}
    ${LinkedAccountsFragmentDoc}`;
export type UnlinkIdentityProviderMutationFn = Apollo.MutationFunction<UnlinkIdentityProviderMutation, UnlinkIdentityProviderMutationVariables>;

/**
 * __useUnlinkIdentityProviderMutation__
 *
 * To run a mutation, you first call `useUnlinkIdentityProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkIdentityProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkIdentityProviderMutation, { data, loading, error }] = useUnlinkIdentityProviderMutation({
 *   variables: {
 *      IdentityProviderType: // value for 'IdentityProviderType'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnlinkIdentityProviderMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkIdentityProviderMutation, UnlinkIdentityProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkIdentityProviderMutation, UnlinkIdentityProviderMutationVariables>(UnlinkIdentityProviderDocument, options);
      }
export type UnlinkIdentityProviderMutationHookResult = ReturnType<typeof useUnlinkIdentityProviderMutation>;
export type UnlinkIdentityProviderMutationResult = Apollo.MutationResult<UnlinkIdentityProviderMutation>;
export type UnlinkIdentityProviderMutationOptions = Apollo.BaseMutationOptions<UnlinkIdentityProviderMutation, UnlinkIdentityProviderMutationVariables>;
export const DeleteUserAvatarDocument = gql`
    mutation deleteUserAvatar($userId: String!) {
  updatePerson(id: $userId, personUpdateRequest: {removeAvatarURL: true}) {
    id
    avatarURL
  }
}
    `;
export type DeleteUserAvatarMutationFn = Apollo.MutationFunction<DeleteUserAvatarMutation, DeleteUserAvatarMutationVariables>;

/**
 * __useDeleteUserAvatarMutation__
 *
 * To run a mutation, you first call `useDeleteUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserAvatarMutation, { data, loading, error }] = useDeleteUserAvatarMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserAvatarMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserAvatarMutation, DeleteUserAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserAvatarMutation, DeleteUserAvatarMutationVariables>(DeleteUserAvatarDocument, options);
      }
export type DeleteUserAvatarMutationHookResult = ReturnType<typeof useDeleteUserAvatarMutation>;
export type DeleteUserAvatarMutationResult = Apollo.MutationResult<DeleteUserAvatarMutation>;
export type DeleteUserAvatarMutationOptions = Apollo.BaseMutationOptions<DeleteUserAvatarMutation, DeleteUserAvatarMutationVariables>;
export const DeleteUserBannerDocument = gql`
    mutation deleteUserBanner($userId: String!) {
  updatePerson(id: $userId, personUpdateRequest: {removeBannerURL: true}) {
    id
    avatarURL
  }
}
    `;
export type DeleteUserBannerMutationFn = Apollo.MutationFunction<DeleteUserBannerMutation, DeleteUserBannerMutationVariables>;

/**
 * __useDeleteUserBannerMutation__
 *
 * To run a mutation, you first call `useDeleteUserBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserBannerMutation, { data, loading, error }] = useDeleteUserBannerMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserBannerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserBannerMutation, DeleteUserBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserBannerMutation, DeleteUserBannerMutationVariables>(DeleteUserBannerDocument, options);
      }
export type DeleteUserBannerMutationHookResult = ReturnType<typeof useDeleteUserBannerMutation>;
export type DeleteUserBannerMutationResult = Apollo.MutationResult<DeleteUserBannerMutation>;
export type DeleteUserBannerMutationOptions = Apollo.BaseMutationOptions<DeleteUserBannerMutation, DeleteUserBannerMutationVariables>;
export const MySettingsDocument = gql`
    query mySettings($id: String!) {
  user(id: $id) {
    id
    email {
      ... on StringAttribute {
        value
      }
      isError
    }
    displayName
    avatarURL
    description
    bannerURL
    publicURL
    socialLinks {
      socialLinkType
      link
    }
    ...LinkedAccounts
    ... on Person {
      msisdn {
        ... on StringAttribute {
          value
        }
        isError
      }
      msisdnVerified
      gameAccounts {
        ...GameAccount
      }
    }
  }
}
    ${LinkedAccountsFragmentDoc}
${GameAccountFragmentDoc}`;

/**
 * __useMySettingsQuery__
 *
 * To run a query within a React component, call `useMySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMySettingsQuery(baseOptions: Apollo.QueryHookOptions<MySettingsQuery, MySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySettingsQuery, MySettingsQueryVariables>(MySettingsDocument, options);
      }
export function useMySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySettingsQuery, MySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySettingsQuery, MySettingsQueryVariables>(MySettingsDocument, options);
        }
export type MySettingsQueryHookResult = ReturnType<typeof useMySettingsQuery>;
export type MySettingsLazyQueryHookResult = ReturnType<typeof useMySettingsLazyQuery>;
export type MySettingsQueryResult = Apollo.QueryResult<MySettingsQuery, MySettingsQueryVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($id: String!, $oldPassword: String!, $newPassword: String!) {
  updatePassword(
    userId: $id
    oldPassword: $oldPassword
    newPassword: $newPassword
  ) {
    id
  }
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: String!, $personUpdateRequest: PersonUpdateRequest!) {
  updatePerson(id: $id, personUpdateRequest: $personUpdateRequest) {
    id
    displayName
    publicURL
    description
    msisdn {
      ... on StringAttribute {
        value
      }
      isError
    }
    msisdnVerified
    socialLinks {
      socialLinkType
      link
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      personUpdateRequest: // value for 'personUpdateRequest'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetMyOrdersDocument = gql`
    query getMyOrders($accountId: String!) {
  account(id: $accountId) {
    id
    purchaseTransactions {
      ...PurchaseTransaction
    }
  }
}
    ${PurchaseTransactionFragmentDoc}`;

/**
 * __useGetMyOrdersQuery__
 *
 * To run a query within a React component, call `useGetMyOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrdersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetMyOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetMyOrdersQuery, GetMyOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOrdersQuery, GetMyOrdersQueryVariables>(GetMyOrdersDocument, options);
      }
export function useGetMyOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOrdersQuery, GetMyOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOrdersQuery, GetMyOrdersQueryVariables>(GetMyOrdersDocument, options);
        }
export type GetMyOrdersQueryHookResult = ReturnType<typeof useGetMyOrdersQuery>;
export type GetMyOrdersLazyQueryHookResult = ReturnType<typeof useGetMyOrdersLazyQuery>;
export type GetMyOrdersQueryResult = Apollo.QueryResult<GetMyOrdersQuery, GetMyOrdersQueryVariables>;
export const GetPayPurchaseTransactionDocument = gql`
    query getPayPurchaseTransaction($transactionId: String!) {
  getPayPurchaseTransaction(transactionId: $transactionId) {
    id
    created
    status
    itemId
    fields
    merchantPaymentMethodId
    merchantPaymentMethodType
    purchaserData {
      email
    }
    payment {
      id
      internalPaymentServiceId
      purchaseTransactionId
      externalPaymentServiceId
      paymentType
      amount
      currency
      received
    }
    order {
      ...RootCode_Order
    }
  }
}
    ${RootCode_OrderFragmentDoc}`;

/**
 * __useGetPayPurchaseTransactionQuery__
 *
 * To run a query within a React component, call `useGetPayPurchaseTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayPurchaseTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayPurchaseTransactionQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useGetPayPurchaseTransactionQuery(baseOptions: Apollo.QueryHookOptions<GetPayPurchaseTransactionQuery, GetPayPurchaseTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayPurchaseTransactionQuery, GetPayPurchaseTransactionQueryVariables>(GetPayPurchaseTransactionDocument, options);
      }
export function useGetPayPurchaseTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayPurchaseTransactionQuery, GetPayPurchaseTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayPurchaseTransactionQuery, GetPayPurchaseTransactionQueryVariables>(GetPayPurchaseTransactionDocument, options);
        }
export type GetPayPurchaseTransactionQueryHookResult = ReturnType<typeof useGetPayPurchaseTransactionQuery>;
export type GetPayPurchaseTransactionLazyQueryHookResult = ReturnType<typeof useGetPayPurchaseTransactionLazyQuery>;
export type GetPayPurchaseTransactionQueryResult = Apollo.QueryResult<GetPayPurchaseTransactionQuery, GetPayPurchaseTransactionQueryVariables>;
export const PurchaseTransactionDocument = gql`
    query purchaseTransaction($transactionId: String!) {
  purchaseTransaction(transactionId: $transactionId) {
    accountId
    itemId
    fields
    purchaseTransactionId
    status
    created
    order {
      ...RootCode_Order
    }
  }
}
    ${RootCode_OrderFragmentDoc}`;

/**
 * __usePurchaseTransactionQuery__
 *
 * To run a query within a React component, call `usePurchaseTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseTransactionQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function usePurchaseTransactionQuery(baseOptions: Apollo.QueryHookOptions<PurchaseTransactionQuery, PurchaseTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PurchaseTransactionQuery, PurchaseTransactionQueryVariables>(PurchaseTransactionDocument, options);
      }
export function usePurchaseTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseTransactionQuery, PurchaseTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PurchaseTransactionQuery, PurchaseTransactionQueryVariables>(PurchaseTransactionDocument, options);
        }
export type PurchaseTransactionQueryHookResult = ReturnType<typeof usePurchaseTransactionQuery>;
export type PurchaseTransactionLazyQueryHookResult = ReturnType<typeof usePurchaseTransactionLazyQuery>;
export type PurchaseTransactionQueryResult = Apollo.QueryResult<PurchaseTransactionQuery, PurchaseTransactionQueryVariables>;
export const ProductGroupItemsDocument = gql`
    query productGroupItems($partnerId: ID!, $productGroupId: ID!, $languageCode: String!) {
  partnerProductGroup(
    partnerId: $partnerId
    productGroupId: $productGroupId
    languageCode: $languageCode
  ) {
    name: displayName
    bannerImage
    description
    items {
      ...CatalogItem
    }
  }
}
    ${CatalogItemFragmentDoc}`;

/**
 * __useProductGroupItemsQuery__
 *
 * To run a query within a React component, call `useProductGroupItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductGroupItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductGroupItemsQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      productGroupId: // value for 'productGroupId'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useProductGroupItemsQuery(baseOptions: Apollo.QueryHookOptions<ProductGroupItemsQuery, ProductGroupItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductGroupItemsQuery, ProductGroupItemsQueryVariables>(ProductGroupItemsDocument, options);
      }
export function useProductGroupItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductGroupItemsQuery, ProductGroupItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductGroupItemsQuery, ProductGroupItemsQueryVariables>(ProductGroupItemsDocument, options);
        }
export type ProductGroupItemsQueryHookResult = ReturnType<typeof useProductGroupItemsQuery>;
export type ProductGroupItemsLazyQueryHookResult = ReturnType<typeof useProductGroupItemsLazyQuery>;
export type ProductGroupItemsQueryResult = Apollo.QueryResult<ProductGroupItemsQuery, ProductGroupItemsQueryVariables>;
export const CategoryProductGroupsDocument = gql`
    query categoryProductGroups($categoryId: ID!, $partnerId: ID!, $limit: Int!, $offset: Int!, $languageCode: String!) {
  categoryProductGroups(
    categoryId: $categoryId
    partnerId: $partnerId
    limit: $limit
    offset: $offset
    languageCode: $languageCode
  ) {
    totalPages
    totalProductGroups
    productGroups {
      ...ProductGroup
    }
    currentPage
  }
}
    ${ProductGroupFragmentDoc}`;

/**
 * __useCategoryProductGroupsQuery__
 *
 * To run a query within a React component, call `useCategoryProductGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryProductGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryProductGroupsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      partnerId: // value for 'partnerId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useCategoryProductGroupsQuery(baseOptions: Apollo.QueryHookOptions<CategoryProductGroupsQuery, CategoryProductGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryProductGroupsQuery, CategoryProductGroupsQueryVariables>(CategoryProductGroupsDocument, options);
      }
export function useCategoryProductGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryProductGroupsQuery, CategoryProductGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryProductGroupsQuery, CategoryProductGroupsQueryVariables>(CategoryProductGroupsDocument, options);
        }
export type CategoryProductGroupsQueryHookResult = ReturnType<typeof useCategoryProductGroupsQuery>;
export type CategoryProductGroupsLazyQueryHookResult = ReturnType<typeof useCategoryProductGroupsLazyQuery>;
export type CategoryProductGroupsQueryResult = Apollo.QueryResult<CategoryProductGroupsQuery, CategoryProductGroupsQueryVariables>;
export const CatalogItemDocument = gql`
    query catalogItem($partnerId: ID!, $itemId: ID!, $languageCode: String!) {
  catalogItem(partnerId: $partnerId, itemId: $itemId, languageCode: $languageCode) {
    ...CatalogItem
  }
}
    ${CatalogItemFragmentDoc}`;

/**
 * __useCatalogItemQuery__
 *
 * To run a query within a React component, call `useCatalogItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogItemQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      itemId: // value for 'itemId'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useCatalogItemQuery(baseOptions: Apollo.QueryHookOptions<CatalogItemQuery, CatalogItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogItemQuery, CatalogItemQueryVariables>(CatalogItemDocument, options);
      }
export function useCatalogItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogItemQuery, CatalogItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogItemQuery, CatalogItemQueryVariables>(CatalogItemDocument, options);
        }
export type CatalogItemQueryHookResult = ReturnType<typeof useCatalogItemQuery>;
export type CatalogItemLazyQueryHookResult = ReturnType<typeof useCatalogItemLazyQuery>;
export type CatalogItemQueryResult = Apollo.QueryResult<CatalogItemQuery, CatalogItemQueryVariables>;
export const CatalogItemsDocument = gql`
    query catalogItems($filter: CatalogFilterInput!, $limit: Int!, $offset: Int!, $partnerId: ID!, $sort: CatalogSortInput) {
  catalogItems(
    filter: $filter
    limit: $limit
    offset: $offset
    partnerId: $partnerId
    sort: $sort
  ) {
    totalPages
    totalItems
    items {
      ...CatalogItem
    }
    currentPage
  }
}
    ${CatalogItemFragmentDoc}`;

/**
 * __useCatalogItemsQuery__
 *
 * To run a query within a React component, call `useCatalogItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      partnerId: // value for 'partnerId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCatalogItemsQuery(baseOptions: Apollo.QueryHookOptions<CatalogItemsQuery, CatalogItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogItemsQuery, CatalogItemsQueryVariables>(CatalogItemsDocument, options);
      }
export function useCatalogItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogItemsQuery, CatalogItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogItemsQuery, CatalogItemsQueryVariables>(CatalogItemsDocument, options);
        }
export type CatalogItemsQueryHookResult = ReturnType<typeof useCatalogItemsQuery>;
export type CatalogItemsLazyQueryHookResult = ReturnType<typeof useCatalogItemsLazyQuery>;
export type CatalogItemsQueryResult = Apollo.QueryResult<CatalogItemsQuery, CatalogItemsQueryVariables>;
export const CategoryCatalogDocument = gql`
    query categoryCatalog($partnerId: ID!, $languageCode: String!) {
  categoryCatalog(partnerId: $partnerId, languageCode: $languageCode) {
    categories {
      ...StoreCategory
    }
  }
}
    ${StoreCategoryFragmentDoc}`;

/**
 * __useCategoryCatalogQuery__
 *
 * To run a query within a React component, call `useCategoryCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryCatalogQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useCategoryCatalogQuery(baseOptions: Apollo.QueryHookOptions<CategoryCatalogQuery, CategoryCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryCatalogQuery, CategoryCatalogQueryVariables>(CategoryCatalogDocument, options);
      }
export function useCategoryCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryCatalogQuery, CategoryCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryCatalogQuery, CategoryCatalogQueryVariables>(CategoryCatalogDocument, options);
        }
export type CategoryCatalogQueryHookResult = ReturnType<typeof useCategoryCatalogQuery>;
export type CategoryCatalogLazyQueryHookResult = ReturnType<typeof useCategoryCatalogLazyQuery>;
export type CategoryCatalogQueryResult = Apollo.QueryResult<CategoryCatalogQuery, CategoryCatalogQueryVariables>;
export const GetStoreMerchantPaymentMethodsDocument = gql`
    query getStoreMerchantPaymentMethods($amount: Float!, $currency: String!, $country: Int!) {
  getPaymentMethodsAvailableForMerchant(
    amount: $amount
    currency: $currency
    country: $country
  ) {
    id
    name
    paymentMethodType
    refundSupported
    imageUrl
    disabled
  }
}
    `;

/**
 * __useGetStoreMerchantPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetStoreMerchantPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreMerchantPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreMerchantPaymentMethodsQuery({
 *   variables: {
 *      amount: // value for 'amount'
 *      currency: // value for 'currency'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetStoreMerchantPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetStoreMerchantPaymentMethodsQuery, GetStoreMerchantPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoreMerchantPaymentMethodsQuery, GetStoreMerchantPaymentMethodsQueryVariables>(GetStoreMerchantPaymentMethodsDocument, options);
      }
export function useGetStoreMerchantPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoreMerchantPaymentMethodsQuery, GetStoreMerchantPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoreMerchantPaymentMethodsQuery, GetStoreMerchantPaymentMethodsQueryVariables>(GetStoreMerchantPaymentMethodsDocument, options);
        }
export type GetStoreMerchantPaymentMethodsQueryHookResult = ReturnType<typeof useGetStoreMerchantPaymentMethodsQuery>;
export type GetStoreMerchantPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetStoreMerchantPaymentMethodsLazyQuery>;
export type GetStoreMerchantPaymentMethodsQueryResult = Apollo.QueryResult<GetStoreMerchantPaymentMethodsQuery, GetStoreMerchantPaymentMethodsQueryVariables>;
export const ItemSearchSuggestionsDocument = gql`
    query itemSearchSuggestions($itemName: String!) {
  itemSearchSuggestions(key: $itemName)
}
    `;

/**
 * __useItemSearchSuggestionsQuery__
 *
 * To run a query within a React component, call `useItemSearchSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemSearchSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemSearchSuggestionsQuery({
 *   variables: {
 *      itemName: // value for 'itemName'
 *   },
 * });
 */
export function useItemSearchSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<ItemSearchSuggestionsQuery, ItemSearchSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemSearchSuggestionsQuery, ItemSearchSuggestionsQueryVariables>(ItemSearchSuggestionsDocument, options);
      }
export function useItemSearchSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemSearchSuggestionsQuery, ItemSearchSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemSearchSuggestionsQuery, ItemSearchSuggestionsQueryVariables>(ItemSearchSuggestionsDocument, options);
        }
export type ItemSearchSuggestionsQueryHookResult = ReturnType<typeof useItemSearchSuggestionsQuery>;
export type ItemSearchSuggestionsLazyQueryHookResult = ReturnType<typeof useItemSearchSuggestionsLazyQuery>;
export type ItemSearchSuggestionsQueryResult = Apollo.QueryResult<ItemSearchSuggestionsQuery, ItemSearchSuggestionsQueryVariables>;
export const PartnerProductGroupsDocument = gql`
    query partnerProductGroups($limit: Int! = 50, $offset: Int! = 0, $partnerId: ID!, $search: CatalogSearchInput, $sort: CatalogSortInput, $languageCode: String!) {
  partnerProductGroups(
    limit: $limit
    offset: $offset
    partnerId: $partnerId
    search: $search
    sort: $sort
    languageCode: $languageCode
  ) {
    productGroups {
      id
      productGroupId
      name
      displayName
      bannerImage
      thumbnail
      items {
        ...CatalogItem
      }
    }
    totalPages
    currentPage
    totalProductGroups
  }
}
    ${CatalogItemFragmentDoc}`;

/**
 * __usePartnerProductGroupsQuery__
 *
 * To run a query within a React component, call `usePartnerProductGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerProductGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerProductGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      partnerId: // value for 'partnerId'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function usePartnerProductGroupsQuery(baseOptions: Apollo.QueryHookOptions<PartnerProductGroupsQuery, PartnerProductGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerProductGroupsQuery, PartnerProductGroupsQueryVariables>(PartnerProductGroupsDocument, options);
      }
export function usePartnerProductGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerProductGroupsQuery, PartnerProductGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerProductGroupsQuery, PartnerProductGroupsQueryVariables>(PartnerProductGroupsDocument, options);
        }
export type PartnerProductGroupsQueryHookResult = ReturnType<typeof usePartnerProductGroupsQuery>;
export type PartnerProductGroupsLazyQueryHookResult = ReturnType<typeof usePartnerProductGroupsLazyQuery>;
export type PartnerProductGroupsQueryResult = Apollo.QueryResult<PartnerProductGroupsQuery, PartnerProductGroupsQueryVariables>;
export const PurchaseStoreItemWithPointsDocument = gql`
    mutation purchaseStoreItemWithPoints($gamerId: String, $gamerEmail: String, $gamerFirstName: String, $gamerLastName: String, $gamerAddress: String, $gamerIPAddress: String, $country: String, $gamerMobileNumber: String, $itemId: String!, $quantity: Int!, $tagId: String!, $fields: String) {
  purchaseExternalItemWithPoints(
    gamerId: $gamerId
    gamerEmail: $gamerEmail
    gamerFirstName: $gamerFirstName
    gamerLastName: $gamerLastName
    gamerAddress: $gamerAddress
    gamerIPAddress: $gamerIPAddress
    country: $country
    gamerMobileNumber: $gamerMobileNumber
    itemId: $itemId
    quantity: $quantity
    tagId: $tagId
    fields: $fields
  ) {
    id
    purchaseTransactions {
      ...PurchaseTransaction
    }
  }
}
    ${PurchaseTransactionFragmentDoc}`;
export type PurchaseStoreItemWithPointsMutationFn = Apollo.MutationFunction<PurchaseStoreItemWithPointsMutation, PurchaseStoreItemWithPointsMutationVariables>;

/**
 * __usePurchaseStoreItemWithPointsMutation__
 *
 * To run a mutation, you first call `usePurchaseStoreItemWithPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseStoreItemWithPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseStoreItemWithPointsMutation, { data, loading, error }] = usePurchaseStoreItemWithPointsMutation({
 *   variables: {
 *      gamerId: // value for 'gamerId'
 *      gamerEmail: // value for 'gamerEmail'
 *      gamerFirstName: // value for 'gamerFirstName'
 *      gamerLastName: // value for 'gamerLastName'
 *      gamerAddress: // value for 'gamerAddress'
 *      gamerIPAddress: // value for 'gamerIPAddress'
 *      country: // value for 'country'
 *      gamerMobileNumber: // value for 'gamerMobileNumber'
 *      itemId: // value for 'itemId'
 *      quantity: // value for 'quantity'
 *      tagId: // value for 'tagId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function usePurchaseStoreItemWithPointsMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseStoreItemWithPointsMutation, PurchaseStoreItemWithPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseStoreItemWithPointsMutation, PurchaseStoreItemWithPointsMutationVariables>(PurchaseStoreItemWithPointsDocument, options);
      }
export type PurchaseStoreItemWithPointsMutationHookResult = ReturnType<typeof usePurchaseStoreItemWithPointsMutation>;
export type PurchaseStoreItemWithPointsMutationResult = Apollo.MutationResult<PurchaseStoreItemWithPointsMutation>;
export type PurchaseStoreItemWithPointsMutationOptions = Apollo.BaseMutationOptions<PurchaseStoreItemWithPointsMutation, PurchaseStoreItemWithPointsMutationVariables>;
export const PurchaseStoreItemDocument = gql`
    mutation purchaseStoreItem($gamerId: String, $gamerEmail: String!, $gamerFirstName: String, $gamerLastName: String, $gamerAddress: String, $gamerIPAddress: String, $country: String, $gamerMobileNumber: String, $itemId: String!, $quantity: Int!, $tagId: String!, $fields: String, $merchantPaymentMethodType: String!, $merchantPaymentMethodId: String!, $maybeMaxitJWT: String) {
  purchaseExternalItem(
    gamerId: $gamerId
    gamerEmail: $gamerEmail
    gamerFirstName: $gamerFirstName
    gamerLastName: $gamerLastName
    gamerAddress: $gamerAddress
    gamerIPAddress: $gamerIPAddress
    country: $country
    gamerMobileNumber: $gamerMobileNumber
    itemId: $itemId
    quantity: $quantity
    tagId: $tagId
    fields: $fields
    merchantPaymentMethodId: $merchantPaymentMethodId
    merchantPaymentMethodType: $merchantPaymentMethodType
    maxitJWT: $maybeMaxitJWT
  ) {
    gatewaySessionId
    transactionId
  }
}
    `;
export type PurchaseStoreItemMutationFn = Apollo.MutationFunction<PurchaseStoreItemMutation, PurchaseStoreItemMutationVariables>;

/**
 * __usePurchaseStoreItemMutation__
 *
 * To run a mutation, you first call `usePurchaseStoreItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseStoreItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseStoreItemMutation, { data, loading, error }] = usePurchaseStoreItemMutation({
 *   variables: {
 *      gamerId: // value for 'gamerId'
 *      gamerEmail: // value for 'gamerEmail'
 *      gamerFirstName: // value for 'gamerFirstName'
 *      gamerLastName: // value for 'gamerLastName'
 *      gamerAddress: // value for 'gamerAddress'
 *      gamerIPAddress: // value for 'gamerIPAddress'
 *      country: // value for 'country'
 *      gamerMobileNumber: // value for 'gamerMobileNumber'
 *      itemId: // value for 'itemId'
 *      quantity: // value for 'quantity'
 *      tagId: // value for 'tagId'
 *      fields: // value for 'fields'
 *      merchantPaymentMethodType: // value for 'merchantPaymentMethodType'
 *      merchantPaymentMethodId: // value for 'merchantPaymentMethodId'
 *      maybeMaxitJWT: // value for 'maybeMaxitJWT'
 *   },
 * });
 */
export function usePurchaseStoreItemMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseStoreItemMutation, PurchaseStoreItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseStoreItemMutation, PurchaseStoreItemMutationVariables>(PurchaseStoreItemDocument, options);
      }
export type PurchaseStoreItemMutationHookResult = ReturnType<typeof usePurchaseStoreItemMutation>;
export type PurchaseStoreItemMutationResult = Apollo.MutationResult<PurchaseStoreItemMutation>;
export type PurchaseStoreItemMutationOptions = Apollo.BaseMutationOptions<PurchaseStoreItemMutation, PurchaseStoreItemMutationVariables>;
export const StoreBannersDocument = gql`
    query storeBanners {
  banners {
    id
    primaryImageUrl
    secondaryImageUrl
    redirectUrl
  }
}
    `;

/**
 * __useStoreBannersQuery__
 *
 * To run a query within a React component, call `useStoreBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreBannersQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreBannersQuery(baseOptions?: Apollo.QueryHookOptions<StoreBannersQuery, StoreBannersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreBannersQuery, StoreBannersQueryVariables>(StoreBannersDocument, options);
      }
export function useStoreBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreBannersQuery, StoreBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreBannersQuery, StoreBannersQueryVariables>(StoreBannersDocument, options);
        }
export type StoreBannersQueryHookResult = ReturnType<typeof useStoreBannersQuery>;
export type StoreBannersLazyQueryHookResult = ReturnType<typeof useStoreBannersLazyQuery>;
export type StoreBannersQueryResult = Apollo.QueryResult<StoreBannersQuery, StoreBannersQueryVariables>;
export const GetTeamProfileDocument = gql`
    query getTeamProfile($id: String!) {
  teamById: account(id: $id) {
    ...TeamProfile
  }
  teamByPublicURL: accountByPublicURL(publicURL: $id) {
    ...TeamProfile
  }
}
    ${TeamProfileFragmentDoc}`;

/**
 * __useGetTeamProfileQuery__
 *
 * To run a query within a React component, call `useGetTeamProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamProfileQuery(baseOptions: Apollo.QueryHookOptions<GetTeamProfileQuery, GetTeamProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamProfileQuery, GetTeamProfileQueryVariables>(GetTeamProfileDocument, options);
      }
export function useGetTeamProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamProfileQuery, GetTeamProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamProfileQuery, GetTeamProfileQueryVariables>(GetTeamProfileDocument, options);
        }
export type GetTeamProfileQueryHookResult = ReturnType<typeof useGetTeamProfileQuery>;
export type GetTeamProfileLazyQueryHookResult = ReturnType<typeof useGetTeamProfileLazyQuery>;
export type GetTeamProfileQueryResult = Apollo.QueryResult<GetTeamProfileQuery, GetTeamProfileQueryVariables>;
export const PurchaseSwarmioCurrencyItemDocument = gql`
    mutation purchaseSwarmioCurrencyItem($maybeEmail: String, $maybeCustomerName: String, $swarmioCurrencyItemCostId: String!, $paymentType: PaymentType!) {
  purchaseSwarmioCurrencyItem(
    maybeEmail: $maybeEmail
    maybeCustomerName: $maybeCustomerName
    swarmioCurrencyItemCostId: $swarmioCurrencyItemCostId
    paymentType: $paymentType
  )
}
    `;
export type PurchaseSwarmioCurrencyItemMutationFn = Apollo.MutationFunction<PurchaseSwarmioCurrencyItemMutation, PurchaseSwarmioCurrencyItemMutationVariables>;

/**
 * __usePurchaseSwarmioCurrencyItemMutation__
 *
 * To run a mutation, you first call `usePurchaseSwarmioCurrencyItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseSwarmioCurrencyItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseSwarmioCurrencyItemMutation, { data, loading, error }] = usePurchaseSwarmioCurrencyItemMutation({
 *   variables: {
 *      maybeEmail: // value for 'maybeEmail'
 *      maybeCustomerName: // value for 'maybeCustomerName'
 *      swarmioCurrencyItemCostId: // value for 'swarmioCurrencyItemCostId'
 *      paymentType: // value for 'paymentType'
 *   },
 * });
 */
export function usePurchaseSwarmioCurrencyItemMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseSwarmioCurrencyItemMutation, PurchaseSwarmioCurrencyItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseSwarmioCurrencyItemMutation, PurchaseSwarmioCurrencyItemMutationVariables>(PurchaseSwarmioCurrencyItemDocument, options);
      }
export type PurchaseSwarmioCurrencyItemMutationHookResult = ReturnType<typeof usePurchaseSwarmioCurrencyItemMutation>;
export type PurchaseSwarmioCurrencyItemMutationResult = Apollo.MutationResult<PurchaseSwarmioCurrencyItemMutation>;
export type PurchaseSwarmioCurrencyItemMutationOptions = Apollo.BaseMutationOptions<PurchaseSwarmioCurrencyItemMutation, PurchaseSwarmioCurrencyItemMutationVariables>;
export const CreateWalletsDocument = gql`
    mutation createWallets($ownerId: String!, $swarmioCurrencyIds: [String!]!) {
  createWalletsForUser(ownerId: $ownerId, swarmioCurrencyIds: $swarmioCurrencyIds) {
    id
  }
}
    `;
export type CreateWalletsMutationFn = Apollo.MutationFunction<CreateWalletsMutation, CreateWalletsMutationVariables>;

/**
 * __useCreateWalletsMutation__
 *
 * To run a mutation, you first call `useCreateWalletsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWalletsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWalletsMutation, { data, loading, error }] = useCreateWalletsMutation({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *      swarmioCurrencyIds: // value for 'swarmioCurrencyIds'
 *   },
 * });
 */
export function useCreateWalletsMutation(baseOptions?: Apollo.MutationHookOptions<CreateWalletsMutation, CreateWalletsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWalletsMutation, CreateWalletsMutationVariables>(CreateWalletsDocument, options);
      }
export type CreateWalletsMutationHookResult = ReturnType<typeof useCreateWalletsMutation>;
export type CreateWalletsMutationResult = Apollo.MutationResult<CreateWalletsMutation>;
export type CreateWalletsMutationOptions = Apollo.BaseMutationOptions<CreateWalletsMutation, CreateWalletsMutationVariables>;
export const GetAllSwarmioCurrenciesDocument = gql`
    query GetAllSwarmioCurrencies {
  getAllSwarmioCurrencies {
    id
    name
    cashable
  }
}
    `;

/**
 * __useGetAllSwarmioCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetAllSwarmioCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSwarmioCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSwarmioCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSwarmioCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSwarmioCurrenciesQuery, GetAllSwarmioCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSwarmioCurrenciesQuery, GetAllSwarmioCurrenciesQueryVariables>(GetAllSwarmioCurrenciesDocument, options);
      }
export function useGetAllSwarmioCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSwarmioCurrenciesQuery, GetAllSwarmioCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSwarmioCurrenciesQuery, GetAllSwarmioCurrenciesQueryVariables>(GetAllSwarmioCurrenciesDocument, options);
        }
export type GetAllSwarmioCurrenciesQueryHookResult = ReturnType<typeof useGetAllSwarmioCurrenciesQuery>;
export type GetAllSwarmioCurrenciesLazyQueryHookResult = ReturnType<typeof useGetAllSwarmioCurrenciesLazyQuery>;
export type GetAllSwarmioCurrenciesQueryResult = Apollo.QueryResult<GetAllSwarmioCurrenciesQuery, GetAllSwarmioCurrenciesQueryVariables>;
export const GetAllSwarmioCurrencyItemsDocument = gql`
    query GetAllSwarmioCurrencyItems {
  getAllSwarmioCurrencyItems {
    ...SwarmioCurrencyItem
  }
}
    ${SwarmioCurrencyItemFragmentDoc}`;

/**
 * __useGetAllSwarmioCurrencyItemsQuery__
 *
 * To run a query within a React component, call `useGetAllSwarmioCurrencyItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSwarmioCurrencyItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSwarmioCurrencyItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSwarmioCurrencyItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSwarmioCurrencyItemsQuery, GetAllSwarmioCurrencyItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSwarmioCurrencyItemsQuery, GetAllSwarmioCurrencyItemsQueryVariables>(GetAllSwarmioCurrencyItemsDocument, options);
      }
export function useGetAllSwarmioCurrencyItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSwarmioCurrencyItemsQuery, GetAllSwarmioCurrencyItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSwarmioCurrencyItemsQuery, GetAllSwarmioCurrencyItemsQueryVariables>(GetAllSwarmioCurrencyItemsDocument, options);
        }
export type GetAllSwarmioCurrencyItemsQueryHookResult = ReturnType<typeof useGetAllSwarmioCurrencyItemsQuery>;
export type GetAllSwarmioCurrencyItemsLazyQueryHookResult = ReturnType<typeof useGetAllSwarmioCurrencyItemsLazyQuery>;
export type GetAllSwarmioCurrencyItemsQueryResult = Apollo.QueryResult<GetAllSwarmioCurrencyItemsQuery, GetAllSwarmioCurrencyItemsQueryVariables>;
export const GetCurrencyPurchaseHistoryByOwnerIdDocument = gql`
    query getCurrencyPurchaseHistoryByOwnerId($ownerId: String!) {
  getCurrencyPurchaseHistoryByOwnerId(ownerId: $ownerId) {
    ...SwarmioPayPaymentOnPurchaseHistory
  }
}
    ${SwarmioPayPaymentOnPurchaseHistoryFragmentDoc}`;

/**
 * __useGetCurrencyPurchaseHistoryByOwnerIdQuery__
 *
 * To run a query within a React component, call `useGetCurrencyPurchaseHistoryByOwnerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyPurchaseHistoryByOwnerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyPurchaseHistoryByOwnerIdQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *   },
 * });
 */
export function useGetCurrencyPurchaseHistoryByOwnerIdQuery(baseOptions: Apollo.QueryHookOptions<GetCurrencyPurchaseHistoryByOwnerIdQuery, GetCurrencyPurchaseHistoryByOwnerIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyPurchaseHistoryByOwnerIdQuery, GetCurrencyPurchaseHistoryByOwnerIdQueryVariables>(GetCurrencyPurchaseHistoryByOwnerIdDocument, options);
      }
export function useGetCurrencyPurchaseHistoryByOwnerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyPurchaseHistoryByOwnerIdQuery, GetCurrencyPurchaseHistoryByOwnerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyPurchaseHistoryByOwnerIdQuery, GetCurrencyPurchaseHistoryByOwnerIdQueryVariables>(GetCurrencyPurchaseHistoryByOwnerIdDocument, options);
        }
export type GetCurrencyPurchaseHistoryByOwnerIdQueryHookResult = ReturnType<typeof useGetCurrencyPurchaseHistoryByOwnerIdQuery>;
export type GetCurrencyPurchaseHistoryByOwnerIdLazyQueryHookResult = ReturnType<typeof useGetCurrencyPurchaseHistoryByOwnerIdLazyQuery>;
export type GetCurrencyPurchaseHistoryByOwnerIdQueryResult = Apollo.QueryResult<GetCurrencyPurchaseHistoryByOwnerIdQuery, GetCurrencyPurchaseHistoryByOwnerIdQueryVariables>;
export const GetWalletsForOwnerDocument = gql`
    query getWalletsForOwner($ownerId: String!, $offset: Int!, $limit: Int!) {
  getWalletsForOwner(ownerId: $ownerId) {
    id
    ownerId
    balance
    swarmioCurrency {
      ...SwarmioCurrencyOnWalletsForOwner
    }
    created
    transactions(offset: $offset, limit: $limit) {
      ...TransactionsOnWalletsForOwner
    }
  }
}
    ${SwarmioCurrencyOnWalletsForOwnerFragmentDoc}
${TransactionsOnWalletsForOwnerFragmentDoc}`;

/**
 * __useGetWalletsForOwnerQuery__
 *
 * To run a query within a React component, call `useGetWalletsForOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletsForOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletsForOwnerQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetWalletsForOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetWalletsForOwnerQuery, GetWalletsForOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletsForOwnerQuery, GetWalletsForOwnerQueryVariables>(GetWalletsForOwnerDocument, options);
      }
export function useGetWalletsForOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletsForOwnerQuery, GetWalletsForOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletsForOwnerQuery, GetWalletsForOwnerQueryVariables>(GetWalletsForOwnerDocument, options);
        }
export type GetWalletsForOwnerQueryHookResult = ReturnType<typeof useGetWalletsForOwnerQuery>;
export type GetWalletsForOwnerLazyQueryHookResult = ReturnType<typeof useGetWalletsForOwnerLazyQuery>;
export type GetWalletsForOwnerQueryResult = Apollo.QueryResult<GetWalletsForOwnerQuery, GetWalletsForOwnerQueryVariables>;
export const GetStreamsByIdsDocument = gql`
    query getStreamsByIds($ids: [String!]!) {
  getStreamsByIds(ids: $ids) {
    id
    streamUrl
    streamType
    mediaType
    ...TwitchStream_v2
  }
}
    ${TwitchStream_V2FragmentDoc}`;

/**
 * __useGetStreamsByIdsQuery__
 *
 * To run a query within a React component, call `useGetStreamsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetStreamsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetStreamsByIdsQuery, GetStreamsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStreamsByIdsQuery, GetStreamsByIdsQueryVariables>(GetStreamsByIdsDocument, options);
      }
export function useGetStreamsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStreamsByIdsQuery, GetStreamsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStreamsByIdsQuery, GetStreamsByIdsQueryVariables>(GetStreamsByIdsDocument, options);
        }
export type GetStreamsByIdsQueryHookResult = ReturnType<typeof useGetStreamsByIdsQuery>;
export type GetStreamsByIdsLazyQueryHookResult = ReturnType<typeof useGetStreamsByIdsLazyQuery>;
export type GetStreamsByIdsQueryResult = Apollo.QueryResult<GetStreamsByIdsQuery, GetStreamsByIdsQueryVariables>;
export const GetStreamsByTypeDocument = gql`
    query getStreamsByType($streamsType: StreamType!) {
  getStreamsbyType(streamsType: $streamsType) {
    id
    streamUrl
    streamType
    mediaType
    ...TwitchStream_v2
  }
}
    ${TwitchStream_V2FragmentDoc}`;

/**
 * __useGetStreamsByTypeQuery__
 *
 * To run a query within a React component, call `useGetStreamsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamsByTypeQuery({
 *   variables: {
 *      streamsType: // value for 'streamsType'
 *   },
 * });
 */
export function useGetStreamsByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetStreamsByTypeQuery, GetStreamsByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStreamsByTypeQuery, GetStreamsByTypeQueryVariables>(GetStreamsByTypeDocument, options);
      }
export function useGetStreamsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStreamsByTypeQuery, GetStreamsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStreamsByTypeQuery, GetStreamsByTypeQueryVariables>(GetStreamsByTypeDocument, options);
        }
export type GetStreamsByTypeQueryHookResult = ReturnType<typeof useGetStreamsByTypeQuery>;
export type GetStreamsByTypeLazyQueryHookResult = ReturnType<typeof useGetStreamsByTypeLazyQuery>;
export type GetStreamsByTypeQueryResult = Apollo.QueryResult<GetStreamsByTypeQuery, GetStreamsByTypeQueryVariables>;
export const GetApplicationConfigByNameDocument = gql`
    query getApplicationConfigByName($applicationConfigName: String!) {
  applicationConfigByName(applicationConfigName: $applicationConfigName) {
    id
    name
    featureFlags {
      ...FeatureFlag
    }
  }
}
    ${FeatureFlagFragmentDoc}`;

/**
 * __useGetApplicationConfigByNameQuery__
 *
 * To run a query within a React component, call `useGetApplicationConfigByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationConfigByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationConfigByNameQuery({
 *   variables: {
 *      applicationConfigName: // value for 'applicationConfigName'
 *   },
 * });
 */
export function useGetApplicationConfigByNameQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationConfigByNameQuery, GetApplicationConfigByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationConfigByNameQuery, GetApplicationConfigByNameQueryVariables>(GetApplicationConfigByNameDocument, options);
      }
export function useGetApplicationConfigByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationConfigByNameQuery, GetApplicationConfigByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationConfigByNameQuery, GetApplicationConfigByNameQueryVariables>(GetApplicationConfigByNameDocument, options);
        }
export type GetApplicationConfigByNameQueryHookResult = ReturnType<typeof useGetApplicationConfigByNameQuery>;
export type GetApplicationConfigByNameLazyQueryHookResult = ReturnType<typeof useGetApplicationConfigByNameLazyQuery>;
export type GetApplicationConfigByNameQueryResult = Apollo.QueryResult<GetApplicationConfigByNameQuery, GetApplicationConfigByNameQueryVariables>;
export const UniqueDisplayNameDocument = gql`
    query uniqueDisplayName($displayName: String!) {
  userByDisplayName(displayName: $displayName) {
    id
  }
}
    `;

/**
 * __useUniqueDisplayNameQuery__
 *
 * To run a query within a React component, call `useUniqueDisplayNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniqueDisplayNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniqueDisplayNameQuery({
 *   variables: {
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useUniqueDisplayNameQuery(baseOptions: Apollo.QueryHookOptions<UniqueDisplayNameQuery, UniqueDisplayNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniqueDisplayNameQuery, UniqueDisplayNameQueryVariables>(UniqueDisplayNameDocument, options);
      }
export function useUniqueDisplayNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniqueDisplayNameQuery, UniqueDisplayNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniqueDisplayNameQuery, UniqueDisplayNameQueryVariables>(UniqueDisplayNameDocument, options);
        }
export type UniqueDisplayNameQueryHookResult = ReturnType<typeof useUniqueDisplayNameQuery>;
export type UniqueDisplayNameLazyQueryHookResult = ReturnType<typeof useUniqueDisplayNameLazyQuery>;
export type UniqueDisplayNameQueryResult = Apollo.QueryResult<UniqueDisplayNameQuery, UniqueDisplayNameQueryVariables>;
export const UniquePublicUrlDocument = gql`
    query uniquePublicURL($publicURL: String!) {
  accountByPublicURL(publicURL: $publicURL) {
    id
    accountType
  }
}
    `;

/**
 * __useUniquePublicUrlQuery__
 *
 * To run a query within a React component, call `useUniquePublicUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniquePublicUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniquePublicUrlQuery({
 *   variables: {
 *      publicURL: // value for 'publicURL'
 *   },
 * });
 */
export function useUniquePublicUrlQuery(baseOptions: Apollo.QueryHookOptions<UniquePublicUrlQuery, UniquePublicUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniquePublicUrlQuery, UniquePublicUrlQueryVariables>(UniquePublicUrlDocument, options);
      }
export function useUniquePublicUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniquePublicUrlQuery, UniquePublicUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniquePublicUrlQuery, UniquePublicUrlQueryVariables>(UniquePublicUrlDocument, options);
        }
export type UniquePublicUrlQueryHookResult = ReturnType<typeof useUniquePublicUrlQuery>;
export type UniquePublicUrlLazyQueryHookResult = ReturnType<typeof useUniquePublicUrlLazyQuery>;
export type UniquePublicUrlQueryResult = Apollo.QueryResult<UniquePublicUrlQuery, UniquePublicUrlQueryVariables>;
export const UniqueTeamNameDocument = gql`
    query uniqueTeamName($name: String!) {
  groupTraitNameIsUnique(name: $name)
}
    `;

/**
 * __useUniqueTeamNameQuery__
 *
 * To run a query within a React component, call `useUniqueTeamNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniqueTeamNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniqueTeamNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUniqueTeamNameQuery(baseOptions: Apollo.QueryHookOptions<UniqueTeamNameQuery, UniqueTeamNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniqueTeamNameQuery, UniqueTeamNameQueryVariables>(UniqueTeamNameDocument, options);
      }
export function useUniqueTeamNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniqueTeamNameQuery, UniqueTeamNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniqueTeamNameQuery, UniqueTeamNameQueryVariables>(UniqueTeamNameDocument, options);
        }
export type UniqueTeamNameQueryHookResult = ReturnType<typeof useUniqueTeamNameQuery>;
export type UniqueTeamNameLazyQueryHookResult = ReturnType<typeof useUniqueTeamNameLazyQuery>;
export type UniqueTeamNameQueryResult = Apollo.QueryResult<UniqueTeamNameQuery, UniqueTeamNameQueryVariables>;
export function mockAddSltAccountResponse(
  variables: AddSltAccountMutationVariables,
  data: AddSltAccountMutation | Error
): MockedResponse<AddSltAccountMutationVariables, AddSltAccountMutation> {
  return {
    request: { query: AddSltAccountDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockValidateSltAccountResponse(
  variables: ValidateSltAccountQueryVariables,
  data: ValidateSltAccountQuery | Error
): MockedResponse<ValidateSltAccountQueryVariables, ValidateSltAccountQuery> {
  return {
    request: { query: ValidateSltAccountDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetUserForLinkedGamesResponse(
  variables: GetUserForLinkedGamesQueryVariables,
  data: GetUserForLinkedGamesQuery | Error
): MockedResponse<
  GetUserForLinkedGamesQueryVariables,
  GetUserForLinkedGamesQuery
> {
  return {
    request: { query: GetUserForLinkedGamesDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetNotificationsResponse(
  variables: GetNotificationsQueryVariables,
  data: GetNotificationsQuery | Error
): MockedResponse<GetNotificationsQueryVariables, GetNotificationsQuery> {
  return {
    request: { query: GetNotificationsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockMarkNotificationsAsReadResponse(
  variables: MarkNotificationsAsReadMutationVariables,
  data: MarkNotificationsAsReadMutation | Error
): MockedResponse<
  MarkNotificationsAsReadMutationVariables,
  MarkNotificationsAsReadMutation
> {
  return {
    request: { query: MarkNotificationsAsReadDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockNewNotificationResponse(
  variables: NewNotificationSubscriptionVariables,
  data: NewNotificationSubscription | Error
): MockedResponse<
  NewNotificationSubscriptionVariables,
  NewNotificationSubscription
> {
  return {
    request: { query: NewNotificationDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetMinimalUserResponse(
  variables: GetMinimalUserQueryVariables,
  data: GetMinimalUserQuery | Error
): MockedResponse<GetMinimalUserQueryVariables, GetMinimalUserQuery> {
  return {
    request: { query: GetMinimalUserDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetUserForPermissionsResponse(
  variables: GetUserForPermissionsQueryVariables,
  data: GetUserForPermissionsQuery | Error
): MockedResponse<
  GetUserForPermissionsQueryVariables,
  GetUserForPermissionsQuery
> {
  return {
    request: { query: GetUserForPermissionsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockCancelScheduledSubscriptionResponse(
  variables: CancelScheduledSubscriptionMutationVariables,
  data: CancelScheduledSubscriptionMutation | Error
): MockedResponse<
  CancelScheduledSubscriptionMutationVariables,
  CancelScheduledSubscriptionMutation
> {
  return {
    request: { query: CancelScheduledSubscriptionDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockEnrollExplicitSubscriptionResponse(
  variables: EnrollExplicitSubscriptionMutationVariables,
  data: EnrollExplicitSubscriptionMutation | Error
): MockedResponse<
  EnrollExplicitSubscriptionMutationVariables,
  EnrollExplicitSubscriptionMutation
> {
  return {
    request: { query: EnrollExplicitSubscriptionDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockEnrollExternalSubscriptionPackageResponse(
  variables: EnrollExternalSubscriptionPackageMutationVariables,
  data: EnrollExternalSubscriptionPackageMutation | Error
): MockedResponse<
  EnrollExternalSubscriptionPackageMutationVariables,
  EnrollExternalSubscriptionPackageMutation
> {
  return {
    request: { query: EnrollExternalSubscriptionPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetAllEventGamesResponse(
  data: GetAllEventGamesQuery | Error
): MockedResponse<GetAllEventGamesQueryVariables, GetAllEventGamesQuery> {
  return {
    request: { query: GetAllEventGamesDocument },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAllGameAccountTypesResponse(
  data: AllGameAccountTypesQuery | Error
): MockedResponse<AllGameAccountTypesQueryVariables, AllGameAccountTypesQuery> {
  return {
    request: { query: AllGameAccountTypesDocument },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetAllSubscriptionTypesResponse(
  data: GetAllSubscriptionTypesQuery | Error
): MockedResponse<
  GetAllSubscriptionTypesQueryVariables,
  GetAllSubscriptionTypesQuery
> {
  return {
    request: { query: GetAllSubscriptionTypesDocument },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventParticipationSummaryResponse(
  variables: GetEventParticipationSummaryQueryVariables,
  data: GetEventParticipationSummaryQuery | Error
): MockedResponse<
  GetEventParticipationSummaryQueryVariables,
  GetEventParticipationSummaryQuery
> {
  return {
    request: { query: GetEventParticipationSummaryDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventParticipationsResponse(
  variables: GetEventParticipationsQueryVariables,
  data: GetEventParticipationsQuery | Error
): MockedResponse<
  GetEventParticipationsQueryVariables,
  GetEventParticipationsQuery
> {
  return {
    request: { query: GetEventParticipationsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetGroupMembershipsResponse(
  variables: GetGroupMembershipsQueryVariables,
  data: GetGroupMembershipsQuery | Error
): MockedResponse<GetGroupMembershipsQueryVariables, GetGroupMembershipsQuery> {
  return {
    request: { query: GetGroupMembershipsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetSubscriptionTypesForEventDetailsResponse(
  data: GetSubscriptionTypesForEventDetailsQuery | Error
): MockedResponse<
  GetSubscriptionTypesForEventDetailsQueryVariables,
  GetSubscriptionTypesForEventDetailsQuery
> {
  return {
    request: { query: GetSubscriptionTypesForEventDetailsDocument },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetSubscriptionsForAccountIdResponse(
  variables: GetSubscriptionsForAccountIdQueryVariables,
  data: GetSubscriptionsForAccountIdQuery | Error
): MockedResponse<
  GetSubscriptionsForAccountIdQueryVariables,
  GetSubscriptionsForAccountIdQuery
> {
  return {
    request: { query: GetSubscriptionsForAccountIdDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetTeamForEventJoinResponse(
  variables: GetTeamForEventJoinQueryVariables,
  data: GetTeamForEventJoinQuery | Error
): MockedResponse<GetTeamForEventJoinQueryVariables, GetTeamForEventJoinQuery> {
  return {
    request: { query: GetTeamForEventJoinDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetUserForEventJoinResponse(
  variables: GetUserForEventJoinQueryVariables,
  data: GetUserForEventJoinQuery | Error
): MockedResponse<GetUserForEventJoinQueryVariables, GetUserForEventJoinQuery> {
  return {
    request: { query: GetUserForEventJoinDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetUserProviderAccountsResponse(
  variables: GetUserProviderAccountsQueryVariables,
  data: GetUserProviderAccountsQuery | Error
): MockedResponse<
  GetUserProviderAccountsQueryVariables,
  GetUserProviderAccountsQuery
> {
  return {
    request: { query: GetUserProviderAccountsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockRemoveSubscriptionProviderAccountResponse(
  variables: RemoveSubscriptionProviderAccountMutationVariables,
  data: RemoveSubscriptionProviderAccountMutation | Error
): MockedResponse<
  RemoveSubscriptionProviderAccountMutationVariables,
  RemoveSubscriptionProviderAccountMutation
> {
  return {
    request: { query: RemoveSubscriptionProviderAccountDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockResendVerificationSmsResponse(
  variables: ResendVerificationSmsMutationVariables,
  data: ResendVerificationSmsMutation | Error
): MockedResponse<
  ResendVerificationSmsMutationVariables,
  ResendVerificationSmsMutation
> {
  return {
    request: { query: ResendVerificationSmsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockUnenrollExternalSubscriptionPackageResponse(
  variables: UnenrollExternalSubscriptionPackageMutationVariables,
  data: UnenrollExternalSubscriptionPackageMutation | Error
): MockedResponse<
  UnenrollExternalSubscriptionPackageMutationVariables,
  UnenrollExternalSubscriptionPackageMutation
> {
  return {
    request: { query: UnenrollExternalSubscriptionPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockCancelPendingSubscriptionResponse(
  variables: CancelPendingSubscriptionMutationVariables,
  data: CancelPendingSubscriptionMutation | Error
): MockedResponse<
  CancelPendingSubscriptionMutationVariables,
  CancelPendingSubscriptionMutation
> {
  return {
    request: { query: CancelPendingSubscriptionDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockMyInvitationsResponse(
  variables: MyInvitationsQueryVariables,
  data: MyInvitationsQuery | Error
): MockedResponse<MyInvitationsQueryVariables, MyInvitationsQuery> {
  return {
    request: { query: MyInvitationsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockPaySubscriptionWithSwarmioResponse(
  variables: PaySubscriptionWithSwarmioMutationVariables,
  data: PaySubscriptionWithSwarmioMutation | Error
): MockedResponse<
  PaySubscriptionWithSwarmioMutationVariables,
  PaySubscriptionWithSwarmioMutation
> {
  return {
    request: { query: PaySubscriptionWithSwarmioDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEmbeddedGamesResponse(
  variables: GetEmbeddedGamesQueryVariables,
  data: GetEmbeddedGamesQuery | Error
): MockedResponse<GetEmbeddedGamesQueryVariables, GetEmbeddedGamesQuery> {
  return {
    request: { query: GetEmbeddedGamesDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockCheckMsisdnCodeResponse(
  variables: CheckMsisdnCodeQueryVariables,
  data: CheckMsisdnCodeQuery | Error
): MockedResponse<CheckMsisdnCodeQueryVariables, CheckMsisdnCodeQuery> {
  return {
    request: { query: CheckMsisdnCodeDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockCompleteAccountResponse(
  variables: CompleteAccountMutationVariables,
  data: CompleteAccountMutation | Error
): MockedResponse<CompleteAccountMutationVariables, CompleteAccountMutation> {
  return {
    request: { query: CompleteAccountDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockResetPasswordRequestResponse(
  variables: ResetPasswordRequestMutationVariables,
  data: ResetPasswordRequestMutation | Error
): MockedResponse<
  ResetPasswordRequestMutationVariables,
  ResetPasswordRequestMutation
> {
  return {
    request: { query: ResetPasswordRequestDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockRegisterPersonEmailResponse(
  variables: RegisterPersonEmailMutationVariables,
  data: RegisterPersonEmailMutation | Error
): MockedResponse<
  RegisterPersonEmailMutationVariables,
  RegisterPersonEmailMutation
> {
  return {
    request: { query: RegisterPersonEmailDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockRegisterPersonMsisdnResponse(
  variables: RegisterPersonMsisdnMutationVariables,
  data: RegisterPersonMsisdnMutation | Error
): MockedResponse<
  RegisterPersonMsisdnMutationVariables,
  RegisterPersonMsisdnMutation
> {
  return {
    request: { query: RegisterPersonMsisdnDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockResetPasswordResponse(
  variables: ResetPasswordMutationVariables,
  data: ResetPasswordMutation | Error
): MockedResponse<ResetPasswordMutationVariables, ResetPasswordMutation> {
  return {
    request: { query: ResetPasswordDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetBlogGameResponse(
  variables: GetBlogGameQueryVariables,
  data: GetBlogGameQuery | Error
): MockedResponse<GetBlogGameQueryVariables, GetBlogGameQuery> {
  return {
    request: { query: GetBlogGameDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetBlogGamerResponse(
  variables: GetBlogGamerQueryVariables,
  data: GetBlogGamerQuery | Error
): MockedResponse<GetBlogGamerQueryVariables, GetBlogGamerQuery> {
  return {
    request: { query: GetBlogGamerDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetBlogPageResponse(
  data: GetBlogPageQuery | Error
): MockedResponse<GetBlogPageQueryVariables, GetBlogPageQuery> {
  return {
    request: { query: GetBlogPageDocument },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetBlogPostResponse(
  variables: GetBlogPostQueryVariables,
  data: GetBlogPostQuery | Error
): MockedResponse<GetBlogPostQueryVariables, GetBlogPostQuery> {
  return {
    request: { query: GetBlogPostDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAddGameToGameAccountResponse(
  variables: AddGameToGameAccountMutationVariables,
  data: AddGameToGameAccountMutation | Error
): MockedResponse<
  AddGameToGameAccountMutationVariables,
  AddGameToGameAccountMutation
> {
  return {
    request: { query: AddGameToGameAccountDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockLinkNonIntegratedGameAccountResponse(
  variables: LinkNonIntegratedGameAccountMutationVariables,
  data: LinkNonIntegratedGameAccountMutation | Error
): MockedResponse<
  LinkNonIntegratedGameAccountMutationVariables,
  LinkNonIntegratedGameAccountMutation
> {
  return {
    request: { query: LinkNonIntegratedGameAccountDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockCreateTeamResponse(
  variables: CreateTeamMutationVariables,
  data: CreateTeamMutation | Error
): MockedResponse<CreateTeamMutationVariables, CreateTeamMutation> {
  return {
    request: { query: CreateTeamDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAddMultiDimensionalBucketBasedResultForVerificationResponse(
  variables: AddMultiDimensionalBucketBasedResultForVerificationMutationVariables,
  data: AddMultiDimensionalBucketBasedResultForVerificationMutation | Error
): MockedResponse<
  AddMultiDimensionalBucketBasedResultForVerificationMutationVariables,
  AddMultiDimensionalBucketBasedResultForVerificationMutation
> {
  return {
    request: {
      query: AddMultiDimensionalBucketBasedResultForVerificationDocument,
      variables,
    },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockManuallyVerifiedResultsForRoundIdAndParticipantIdResponse(
  variables: ManuallyVerifiedResultsForRoundIdAndParticipantIdQueryVariables,
  data: ManuallyVerifiedResultsForRoundIdAndParticipantIdQuery | Error
): MockedResponse<
  ManuallyVerifiedResultsForRoundIdAndParticipantIdQueryVariables,
  ManuallyVerifiedResultsForRoundIdAndParticipantIdQuery
> {
  return {
    request: {
      query: ManuallyVerifiedResultsForRoundIdAndParticipantIdDocument,
      variables,
    },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockConfirmParticipantResponse(
  variables: ConfirmParticipantMutationVariables,
  data: ConfirmParticipantMutation | Error
): MockedResponse<
  ConfirmParticipantMutationVariables,
  ConfirmParticipantMutation
> {
  return {
    request: { query: ConfirmParticipantDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetParticipantsForParticipantConfirmationResponse(
  variables: GetParticipantsForParticipantConfirmationQueryVariables,
  data: GetParticipantsForParticipantConfirmationQuery | Error
): MockedResponse<
  GetParticipantsForParticipantConfirmationQueryVariables,
  GetParticipantsForParticipantConfirmationQuery
> {
  return {
    request: {
      query: GetParticipantsForParticipantConfirmationDocument,
      variables,
    },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetLaddersTimelineResponse(
  variables: GetLaddersTimelineQueryVariables,
  data: GetLaddersTimelineQuery | Error
): MockedResponse<GetLaddersTimelineQueryVariables, GetLaddersTimelineQuery> {
  return {
    request: { query: GetLaddersTimelineDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAddIndividualParticipantResponse(
  variables: AddIndividualParticipantMutationVariables,
  data: AddIndividualParticipantMutation | Error
): MockedResponse<
  AddIndividualParticipantMutationVariables,
  AddIndividualParticipantMutation
> {
  return {
    request: { query: AddIndividualParticipantDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAddTeamParticipantResponse(
  variables: AddTeamParticipantMutationVariables,
  data: AddTeamParticipantMutation | Error
): MockedResponse<
  AddTeamParticipantMutationVariables,
  AddTeamParticipantMutation
> {
  return {
    request: { query: AddTeamParticipantDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetParticipantsForJoinEventModalResponse(
  variables: GetParticipantsForJoinEventModalQueryVariables,
  data: GetParticipantsForJoinEventModalQuery | Error
): MockedResponse<
  GetParticipantsForJoinEventModalQueryVariables,
  GetParticipantsForJoinEventModalQuery
> {
  return {
    request: { query: GetParticipantsForJoinEventModalDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetParticipantsForLeaveEventModalResponse(
  variables: GetParticipantsForLeaveEventModalQueryVariables,
  data: GetParticipantsForLeaveEventModalQuery | Error
): MockedResponse<
  GetParticipantsForLeaveEventModalQueryVariables,
  GetParticipantsForLeaveEventModalQuery
> {
  return {
    request: { query: GetParticipantsForLeaveEventModalDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockRemoveParticipantResponse(
  variables: RemoveParticipantMutationVariables,
  data: RemoveParticipantMutation | Error
): MockedResponse<
  RemoveParticipantMutationVariables,
  RemoveParticipantMutation
> {
  return {
    request: { query: RemoveParticipantDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAddAutomaticallyVerifiedResultForRoundResponse(
  variables: AddAutomaticallyVerifiedResultForRoundMutationVariables,
  data: AddAutomaticallyVerifiedResultForRoundMutation | Error
): MockedResponse<
  AddAutomaticallyVerifiedResultForRoundMutationVariables,
  AddAutomaticallyVerifiedResultForRoundMutation
> {
  return {
    request: {
      query: AddAutomaticallyVerifiedResultForRoundDocument,
      variables,
    },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAutomaticallyVerifiedResultsForRoundAndFromParticipantIdResponse(
  variables: AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQueryVariables,
  data: AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery | Error
): MockedResponse<
  AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQueryVariables,
  AutomaticallyVerifiedResultsForRoundAndFromParticipantIdQuery
> {
  return {
    request: {
      query: AutomaticallyVerifiedResultsForRoundAndFromParticipantIdDocument,
      variables,
    },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventToMatchUpResponse(
  variables: GetEventToMatchUpQueryVariables,
  data: GetEventToMatchUpQuery | Error
): MockedResponse<GetEventToMatchUpQueryVariables, GetEventToMatchUpQuery> {
  return {
    request: { query: GetEventToMatchUpDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockBracketsResponse(
  variables: BracketsQueryVariables,
  data: BracketsQuery | Error
): MockedResponse<BracketsQueryVariables, BracketsQuery> {
  return {
    request: { query: BracketsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockEventMatchResponse(
  variables: EventMatchQueryVariables,
  data: EventMatchQuery | Error
): MockedResponse<EventMatchQueryVariables, EventMatchQuery> {
  return {
    request: { query: EventMatchDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockUnmatchedParticipantsResponse(
  variables: UnmatchedParticipantsQueryVariables,
  data: UnmatchedParticipantsQuery | Error
): MockedResponse<
  UnmatchedParticipantsQueryVariables,
  UnmatchedParticipantsQuery
> {
  return {
    request: { query: UnmatchedParticipantsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventLaddersDashboardResponse(
  variables: GetEventLaddersDashboardQueryVariables,
  data: GetEventLaddersDashboardQuery | Error
): MockedResponse<
  GetEventLaddersDashboardQueryVariables,
  GetEventLaddersDashboardQuery
> {
  return {
    request: { query: GetEventLaddersDashboardDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockReadyParticipantResponse(
  variables: ReadyParticipantMutationVariables,
  data: ReadyParticipantMutation | Error
): MockedResponse<ReadyParticipantMutationVariables, ReadyParticipantMutation> {
  return {
    request: { query: ReadyParticipantDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAddEventTeamInviteCodeResponse(
  variables: AddEventTeamInviteCodeMutationVariables,
  data: AddEventTeamInviteCodeMutation | Error
): MockedResponse<
  AddEventTeamInviteCodeMutationVariables,
  AddEventTeamInviteCodeMutation
> {
  return {
    request: { query: AddEventTeamInviteCodeDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAddToEventTeamResponse(
  variables: AddToEventTeamMutationVariables,
  data: AddToEventTeamMutation | Error
): MockedResponse<AddToEventTeamMutationVariables, AddToEventTeamMutation> {
  return {
    request: { query: AddToEventTeamDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventParticipantByAccountIdResponse(
  variables: GetEventParticipantByAccountIdQueryVariables,
  data: GetEventParticipantByAccountIdQuery | Error
): MockedResponse<
  GetEventParticipantByAccountIdQueryVariables,
  GetEventParticipantByAccountIdQuery
> {
  return {
    request: { query: GetEventParticipantByAccountIdDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventToDashboardResponse(
  variables: GetEventToDashboardQueryVariables,
  data: GetEventToDashboardQuery | Error
): MockedResponse<GetEventToDashboardQueryVariables, GetEventToDashboardQuery> {
  return {
    request: { query: GetEventToDashboardDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventToReadyToJoinResponse(
  variables: GetEventToReadyToJoinQueryVariables,
  data: GetEventToReadyToJoinQuery | Error
): MockedResponse<
  GetEventToReadyToJoinQueryVariables,
  GetEventToReadyToJoinQuery
> {
  return {
    request: { query: GetEventToReadyToJoinDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetTeamForEditLineupResponse(
  variables: GetTeamForEditLineupQueryVariables,
  data: GetTeamForEditLineupQuery | Error
): MockedResponse<
  GetTeamForEditLineupQueryVariables,
  GetTeamForEditLineupQuery
> {
  return {
    request: { query: GetTeamForEditLineupDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockRemoveFromEventTeamResponse(
  variables: RemoveFromEventTeamMutationVariables,
  data: RemoveFromEventTeamMutation | Error
): MockedResponse<
  RemoveFromEventTeamMutationVariables,
  RemoveFromEventTeamMutation
> {
  return {
    request: { query: RemoveFromEventTeamDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockMakeGhostResponse(
  data: MakeGhostQuery | Error
): MockedResponse<MakeGhostQueryVariables, MakeGhostQuery> {
  return {
    request: { query: MakeGhostDocument },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventDefaultOverviewResponse(
  variables: GetEventDefaultOverviewQueryVariables,
  data: GetEventDefaultOverviewQuery | Error
): MockedResponse<
  GetEventDefaultOverviewQueryVariables,
  GetEventDefaultOverviewQuery
> {
  return {
    request: { query: GetEventDefaultOverviewDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventLaddersOverviewResponse(
  variables: GetEventLaddersOverviewQueryVariables,
  data: GetEventLaddersOverviewQuery | Error
): MockedResponse<
  GetEventLaddersOverviewQueryVariables,
  GetEventLaddersOverviewQuery
> {
  return {
    request: { query: GetEventLaddersOverviewDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventParticipantResponse(
  variables: GetEventParticipantQueryVariables,
  data: GetEventParticipantQuery | Error
): MockedResponse<GetEventParticipantQueryVariables, GetEventParticipantQuery> {
  return {
    request: { query: GetEventParticipantDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetParticipantsForParticipantTabResponse(
  variables: GetParticipantsForParticipantTabQueryVariables,
  data: GetParticipantsForParticipantTabQuery | Error
): MockedResponse<
  GetParticipantsForParticipantTabQueryVariables,
  GetParticipantsForParticipantTabQuery
> {
  return {
    request: { query: GetParticipantsForParticipantTabDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetParticipantsForPrizesTabResponse(
  variables: GetParticipantsForPrizesTabQueryVariables,
  data: GetParticipantsForPrizesTabQuery | Error
): MockedResponse<
  GetParticipantsForPrizesTabQueryVariables,
  GetParticipantsForPrizesTabQuery
> {
  return {
    request: { query: GetParticipantsForPrizesTabDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetActiveMatchesResponse(
  variables: GetActiveMatchesQueryVariables,
  data: GetActiveMatchesQuery | Error
): MockedResponse<GetActiveMatchesQueryVariables, GetActiveMatchesQuery> {
  return {
    request: { query: GetActiveMatchesDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetAllEventsResponse(
  variables: GetAllEventsQueryVariables,
  data: GetAllEventsQuery | Error
): MockedResponse<GetAllEventsQueryVariables, GetAllEventsQuery> {
  return {
    request: { query: GetAllEventsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventResponse(
  variables: GetEventQueryVariables,
  data: GetEventQuery | Error
): MockedResponse<GetEventQueryVariables, GetEventQuery> {
  return {
    request: { query: GetEventDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockInGameResultsResponse(
  variables: InGameResultsQueryVariables,
  data: InGameResultsQuery | Error
): MockedResponse<InGameResultsQueryVariables, InGameResultsQuery> {
  return {
    request: { query: InGameResultsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockUpdatedEventResponse(
  variables: UpdatedEventSubscriptionVariables,
  data: UpdatedEventSubscription | Error
): MockedResponse<UpdatedEventSubscriptionVariables, UpdatedEventSubscription> {
  return {
    request: { query: UpdatedEventDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventToInvitePageResponse(
  variables: GetEventToInvitePageQueryVariables,
  data: GetEventToInvitePageQuery | Error
): MockedResponse<
  GetEventToInvitePageQueryVariables,
  GetEventToInvitePageQuery
> {
  return {
    request: { query: GetEventToInvitePageDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetTeamForInvitePageResponse(
  variables: GetTeamForInvitePageQueryVariables,
  data: GetTeamForInvitePageQuery | Error
): MockedResponse<
  GetTeamForInvitePageQueryVariables,
  GetTeamForInvitePageQuery
> {
  return {
    request: { query: GetTeamForInvitePageDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetTeamProfileForInvitePageResponse(
  variables: GetTeamProfileForInvitePageQueryVariables,
  data: GetTeamProfileForInvitePageQuery | Error
): MockedResponse<
  GetTeamProfileForInvitePageQueryVariables,
  GetTeamProfileForInvitePageQuery
> {
  return {
    request: { query: GetTeamProfileForInvitePageDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockJoinEventByInviteResponse(
  variables: JoinEventByInviteMutationVariables,
  data: JoinEventByInviteMutation | Error
): MockedResponse<
  JoinEventByInviteMutationVariables,
  JoinEventByInviteMutation
> {
  return {
    request: { query: JoinEventByInviteDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockJoinTeamByInviteResponse(
  variables: JoinTeamByInviteMutationVariables,
  data: JoinTeamByInviteMutation | Error
): MockedResponse<JoinTeamByInviteMutationVariables, JoinTeamByInviteMutation> {
  return {
    request: { query: JoinTeamByInviteDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockDeleteGroupAvatarResponse(
  variables: DeleteGroupAvatarMutationVariables,
  data: DeleteGroupAvatarMutation | Error
): MockedResponse<
  DeleteGroupAvatarMutationVariables,
  DeleteGroupAvatarMutation
> {
  return {
    request: { query: DeleteGroupAvatarDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockDeleteGroupBannerResponse(
  variables: DeleteGroupBannerMutationVariables,
  data: DeleteGroupBannerMutation | Error
): MockedResponse<
  DeleteGroupBannerMutationVariables,
  DeleteGroupBannerMutation
> {
  return {
    request: { query: DeleteGroupBannerDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAddTeamInviteCodeResponse(
  variables: AddTeamInviteCodeMutationVariables,
  data: AddTeamInviteCodeMutation | Error
): MockedResponse<
  AddTeamInviteCodeMutationVariables,
  AddTeamInviteCodeMutation
> {
  return {
    request: { query: AddTeamInviteCodeDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockPromoteToGroupAdminResponse(
  variables: PromoteToGroupAdminMutationVariables,
  data: PromoteToGroupAdminMutation | Error
): MockedResponse<
  PromoteToGroupAdminMutationVariables,
  PromoteToGroupAdminMutation
> {
  return {
    request: { query: PromoteToGroupAdminDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockRemoveMemberFromGroupResponse(
  variables: RemoveMemberFromGroupMutationVariables,
  data: RemoveMemberFromGroupMutation | Error
): MockedResponse<
  RemoveMemberFromGroupMutationVariables,
  RemoveMemberFromGroupMutation
> {
  return {
    request: { query: RemoveMemberFromGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockRemoveRolesFromGroupMemberResponse(
  variables: RemoveRolesFromGroupMemberMutationVariables,
  data: RemoveRolesFromGroupMemberMutation | Error
): MockedResponse<
  RemoveRolesFromGroupMemberMutationVariables,
  RemoveRolesFromGroupMemberMutation
> {
  return {
    request: { query: RemoveRolesFromGroupMemberDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockReplaceGroupOwnerResponse(
  variables: ReplaceGroupOwnerMutationVariables,
  data: ReplaceGroupOwnerMutation | Error
): MockedResponse<
  ReplaceGroupOwnerMutationVariables,
  ReplaceGroupOwnerMutation
> {
  return {
    request: { query: ReplaceGroupOwnerDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockInviteToGroupResponse(
  variables: InviteToGroupMutationVariables,
  data: InviteToGroupMutation | Error
): MockedResponse<InviteToGroupMutationVariables, InviteToGroupMutation> {
  return {
    request: { query: InviteToGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockUserSuggestionsResponse(
  variables: UserSuggestionsQueryVariables,
  data: UserSuggestionsQuery | Error
): MockedResponse<UserSuggestionsQueryVariables, UserSuggestionsQuery> {
  return {
    request: { query: UserSuggestionsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockUpdateTeamResponse(
  variables: UpdateTeamMutationVariables,
  data: UpdateTeamMutation | Error
): MockedResponse<UpdateTeamMutationVariables, UpdateTeamMutation> {
  return {
    request: { query: UpdateTeamDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAcceptAllGroupInvitationsResponse(
  variables: AcceptAllGroupInvitationsMutationVariables,
  data: AcceptAllGroupInvitationsMutation | Error
): MockedResponse<
  AcceptAllGroupInvitationsMutationVariables,
  AcceptAllGroupInvitationsMutation
> {
  return {
    request: { query: AcceptAllGroupInvitationsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAcceptGroupInvitationResponse(
  variables: AcceptGroupInvitationMutationVariables,
  data: AcceptGroupInvitationMutation | Error
): MockedResponse<
  AcceptGroupInvitationMutationVariables,
  AcceptGroupInvitationMutation
> {
  return {
    request: { query: AcceptGroupInvitationDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockDeclineAllGroupInvitationsResponse(
  variables: DeclineAllGroupInvitationsMutationVariables,
  data: DeclineAllGroupInvitationsMutation | Error
): MockedResponse<
  DeclineAllGroupInvitationsMutationVariables,
  DeclineAllGroupInvitationsMutation
> {
  return {
    request: { query: DeclineAllGroupInvitationsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockDeclineGroupInvitationResponse(
  variables: DeclineGroupInvitationMutationVariables,
  data: DeclineGroupInvitationMutation | Error
): MockedResponse<
  DeclineGroupInvitationMutationVariables,
  DeclineGroupInvitationMutation
> {
  return {
    request: { query: DeclineGroupInvitationDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockNewTeamInvitationResponse(
  variables: NewTeamInvitationSubscriptionVariables,
  data: NewTeamInvitationSubscription | Error
): MockedResponse<
  NewTeamInvitationSubscriptionVariables,
  NewTeamInvitationSubscription
> {
  return {
    request: { query: NewTeamInvitationDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockMyTeamsResponse(
  variables: MyTeamsQueryVariables,
  data: MyTeamsQuery | Error
): MockedResponse<MyTeamsQueryVariables, MyTeamsQuery> {
  return {
    request: { query: MyTeamsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetUserProfileResponse(
  variables: GetUserProfileQueryVariables,
  data: GetUserProfileQuery | Error
): MockedResponse<GetUserProfileQueryVariables, GetUserProfileQuery> {
  return {
    request: { query: GetUserProfileDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockMyProfileResponse(
  variables: MyProfileQueryVariables,
  data: MyProfileQuery | Error
): MockedResponse<MyProfileQueryVariables, MyProfileQuery> {
  return {
    request: { query: MyProfileDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetEventsForSeriesResponse(
  variables: GetEventsForSeriesQueryVariables,
  data: GetEventsForSeriesQuery | Error
): MockedResponse<GetEventsForSeriesQueryVariables, GetEventsForSeriesQuery> {
  return {
    request: { query: GetEventsForSeriesDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockAllActivePublicServersResponse(
  variables: AllActivePublicServersQueryVariables,
  data: AllActivePublicServersQuery | Error
): MockedResponse<
  AllActivePublicServersQueryVariables,
  AllActivePublicServersQuery
> {
  return {
    request: { query: AllActivePublicServersDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetUserAvatarResponse(
  variables: GetUserAvatarQueryVariables,
  data: GetUserAvatarQuery | Error
): MockedResponse<GetUserAvatarQueryVariables, GetUserAvatarQuery> {
  return {
    request: { query: GetUserAvatarDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockUnlinkIdentityProviderResponse(
  variables: UnlinkIdentityProviderMutationVariables,
  data: UnlinkIdentityProviderMutation | Error
): MockedResponse<
  UnlinkIdentityProviderMutationVariables,
  UnlinkIdentityProviderMutation
> {
  return {
    request: { query: UnlinkIdentityProviderDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockDeleteUserAvatarResponse(
  variables: DeleteUserAvatarMutationVariables,
  data: DeleteUserAvatarMutation | Error
): MockedResponse<DeleteUserAvatarMutationVariables, DeleteUserAvatarMutation> {
  return {
    request: { query: DeleteUserAvatarDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockDeleteUserBannerResponse(
  variables: DeleteUserBannerMutationVariables,
  data: DeleteUserBannerMutation | Error
): MockedResponse<DeleteUserBannerMutationVariables, DeleteUserBannerMutation> {
  return {
    request: { query: DeleteUserBannerDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockMySettingsResponse(
  variables: MySettingsQueryVariables,
  data: MySettingsQuery | Error
): MockedResponse<MySettingsQueryVariables, MySettingsQuery> {
  return {
    request: { query: MySettingsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockUpdatePasswordResponse(
  variables: UpdatePasswordMutationVariables,
  data: UpdatePasswordMutation | Error
): MockedResponse<UpdatePasswordMutationVariables, UpdatePasswordMutation> {
  return {
    request: { query: UpdatePasswordDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockUpdateUserResponse(
  variables: UpdateUserMutationVariables,
  data: UpdateUserMutation | Error
): MockedResponse<UpdateUserMutationVariables, UpdateUserMutation> {
  return {
    request: { query: UpdateUserDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetMyOrdersResponse(
  variables: GetMyOrdersQueryVariables,
  data: GetMyOrdersQuery | Error
): MockedResponse<GetMyOrdersQueryVariables, GetMyOrdersQuery> {
  return {
    request: { query: GetMyOrdersDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetPayPurchaseTransactionResponse(
  variables: GetPayPurchaseTransactionQueryVariables,
  data: GetPayPurchaseTransactionQuery | Error
): MockedResponse<
  GetPayPurchaseTransactionQueryVariables,
  GetPayPurchaseTransactionQuery
> {
  return {
    request: { query: GetPayPurchaseTransactionDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockPurchaseTransactionResponse(
  variables: PurchaseTransactionQueryVariables,
  data: PurchaseTransactionQuery | Error
): MockedResponse<PurchaseTransactionQueryVariables, PurchaseTransactionQuery> {
  return {
    request: { query: PurchaseTransactionDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockProductGroupItemsResponse(
  variables: ProductGroupItemsQueryVariables,
  data: ProductGroupItemsQuery | Error
): MockedResponse<ProductGroupItemsQueryVariables, ProductGroupItemsQuery> {
  return {
    request: { query: ProductGroupItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockCategoryProductGroupsResponse(
  variables: CategoryProductGroupsQueryVariables,
  data: CategoryProductGroupsQuery | Error
): MockedResponse<
  CategoryProductGroupsQueryVariables,
  CategoryProductGroupsQuery
> {
  return {
    request: { query: CategoryProductGroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockCatalogItemResponse(
  variables: CatalogItemQueryVariables,
  data: CatalogItemQuery | Error
): MockedResponse<CatalogItemQueryVariables, CatalogItemQuery> {
  return {
    request: { query: CatalogItemDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockCatalogItemsResponse(
  variables: CatalogItemsQueryVariables,
  data: CatalogItemsQuery | Error
): MockedResponse<CatalogItemsQueryVariables, CatalogItemsQuery> {
  return {
    request: { query: CatalogItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockCategoryCatalogResponse(
  variables: CategoryCatalogQueryVariables,
  data: CategoryCatalogQuery | Error
): MockedResponse<CategoryCatalogQueryVariables, CategoryCatalogQuery> {
  return {
    request: { query: CategoryCatalogDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetStoreMerchantPaymentMethodsResponse(
  variables: GetStoreMerchantPaymentMethodsQueryVariables,
  data: GetStoreMerchantPaymentMethodsQuery | Error
): MockedResponse<
  GetStoreMerchantPaymentMethodsQueryVariables,
  GetStoreMerchantPaymentMethodsQuery
> {
  return {
    request: { query: GetStoreMerchantPaymentMethodsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockItemSearchSuggestionsResponse(
  variables: ItemSearchSuggestionsQueryVariables,
  data: ItemSearchSuggestionsQuery | Error
): MockedResponse<
  ItemSearchSuggestionsQueryVariables,
  ItemSearchSuggestionsQuery
> {
  return {
    request: { query: ItemSearchSuggestionsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockPartnerProductGroupsResponse(
  variables: PartnerProductGroupsQueryVariables,
  data: PartnerProductGroupsQuery | Error
): MockedResponse<
  PartnerProductGroupsQueryVariables,
  PartnerProductGroupsQuery
> {
  return {
    request: { query: PartnerProductGroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockPurchaseStoreItemWithPointsResponse(
  variables: PurchaseStoreItemWithPointsMutationVariables,
  data: PurchaseStoreItemWithPointsMutation | Error
): MockedResponse<
  PurchaseStoreItemWithPointsMutationVariables,
  PurchaseStoreItemWithPointsMutation
> {
  return {
    request: { query: PurchaseStoreItemWithPointsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockPurchaseStoreItemResponse(
  variables: PurchaseStoreItemMutationVariables,
  data: PurchaseStoreItemMutation | Error
): MockedResponse<
  PurchaseStoreItemMutationVariables,
  PurchaseStoreItemMutation
> {
  return {
    request: { query: PurchaseStoreItemDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockStoreBannersResponse(
  data: StoreBannersQuery | Error
): MockedResponse<StoreBannersQueryVariables, StoreBannersQuery> {
  return {
    request: { query: StoreBannersDocument },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetTeamProfileResponse(
  variables: GetTeamProfileQueryVariables,
  data: GetTeamProfileQuery | Error
): MockedResponse<GetTeamProfileQueryVariables, GetTeamProfileQuery> {
  return {
    request: { query: GetTeamProfileDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockPurchaseSwarmioCurrencyItemResponse(
  variables: PurchaseSwarmioCurrencyItemMutationVariables,
  data: PurchaseSwarmioCurrencyItemMutation | Error
): MockedResponse<
  PurchaseSwarmioCurrencyItemMutationVariables,
  PurchaseSwarmioCurrencyItemMutation
> {
  return {
    request: { query: PurchaseSwarmioCurrencyItemDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockCreateWalletsResponse(
  variables: CreateWalletsMutationVariables,
  data: CreateWalletsMutation | Error
): MockedResponse<CreateWalletsMutationVariables, CreateWalletsMutation> {
  return {
    request: { query: CreateWalletsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetAllSwarmioCurrenciesResponse(
  data: GetAllSwarmioCurrenciesQuery | Error
): MockedResponse<
  GetAllSwarmioCurrenciesQueryVariables,
  GetAllSwarmioCurrenciesQuery
> {
  return {
    request: { query: GetAllSwarmioCurrenciesDocument },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetAllSwarmioCurrencyItemsResponse(
  data: GetAllSwarmioCurrencyItemsQuery | Error
): MockedResponse<
  GetAllSwarmioCurrencyItemsQueryVariables,
  GetAllSwarmioCurrencyItemsQuery
> {
  return {
    request: { query: GetAllSwarmioCurrencyItemsDocument },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetCurrencyPurchaseHistoryByOwnerIdResponse(
  variables: GetCurrencyPurchaseHistoryByOwnerIdQueryVariables,
  data: GetCurrencyPurchaseHistoryByOwnerIdQuery | Error
): MockedResponse<
  GetCurrencyPurchaseHistoryByOwnerIdQueryVariables,
  GetCurrencyPurchaseHistoryByOwnerIdQuery
> {
  return {
    request: { query: GetCurrencyPurchaseHistoryByOwnerIdDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetWalletsForOwnerResponse(
  variables: GetWalletsForOwnerQueryVariables,
  data: GetWalletsForOwnerQuery | Error
): MockedResponse<GetWalletsForOwnerQueryVariables, GetWalletsForOwnerQuery> {
  return {
    request: { query: GetWalletsForOwnerDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetStreamsByIdsResponse(
  variables: GetStreamsByIdsQueryVariables,
  data: GetStreamsByIdsQuery | Error
): MockedResponse<GetStreamsByIdsQueryVariables, GetStreamsByIdsQuery> {
  return {
    request: { query: GetStreamsByIdsDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetStreamsByTypeResponse(
  variables: GetStreamsByTypeQueryVariables,
  data: GetStreamsByTypeQuery | Error
): MockedResponse<GetStreamsByTypeQueryVariables, GetStreamsByTypeQuery> {
  return {
    request: { query: GetStreamsByTypeDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockGetApplicationConfigByNameResponse(
  variables: GetApplicationConfigByNameQueryVariables,
  data: GetApplicationConfigByNameQuery | Error
): MockedResponse<
  GetApplicationConfigByNameQueryVariables,
  GetApplicationConfigByNameQuery
> {
  return {
    request: { query: GetApplicationConfigByNameDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockUniqueDisplayNameResponse(
  variables: UniqueDisplayNameQueryVariables,
  data: UniqueDisplayNameQuery | Error
): MockedResponse<UniqueDisplayNameQueryVariables, UniqueDisplayNameQuery> {
  return {
    request: { query: UniqueDisplayNameDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockUniquePublicUrlResponse(
  variables: UniquePublicUrlQueryVariables,
  data: UniquePublicUrlQuery | Error
): MockedResponse<UniquePublicUrlQueryVariables, UniquePublicUrlQuery> {
  return {
    request: { query: UniquePublicUrlDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}
export function mockUniqueTeamNameResponse(
  variables: UniqueTeamNameQueryVariables,
  data: UniqueTeamNameQuery | Error
): MockedResponse<UniqueTeamNameQueryVariables, UniqueTeamNameQuery> {
  return {
    request: { query: UniqueTeamNameDocument, variables },
    result: { data: data instanceof Error ? undefined : data },
    error: data instanceof Error ? data : undefined,
  };
}

  export type MockedResponse<V, Q> = {
    request: {
      query: any;
      variables?: V;
    };
    result: {
      data?: Q;
    };
    error?: Error;
  };

export type AccessKeySpecifier = ('CmsUsers' | 'canAccessAdmin' | 'cms_banners' | 'cms_blog_pages' | 'cms_blog_posts' | 'cms_gamers' | 'cms_games' | 'cms_media' | 'payload_locked_documents' | 'payload_preferences' | AccessKeySpecifier)[];
export type AccessFieldPolicy = {
	CmsUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	canAccessAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	cms_banners?: FieldPolicy<any> | FieldReadFunction<any>,
	cms_blog_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	cms_blog_posts?: FieldPolicy<any> | FieldReadFunction<any>,
	cms_gamers?: FieldPolicy<any> | FieldReadFunction<any>,
	cms_games?: FieldPolicy<any> | FieldReadFunction<any>,
	cms_media?: FieldPolicy<any> | FieldReadFunction<any>,
	payload_locked_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	payload_preferences?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountKeySpecifier = ('accountType' | 'avatarURL' | 'bannerURL' | 'created' | 'description' | 'groupInvites' | 'groupMemberships' | 'id' | 'isSupplier' | 'managedAccounts' | 'otherFields' | 'payPurchaseTransactions' | 'publicURL' | 'purchaseTransactions' | 'socialLinks' | 'subscriptionProviderAccounts' | 'subscriptions' | 'updated' | 'wallets' | AccountKeySpecifier)[];
export type AccountFieldPolicy = {
	accountType?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarURL?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerURL?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	groupInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	groupMemberships?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSupplier?: FieldPolicy<any> | FieldReadFunction<any>,
	managedAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	otherFields?: FieldPolicy<any> | FieldReadFunction<any>,
	payPurchaseTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	publicURL?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	socialLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProviderAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>,
	wallets?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountInviteKeySpecifier = ('accountId' | 'created' | 'id' | 'isError' | 'roles' | AccountInviteKeySpecifier)[];
export type AccountInviteFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountInviteWithPossibleErrorKeySpecifier = ('isError' | AccountInviteWithPossibleErrorKeySpecifier)[];
export type AccountInviteWithPossibleErrorFieldPolicy = {
	isError?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountManagerKeySpecifier = ('accountId' | 'isError' | 'roles' | AccountManagerKeySpecifier)[];
export type AccountManagerFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountManagerWithPossibleErrorKeySpecifier = ('isError' | AccountManagerWithPossibleErrorKeySpecifier)[];
export type AccountManagerWithPossibleErrorFieldPolicy = {
	isError?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountNotificationKeySpecifier = ('created' | 'defaultMessage' | 'expiry' | 'fields' | 'id' | 'notificationType' | 'read' | AccountNotificationKeySpecifier)[];
export type AccountNotificationFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	expiry?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationType?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountNotificationEventKeySpecifier = ('created' | 'defaultMessage' | 'expiry' | 'fields' | 'id' | 'notificationType' | 'read' | AccountNotificationEventKeySpecifier)[];
export type AccountNotificationEventFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	expiry?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationType?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountProjectionKeySpecifier = ('accountManagers' | 'avatarURL' | 'birthday' | 'created' | 'displayName' | 'email' | 'emailContact' | 'emailVerified' | 'groupInvites' | 'groupMemberships' | 'id' | 'linkedAccounts' | 'managedAccounts' | 'msisdn' | 'msisdnContact' | 'otherContact' | 'publicURL' | 'realName' | 'updated' | 'userType' | AccountProjectionKeySpecifier)[];
export type AccountProjectionFieldPolicy = {
	accountManagers?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarURL?: FieldPolicy<any> | FieldReadFunction<any>,
	birthday?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	emailContact?: FieldPolicy<any> | FieldReadFunction<any>,
	emailVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	groupInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	groupMemberships?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	managedAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	msisdn?: FieldPolicy<any> | FieldReadFunction<any>,
	msisdnContact?: FieldPolicy<any> | FieldReadFunction<any>,
	otherContact?: FieldPolicy<any> | FieldReadFunction<any>,
	publicURL?: FieldPolicy<any> | FieldReadFunction<any>,
	realName?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>,
	userType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountTagKeySpecifier = ('label' | 'value' | AccountTagKeySpecifier)[];
export type AccountTagFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActionNotAllowedErrorKeySpecifier = ('isError' | 'message' | ActionNotAllowedErrorKeySpecifier)[];
export type ActionNotAllowedErrorFieldPolicy = {
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdditionalInformationKeySpecifier = ('key' | 'value' | AdditionalInformationKeySpecifier)[];
export type AdditionalInformationFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AdvanceStrategyKeySpecifier = ('advanceStrategyType' | AdvanceStrategyKeySpecifier)[];
export type AdvanceStrategyFieldPolicy = {
	advanceStrategyType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AllServHealthCheckKeySpecifier = ('company' | 'health' | 'message' | 'status' | AllServHealthCheckKeySpecifier)[];
export type AllServHealthCheckFieldPolicy = {
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	health?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ApplicationConfigKeySpecifier = ('created' | 'description' | 'featureFlags' | 'id' | 'name' | 'updated' | ApplicationConfigKeySpecifier)[];
export type ApplicationConfigFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	featureFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AtLeastPlacementAdvanceStrategyKeySpecifier = ('advanceStrategyType' | 'placement' | AtLeastPlacementAdvanceStrategyKeySpecifier)[];
export type AtLeastPlacementAdvanceStrategyFieldPolicy = {
	advanceStrategyType?: FieldPolicy<any> | FieldReadFunction<any>,
	placement?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AutomaticallyVerifiedResultsForRoundFromParticipantKeySpecifier = ('competitionId' | 'created' | 'fromParticipantId' | 'plzDelete' | 'roundId' | 'unverifiedResults' | AutomaticallyVerifiedResultsForRoundFromParticipantKeySpecifier)[];
export type AutomaticallyVerifiedResultsForRoundFromParticipantFieldPolicy = {
	competitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	fromParticipantId?: FieldPolicy<any> | FieldReadFunction<any>,
	plzDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	roundId?: FieldPolicy<any> | FieldReadFunction<any>,
	unverifiedResults?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BannerKeySpecifier = ('buttonText' | 'created' | 'description' | 'id' | 'logoUrl' | 'primaryImageUrl' | 'redirectUrl' | 'secondaryImageUrl' | 'title' | 'updated' | BannerKeySpecifier)[];
export type BannerFieldPolicy = {
	buttonText?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	logoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BaseEventTeamMemberKeySpecifier = ('accountId' | 'id' | 'roles' | BaseEventTeamMemberKeySpecifier)[];
export type BaseEventTeamMemberFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BasicAutomaticallyVerifiedResultKeySpecifier = ('participantId' | 'score' | BasicAutomaticallyVerifiedResultKeySpecifier)[];
export type BasicAutomaticallyVerifiedResultFieldPolicy = {
	participantId?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BasicResultKeySpecifier = ('id' | 'maybeShowed' | 'placement' | 'prizePayoutReceipt' | 'resultImageURLs' | 'score' | 'showed' | BasicResultKeySpecifier)[];
export type BasicResultFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeShowed?: FieldPolicy<any> | FieldReadFunction<any>,
	placement?: FieldPolicy<any> | FieldReadFunction<any>,
	prizePayoutReceipt?: FieldPolicy<any> | FieldReadFunction<any>,
	resultImageURLs?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>,
	showed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BattleRoyaleSpecificDetailsKeySpecifier = ('advanceFraction' | 'definedBucketDimensionsMap' | 'id' | 'matchUpFormat' | 'maxRoundParticipants' | 'maybeMaxRoundParticipants' | 'maybeParticipantsInRound' | BattleRoyaleSpecificDetailsKeySpecifier)[];
export type BattleRoyaleSpecificDetailsFieldPolicy = {
	advanceFraction?: FieldPolicy<any> | FieldReadFunction<any>,
	definedBucketDimensionsMap?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	matchUpFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	maxRoundParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeMaxRoundParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeParticipantsInRound?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BeedlePaymentKeySpecifier = ('alternateTransactionId' | 'amount' | 'currency' | 'externalPaymentServiceId' | 'id' | 'internalPaymentServiceId' | 'paymentType' | 'purchaseTransactionId' | 'received' | BeedlePaymentKeySpecifier)[];
export type BeedlePaymentFieldPolicy = {
	alternateTransactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	externalPaymentServiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalPaymentServiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentType?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseTransactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	received?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BotsKeySpecifier = ('difficulty' | 'quota' | BotsKeySpecifier)[];
export type BotsFieldPolicy = {
	difficulty?: FieldPolicy<any> | FieldReadFunction<any>,
	quota?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BoughtTransactionKeySpecifier = ('amount' | 'created' | 'id' | 'notes' | 'swarmioCurrencyItemCostPurchaseRequest' | 'swarmioCurrencyItemCostPurchaseRequestId' | 'transactionType' | 'wallet' | 'walletId' | BoughtTransactionKeySpecifier)[];
export type BoughtTransactionFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyItemCostPurchaseRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyItemCostPurchaseRequestId?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionType?: FieldPolicy<any> | FieldReadFunction<any>,
	wallet?: FieldPolicy<any> | FieldReadFunction<any>,
	walletId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BracketModificationsKeySpecifier = ('bracketName' | 'phaseModifications' | BracketModificationsKeySpecifier)[];
export type BracketModificationsFieldPolicy = {
	bracketName?: FieldPolicy<any> | FieldReadFunction<any>,
	phaseModifications?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BreakStrategyKeySpecifier = ('breakStrategyType' | BreakStrategyKeySpecifier)[];
export type BreakStrategyFieldPolicy = {
	breakStrategyType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BucketDimensionsMapKeySpecifier = ('allBucketMultipliers' | 'bucketLabel' | 'id' | BucketDimensionsMapKeySpecifier)[];
export type BucketDimensionsMapFieldPolicy = {
	allBucketMultipliers?: FieldPolicy<any> | FieldReadFunction<any>,
	bucketLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BucketMultipliersKeySpecifier = ('dimensionMultipliers' | 'id' | 'resultBucket' | 'staticValue' | BucketMultipliersKeySpecifier)[];
export type BucketMultipliersFieldPolicy = {
	dimensionMultipliers?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	resultBucket?: FieldPolicy<any> | FieldReadFunction<any>,
	staticValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CSGOCompetitionDetailsKeySpecifier = ('gameId' | 'maxOvertimeRounds' | 'maxRounds' | CSGOCompetitionDetailsKeySpecifier)[];
export type CSGOCompetitionDetailsFieldPolicy = {
	gameId?: FieldPolicy<any> | FieldReadFunction<any>,
	maxOvertimeRounds?: FieldPolicy<any> | FieldReadFunction<any>,
	maxRounds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CSGOMatchDetailsKeySpecifier = ('gameId' | 'serverDetails' | CSGOMatchDetailsKeySpecifier)[];
export type CSGOMatchDetailsFieldPolicy = {
	gameId?: FieldPolicy<any> | FieldReadFunction<any>,
	serverDetails?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CSVFileKeySpecifier = ('availableProducts' | 'availableVouchers' | 'createdBy' | 'createdDate' | 'fileName' | 'fileStatus' | 'fileUrl' | 'id' | 'modifiedBy' | 'modifiedDate' | 'supplier' | 'totalProducts' | 'totalVouchers' | CSVFileKeySpecifier)[];
export type CSVFileFieldPolicy = {
	availableProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	availableVouchers?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	fileStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>,
	totalProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVouchers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CashOutTransactionKeySpecifier = ('amount' | 'created' | 'id' | 'notes' | 'swarmioCurrencyPayoutRequest' | 'swarmioCurrencyPayoutRequestId' | 'transactionType' | 'wallet' | 'walletId' | CashOutTransactionKeySpecifier)[];
export type CashOutTransactionFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyPayoutRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyPayoutRequestId?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionType?: FieldPolicy<any> | FieldReadFunction<any>,
	wallet?: FieldPolicy<any> | FieldReadFunction<any>,
	walletId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CatalogKeySpecifier = ('catalogId' | 'catalogName' | 'categoryOrder' | 'createdBy' | 'createdDate' | 'itemOrder' | 'partner' | CatalogKeySpecifier)[];
export type CatalogFieldPolicy = {
	catalogId?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogName?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	itemOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	partner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CatalogItemKeySpecifier = ('availablePaymentChannels' | 'contentType' | 'deal' | 'displayName' | 'fields' | 'id' | 'isActive' | 'itemDescBrief' | 'itemDescDetail' | 'itemGalleryUrls' | 'itemId' | 'itemImageUrl' | 'itemName' | 'itemType' | 'outOfStockImageUrl' | 'productId' | 'productOrigin' | 'productPrices' | 'productType' | 'sourceCurrency' | 'stock' | CatalogItemKeySpecifier)[];
export type CatalogItemFieldPolicy = {
	availablePaymentChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	deal?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDescBrief?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDescDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	itemGalleryUrls?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	outOfStockImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	productId?: FieldPolicy<any> | FieldReadFunction<any>,
	productOrigin?: FieldPolicy<any> | FieldReadFunction<any>,
	productPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	stock?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CatalogItemDealKeySpecifier = ('dealActivePaymentChannels' | 'dealId' | 'dealName' | 'dealPercentage' | 'endDateTime' | 'isActive' | 'startDateTime' | CatalogItemDealKeySpecifier)[];
export type CatalogItemDealFieldPolicy = {
	dealActivePaymentChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	dealId?: FieldPolicy<any> | FieldReadFunction<any>,
	dealName?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	endDateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	startDateTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CatalogMappingDtoKeySpecifier = ('catalogId' | 'catalogName' | 'dealExist' | CatalogMappingDtoKeySpecifier)[];
export type CatalogMappingDtoFieldPolicy = {
	catalogId?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogName?: FieldPolicy<any> | FieldReadFunction<any>,
	dealExist?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryKeySpecifier = ('categoryCoverImage' | 'categoryDescription' | 'categoryIcon' | 'categoryId' | 'categoryImage' | 'categoryName' | 'featured' | 'groupOrder' | 'id' | 'isActive' | 'isDeleted' | 'parentCategory' | 'productGroupCatalogCategory' | 'urlMask' | CategoryKeySpecifier)[];
export type CategoryFieldPolicy = {
	categoryCoverImage?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryImage?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	groupOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	parentCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupCatalogCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	urlMask?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryCatalogKeySpecifier = ('categoryCoverImage' | 'categoryDescription' | 'categoryIcon' | 'categoryId' | 'categoryImage' | 'categoryName' | 'featured' | 'id' | 'productGroups' | 'urlMask' | CategoryCatalogKeySpecifier)[];
export type CategoryCatalogFieldPolicy = {
	categoryCoverImage?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryImage?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	urlMask?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryCatalogResponseKeySpecifier = ('categories' | 'currentPage' | 'totalCategories' | 'totalPages' | CategoryCatalogResponseKeySpecifier)[];
export type CategoryCatalogResponseFieldPolicy = {
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryDtoKeySpecifier = ('categoryCoverImage' | 'categoryDescription' | 'categoryIcon' | 'categoryId' | 'categoryImage' | 'categoryName' | 'featured' | 'groupCount' | 'groupOrder' | 'id' | 'isActive' | 'isDeleted' | 'mappedPartners' | 'parentCategory' | 'productGroupCatalogCategory' | CategoryDtoKeySpecifier)[];
export type CategoryDtoFieldPolicy = {
	categoryCoverImage?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryImage?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	groupCount?: FieldPolicy<any> | FieldReadFunction<any>,
	groupOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	mappedPartners?: FieldPolicy<any> | FieldReadFunction<any>,
	parentCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupCatalogCategory?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryInfoKeySpecifier = ('categoryCoverImage' | 'categoryDescription' | 'categoryIcon' | 'categoryId' | 'categoryImage' | 'categoryName' | 'featured' | 'groupOrder' | 'id' | 'isActive' | 'isDeleted' | 'parentCategory' | 'productGroupCatalogCategory' | 'urlMask' | CategoryInfoKeySpecifier)[];
export type CategoryInfoFieldPolicy = {
	categoryCoverImage?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryImage?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	groupOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	parentCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupCatalogCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	urlMask?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryLanguageKeySpecifier = ('categoryId' | 'categoryName' | 'id' | 'languages' | 'unConfiguredLanguageIds' | CategoryLanguageKeySpecifier)[];
export type CategoryLanguageFieldPolicy = {
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	languages?: FieldPolicy<any> | FieldReadFunction<any>,
	unConfiguredLanguageIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryLanguageDataResponseKeySpecifier = ('categoryDescription' | 'categoryId' | 'categoryName' | CategoryLanguageDataResponseKeySpecifier)[];
export type CategoryLanguageDataResponseFieldPolicy = {
	categoryDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryLanguageDetailsKeySpecifier = ('categoryDescription' | 'categoryId' | 'categoryName' | 'countryCode' | 'isDefault' | 'isLanguageConfigured' | 'languageCode' | 'languageId' | 'languageName' | 'mappedPartnerLanguage' | CategoryLanguageDetailsKeySpecifier)[];
export type CategoryLanguageDetailsFieldPolicy = {
	categoryDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	isLanguageConfigured?: FieldPolicy<any> | FieldReadFunction<any>,
	languageCode?: FieldPolicy<any> | FieldReadFunction<any>,
	languageId?: FieldPolicy<any> | FieldReadFunction<any>,
	languageName?: FieldPolicy<any> | FieldReadFunction<any>,
	mappedPartnerLanguage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryProductGroupResponseKeySpecifier = ('bannerImage' | 'description' | 'displayName' | 'featured' | 'id' | 'items' | 'name' | 'productGroupId' | 'thumbnail' | 'urlMask' | CategoryProductGroupResponseKeySpecifier)[];
export type CategoryProductGroupResponseFieldPolicy = {
	bannerImage?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	urlMask?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryResponseDataKeySpecifier = ('categories' | 'currentPage' | 'totalActiveCategories' | 'totalCategories' | 'totalDeletedCategories' | 'totalFilteredCategories' | 'totalInactiveCategories' | 'totalPages' | CategoryResponseDataKeySpecifier)[];
export type CategoryResponseDataFieldPolicy = {
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalActiveCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDeletedCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFilteredCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	totalInactiveCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChallengeKeySpecifier = ('challengeFormat' | 'competitionSpecificDetails' | 'competitionState' | 'competitionTiming' | 'competitionType' | 'created' | 'event' | 'eventId' | 'eventStageId' | 'game' | 'gameId' | 'gameSpecificDetails' | 'id' | 'manualAdvancement' | 'participantType' | 'participants' | ChallengeKeySpecifier)[];
export type ChallengeFieldPolicy = {
	challengeFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionState?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionTiming?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionType?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventStageId?: FieldPolicy<any> | FieldReadFunction<any>,
	game?: FieldPolicy<any> | FieldReadFunction<any>,
	gameId?: FieldPolicy<any> | FieldReadFunction<any>,
	gameSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	manualAdvancement?: FieldPolicy<any> | FieldReadFunction<any>,
	participantType?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChallengeSpecificDetailsKeySpecifier = ('ChallengeFormat' | 'id' | ChallengeSpecificDetailsKeySpecifier)[];
export type ChallengeSpecificDetailsFieldPolicy = {
	ChallengeFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientNotificationEventKeySpecifier = ('created' | 'defaultMessage' | 'expiry' | 'fields' | 'id' | 'notificationType' | 'targetId' | ClientNotificationEventKeySpecifier)[];
export type ClientNotificationEventFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	expiry?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationType?: FieldPolicy<any> | FieldReadFunction<any>,
	targetId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ClientVisibleErrorKeySpecifier = ('isError' | 'message' | ClientVisibleErrorKeySpecifier)[];
export type ClientVisibleErrorFieldPolicy = {
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannerKeySpecifier = ('createdAt' | 'featuredImage' | 'id' | 'link' | 'relatedPost' | 'title' | 'updatedAt' | CmsBannerKeySpecifier)[];
export type CmsBannerFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredImage?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedPost?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersKeySpecifier = ('docs' | 'hasNextPage' | 'hasPrevPage' | 'limit' | 'nextPage' | 'offset' | 'page' | 'pagingCounter' | 'prevPage' | 'totalDocs' | 'totalPages' | CmsBannersKeySpecifier)[];
export type CmsBannersFieldPolicy = {
	docs?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPrevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	nextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pagingCounter?: FieldPolicy<any> | FieldReadFunction<any>,
	prevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersCreateAccessKeySpecifier = ('permission' | 'where' | CmsBannersCreateAccessKeySpecifier)[];
export type CmsBannersCreateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersCreateDocAccessKeySpecifier = ('permission' | 'where' | CmsBannersCreateDocAccessKeySpecifier)[];
export type CmsBannersCreateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDeleteAccessKeySpecifier = ('permission' | 'where' | CmsBannersDeleteAccessKeySpecifier)[];
export type CmsBannersDeleteAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDeleteDocAccessKeySpecifier = ('permission' | 'where' | CmsBannersDeleteDocAccessKeySpecifier)[];
export type CmsBannersDeleteDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFieldsKeySpecifier = ('createdAt' | 'featuredImage' | 'link' | 'relatedPost' | 'title' | 'updatedAt' | CmsBannersDocAccessFieldsKeySpecifier)[];
export type CmsBannersDocAccessFieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredImage?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedPost?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBannersDocAccessFields_createdAtKeySpecifier)[];
export type CmsBannersDocAccessFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_createdAt_CreateKeySpecifier = ('permission' | CmsBannersDocAccessFields_createdAt_CreateKeySpecifier)[];
export type CmsBannersDocAccessFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_createdAt_DeleteKeySpecifier = ('permission' | CmsBannersDocAccessFields_createdAt_DeleteKeySpecifier)[];
export type CmsBannersDocAccessFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_createdAt_ReadKeySpecifier = ('permission' | CmsBannersDocAccessFields_createdAt_ReadKeySpecifier)[];
export type CmsBannersDocAccessFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_createdAt_UpdateKeySpecifier = ('permission' | CmsBannersDocAccessFields_createdAt_UpdateKeySpecifier)[];
export type CmsBannersDocAccessFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_featuredImageKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBannersDocAccessFields_featuredImageKeySpecifier)[];
export type CmsBannersDocAccessFields_featuredImageFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_featuredImage_CreateKeySpecifier = ('permission' | CmsBannersDocAccessFields_featuredImage_CreateKeySpecifier)[];
export type CmsBannersDocAccessFields_featuredImage_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_featuredImage_DeleteKeySpecifier = ('permission' | CmsBannersDocAccessFields_featuredImage_DeleteKeySpecifier)[];
export type CmsBannersDocAccessFields_featuredImage_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_featuredImage_ReadKeySpecifier = ('permission' | CmsBannersDocAccessFields_featuredImage_ReadKeySpecifier)[];
export type CmsBannersDocAccessFields_featuredImage_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_featuredImage_UpdateKeySpecifier = ('permission' | CmsBannersDocAccessFields_featuredImage_UpdateKeySpecifier)[];
export type CmsBannersDocAccessFields_featuredImage_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_linkKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBannersDocAccessFields_linkKeySpecifier)[];
export type CmsBannersDocAccessFields_linkFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_link_CreateKeySpecifier = ('permission' | CmsBannersDocAccessFields_link_CreateKeySpecifier)[];
export type CmsBannersDocAccessFields_link_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_link_DeleteKeySpecifier = ('permission' | CmsBannersDocAccessFields_link_DeleteKeySpecifier)[];
export type CmsBannersDocAccessFields_link_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_link_ReadKeySpecifier = ('permission' | CmsBannersDocAccessFields_link_ReadKeySpecifier)[];
export type CmsBannersDocAccessFields_link_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_link_UpdateKeySpecifier = ('permission' | CmsBannersDocAccessFields_link_UpdateKeySpecifier)[];
export type CmsBannersDocAccessFields_link_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_relatedPostKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBannersDocAccessFields_relatedPostKeySpecifier)[];
export type CmsBannersDocAccessFields_relatedPostFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_relatedPost_CreateKeySpecifier = ('permission' | CmsBannersDocAccessFields_relatedPost_CreateKeySpecifier)[];
export type CmsBannersDocAccessFields_relatedPost_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_relatedPost_DeleteKeySpecifier = ('permission' | CmsBannersDocAccessFields_relatedPost_DeleteKeySpecifier)[];
export type CmsBannersDocAccessFields_relatedPost_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_relatedPost_ReadKeySpecifier = ('permission' | CmsBannersDocAccessFields_relatedPost_ReadKeySpecifier)[];
export type CmsBannersDocAccessFields_relatedPost_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_relatedPost_UpdateKeySpecifier = ('permission' | CmsBannersDocAccessFields_relatedPost_UpdateKeySpecifier)[];
export type CmsBannersDocAccessFields_relatedPost_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_titleKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBannersDocAccessFields_titleKeySpecifier)[];
export type CmsBannersDocAccessFields_titleFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_title_CreateKeySpecifier = ('permission' | CmsBannersDocAccessFields_title_CreateKeySpecifier)[];
export type CmsBannersDocAccessFields_title_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_title_DeleteKeySpecifier = ('permission' | CmsBannersDocAccessFields_title_DeleteKeySpecifier)[];
export type CmsBannersDocAccessFields_title_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_title_ReadKeySpecifier = ('permission' | CmsBannersDocAccessFields_title_ReadKeySpecifier)[];
export type CmsBannersDocAccessFields_title_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_title_UpdateKeySpecifier = ('permission' | CmsBannersDocAccessFields_title_UpdateKeySpecifier)[];
export type CmsBannersDocAccessFields_title_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBannersDocAccessFields_updatedAtKeySpecifier)[];
export type CmsBannersDocAccessFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_updatedAt_CreateKeySpecifier = ('permission' | CmsBannersDocAccessFields_updatedAt_CreateKeySpecifier)[];
export type CmsBannersDocAccessFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsBannersDocAccessFields_updatedAt_DeleteKeySpecifier)[];
export type CmsBannersDocAccessFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_updatedAt_ReadKeySpecifier = ('permission' | CmsBannersDocAccessFields_updatedAt_ReadKeySpecifier)[];
export type CmsBannersDocAccessFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersDocAccessFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsBannersDocAccessFields_updatedAt_UpdateKeySpecifier)[];
export type CmsBannersDocAccessFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFieldsKeySpecifier = ('createdAt' | 'featuredImage' | 'link' | 'relatedPost' | 'title' | 'updatedAt' | CmsBannersFieldsKeySpecifier)[];
export type CmsBannersFieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredImage?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedPost?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBannersFields_createdAtKeySpecifier)[];
export type CmsBannersFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_createdAt_CreateKeySpecifier = ('permission' | CmsBannersFields_createdAt_CreateKeySpecifier)[];
export type CmsBannersFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_createdAt_DeleteKeySpecifier = ('permission' | CmsBannersFields_createdAt_DeleteKeySpecifier)[];
export type CmsBannersFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_createdAt_ReadKeySpecifier = ('permission' | CmsBannersFields_createdAt_ReadKeySpecifier)[];
export type CmsBannersFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_createdAt_UpdateKeySpecifier = ('permission' | CmsBannersFields_createdAt_UpdateKeySpecifier)[];
export type CmsBannersFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_featuredImageKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBannersFields_featuredImageKeySpecifier)[];
export type CmsBannersFields_featuredImageFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_featuredImage_CreateKeySpecifier = ('permission' | CmsBannersFields_featuredImage_CreateKeySpecifier)[];
export type CmsBannersFields_featuredImage_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_featuredImage_DeleteKeySpecifier = ('permission' | CmsBannersFields_featuredImage_DeleteKeySpecifier)[];
export type CmsBannersFields_featuredImage_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_featuredImage_ReadKeySpecifier = ('permission' | CmsBannersFields_featuredImage_ReadKeySpecifier)[];
export type CmsBannersFields_featuredImage_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_featuredImage_UpdateKeySpecifier = ('permission' | CmsBannersFields_featuredImage_UpdateKeySpecifier)[];
export type CmsBannersFields_featuredImage_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_linkKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBannersFields_linkKeySpecifier)[];
export type CmsBannersFields_linkFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_link_CreateKeySpecifier = ('permission' | CmsBannersFields_link_CreateKeySpecifier)[];
export type CmsBannersFields_link_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_link_DeleteKeySpecifier = ('permission' | CmsBannersFields_link_DeleteKeySpecifier)[];
export type CmsBannersFields_link_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_link_ReadKeySpecifier = ('permission' | CmsBannersFields_link_ReadKeySpecifier)[];
export type CmsBannersFields_link_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_link_UpdateKeySpecifier = ('permission' | CmsBannersFields_link_UpdateKeySpecifier)[];
export type CmsBannersFields_link_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_relatedPostKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBannersFields_relatedPostKeySpecifier)[];
export type CmsBannersFields_relatedPostFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_relatedPost_CreateKeySpecifier = ('permission' | CmsBannersFields_relatedPost_CreateKeySpecifier)[];
export type CmsBannersFields_relatedPost_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_relatedPost_DeleteKeySpecifier = ('permission' | CmsBannersFields_relatedPost_DeleteKeySpecifier)[];
export type CmsBannersFields_relatedPost_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_relatedPost_ReadKeySpecifier = ('permission' | CmsBannersFields_relatedPost_ReadKeySpecifier)[];
export type CmsBannersFields_relatedPost_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_relatedPost_UpdateKeySpecifier = ('permission' | CmsBannersFields_relatedPost_UpdateKeySpecifier)[];
export type CmsBannersFields_relatedPost_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_titleKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBannersFields_titleKeySpecifier)[];
export type CmsBannersFields_titleFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_title_CreateKeySpecifier = ('permission' | CmsBannersFields_title_CreateKeySpecifier)[];
export type CmsBannersFields_title_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_title_DeleteKeySpecifier = ('permission' | CmsBannersFields_title_DeleteKeySpecifier)[];
export type CmsBannersFields_title_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_title_ReadKeySpecifier = ('permission' | CmsBannersFields_title_ReadKeySpecifier)[];
export type CmsBannersFields_title_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_title_UpdateKeySpecifier = ('permission' | CmsBannersFields_title_UpdateKeySpecifier)[];
export type CmsBannersFields_title_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBannersFields_updatedAtKeySpecifier)[];
export type CmsBannersFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_updatedAt_CreateKeySpecifier = ('permission' | CmsBannersFields_updatedAt_CreateKeySpecifier)[];
export type CmsBannersFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsBannersFields_updatedAt_DeleteKeySpecifier)[];
export type CmsBannersFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_updatedAt_ReadKeySpecifier = ('permission' | CmsBannersFields_updatedAt_ReadKeySpecifier)[];
export type CmsBannersFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsBannersFields_updatedAt_UpdateKeySpecifier)[];
export type CmsBannersFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersReadAccessKeySpecifier = ('permission' | 'where' | CmsBannersReadAccessKeySpecifier)[];
export type CmsBannersReadAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersReadDocAccessKeySpecifier = ('permission' | 'where' | CmsBannersReadDocAccessKeySpecifier)[];
export type CmsBannersReadDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersUpdateAccessKeySpecifier = ('permission' | 'where' | CmsBannersUpdateAccessKeySpecifier)[];
export type CmsBannersUpdateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBannersUpdateDocAccessKeySpecifier = ('permission' | 'where' | CmsBannersUpdateDocAccessKeySpecifier)[];
export type CmsBannersUpdateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPageKeySpecifier = ('createdAt' | 'id' | 'sections' | 'slug' | 'status' | 'title' | 'updatedAt' | CmsBlogPageKeySpecifier)[];
export type CmsBlogPageFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sections?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPage_SectionsKeySpecifier = ('featuredBanners' | 'featuredBlogPosts' | 'featuredGamers' | 'featuredGames' | 'id' | 'sectionTitle' | 'sectionType' | CmsBlogPage_SectionsKeySpecifier)[];
export type CmsBlogPage_SectionsFieldPolicy = {
	featuredBanners?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredBlogPosts?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredGamers?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredGames?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesKeySpecifier = ('docs' | 'hasNextPage' | 'hasPrevPage' | 'limit' | 'nextPage' | 'offset' | 'page' | 'pagingCounter' | 'prevPage' | 'totalDocs' | 'totalPages' | CmsBlogPagesKeySpecifier)[];
export type CmsBlogPagesFieldPolicy = {
	docs?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPrevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	nextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pagingCounter?: FieldPolicy<any> | FieldReadFunction<any>,
	prevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesCreateAccessKeySpecifier = ('permission' | 'where' | CmsBlogPagesCreateAccessKeySpecifier)[];
export type CmsBlogPagesCreateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesCreateDocAccessKeySpecifier = ('permission' | 'where' | CmsBlogPagesCreateDocAccessKeySpecifier)[];
export type CmsBlogPagesCreateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDeleteAccessKeySpecifier = ('permission' | 'where' | CmsBlogPagesDeleteAccessKeySpecifier)[];
export type CmsBlogPagesDeleteAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDeleteDocAccessKeySpecifier = ('permission' | 'where' | CmsBlogPagesDeleteDocAccessKeySpecifier)[];
export type CmsBlogPagesDeleteDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFieldsKeySpecifier = ('createdAt' | 'sections' | 'slug' | 'status' | 'title' | 'updatedAt' | CmsBlogPagesDocAccessFieldsKeySpecifier)[];
export type CmsBlogPagesDocAccessFieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	sections?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesDocAccessFields_createdAtKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_createdAt_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_createdAt_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_createdAt_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_createdAt_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_createdAt_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_createdAt_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_createdAt_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_createdAt_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sectionsKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsBlogPagesDocAccessFields_sectionsKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sectionsFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_FieldsKeySpecifier = ('featuredBanners' | 'featuredBlogPosts' | 'featuredGamers' | 'featuredGames' | 'id' | 'sectionTitle' | 'sectionType' | CmsBlogPagesDocAccessFields_sections_FieldsKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_FieldsFieldPolicy = {
	featuredBanners?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredBlogPosts?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredGamers?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredGames?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredBannersKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesDocAccessFields_sections_featuredBannersKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredBannersFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredBanners_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredBanners_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredBanners_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredBanners_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredBanners_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredBanners_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredBanners_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredBanners_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredBanners_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredBanners_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredBanners_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredBanners_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredBlogPostsKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesDocAccessFields_sections_featuredBlogPostsKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredBlogPostsFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredGamersKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesDocAccessFields_sections_featuredGamersKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredGamersFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredGamers_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredGamers_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredGamers_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredGamers_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredGamers_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredGamers_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredGamers_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredGamers_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredGamers_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredGamers_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredGamers_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredGamers_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredGamesKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesDocAccessFields_sections_featuredGamesKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredGamesFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredGames_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredGames_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredGames_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredGames_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredGames_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredGames_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredGames_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredGames_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredGames_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_featuredGames_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_featuredGames_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_featuredGames_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_idKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesDocAccessFields_sections_idKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_idFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_id_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_id_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_id_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_id_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_id_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_id_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_id_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_id_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_id_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_id_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_id_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_id_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_sectionTitleKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesDocAccessFields_sections_sectionTitleKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_sectionTitleFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_sectionTitle_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_sectionTitle_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_sectionTitle_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_sectionTitle_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_sectionTitle_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_sectionTitle_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_sectionTitle_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_sectionTitle_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_sectionTitle_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_sectionTitle_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_sectionTitle_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_sectionTitle_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_sectionTypeKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesDocAccessFields_sections_sectionTypeKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_sectionTypeFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_sectionType_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_sectionType_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_sectionType_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_sectionType_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_sectionType_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_sectionType_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_sectionType_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_sectionType_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_sectionType_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_sections_sectionType_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_sections_sectionType_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_sections_sectionType_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_slugKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesDocAccessFields_slugKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_slugFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_slug_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_slug_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_slug_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_slug_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_slug_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_slug_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_slug_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_slug_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_slug_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_slug_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_slug_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_slug_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_statusKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesDocAccessFields_statusKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_statusFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_status_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_status_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_status_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_status_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_status_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_status_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_status_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_status_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_status_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_status_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_status_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_status_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_titleKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesDocAccessFields_titleKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_titleFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_title_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_title_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_title_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_title_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_title_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_title_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_title_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_title_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_title_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_title_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_title_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_title_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesDocAccessFields_updatedAtKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_updatedAt_CreateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_updatedAt_CreateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_updatedAt_DeleteKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_updatedAt_ReadKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_updatedAt_ReadKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesDocAccessFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsBlogPagesDocAccessFields_updatedAt_UpdateKeySpecifier)[];
export type CmsBlogPagesDocAccessFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFieldsKeySpecifier = ('createdAt' | 'sections' | 'slug' | 'status' | 'title' | 'updatedAt' | CmsBlogPagesFieldsKeySpecifier)[];
export type CmsBlogPagesFieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	sections?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesFields_createdAtKeySpecifier)[];
export type CmsBlogPagesFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_createdAt_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_createdAt_CreateKeySpecifier)[];
export type CmsBlogPagesFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_createdAt_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_createdAt_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_createdAt_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_createdAt_ReadKeySpecifier)[];
export type CmsBlogPagesFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_createdAt_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_createdAt_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sectionsKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsBlogPagesFields_sectionsKeySpecifier)[];
export type CmsBlogPagesFields_sectionsFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_CreateKeySpecifier)[];
export type CmsBlogPagesFields_sections_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_sections_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_sections_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_FieldsKeySpecifier = ('featuredBanners' | 'featuredBlogPosts' | 'featuredGamers' | 'featuredGames' | 'id' | 'sectionTitle' | 'sectionType' | CmsBlogPagesFields_sections_FieldsKeySpecifier)[];
export type CmsBlogPagesFields_sections_FieldsFieldPolicy = {
	featuredBanners?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredBlogPosts?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredGamers?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredGames?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	sectionType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_sections_ReadKeySpecifier)[];
export type CmsBlogPagesFields_sections_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_sections_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredBannersKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesFields_sections_featuredBannersKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredBannersFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredBanners_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredBanners_CreateKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredBanners_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredBanners_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredBanners_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredBanners_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredBanners_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredBanners_ReadKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredBanners_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredBanners_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredBanners_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredBanners_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredBlogPostsKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesFields_sections_featuredBlogPostsKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredBlogPostsFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredBlogPosts_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredBlogPosts_CreateKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredBlogPosts_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredBlogPosts_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredBlogPosts_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredBlogPosts_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredBlogPosts_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredBlogPosts_ReadKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredBlogPosts_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredBlogPosts_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredBlogPosts_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredBlogPosts_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredGamersKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesFields_sections_featuredGamersKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredGamersFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredGamers_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredGamers_CreateKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredGamers_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredGamers_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredGamers_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredGamers_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredGamers_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredGamers_ReadKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredGamers_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredGamers_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredGamers_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredGamers_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredGamesKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesFields_sections_featuredGamesKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredGamesFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredGames_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredGames_CreateKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredGames_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredGames_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredGames_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredGames_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredGames_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredGames_ReadKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredGames_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_featuredGames_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_featuredGames_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_sections_featuredGames_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_idKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesFields_sections_idKeySpecifier)[];
export type CmsBlogPagesFields_sections_idFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_id_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_id_CreateKeySpecifier)[];
export type CmsBlogPagesFields_sections_id_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_id_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_sections_id_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_sections_id_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_id_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_sections_id_ReadKeySpecifier)[];
export type CmsBlogPagesFields_sections_id_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_id_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_id_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_sections_id_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_sectionTitleKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesFields_sections_sectionTitleKeySpecifier)[];
export type CmsBlogPagesFields_sections_sectionTitleFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_sectionTitle_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_sectionTitle_CreateKeySpecifier)[];
export type CmsBlogPagesFields_sections_sectionTitle_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_sectionTitle_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_sections_sectionTitle_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_sections_sectionTitle_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_sectionTitle_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_sections_sectionTitle_ReadKeySpecifier)[];
export type CmsBlogPagesFields_sections_sectionTitle_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_sectionTitle_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_sectionTitle_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_sections_sectionTitle_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_sectionTypeKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesFields_sections_sectionTypeKeySpecifier)[];
export type CmsBlogPagesFields_sections_sectionTypeFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_sectionType_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_sectionType_CreateKeySpecifier)[];
export type CmsBlogPagesFields_sections_sectionType_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_sectionType_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_sections_sectionType_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_sections_sectionType_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_sectionType_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_sections_sectionType_ReadKeySpecifier)[];
export type CmsBlogPagesFields_sections_sectionType_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_sections_sectionType_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_sections_sectionType_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_sections_sectionType_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_slugKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesFields_slugKeySpecifier)[];
export type CmsBlogPagesFields_slugFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_slug_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_slug_CreateKeySpecifier)[];
export type CmsBlogPagesFields_slug_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_slug_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_slug_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_slug_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_slug_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_slug_ReadKeySpecifier)[];
export type CmsBlogPagesFields_slug_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_slug_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_slug_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_slug_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_statusKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesFields_statusKeySpecifier)[];
export type CmsBlogPagesFields_statusFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_status_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_status_CreateKeySpecifier)[];
export type CmsBlogPagesFields_status_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_status_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_status_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_status_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_status_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_status_ReadKeySpecifier)[];
export type CmsBlogPagesFields_status_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_status_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_status_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_status_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_titleKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesFields_titleKeySpecifier)[];
export type CmsBlogPagesFields_titleFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_title_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_title_CreateKeySpecifier)[];
export type CmsBlogPagesFields_title_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_title_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_title_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_title_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_title_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_title_ReadKeySpecifier)[];
export type CmsBlogPagesFields_title_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_title_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_title_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_title_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPagesFields_updatedAtKeySpecifier)[];
export type CmsBlogPagesFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_updatedAt_CreateKeySpecifier = ('permission' | CmsBlogPagesFields_updatedAt_CreateKeySpecifier)[];
export type CmsBlogPagesFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsBlogPagesFields_updatedAt_DeleteKeySpecifier)[];
export type CmsBlogPagesFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_updatedAt_ReadKeySpecifier = ('permission' | CmsBlogPagesFields_updatedAt_ReadKeySpecifier)[];
export type CmsBlogPagesFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsBlogPagesFields_updatedAt_UpdateKeySpecifier)[];
export type CmsBlogPagesFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesReadAccessKeySpecifier = ('permission' | 'where' | CmsBlogPagesReadAccessKeySpecifier)[];
export type CmsBlogPagesReadAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesReadDocAccessKeySpecifier = ('permission' | 'where' | CmsBlogPagesReadDocAccessKeySpecifier)[];
export type CmsBlogPagesReadDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesUpdateAccessKeySpecifier = ('permission' | 'where' | CmsBlogPagesUpdateAccessKeySpecifier)[];
export type CmsBlogPagesUpdateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPagesUpdateDocAccessKeySpecifier = ('permission' | 'where' | CmsBlogPagesUpdateDocAccessKeySpecifier)[];
export type CmsBlogPagesUpdateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostKeySpecifier = ('content' | 'createdAt' | 'description' | 'featuredImage' | 'id' | 'relatedPosts' | 'title' | 'updatedAt' | 'videos' | CmsBlogPostKeySpecifier)[];
export type CmsBlogPostFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredImage?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedPosts?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	videos?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPost_VideosKeySpecifier = ('embedId' | 'id' | 'title' | CmsBlogPost_VideosKeySpecifier)[];
export type CmsBlogPost_VideosFieldPolicy = {
	embedId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsKeySpecifier = ('docs' | 'hasNextPage' | 'hasPrevPage' | 'limit' | 'nextPage' | 'offset' | 'page' | 'pagingCounter' | 'prevPage' | 'totalDocs' | 'totalPages' | CmsBlogPostsKeySpecifier)[];
export type CmsBlogPostsFieldPolicy = {
	docs?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPrevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	nextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pagingCounter?: FieldPolicy<any> | FieldReadFunction<any>,
	prevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsCreateAccessKeySpecifier = ('permission' | 'where' | CmsBlogPostsCreateAccessKeySpecifier)[];
export type CmsBlogPostsCreateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsCreateDocAccessKeySpecifier = ('permission' | 'where' | CmsBlogPostsCreateDocAccessKeySpecifier)[];
export type CmsBlogPostsCreateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDeleteAccessKeySpecifier = ('permission' | 'where' | CmsBlogPostsDeleteAccessKeySpecifier)[];
export type CmsBlogPostsDeleteAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDeleteDocAccessKeySpecifier = ('permission' | 'where' | CmsBlogPostsDeleteDocAccessKeySpecifier)[];
export type CmsBlogPostsDeleteDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFieldsKeySpecifier = ('content' | 'createdAt' | 'description' | 'featuredImage' | 'relatedPosts' | 'title' | 'updatedAt' | 'videos' | CmsBlogPostsDocAccessFieldsKeySpecifier)[];
export type CmsBlogPostsDocAccessFieldsFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredImage?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedPosts?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	videos?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_contentKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsDocAccessFields_contentKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_contentFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_content_CreateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_content_CreateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_content_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_content_DeleteKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_content_DeleteKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_content_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_content_ReadKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_content_ReadKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_content_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_content_UpdateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_content_UpdateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_content_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsDocAccessFields_createdAtKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_createdAt_CreateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_createdAt_CreateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_createdAt_DeleteKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_createdAt_DeleteKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_createdAt_ReadKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_createdAt_ReadKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_createdAt_UpdateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_createdAt_UpdateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_descriptionKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsDocAccessFields_descriptionKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_descriptionFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_description_CreateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_description_CreateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_description_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_description_DeleteKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_description_DeleteKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_description_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_description_ReadKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_description_ReadKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_description_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_description_UpdateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_description_UpdateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_description_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_featuredImageKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsDocAccessFields_featuredImageKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_featuredImageFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_featuredImage_CreateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_featuredImage_CreateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_featuredImage_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_featuredImage_DeleteKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_featuredImage_DeleteKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_featuredImage_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_featuredImage_ReadKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_featuredImage_ReadKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_featuredImage_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_featuredImage_UpdateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_featuredImage_UpdateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_featuredImage_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_relatedPostsKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsDocAccessFields_relatedPostsKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_relatedPostsFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_relatedPosts_CreateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_relatedPosts_CreateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_relatedPosts_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_relatedPosts_DeleteKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_relatedPosts_DeleteKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_relatedPosts_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_relatedPosts_ReadKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_relatedPosts_ReadKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_relatedPosts_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_relatedPosts_UpdateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_relatedPosts_UpdateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_relatedPosts_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_titleKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsDocAccessFields_titleKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_titleFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_title_CreateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_title_CreateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_title_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_title_DeleteKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_title_DeleteKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_title_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_title_ReadKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_title_ReadKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_title_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_title_UpdateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_title_UpdateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_title_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsDocAccessFields_updatedAtKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_updatedAt_CreateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_updatedAt_CreateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_updatedAt_DeleteKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_updatedAt_ReadKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_updatedAt_ReadKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_updatedAt_UpdateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videosKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsBlogPostsDocAccessFields_videosKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videosFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_CreateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_CreateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_DeleteKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_DeleteKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_FieldsKeySpecifier = ('embedId' | 'id' | 'title' | CmsBlogPostsDocAccessFields_videos_FieldsKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_FieldsFieldPolicy = {
	embedId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_ReadKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_ReadKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_UpdateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_UpdateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_embedIdKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsDocAccessFields_videos_embedIdKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_embedIdFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_embedId_CreateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_embedId_CreateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_embedId_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_embedId_DeleteKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_embedId_DeleteKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_embedId_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_embedId_ReadKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_embedId_ReadKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_embedId_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_embedId_UpdateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_embedId_UpdateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_embedId_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_idKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsDocAccessFields_videos_idKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_idFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_id_CreateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_id_CreateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_id_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_id_DeleteKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_id_DeleteKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_id_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_id_ReadKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_id_ReadKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_id_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_id_UpdateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_id_UpdateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_id_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_titleKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsDocAccessFields_videos_titleKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_titleFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_title_CreateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_title_CreateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_title_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_title_DeleteKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_title_DeleteKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_title_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_title_ReadKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_title_ReadKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_title_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsDocAccessFields_videos_title_UpdateKeySpecifier = ('permission' | CmsBlogPostsDocAccessFields_videos_title_UpdateKeySpecifier)[];
export type CmsBlogPostsDocAccessFields_videos_title_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFieldsKeySpecifier = ('content' | 'createdAt' | 'description' | 'featuredImage' | 'relatedPosts' | 'title' | 'updatedAt' | 'videos' | CmsBlogPostsFieldsKeySpecifier)[];
export type CmsBlogPostsFieldsFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredImage?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedPosts?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	videos?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_contentKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsFields_contentKeySpecifier)[];
export type CmsBlogPostsFields_contentFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_content_CreateKeySpecifier = ('permission' | CmsBlogPostsFields_content_CreateKeySpecifier)[];
export type CmsBlogPostsFields_content_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_content_DeleteKeySpecifier = ('permission' | CmsBlogPostsFields_content_DeleteKeySpecifier)[];
export type CmsBlogPostsFields_content_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_content_ReadKeySpecifier = ('permission' | CmsBlogPostsFields_content_ReadKeySpecifier)[];
export type CmsBlogPostsFields_content_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_content_UpdateKeySpecifier = ('permission' | CmsBlogPostsFields_content_UpdateKeySpecifier)[];
export type CmsBlogPostsFields_content_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsFields_createdAtKeySpecifier)[];
export type CmsBlogPostsFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_createdAt_CreateKeySpecifier = ('permission' | CmsBlogPostsFields_createdAt_CreateKeySpecifier)[];
export type CmsBlogPostsFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_createdAt_DeleteKeySpecifier = ('permission' | CmsBlogPostsFields_createdAt_DeleteKeySpecifier)[];
export type CmsBlogPostsFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_createdAt_ReadKeySpecifier = ('permission' | CmsBlogPostsFields_createdAt_ReadKeySpecifier)[];
export type CmsBlogPostsFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_createdAt_UpdateKeySpecifier = ('permission' | CmsBlogPostsFields_createdAt_UpdateKeySpecifier)[];
export type CmsBlogPostsFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_descriptionKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsFields_descriptionKeySpecifier)[];
export type CmsBlogPostsFields_descriptionFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_description_CreateKeySpecifier = ('permission' | CmsBlogPostsFields_description_CreateKeySpecifier)[];
export type CmsBlogPostsFields_description_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_description_DeleteKeySpecifier = ('permission' | CmsBlogPostsFields_description_DeleteKeySpecifier)[];
export type CmsBlogPostsFields_description_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_description_ReadKeySpecifier = ('permission' | CmsBlogPostsFields_description_ReadKeySpecifier)[];
export type CmsBlogPostsFields_description_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_description_UpdateKeySpecifier = ('permission' | CmsBlogPostsFields_description_UpdateKeySpecifier)[];
export type CmsBlogPostsFields_description_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_featuredImageKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsFields_featuredImageKeySpecifier)[];
export type CmsBlogPostsFields_featuredImageFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_featuredImage_CreateKeySpecifier = ('permission' | CmsBlogPostsFields_featuredImage_CreateKeySpecifier)[];
export type CmsBlogPostsFields_featuredImage_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_featuredImage_DeleteKeySpecifier = ('permission' | CmsBlogPostsFields_featuredImage_DeleteKeySpecifier)[];
export type CmsBlogPostsFields_featuredImage_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_featuredImage_ReadKeySpecifier = ('permission' | CmsBlogPostsFields_featuredImage_ReadKeySpecifier)[];
export type CmsBlogPostsFields_featuredImage_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_featuredImage_UpdateKeySpecifier = ('permission' | CmsBlogPostsFields_featuredImage_UpdateKeySpecifier)[];
export type CmsBlogPostsFields_featuredImage_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_relatedPostsKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsFields_relatedPostsKeySpecifier)[];
export type CmsBlogPostsFields_relatedPostsFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_relatedPosts_CreateKeySpecifier = ('permission' | CmsBlogPostsFields_relatedPosts_CreateKeySpecifier)[];
export type CmsBlogPostsFields_relatedPosts_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_relatedPosts_DeleteKeySpecifier = ('permission' | CmsBlogPostsFields_relatedPosts_DeleteKeySpecifier)[];
export type CmsBlogPostsFields_relatedPosts_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_relatedPosts_ReadKeySpecifier = ('permission' | CmsBlogPostsFields_relatedPosts_ReadKeySpecifier)[];
export type CmsBlogPostsFields_relatedPosts_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_relatedPosts_UpdateKeySpecifier = ('permission' | CmsBlogPostsFields_relatedPosts_UpdateKeySpecifier)[];
export type CmsBlogPostsFields_relatedPosts_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_titleKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsFields_titleKeySpecifier)[];
export type CmsBlogPostsFields_titleFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_title_CreateKeySpecifier = ('permission' | CmsBlogPostsFields_title_CreateKeySpecifier)[];
export type CmsBlogPostsFields_title_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_title_DeleteKeySpecifier = ('permission' | CmsBlogPostsFields_title_DeleteKeySpecifier)[];
export type CmsBlogPostsFields_title_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_title_ReadKeySpecifier = ('permission' | CmsBlogPostsFields_title_ReadKeySpecifier)[];
export type CmsBlogPostsFields_title_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_title_UpdateKeySpecifier = ('permission' | CmsBlogPostsFields_title_UpdateKeySpecifier)[];
export type CmsBlogPostsFields_title_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsFields_updatedAtKeySpecifier)[];
export type CmsBlogPostsFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_updatedAt_CreateKeySpecifier = ('permission' | CmsBlogPostsFields_updatedAt_CreateKeySpecifier)[];
export type CmsBlogPostsFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsBlogPostsFields_updatedAt_DeleteKeySpecifier)[];
export type CmsBlogPostsFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_updatedAt_ReadKeySpecifier = ('permission' | CmsBlogPostsFields_updatedAt_ReadKeySpecifier)[];
export type CmsBlogPostsFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsBlogPostsFields_updatedAt_UpdateKeySpecifier)[];
export type CmsBlogPostsFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videosKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsBlogPostsFields_videosKeySpecifier)[];
export type CmsBlogPostsFields_videosFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_CreateKeySpecifier = ('permission' | CmsBlogPostsFields_videos_CreateKeySpecifier)[];
export type CmsBlogPostsFields_videos_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_DeleteKeySpecifier = ('permission' | CmsBlogPostsFields_videos_DeleteKeySpecifier)[];
export type CmsBlogPostsFields_videos_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_FieldsKeySpecifier = ('embedId' | 'id' | 'title' | CmsBlogPostsFields_videos_FieldsKeySpecifier)[];
export type CmsBlogPostsFields_videos_FieldsFieldPolicy = {
	embedId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_ReadKeySpecifier = ('permission' | CmsBlogPostsFields_videos_ReadKeySpecifier)[];
export type CmsBlogPostsFields_videos_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_UpdateKeySpecifier = ('permission' | CmsBlogPostsFields_videos_UpdateKeySpecifier)[];
export type CmsBlogPostsFields_videos_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_embedIdKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsFields_videos_embedIdKeySpecifier)[];
export type CmsBlogPostsFields_videos_embedIdFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_embedId_CreateKeySpecifier = ('permission' | CmsBlogPostsFields_videos_embedId_CreateKeySpecifier)[];
export type CmsBlogPostsFields_videos_embedId_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_embedId_DeleteKeySpecifier = ('permission' | CmsBlogPostsFields_videos_embedId_DeleteKeySpecifier)[];
export type CmsBlogPostsFields_videos_embedId_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_embedId_ReadKeySpecifier = ('permission' | CmsBlogPostsFields_videos_embedId_ReadKeySpecifier)[];
export type CmsBlogPostsFields_videos_embedId_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_embedId_UpdateKeySpecifier = ('permission' | CmsBlogPostsFields_videos_embedId_UpdateKeySpecifier)[];
export type CmsBlogPostsFields_videos_embedId_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_idKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsFields_videos_idKeySpecifier)[];
export type CmsBlogPostsFields_videos_idFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_id_CreateKeySpecifier = ('permission' | CmsBlogPostsFields_videos_id_CreateKeySpecifier)[];
export type CmsBlogPostsFields_videos_id_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_id_DeleteKeySpecifier = ('permission' | CmsBlogPostsFields_videos_id_DeleteKeySpecifier)[];
export type CmsBlogPostsFields_videos_id_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_id_ReadKeySpecifier = ('permission' | CmsBlogPostsFields_videos_id_ReadKeySpecifier)[];
export type CmsBlogPostsFields_videos_id_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_id_UpdateKeySpecifier = ('permission' | CmsBlogPostsFields_videos_id_UpdateKeySpecifier)[];
export type CmsBlogPostsFields_videos_id_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_titleKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsBlogPostsFields_videos_titleKeySpecifier)[];
export type CmsBlogPostsFields_videos_titleFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_title_CreateKeySpecifier = ('permission' | CmsBlogPostsFields_videos_title_CreateKeySpecifier)[];
export type CmsBlogPostsFields_videos_title_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_title_DeleteKeySpecifier = ('permission' | CmsBlogPostsFields_videos_title_DeleteKeySpecifier)[];
export type CmsBlogPostsFields_videos_title_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_title_ReadKeySpecifier = ('permission' | CmsBlogPostsFields_videos_title_ReadKeySpecifier)[];
export type CmsBlogPostsFields_videos_title_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsFields_videos_title_UpdateKeySpecifier = ('permission' | CmsBlogPostsFields_videos_title_UpdateKeySpecifier)[];
export type CmsBlogPostsFields_videos_title_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsReadAccessKeySpecifier = ('permission' | 'where' | CmsBlogPostsReadAccessKeySpecifier)[];
export type CmsBlogPostsReadAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsReadDocAccessKeySpecifier = ('permission' | 'where' | CmsBlogPostsReadDocAccessKeySpecifier)[];
export type CmsBlogPostsReadDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsUpdateAccessKeySpecifier = ('permission' | 'where' | CmsBlogPostsUpdateAccessKeySpecifier)[];
export type CmsBlogPostsUpdateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsBlogPostsUpdateDocAccessKeySpecifier = ('permission' | 'where' | CmsBlogPostsUpdateDocAccessKeySpecifier)[];
export type CmsBlogPostsUpdateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGameKeySpecifier = ('avatar' | 'company' | 'content' | 'createdAt' | 'gameBanner' | 'gameLink' | 'gameTrailerEmbedId' | 'id' | 'images' | 'name' | 'relatedGames' | 'shortDescription' | 'status' | 'updatedAt' | CmsGameKeySpecifier)[];
export type CmsGameFieldPolicy = {
	avatar?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	gameBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	gameLink?: FieldPolicy<any> | FieldReadFunction<any>,
	gameTrailerEmbedId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedGames?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGame_GameTrailerEmbedIdKeySpecifier = ('embedId' | 'title' | CmsGame_GameTrailerEmbedIdKeySpecifier)[];
export type CmsGame_GameTrailerEmbedIdFieldPolicy = {
	embedId?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGame_ImagesKeySpecifier = ('id' | 'image' | CmsGame_ImagesKeySpecifier)[];
export type CmsGame_ImagesFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamerKeySpecifier = ('avatar' | 'country' | 'createdAt' | 'description' | 'gamerSocialMedia' | 'id' | 'name' | 'nickname' | 'updatedAt' | CmsGamerKeySpecifier)[];
export type CmsGamerFieldPolicy = {
	avatar?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerSocialMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nickname?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamer_GamerSocialMediaKeySpecifier = ('id' | 'link' | 'platform' | CmsGamer_GamerSocialMediaKeySpecifier)[];
export type CmsGamer_GamerSocialMediaFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	platform?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersKeySpecifier = ('docs' | 'hasNextPage' | 'hasPrevPage' | 'limit' | 'nextPage' | 'offset' | 'page' | 'pagingCounter' | 'prevPage' | 'totalDocs' | 'totalPages' | CmsGamersKeySpecifier)[];
export type CmsGamersFieldPolicy = {
	docs?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPrevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	nextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pagingCounter?: FieldPolicy<any> | FieldReadFunction<any>,
	prevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersCreateAccessKeySpecifier = ('permission' | 'where' | CmsGamersCreateAccessKeySpecifier)[];
export type CmsGamersCreateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersCreateDocAccessKeySpecifier = ('permission' | 'where' | CmsGamersCreateDocAccessKeySpecifier)[];
export type CmsGamersCreateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDeleteAccessKeySpecifier = ('permission' | 'where' | CmsGamersDeleteAccessKeySpecifier)[];
export type CmsGamersDeleteAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDeleteDocAccessKeySpecifier = ('permission' | 'where' | CmsGamersDeleteDocAccessKeySpecifier)[];
export type CmsGamersDeleteDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFieldsKeySpecifier = ('avatar' | 'country' | 'createdAt' | 'description' | 'gamerSocialMedia' | 'name' | 'nickname' | 'updatedAt' | CmsGamersDocAccessFieldsKeySpecifier)[];
export type CmsGamersDocAccessFieldsFieldPolicy = {
	avatar?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerSocialMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nickname?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_avatarKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersDocAccessFields_avatarKeySpecifier)[];
export type CmsGamersDocAccessFields_avatarFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_avatar_CreateKeySpecifier = ('permission' | CmsGamersDocAccessFields_avatar_CreateKeySpecifier)[];
export type CmsGamersDocAccessFields_avatar_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_avatar_DeleteKeySpecifier = ('permission' | CmsGamersDocAccessFields_avatar_DeleteKeySpecifier)[];
export type CmsGamersDocAccessFields_avatar_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_avatar_ReadKeySpecifier = ('permission' | CmsGamersDocAccessFields_avatar_ReadKeySpecifier)[];
export type CmsGamersDocAccessFields_avatar_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_avatar_UpdateKeySpecifier = ('permission' | CmsGamersDocAccessFields_avatar_UpdateKeySpecifier)[];
export type CmsGamersDocAccessFields_avatar_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_countryKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersDocAccessFields_countryKeySpecifier)[];
export type CmsGamersDocAccessFields_countryFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_country_CreateKeySpecifier = ('permission' | CmsGamersDocAccessFields_country_CreateKeySpecifier)[];
export type CmsGamersDocAccessFields_country_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_country_DeleteKeySpecifier = ('permission' | CmsGamersDocAccessFields_country_DeleteKeySpecifier)[];
export type CmsGamersDocAccessFields_country_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_country_ReadKeySpecifier = ('permission' | CmsGamersDocAccessFields_country_ReadKeySpecifier)[];
export type CmsGamersDocAccessFields_country_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_country_UpdateKeySpecifier = ('permission' | CmsGamersDocAccessFields_country_UpdateKeySpecifier)[];
export type CmsGamersDocAccessFields_country_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersDocAccessFields_createdAtKeySpecifier)[];
export type CmsGamersDocAccessFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_createdAt_CreateKeySpecifier = ('permission' | CmsGamersDocAccessFields_createdAt_CreateKeySpecifier)[];
export type CmsGamersDocAccessFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_createdAt_DeleteKeySpecifier = ('permission' | CmsGamersDocAccessFields_createdAt_DeleteKeySpecifier)[];
export type CmsGamersDocAccessFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_createdAt_ReadKeySpecifier = ('permission' | CmsGamersDocAccessFields_createdAt_ReadKeySpecifier)[];
export type CmsGamersDocAccessFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_createdAt_UpdateKeySpecifier = ('permission' | CmsGamersDocAccessFields_createdAt_UpdateKeySpecifier)[];
export type CmsGamersDocAccessFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_descriptionKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersDocAccessFields_descriptionKeySpecifier)[];
export type CmsGamersDocAccessFields_descriptionFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_description_CreateKeySpecifier = ('permission' | CmsGamersDocAccessFields_description_CreateKeySpecifier)[];
export type CmsGamersDocAccessFields_description_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_description_DeleteKeySpecifier = ('permission' | CmsGamersDocAccessFields_description_DeleteKeySpecifier)[];
export type CmsGamersDocAccessFields_description_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_description_ReadKeySpecifier = ('permission' | CmsGamersDocAccessFields_description_ReadKeySpecifier)[];
export type CmsGamersDocAccessFields_description_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_description_UpdateKeySpecifier = ('permission' | CmsGamersDocAccessFields_description_UpdateKeySpecifier)[];
export type CmsGamersDocAccessFields_description_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMediaKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsGamersDocAccessFields_gamerSocialMediaKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMediaFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_CreateKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_CreateKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_DeleteKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_DeleteKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_FieldsKeySpecifier = ('id' | 'link' | 'platform' | CmsGamersDocAccessFields_gamerSocialMedia_FieldsKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_FieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	platform?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_ReadKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_ReadKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_UpdateKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_UpdateKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_idKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersDocAccessFields_gamerSocialMedia_idKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_idFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_id_CreateKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_id_CreateKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_id_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_id_DeleteKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_id_DeleteKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_id_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_id_ReadKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_id_ReadKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_id_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_id_UpdateKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_id_UpdateKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_id_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_linkKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersDocAccessFields_gamerSocialMedia_linkKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_linkFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_link_CreateKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_link_CreateKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_link_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_link_DeleteKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_link_DeleteKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_link_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_link_ReadKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_link_ReadKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_link_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_link_UpdateKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_link_UpdateKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_link_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_platformKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersDocAccessFields_gamerSocialMedia_platformKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_platformFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_platform_CreateKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_platform_CreateKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_platform_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_platform_DeleteKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_platform_DeleteKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_platform_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_platform_ReadKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_platform_ReadKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_platform_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_gamerSocialMedia_platform_UpdateKeySpecifier = ('permission' | CmsGamersDocAccessFields_gamerSocialMedia_platform_UpdateKeySpecifier)[];
export type CmsGamersDocAccessFields_gamerSocialMedia_platform_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_nameKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersDocAccessFields_nameKeySpecifier)[];
export type CmsGamersDocAccessFields_nameFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_name_CreateKeySpecifier = ('permission' | CmsGamersDocAccessFields_name_CreateKeySpecifier)[];
export type CmsGamersDocAccessFields_name_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_name_DeleteKeySpecifier = ('permission' | CmsGamersDocAccessFields_name_DeleteKeySpecifier)[];
export type CmsGamersDocAccessFields_name_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_name_ReadKeySpecifier = ('permission' | CmsGamersDocAccessFields_name_ReadKeySpecifier)[];
export type CmsGamersDocAccessFields_name_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_name_UpdateKeySpecifier = ('permission' | CmsGamersDocAccessFields_name_UpdateKeySpecifier)[];
export type CmsGamersDocAccessFields_name_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_nicknameKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersDocAccessFields_nicknameKeySpecifier)[];
export type CmsGamersDocAccessFields_nicknameFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_nickname_CreateKeySpecifier = ('permission' | CmsGamersDocAccessFields_nickname_CreateKeySpecifier)[];
export type CmsGamersDocAccessFields_nickname_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_nickname_DeleteKeySpecifier = ('permission' | CmsGamersDocAccessFields_nickname_DeleteKeySpecifier)[];
export type CmsGamersDocAccessFields_nickname_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_nickname_ReadKeySpecifier = ('permission' | CmsGamersDocAccessFields_nickname_ReadKeySpecifier)[];
export type CmsGamersDocAccessFields_nickname_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_nickname_UpdateKeySpecifier = ('permission' | CmsGamersDocAccessFields_nickname_UpdateKeySpecifier)[];
export type CmsGamersDocAccessFields_nickname_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersDocAccessFields_updatedAtKeySpecifier)[];
export type CmsGamersDocAccessFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_updatedAt_CreateKeySpecifier = ('permission' | CmsGamersDocAccessFields_updatedAt_CreateKeySpecifier)[];
export type CmsGamersDocAccessFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsGamersDocAccessFields_updatedAt_DeleteKeySpecifier)[];
export type CmsGamersDocAccessFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_updatedAt_ReadKeySpecifier = ('permission' | CmsGamersDocAccessFields_updatedAt_ReadKeySpecifier)[];
export type CmsGamersDocAccessFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersDocAccessFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsGamersDocAccessFields_updatedAt_UpdateKeySpecifier)[];
export type CmsGamersDocAccessFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFieldsKeySpecifier = ('avatar' | 'country' | 'createdAt' | 'description' | 'gamerSocialMedia' | 'name' | 'nickname' | 'updatedAt' | CmsGamersFieldsKeySpecifier)[];
export type CmsGamersFieldsFieldPolicy = {
	avatar?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerSocialMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nickname?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_avatarKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersFields_avatarKeySpecifier)[];
export type CmsGamersFields_avatarFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_avatar_CreateKeySpecifier = ('permission' | CmsGamersFields_avatar_CreateKeySpecifier)[];
export type CmsGamersFields_avatar_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_avatar_DeleteKeySpecifier = ('permission' | CmsGamersFields_avatar_DeleteKeySpecifier)[];
export type CmsGamersFields_avatar_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_avatar_ReadKeySpecifier = ('permission' | CmsGamersFields_avatar_ReadKeySpecifier)[];
export type CmsGamersFields_avatar_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_avatar_UpdateKeySpecifier = ('permission' | CmsGamersFields_avatar_UpdateKeySpecifier)[];
export type CmsGamersFields_avatar_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_countryKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersFields_countryKeySpecifier)[];
export type CmsGamersFields_countryFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_country_CreateKeySpecifier = ('permission' | CmsGamersFields_country_CreateKeySpecifier)[];
export type CmsGamersFields_country_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_country_DeleteKeySpecifier = ('permission' | CmsGamersFields_country_DeleteKeySpecifier)[];
export type CmsGamersFields_country_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_country_ReadKeySpecifier = ('permission' | CmsGamersFields_country_ReadKeySpecifier)[];
export type CmsGamersFields_country_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_country_UpdateKeySpecifier = ('permission' | CmsGamersFields_country_UpdateKeySpecifier)[];
export type CmsGamersFields_country_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersFields_createdAtKeySpecifier)[];
export type CmsGamersFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_createdAt_CreateKeySpecifier = ('permission' | CmsGamersFields_createdAt_CreateKeySpecifier)[];
export type CmsGamersFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_createdAt_DeleteKeySpecifier = ('permission' | CmsGamersFields_createdAt_DeleteKeySpecifier)[];
export type CmsGamersFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_createdAt_ReadKeySpecifier = ('permission' | CmsGamersFields_createdAt_ReadKeySpecifier)[];
export type CmsGamersFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_createdAt_UpdateKeySpecifier = ('permission' | CmsGamersFields_createdAt_UpdateKeySpecifier)[];
export type CmsGamersFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_descriptionKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersFields_descriptionKeySpecifier)[];
export type CmsGamersFields_descriptionFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_description_CreateKeySpecifier = ('permission' | CmsGamersFields_description_CreateKeySpecifier)[];
export type CmsGamersFields_description_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_description_DeleteKeySpecifier = ('permission' | CmsGamersFields_description_DeleteKeySpecifier)[];
export type CmsGamersFields_description_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_description_ReadKeySpecifier = ('permission' | CmsGamersFields_description_ReadKeySpecifier)[];
export type CmsGamersFields_description_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_description_UpdateKeySpecifier = ('permission' | CmsGamersFields_description_UpdateKeySpecifier)[];
export type CmsGamersFields_description_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMediaKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsGamersFields_gamerSocialMediaKeySpecifier)[];
export type CmsGamersFields_gamerSocialMediaFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_CreateKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_CreateKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_DeleteKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_DeleteKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_FieldsKeySpecifier = ('id' | 'link' | 'platform' | CmsGamersFields_gamerSocialMedia_FieldsKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_FieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	platform?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_ReadKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_ReadKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_UpdateKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_UpdateKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_idKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersFields_gamerSocialMedia_idKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_idFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_id_CreateKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_id_CreateKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_id_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_id_DeleteKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_id_DeleteKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_id_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_id_ReadKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_id_ReadKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_id_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_id_UpdateKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_id_UpdateKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_id_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_linkKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersFields_gamerSocialMedia_linkKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_linkFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_link_CreateKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_link_CreateKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_link_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_link_DeleteKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_link_DeleteKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_link_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_link_ReadKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_link_ReadKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_link_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_link_UpdateKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_link_UpdateKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_link_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_platformKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersFields_gamerSocialMedia_platformKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_platformFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_platform_CreateKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_platform_CreateKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_platform_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_platform_DeleteKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_platform_DeleteKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_platform_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_platform_ReadKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_platform_ReadKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_platform_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_gamerSocialMedia_platform_UpdateKeySpecifier = ('permission' | CmsGamersFields_gamerSocialMedia_platform_UpdateKeySpecifier)[];
export type CmsGamersFields_gamerSocialMedia_platform_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_nameKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersFields_nameKeySpecifier)[];
export type CmsGamersFields_nameFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_name_CreateKeySpecifier = ('permission' | CmsGamersFields_name_CreateKeySpecifier)[];
export type CmsGamersFields_name_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_name_DeleteKeySpecifier = ('permission' | CmsGamersFields_name_DeleteKeySpecifier)[];
export type CmsGamersFields_name_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_name_ReadKeySpecifier = ('permission' | CmsGamersFields_name_ReadKeySpecifier)[];
export type CmsGamersFields_name_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_name_UpdateKeySpecifier = ('permission' | CmsGamersFields_name_UpdateKeySpecifier)[];
export type CmsGamersFields_name_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_nicknameKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersFields_nicknameKeySpecifier)[];
export type CmsGamersFields_nicknameFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_nickname_CreateKeySpecifier = ('permission' | CmsGamersFields_nickname_CreateKeySpecifier)[];
export type CmsGamersFields_nickname_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_nickname_DeleteKeySpecifier = ('permission' | CmsGamersFields_nickname_DeleteKeySpecifier)[];
export type CmsGamersFields_nickname_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_nickname_ReadKeySpecifier = ('permission' | CmsGamersFields_nickname_ReadKeySpecifier)[];
export type CmsGamersFields_nickname_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_nickname_UpdateKeySpecifier = ('permission' | CmsGamersFields_nickname_UpdateKeySpecifier)[];
export type CmsGamersFields_nickname_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamersFields_updatedAtKeySpecifier)[];
export type CmsGamersFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_updatedAt_CreateKeySpecifier = ('permission' | CmsGamersFields_updatedAt_CreateKeySpecifier)[];
export type CmsGamersFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsGamersFields_updatedAt_DeleteKeySpecifier)[];
export type CmsGamersFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_updatedAt_ReadKeySpecifier = ('permission' | CmsGamersFields_updatedAt_ReadKeySpecifier)[];
export type CmsGamersFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsGamersFields_updatedAt_UpdateKeySpecifier)[];
export type CmsGamersFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersReadAccessKeySpecifier = ('permission' | 'where' | CmsGamersReadAccessKeySpecifier)[];
export type CmsGamersReadAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersReadDocAccessKeySpecifier = ('permission' | 'where' | CmsGamersReadDocAccessKeySpecifier)[];
export type CmsGamersReadDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersUpdateAccessKeySpecifier = ('permission' | 'where' | CmsGamersUpdateAccessKeySpecifier)[];
export type CmsGamersUpdateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamersUpdateDocAccessKeySpecifier = ('permission' | 'where' | CmsGamersUpdateDocAccessKeySpecifier)[];
export type CmsGamersUpdateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesKeySpecifier = ('docs' | 'hasNextPage' | 'hasPrevPage' | 'limit' | 'nextPage' | 'offset' | 'page' | 'pagingCounter' | 'prevPage' | 'totalDocs' | 'totalPages' | CmsGamesKeySpecifier)[];
export type CmsGamesFieldPolicy = {
	docs?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPrevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	nextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pagingCounter?: FieldPolicy<any> | FieldReadFunction<any>,
	prevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesCreateAccessKeySpecifier = ('permission' | 'where' | CmsGamesCreateAccessKeySpecifier)[];
export type CmsGamesCreateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesCreateDocAccessKeySpecifier = ('permission' | 'where' | CmsGamesCreateDocAccessKeySpecifier)[];
export type CmsGamesCreateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDeleteAccessKeySpecifier = ('permission' | 'where' | CmsGamesDeleteAccessKeySpecifier)[];
export type CmsGamesDeleteAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDeleteDocAccessKeySpecifier = ('permission' | 'where' | CmsGamesDeleteDocAccessKeySpecifier)[];
export type CmsGamesDeleteDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFieldsKeySpecifier = ('avatar' | 'company' | 'content' | 'createdAt' | 'gameBanner' | 'gameLink' | 'gameTrailerEmbedId' | 'images' | 'name' | 'relatedGames' | 'shortDescription' | 'status' | 'updatedAt' | CmsGamesDocAccessFieldsKeySpecifier)[];
export type CmsGamesDocAccessFieldsFieldPolicy = {
	avatar?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	gameBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	gameLink?: FieldPolicy<any> | FieldReadFunction<any>,
	gameTrailerEmbedId?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedGames?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_avatarKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_avatarKeySpecifier)[];
export type CmsGamesDocAccessFields_avatarFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_avatar_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_avatar_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_avatar_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_avatar_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_avatar_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_avatar_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_avatar_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_avatar_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_avatar_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_avatar_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_avatar_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_avatar_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_companyKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_companyKeySpecifier)[];
export type CmsGamesDocAccessFields_companyFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_company_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_company_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_company_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_company_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_company_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_company_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_company_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_company_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_company_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_company_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_company_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_company_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_contentKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_contentKeySpecifier)[];
export type CmsGamesDocAccessFields_contentFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_content_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_content_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_content_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_content_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_content_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_content_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_content_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_content_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_content_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_content_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_content_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_content_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_createdAtKeySpecifier)[];
export type CmsGamesDocAccessFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_createdAt_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_createdAt_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_createdAt_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_createdAt_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_createdAt_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_createdAt_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_createdAt_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_createdAt_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameBannerKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_gameBannerKeySpecifier)[];
export type CmsGamesDocAccessFields_gameBannerFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameBanner_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameBanner_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_gameBanner_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameBanner_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameBanner_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_gameBanner_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameBanner_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameBanner_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_gameBanner_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameBanner_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameBanner_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_gameBanner_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameLinkKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_gameLinkKeySpecifier)[];
export type CmsGamesDocAccessFields_gameLinkFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameLink_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameLink_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_gameLink_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameLink_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameLink_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_gameLink_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameLink_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameLink_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_gameLink_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameLink_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameLink_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_gameLink_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedIdKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsGamesDocAccessFields_gameTrailerEmbedIdKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedIdFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameTrailerEmbedId_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameTrailerEmbedId_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_FieldsKeySpecifier = ('embedId' | 'title' | CmsGamesDocAccessFields_gameTrailerEmbedId_FieldsKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_FieldsFieldPolicy = {
	embedId?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameTrailerEmbedId_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameTrailerEmbedId_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_embedIdKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_gameTrailerEmbedId_embedIdKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_embedIdFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_titleKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_gameTrailerEmbedId_titleKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_titleFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_title_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameTrailerEmbedId_title_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_title_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_title_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameTrailerEmbedId_title_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_title_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_title_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameTrailerEmbedId_title_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_title_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_gameTrailerEmbedId_title_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_gameTrailerEmbedId_title_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_gameTrailerEmbedId_title_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_imagesKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsGamesDocAccessFields_imagesKeySpecifier)[];
export type CmsGamesDocAccessFields_imagesFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_images_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_images_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_images_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_images_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_FieldsKeySpecifier = ('id' | 'image' | CmsGamesDocAccessFields_images_FieldsKeySpecifier)[];
export type CmsGamesDocAccessFields_images_FieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_images_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_images_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_images_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_images_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_idKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_images_idKeySpecifier)[];
export type CmsGamesDocAccessFields_images_idFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_id_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_images_id_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_images_id_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_id_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_images_id_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_images_id_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_id_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_images_id_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_images_id_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_id_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_images_id_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_images_id_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_imageKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_images_imageKeySpecifier)[];
export type CmsGamesDocAccessFields_images_imageFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_image_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_images_image_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_images_image_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_image_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_images_image_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_images_image_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_image_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_images_image_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_images_image_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_images_image_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_images_image_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_images_image_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_nameKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_nameKeySpecifier)[];
export type CmsGamesDocAccessFields_nameFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_name_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_name_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_name_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_name_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_name_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_name_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_name_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_name_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_name_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_name_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_name_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_name_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_relatedGamesKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_relatedGamesKeySpecifier)[];
export type CmsGamesDocAccessFields_relatedGamesFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_relatedGames_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_relatedGames_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_relatedGames_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_relatedGames_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_relatedGames_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_relatedGames_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_relatedGames_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_relatedGames_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_relatedGames_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_relatedGames_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_relatedGames_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_relatedGames_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_shortDescriptionKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_shortDescriptionKeySpecifier)[];
export type CmsGamesDocAccessFields_shortDescriptionFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_shortDescription_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_shortDescription_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_shortDescription_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_shortDescription_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_shortDescription_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_shortDescription_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_shortDescription_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_shortDescription_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_shortDescription_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_shortDescription_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_shortDescription_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_shortDescription_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_statusKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_statusKeySpecifier)[];
export type CmsGamesDocAccessFields_statusFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_status_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_status_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_status_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_status_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_status_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_status_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_status_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_status_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_status_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_status_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_status_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_status_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesDocAccessFields_updatedAtKeySpecifier)[];
export type CmsGamesDocAccessFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_updatedAt_CreateKeySpecifier = ('permission' | CmsGamesDocAccessFields_updatedAt_CreateKeySpecifier)[];
export type CmsGamesDocAccessFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsGamesDocAccessFields_updatedAt_DeleteKeySpecifier)[];
export type CmsGamesDocAccessFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_updatedAt_ReadKeySpecifier = ('permission' | CmsGamesDocAccessFields_updatedAt_ReadKeySpecifier)[];
export type CmsGamesDocAccessFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesDocAccessFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsGamesDocAccessFields_updatedAt_UpdateKeySpecifier)[];
export type CmsGamesDocAccessFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFieldsKeySpecifier = ('avatar' | 'company' | 'content' | 'createdAt' | 'gameBanner' | 'gameLink' | 'gameTrailerEmbedId' | 'images' | 'name' | 'relatedGames' | 'shortDescription' | 'status' | 'updatedAt' | CmsGamesFieldsKeySpecifier)[];
export type CmsGamesFieldsFieldPolicy = {
	avatar?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	gameBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	gameLink?: FieldPolicy<any> | FieldReadFunction<any>,
	gameTrailerEmbedId?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedGames?: FieldPolicy<any> | FieldReadFunction<any>,
	shortDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_avatarKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_avatarKeySpecifier)[];
export type CmsGamesFields_avatarFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_avatar_CreateKeySpecifier = ('permission' | CmsGamesFields_avatar_CreateKeySpecifier)[];
export type CmsGamesFields_avatar_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_avatar_DeleteKeySpecifier = ('permission' | CmsGamesFields_avatar_DeleteKeySpecifier)[];
export type CmsGamesFields_avatar_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_avatar_ReadKeySpecifier = ('permission' | CmsGamesFields_avatar_ReadKeySpecifier)[];
export type CmsGamesFields_avatar_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_avatar_UpdateKeySpecifier = ('permission' | CmsGamesFields_avatar_UpdateKeySpecifier)[];
export type CmsGamesFields_avatar_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_companyKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_companyKeySpecifier)[];
export type CmsGamesFields_companyFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_company_CreateKeySpecifier = ('permission' | CmsGamesFields_company_CreateKeySpecifier)[];
export type CmsGamesFields_company_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_company_DeleteKeySpecifier = ('permission' | CmsGamesFields_company_DeleteKeySpecifier)[];
export type CmsGamesFields_company_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_company_ReadKeySpecifier = ('permission' | CmsGamesFields_company_ReadKeySpecifier)[];
export type CmsGamesFields_company_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_company_UpdateKeySpecifier = ('permission' | CmsGamesFields_company_UpdateKeySpecifier)[];
export type CmsGamesFields_company_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_contentKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_contentKeySpecifier)[];
export type CmsGamesFields_contentFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_content_CreateKeySpecifier = ('permission' | CmsGamesFields_content_CreateKeySpecifier)[];
export type CmsGamesFields_content_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_content_DeleteKeySpecifier = ('permission' | CmsGamesFields_content_DeleteKeySpecifier)[];
export type CmsGamesFields_content_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_content_ReadKeySpecifier = ('permission' | CmsGamesFields_content_ReadKeySpecifier)[];
export type CmsGamesFields_content_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_content_UpdateKeySpecifier = ('permission' | CmsGamesFields_content_UpdateKeySpecifier)[];
export type CmsGamesFields_content_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_createdAtKeySpecifier)[];
export type CmsGamesFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_createdAt_CreateKeySpecifier = ('permission' | CmsGamesFields_createdAt_CreateKeySpecifier)[];
export type CmsGamesFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_createdAt_DeleteKeySpecifier = ('permission' | CmsGamesFields_createdAt_DeleteKeySpecifier)[];
export type CmsGamesFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_createdAt_ReadKeySpecifier = ('permission' | CmsGamesFields_createdAt_ReadKeySpecifier)[];
export type CmsGamesFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_createdAt_UpdateKeySpecifier = ('permission' | CmsGamesFields_createdAt_UpdateKeySpecifier)[];
export type CmsGamesFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameBannerKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_gameBannerKeySpecifier)[];
export type CmsGamesFields_gameBannerFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameBanner_CreateKeySpecifier = ('permission' | CmsGamesFields_gameBanner_CreateKeySpecifier)[];
export type CmsGamesFields_gameBanner_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameBanner_DeleteKeySpecifier = ('permission' | CmsGamesFields_gameBanner_DeleteKeySpecifier)[];
export type CmsGamesFields_gameBanner_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameBanner_ReadKeySpecifier = ('permission' | CmsGamesFields_gameBanner_ReadKeySpecifier)[];
export type CmsGamesFields_gameBanner_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameBanner_UpdateKeySpecifier = ('permission' | CmsGamesFields_gameBanner_UpdateKeySpecifier)[];
export type CmsGamesFields_gameBanner_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameLinkKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_gameLinkKeySpecifier)[];
export type CmsGamesFields_gameLinkFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameLink_CreateKeySpecifier = ('permission' | CmsGamesFields_gameLink_CreateKeySpecifier)[];
export type CmsGamesFields_gameLink_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameLink_DeleteKeySpecifier = ('permission' | CmsGamesFields_gameLink_DeleteKeySpecifier)[];
export type CmsGamesFields_gameLink_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameLink_ReadKeySpecifier = ('permission' | CmsGamesFields_gameLink_ReadKeySpecifier)[];
export type CmsGamesFields_gameLink_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameLink_UpdateKeySpecifier = ('permission' | CmsGamesFields_gameLink_UpdateKeySpecifier)[];
export type CmsGamesFields_gameLink_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedIdKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsGamesFields_gameTrailerEmbedIdKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedIdFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_CreateKeySpecifier = ('permission' | CmsGamesFields_gameTrailerEmbedId_CreateKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_DeleteKeySpecifier = ('permission' | CmsGamesFields_gameTrailerEmbedId_DeleteKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_FieldsKeySpecifier = ('embedId' | 'title' | CmsGamesFields_gameTrailerEmbedId_FieldsKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_FieldsFieldPolicy = {
	embedId?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_ReadKeySpecifier = ('permission' | CmsGamesFields_gameTrailerEmbedId_ReadKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_UpdateKeySpecifier = ('permission' | CmsGamesFields_gameTrailerEmbedId_UpdateKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_embedIdKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_gameTrailerEmbedId_embedIdKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_embedIdFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_embedId_CreateKeySpecifier = ('permission' | CmsGamesFields_gameTrailerEmbedId_embedId_CreateKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_embedId_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_embedId_DeleteKeySpecifier = ('permission' | CmsGamesFields_gameTrailerEmbedId_embedId_DeleteKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_embedId_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_embedId_ReadKeySpecifier = ('permission' | CmsGamesFields_gameTrailerEmbedId_embedId_ReadKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_embedId_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_embedId_UpdateKeySpecifier = ('permission' | CmsGamesFields_gameTrailerEmbedId_embedId_UpdateKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_embedId_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_titleKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_gameTrailerEmbedId_titleKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_titleFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_title_CreateKeySpecifier = ('permission' | CmsGamesFields_gameTrailerEmbedId_title_CreateKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_title_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_title_DeleteKeySpecifier = ('permission' | CmsGamesFields_gameTrailerEmbedId_title_DeleteKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_title_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_title_ReadKeySpecifier = ('permission' | CmsGamesFields_gameTrailerEmbedId_title_ReadKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_title_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_gameTrailerEmbedId_title_UpdateKeySpecifier = ('permission' | CmsGamesFields_gameTrailerEmbedId_title_UpdateKeySpecifier)[];
export type CmsGamesFields_gameTrailerEmbedId_title_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_imagesKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsGamesFields_imagesKeySpecifier)[];
export type CmsGamesFields_imagesFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_CreateKeySpecifier = ('permission' | CmsGamesFields_images_CreateKeySpecifier)[];
export type CmsGamesFields_images_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_DeleteKeySpecifier = ('permission' | CmsGamesFields_images_DeleteKeySpecifier)[];
export type CmsGamesFields_images_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_FieldsKeySpecifier = ('id' | 'image' | CmsGamesFields_images_FieldsKeySpecifier)[];
export type CmsGamesFields_images_FieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_ReadKeySpecifier = ('permission' | CmsGamesFields_images_ReadKeySpecifier)[];
export type CmsGamesFields_images_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_UpdateKeySpecifier = ('permission' | CmsGamesFields_images_UpdateKeySpecifier)[];
export type CmsGamesFields_images_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_idKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_images_idKeySpecifier)[];
export type CmsGamesFields_images_idFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_id_CreateKeySpecifier = ('permission' | CmsGamesFields_images_id_CreateKeySpecifier)[];
export type CmsGamesFields_images_id_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_id_DeleteKeySpecifier = ('permission' | CmsGamesFields_images_id_DeleteKeySpecifier)[];
export type CmsGamesFields_images_id_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_id_ReadKeySpecifier = ('permission' | CmsGamesFields_images_id_ReadKeySpecifier)[];
export type CmsGamesFields_images_id_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_id_UpdateKeySpecifier = ('permission' | CmsGamesFields_images_id_UpdateKeySpecifier)[];
export type CmsGamesFields_images_id_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_imageKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_images_imageKeySpecifier)[];
export type CmsGamesFields_images_imageFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_image_CreateKeySpecifier = ('permission' | CmsGamesFields_images_image_CreateKeySpecifier)[];
export type CmsGamesFields_images_image_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_image_DeleteKeySpecifier = ('permission' | CmsGamesFields_images_image_DeleteKeySpecifier)[];
export type CmsGamesFields_images_image_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_image_ReadKeySpecifier = ('permission' | CmsGamesFields_images_image_ReadKeySpecifier)[];
export type CmsGamesFields_images_image_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_images_image_UpdateKeySpecifier = ('permission' | CmsGamesFields_images_image_UpdateKeySpecifier)[];
export type CmsGamesFields_images_image_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_nameKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_nameKeySpecifier)[];
export type CmsGamesFields_nameFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_name_CreateKeySpecifier = ('permission' | CmsGamesFields_name_CreateKeySpecifier)[];
export type CmsGamesFields_name_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_name_DeleteKeySpecifier = ('permission' | CmsGamesFields_name_DeleteKeySpecifier)[];
export type CmsGamesFields_name_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_name_ReadKeySpecifier = ('permission' | CmsGamesFields_name_ReadKeySpecifier)[];
export type CmsGamesFields_name_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_name_UpdateKeySpecifier = ('permission' | CmsGamesFields_name_UpdateKeySpecifier)[];
export type CmsGamesFields_name_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_relatedGamesKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_relatedGamesKeySpecifier)[];
export type CmsGamesFields_relatedGamesFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_relatedGames_CreateKeySpecifier = ('permission' | CmsGamesFields_relatedGames_CreateKeySpecifier)[];
export type CmsGamesFields_relatedGames_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_relatedGames_DeleteKeySpecifier = ('permission' | CmsGamesFields_relatedGames_DeleteKeySpecifier)[];
export type CmsGamesFields_relatedGames_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_relatedGames_ReadKeySpecifier = ('permission' | CmsGamesFields_relatedGames_ReadKeySpecifier)[];
export type CmsGamesFields_relatedGames_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_relatedGames_UpdateKeySpecifier = ('permission' | CmsGamesFields_relatedGames_UpdateKeySpecifier)[];
export type CmsGamesFields_relatedGames_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_shortDescriptionKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_shortDescriptionKeySpecifier)[];
export type CmsGamesFields_shortDescriptionFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_shortDescription_CreateKeySpecifier = ('permission' | CmsGamesFields_shortDescription_CreateKeySpecifier)[];
export type CmsGamesFields_shortDescription_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_shortDescription_DeleteKeySpecifier = ('permission' | CmsGamesFields_shortDescription_DeleteKeySpecifier)[];
export type CmsGamesFields_shortDescription_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_shortDescription_ReadKeySpecifier = ('permission' | CmsGamesFields_shortDescription_ReadKeySpecifier)[];
export type CmsGamesFields_shortDescription_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_shortDescription_UpdateKeySpecifier = ('permission' | CmsGamesFields_shortDescription_UpdateKeySpecifier)[];
export type CmsGamesFields_shortDescription_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_statusKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_statusKeySpecifier)[];
export type CmsGamesFields_statusFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_status_CreateKeySpecifier = ('permission' | CmsGamesFields_status_CreateKeySpecifier)[];
export type CmsGamesFields_status_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_status_DeleteKeySpecifier = ('permission' | CmsGamesFields_status_DeleteKeySpecifier)[];
export type CmsGamesFields_status_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_status_ReadKeySpecifier = ('permission' | CmsGamesFields_status_ReadKeySpecifier)[];
export type CmsGamesFields_status_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_status_UpdateKeySpecifier = ('permission' | CmsGamesFields_status_UpdateKeySpecifier)[];
export type CmsGamesFields_status_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsGamesFields_updatedAtKeySpecifier)[];
export type CmsGamesFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_updatedAt_CreateKeySpecifier = ('permission' | CmsGamesFields_updatedAt_CreateKeySpecifier)[];
export type CmsGamesFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsGamesFields_updatedAt_DeleteKeySpecifier)[];
export type CmsGamesFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_updatedAt_ReadKeySpecifier = ('permission' | CmsGamesFields_updatedAt_ReadKeySpecifier)[];
export type CmsGamesFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsGamesFields_updatedAt_UpdateKeySpecifier)[];
export type CmsGamesFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesReadAccessKeySpecifier = ('permission' | 'where' | CmsGamesReadAccessKeySpecifier)[];
export type CmsGamesReadAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesReadDocAccessKeySpecifier = ('permission' | 'where' | CmsGamesReadDocAccessKeySpecifier)[];
export type CmsGamesReadDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesUpdateAccessKeySpecifier = ('permission' | 'where' | CmsGamesUpdateAccessKeySpecifier)[];
export type CmsGamesUpdateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsGamesUpdateDocAccessKeySpecifier = ('permission' | 'where' | CmsGamesUpdateDocAccessKeySpecifier)[];
export type CmsGamesUpdateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaKeySpecifier = ('createdAt' | 'filename' | 'filesize' | 'focalX' | 'focalY' | 'height' | 'id' | 'mimeType' | 'sizes' | 'thumbnailURL' | 'updatedAt' | 'url' | 'width' | CmsMediaKeySpecifier)[];
export type CmsMediaFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	filesize?: FieldPolicy<any> | FieldReadFunction<any>,
	focalX?: FieldPolicy<any> | FieldReadFunction<any>,
	focalY?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	sizes?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailURL?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaCreateAccessKeySpecifier = ('permission' | 'where' | CmsMediaCreateAccessKeySpecifier)[];
export type CmsMediaCreateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaCreateDocAccessKeySpecifier = ('permission' | 'where' | CmsMediaCreateDocAccessKeySpecifier)[];
export type CmsMediaCreateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDeleteAccessKeySpecifier = ('permission' | 'where' | CmsMediaDeleteAccessKeySpecifier)[];
export type CmsMediaDeleteAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDeleteDocAccessKeySpecifier = ('permission' | 'where' | CmsMediaDeleteDocAccessKeySpecifier)[];
export type CmsMediaDeleteDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFieldsKeySpecifier = ('createdAt' | 'filename' | 'filesize' | 'focalX' | 'focalY' | 'height' | 'mimeType' | 'sizes' | 'thumbnailURL' | 'updatedAt' | 'url' | 'width' | CmsMediaDocAccessFieldsKeySpecifier)[];
export type CmsMediaDocAccessFieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	filesize?: FieldPolicy<any> | FieldReadFunction<any>,
	focalX?: FieldPolicy<any> | FieldReadFunction<any>,
	focalY?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	sizes?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailURL?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_createdAtKeySpecifier)[];
export type CmsMediaDocAccessFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_createdAt_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_createdAt_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_createdAt_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_createdAt_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_createdAt_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_createdAt_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_createdAt_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_createdAt_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_filenameKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_filenameKeySpecifier)[];
export type CmsMediaDocAccessFields_filenameFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_filename_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_filename_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_filename_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_filename_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_filename_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_filename_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_filename_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_filename_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_filename_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_filename_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_filename_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_filename_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_filesizeKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_filesizeKeySpecifier)[];
export type CmsMediaDocAccessFields_filesizeFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_filesize_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_filesize_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_filesize_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_filesize_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_filesize_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_filesize_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_filesize_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_filesize_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_filesize_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_filesize_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_filesize_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_filesize_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_focalXKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_focalXKeySpecifier)[];
export type CmsMediaDocAccessFields_focalXFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_focalX_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_focalX_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_focalX_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_focalX_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_focalX_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_focalX_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_focalX_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_focalX_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_focalX_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_focalX_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_focalX_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_focalX_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_focalYKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_focalYKeySpecifier)[];
export type CmsMediaDocAccessFields_focalYFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_focalY_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_focalY_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_focalY_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_focalY_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_focalY_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_focalY_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_focalY_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_focalY_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_focalY_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_focalY_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_focalY_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_focalY_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_heightKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_heightKeySpecifier)[];
export type CmsMediaDocAccessFields_heightFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_height_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_height_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_height_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_height_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_height_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_height_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_height_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_height_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_height_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_height_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_height_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_height_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_mimeTypeKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_mimeTypeKeySpecifier)[];
export type CmsMediaDocAccessFields_mimeTypeFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_mimeType_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_mimeType_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_mimeType_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_mimeType_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_mimeType_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_mimeType_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_mimeType_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_mimeType_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_mimeType_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_mimeType_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_mimeType_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_mimeType_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizesKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsMediaDocAccessFields_sizesKeySpecifier)[];
export type CmsMediaDocAccessFields_sizesFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_FieldsKeySpecifier = ('thumbnail' | CmsMediaDocAccessFields_sizes_FieldsKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_FieldsFieldPolicy = {
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnailKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsMediaDocAccessFields_sizes_thumbnailKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnailFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_FieldsKeySpecifier = ('filename' | 'filesize' | 'height' | 'mimeType' | 'url' | 'width' | CmsMediaDocAccessFields_sizes_thumbnail_FieldsKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_FieldsFieldPolicy = {
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	filesize?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_filenameKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_sizes_thumbnail_filenameKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_filenameFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_filename_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_filename_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_filename_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_filename_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_filename_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_filename_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_filename_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_filename_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_filename_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_filename_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_filename_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_filename_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_filesizeKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_sizes_thumbnail_filesizeKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_filesizeFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_filesize_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_filesize_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_filesize_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_filesize_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_filesize_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_filesize_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_filesize_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_filesize_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_filesize_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_filesize_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_filesize_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_filesize_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_heightKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_sizes_thumbnail_heightKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_heightFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_height_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_height_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_height_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_height_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_height_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_height_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_height_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_height_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_height_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_height_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_height_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_height_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_mimeTypeKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_sizes_thumbnail_mimeTypeKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_mimeTypeFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_mimeType_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_mimeType_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_mimeType_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_mimeType_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_mimeType_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_mimeType_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_mimeType_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_mimeType_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_mimeType_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_mimeType_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_mimeType_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_mimeType_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_urlKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_sizes_thumbnail_urlKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_urlFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_url_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_url_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_url_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_url_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_url_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_url_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_url_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_url_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_url_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_url_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_url_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_url_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_widthKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_sizes_thumbnail_widthKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_widthFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_width_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_width_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_width_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_width_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_width_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_width_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_width_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_width_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_width_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_sizes_thumbnail_width_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_sizes_thumbnail_width_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_sizes_thumbnail_width_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_thumbnailURLKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_thumbnailURLKeySpecifier)[];
export type CmsMediaDocAccessFields_thumbnailURLFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_thumbnailURL_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_thumbnailURL_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_thumbnailURL_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_thumbnailURL_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_thumbnailURL_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_thumbnailURL_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_thumbnailURL_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_thumbnailURL_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_thumbnailURL_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_thumbnailURL_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_thumbnailURL_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_thumbnailURL_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_updatedAtKeySpecifier)[];
export type CmsMediaDocAccessFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_updatedAt_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_updatedAt_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_updatedAt_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_updatedAt_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_updatedAt_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_updatedAt_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_urlKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_urlKeySpecifier)[];
export type CmsMediaDocAccessFields_urlFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_url_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_url_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_url_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_url_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_url_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_url_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_url_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_url_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_url_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_url_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_url_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_url_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_widthKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaDocAccessFields_widthKeySpecifier)[];
export type CmsMediaDocAccessFields_widthFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_width_CreateKeySpecifier = ('permission' | CmsMediaDocAccessFields_width_CreateKeySpecifier)[];
export type CmsMediaDocAccessFields_width_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_width_DeleteKeySpecifier = ('permission' | CmsMediaDocAccessFields_width_DeleteKeySpecifier)[];
export type CmsMediaDocAccessFields_width_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_width_ReadKeySpecifier = ('permission' | CmsMediaDocAccessFields_width_ReadKeySpecifier)[];
export type CmsMediaDocAccessFields_width_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaDocAccessFields_width_UpdateKeySpecifier = ('permission' | CmsMediaDocAccessFields_width_UpdateKeySpecifier)[];
export type CmsMediaDocAccessFields_width_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFieldsKeySpecifier = ('createdAt' | 'filename' | 'filesize' | 'focalX' | 'focalY' | 'height' | 'mimeType' | 'sizes' | 'thumbnailURL' | 'updatedAt' | 'url' | 'width' | CmsMediaFieldsKeySpecifier)[];
export type CmsMediaFieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	filesize?: FieldPolicy<any> | FieldReadFunction<any>,
	focalX?: FieldPolicy<any> | FieldReadFunction<any>,
	focalY?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	sizes?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailURL?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_createdAtKeySpecifier)[];
export type CmsMediaFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_createdAt_CreateKeySpecifier = ('permission' | CmsMediaFields_createdAt_CreateKeySpecifier)[];
export type CmsMediaFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_createdAt_DeleteKeySpecifier = ('permission' | CmsMediaFields_createdAt_DeleteKeySpecifier)[];
export type CmsMediaFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_createdAt_ReadKeySpecifier = ('permission' | CmsMediaFields_createdAt_ReadKeySpecifier)[];
export type CmsMediaFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_createdAt_UpdateKeySpecifier = ('permission' | CmsMediaFields_createdAt_UpdateKeySpecifier)[];
export type CmsMediaFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_filenameKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_filenameKeySpecifier)[];
export type CmsMediaFields_filenameFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_filename_CreateKeySpecifier = ('permission' | CmsMediaFields_filename_CreateKeySpecifier)[];
export type CmsMediaFields_filename_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_filename_DeleteKeySpecifier = ('permission' | CmsMediaFields_filename_DeleteKeySpecifier)[];
export type CmsMediaFields_filename_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_filename_ReadKeySpecifier = ('permission' | CmsMediaFields_filename_ReadKeySpecifier)[];
export type CmsMediaFields_filename_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_filename_UpdateKeySpecifier = ('permission' | CmsMediaFields_filename_UpdateKeySpecifier)[];
export type CmsMediaFields_filename_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_filesizeKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_filesizeKeySpecifier)[];
export type CmsMediaFields_filesizeFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_filesize_CreateKeySpecifier = ('permission' | CmsMediaFields_filesize_CreateKeySpecifier)[];
export type CmsMediaFields_filesize_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_filesize_DeleteKeySpecifier = ('permission' | CmsMediaFields_filesize_DeleteKeySpecifier)[];
export type CmsMediaFields_filesize_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_filesize_ReadKeySpecifier = ('permission' | CmsMediaFields_filesize_ReadKeySpecifier)[];
export type CmsMediaFields_filesize_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_filesize_UpdateKeySpecifier = ('permission' | CmsMediaFields_filesize_UpdateKeySpecifier)[];
export type CmsMediaFields_filesize_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_focalXKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_focalXKeySpecifier)[];
export type CmsMediaFields_focalXFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_focalX_CreateKeySpecifier = ('permission' | CmsMediaFields_focalX_CreateKeySpecifier)[];
export type CmsMediaFields_focalX_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_focalX_DeleteKeySpecifier = ('permission' | CmsMediaFields_focalX_DeleteKeySpecifier)[];
export type CmsMediaFields_focalX_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_focalX_ReadKeySpecifier = ('permission' | CmsMediaFields_focalX_ReadKeySpecifier)[];
export type CmsMediaFields_focalX_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_focalX_UpdateKeySpecifier = ('permission' | CmsMediaFields_focalX_UpdateKeySpecifier)[];
export type CmsMediaFields_focalX_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_focalYKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_focalYKeySpecifier)[];
export type CmsMediaFields_focalYFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_focalY_CreateKeySpecifier = ('permission' | CmsMediaFields_focalY_CreateKeySpecifier)[];
export type CmsMediaFields_focalY_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_focalY_DeleteKeySpecifier = ('permission' | CmsMediaFields_focalY_DeleteKeySpecifier)[];
export type CmsMediaFields_focalY_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_focalY_ReadKeySpecifier = ('permission' | CmsMediaFields_focalY_ReadKeySpecifier)[];
export type CmsMediaFields_focalY_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_focalY_UpdateKeySpecifier = ('permission' | CmsMediaFields_focalY_UpdateKeySpecifier)[];
export type CmsMediaFields_focalY_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_heightKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_heightKeySpecifier)[];
export type CmsMediaFields_heightFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_height_CreateKeySpecifier = ('permission' | CmsMediaFields_height_CreateKeySpecifier)[];
export type CmsMediaFields_height_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_height_DeleteKeySpecifier = ('permission' | CmsMediaFields_height_DeleteKeySpecifier)[];
export type CmsMediaFields_height_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_height_ReadKeySpecifier = ('permission' | CmsMediaFields_height_ReadKeySpecifier)[];
export type CmsMediaFields_height_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_height_UpdateKeySpecifier = ('permission' | CmsMediaFields_height_UpdateKeySpecifier)[];
export type CmsMediaFields_height_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_mimeTypeKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_mimeTypeKeySpecifier)[];
export type CmsMediaFields_mimeTypeFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_mimeType_CreateKeySpecifier = ('permission' | CmsMediaFields_mimeType_CreateKeySpecifier)[];
export type CmsMediaFields_mimeType_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_mimeType_DeleteKeySpecifier = ('permission' | CmsMediaFields_mimeType_DeleteKeySpecifier)[];
export type CmsMediaFields_mimeType_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_mimeType_ReadKeySpecifier = ('permission' | CmsMediaFields_mimeType_ReadKeySpecifier)[];
export type CmsMediaFields_mimeType_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_mimeType_UpdateKeySpecifier = ('permission' | CmsMediaFields_mimeType_UpdateKeySpecifier)[];
export type CmsMediaFields_mimeType_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizesKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsMediaFields_sizesKeySpecifier)[];
export type CmsMediaFields_sizesFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_CreateKeySpecifier = ('permission' | CmsMediaFields_sizes_CreateKeySpecifier)[];
export type CmsMediaFields_sizes_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_DeleteKeySpecifier = ('permission' | CmsMediaFields_sizes_DeleteKeySpecifier)[];
export type CmsMediaFields_sizes_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_FieldsKeySpecifier = ('thumbnail' | CmsMediaFields_sizes_FieldsKeySpecifier)[];
export type CmsMediaFields_sizes_FieldsFieldPolicy = {
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_ReadKeySpecifier = ('permission' | CmsMediaFields_sizes_ReadKeySpecifier)[];
export type CmsMediaFields_sizes_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_UpdateKeySpecifier = ('permission' | CmsMediaFields_sizes_UpdateKeySpecifier)[];
export type CmsMediaFields_sizes_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnailKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | CmsMediaFields_sizes_thumbnailKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnailFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_CreateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_CreateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_DeleteKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_DeleteKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_FieldsKeySpecifier = ('filename' | 'filesize' | 'height' | 'mimeType' | 'url' | 'width' | CmsMediaFields_sizes_thumbnail_FieldsKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_FieldsFieldPolicy = {
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	filesize?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_ReadKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_ReadKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_UpdateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_UpdateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_filenameKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_sizes_thumbnail_filenameKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_filenameFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_filename_CreateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_filename_CreateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_filename_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_filename_DeleteKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_filename_DeleteKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_filename_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_filename_ReadKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_filename_ReadKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_filename_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_filename_UpdateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_filename_UpdateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_filename_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_filesizeKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_sizes_thumbnail_filesizeKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_filesizeFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_filesize_CreateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_filesize_CreateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_filesize_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_filesize_DeleteKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_filesize_DeleteKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_filesize_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_filesize_ReadKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_filesize_ReadKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_filesize_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_filesize_UpdateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_filesize_UpdateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_filesize_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_heightKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_sizes_thumbnail_heightKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_heightFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_height_CreateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_height_CreateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_height_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_height_DeleteKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_height_DeleteKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_height_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_height_ReadKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_height_ReadKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_height_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_height_UpdateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_height_UpdateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_height_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_mimeTypeKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_sizes_thumbnail_mimeTypeKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_mimeTypeFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_mimeType_CreateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_mimeType_CreateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_mimeType_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_mimeType_DeleteKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_mimeType_DeleteKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_mimeType_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_mimeType_ReadKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_mimeType_ReadKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_mimeType_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_mimeType_UpdateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_mimeType_UpdateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_mimeType_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_urlKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_sizes_thumbnail_urlKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_urlFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_url_CreateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_url_CreateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_url_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_url_DeleteKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_url_DeleteKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_url_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_url_ReadKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_url_ReadKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_url_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_url_UpdateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_url_UpdateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_url_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_widthKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_sizes_thumbnail_widthKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_widthFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_width_CreateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_width_CreateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_width_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_width_DeleteKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_width_DeleteKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_width_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_width_ReadKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_width_ReadKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_width_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_sizes_thumbnail_width_UpdateKeySpecifier = ('permission' | CmsMediaFields_sizes_thumbnail_width_UpdateKeySpecifier)[];
export type CmsMediaFields_sizes_thumbnail_width_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_thumbnailURLKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_thumbnailURLKeySpecifier)[];
export type CmsMediaFields_thumbnailURLFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_thumbnailURL_CreateKeySpecifier = ('permission' | CmsMediaFields_thumbnailURL_CreateKeySpecifier)[];
export type CmsMediaFields_thumbnailURL_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_thumbnailURL_DeleteKeySpecifier = ('permission' | CmsMediaFields_thumbnailURL_DeleteKeySpecifier)[];
export type CmsMediaFields_thumbnailURL_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_thumbnailURL_ReadKeySpecifier = ('permission' | CmsMediaFields_thumbnailURL_ReadKeySpecifier)[];
export type CmsMediaFields_thumbnailURL_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_thumbnailURL_UpdateKeySpecifier = ('permission' | CmsMediaFields_thumbnailURL_UpdateKeySpecifier)[];
export type CmsMediaFields_thumbnailURL_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_updatedAtKeySpecifier)[];
export type CmsMediaFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_updatedAt_CreateKeySpecifier = ('permission' | CmsMediaFields_updatedAt_CreateKeySpecifier)[];
export type CmsMediaFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsMediaFields_updatedAt_DeleteKeySpecifier)[];
export type CmsMediaFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_updatedAt_ReadKeySpecifier = ('permission' | CmsMediaFields_updatedAt_ReadKeySpecifier)[];
export type CmsMediaFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsMediaFields_updatedAt_UpdateKeySpecifier)[];
export type CmsMediaFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_urlKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_urlKeySpecifier)[];
export type CmsMediaFields_urlFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_url_CreateKeySpecifier = ('permission' | CmsMediaFields_url_CreateKeySpecifier)[];
export type CmsMediaFields_url_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_url_DeleteKeySpecifier = ('permission' | CmsMediaFields_url_DeleteKeySpecifier)[];
export type CmsMediaFields_url_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_url_ReadKeySpecifier = ('permission' | CmsMediaFields_url_ReadKeySpecifier)[];
export type CmsMediaFields_url_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_url_UpdateKeySpecifier = ('permission' | CmsMediaFields_url_UpdateKeySpecifier)[];
export type CmsMediaFields_url_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_widthKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsMediaFields_widthKeySpecifier)[];
export type CmsMediaFields_widthFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_width_CreateKeySpecifier = ('permission' | CmsMediaFields_width_CreateKeySpecifier)[];
export type CmsMediaFields_width_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_width_DeleteKeySpecifier = ('permission' | CmsMediaFields_width_DeleteKeySpecifier)[];
export type CmsMediaFields_width_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_width_ReadKeySpecifier = ('permission' | CmsMediaFields_width_ReadKeySpecifier)[];
export type CmsMediaFields_width_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaFields_width_UpdateKeySpecifier = ('permission' | CmsMediaFields_width_UpdateKeySpecifier)[];
export type CmsMediaFields_width_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaReadAccessKeySpecifier = ('permission' | 'where' | CmsMediaReadAccessKeySpecifier)[];
export type CmsMediaReadAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaReadDocAccessKeySpecifier = ('permission' | 'where' | CmsMediaReadDocAccessKeySpecifier)[];
export type CmsMediaReadDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaUpdateAccessKeySpecifier = ('permission' | 'where' | CmsMediaUpdateAccessKeySpecifier)[];
export type CmsMediaUpdateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediaUpdateDocAccessKeySpecifier = ('permission' | 'where' | CmsMediaUpdateDocAccessKeySpecifier)[];
export type CmsMediaUpdateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMedia_SizesKeySpecifier = ('thumbnail' | CmsMedia_SizesKeySpecifier)[];
export type CmsMedia_SizesFieldPolicy = {
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMedia_Sizes_ThumbnailKeySpecifier = ('filename' | 'filesize' | 'height' | 'mimeType' | 'url' | 'width' | CmsMedia_Sizes_ThumbnailKeySpecifier)[];
export type CmsMedia_Sizes_ThumbnailFieldPolicy = {
	filename?: FieldPolicy<any> | FieldReadFunction<any>,
	filesize?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsMediasKeySpecifier = ('docs' | 'hasNextPage' | 'hasPrevPage' | 'limit' | 'nextPage' | 'offset' | 'page' | 'pagingCounter' | 'prevPage' | 'totalDocs' | 'totalPages' | CmsMediasKeySpecifier)[];
export type CmsMediasFieldPolicy = {
	docs?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPrevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	nextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pagingCounter?: FieldPolicy<any> | FieldReadFunction<any>,
	prevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUserKeySpecifier = ('createdAt' | 'email' | 'hash' | 'id' | 'lockUntil' | 'loginAttempts' | 'name' | 'resetPasswordExpiration' | 'resetPasswordToken' | 'salt' | 'updatedAt' | CmsUserKeySpecifier)[];
export type CmsUserFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	hash?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lockUntil?: FieldPolicy<any> | FieldReadFunction<any>,
	loginAttempts?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPasswordExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPasswordToken?: FieldPolicy<any> | FieldReadFunction<any>,
	salt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersKeySpecifier = ('docs' | 'hasNextPage' | 'hasPrevPage' | 'limit' | 'nextPage' | 'offset' | 'page' | 'pagingCounter' | 'prevPage' | 'totalDocs' | 'totalPages' | CmsUsersKeySpecifier)[];
export type CmsUsersFieldPolicy = {
	docs?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPrevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	nextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pagingCounter?: FieldPolicy<any> | FieldReadFunction<any>,
	prevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'unlock' | 'update' | CmsUsersAccessKeySpecifier)[];
export type CmsUsersAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	unlock?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersCreateAccessKeySpecifier = ('permission' | 'where' | CmsUsersCreateAccessKeySpecifier)[];
export type CmsUsersCreateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersCreateDocAccessKeySpecifier = ('permission' | 'where' | CmsUsersCreateDocAccessKeySpecifier)[];
export type CmsUsersCreateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDeleteAccessKeySpecifier = ('permission' | 'where' | CmsUsersDeleteAccessKeySpecifier)[];
export type CmsUsersDeleteAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDeleteDocAccessKeySpecifier = ('permission' | 'where' | CmsUsersDeleteDocAccessKeySpecifier)[];
export type CmsUsersDeleteDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'unlock' | 'update' | CmsUsersDocAccessKeySpecifier)[];
export type CmsUsersDocAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	unlock?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFieldsKeySpecifier = ('createdAt' | 'email' | 'name' | 'updatedAt' | CmsUsersDocAccessFieldsKeySpecifier)[];
export type CmsUsersDocAccessFieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsUsersDocAccessFields_createdAtKeySpecifier)[];
export type CmsUsersDocAccessFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_createdAt_CreateKeySpecifier = ('permission' | CmsUsersDocAccessFields_createdAt_CreateKeySpecifier)[];
export type CmsUsersDocAccessFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_createdAt_DeleteKeySpecifier = ('permission' | CmsUsersDocAccessFields_createdAt_DeleteKeySpecifier)[];
export type CmsUsersDocAccessFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_createdAt_ReadKeySpecifier = ('permission' | CmsUsersDocAccessFields_createdAt_ReadKeySpecifier)[];
export type CmsUsersDocAccessFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_createdAt_UpdateKeySpecifier = ('permission' | CmsUsersDocAccessFields_createdAt_UpdateKeySpecifier)[];
export type CmsUsersDocAccessFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_emailKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsUsersDocAccessFields_emailKeySpecifier)[];
export type CmsUsersDocAccessFields_emailFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_email_CreateKeySpecifier = ('permission' | CmsUsersDocAccessFields_email_CreateKeySpecifier)[];
export type CmsUsersDocAccessFields_email_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_email_DeleteKeySpecifier = ('permission' | CmsUsersDocAccessFields_email_DeleteKeySpecifier)[];
export type CmsUsersDocAccessFields_email_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_email_ReadKeySpecifier = ('permission' | CmsUsersDocAccessFields_email_ReadKeySpecifier)[];
export type CmsUsersDocAccessFields_email_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_email_UpdateKeySpecifier = ('permission' | CmsUsersDocAccessFields_email_UpdateKeySpecifier)[];
export type CmsUsersDocAccessFields_email_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_nameKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsUsersDocAccessFields_nameKeySpecifier)[];
export type CmsUsersDocAccessFields_nameFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_name_CreateKeySpecifier = ('permission' | CmsUsersDocAccessFields_name_CreateKeySpecifier)[];
export type CmsUsersDocAccessFields_name_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_name_DeleteKeySpecifier = ('permission' | CmsUsersDocAccessFields_name_DeleteKeySpecifier)[];
export type CmsUsersDocAccessFields_name_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_name_ReadKeySpecifier = ('permission' | CmsUsersDocAccessFields_name_ReadKeySpecifier)[];
export type CmsUsersDocAccessFields_name_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_name_UpdateKeySpecifier = ('permission' | CmsUsersDocAccessFields_name_UpdateKeySpecifier)[];
export type CmsUsersDocAccessFields_name_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsUsersDocAccessFields_updatedAtKeySpecifier)[];
export type CmsUsersDocAccessFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_updatedAt_CreateKeySpecifier = ('permission' | CmsUsersDocAccessFields_updatedAt_CreateKeySpecifier)[];
export type CmsUsersDocAccessFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsUsersDocAccessFields_updatedAt_DeleteKeySpecifier)[];
export type CmsUsersDocAccessFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_updatedAt_ReadKeySpecifier = ('permission' | CmsUsersDocAccessFields_updatedAt_ReadKeySpecifier)[];
export type CmsUsersDocAccessFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersDocAccessFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsUsersDocAccessFields_updatedAt_UpdateKeySpecifier)[];
export type CmsUsersDocAccessFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFieldsKeySpecifier = ('createdAt' | 'email' | 'name' | 'updatedAt' | CmsUsersFieldsKeySpecifier)[];
export type CmsUsersFieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsUsersFields_createdAtKeySpecifier)[];
export type CmsUsersFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_createdAt_CreateKeySpecifier = ('permission' | CmsUsersFields_createdAt_CreateKeySpecifier)[];
export type CmsUsersFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_createdAt_DeleteKeySpecifier = ('permission' | CmsUsersFields_createdAt_DeleteKeySpecifier)[];
export type CmsUsersFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_createdAt_ReadKeySpecifier = ('permission' | CmsUsersFields_createdAt_ReadKeySpecifier)[];
export type CmsUsersFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_createdAt_UpdateKeySpecifier = ('permission' | CmsUsersFields_createdAt_UpdateKeySpecifier)[];
export type CmsUsersFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_emailKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsUsersFields_emailKeySpecifier)[];
export type CmsUsersFields_emailFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_email_CreateKeySpecifier = ('permission' | CmsUsersFields_email_CreateKeySpecifier)[];
export type CmsUsersFields_email_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_email_DeleteKeySpecifier = ('permission' | CmsUsersFields_email_DeleteKeySpecifier)[];
export type CmsUsersFields_email_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_email_ReadKeySpecifier = ('permission' | CmsUsersFields_email_ReadKeySpecifier)[];
export type CmsUsersFields_email_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_email_UpdateKeySpecifier = ('permission' | CmsUsersFields_email_UpdateKeySpecifier)[];
export type CmsUsersFields_email_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_nameKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsUsersFields_nameKeySpecifier)[];
export type CmsUsersFields_nameFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_name_CreateKeySpecifier = ('permission' | CmsUsersFields_name_CreateKeySpecifier)[];
export type CmsUsersFields_name_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_name_DeleteKeySpecifier = ('permission' | CmsUsersFields_name_DeleteKeySpecifier)[];
export type CmsUsersFields_name_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_name_ReadKeySpecifier = ('permission' | CmsUsersFields_name_ReadKeySpecifier)[];
export type CmsUsersFields_name_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_name_UpdateKeySpecifier = ('permission' | CmsUsersFields_name_UpdateKeySpecifier)[];
export type CmsUsersFields_name_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | CmsUsersFields_updatedAtKeySpecifier)[];
export type CmsUsersFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_updatedAt_CreateKeySpecifier = ('permission' | CmsUsersFields_updatedAt_CreateKeySpecifier)[];
export type CmsUsersFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_updatedAt_DeleteKeySpecifier = ('permission' | CmsUsersFields_updatedAt_DeleteKeySpecifier)[];
export type CmsUsersFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_updatedAt_ReadKeySpecifier = ('permission' | CmsUsersFields_updatedAt_ReadKeySpecifier)[];
export type CmsUsersFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersFields_updatedAt_UpdateKeySpecifier = ('permission' | CmsUsersFields_updatedAt_UpdateKeySpecifier)[];
export type CmsUsersFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersJWTKeySpecifier = ('collection' | 'email' | CmsUsersJWTKeySpecifier)[];
export type CmsUsersJWTFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersLoginResultKeySpecifier = ('exp' | 'token' | 'user' | CmsUsersLoginResultKeySpecifier)[];
export type CmsUsersLoginResultFieldPolicy = {
	exp?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersMeKeySpecifier = ('collection' | 'exp' | 'strategy' | 'token' | 'user' | CmsUsersMeKeySpecifier)[];
export type CmsUsersMeFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	exp?: FieldPolicy<any> | FieldReadFunction<any>,
	strategy?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersReadAccessKeySpecifier = ('permission' | 'where' | CmsUsersReadAccessKeySpecifier)[];
export type CmsUsersReadAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersReadDocAccessKeySpecifier = ('permission' | 'where' | CmsUsersReadDocAccessKeySpecifier)[];
export type CmsUsersReadDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersRefreshedCmsUserKeySpecifier = ('exp' | 'refreshedToken' | 'strategy' | 'user' | CmsUsersRefreshedCmsUserKeySpecifier)[];
export type CmsUsersRefreshedCmsUserFieldPolicy = {
	exp?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshedToken?: FieldPolicy<any> | FieldReadFunction<any>,
	strategy?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersResetPasswordKeySpecifier = ('token' | 'user' | CmsUsersResetPasswordKeySpecifier)[];
export type CmsUsersResetPasswordFieldPolicy = {
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersUnlockAccessKeySpecifier = ('permission' | 'where' | CmsUsersUnlockAccessKeySpecifier)[];
export type CmsUsersUnlockAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersUnlockDocAccessKeySpecifier = ('permission' | 'where' | CmsUsersUnlockDocAccessKeySpecifier)[];
export type CmsUsersUnlockDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersUpdateAccessKeySpecifier = ('permission' | 'where' | CmsUsersUpdateAccessKeySpecifier)[];
export type CmsUsersUpdateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CmsUsersUpdateDocAccessKeySpecifier = ('permission' | 'where' | CmsUsersUpdateDocAccessKeySpecifier)[];
export type CmsUsersUpdateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompetitionKeySpecifier = ('competitionState' | 'competitionTiming' | 'competitionType' | 'created' | 'event' | 'eventId' | 'eventStageId' | 'game' | 'gameId' | 'id' | 'participantType' | 'participants' | CompetitionKeySpecifier)[];
export type CompetitionFieldPolicy = {
	competitionState?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionTiming?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionType?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventStageId?: FieldPolicy<any> | FieldReadFunction<any>,
	game?: FieldPolicy<any> | FieldReadFunction<any>,
	gameId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	participantType?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompetitionMatchKeySpecifier = ('assets' | 'gameSpecificDetails' | 'id' | 'isComplete' | 'name' | 'startTime' | CompetitionMatchKeySpecifier)[];
export type CompetitionMatchFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	gameSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompetitionParticipantReferenceKeySpecifier = ('accountId' | 'participant' | 'participantId' | 'result' | CompetitionParticipantReferenceKeySpecifier)[];
export type CompetitionParticipantReferenceFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	participant?: FieldPolicy<any> | FieldReadFunction<any>,
	participantId?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompetitionParticipantReferenceWithRosterKeySpecifier = ('accountId' | 'participant' | 'participantId' | 'result' | 'roster' | 'seededFromCompetitionMatchId' | CompetitionParticipantReferenceWithRosterKeySpecifier)[];
export type CompetitionParticipantReferenceWithRosterFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	participant?: FieldPolicy<any> | FieldReadFunction<any>,
	participantId?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>,
	roster?: FieldPolicy<any> | FieldReadFunction<any>,
	seededFromCompetitionMatchId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompetitionSpecificDetailsKeySpecifier = ('id' | CompetitionSpecificDetailsKeySpecifier)[];
export type CompetitionSpecificDetailsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompetitionTimingKeySpecifier = ('latestPreparationStartTime' | 'startTime' | CompetitionTimingKeySpecifier)[];
export type CompetitionTimingFieldPolicy = {
	latestPreparationStartTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactKeySpecifier = ('contactId' | 'contactNumber' | 'countryCode' | 'email' | ContactKeySpecifier)[];
export type ContactFieldPolicy = {
	contactId?: FieldPolicy<any> | FieldReadFunction<any>,
	contactNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CostKeySpecifier = ('amount' | 'costType' | 'created' | 'frequency' | 'id' | CostKeySpecifier)[];
export type CostFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	costType?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	frequency?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CurrencyConversionKeySpecifier = ('conversionRate' | 'conversionRateOverriddenLevel' | 'sourceCurrency' | 'targetCurrency' | CurrencyConversionKeySpecifier)[];
export type CurrencyConversionFieldPolicy = {
	conversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	conversionRateOverriddenLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	targetCurrency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CurrencyItemCostKeySpecifier = ('cost' | 'created' | 'currencyItem' | 'currencyItemCostType' | 'id' | 'realWorldCurrencyType' | 'swarmioCurrencyItemId' | 'version' | CurrencyItemCostKeySpecifier)[];
export type CurrencyItemCostFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyItem?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyItemCostType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	realWorldCurrencyType?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CurrencyItemCostArchiveKeySpecifier = ('cost' | 'created' | 'currencyItem' | 'currencyItemCostType' | 'id' | 'realWorldCurrencyType' | 'swarmioCurrencyItemId' | 'version' | CurrencyItemCostArchiveKeySpecifier)[];
export type CurrencyItemCostArchiveFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyItem?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyItemCostType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	realWorldCurrencyType?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CurrencyPriceKeySpecifier = ('currency' | 'markUpPrice' | 'markUpPriceForCurrency' | CurrencyPriceKeySpecifier)[];
export type CurrencyPriceFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	markUpPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	markUpPriceForCurrency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomPrizeKeySpecifier = ('id' | 'localizedDescriptions' | 'prizeType' | CustomPrizeKeySpecifier)[];
export type CustomPrizeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	localizedDescriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	prizeType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomPrizePayoutReceiptKeySpecifier = ('accountId' | 'created' | 'description' | 'id' | 'notes' | 'prizePayoutReceiptType' | 'prizeTierId' | 'successful' | CustomPrizePayoutReceiptKeySpecifier)[];
export type CustomPrizePayoutReceiptFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	prizePayoutReceiptType?: FieldPolicy<any> | FieldReadFunction<any>,
	prizeTierId?: FieldPolicy<any> | FieldReadFunction<any>,
	successful?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DateAttributeKeySpecifier = ('isError' | 'value' | DateAttributeKeySpecifier)[];
export type DateAttributeFieldPolicy = {
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DateAttributeWithPossibleErrorKeySpecifier = ('isError' | DateAttributeWithPossibleErrorKeySpecifier)[];
export type DateAttributeWithPossibleErrorFieldPolicy = {
	isError?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealKeySpecifier = ('createdBy' | 'createdDate' | 'deactivatedDateTime' | 'dealActivePartnerItems' | 'dealName' | 'dealPaymentChannels' | 'dealPercentage' | 'endDateTime' | 'finalPriceRoundOffBoundary' | 'finalPriceRoundOffDecimalPlace' | 'id' | 'isActive' | 'selectedPartners' | 'startDateTime' | DealKeySpecifier)[];
export type DealFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	deactivatedDateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	dealActivePartnerItems?: FieldPolicy<any> | FieldReadFunction<any>,
	dealName?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPaymentChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	endDateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	finalPriceRoundOffBoundary?: FieldPolicy<any> | FieldReadFunction<any>,
	finalPriceRoundOffDecimalPlace?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	selectedPartners?: FieldPolicy<any> | FieldReadFunction<any>,
	startDateTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealActivePartnerItemKeySpecifier = ('catalog' | 'createdDateTime' | 'id' | 'item' | DealActivePartnerItemKeySpecifier)[];
export type DealActivePartnerItemFieldPolicy = {
	catalog?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealCategoryKeySpecifier = ('categoryId' | 'categoryName' | 'id' | 'productGroups' | DealCategoryKeySpecifier)[];
export type DealCategoryFieldPolicy = {
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroups?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealDetailsDtoKeySpecifier = ('dealName' | 'dealPercentage' | 'dealStatus' | 'endDateTime' | 'finalPriceRoundOffBoundary' | 'finalPriceRoundOffDecimalPlace' | 'id' | 'isActive' | 'startDateTime' | DealDetailsDtoKeySpecifier)[];
export type DealDetailsDtoFieldPolicy = {
	dealName?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	dealStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	endDateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	finalPriceRoundOffBoundary?: FieldPolicy<any> | FieldReadFunction<any>,
	finalPriceRoundOffDecimalPlace?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	startDateTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealDtoKeySpecifier = ('dealActivePartnerItems' | 'dealName' | 'dealPaymentChannel' | 'dealPercentage' | 'endDateTime' | 'finalPriceRoundOffBoundary' | 'finalPriceRoundOffDecimalPlace' | 'id' | 'isActive' | 'productCount' | 'selectedPartners' | 'startDateTime' | 'status' | DealDtoKeySpecifier)[];
export type DealDtoFieldPolicy = {
	dealActivePartnerItems?: FieldPolicy<any> | FieldReadFunction<any>,
	dealName?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPaymentChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	endDateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	finalPriceRoundOffBoundary?: FieldPolicy<any> | FieldReadFunction<any>,
	finalPriceRoundOffDecimalPlace?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	productCount?: FieldPolicy<any> | FieldReadFunction<any>,
	selectedPartners?: FieldPolicy<any> | FieldReadFunction<any>,
	startDateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealItemKeySpecifier = ('displayName' | 'gamePublisher' | 'id' | 'isAlreadyInDeal' | 'itemId' | 'itemName' | 'sourceCurrency' | 'unitPrice' | 'variantName' | DealItemKeySpecifier)[];
export type DealItemFieldPolicy = {
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	gamePublisher?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAlreadyInDeal?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	variantName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealLogDetailDtoKeySpecifier = ('currentPage' | 'dealLogs' | 'totalFilteredDealLogs' | 'totalPages' | DealLogDetailDtoKeySpecifier)[];
export type DealLogDetailDtoFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	dealLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFilteredDealLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealLogDtoKeySpecifier = ('createdDate' | 'dealId' | 'description' | 'id' | 'initiatedBy' | 'itemId' | 'itemName' | DealLogDtoKeySpecifier)[];
export type DealLogDtoFieldPolicy = {
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	dealId?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	initiatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealPartnerKeySpecifier = ('catalogId' | 'catalogName' | 'categories' | 'id' | 'partnerId' | 'partnerName' | DealPartnerKeySpecifier)[];
export type DealPartnerFieldPolicy = {
	catalogId?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogName?: FieldPolicy<any> | FieldReadFunction<any>,
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealPartnerDtoKeySpecifier = ('country' | 'id' | 'localCurrency' | 'partnerId' | 'partnerName' | 'partnerUrl' | DealPartnerDtoKeySpecifier)[];
export type DealPartnerDtoFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	localCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerName?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealPartnerItemDtoKeySpecifier = ('catalogId' | 'catalogName' | 'itemId' | 'itemName' | DealPartnerItemDtoKeySpecifier)[];
export type DealPartnerItemDtoFieldPolicy = {
	catalogId?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealPaymentChannelKeySpecifier = ('id' | 'paymentChannel' | DealPaymentChannelKeySpecifier)[];
export type DealPaymentChannelFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentChannel?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealPaymentChannelsDtoKeySpecifier = ('paymentChannels' | DealPaymentChannelsDtoKeySpecifier)[];
export type DealPaymentChannelsDtoFieldPolicy = {
	paymentChannels?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DealProductGroupKeySpecifier = ('id' | 'items' | 'productGroupId' | 'productGroupName' | DealProductGroupKeySpecifier)[];
export type DealProductGroupFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DimensionMultiplierKeySpecifier = ('dimensionId' | 'id' | 'multiplier' | DimensionMultiplierKeySpecifier)[];
export type DimensionMultiplierFieldPolicy = {
	dimensionId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	multiplier?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DistributionInfoKeySpecifier = ('channel' | 'date' | 'distributedTo' | DistributionInfoKeySpecifier)[];
export type DistributionInfoFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	distributedTo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftProductKeySpecifier = ('additionalData' | 'availableStock' | 'costPrice' | 'currency' | 'id' | 'productCode' | 'productName' | 'productType' | 'publisherName' | 'sku' | 'totalStock' | 'voucherCode' | 'voucherExpiry' | 'voucherPin' | 'voucherSerial' | DraftProductKeySpecifier)[];
export type DraftProductFieldPolicy = {
	additionalData?: FieldPolicy<any> | FieldReadFunction<any>,
	availableStock?: FieldPolicy<any> | FieldReadFunction<any>,
	costPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	productCode?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	publisherName?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	totalStock?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCode?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherExpiry?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherPin?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherSerial?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmbeddedGameKeySpecifier = ('availability' | 'desc' | 'embeddedGameURL' | 'id' | 'thumbnailURL' | 'title' | EmbeddedGameKeySpecifier)[];
export type EmbeddedGameFieldPolicy = {
	availability?: FieldPolicy<any> | FieldReadFunction<any>,
	desc?: FieldPolicy<any> | FieldReadFunction<any>,
	embeddedGameURL?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailURL?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnumMissingParticipantRequirementKeySpecifier = ('entryName' | EnumMissingParticipantRequirementKeySpecifier)[];
export type EnumMissingParticipantRequirementFieldPolicy = {
	entryName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventKeySpecifier = ('category' | 'created' | 'defaultLocale' | 'disqualifiedParticipants' | 'eventCurrencyExchanges' | 'eventLimitations' | 'eventStages' | 'eventState' | 'eventTeam' | 'eventTiming' | 'featured' | 'game' | 'gameAccountTypeIds' | 'gameAccountTypes' | 'gameId' | 'id' | 'isSimulated' | 'localizedDescriptions' | 'localizedMediaContentDetails' | 'localizedNames' | 'ownerId' | 'participantCount' | 'participantType' | 'participants' | 'region' | 'tags' | 'unlisted' | EventKeySpecifier)[];
export type EventFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultLocale?: FieldPolicy<any> | FieldReadFunction<any>,
	disqualifiedParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	eventCurrencyExchanges?: FieldPolicy<any> | FieldReadFunction<any>,
	eventLimitations?: FieldPolicy<any> | FieldReadFunction<any>,
	eventStages?: FieldPolicy<any> | FieldReadFunction<any>,
	eventState?: FieldPolicy<any> | FieldReadFunction<any>,
	eventTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	eventTiming?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	game?: FieldPolicy<any> | FieldReadFunction<any>,
	gameAccountTypeIds?: FieldPolicy<any> | FieldReadFunction<any>,
	gameAccountTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	gameId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSimulated?: FieldPolicy<any> | FieldReadFunction<any>,
	localizedDescriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	localizedMediaContentDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	localizedNames?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	participantCount?: FieldPolicy<any> | FieldReadFunction<any>,
	participantType?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	unlisted?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventCurrencyExchangesKeySpecifier = ('prizeList' | EventCurrencyExchangesKeySpecifier)[];
export type EventCurrencyExchangesFieldPolicy = {
	prizeList?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventEntryRulesKeySpecifier = ('id' | EventEntryRulesKeySpecifier)[];
export type EventEntryRulesFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventLimitationsKeySpecifier = ('checkInMode' | 'eventEntryRules' | 'localizedJoinInstructions' | 'localizedWrittenRules' | 'maximumParticipants' | 'minimumParticipants' | 'requiredAdditionalInformation' | EventLimitationsKeySpecifier)[];
export type EventLimitationsFieldPolicy = {
	checkInMode?: FieldPolicy<any> | FieldReadFunction<any>,
	eventEntryRules?: FieldPolicy<any> | FieldReadFunction<any>,
	localizedJoinInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	localizedWrittenRules?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	requiredAdditionalInformation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventRequirementKeySpecifier = ('playersMissingCheckIn' | 'playersMissingRegistration' | 'teamMissingPlayers' | EventRequirementKeySpecifier)[];
export type EventRequirementFieldPolicy = {
	playersMissingCheckIn?: FieldPolicy<any> | FieldReadFunction<any>,
	playersMissingRegistration?: FieldPolicy<any> | FieldReadFunction<any>,
	teamMissingPlayers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventStageKeySpecifier = ('advanceStrategy' | 'breakStrategy' | 'competitions' | 'created' | 'eventId' | 'eventStageState' | 'game' | 'gameId' | 'id' | 'isComplete' | 'isSimulated' | 'mustEndBy' | 'participantType' | 'participants' | 'stageNumber' | 'startTime' | 'startXMinutesAfterPreviousStage' | EventStageKeySpecifier)[];
export type EventStageFieldPolicy = {
	advanceStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	breakStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	competitions?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventStageState?: FieldPolicy<any> | FieldReadFunction<any>,
	game?: FieldPolicy<any> | FieldReadFunction<any>,
	gameId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	isSimulated?: FieldPolicy<any> | FieldReadFunction<any>,
	mustEndBy?: FieldPolicy<any> | FieldReadFunction<any>,
	participantType?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>,
	stageNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	startXMinutesAfterPreviousStage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventStageParticipantReferenceKeySpecifier = ('accountId' | 'participant' | 'participantId' | 'result' | EventStageParticipantReferenceKeySpecifier)[];
export type EventStageParticipantReferenceFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	participant?: FieldPolicy<any> | FieldReadFunction<any>,
	participantId?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventTeamMemberKeySpecifier = ('accountId' | 'id' | 'roles' | EventTeamMemberKeySpecifier)[];
export type EventTeamMemberFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventTimingKeySpecifier = ('completedAt' | 'registrationClose' | 'registrationOpen' | 'startTime' | EventTimingKeySpecifier)[];
export type EventTimingFieldPolicy = {
	completedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationClose?: FieldPolicy<any> | FieldReadFunction<any>,
	registrationOpen?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExactPlacementAdvanceStrategyKeySpecifier = ('advanceStrategyType' | 'placement' | ExactPlacementAdvanceStrategyKeySpecifier)[];
export type ExactPlacementAdvanceStrategyFieldPolicy = {
	advanceStrategyType?: FieldPolicy<any> | FieldReadFunction<any>,
	placement?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExchangedTransactionKeySpecifier = ('amount' | 'created' | 'id' | 'notes' | 'otherWallet' | 'otherWalletId' | 'swarmioCurrencyExchangeRateArchiveId' | 'transactionType' | 'wallet' | 'walletId' | ExchangedTransactionKeySpecifier)[];
export type ExchangedTransactionFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	otherWallet?: FieldPolicy<any> | FieldReadFunction<any>,
	otherWalletId?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyExchangeRateArchiveId?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionType?: FieldPolicy<any> | FieldReadFunction<any>,
	wallet?: FieldPolicy<any> | FieldReadFunction<any>,
	walletId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExplicitEnrollmentKeySpecifier = ('costs' | 'costsArchive' | 'externalField' | 'id' | ExplicitEnrollmentKeySpecifier)[];
export type ExplicitEnrollmentFieldPolicy = {
	costs?: FieldPolicy<any> | FieldReadFunction<any>,
	costsArchive?: FieldPolicy<any> | FieldReadFunction<any>,
	externalField?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExplicitSubscriptionKeySpecifier = ('expiry' | 'id' | 'isUsable' | 'lastPaymentDate' | 'nextExpectedPayment' | 'nextRewardDate' | 'payments' | 'secret' | 'subscriptionImplementation' | 'subscriptionState' | 'subscriptionType' | 'subscriptionTypeCostId' | 'subscriptionTypeId' | 'unappliedPayments' | ExplicitSubscriptionKeySpecifier)[];
export type ExplicitSubscriptionFieldPolicy = {
	expiry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isUsable?: FieldPolicy<any> | FieldReadFunction<any>,
	lastPaymentDate?: FieldPolicy<any> | FieldReadFunction<any>,
	nextExpectedPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	nextRewardDate?: FieldPolicy<any> | FieldReadFunction<any>,
	payments?: FieldPolicy<any> | FieldReadFunction<any>,
	secret?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionImplementation?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionState?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionTypeCostId?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	unappliedPayments?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportedItemsCSVKeySpecifier = ('filePath' | ExportedItemsCSVKeySpecifier)[];
export type ExportedItemsCSVFieldPolicy = {
	filePath?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalCurrencyItemCostKeySpecifier = ('cost' | 'created' | 'currencyItem' | 'currencyItemCostType' | 'externalId' | 'id' | 'realWorldCurrencyType' | 'swarmioCurrencyItemId' | 'version' | ExternalCurrencyItemCostKeySpecifier)[];
export type ExternalCurrencyItemCostFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyItem?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyItemCostType?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	realWorldCurrencyType?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalCurrencyItemCostArchiveKeySpecifier = ('cost' | 'created' | 'currencyItem' | 'currencyItemCostType' | 'externalId' | 'id' | 'realWorldCurrencyType' | 'swarmioCurrencyItemId' | 'version' | ExternalCurrencyItemCostArchiveKeySpecifier)[];
export type ExternalCurrencyItemCostArchiveFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyItem?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyItemCostType?: FieldPolicy<any> | FieldReadFunction<any>,
	externalId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	realWorldCurrencyType?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalFieldKeySpecifier = ('id' | 'name' | ExternalFieldKeySpecifier)[];
export type ExternalFieldFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalSubscriptionPackageKeySpecifier = ('active' | 'costs' | 'description' | 'id' | 'name' | 'providerSubscriptionId' | 'subscriptionPartner' | 'subscriptionProvider' | 'subscriptionType' | 'subscriptionTypeId' | ExternalSubscriptionPackageKeySpecifier)[];
export type ExternalSubscriptionPackageFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	costs?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	providerSubscriptionId?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionPartner?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionTypeId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FailedOrderTransactionKeySpecifier = ('contentType' | 'createdDate' | 'currencyConversionRate' | 'dealId' | 'dealPercentage' | 'dealValue' | 'errorCode' | 'errorMessage' | 'gamerEmail' | 'gamerId' | 'gamerName' | 'id' | 'item' | 'markedUpPrice' | 'partner' | 'pointsConversionRate' | 'pointsValue' | 'productSellPrice' | 'purchaseCurrency' | 'purchaseMedium' | 'purchasePaymentChannelName' | 'quantity' | 'retryButtonDisabled' | 'status' | 'totalPoints' | 'transactionId' | 'unitPrice' | FailedOrderTransactionKeySpecifier)[];
export type FailedOrderTransactionFieldPolicy = {
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyConversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	dealId?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	dealValue?: FieldPolicy<any> | FieldReadFunction<any>,
	errorCode?: FieldPolicy<any> | FieldReadFunction<any>,
	errorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerId?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	partner?: FieldPolicy<any> | FieldReadFunction<any>,
	pointsConversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	pointsValue?: FieldPolicy<any> | FieldReadFunction<any>,
	productSellPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseMedium?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasePaymentChannelName?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	retryButtonDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FeatureKeySpecifier = ('created' | 'description' | 'id' | 'name' | 'updated' | FeatureKeySpecifier)[];
export type FeatureFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FeatureFlagKeySpecifier = ('created' | 'feature' | 'id' | 'segments' | 'state' | 'updated' | FeatureFlagKeySpecifier)[];
export type FeatureFlagFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	feature?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	segments?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FixedNumberBreakStrategyKeySpecifier = ('breakStrategyType' | 'number' | FixedNumberBreakStrategyKeySpecifier)[];
export type FixedNumberBreakStrategyFieldPolicy = {
	breakStrategyType?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FixedPrizeKeySpecifier = ('id' | 'prizeType' | FixedPrizeKeySpecifier)[];
export type FixedPrizeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	prizeType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FreebieTransactionKeySpecifier = ('amount' | 'approvedBy' | 'created' | 'id' | 'notes' | 'transactionType' | 'wallet' | 'walletId' | FreebieTransactionKeySpecifier)[];
export type FreebieTransactionFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	approvedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionType?: FieldPolicy<any> | FieldReadFunction<any>,
	wallet?: FieldPolicy<any> | FieldReadFunction<any>,
	walletId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GameKeySpecifier = ('bufferTime' | 'description' | 'estimatedRoundLength' | 'gameAccountTypeIds' | 'gameAccountTypes' | 'id' | 'image' | 'integrated' | 'maxParticipantsPerRound' | 'prettyName' | 'supportedCompetitionFormats' | 'supportedParticipantTypes' | 'typicalPlacingStrategyForRounds' | 'weight' | GameKeySpecifier)[];
export type GameFieldPolicy = {
	bufferTime?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	estimatedRoundLength?: FieldPolicy<any> | FieldReadFunction<any>,
	gameAccountTypeIds?: FieldPolicy<any> | FieldReadFunction<any>,
	gameAccountTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	integrated?: FieldPolicy<any> | FieldReadFunction<any>,
	maxParticipantsPerRound?: FieldPolicy<any> | FieldReadFunction<any>,
	prettyName?: FieldPolicy<any> | FieldReadFunction<any>,
	supportedCompetitionFormats?: FieldPolicy<any> | FieldReadFunction<any>,
	supportedParticipantTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	typicalPlacingStrategyForRounds?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GameAccountKeySpecifier = ('created' | 'externalAccountId' | 'externalAccountName' | 'gameAccountTypeId' | 'gameIds' | 'games' | 'id' | 'updated' | 'verified' | GameAccountKeySpecifier)[];
export type GameAccountFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	externalAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	externalAccountName?: FieldPolicy<any> | FieldReadFunction<any>,
	gameAccountTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	gameIds?: FieldPolicy<any> | FieldReadFunction<any>,
	games?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>,
	verified?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GameAccountTypeKeySpecifier = ('accountIDLabel' | 'accountNameLabel' | 'games' | 'iconUrl' | 'id' | 'imageUrl' | 'implicitGameIds' | 'integrated' | 'prettyName' | 'requiresExternalAccountId' | 'requiresExternalAccountName' | 'unlisted' | GameAccountTypeKeySpecifier)[];
export type GameAccountTypeFieldPolicy = {
	accountIDLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNameLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	games?: FieldPolicy<any> | FieldReadFunction<any>,
	iconUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	implicitGameIds?: FieldPolicy<any> | FieldReadFunction<any>,
	integrated?: FieldPolicy<any> | FieldReadFunction<any>,
	prettyName?: FieldPolicy<any> | FieldReadFunction<any>,
	requiresExternalAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	requiresExternalAccountName?: FieldPolicy<any> | FieldReadFunction<any>,
	unlisted?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GameSpecificCompetitionDetailsKeySpecifier = ('gameId' | GameSpecificCompetitionDetailsKeySpecifier)[];
export type GameSpecificCompetitionDetailsFieldPolicy = {
	gameId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GameSpecificDetailsKeySpecifier = ('gameId' | GameSpecificDetailsKeySpecifier)[];
export type GameSpecificDetailsFieldPolicy = {
	gameId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GameUserIdValidationResponseKeySpecifier = ('isValid' | 'responseMessage' | GameUserIdValidationResponseKeySpecifier)[];
export type GameUserIdValidationResponseFieldPolicy = {
	isValid?: FieldPolicy<any> | FieldReadFunction<any>,
	responseMessage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GamingActionableKeySpecifier = ('action' | 'id' | 'scopeGroups' | 'target' | GamingActionableKeySpecifier)[];
export type GamingActionableFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	scopeGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	target?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GamingFullRoleKeySpecifier = ('businessScope' | 'id' | 'permissions' | 'prettyName' | 'roleDisplayName' | 'roleId' | GamingFullRoleKeySpecifier)[];
export type GamingFullRoleFieldPolicy = {
	businessScope?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	prettyName?: FieldPolicy<any> | FieldReadFunction<any>,
	roleDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	roleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GamingRoleKeySpecifier = ('businessScope' | 'roleDisplayName' | 'roleId' | GamingRoleKeySpecifier)[];
export type GamingRoleFieldPolicy = {
	businessScope?: FieldPolicy<any> | FieldReadFunction<any>,
	roleDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	roleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GamingRoleFragmentKeySpecifier = ('businessScope' | 'roleDisplayName' | 'roleId' | GamingRoleFragmentKeySpecifier)[];
export type GamingRoleFragmentFieldPolicy = {
	businessScope?: FieldPolicy<any> | FieldReadFunction<any>,
	roleDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	roleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GamingScopeKeySpecifier = ('scopeTarget' | 'value' | GamingScopeKeySpecifier)[];
export type GamingScopeFieldPolicy = {
	scopeTarget?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GamingScopeGroupKeySpecifier = ('scopes' | GamingScopeGroupKeySpecifier)[];
export type GamingScopeGroupFieldPolicy = {
	scopes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupKeySpecifier = ('accountInvites' | 'accountType' | 'avatarURL' | 'bannerURL' | 'created' | 'description' | 'groupInvites' | 'groupMembers' | 'groupMemberships' | 'groupType' | 'id' | 'isSupplier' | 'lastUpdated' | 'managedAccounts' | 'name' | 'otherFields' | 'ownerId' | 'payPurchaseTransactions' | 'publicURL' | 'purchaseTransactions' | 'socialLinks' | 'subscriptionProviderAccounts' | 'subscriptions' | 'updated' | 'wallets' | GroupKeySpecifier)[];
export type GroupFieldPolicy = {
	accountInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	accountType?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarURL?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerURL?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	groupInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	groupMembers?: FieldPolicy<any> | FieldReadFunction<any>,
	groupMemberships?: FieldPolicy<any> | FieldReadFunction<any>,
	groupType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSupplier?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	managedAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	otherFields?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	payPurchaseTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	publicURL?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	socialLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProviderAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>,
	wallets?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupInviteKeySpecifier = ('created' | 'group' | 'groupId' | 'id' | 'isError' | 'roles' | GroupInviteKeySpecifier)[];
export type GroupInviteFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	groupId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupInviteWithPossibleErrorKeySpecifier = ('isError' | GroupInviteWithPossibleErrorKeySpecifier)[];
export type GroupInviteWithPossibleErrorFieldPolicy = {
	isError?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupMemberKeySpecifier = ('account' | 'accountId' | 'created' | 'id' | 'inviteCode' | 'roles' | GroupMemberKeySpecifier)[];
export type GroupMemberFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteCode?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupMembershipKeySpecifier = ('created' | 'group' | 'groupId' | 'id' | 'roles' | GroupMembershipKeySpecifier)[];
export type GroupMembershipFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	groupId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupTraitKeySpecifier = ('accountInvites' | 'accountType' | 'avatarURL' | 'bannerURL' | 'created' | 'description' | 'groupInvites' | 'groupMembers' | 'groupMemberships' | 'groupType' | 'id' | 'managedAccounts' | 'name' | 'otherFields' | 'ownerId' | 'publicURL' | 'socialLinks' | 'updated' | 'wallets' | GroupTraitKeySpecifier)[];
export type GroupTraitFieldPolicy = {
	accountInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	accountType?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarURL?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerURL?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	groupInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	groupMembers?: FieldPolicy<any> | FieldReadFunction<any>,
	groupMemberships?: FieldPolicy<any> | FieldReadFunction<any>,
	groupType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	managedAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	otherFields?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	publicURL?: FieldPolicy<any> | FieldReadFunction<any>,
	socialLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>,
	wallets?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HiveContactKeySpecifier = ('contact' | 'contactType' | 'isError' | 'verified' | HiveContactKeySpecifier)[];
export type HiveContactFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contactType?: FieldPolicy<any> | FieldReadFunction<any>,
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	verified?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HiveContactWithPossibleErrorKeySpecifier = ('isError' | HiveContactWithPossibleErrorKeySpecifier)[];
export type HiveContactWithPossibleErrorFieldPolicy = {
	isError?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IdentityProviderKeySpecifier = ('email' | 'externalAccountId' | 'isError' | 'providerType' | IdentityProviderKeySpecifier)[];
export type IdentityProviderFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	externalAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	providerType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IdentityProviderWithPossibleErrorKeySpecifier = ('isError' | IdentityProviderWithPossibleErrorKeySpecifier)[];
export type IdentityProviderWithPossibleErrorFieldPolicy = {
	isError?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImplicitEnrollmentKeySpecifier = ('externalSubscriptionPackage' | 'externalSubscriptionPackageId' | 'id' | 'invalidateCacheAt' | ImplicitEnrollmentKeySpecifier)[];
export type ImplicitEnrollmentFieldPolicy = {
	externalSubscriptionPackage?: FieldPolicy<any> | FieldReadFunction<any>,
	externalSubscriptionPackageId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invalidateCacheAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImplicitSubscriptionKeySpecifier = ('cacheExpiry' | 'canUnsubscribe' | 'expiry' | 'externalSubscriptionPackage' | 'externalSubscriptionPackageId' | 'id' | 'isUsable' | 'lastVerified' | 'nextRewardDate' | 'secret' | 'subscriptionImplementation' | 'subscriptionProviderAccountId' | 'subscriptionState' | 'subscriptionType' | 'subscriptionTypeId' | ImplicitSubscriptionKeySpecifier)[];
export type ImplicitSubscriptionFieldPolicy = {
	cacheExpiry?: FieldPolicy<any> | FieldReadFunction<any>,
	canUnsubscribe?: FieldPolicy<any> | FieldReadFunction<any>,
	expiry?: FieldPolicy<any> | FieldReadFunction<any>,
	externalSubscriptionPackage?: FieldPolicy<any> | FieldReadFunction<any>,
	externalSubscriptionPackageId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isUsable?: FieldPolicy<any> | FieldReadFunction<any>,
	lastVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	nextRewardDate?: FieldPolicy<any> | FieldReadFunction<any>,
	secret?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionImplementation?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProviderAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionState?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionTypeId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InGameResultKeySpecifier = ('id' | 'matchId' | 'scores' | InGameResultKeySpecifier)[];
export type InGameResultFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	matchId?: FieldPolicy<any> | FieldReadFunction<any>,
	scores?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndividualParticipantKeySpecifier = ('accountId' | 'confirmed' | 'inviteLink' | 'maybeGameAccountId' | 'participantType' | 'requirementsNotMet' | 'result' | IndividualParticipantKeySpecifier)[];
export type IndividualParticipantFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteLink?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeGameAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	participantType?: FieldPolicy<any> | FieldReadFunction<any>,
	requirementsNotMet?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndividualParticipantInviteLinkKeySpecifier = ('code' | 'id' | IndividualParticipantInviteLinkKeySpecifier)[];
export type IndividualParticipantInviteLinkFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IntegratedVoucherKeySpecifier = ('code' | 'distributionInfo' | 'expirationDate' | 'id' | 'issueDate' | 'monetaryValue' | 'redemption' | 'voucherType' | 'whatYouGet' | IntegratedVoucherKeySpecifier)[];
export type IntegratedVoucherFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	distributionInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	expirationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	monetaryValue?: FieldPolicy<any> | FieldReadFunction<any>,
	redemption?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherType?: FieldPolicy<any> | FieldReadFunction<any>,
	whatYouGet?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalPaymentKeySpecifier = ('amount' | 'cancelScheduledPaymentSupported' | 'currency' | 'externalPaymentServiceId' | 'forSubscriptionId' | 'id' | 'internalPaymentServiceId' | 'paymentSchedule' | 'paymentType' | 'received' | InternalPaymentKeySpecifier)[];
export type InternalPaymentFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelScheduledPaymentSupported?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	externalPaymentServiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	forSubscriptionId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalPaymentServiceId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentSchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentType?: FieldPolicy<any> | FieldReadFunction<any>,
	received?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalScheduleKeySpecifier = ('endDate' | 'every' | 'msisdn' | 'nextPaymentDate' | 'packageId' | 'paymentMethod' | 'period' | 'scheduleId' | 'startOn' | 'status' | InternalScheduleKeySpecifier)[];
export type InternalScheduleFieldPolicy = {
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	every?: FieldPolicy<any> | FieldReadFunction<any>,
	msisdn?: FieldPolicy<any> | FieldReadFunction<any>,
	nextPaymentDate?: FieldPolicy<any> | FieldReadFunction<any>,
	packageId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	period?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleId?: FieldPolicy<any> | FieldReadFunction<any>,
	startOn?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InternalServiceKeySpecifier = ('accountManagers' | 'accountType' | 'avatarURL' | 'bannerURL' | 'contactIdentifier' | 'created' | 'description' | 'displayName' | 'email' | 'emailContact' | 'emailVerified' | 'groupInvites' | 'groupMemberships' | 'hasValidContact' | 'id' | 'isSupplier' | 'lastUpdated' | 'managedAccounts' | 'msisdn' | 'msisdnContact' | 'msisdnVerified' | 'otherFields' | 'payPurchaseTransactions' | 'publicURL' | 'purchaseTransactions' | 'socialLinks' | 'subscriptionProviderAccounts' | 'subscriptions' | 'updated' | 'userType' | 'wallets' | InternalServiceKeySpecifier)[];
export type InternalServiceFieldPolicy = {
	accountManagers?: FieldPolicy<any> | FieldReadFunction<any>,
	accountType?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarURL?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerURL?: FieldPolicy<any> | FieldReadFunction<any>,
	contactIdentifier?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	emailContact?: FieldPolicy<any> | FieldReadFunction<any>,
	emailVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	groupInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	groupMemberships?: FieldPolicy<any> | FieldReadFunction<any>,
	hasValidContact?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSupplier?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	managedAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	msisdn?: FieldPolicy<any> | FieldReadFunction<any>,
	msisdnContact?: FieldPolicy<any> | FieldReadFunction<any>,
	msisdnVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	otherFields?: FieldPolicy<any> | FieldReadFunction<any>,
	payPurchaseTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	publicURL?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	socialLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProviderAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>,
	userType?: FieldPolicy<any> | FieldReadFunction<any>,
	wallets?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InviteCodeKeySpecifier = ('code' | 'expiry' | InviteCodeKeySpecifier)[];
export type InviteCodeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	expiry?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemKeySpecifier = ('contentType' | 'createdBy' | 'createdDate' | 'currencyConversionRate' | 'deliveryMethod' | 'displayName' | 'gamePublisher' | 'id' | 'isActive' | 'isDeleted' | 'isStockAvailable' | 'itemDescBrief' | 'itemDescDetail' | 'itemGalleryUrls' | 'itemId' | 'itemImageUrl' | 'itemName' | 'itemPartnerPoints' | 'itemProductGroup' | 'itemStatus' | 'itemType' | 'outOfStockDate' | 'outOfStockImageUrl' | 'product' | 'safetyStockThreshold' | 'supplier' | 'unitPrice' | 'variantName' | ItemKeySpecifier)[];
export type ItemFieldPolicy = {
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyConversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	gamePublisher?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	isStockAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDescBrief?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDescDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	itemGalleryUrls?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemPartnerPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	itemProductGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	itemStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	outOfStockDate?: FieldPolicy<any> | FieldReadFunction<any>,
	outOfStockImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	safetyStockThreshold?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	variantName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemCostKeySpecifier = ('paymentChannelId' | 'paymentChannelName' | 'paymentMethod' | 'targetCurrencyPrices' | ItemCostKeySpecifier)[];
export type ItemCostFieldPolicy = {
	paymentChannelId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentChannelName?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	targetCurrencyPrices?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemLanguageDTOKeySpecifier = ('id' | 'itemId' | 'itemName' | 'languages' | 'unConfiguredLanguageIds' | ItemLanguageDTOKeySpecifier)[];
export type ItemLanguageDTOFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>,
	languages?: FieldPolicy<any> | FieldReadFunction<any>,
	unConfiguredLanguageIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemLanguageDataKeySpecifier = ('countryCode' | 'displayName' | 'isDefault' | 'isLanguageConfigured' | 'itemDescBrief' | 'itemDescDetail' | 'itemName' | 'languageCode' | 'languageId' | 'languageName' | 'mappedPartnerLanguage' | ItemLanguageDataKeySpecifier)[];
export type ItemLanguageDataFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	isLanguageConfigured?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDescBrief?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDescDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>,
	languageCode?: FieldPolicy<any> | FieldReadFunction<any>,
	languageId?: FieldPolicy<any> | FieldReadFunction<any>,
	languageName?: FieldPolicy<any> | FieldReadFunction<any>,
	mappedPartnerLanguage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemLanguageResponseKeySpecifier = ('displayName' | 'itemDescBrief' | 'itemDescDetail' | 'itemName' | ItemLanguageResponseKeySpecifier)[];
export type ItemLanguageResponseFieldPolicy = {
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDescBrief?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDescDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemLanguagesResponseKeySpecifier = ('currentPage' | 'items' | 'pageSize' | 'totalFilteredItems' | 'totalPages' | ItemLanguagesResponseKeySpecifier)[];
export type ItemLanguagesResponseFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSize?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFilteredItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemPointsKeySpecifier = ('createdDate' | 'id' | 'item' | 'localCurrencyConversionRate' | 'markedUpPrice' | 'partner' | 'pointsConversionRate' | 'pointsValue' | ItemPointsKeySpecifier)[];
export type ItemPointsFieldPolicy = {
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	localCurrencyConversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	partner?: FieldPolicy<any> | FieldReadFunction<any>,
	pointsConversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	pointsValue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ItemProductGroupKeySpecifier = ('item' | 'productGroup' | ItemProductGroupKeySpecifier)[];
export type ItemProductGroupFieldPolicy = {
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroup?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JobInfoKeySpecifier = ('className' | 'createdDate' | 'cronDefinition' | 'description' | 'executionTime' | 'id' | 'isActive' | 'jobId' | 'jobName' | 'jobType' | 'lastTriggerStatus' | 'lastTriggerTime' | 'schedulerMethodType' | 'supplier' | JobInfoKeySpecifier)[];
export type JobInfoFieldPolicy = {
	className?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	cronDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	executionTime?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	jobId?: FieldPolicy<any> | FieldReadFunction<any>,
	jobName?: FieldPolicy<any> | FieldReadFunction<any>,
	jobType?: FieldPolicy<any> | FieldReadFunction<any>,
	lastTriggerStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	lastTriggerTime?: FieldPolicy<any> | FieldReadFunction<any>,
	schedulerMethodType?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KingOfTheHillSpecificDetailsKeySpecifier = ('host' | 'id' | 'matchUpFormat' | 'maximumNumberOfPhases' | 'maybeMaxRoundParticipants' | 'maybeParticipantsInRound' | 'remainingParticipants' | KingOfTheHillSpecificDetailsKeySpecifier)[];
export type KingOfTheHillSpecificDetailsFieldPolicy = {
	host?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	matchUpFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumNumberOfPhases?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeMaxRoundParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeParticipantsInRound?: FieldPolicy<any> | FieldReadFunction<any>,
	remainingParticipants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LadderSpecificDetailsKeySpecifier = ('ChallengeFormat' | 'duration' | 'id' | 'topResultsThreshold' | LadderSpecificDetailsKeySpecifier)[];
export type LadderSpecificDetailsFieldPolicy = {
	ChallengeFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	topResultsThreshold?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LanguageKeySpecifier = ('countryCode' | 'id' | 'isDefault' | 'languageName' | LanguageKeySpecifier)[];
export type LanguageFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	languageName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LanguageDtoKeySpecifier = ('countryCode' | 'id' | 'isLanguageConfigured' | 'languageCode' | 'languageName' | LanguageDtoKeySpecifier)[];
export type LanguageDtoFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isLanguageConfigured?: FieldPolicy<any> | FieldReadFunction<any>,
	languageCode?: FieldPolicy<any> | FieldReadFunction<any>,
	languageName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocalizedMediaContentDetailsKeySpecifier = ('locale' | 'value' | LocalizedMediaContentDetailsKeySpecifier)[];
export type LocalizedMediaContentDetailsFieldPolicy = {
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocalizedOptionalStringKeySpecifier = ('locale' | 'value' | LocalizedOptionalStringKeySpecifier)[];
export type LocalizedOptionalStringFieldPolicy = {
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocalizedStringKeySpecifier = ('locale' | 'value' | LocalizedStringKeySpecifier)[];
export type LocalizedStringFieldPolicy = {
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManagedAccountKeySpecifier = ('account' | 'accountId' | 'isError' | 'roles' | ManagedAccountKeySpecifier)[];
export type ManagedAccountFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManagedAccountWithPossibleErrorKeySpecifier = ('isError' | ManagedAccountWithPossibleErrorKeySpecifier)[];
export type ManagedAccountWithPossibleErrorFieldPolicy = {
	isError?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManualResultKeySpecifier = ('id' | 'placement' | 'prizePayoutReceipt' | 'resultImageURLs' | 'score' | 'showed' | ManualResultKeySpecifier)[];
export type ManualResultFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	placement?: FieldPolicy<any> | FieldReadFunction<any>,
	prizePayoutReceipt?: FieldPolicy<any> | FieldReadFunction<any>,
	resultImageURLs?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>,
	showed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManuallyVerifiedResultKeySpecifier = ('competitionId' | 'created' | 'id' | 'participantId' | 'plzDelete' | 'roundId' | 'unverifiedResult' | ManuallyVerifiedResultKeySpecifier)[];
export type ManuallyVerifiedResultFieldPolicy = {
	competitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	participantId?: FieldPolicy<any> | FieldReadFunction<any>,
	plzDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	roundId?: FieldPolicy<any> | FieldReadFunction<any>,
	unverifiedResult?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MatchModificationsKeySpecifier = ('assets' | 'matchId' | 'name' | 'startTime' | MatchModificationsKeySpecifier)[];
export type MatchModificationsFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	matchId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MatchUpKeySpecifier = ('competitionState' | 'competitionTiming' | 'competitionType' | 'created' | 'event' | 'eventId' | 'eventStageId' | 'game' | 'gameId' | 'gameSpecificDetails' | 'id' | 'isSimulated' | 'manualAdvancement' | 'matchUpFormat' | 'matchUpFormatSpecificDetails' | 'numberOfRounds' | 'participantType' | 'participants' | 'phaseBufferTime' | 'phaseModifications' | 'phases' | MatchUpKeySpecifier)[];
export type MatchUpFieldPolicy = {
	competitionState?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionTiming?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionType?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventStageId?: FieldPolicy<any> | FieldReadFunction<any>,
	game?: FieldPolicy<any> | FieldReadFunction<any>,
	gameId?: FieldPolicy<any> | FieldReadFunction<any>,
	gameSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSimulated?: FieldPolicy<any> | FieldReadFunction<any>,
	manualAdvancement?: FieldPolicy<any> | FieldReadFunction<any>,
	matchUpFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	matchUpFormatSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfRounds?: FieldPolicy<any> | FieldReadFunction<any>,
	participantType?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>,
	phaseBufferTime?: FieldPolicy<any> | FieldReadFunction<any>,
	phaseModifications?: FieldPolicy<any> | FieldReadFunction<any>,
	phases?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MatchUpFormatSpecificDetailsKeySpecifier = ('id' | 'matchUpFormat' | 'maybeMaxRoundParticipants' | 'maybeParticipantsInRound' | MatchUpFormatSpecificDetailsKeySpecifier)[];
export type MatchUpFormatSpecificDetailsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	matchUpFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeMaxRoundParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeParticipantsInRound?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MatchUpMatchKeySpecifier = ('assets' | 'gameSpecificDetails' | 'id' | 'isComplete' | 'name' | 'startTime' | MatchUpMatchKeySpecifier)[];
export type MatchUpMatchFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	gameSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MatchUpMatchByeKeySpecifier = ('assets' | 'gameSpecificDetails' | 'id' | 'isComplete' | 'name' | 'participants' | 'startTime' | MatchUpMatchByeKeySpecifier)[];
export type MatchUpMatchByeFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	gameSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MatchUpPhaseKeySpecifier = ('id' | 'isComplete' | 'matches' | 'phaseNumber' | MatchUpPhaseKeySpecifier)[];
export type MatchUpPhaseFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	matches?: FieldPolicy<any> | FieldReadFunction<any>,
	phaseNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MatchUpRoundKeySpecifier = ('id' | 'isComplete' | 'participants' | 'roundNumber' | MatchUpRoundKeySpecifier)[];
export type MatchUpRoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>,
	roundNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MaximumParticipantsBreakStrategyKeySpecifier = ('breakStrategyType' | 'maxParticipants' | MaximumParticipantsBreakStrategyKeySpecifier)[];
export type MaximumParticipantsBreakStrategyFieldPolicy = {
	breakStrategyType?: FieldPolicy<any> | FieldReadFunction<any>,
	maxParticipants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaContentDetailsKeySpecifier = ('avatar' | 'banner' | 'descriptionImage' | 'streams' | MediaContentDetailsKeySpecifier)[];
export type MediaContentDetailsFieldPolicy = {
	avatar?: FieldPolicy<any> | FieldReadFunction<any>,
	banner?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionImage?: FieldPolicy<any> | FieldReadFunction<any>,
	streams?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaTraitKeySpecifier = ('expiry' | 'id' | 'mediaType' | 'weight' | MediaTraitKeySpecifier)[];
export type MediaTraitFieldPolicy = {
	expiry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaType?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaTwitchStreamTypeKeySpecifier = ('expiry' | 'gameId' | 'gameName' | 'id' | 'language' | 'mediaType' | 'providerIdentifier' | 'startedAt' | 'status' | 'streamType' | 'streamUrl' | 'thumbnailUrl' | 'title' | 'userLogin' | 'userName' | 'viewerCount' | 'weight' | MediaTwitchStreamTypeKeySpecifier)[];
export type MediaTwitchStreamTypeFieldPolicy = {
	expiry?: FieldPolicy<any> | FieldReadFunction<any>,
	gameId?: FieldPolicy<any> | FieldReadFunction<any>,
	gameName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaType?: FieldPolicy<any> | FieldReadFunction<any>,
	providerIdentifier?: FieldPolicy<any> | FieldReadFunction<any>,
	startedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	streamType?: FieldPolicy<any> | FieldReadFunction<any>,
	streamUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	userLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	userName?: FieldPolicy<any> | FieldReadFunction<any>,
	viewerCount?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MerchantPaymentMethodKeySpecifier = ('cancelScheduledPaymentSupported' | 'id' | 'name' | 'paymentMethodType' | 'recurringPaymentSupported' | 'refundSupported' | MerchantPaymentMethodKeySpecifier)[];
export type MerchantPaymentMethodFieldPolicy = {
	cancelScheduledPaymentSupported?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodType?: FieldPolicy<any> | FieldReadFunction<any>,
	recurringPaymentSupported?: FieldPolicy<any> | FieldReadFunction<any>,
	refundSupported?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MissingParticipantRequirementKeySpecifier = ('entryName' | MissingParticipantRequirementKeySpecifier)[];
export type MissingParticipantRequirementFieldPolicy = {
	entryName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MonetaryValueKeySpecifier = ('currency' | 'value' | MonetaryValueKeySpecifier)[];
export type MonetaryValueFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MultiDimensionalBucketBasedResultKeySpecifier = ('bucketValue' | 'calculatedScore' | 'id' | 'maybeShowed' | 'multiDimensionalResults' | 'placement' | 'prizePayoutReceipt' | 'resultImageURLs' | 'score' | 'showed' | MultiDimensionalBucketBasedResultKeySpecifier)[];
export type MultiDimensionalBucketBasedResultFieldPolicy = {
	bucketValue?: FieldPolicy<any> | FieldReadFunction<any>,
	calculatedScore?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeShowed?: FieldPolicy<any> | FieldReadFunction<any>,
	multiDimensionalResults?: FieldPolicy<any> | FieldReadFunction<any>,
	placement?: FieldPolicy<any> | FieldReadFunction<any>,
	prizePayoutReceipt?: FieldPolicy<any> | FieldReadFunction<any>,
	resultImageURLs?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>,
	showed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('acceptAllGroupInvitations' | 'acceptGroupInvitation' | 'addAutomaticallyVerifiedResultForRoundId' | 'addClientNotifications' | 'addEventTeamInviteCode' | 'addGameToGameAccount' | 'addIndividualParticipant' | 'addInviteCode' | 'addMultiDimensionalBucketBasedResultForVerification' | 'addNotifications' | 'addSLTAccount' | 'addTeamParticipant' | 'addToEventTeam' | 'advancePhasedCompetition' | 'cancelEvents' | 'cancelPendingSubscription' | 'cancelScheduledSubscription' | 'checkHealth' | 'completeCompetition' | 'completePayoutRequest' | 'confirmParticipant' | 'createApplicationConfig' | 'createBanner' | 'createCmsBanner' | 'createCmsBlogPage' | 'createCmsBlogPost' | 'createCmsGame' | 'createCmsGamer' | 'createCmsMedia' | 'createCmsUser' | 'createEmbeddedGame' | 'createEvent' | 'createExchangedTransaction' | 'createFeature' | 'createFreebieTransaction' | 'createGroup' | 'createNonIntegratedEventsGame' | 'createNonIntegratedGameAccountType' | 'createPayloadLockedDocument' | 'createPayloadPreference' | 'createPaymentMethodConfig' | 'createPrivateServer' | 'createPrizeList' | 'createPublicServer' | 'createSubscriptionType' | 'createSwarmioCurrencyExchangeBlock' | 'createSwarmioCurrencyItem' | 'createSwarmioCurrencyPayout' | 'createTeam' | 'createWallet' | 'createWalletsForUser' | 'createWatchStreams' | 'declineAllGroupInvitations' | 'declineGroupInvitation' | 'deleteBanner' | 'deleteCmsBanner' | 'deleteCmsBlogPage' | 'deleteCmsBlogPost' | 'deleteCmsGame' | 'deleteCmsGamer' | 'deleteCmsMedia' | 'deleteCmsUser' | 'deleteEmbeddedGame' | 'deletePartnerCurrencyPreferenceById' | 'deletePayloadLockedDocument' | 'deletePayloadPreference' | 'deletePaymentMethodConfig' | 'deleteProductByID' | 'deleteProductByIDs' | 'deleteProductsByFileIds' | 'deletePublicServer' | 'deleteSupplier' | 'deleteVoucherByID' | 'deleteVoucherByIDs' | 'distributeVoucher' | 'duplicateCmsBanner' | 'duplicateCmsBlogPage' | 'duplicateCmsBlogPost' | 'duplicateCmsGame' | 'duplicateCmsGamer' | 'duplicateCmsMedia' | 'duplicatePayloadLockedDocument' | 'duplicatePayloadPreference' | 'editSwarmioCurrencyItem' | 'enrollExplicitSubscription' | 'enrollExternalSubscriptionPackage' | 'exchangeCustomSwarmioCurrencyAmount' | 'exchangeEntireSwarmioCurrencyWallet' | 'forceVerifyPersonEmail' | 'forgotPasswordCmsUser' | 'generateIntegratedVouchers' | 'generateNonIntegratedVouchers' | 'hardRefreshSubscriptionsForAccountId' | 'inviteToGroup' | 'joinEventByInvite' | 'joinGroupTraitByInvite' | 'leaveEventTeam' | 'linkNonIntegratedGameAccount' | 'loginCmsUser' | 'logoutCmsUser' | 'manuallyPairLatestCompetitionPhase' | 'markNotificationsAsRead' | 'multipleSwarmioCurrencyTransfers' | 'overridePspMarkedUpPercentage' | 'partnerItemFinalPriceOverride' | 'paySubscriptionWithSwarmio' | 'payoutEventPrizes' | 'processCSVFile' | 'processOrderFieldsCSVFile' | 'promoteToGroupAdmin' | 'purchaseExternalItem' | 'purchaseExternalItemWithPoints' | 'purchaseItem' | 'purchaseSwarmioCurrencyItem' | 'purchaseTagIdRegistration' | 'readyIndividualParticipant' | 'redeemVoucher' | 'refreshLadderCompetitionResults' | 'refreshRiotAccount' | 'refreshTokenCmsUser' | 'refreshUsersSubscriptions' | 'refreshWatchStreams' | 'registerInternalService' | 'registerPerson' | 'registerPersonEmail' | 'registerPersonMSISDN' | 'removeFromEventTeam' | 'removeMemberFromGroup' | 'removeParticipant' | 'removeRolesFromGroupMember' | 'removeSubscriptionProviderAccount' | 'removeWatchStream' | 'replaceGroupOwner' | 'requestCustomPayout' | 'requestPayout' | 'requestVoucherForRecipient' | 'resendVerificationEmail' | 'resendVerificationSMS' | 'resetLocalConversionRate' | 'resetMarkedUpPrice' | 'resetOverriddenFinalPrice' | 'resetOverrideCurrencyMarkedUpPercentage' | 'resetOverrideFinalPrice' | 'resetOverridePointsMarkedUpPercentage' | 'resetOverridePspMarkedUpPercentage' | 'resetOverrideRate' | 'resetPartnerItemMarkedUpPercentage' | 'resetPartnerPaymentChannelMarkedUpPercentage' | 'resetPassword' | 'resetPasswordCmsUser' | 'resetPasswordRequest' | 'resetPasswordRequestWithSpecialEmail' | 'retryFailedTransaction' | 'saveCSVFile' | 'saveCategory' | 'saveCategoryLanguageData' | 'saveDeal' | 'saveGlobalPoints' | 'saveItem' | 'saveItemLanguageData' | 'saveItemPartnerCurrencyConversions' | 'saveItemPoints' | 'savePartnerCurrencyPreferences' | 'savePartnerPaymentChannelData' | 'savePaymentChannel' | 'saveProductGroup' | 'saveProductGroupLanguageData' | 'saveSupplier' | 'sendTemplateEmail' | 'transferAllWallets' | 'transferSwarmioCurrency' | 'undoLastAdvance' | 'unenrollExternalSubscriptionPackage' | 'unlinkGameAccount' | 'unlinkIdentityProvider' | 'unlinkIdentityProviderByEmail' | 'unlockCmsUser' | 'updateApplicationConfig' | 'updateBanner' | 'updateCatalog' | 'updateCategoryList' | 'updateChallenge' | 'updateCmsBanner' | 'updateCmsBlogPage' | 'updateCmsBlogPost' | 'updateCmsGame' | 'updateCmsGamer' | 'updateCmsMedia' | 'updateCmsUser' | 'updateDisabledPaymentChannels' | 'updateEmbeddedGame' | 'updateEvent' | 'updateEventStage' | 'updateEventsGame' | 'updateFeature' | 'updateGameAccountType' | 'updateGroup' | 'updateInternalService' | 'updateItemList' | 'updateManualGameAccount' | 'updateMatchUp' | 'updateOrderList' | 'updatePartnerCurrencyConversionRate' | 'updatePartnerItemPaymentChannelData' | 'updatePartnerLocalCurrencyConversionRate' | 'updatePassword' | 'updatePayloadLockedDocument' | 'updatePayloadPreference' | 'updatePaymentMethodConfig' | 'updatePerson' | 'updatePrizeList' | 'updateProductCodes' | 'updateProducts' | 'updatePublicServer' | 'updatePurchaseTransaction' | 'updateResultForChallengeId' | 'updateResultForRoundId' | 'updateSubscriptionType' | 'updateTeam' | 'updateTournament' | 'uploadDraftProducts' | 'uploadOrderFields' | 'validateBulkEmails' | 'verifyEmailCmsUser' | 'verifyManuallyVerifiedResult' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	acceptAllGroupInvitations?: FieldPolicy<any> | FieldReadFunction<any>,
	acceptGroupInvitation?: FieldPolicy<any> | FieldReadFunction<any>,
	addAutomaticallyVerifiedResultForRoundId?: FieldPolicy<any> | FieldReadFunction<any>,
	addClientNotifications?: FieldPolicy<any> | FieldReadFunction<any>,
	addEventTeamInviteCode?: FieldPolicy<any> | FieldReadFunction<any>,
	addGameToGameAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	addIndividualParticipant?: FieldPolicy<any> | FieldReadFunction<any>,
	addInviteCode?: FieldPolicy<any> | FieldReadFunction<any>,
	addMultiDimensionalBucketBasedResultForVerification?: FieldPolicy<any> | FieldReadFunction<any>,
	addNotifications?: FieldPolicy<any> | FieldReadFunction<any>,
	addSLTAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	addTeamParticipant?: FieldPolicy<any> | FieldReadFunction<any>,
	addToEventTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	advancePhasedCompetition?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelPendingSubscription?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelScheduledSubscription?: FieldPolicy<any> | FieldReadFunction<any>,
	checkHealth?: FieldPolicy<any> | FieldReadFunction<any>,
	completeCompetition?: FieldPolicy<any> | FieldReadFunction<any>,
	completePayoutRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmParticipant?: FieldPolicy<any> | FieldReadFunction<any>,
	createApplicationConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	createBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	createCmsBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	createCmsBlogPage?: FieldPolicy<any> | FieldReadFunction<any>,
	createCmsBlogPost?: FieldPolicy<any> | FieldReadFunction<any>,
	createCmsGame?: FieldPolicy<any> | FieldReadFunction<any>,
	createCmsGamer?: FieldPolicy<any> | FieldReadFunction<any>,
	createCmsMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	createCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createEmbeddedGame?: FieldPolicy<any> | FieldReadFunction<any>,
	createEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	createExchangedTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	createFeature?: FieldPolicy<any> | FieldReadFunction<any>,
	createFreebieTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	createGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	createNonIntegratedEventsGame?: FieldPolicy<any> | FieldReadFunction<any>,
	createNonIntegratedGameAccountType?: FieldPolicy<any> | FieldReadFunction<any>,
	createPayloadLockedDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	createPayloadPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	createPaymentMethodConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	createPrivateServer?: FieldPolicy<any> | FieldReadFunction<any>,
	createPrizeList?: FieldPolicy<any> | FieldReadFunction<any>,
	createPublicServer?: FieldPolicy<any> | FieldReadFunction<any>,
	createSubscriptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	createSwarmioCurrencyExchangeBlock?: FieldPolicy<any> | FieldReadFunction<any>,
	createSwarmioCurrencyItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createSwarmioCurrencyPayout?: FieldPolicy<any> | FieldReadFunction<any>,
	createTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	createWallet?: FieldPolicy<any> | FieldReadFunction<any>,
	createWalletsForUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createWatchStreams?: FieldPolicy<any> | FieldReadFunction<any>,
	declineAllGroupInvitations?: FieldPolicy<any> | FieldReadFunction<any>,
	declineGroupInvitation?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCmsBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCmsBlogPage?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCmsBlogPost?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCmsGame?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCmsGamer?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCmsMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmbeddedGame?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePartnerCurrencyPreferenceById?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePayloadLockedDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePayloadPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePaymentMethodConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteProductByID?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteProductByIDs?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteProductsByFileIds?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePublicServer?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSupplier?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVoucherByID?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteVoucherByIDs?: FieldPolicy<any> | FieldReadFunction<any>,
	distributeVoucher?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicateCmsBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicateCmsBlogPage?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicateCmsBlogPost?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicateCmsGame?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicateCmsGamer?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicateCmsMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicatePayloadLockedDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	duplicatePayloadPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	editSwarmioCurrencyItem?: FieldPolicy<any> | FieldReadFunction<any>,
	enrollExplicitSubscription?: FieldPolicy<any> | FieldReadFunction<any>,
	enrollExternalSubscriptionPackage?: FieldPolicy<any> | FieldReadFunction<any>,
	exchangeCustomSwarmioCurrencyAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	exchangeEntireSwarmioCurrencyWallet?: FieldPolicy<any> | FieldReadFunction<any>,
	forceVerifyPersonEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	forgotPasswordCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	generateIntegratedVouchers?: FieldPolicy<any> | FieldReadFunction<any>,
	generateNonIntegratedVouchers?: FieldPolicy<any> | FieldReadFunction<any>,
	hardRefreshSubscriptionsForAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteToGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	joinEventByInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	joinGroupTraitByInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	leaveEventTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	linkNonIntegratedGameAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	loginCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	logoutCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	manuallyPairLatestCompetitionPhase?: FieldPolicy<any> | FieldReadFunction<any>,
	markNotificationsAsRead?: FieldPolicy<any> | FieldReadFunction<any>,
	multipleSwarmioCurrencyTransfers?: FieldPolicy<any> | FieldReadFunction<any>,
	overridePspMarkedUpPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerItemFinalPriceOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	paySubscriptionWithSwarmio?: FieldPolicy<any> | FieldReadFunction<any>,
	payoutEventPrizes?: FieldPolicy<any> | FieldReadFunction<any>,
	processCSVFile?: FieldPolicy<any> | FieldReadFunction<any>,
	processOrderFieldsCSVFile?: FieldPolicy<any> | FieldReadFunction<any>,
	promoteToGroupAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseExternalItem?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseExternalItemWithPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseItem?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseSwarmioCurrencyItem?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseTagIdRegistration?: FieldPolicy<any> | FieldReadFunction<any>,
	readyIndividualParticipant?: FieldPolicy<any> | FieldReadFunction<any>,
	redeemVoucher?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshLadderCompetitionResults?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshRiotAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshTokenCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshUsersSubscriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshWatchStreams?: FieldPolicy<any> | FieldReadFunction<any>,
	registerInternalService?: FieldPolicy<any> | FieldReadFunction<any>,
	registerPerson?: FieldPolicy<any> | FieldReadFunction<any>,
	registerPersonEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	registerPersonMSISDN?: FieldPolicy<any> | FieldReadFunction<any>,
	removeFromEventTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	removeMemberFromGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	removeParticipant?: FieldPolicy<any> | FieldReadFunction<any>,
	removeRolesFromGroupMember?: FieldPolicy<any> | FieldReadFunction<any>,
	removeSubscriptionProviderAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	removeWatchStream?: FieldPolicy<any> | FieldReadFunction<any>,
	replaceGroupOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	requestCustomPayout?: FieldPolicy<any> | FieldReadFunction<any>,
	requestPayout?: FieldPolicy<any> | FieldReadFunction<any>,
	requestVoucherForRecipient?: FieldPolicy<any> | FieldReadFunction<any>,
	resendVerificationEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	resendVerificationSMS?: FieldPolicy<any> | FieldReadFunction<any>,
	resetLocalConversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	resetMarkedUpPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	resetOverriddenFinalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	resetOverrideCurrencyMarkedUpPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	resetOverrideFinalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	resetOverridePointsMarkedUpPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	resetOverridePspMarkedUpPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	resetOverrideRate?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPartnerItemMarkedUpPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPartnerPaymentChannelMarkedUpPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPasswordCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPasswordRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPasswordRequestWithSpecialEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	retryFailedTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	saveCSVFile?: FieldPolicy<any> | FieldReadFunction<any>,
	saveCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	saveCategoryLanguageData?: FieldPolicy<any> | FieldReadFunction<any>,
	saveDeal?: FieldPolicy<any> | FieldReadFunction<any>,
	saveGlobalPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	saveItem?: FieldPolicy<any> | FieldReadFunction<any>,
	saveItemLanguageData?: FieldPolicy<any> | FieldReadFunction<any>,
	saveItemPartnerCurrencyConversions?: FieldPolicy<any> | FieldReadFunction<any>,
	saveItemPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	savePartnerCurrencyPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	savePartnerPaymentChannelData?: FieldPolicy<any> | FieldReadFunction<any>,
	savePaymentChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	saveProductGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	saveProductGroupLanguageData?: FieldPolicy<any> | FieldReadFunction<any>,
	saveSupplier?: FieldPolicy<any> | FieldReadFunction<any>,
	sendTemplateEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	transferAllWallets?: FieldPolicy<any> | FieldReadFunction<any>,
	transferSwarmioCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	undoLastAdvance?: FieldPolicy<any> | FieldReadFunction<any>,
	unenrollExternalSubscriptionPackage?: FieldPolicy<any> | FieldReadFunction<any>,
	unlinkGameAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	unlinkIdentityProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	unlinkIdentityProviderByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateApplicationConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCatalog?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCategoryList?: FieldPolicy<any> | FieldReadFunction<any>,
	updateChallenge?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCmsBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCmsBlogPage?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCmsBlogPost?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCmsGame?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCmsGamer?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCmsMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDisabledPaymentChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEmbeddedGame?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventStage?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEventsGame?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFeature?: FieldPolicy<any> | FieldReadFunction<any>,
	updateGameAccountType?: FieldPolicy<any> | FieldReadFunction<any>,
	updateGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateInternalService?: FieldPolicy<any> | FieldReadFunction<any>,
	updateItemList?: FieldPolicy<any> | FieldReadFunction<any>,
	updateManualGameAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMatchUp?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOrderList?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePartnerCurrencyConversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePartnerItemPaymentChannelData?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePartnerLocalCurrencyConversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePassword?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePayloadLockedDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePayloadPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePaymentMethodConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePerson?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePrizeList?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProductCodes?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePublicServer?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePurchaseTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	updateResultForChallengeId?: FieldPolicy<any> | FieldReadFunction<any>,
	updateResultForRoundId?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSubscriptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTournament?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadDraftProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadOrderFields?: FieldPolicy<any> | FieldReadFunction<any>,
	validateBulkEmails?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyEmailCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyManuallyVerifiedResult?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NewHiveContactKeySpecifier = ('contact' | 'contactType' | 'isError' | 'newContact' | 'verified' | NewHiveContactKeySpecifier)[];
export type NewHiveContactFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contactType?: FieldPolicy<any> | FieldReadFunction<any>,
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	newContact?: FieldPolicy<any> | FieldReadFunction<any>,
	verified?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NonIntegratedVoucherKeySpecifier = ('code' | 'distributionInfo' | 'expirationDate' | 'id' | 'issueDate' | 'voucherType' | 'whatYouGet' | NonIntegratedVoucherKeySpecifier)[];
export type NonIntegratedVoucherFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	distributionInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	expirationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherType?: FieldPolicy<any> | FieldReadFunction<any>,
	whatYouGet?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotEnoughTeamMembersKeySpecifier = ('entryName' | 'needsMore' | NotEnoughTeamMembersKeySpecifier)[];
export type NotEnoughTeamMembersFieldPolicy = {
	entryName?: FieldPolicy<any> | FieldReadFunction<any>,
	needsMore?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ObjectRepresentationKeySpecifier = ('id' | ObjectRepresentationKeySpecifier)[];
export type ObjectRepresentationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderKeySpecifier = ('billingAddress' | 'cancellationNote' | 'contentType' | 'createdBy' | 'createdDate' | 'dealId' | 'dealPercentage' | 'dealValue' | 'formattedItemId' | 'gamerEmail' | 'gamerId' | 'gamerName' | 'id' | 'isActive' | 'item' | 'itemName' | 'markedUpPrice' | 'modifiedBy' | 'modifiedDate' | 'orderDate' | 'orderId' | 'orderStatus' | 'orderTransaction' | 'partner' | 'payment' | 'pointsValue' | 'purchaseMedium' | 'purchasePaymentChannelName' | 'quantity' | 'retriedTransactionId' | 'shipment' | 'targetCurrency' | 'totalPoints' | 'transaction' | 'transactionId' | 'vouchers' | OrderKeySpecifier)[];
export type OrderFieldPolicy = {
	billingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	cancellationNote?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	dealId?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	dealValue?: FieldPolicy<any> | FieldReadFunction<any>,
	formattedItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerId?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderDate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	orderStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	orderTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	partner?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	pointsValue?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseMedium?: FieldPolicy<any> | FieldReadFunction<any>,
	purchasePaymentChannelName?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	retriedTransactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	shipment?: FieldPolicy<any> | FieldReadFunction<any>,
	targetCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	vouchers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderFieldsProductKeySpecifier = ('isProductAvailable' | 'productCode' | 'productName' | OrderFieldsProductKeySpecifier)[];
export type OrderFieldsProductFieldPolicy = {
	isProductAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	productCode?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderTransactionKeySpecifier = ('id' | 'productRedemptionInstructions' | 'transactionId' | 'voucherQuantity' | 'vouchers' | OrderTransactionKeySpecifier)[];
export type OrderTransactionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	productRedemptionInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	vouchers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OutOfContextCompetitionMatchesKeySpecifier = ('competitionId' | 'competitionType' | 'isSimulated' | 'matches' | OutOfContextCompetitionMatchesKeySpecifier)[];
export type OutOfContextCompetitionMatchesFieldPolicy = {
	competitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionType?: FieldPolicy<any> | FieldReadFunction<any>,
	isSimulated?: FieldPolicy<any> | FieldReadFunction<any>,
	matches?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OutOfContextMatchUpMatchesKeySpecifier = ('competitionId' | 'competitionType' | 'isSimulated' | 'matches' | OutOfContextMatchUpMatchesKeySpecifier)[];
export type OutOfContextMatchUpMatchesFieldPolicy = {
	competitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionType?: FieldPolicy<any> | FieldReadFunction<any>,
	isSimulated?: FieldPolicy<any> | FieldReadFunction<any>,
	matches?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OutOfContextPurchaseTransactionKeySpecifier = ('account' | 'accountId' | 'created' | 'fields' | 'itemId' | 'order' | 'purchaseTransactionId' | 'status' | OutOfContextPurchaseTransactionKeySpecifier)[];
export type OutOfContextPurchaseTransactionFieldPolicy = {
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseTransactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OutOfContextTournamentMatchesKeySpecifier = ('competitionId' | 'competitionType' | 'isSimulated' | 'matches' | OutOfContextTournamentMatchesKeySpecifier)[];
export type OutOfContextTournamentMatchesFieldPolicy = {
	competitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionType?: FieldPolicy<any> | FieldReadFunction<any>,
	isSimulated?: FieldPolicy<any> | FieldReadFunction<any>,
	matches?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedBoughtTransactionKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedBoughtTransactionKeySpecifier)[];
export type PaginatedBoughtTransactionFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedCSVFilesKeySpecifier = ('currentPage' | 'files' | 'totalFiles' | 'totalPages' | PaginatedCSVFilesKeySpecifier)[];
export type PaginatedCSVFilesFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedCashOutTransactionKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedCashOutTransactionKeySpecifier)[];
export type PaginatedCashOutTransactionFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedCatalogItemsKeySpecifier = ('currentPage' | 'items' | 'totalItems' | 'totalPages' | PaginatedCatalogItemsKeySpecifier)[];
export type PaginatedCatalogItemsFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	totalItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedCategoryLanguageKeySpecifier = ('categories' | 'currentPage' | 'totalCategories' | 'totalPages' | PaginatedCategoryLanguageKeySpecifier)[];
export type PaginatedCategoryLanguageFieldPolicy = {
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedCategoryProductGroupsKeySpecifier = ('categoryCoverImage' | 'categoryDescription' | 'categoryIcon' | 'categoryId' | 'categoryImage' | 'categoryName' | 'currentPage' | 'featured' | 'productGroups' | 'totalPages' | 'totalProductGroups' | 'urlMask' | PaginatedCategoryProductGroupsKeySpecifier)[];
export type PaginatedCategoryProductGroupsFieldPolicy = {
	categoryCoverImage?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryIcon?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryImage?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryName?: FieldPolicy<any> | FieldReadFunction<any>,
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalProductGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	urlMask?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedDealKeySpecifier = ('currentPage' | 'deals' | 'totalDeals' | 'totalEndedDeals' | 'totalFilteredDeals' | 'totalOngoingDeals' | 'totalPages' | 'totalScheduledDeals' | PaginatedDealKeySpecifier)[];
export type PaginatedDealFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	deals?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDeals?: FieldPolicy<any> | FieldReadFunction<any>,
	totalEndedDeals?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFilteredDeals?: FieldPolicy<any> | FieldReadFunction<any>,
	totalOngoingDeals?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalScheduledDeals?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedEmbeddedGameKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedEmbeddedGameKeySpecifier)[];
export type PaginatedEmbeddedGameFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedEventKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedEventKeySpecifier)[];
export type PaginatedEventFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedExchangedTransactionKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedExchangedTransactionKeySpecifier)[];
export type PaginatedExchangedTransactionFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedFailedOrderTransactionKeySpecifier = ('currentPage' | 'failedTransactions' | 'totalFailedTransactions' | 'totalPages' | 'totalRetriedSuccessOrders' | PaginatedFailedOrderTransactionKeySpecifier)[];
export type PaginatedFailedOrderTransactionFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	failedTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFailedTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRetriedSuccessOrders?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedFreebieTransactionKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedFreebieTransactionKeySpecifier)[];
export type PaginatedFreebieTransactionFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedItemsKeySpecifier = ('currentPage' | 'items' | 'totalCreatedItems' | 'totalItemStatusCount' | 'totalItems' | 'totalLiveItems' | 'totalLiveReadyItems' | 'totalPages' | 'totalRemovedItems' | 'totalTrashedItems' | 'totalValidatedItems' | PaginatedItemsKeySpecifier)[];
export type PaginatedItemsFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCreatedItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalItemStatusCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalLiveItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalLiveReadyItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRemovedItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalTrashedItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalValidatedItems?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedOrderKeySpecifier = ('currentPage' | 'orders' | 'totalCancelledOrders' | 'totalCompletedOrders' | 'totalDeletedOrders' | 'totalOrders' | 'totalPages' | 'totalProcessingOrders' | 'totalRefundedOrders' | PaginatedOrderKeySpecifier)[];
export type PaginatedOrderFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCancelledOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCompletedOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDeletedOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	totalOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalProcessingOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRefundedOrders?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedPartnerLanguageKeySpecifier = ('currentPage' | 'partners' | 'totalPages' | 'totalPartners' | PaginatedPartnerLanguageKeySpecifier)[];
export type PaginatedPartnerLanguageFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	partners?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPartners?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedPartnerProductGroupsKeySpecifier = ('currentPage' | 'productGroups' | 'totalPages' | 'totalProductGroups' | PaginatedPartnerProductGroupsKeySpecifier)[];
export type PaginatedPartnerProductGroupsFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalProductGroups?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedPaymentChannelKeySpecifier = ('currentPage' | 'paymentChannels' | 'totalActivePaymentChannels' | 'totalFilteredPaymentChannels' | 'totalInactivePaymentChannels' | 'totalPages' | 'totalPaymentChannels' | PaginatedPaymentChannelKeySpecifier)[];
export type PaginatedPaymentChannelFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	totalActivePaymentChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFilteredPaymentChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	totalInactivePaymentChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPaymentChannels?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedProductGroupKeySpecifier = ('currentPage' | 'productGroups' | 'totalActiveProductGroups' | 'totalDeletedProductGroups' | 'totalFilteredProductGroups' | 'totalInactiveProductGroups' | 'totalPages' | 'totalProductGroups' | PaginatedProductGroupKeySpecifier)[];
export type PaginatedProductGroupFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	totalActiveProductGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDeletedProductGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFilteredProductGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	totalInactiveProductGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalProductGroups?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedProductsKeySpecifier = ('currentPage' | 'products' | 'totalPages' | 'totalProducts' | PaginatedProductsKeySpecifier)[];
export type PaginatedProductsFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalProducts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedSwarmioCurrencyKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedSwarmioCurrencyKeySpecifier)[];
export type PaginatedSwarmioCurrencyFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedSwarmioCurrencyExchangeBlockKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedSwarmioCurrencyExchangeBlockKeySpecifier)[];
export type PaginatedSwarmioCurrencyExchangeBlockFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedSwarmioCurrencyItemKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedSwarmioCurrencyItemKeySpecifier)[];
export type PaginatedSwarmioCurrencyItemFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedSwarmioCurrencyPayoutKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedSwarmioCurrencyPayoutKeySpecifier)[];
export type PaginatedSwarmioCurrencyPayoutFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedSwarmioWalletTransactionWithMetadataKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedSwarmioWalletTransactionWithMetadataKeySpecifier)[];
export type PaginatedSwarmioWalletTransactionWithMetadataFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedTransferTransactionKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedTransferTransactionKeySpecifier)[];
export type PaginatedTransferTransactionFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedUserKeySpecifier = ('hasNextPage' | 'nodes' | 'totalCount' | PaginatedUserKeySpecifier)[];
export type PaginatedUserFieldPolicy = {
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedVouchersKeySpecifier = ('currentPage' | 'totalPages' | 'totalVouchers' | 'vouchers' | PaginatedVouchersKeySpecifier)[];
export type PaginatedVouchersFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVouchers?: FieldPolicy<any> | FieldReadFunction<any>,
	vouchers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ParticipantKeySpecifier = ('accountId' | 'confirmed' | 'participantType' | 'requirementsNotMet' | 'result' | ParticipantKeySpecifier)[];
export type ParticipantFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	participantType?: FieldPolicy<any> | FieldReadFunction<any>,
	requirementsNotMet?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ParticipantReferenceKeySpecifier = ('accountId' | 'participant' | 'participantId' | 'result' | ParticipantReferenceKeySpecifier)[];
export type ParticipantReferenceFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	participant?: FieldPolicy<any> | FieldReadFunction<any>,
	participantId?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ParticipantRequirementNotMetKeySpecifier = ('missingParticipantRequirement' | 'participantID' | ParticipantRequirementNotMetKeySpecifier)[];
export type ParticipantRequirementNotMetFieldPolicy = {
	missingParticipantRequirement?: FieldPolicy<any> | FieldReadFunction<any>,
	participantID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ParticipantScoreKeySpecifier = ('id' | 'score' | ParticipantScoreKeySpecifier)[];
export type ParticipantScoreFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ParticipationDataKeySpecifier = ('disqualified' | 'eliminated' | 'eventId' | 'participant' | ParticipationDataKeySpecifier)[];
export type ParticipationDataFieldPolicy = {
	disqualified?: FieldPolicy<any> | FieldReadFunction<any>,
	eliminated?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	participant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerKeySpecifier = ('catalog' | 'createdBy' | 'createdDate' | 'creditLimit' | 'id' | 'isActive' | 'localCurrency' | 'markedUpPercentage' | 'markedUpPercentageForCurrency' | 'markedUpPercentageForPsp' | 'modifiedBy' | 'modifiedDate' | 'partnerId' | 'partnerName' | 'partnerUrl' | PartnerKeySpecifier)[];
export type PartnerFieldPolicy = {
	catalog?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creditLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	localCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPercentageForCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPercentageForPsp?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerName?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerConversionKeySpecifier = ('currencyPrices' | 'finalRetailPrice' | 'finalRetailPriceOverridden' | 'finalRoundedPointsValue' | 'id' | 'isPartnerCurrencyMarkedUpPercentageOverridden' | 'isPartnerPointsMarkedUpPercentageOverridden' | 'isPartnerPspMarkedUpPercentageOverridden' | 'localCurrency' | 'localCurrencyConversionRate' | 'localCurrencyConversionRateOverridden' | 'markedUpPercentage' | 'markedUpPercentageForCurrency' | 'markedUpPercentageForPsp' | 'markedUpPrice' | 'markedUpPriceForCurrency' | 'markedUpPriceForPsp' | 'markedUpPriceOverridden' | 'overriddenMarkedUpPriceForCurrency' | 'overriddenMarkedUpPriceForPsp' | 'partnerId' | 'partnerName' | 'productsAvailable' | PartnerConversionKeySpecifier)[];
export type PartnerConversionFieldPolicy = {
	currencyPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	finalRetailPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	finalRetailPriceOverridden?: FieldPolicy<any> | FieldReadFunction<any>,
	finalRoundedPointsValue?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPartnerCurrencyMarkedUpPercentageOverridden?: FieldPolicy<any> | FieldReadFunction<any>,
	isPartnerPointsMarkedUpPercentageOverridden?: FieldPolicy<any> | FieldReadFunction<any>,
	isPartnerPspMarkedUpPercentageOverridden?: FieldPolicy<any> | FieldReadFunction<any>,
	localCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	localCurrencyConversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	localCurrencyConversionRateOverridden?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPercentageForCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPercentageForPsp?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPriceForCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPriceForPsp?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPriceOverridden?: FieldPolicy<any> | FieldReadFunction<any>,
	overriddenMarkedUpPriceForCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	overriddenMarkedUpPriceForPsp?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerName?: FieldPolicy<any> | FieldReadFunction<any>,
	productsAvailable?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerCurrencyPreferenceKeySpecifier = ('conversionRate' | 'id' | 'overridePartner' | 'sourceCurrency' | 'targetCurrency' | PartnerCurrencyPreferenceKeySpecifier)[];
export type PartnerCurrencyPreferenceFieldPolicy = {
	conversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	overridePartner?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	targetCurrency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerItemPaymentChannelResponseKeySpecifier = ('channelId' | 'globallyEnabled' | 'id' | 'isEnabled' | 'paymentName' | PartnerItemPaymentChannelResponseKeySpecifier)[];
export type PartnerItemPaymentChannelResponseFieldPolicy = {
	channelId?: FieldPolicy<any> | FieldReadFunction<any>,
	globallyEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerLanguageKeySpecifier = ('id' | 'languages' | 'partnerId' | 'partnerName' | PartnerLanguageKeySpecifier)[];
export type PartnerLanguageFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	languages?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerLocalCurrencyConversionKeySpecifier = ('conversionRate' | 'localCurrency' | PartnerLocalCurrencyConversionKeySpecifier)[];
export type PartnerLocalCurrencyConversionFieldPolicy = {
	conversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	localCurrency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerPaymentChannelKeySpecifier = ('active' | 'channelName' | 'id' | 'markedUpPercentage' | 'overridden' | PartnerPaymentChannelKeySpecifier)[];
export type PartnerPaymentChannelFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	channelName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	overridden?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PartnerPaymentChannelDataKeySpecifier = ('partnerId' | 'paymentChannelId' | PartnerPaymentChannelDataKeySpecifier)[];
export type PartnerPaymentChannelDataFieldPolicy = {
	partnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentChannelId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayPurchaseTransactionKeySpecifier = ('alternateTransactionId' | 'created' | 'fields' | 'id' | 'itemId' | 'merchantPaymentMethodId' | 'merchantPaymentMethodType' | 'notes' | 'order' | 'payment' | 'purchaserData' | 'quantity' | 'status' | 'tagId' | PayPurchaseTransactionKeySpecifier)[];
export type PayPurchaseTransactionFieldPolicy = {
	alternateTransactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	merchantPaymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	merchantPaymentMethodType?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaserData?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tagId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentKeySpecifier = ('createdAt' | 'document' | 'globalSlug' | 'id' | 'updatedAt' | 'user' | PayloadLockedDocumentKeySpecifier)[];
export type PayloadLockedDocumentFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	globalSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocument_Document_RelationshipKeySpecifier = ('relationTo' | 'value' | PayloadLockedDocument_Document_RelationshipKeySpecifier)[];
export type PayloadLockedDocument_Document_RelationshipFieldPolicy = {
	relationTo?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocument_User_RelationshipKeySpecifier = ('relationTo' | 'value' | PayloadLockedDocument_User_RelationshipKeySpecifier)[];
export type PayloadLockedDocument_User_RelationshipFieldPolicy = {
	relationTo?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsKeySpecifier = ('docs' | 'hasNextPage' | 'hasPrevPage' | 'limit' | 'nextPage' | 'offset' | 'page' | 'pagingCounter' | 'prevPage' | 'totalDocs' | 'totalPages' | PayloadLockedDocumentsKeySpecifier)[];
export type PayloadLockedDocumentsFieldPolicy = {
	docs?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPrevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	nextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pagingCounter?: FieldPolicy<any> | FieldReadFunction<any>,
	prevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsCreateAccessKeySpecifier = ('permission' | 'where' | PayloadLockedDocumentsCreateAccessKeySpecifier)[];
export type PayloadLockedDocumentsCreateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsCreateDocAccessKeySpecifier = ('permission' | 'where' | PayloadLockedDocumentsCreateDocAccessKeySpecifier)[];
export type PayloadLockedDocumentsCreateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDeleteAccessKeySpecifier = ('permission' | 'where' | PayloadLockedDocumentsDeleteAccessKeySpecifier)[];
export type PayloadLockedDocumentsDeleteAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDeleteDocAccessKeySpecifier = ('permission' | 'where' | PayloadLockedDocumentsDeleteDocAccessKeySpecifier)[];
export type PayloadLockedDocumentsDeleteDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFieldsKeySpecifier = ('createdAt' | 'document' | 'globalSlug' | 'updatedAt' | 'user' | PayloadLockedDocumentsDocAccessFieldsKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	globalSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadLockedDocumentsDocAccessFields_createdAtKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_createdAt_CreateKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_createdAt_CreateKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_createdAt_DeleteKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_createdAt_DeleteKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_createdAt_ReadKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_createdAt_ReadKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_createdAt_UpdateKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_createdAt_UpdateKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_documentKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadLockedDocumentsDocAccessFields_documentKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_documentFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_document_CreateKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_document_CreateKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_document_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_document_DeleteKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_document_DeleteKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_document_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_document_ReadKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_document_ReadKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_document_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_document_UpdateKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_document_UpdateKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_document_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_globalSlugKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadLockedDocumentsDocAccessFields_globalSlugKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_globalSlugFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_globalSlug_CreateKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_globalSlug_CreateKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_globalSlug_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_globalSlug_DeleteKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_globalSlug_DeleteKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_globalSlug_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_globalSlug_ReadKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_globalSlug_ReadKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_globalSlug_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_globalSlug_UpdateKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_globalSlug_UpdateKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_globalSlug_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadLockedDocumentsDocAccessFields_updatedAtKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_updatedAt_CreateKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_updatedAt_CreateKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_updatedAt_DeleteKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_updatedAt_DeleteKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_updatedAt_ReadKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_updatedAt_ReadKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_updatedAt_UpdateKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_updatedAt_UpdateKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_userKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadLockedDocumentsDocAccessFields_userKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_userFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_user_CreateKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_user_CreateKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_user_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_user_DeleteKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_user_DeleteKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_user_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_user_ReadKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_user_ReadKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_user_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsDocAccessFields_user_UpdateKeySpecifier = ('permission' | PayloadLockedDocumentsDocAccessFields_user_UpdateKeySpecifier)[];
export type PayloadLockedDocumentsDocAccessFields_user_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFieldsKeySpecifier = ('createdAt' | 'document' | 'globalSlug' | 'updatedAt' | 'user' | PayloadLockedDocumentsFieldsKeySpecifier)[];
export type PayloadLockedDocumentsFieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	globalSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadLockedDocumentsFields_createdAtKeySpecifier)[];
export type PayloadLockedDocumentsFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_createdAt_CreateKeySpecifier = ('permission' | PayloadLockedDocumentsFields_createdAt_CreateKeySpecifier)[];
export type PayloadLockedDocumentsFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_createdAt_DeleteKeySpecifier = ('permission' | PayloadLockedDocumentsFields_createdAt_DeleteKeySpecifier)[];
export type PayloadLockedDocumentsFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_createdAt_ReadKeySpecifier = ('permission' | PayloadLockedDocumentsFields_createdAt_ReadKeySpecifier)[];
export type PayloadLockedDocumentsFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_createdAt_UpdateKeySpecifier = ('permission' | PayloadLockedDocumentsFields_createdAt_UpdateKeySpecifier)[];
export type PayloadLockedDocumentsFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_documentKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadLockedDocumentsFields_documentKeySpecifier)[];
export type PayloadLockedDocumentsFields_documentFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_document_CreateKeySpecifier = ('permission' | PayloadLockedDocumentsFields_document_CreateKeySpecifier)[];
export type PayloadLockedDocumentsFields_document_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_document_DeleteKeySpecifier = ('permission' | PayloadLockedDocumentsFields_document_DeleteKeySpecifier)[];
export type PayloadLockedDocumentsFields_document_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_document_ReadKeySpecifier = ('permission' | PayloadLockedDocumentsFields_document_ReadKeySpecifier)[];
export type PayloadLockedDocumentsFields_document_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_document_UpdateKeySpecifier = ('permission' | PayloadLockedDocumentsFields_document_UpdateKeySpecifier)[];
export type PayloadLockedDocumentsFields_document_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_globalSlugKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadLockedDocumentsFields_globalSlugKeySpecifier)[];
export type PayloadLockedDocumentsFields_globalSlugFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_globalSlug_CreateKeySpecifier = ('permission' | PayloadLockedDocumentsFields_globalSlug_CreateKeySpecifier)[];
export type PayloadLockedDocumentsFields_globalSlug_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_globalSlug_DeleteKeySpecifier = ('permission' | PayloadLockedDocumentsFields_globalSlug_DeleteKeySpecifier)[];
export type PayloadLockedDocumentsFields_globalSlug_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_globalSlug_ReadKeySpecifier = ('permission' | PayloadLockedDocumentsFields_globalSlug_ReadKeySpecifier)[];
export type PayloadLockedDocumentsFields_globalSlug_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_globalSlug_UpdateKeySpecifier = ('permission' | PayloadLockedDocumentsFields_globalSlug_UpdateKeySpecifier)[];
export type PayloadLockedDocumentsFields_globalSlug_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadLockedDocumentsFields_updatedAtKeySpecifier)[];
export type PayloadLockedDocumentsFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_updatedAt_CreateKeySpecifier = ('permission' | PayloadLockedDocumentsFields_updatedAt_CreateKeySpecifier)[];
export type PayloadLockedDocumentsFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_updatedAt_DeleteKeySpecifier = ('permission' | PayloadLockedDocumentsFields_updatedAt_DeleteKeySpecifier)[];
export type PayloadLockedDocumentsFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_updatedAt_ReadKeySpecifier = ('permission' | PayloadLockedDocumentsFields_updatedAt_ReadKeySpecifier)[];
export type PayloadLockedDocumentsFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_updatedAt_UpdateKeySpecifier = ('permission' | PayloadLockedDocumentsFields_updatedAt_UpdateKeySpecifier)[];
export type PayloadLockedDocumentsFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_userKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadLockedDocumentsFields_userKeySpecifier)[];
export type PayloadLockedDocumentsFields_userFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_user_CreateKeySpecifier = ('permission' | PayloadLockedDocumentsFields_user_CreateKeySpecifier)[];
export type PayloadLockedDocumentsFields_user_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_user_DeleteKeySpecifier = ('permission' | PayloadLockedDocumentsFields_user_DeleteKeySpecifier)[];
export type PayloadLockedDocumentsFields_user_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_user_ReadKeySpecifier = ('permission' | PayloadLockedDocumentsFields_user_ReadKeySpecifier)[];
export type PayloadLockedDocumentsFields_user_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsFields_user_UpdateKeySpecifier = ('permission' | PayloadLockedDocumentsFields_user_UpdateKeySpecifier)[];
export type PayloadLockedDocumentsFields_user_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsReadAccessKeySpecifier = ('permission' | 'where' | PayloadLockedDocumentsReadAccessKeySpecifier)[];
export type PayloadLockedDocumentsReadAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsReadDocAccessKeySpecifier = ('permission' | 'where' | PayloadLockedDocumentsReadDocAccessKeySpecifier)[];
export type PayloadLockedDocumentsReadDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsUpdateAccessKeySpecifier = ('permission' | 'where' | PayloadLockedDocumentsUpdateAccessKeySpecifier)[];
export type PayloadLockedDocumentsUpdateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadLockedDocumentsUpdateDocAccessKeySpecifier = ('permission' | 'where' | PayloadLockedDocumentsUpdateDocAccessKeySpecifier)[];
export type PayloadLockedDocumentsUpdateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferenceKeySpecifier = ('createdAt' | 'id' | 'key' | 'updatedAt' | 'user' | 'value' | PayloadPreferenceKeySpecifier)[];
export type PayloadPreferenceFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreference_User_RelationshipKeySpecifier = ('relationTo' | 'value' | PayloadPreference_User_RelationshipKeySpecifier)[];
export type PayloadPreference_User_RelationshipFieldPolicy = {
	relationTo?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesKeySpecifier = ('docs' | 'hasNextPage' | 'hasPrevPage' | 'limit' | 'nextPage' | 'offset' | 'page' | 'pagingCounter' | 'prevPage' | 'totalDocs' | 'totalPages' | PayloadPreferencesKeySpecifier)[];
export type PayloadPreferencesFieldPolicy = {
	docs?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPrevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	nextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	offset?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pagingCounter?: FieldPolicy<any> | FieldReadFunction<any>,
	prevPage?: FieldPolicy<any> | FieldReadFunction<any>,
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesCreateAccessKeySpecifier = ('permission' | 'where' | PayloadPreferencesCreateAccessKeySpecifier)[];
export type PayloadPreferencesCreateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesCreateDocAccessKeySpecifier = ('permission' | 'where' | PayloadPreferencesCreateDocAccessKeySpecifier)[];
export type PayloadPreferencesCreateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDeleteAccessKeySpecifier = ('permission' | 'where' | PayloadPreferencesDeleteAccessKeySpecifier)[];
export type PayloadPreferencesDeleteAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDeleteDocAccessKeySpecifier = ('permission' | 'where' | PayloadPreferencesDeleteDocAccessKeySpecifier)[];
export type PayloadPreferencesDeleteDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFieldsKeySpecifier = ('createdAt' | 'key' | 'updatedAt' | 'user' | 'value' | PayloadPreferencesDocAccessFieldsKeySpecifier)[];
export type PayloadPreferencesDocAccessFieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadPreferencesDocAccessFields_createdAtKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_createdAt_CreateKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_createdAt_CreateKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_createdAt_DeleteKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_createdAt_DeleteKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_createdAt_ReadKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_createdAt_ReadKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_createdAt_UpdateKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_createdAt_UpdateKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_keyKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadPreferencesDocAccessFields_keyKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_keyFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_key_CreateKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_key_CreateKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_key_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_key_DeleteKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_key_DeleteKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_key_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_key_ReadKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_key_ReadKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_key_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_key_UpdateKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_key_UpdateKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_key_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadPreferencesDocAccessFields_updatedAtKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_updatedAt_CreateKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_updatedAt_CreateKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_updatedAt_DeleteKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_updatedAt_DeleteKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_updatedAt_ReadKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_updatedAt_ReadKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_updatedAt_UpdateKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_updatedAt_UpdateKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_userKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadPreferencesDocAccessFields_userKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_userFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_user_CreateKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_user_CreateKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_user_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_user_DeleteKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_user_DeleteKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_user_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_user_ReadKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_user_ReadKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_user_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_user_UpdateKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_user_UpdateKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_user_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_valueKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadPreferencesDocAccessFields_valueKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_valueFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_value_CreateKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_value_CreateKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_value_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_value_DeleteKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_value_DeleteKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_value_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_value_ReadKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_value_ReadKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_value_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesDocAccessFields_value_UpdateKeySpecifier = ('permission' | PayloadPreferencesDocAccessFields_value_UpdateKeySpecifier)[];
export type PayloadPreferencesDocAccessFields_value_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFieldsKeySpecifier = ('createdAt' | 'key' | 'updatedAt' | 'user' | 'value' | PayloadPreferencesFieldsKeySpecifier)[];
export type PayloadPreferencesFieldsFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_createdAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadPreferencesFields_createdAtKeySpecifier)[];
export type PayloadPreferencesFields_createdAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_createdAt_CreateKeySpecifier = ('permission' | PayloadPreferencesFields_createdAt_CreateKeySpecifier)[];
export type PayloadPreferencesFields_createdAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_createdAt_DeleteKeySpecifier = ('permission' | PayloadPreferencesFields_createdAt_DeleteKeySpecifier)[];
export type PayloadPreferencesFields_createdAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_createdAt_ReadKeySpecifier = ('permission' | PayloadPreferencesFields_createdAt_ReadKeySpecifier)[];
export type PayloadPreferencesFields_createdAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_createdAt_UpdateKeySpecifier = ('permission' | PayloadPreferencesFields_createdAt_UpdateKeySpecifier)[];
export type PayloadPreferencesFields_createdAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_keyKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadPreferencesFields_keyKeySpecifier)[];
export type PayloadPreferencesFields_keyFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_key_CreateKeySpecifier = ('permission' | PayloadPreferencesFields_key_CreateKeySpecifier)[];
export type PayloadPreferencesFields_key_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_key_DeleteKeySpecifier = ('permission' | PayloadPreferencesFields_key_DeleteKeySpecifier)[];
export type PayloadPreferencesFields_key_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_key_ReadKeySpecifier = ('permission' | PayloadPreferencesFields_key_ReadKeySpecifier)[];
export type PayloadPreferencesFields_key_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_key_UpdateKeySpecifier = ('permission' | PayloadPreferencesFields_key_UpdateKeySpecifier)[];
export type PayloadPreferencesFields_key_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_updatedAtKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadPreferencesFields_updatedAtKeySpecifier)[];
export type PayloadPreferencesFields_updatedAtFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_updatedAt_CreateKeySpecifier = ('permission' | PayloadPreferencesFields_updatedAt_CreateKeySpecifier)[];
export type PayloadPreferencesFields_updatedAt_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_updatedAt_DeleteKeySpecifier = ('permission' | PayloadPreferencesFields_updatedAt_DeleteKeySpecifier)[];
export type PayloadPreferencesFields_updatedAt_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_updatedAt_ReadKeySpecifier = ('permission' | PayloadPreferencesFields_updatedAt_ReadKeySpecifier)[];
export type PayloadPreferencesFields_updatedAt_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_updatedAt_UpdateKeySpecifier = ('permission' | PayloadPreferencesFields_updatedAt_UpdateKeySpecifier)[];
export type PayloadPreferencesFields_updatedAt_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_userKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadPreferencesFields_userKeySpecifier)[];
export type PayloadPreferencesFields_userFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_user_CreateKeySpecifier = ('permission' | PayloadPreferencesFields_user_CreateKeySpecifier)[];
export type PayloadPreferencesFields_user_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_user_DeleteKeySpecifier = ('permission' | PayloadPreferencesFields_user_DeleteKeySpecifier)[];
export type PayloadPreferencesFields_user_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_user_ReadKeySpecifier = ('permission' | PayloadPreferencesFields_user_ReadKeySpecifier)[];
export type PayloadPreferencesFields_user_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_user_UpdateKeySpecifier = ('permission' | PayloadPreferencesFields_user_UpdateKeySpecifier)[];
export type PayloadPreferencesFields_user_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_valueKeySpecifier = ('create' | 'delete' | 'read' | 'update' | PayloadPreferencesFields_valueKeySpecifier)[];
export type PayloadPreferencesFields_valueFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_value_CreateKeySpecifier = ('permission' | PayloadPreferencesFields_value_CreateKeySpecifier)[];
export type PayloadPreferencesFields_value_CreateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_value_DeleteKeySpecifier = ('permission' | PayloadPreferencesFields_value_DeleteKeySpecifier)[];
export type PayloadPreferencesFields_value_DeleteFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_value_ReadKeySpecifier = ('permission' | PayloadPreferencesFields_value_ReadKeySpecifier)[];
export type PayloadPreferencesFields_value_ReadFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesFields_value_UpdateKeySpecifier = ('permission' | PayloadPreferencesFields_value_UpdateKeySpecifier)[];
export type PayloadPreferencesFields_value_UpdateFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesReadAccessKeySpecifier = ('permission' | 'where' | PayloadPreferencesReadAccessKeySpecifier)[];
export type PayloadPreferencesReadAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesReadDocAccessKeySpecifier = ('permission' | 'where' | PayloadPreferencesReadDocAccessKeySpecifier)[];
export type PayloadPreferencesReadDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesUpdateAccessKeySpecifier = ('permission' | 'where' | PayloadPreferencesUpdateAccessKeySpecifier)[];
export type PayloadPreferencesUpdateAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayloadPreferencesUpdateDocAccessKeySpecifier = ('permission' | 'where' | PayloadPreferencesUpdateDocAccessKeySpecifier)[];
export type PayloadPreferencesUpdateDocAccessFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	where?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentKeySpecifier = ('paymentAmount' | 'paymentDate' | 'paymentId' | 'paymentMethod' | PaymentKeySpecifier)[];
export type PaymentFieldPolicy = {
	paymentAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentDate?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentChannelKeySpecifier = ('channelId' | 'channelName' | 'description' | 'id' | 'isActive' | 'markedUpPercentage' | 'paymentMethod' | PaymentChannelKeySpecifier)[];
export type PaymentChannelFieldPolicy = {
	channelId?: FieldPolicy<any> | FieldReadFunction<any>,
	channelName?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentChannelPricingKeySpecifier = ('channelId' | 'channelName' | 'conversionRate' | 'conversionRateOverriddenLevel' | 'finalPrice' | 'finalPriceOverridden' | 'isChannelActive' | 'localPointsRate' | 'localPointsRateOverriddenLevel' | 'markedUpPercentage' | 'markedUpPercentageOverriddenLevel' | 'markedUpPrice' | 'price' | 'roundedPointsValue' | 'sourceCurrency' | 'targetCurrency' | PaymentChannelPricingKeySpecifier)[];
export type PaymentChannelPricingFieldPolicy = {
	channelId?: FieldPolicy<any> | FieldReadFunction<any>,
	channelName?: FieldPolicy<any> | FieldReadFunction<any>,
	conversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	conversionRateOverriddenLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	finalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	finalPriceOverridden?: FieldPolicy<any> | FieldReadFunction<any>,
	isChannelActive?: FieldPolicy<any> | FieldReadFunction<any>,
	localPointsRate?: FieldPolicy<any> | FieldReadFunction<any>,
	localPointsRateOverriddenLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPercentageOverriddenLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	roundedPointsValue?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	targetCurrency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodConfigKeySpecifier = ('created' | 'disabled' | 'id' | 'imageUrl' | 'paymentMethodId' | 'updated' | PaymentMethodConfigKeySpecifier)[];
export type PaymentMethodConfigFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	disabled?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PersonKeySpecifier = ('accountManagers' | 'accountType' | 'additionalInformation' | 'avatarURL' | 'bannerURL' | 'birthday' | 'contactIdentifier' | 'country' | 'created' | 'description' | 'displayName' | 'email' | 'emailContact' | 'emailVerified' | 'eventParticipations' | 'gameAccounts' | 'groupInvites' | 'groupMemberships' | 'hasValidContact' | 'id' | 'isSupplier' | 'isVIP' | 'lastUpdated' | 'linkedAccounts' | 'managedAccounts' | 'msisdn' | 'msisdnContact' | 'msisdnVerified' | 'otherFields' | 'payPurchaseTransactions' | 'publicURL' | 'purchaseTransactions' | 'realName' | 'servers' | 'socialLinks' | 'subscriptionProviderAccounts' | 'subscriptions' | 'updated' | 'userType' | 'wallets' | PersonKeySpecifier)[];
export type PersonFieldPolicy = {
	accountManagers?: FieldPolicy<any> | FieldReadFunction<any>,
	accountType?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarURL?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerURL?: FieldPolicy<any> | FieldReadFunction<any>,
	birthday?: FieldPolicy<any> | FieldReadFunction<any>,
	contactIdentifier?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	emailContact?: FieldPolicy<any> | FieldReadFunction<any>,
	emailVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	eventParticipations?: FieldPolicy<any> | FieldReadFunction<any>,
	gameAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	groupInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	groupMemberships?: FieldPolicy<any> | FieldReadFunction<any>,
	hasValidContact?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSupplier?: FieldPolicy<any> | FieldReadFunction<any>,
	isVIP?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	linkedAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	managedAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	msisdn?: FieldPolicy<any> | FieldReadFunction<any>,
	msisdnContact?: FieldPolicy<any> | FieldReadFunction<any>,
	msisdnVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	otherFields?: FieldPolicy<any> | FieldReadFunction<any>,
	payPurchaseTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	publicURL?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	realName?: FieldPolicy<any> | FieldReadFunction<any>,
	servers?: FieldPolicy<any> | FieldReadFunction<any>,
	socialLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProviderAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>,
	userType?: FieldPolicy<any> | FieldReadFunction<any>,
	wallets?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhaseModificationsKeySpecifier = ('defaultMatchStartTime' | 'matchModifications' | 'numberOfRounds' | 'phaseNumber' | PhaseModificationsKeySpecifier)[];
export type PhaseModificationsFieldPolicy = {
	defaultMatchStartTime?: FieldPolicy<any> | FieldReadFunction<any>,
	matchModifications?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfRounds?: FieldPolicy<any> | FieldReadFunction<any>,
	phaseNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PhasedCompetitionFormatSpecificDetailsKeySpecifier = ('id' | 'maybeMaxRoundParticipants' | 'maybeParticipantsInRound' | PhasedCompetitionFormatSpecificDetailsKeySpecifier)[];
export type PhasedCompetitionFormatSpecificDetailsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeMaxRoundParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeParticipantsInRound?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayableMatchUpMatchKeySpecifier = ('assets' | 'gameSpecificDetails' | 'id' | 'isComplete' | 'name' | 'participants' | 'rounds' | 'startTime' | PlayableMatchUpMatchKeySpecifier)[];
export type PlayableMatchUpMatchFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	gameSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>,
	rounds?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlayableTournamentMatchKeySpecifier = ('assets' | 'gameSpecificDetails' | 'id' | 'isComplete' | 'name' | 'participants' | 'rounds' | 'startTime' | PlayableTournamentMatchKeySpecifier)[];
export type PlayableTournamentMatchFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	gameSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>,
	rounds?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PointsKeySpecifier = ('archive' | 'createdDate' | 'defaultValue' | 'id' | 'modifiedDate' | 'overriddenValue' | 'partner' | 'supplier' | PointsKeySpecifier)[];
export type PointsFieldPolicy = {
	archive?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultValue?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	overriddenValue?: FieldPolicy<any> | FieldReadFunction<any>,
	partner?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PointsArchiveKeySpecifier = ('archivedDate' | 'value' | PointsArchiveKeySpecifier)[];
export type PointsArchiveFieldPolicy = {
	archivedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrivateGameServerKeySpecifier = ('autoKick' | 'bots' | 'friendlyFire' | 'gameId' | 'gameMode' | 'id' | 'ip' | 'maps' | 'maxNumberOfPlayers' | 'numberOfPlayers' | 'ownerId' | 'password' | 'port' | 'rconPassword' | 'region' | 'serverType' | 'status' | 'timeAcquired' | 'timeDestroyed' | 'timeRequested' | PrivateGameServerKeySpecifier)[];
export type PrivateGameServerFieldPolicy = {
	autoKick?: FieldPolicy<any> | FieldReadFunction<any>,
	bots?: FieldPolicy<any> | FieldReadFunction<any>,
	friendlyFire?: FieldPolicy<any> | FieldReadFunction<any>,
	gameId?: FieldPolicy<any> | FieldReadFunction<any>,
	gameMode?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ip?: FieldPolicy<any> | FieldReadFunction<any>,
	maps?: FieldPolicy<any> | FieldReadFunction<any>,
	maxNumberOfPlayers?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfPlayers?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	port?: FieldPolicy<any> | FieldReadFunction<any>,
	rconPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	serverType?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	timeAcquired?: FieldPolicy<any> | FieldReadFunction<any>,
	timeDestroyed?: FieldPolicy<any> | FieldReadFunction<any>,
	timeRequested?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrizeKeySpecifier = ('id' | 'prizeType' | PrizeKeySpecifier)[];
export type PrizeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	prizeType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrizeListKeySpecifier = ('id' | 'prizeTiers' | PrizeListKeySpecifier)[];
export type PrizeListFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	prizeTiers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrizePayoutReceiptKeySpecifier = ('accountId' | 'created' | 'id' | 'notes' | 'prizePayoutReceiptType' | 'prizeTierId' | 'successful' | PrizePayoutReceiptKeySpecifier)[];
export type PrizePayoutReceiptFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	prizePayoutReceiptType?: FieldPolicy<any> | FieldReadFunction<any>,
	prizeTierId?: FieldPolicy<any> | FieldReadFunction<any>,
	successful?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrizeTierKeySpecifier = ('id' | 'placement' | 'placementRange' | 'prize' | PrizeTierKeySpecifier)[];
export type PrizeTierFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	placement?: FieldPolicy<any> | FieldReadFunction<any>,
	placementRange?: FieldPolicy<any> | FieldReadFunction<any>,
	prize?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductKeySpecifier = ('availableStock' | 'createdDate' | 'currency' | 'currencySymbol' | 'id' | 'item' | 'manufacturerBrandId' | 'manufacturerBrandName' | 'manufacturerBrandProductFields' | 'manufacturerBrandProductFormatDesc' | 'manufacturerBrandProductFormatId' | 'manufacturerId' | 'manufacturerName' | 'modifiedDate' | 'orderFields' | 'orderStrategy' | 'productCode' | 'productId' | 'productImageUrl' | 'productName' | 'productRedemptionInstructions' | 'productStatus' | 'productType' | 'productVouchers' | 'productVvssku' | 'purchaseNote' | 'sellPrice' | 'totalStock' | 'unitPrice' | 'voucherInventories' | ProductKeySpecifier)[];
export type ProductFieldPolicy = {
	availableStock?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	currencySymbol?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturerBrandId?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturerBrandName?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturerBrandProductFields?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturerBrandProductFormatDesc?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturerBrandProductFormatId?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturerId?: FieldPolicy<any> | FieldReadFunction<any>,
	manufacturerName?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderFields?: FieldPolicy<any> | FieldReadFunction<any>,
	orderStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	productCode?: FieldPolicy<any> | FieldReadFunction<any>,
	productId?: FieldPolicy<any> | FieldReadFunction<any>,
	productImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	productRedemptionInstructions?: FieldPolicy<any> | FieldReadFunction<any>,
	productStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	productVouchers?: FieldPolicy<any> | FieldReadFunction<any>,
	productVvssku?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseNote?: FieldPolicy<any> | FieldReadFunction<any>,
	sellPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	totalStock?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherInventories?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductDeleteKeySpecifier = ('itemsUnpublishedTotal' | 'voucherDeletedTotal' | ProductDeleteKeySpecifier)[];
export type ProductDeleteFieldPolicy = {
	itemsUnpublishedTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherDeletedTotal?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductGroupKeySpecifier = ('bannerImage' | 'description' | 'displayName' | 'featured' | 'id' | 'isActive' | 'isDeleted' | 'itemOrder' | 'name' | 'productGroupCatalogCategories' | 'productGroupId' | 'productType' | 'thumbnail' | 'urlMask' | ProductGroupKeySpecifier)[];
export type ProductGroupFieldPolicy = {
	bannerImage?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	itemOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupCatalogCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	urlMask?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductGroupCatalogCategoryKeySpecifier = ('catalog' | 'category' | 'productGroup' | ProductGroupCatalogCategoryKeySpecifier)[];
export type ProductGroupCatalogCategoryFieldPolicy = {
	catalog?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroup?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductGroupCatalogCategoryInfoKeySpecifier = ('catalog' | 'category' | 'productGroup' | ProductGroupCatalogCategoryInfoKeySpecifier)[];
export type ProductGroupCatalogCategoryInfoFieldPolicy = {
	catalog?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroup?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductGroupInfoKeySpecifier = ('bannerImage' | 'deals' | 'description' | 'displayName' | 'featured' | 'id' | 'isActive' | 'isDeleted' | 'itemOrder' | 'name' | 'productGroupCatalogCategories' | 'productGroupId' | 'productType' | 'thumbnail' | 'urlMask' | ProductGroupInfoKeySpecifier)[];
export type ProductGroupInfoFieldPolicy = {
	bannerImage?: FieldPolicy<any> | FieldReadFunction<any>,
	deals?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	itemOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupCatalogCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	urlMask?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductGroupItemKeySpecifier = ('contentType' | 'createdBy' | 'createdDate' | 'currencyConversionRate' | 'deals' | 'deliveryMethod' | 'displayName' | 'gamePublisher' | 'id' | 'isActive' | 'isDeleted' | 'isStockAvailable' | 'itemDescBrief' | 'itemDescDetail' | 'itemGalleryUrls' | 'itemId' | 'itemImageUrl' | 'itemName' | 'itemPartnerPoints' | 'itemProductGroup' | 'itemStatus' | 'itemType' | 'mappedCatalogs' | 'outOfStockDate' | 'outOfStockImageUrl' | 'product' | 'safetyStockThreshold' | 'supplier' | 'unitPrice' | 'variantName' | ProductGroupItemKeySpecifier)[];
export type ProductGroupItemFieldPolicy = {
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyConversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	deals?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	gamePublisher?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	isStockAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDescBrief?: FieldPolicy<any> | FieldReadFunction<any>,
	itemDescDetail?: FieldPolicy<any> | FieldReadFunction<any>,
	itemGalleryUrls?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	itemImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>,
	itemPartnerPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	itemProductGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	itemStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	itemType?: FieldPolicy<any> | FieldReadFunction<any>,
	mappedCatalogs?: FieldPolicy<any> | FieldReadFunction<any>,
	outOfStockDate?: FieldPolicy<any> | FieldReadFunction<any>,
	outOfStockImageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	safetyStockThreshold?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	variantName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductGroupLanguageDTOKeySpecifier = ('id' | 'languages' | 'name' | 'productGroupId' | 'unConfiguredLanguageIds' | ProductGroupLanguageDTOKeySpecifier)[];
export type ProductGroupLanguageDTOFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	languages?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	unConfiguredLanguageIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductGroupLanguageDataKeySpecifier = ('countryCode' | 'isDefault' | 'isLanguageConfigured' | 'languageCode' | 'languageId' | 'languageName' | 'mappedPartnerLanguage' | 'productGroupDescription' | 'productGroupDisplayName' | 'productGroupName' | ProductGroupLanguageDataKeySpecifier)[];
export type ProductGroupLanguageDataFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	isLanguageConfigured?: FieldPolicy<any> | FieldReadFunction<any>,
	languageCode?: FieldPolicy<any> | FieldReadFunction<any>,
	languageId?: FieldPolicy<any> | FieldReadFunction<any>,
	languageName?: FieldPolicy<any> | FieldReadFunction<any>,
	mappedPartnerLanguage?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductGroupLanguageResponseKeySpecifier = ('productGroupDescription' | 'productGroupDisplayName' | 'productGroupName' | ProductGroupLanguageResponseKeySpecifier)[];
export type ProductGroupLanguageResponseFieldPolicy = {
	productGroupDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductGroupLanguagesResponseKeySpecifier = ('currentPage' | 'pageSize' | 'productGroups' | 'totalFilteredProductGroups' | 'totalPages' | ProductGroupLanguagesResponseKeySpecifier)[];
export type ProductGroupLanguagesResponseFieldPolicy = {
	currentPage?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSize?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	totalFilteredProductGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPages?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductGroupResponseKeySpecifier = ('bannerImage' | 'catalogs' | 'categories' | 'description' | 'displayName' | 'featured' | 'id' | 'isActive' | 'isDeleted' | 'itemOrder' | 'items' | 'mappedPartners' | 'name' | 'productGroupId' | 'productType' | 'productsCount' | 'thumbnail' | 'urlMask' | ProductGroupResponseKeySpecifier)[];
export type ProductGroupResponseFieldPolicy = {
	bannerImage?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogs?: FieldPolicy<any> | FieldReadFunction<any>,
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	itemOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	mappedPartners?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupId?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	productsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	urlMask?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductPriceKeySpecifier = ('paymentChannelId' | 'paymentChannelName' | 'paymentMethod' | 'targetCurrencyPrices' | ProductPriceKeySpecifier)[];
export type ProductPriceFieldPolicy = {
	paymentChannelId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentChannelName?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	targetCurrencyPrices?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVoucherKeySpecifier = ('createdDate' | 'id' | 'status' | 'voucherCode' | 'voucherExpiry' | 'voucherPin' | 'voucherSerial' | 'voucherSerial2' | ProductVoucherKeySpecifier)[];
export type ProductVoucherFieldPolicy = {
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCode?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherExpiry?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherPin?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherSerial?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherSerial2?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrunedDoubleEliminationSpecificDetailsKeySpecifier = ('accountsIdsWithPruningImmunity' | 'id' | 'lowerBracketParticipantsInHold' | 'maybeMaxRoundParticipants' | 'maybeParticipantsInRound' | 'participantsInHold' | 'tournamentFormat' | PrunedDoubleEliminationSpecificDetailsKeySpecifier)[];
export type PrunedDoubleEliminationSpecificDetailsFieldPolicy = {
	accountsIdsWithPruningImmunity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lowerBracketParticipantsInHold?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeMaxRoundParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeParticipantsInRound?: FieldPolicy<any> | FieldReadFunction<any>,
	participantsInHold?: FieldPolicy<any> | FieldReadFunction<any>,
	tournamentFormat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PrunedSingleEliminationSpecificDetailsKeySpecifier = ('accountsIdsWithPruningImmunity' | 'id' | 'maybeMaxRoundParticipants' | 'maybeParticipantsInRound' | 'participantsInHold' | 'tournamentFormat' | PrunedSingleEliminationSpecificDetailsKeySpecifier)[];
export type PrunedSingleEliminationSpecificDetailsFieldPolicy = {
	accountsIdsWithPruningImmunity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeMaxRoundParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeParticipantsInRound?: FieldPolicy<any> | FieldReadFunction<any>,
	participantsInHold?: FieldPolicy<any> | FieldReadFunction<any>,
	tournamentFormat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicGameServerKeySpecifier = ('connectString' | 'description' | 'featured' | 'id' | 'imageURL' | 'ip' | 'maxNumberOfPlayers' | 'name' | 'port' | 'rconPassword' | 'region' | 'serverType' | 'status' | 'steamURL' | 'timeAcquired' | 'timeDestroyed' | 'timeRequested' | PublicGameServerKeySpecifier)[];
export type PublicGameServerFieldPolicy = {
	connectString?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	featured?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageURL?: FieldPolicy<any> | FieldReadFunction<any>,
	ip?: FieldPolicy<any> | FieldReadFunction<any>,
	maxNumberOfPlayers?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	port?: FieldPolicy<any> | FieldReadFunction<any>,
	rconPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	serverType?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	steamURL?: FieldPolicy<any> | FieldReadFunction<any>,
	timeAcquired?: FieldPolicy<any> | FieldReadFunction<any>,
	timeDestroyed?: FieldPolicy<any> | FieldReadFunction<any>,
	timeRequested?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PurchaseResponseKeySpecifier = ('billingAddress' | 'cancellationNote' | 'contentType' | 'createdBy' | 'createdDate' | 'formattedItemId' | 'gamerEmail' | 'gamerId' | 'gamerName' | 'id' | 'isActive' | 'item' | 'itemName' | 'modifiedBy' | 'modifiedDate' | 'orderDate' | 'orderId' | 'orderStatus' | 'orderTransaction' | 'partner' | 'payment' | 'pointsValue' | 'purchaseCurrency' | 'purchaseCurrencyPrice' | 'purchaseMedium' | 'quantity' | 'shipment' | 'totalPoints' | 'transaction' | 'transactionId' | 'vouchers' | PurchaseResponseKeySpecifier)[];
export type PurchaseResponseFieldPolicy = {
	billingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	cancellationNote?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	formattedItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerId?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderDate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	orderStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	orderTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	partner?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	pointsValue?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseCurrencyPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseMedium?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	shipment?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	vouchers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PurchaseTagIdRegistrationResponseKeySpecifier = ('createdDate' | 'id' | 'itemId' | 'purchaseMedium' | 'transactionId' | PurchaseTagIdRegistrationResponseKeySpecifier)[];
export type PurchaseTagIdRegistrationResponseFieldPolicy = {
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseMedium?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PurchaseTransactionKeySpecifier = ('alternateTransactionId' | 'created' | 'fields' | 'id' | 'item' | 'itemId' | 'notes' | 'order' | 'paymentTransactionId' | 'status' | PurchaseTransactionKeySpecifier)[];
export type PurchaseTransactionFieldPolicy = {
	alternateTransactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentTransactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PurchaserDataKeySpecifier = ('address' | 'country' | 'email' | 'firstName' | 'hasAccount' | 'id' | 'ipAddress' | 'lastName' | 'maxitMSISDN' | 'mobileNumber' | 'posthogId' | PurchaserDataKeySpecifier)[];
export type PurchaserDataFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	hasAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ipAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	maxitMSISDN?: FieldPolicy<any> | FieldReadFunction<any>,
	mobileNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	posthogId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('Access' | 'CmsBanner' | 'CmsBanners' | 'CmsBlogPage' | 'CmsBlogPages' | 'CmsBlogPost' | 'CmsBlogPosts' | 'CmsGame' | 'CmsGamer' | 'CmsGamers' | 'CmsGames' | 'CmsMedia' | 'CmsMedias' | 'CmsUser' | 'CmsUsers' | 'InGameResults' | 'PayloadLockedDocument' | 'PayloadLockedDocuments' | 'PayloadPreference' | 'PayloadPreferences' | 'account' | 'accountByPublicURL' | 'accounts' | 'allActivePublicServers' | 'allEventGames' | 'allEvents' | 'allGameAccountTypes' | 'allServers' | 'allUsers' | 'applicationConfig' | 'applicationConfigByName' | 'applicationConfigs' | 'areYouStillThere' | 'automaticallyVerifiedResultsForRoundAndFromParticipantId' | 'automaticallyVerifiedResultsForRoundId' | 'banner' | 'banners' | 'catalog' | 'catalogItem' | 'catalogItems' | 'catalogs' | 'categories' | 'category' | 'categoryCatalog' | 'categoryCatalogAdmin' | 'categoryLanguageData' | 'categoryLanguages' | 'categoryProductGroups' | 'checkMSISDNVerificationCode' | 'countCmsBanners' | 'countCmsBlogPages' | 'countCmsBlogPosts' | 'countCmsGamers' | 'countCmsGames' | 'countCmsMedias' | 'countCmsUsers' | 'countPayloadLockedDocuments' | 'countPayloadPreferences' | 'csvFiles' | 'currencyConversions' | 'deal' | 'dealItemsByPartnerIdsAndPaymentChannelIds' | 'dealLog' | 'dealSelectedPartnerItems' | 'dealSelectedPartners' | 'dealSelectedPaymentChannels' | 'deals' | 'distinctPaymentMethods' | 'docAccessCmsBanner' | 'docAccessCmsBlogPage' | 'docAccessCmsBlogPost' | 'docAccessCmsGame' | 'docAccessCmsGamer' | 'docAccessCmsMedia' | 'docAccessCmsUser' | 'docAccessPayloadLockedDocument' | 'docAccessPayloadPreference' | 'embeddedGame' | 'event' | 'eventMatch' | 'eventParticipant' | 'eventParticipantByAccount' | 'eventsByTags' | 'exportItems' | 'failedOrderTransactions' | 'feature' | 'features' | 'gameUserIdValidation' | 'getActiveMatches' | 'getAllEventsWithCategory' | 'getAllPayPurchaseTransactions' | 'getAllPaymentMethodsAvailableForMerchant' | 'getAllSubscriptionTypes' | 'getAllSwarmioCurrencies' | 'getAllSwarmioCurrencyItems' | 'getAllSwarmioCurrencyPayouts' | 'getCurrencyPurchaseHistoryByOwnerId' | 'getEmbeddedGames' | 'getEventRequirements' | 'getExternalSubscriptionPackagesBySubscriptionPartner' | 'getMatchUpsAndTournamentsRequiringScoreAttention' | 'getMismatchedOrderFieldsProductsList' | 'getNextMatches' | 'getNotifications' | 'getPayPurchaseTransaction' | 'getPayPurchaseTransactionsByEmail' | 'getPayTransactionsWithError' | 'getPaymentMethodsAvailableForMerchant' | 'getSomething' | 'getStreamers' | 'getStreamsByIds' | 'getStreamsbyType' | 'getSubscriptionsByIds' | 'getSubscriptionsForAccountId' | 'getSubscriptionsForAccountIds' | 'getSwarmioCurrencies' | 'getSwarmioCurrencyExchangeBlocks' | 'getSwarmioCurrencyItem' | 'getSwarmioCurrencyItems' | 'getSwarmioCurrencyPayouts' | 'getWallet' | 'getWalletsForOwner' | 'ghostCompetition' | 'globalPoints' | 'globalPointsList' | 'groupTrait' | 'groupTraitNameIsUnique' | 'groupTraits' | 'initializedCmsUser' | 'isDealNameExists' | 'item' | 'itemLanguageData' | 'itemLanguages' | 'itemSearchSuggestions' | 'items' | 'itemsByPartner' | 'languages' | 'manuallyVerifiedResultsForCompetitionId' | 'manuallyVerifiedResultsForRoundId' | 'manuallyVerifiedResultsForRoundIdAndParticipantId' | 'me' | 'meCmsUser' | 'nonTrashedProductGroups' | 'order' | 'orderByTransactionId' | 'orderSearchSuggestions' | 'orders' | 'ordersByGamer' | 'paginatedCategories' | 'partnerCategoryByURLMask' | 'partnerConversions' | 'partnerConversionsByItemAndPartnerId' | 'partnerCurrencyPreferences' | 'partnerItemPaymentChannels' | 'partnerItemPricingDetails' | 'partnerLanguages' | 'partnerLocalCurrencyConversionRate' | 'partnerProductGroup' | 'partnerProductGroupByURLMask' | 'partnerProductGroups' | 'partnerTargetCurrencyPreferences' | 'partnersByItemId' | 'paymentChannel' | 'paymentChannels' | 'paymentChannelsByPartners' | 'paymentChannelsDataByPartnerId' | 'paymentMethodConfig' | 'paymentMethodConfigs' | 'prize' | 'prizes' | 'product' | 'productGroup' | 'productGroupLanguageData' | 'productGroups' | 'productGroupsByCategory' | 'productGroupsLanguages' | 'products' | 'productsBySupplier' | 'purchaseTransaction' | 'purchaseTransactions' | 'retriedFailedOrderTransactions' | 'retriedSuccessOrders' | 'server' | 'supplier' | 'supplierConfigurations' | 'suppliers' | 'user' | 'userByDisplayName' | 'userByEmail' | 'userSuggestions' | 'users' | 'validatePartnerDeal' | 'validateSLTAccount' | 'voucherCodesBySupplier' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	Access?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsBanners?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsBlogPage?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsBlogPages?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsBlogPost?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsBlogPosts?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsGame?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsGamer?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsGamers?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsGames?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsMedias?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	CmsUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	InGameResults?: FieldPolicy<any> | FieldReadFunction<any>,
	PayloadLockedDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	PayloadLockedDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	PayloadPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	PayloadPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	account?: FieldPolicy<any> | FieldReadFunction<any>,
	accountByPublicURL?: FieldPolicy<any> | FieldReadFunction<any>,
	accounts?: FieldPolicy<any> | FieldReadFunction<any>,
	allActivePublicServers?: FieldPolicy<any> | FieldReadFunction<any>,
	allEventGames?: FieldPolicy<any> | FieldReadFunction<any>,
	allEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	allGameAccountTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	allServers?: FieldPolicy<any> | FieldReadFunction<any>,
	allUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	applicationConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	applicationConfigByName?: FieldPolicy<any> | FieldReadFunction<any>,
	applicationConfigs?: FieldPolicy<any> | FieldReadFunction<any>,
	areYouStillThere?: FieldPolicy<any> | FieldReadFunction<any>,
	automaticallyVerifiedResultsForRoundAndFromParticipantId?: FieldPolicy<any> | FieldReadFunction<any>,
	automaticallyVerifiedResultsForRoundId?: FieldPolicy<any> | FieldReadFunction<any>,
	banner?: FieldPolicy<any> | FieldReadFunction<any>,
	banners?: FieldPolicy<any> | FieldReadFunction<any>,
	catalog?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogItem?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogItems?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogs?: FieldPolicy<any> | FieldReadFunction<any>,
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryCatalog?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryCatalogAdmin?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryLanguageData?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryLanguages?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryProductGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	checkMSISDNVerificationCode?: FieldPolicy<any> | FieldReadFunction<any>,
	countCmsBanners?: FieldPolicy<any> | FieldReadFunction<any>,
	countCmsBlogPages?: FieldPolicy<any> | FieldReadFunction<any>,
	countCmsBlogPosts?: FieldPolicy<any> | FieldReadFunction<any>,
	countCmsGamers?: FieldPolicy<any> | FieldReadFunction<any>,
	countCmsGames?: FieldPolicy<any> | FieldReadFunction<any>,
	countCmsMedias?: FieldPolicy<any> | FieldReadFunction<any>,
	countCmsUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	countPayloadLockedDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	countPayloadPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	csvFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyConversions?: FieldPolicy<any> | FieldReadFunction<any>,
	deal?: FieldPolicy<any> | FieldReadFunction<any>,
	dealItemsByPartnerIdsAndPaymentChannelIds?: FieldPolicy<any> | FieldReadFunction<any>,
	dealLog?: FieldPolicy<any> | FieldReadFunction<any>,
	dealSelectedPartnerItems?: FieldPolicy<any> | FieldReadFunction<any>,
	dealSelectedPartners?: FieldPolicy<any> | FieldReadFunction<any>,
	dealSelectedPaymentChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	deals?: FieldPolicy<any> | FieldReadFunction<any>,
	distinctPaymentMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	docAccessCmsBanner?: FieldPolicy<any> | FieldReadFunction<any>,
	docAccessCmsBlogPage?: FieldPolicy<any> | FieldReadFunction<any>,
	docAccessCmsBlogPost?: FieldPolicy<any> | FieldReadFunction<any>,
	docAccessCmsGame?: FieldPolicy<any> | FieldReadFunction<any>,
	docAccessCmsGamer?: FieldPolicy<any> | FieldReadFunction<any>,
	docAccessCmsMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	docAccessCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	docAccessPayloadLockedDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	docAccessPayloadPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	embeddedGame?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventMatch?: FieldPolicy<any> | FieldReadFunction<any>,
	eventParticipant?: FieldPolicy<any> | FieldReadFunction<any>,
	eventParticipantByAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	eventsByTags?: FieldPolicy<any> | FieldReadFunction<any>,
	exportItems?: FieldPolicy<any> | FieldReadFunction<any>,
	failedOrderTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	feature?: FieldPolicy<any> | FieldReadFunction<any>,
	features?: FieldPolicy<any> | FieldReadFunction<any>,
	gameUserIdValidation?: FieldPolicy<any> | FieldReadFunction<any>,
	getActiveMatches?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllEventsWithCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllPayPurchaseTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllPaymentMethodsAvailableForMerchant?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllSubscriptionTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllSwarmioCurrencies?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllSwarmioCurrencyItems?: FieldPolicy<any> | FieldReadFunction<any>,
	getAllSwarmioCurrencyPayouts?: FieldPolicy<any> | FieldReadFunction<any>,
	getCurrencyPurchaseHistoryByOwnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	getEmbeddedGames?: FieldPolicy<any> | FieldReadFunction<any>,
	getEventRequirements?: FieldPolicy<any> | FieldReadFunction<any>,
	getExternalSubscriptionPackagesBySubscriptionPartner?: FieldPolicy<any> | FieldReadFunction<any>,
	getMatchUpsAndTournamentsRequiringScoreAttention?: FieldPolicy<any> | FieldReadFunction<any>,
	getMismatchedOrderFieldsProductsList?: FieldPolicy<any> | FieldReadFunction<any>,
	getNextMatches?: FieldPolicy<any> | FieldReadFunction<any>,
	getNotifications?: FieldPolicy<any> | FieldReadFunction<any>,
	getPayPurchaseTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	getPayPurchaseTransactionsByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	getPayTransactionsWithError?: FieldPolicy<any> | FieldReadFunction<any>,
	getPaymentMethodsAvailableForMerchant?: FieldPolicy<any> | FieldReadFunction<any>,
	getSomething?: FieldPolicy<any> | FieldReadFunction<any>,
	getStreamers?: FieldPolicy<any> | FieldReadFunction<any>,
	getStreamsByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	getStreamsbyType?: FieldPolicy<any> | FieldReadFunction<any>,
	getSubscriptionsByIds?: FieldPolicy<any> | FieldReadFunction<any>,
	getSubscriptionsForAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	getSubscriptionsForAccountIds?: FieldPolicy<any> | FieldReadFunction<any>,
	getSwarmioCurrencies?: FieldPolicy<any> | FieldReadFunction<any>,
	getSwarmioCurrencyExchangeBlocks?: FieldPolicy<any> | FieldReadFunction<any>,
	getSwarmioCurrencyItem?: FieldPolicy<any> | FieldReadFunction<any>,
	getSwarmioCurrencyItems?: FieldPolicy<any> | FieldReadFunction<any>,
	getSwarmioCurrencyPayouts?: FieldPolicy<any> | FieldReadFunction<any>,
	getWallet?: FieldPolicy<any> | FieldReadFunction<any>,
	getWalletsForOwner?: FieldPolicy<any> | FieldReadFunction<any>,
	ghostCompetition?: FieldPolicy<any> | FieldReadFunction<any>,
	globalPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	globalPointsList?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTrait?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTraitNameIsUnique?: FieldPolicy<any> | FieldReadFunction<any>,
	groupTraits?: FieldPolicy<any> | FieldReadFunction<any>,
	initializedCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	isDealNameExists?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	itemLanguageData?: FieldPolicy<any> | FieldReadFunction<any>,
	itemLanguages?: FieldPolicy<any> | FieldReadFunction<any>,
	itemSearchSuggestions?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	itemsByPartner?: FieldPolicy<any> | FieldReadFunction<any>,
	languages?: FieldPolicy<any> | FieldReadFunction<any>,
	manuallyVerifiedResultsForCompetitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	manuallyVerifiedResultsForRoundId?: FieldPolicy<any> | FieldReadFunction<any>,
	manuallyVerifiedResultsForRoundIdAndParticipantId?: FieldPolicy<any> | FieldReadFunction<any>,
	me?: FieldPolicy<any> | FieldReadFunction<any>,
	meCmsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	nonTrashedProductGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderByTransactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	orderSearchSuggestions?: FieldPolicy<any> | FieldReadFunction<any>,
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	ordersByGamer?: FieldPolicy<any> | FieldReadFunction<any>,
	paginatedCategories?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerCategoryByURLMask?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerConversions?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerConversionsByItemAndPartnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerCurrencyPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerItemPaymentChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerItemPricingDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerLanguages?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerLocalCurrencyConversionRate?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerProductGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerProductGroupByURLMask?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerProductGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerTargetCurrencyPreferences?: FieldPolicy<any> | FieldReadFunction<any>,
	partnersByItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentChannelsByPartners?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentChannelsDataByPartnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodConfigs?: FieldPolicy<any> | FieldReadFunction<any>,
	prize?: FieldPolicy<any> | FieldReadFunction<any>,
	prizes?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupLanguageData?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupsByCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	productGroupsLanguages?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	productsBySupplier?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseTransaction?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	retriedFailedOrderTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	retriedSuccessOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	server?: FieldPolicy<any> | FieldReadFunction<any>,
	supplier?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierConfigurations?: FieldPolicy<any> | FieldReadFunction<any>,
	suppliers?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userByDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	userByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	userSuggestions?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	validatePartnerDeal?: FieldPolicy<any> | FieldReadFunction<any>,
	validateSLTAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCodesBySupplier?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReadyIndividualParticipantKeySpecifier = ('accountId' | 'confirmed' | 'created' | 'gameAccount' | 'gameAccountId' | 'id' | 'inviteLink' | 'maybeGameAccountId' | 'participantType' | 'person' | 'requirementsNotMet' | 'result' | ReadyIndividualParticipantKeySpecifier)[];
export type ReadyIndividualParticipantFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	gameAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	gameAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteLink?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeGameAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	participantType?: FieldPolicy<any> | FieldReadFunction<any>,
	person?: FieldPolicy<any> | FieldReadFunction<any>,
	requirementsNotMet?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RealWorldCurrencyCostKeySpecifier = ('amount' | 'costType' | 'created' | 'currency' | 'frequency' | 'id' | 'updated' | RealWorldCurrencyCostKeySpecifier)[];
export type RealWorldCurrencyCostFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	costType?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	frequency?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RecipientKeySpecifier = ('contact' | 'id' | RecipientKeySpecifier)[];
export type RecipientFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RecurringRewardKeySpecifier = ('amount' | 'id' | 'paymentFrequency' | 'swarmioCurrencyId' | RecurringRewardKeySpecifier)[];
export type RecurringRewardFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFrequency?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RedemptionKeySpecifier = ('date' | 'id' | 'redeemedBy' | RedemptionKeySpecifier)[];
export type RedemptionFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	redeemedBy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResultKeySpecifier = ('placement' | 'score' | 'showed' | ResultKeySpecifier)[];
export type ResultFieldPolicy = {
	placement?: FieldPolicy<any> | FieldReadFunction<any>,
	score?: FieldPolicy<any> | FieldReadFunction<any>,
	showed?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResultBucketKeySpecifier = ('bucketBottom' | 'bucketTop' | 'id' | ResultBucketKeySpecifier)[];
export type ResultBucketFieldPolicy = {
	bucketBottom?: FieldPolicy<any> | FieldReadFunction<any>,
	bucketTop?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RetriedFailedTransactionsKeySpecifier = ('createdDate' | 'errorMessage' | 'retriedTransactionId' | 'status' | 'transactionId' | RetriedFailedTransactionsKeySpecifier)[];
export type RetriedFailedTransactionsFieldPolicy = {
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	errorMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	retriedTransactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleKeySpecifier = ('roleDisplayName' | 'roleId' | RoleKeySpecifier)[];
export type RoleFieldPolicy = {
	roleDisplayName?: FieldPolicy<any> | FieldReadFunction<any>,
	roleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RootCode_OrderKeySpecifier = ('createdDate' | 'gamerId' | 'id' | 'orderDate' | 'orderStatus' | 'quantity' | 'transaction' | 'transactionId' | 'vouchers' | RootCode_OrderKeySpecifier)[];
export type RootCode_OrderFieldPolicy = {
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	gamerId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	orderDate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	vouchers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RootCode_ProductVoucherKeySpecifier = ('voucherCode' | 'voucherExpiry' | 'voucherPin' | 'voucherSerial' | RootCode_ProductVoucherKeySpecifier)[];
export type RootCode_ProductVoucherFieldPolicy = {
	voucherCode?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherExpiry?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherPin?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherSerial?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RuleKeySpecifier = ('created' | 'description' | 'id' | 'name' | 'updated' | RuleKeySpecifier)[];
export type RuleFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SLTExternalSubscriptionPackageKeySpecifier = ('active' | 'costs' | 'dataQuota' | 'description' | 'id' | 'name' | 'packageId' | 'providerSubscriptionId' | 'subscriptionPartner' | 'subscriptionProvider' | 'subscriptionType' | 'subscriptionTypeId' | SLTExternalSubscriptionPackageKeySpecifier)[];
export type SLTExternalSubscriptionPackageFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	costs?: FieldPolicy<any> | FieldReadFunction<any>,
	dataQuota?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	packageId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerSubscriptionId?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionPartner?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionTypeId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SLTProviderAccountKeySpecifier = ('doNotRefreshUntil' | 'externalSubscriptionProviderAccountId' | 'id' | 'sltAccountId' | 'subscriptionProvider' | 'subscriptionProviderAccountState' | SLTProviderAccountKeySpecifier)[];
export type SLTProviderAccountFieldPolicy = {
	doNotRefreshUntil?: FieldPolicy<any> | FieldReadFunction<any>,
	externalSubscriptionProviderAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sltAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProviderAccountState?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SLTProviderExternalSubscriptionPackageKeySpecifier = ('active' | 'costs' | 'dataQuota' | 'defaultLocale' | 'description' | 'id' | 'localizedDescriptions' | 'localizedNames' | 'name' | 'packageId' | 'providerSubscriptionId' | 'subscriptionPartner' | 'subscriptionProvider' | 'subscriptionType' | 'subscriptionTypeId' | SLTProviderExternalSubscriptionPackageKeySpecifier)[];
export type SLTProviderExternalSubscriptionPackageFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	costs?: FieldPolicy<any> | FieldReadFunction<any>,
	dataQuota?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultLocale?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	localizedDescriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	localizedNames?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	packageId?: FieldPolicy<any> | FieldReadFunction<any>,
	providerSubscriptionId?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionPartner?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionTypeId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SegmentKeySpecifier = ('created' | 'description' | 'id' | 'name' | 'rules' | 'updated' | SegmentKeySpecifier)[];
export type SegmentFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	rules?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServerKeySpecifier = ('id' | 'ip' | 'maxNumberOfPlayers' | 'port' | 'rconPassword' | 'region' | 'serverType' | 'status' | 'timeAcquired' | 'timeDestroyed' | 'timeRequested' | ServerKeySpecifier)[];
export type ServerFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ip?: FieldPolicy<any> | FieldReadFunction<any>,
	maxNumberOfPlayers?: FieldPolicy<any> | FieldReadFunction<any>,
	port?: FieldPolicy<any> | FieldReadFunction<any>,
	rconPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	region?: FieldPolicy<any> | FieldReadFunction<any>,
	serverType?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	timeAcquired?: FieldPolicy<any> | FieldReadFunction<any>,
	timeDestroyed?: FieldPolicy<any> | FieldReadFunction<any>,
	timeRequested?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ServerDetailsKeySpecifier = ('password' | 'serverUrl' | ServerDetailsKeySpecifier)[];
export type ServerDetailsFieldPolicy = {
	password?: FieldPolicy<any> | FieldReadFunction<any>,
	serverUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionRequestResultKeySpecifier = ('gatewaySessionId' | 'transactionId' | SessionRequestResultKeySpecifier)[];
export type SessionRequestResultFieldPolicy = {
	gatewaySessionId?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShipmentKeySpecifier = ('shipmentAddress' | 'shipmentDate' | 'shipmentId' | 'shipmentMethod' | ShipmentKeySpecifier)[];
export type ShipmentFieldPolicy = {
	shipmentAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	shipmentDate?: FieldPolicy<any> | FieldReadFunction<any>,
	shipmentId?: FieldPolicy<any> | FieldReadFunction<any>,
	shipmentMethod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SingleDimensionResultKeySpecifier = ('dimensionId' | 'value' | SingleDimensionResultKeySpecifier)[];
export type SingleDimensionResultFieldPolicy = {
	dimensionId?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SingleEliminationSpecificDetailsKeySpecifier = ('id' | 'maybeMaxRoundParticipants' | 'maybeParticipantsInRound' | 'tournamentFormat' | SingleEliminationSpecificDetailsKeySpecifier)[];
export type SingleEliminationSpecificDetailsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeMaxRoundParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeParticipantsInRound?: FieldPolicy<any> | FieldReadFunction<any>,
	tournamentFormat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SocialLinkKeySpecifier = ('link' | 'socialLinkType' | SocialLinkKeySpecifier)[];
export type SocialLinkFieldPolicy = {
	link?: FieldPolicy<any> | FieldReadFunction<any>,
	socialLinkType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpecificSubscriptionPrizeConditionKeySpecifier = ('description' | 'id' | 'order' | 'prize' | 'subscriptionTypeId' | 'variablePrizeConditionType' | SpecificSubscriptionPrizeConditionKeySpecifier)[];
export type SpecificSubscriptionPrizeConditionFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	prize?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	variablePrizeConditionType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StoreMerchantPaymentMethodKeySpecifier = ('cancelScheduledPaymentSupported' | 'disabled' | 'id' | 'imageUrl' | 'name' | 'paymentMethodType' | 'recurringPaymentSupported' | 'refundSupported' | StoreMerchantPaymentMethodKeySpecifier)[];
export type StoreMerchantPaymentMethodFieldPolicy = {
	cancelScheduledPaymentSupported?: FieldPolicy<any> | FieldReadFunction<any>,
	disabled?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodType?: FieldPolicy<any> | FieldReadFunction<any>,
	recurringPaymentSupported?: FieldPolicy<any> | FieldReadFunction<any>,
	refundSupported?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StreamKeySpecifier = ('id' | 'url' | StreamKeySpecifier)[];
export type StreamFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StreamingEventKeySpecifier = ('created' | 'defaultMessage' | 'expiry' | 'id' | 'notificationType' | StreamingEventKeySpecifier)[];
export type StreamingEventFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	expiry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StreamsKeySpecifier = ('expiry' | 'id' | 'mediaType' | 'providerIdentifier' | 'status' | 'streamType' | 'streamUrl' | 'weight' | StreamsKeySpecifier)[];
export type StreamsFieldPolicy = {
	expiry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaType?: FieldPolicy<any> | FieldReadFunction<any>,
	providerIdentifier?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	streamType?: FieldPolicy<any> | FieldReadFunction<any>,
	streamUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StringAttributeKeySpecifier = ('isError' | 'value' | StringAttributeKeySpecifier)[];
export type StringAttributeFieldPolicy = {
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StringAttributeWithPossibleErrorKeySpecifier = ('isError' | StringAttributeWithPossibleErrorKeySpecifier)[];
export type StringAttributeWithPossibleErrorFieldPolicy = {
	isError?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionKeySpecifier = ('AccountNotification' | 'ClientNotification' | SubscriptionKeySpecifier)[];
export type SubscriptionFieldPolicy = {
	AccountNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	ClientNotification?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionPrizeConditionKeySpecifier = ('description' | 'id' | 'order' | 'prize' | 'variablePrizeConditionType' | SubscriptionPrizeConditionKeySpecifier)[];
export type SubscriptionPrizeConditionFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	prize?: FieldPolicy<any> | FieldReadFunction<any>,
	variablePrizeConditionType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionProviderAccountKeySpecifier = ('externalSubscriptionProviderAccountId' | 'id' | 'subscriptionProvider' | 'subscriptionProviderAccountState' | SubscriptionProviderAccountKeySpecifier)[];
export type SubscriptionProviderAccountFieldPolicy = {
	externalSubscriptionProviderAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProviderAccountState?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionTypeKeySpecifier = ('conflictSubscriptionTypeIds' | 'defaultLocale' | 'description' | 'enrollable' | 'explicitEnrollment' | 'id' | 'implicitEnrollments' | 'initialSwarmioCurrencyReward' | 'localizedDescriptions' | 'localizedNames' | 'name' | 'recurringPayoutBonus' | 'weight' | SubscriptionTypeKeySpecifier)[];
export type SubscriptionTypeFieldPolicy = {
	conflictSubscriptionTypeIds?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultLocale?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	enrollable?: FieldPolicy<any> | FieldReadFunction<any>,
	explicitEnrollment?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	implicitEnrollments?: FieldPolicy<any> | FieldReadFunction<any>,
	initialSwarmioCurrencyReward?: FieldPolicy<any> | FieldReadFunction<any>,
	localizedDescriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	localizedNames?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	recurringPayoutBonus?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SupplierKeySpecifier = ('configuration' | 'contact' | 'createdBy' | 'createdDate' | 'creditLimit' | 'endpointUrl' | 'id' | 'isActive' | 'isDeleted' | 'itemCount' | 'job' | 'productCount' | 'products' | 'supplierId' | 'supplierMainType' | 'supplierName' | SupplierKeySpecifier)[];
export type SupplierFieldPolicy = {
	configuration?: FieldPolicy<any> | FieldReadFunction<any>,
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creditLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	endpointUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	itemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	job?: FieldPolicy<any> | FieldReadFunction<any>,
	productCount?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierId?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierMainType?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SupplierConfigurationKeySpecifier = ('config' | 'createdDate' | 'id' | 'modifiedDate' | 'name' | 'supplierType' | SupplierConfigurationKeySpecifier)[];
export type SupplierConfigurationFieldPolicy = {
	config?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	supplierType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyKeySpecifier = ('active' | 'cashable' | 'id' | 'name' | 'prettyName' | SwarmioCurrencyKeySpecifier)[];
export type SwarmioCurrencyFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	cashable?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	prettyName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyExchangeBlockKeySpecifier = ('active' | 'created' | 'description' | 'forThisAmount' | 'forThisSwarmioCurrency' | 'forThisSwarmioCurrencyId' | 'id' | 'name' | 'thisAmount' | 'thisSwarmioCurrency' | 'thisSwarmioCurrencyId' | SwarmioCurrencyExchangeBlockKeySpecifier)[];
export type SwarmioCurrencyExchangeBlockFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	forThisAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	forThisSwarmioCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	forThisSwarmioCurrencyId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	thisAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	thisSwarmioCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	thisSwarmioCurrencyId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyFixedPrizePayoutReceiptKeySpecifier = ('accountId' | 'amount' | 'created' | 'id' | 'notes' | 'prizePayoutReceiptType' | 'prizeTierId' | 'successful' | 'swarmioCurrencyId' | SwarmioCurrencyFixedPrizePayoutReceiptKeySpecifier)[];
export type SwarmioCurrencyFixedPrizePayoutReceiptFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	prizePayoutReceiptType?: FieldPolicy<any> | FieldReadFunction<any>,
	prizeTierId?: FieldPolicy<any> | FieldReadFunction<any>,
	successful?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyItemKeySpecifier = ('active' | 'amount' | 'costs' | 'created' | 'dealTagline' | 'id' | 'name' | 'swarmioCurrency' | 'swarmioCurrencyId' | SwarmioCurrencyItemKeySpecifier)[];
export type SwarmioCurrencyItemFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	costs?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	dealTagline?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyItemCostKeySpecifier = ('cost' | 'created' | 'currencyItem' | 'currencyItemCostType' | 'id' | 'realWorldCurrencyType' | 'swarmioCurrencyItemId' | 'version' | SwarmioCurrencyItemCostKeySpecifier)[];
export type SwarmioCurrencyItemCostFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyItem?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyItemCostType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	realWorldCurrencyType?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyItemCostArchiveKeySpecifier = ('cost' | 'created' | 'currencyItem' | 'currencyItemCostType' | 'id' | 'realWorldCurrencyType' | 'swarmioCurrencyItemId' | 'version' | SwarmioCurrencyItemCostArchiveKeySpecifier)[];
export type SwarmioCurrencyItemCostArchiveFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyItem?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyItemCostType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	realWorldCurrencyType?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyItemCostPurchaseRequestKeySpecifier = ('created' | 'id' | 'requesterId' | 'swarmioCurrencyItemCostArchive' | 'swarmioCurrencyItemCostArchiveId' | SwarmioCurrencyItemCostPurchaseRequestKeySpecifier)[];
export type SwarmioCurrencyItemCostPurchaseRequestFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	requesterId?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyItemCostArchive?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyItemCostArchiveId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyPayoutKeySpecifier = ('active' | 'amount' | 'costs' | 'created' | 'id' | 'name' | 'swarmioCurrency' | 'swarmioCurrencyId' | SwarmioCurrencyPayoutKeySpecifier)[];
export type SwarmioCurrencyPayoutFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	costs?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyPayoutCostKeySpecifier = ('cost' | 'created' | 'id' | 'realWorldCurrencyType' | 'swarmioCurrencyPayout' | 'swarmioCurrencyPayoutId' | 'version' | SwarmioCurrencyPayoutCostKeySpecifier)[];
export type SwarmioCurrencyPayoutCostFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	realWorldCurrencyType?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyPayout?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyPayoutId?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyPayoutCostArchiveKeySpecifier = ('cost' | 'created' | 'id' | 'realWorldCurrencyType' | 'swarmioCurrencyPayout' | 'swarmioCurrencyPayoutId' | 'version' | SwarmioCurrencyPayoutCostArchiveKeySpecifier)[];
export type SwarmioCurrencyPayoutCostArchiveFieldPolicy = {
	cost?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	realWorldCurrencyType?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyPayout?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyPayoutId?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyPayoutPrizeKeySpecifier = ('amount' | 'id' | 'prizeType' | 'swarmioCurrencyId' | SwarmioCurrencyPayoutPrizeKeySpecifier)[];
export type SwarmioCurrencyPayoutPrizeFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	prizeType?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyPayoutRequestKeySpecifier = ('completed' | 'completedBy' | 'dateCompleted' | 'dateRequested' | 'id' | 'requesterId' | 'swarmioCurrencyPayoutArchiveCost' | 'swarmioCurrencyPayoutCostArchiveId' | SwarmioCurrencyPayoutRequestKeySpecifier)[];
export type SwarmioCurrencyPayoutRequestFieldPolicy = {
	completed?: FieldPolicy<any> | FieldReadFunction<any>,
	completedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	dateCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	dateRequested?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	requesterId?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyPayoutArchiveCost?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyPayoutCostArchiveId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioCurrencyRewardKeySpecifier = ('amount' | 'id' | 'swarmioCurrencyId' | SwarmioCurrencyRewardKeySpecifier)[];
export type SwarmioCurrencyRewardFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioItemKeySpecifier = ('active' | 'catalogIds' | 'categoryIds' | 'contentType' | 'costs' | 'description' | 'externalSKU' | 'fields' | 'id' | 'images' | 'name' | 'productOrigin' | 'productType' | 'provisioner' | 'stock' | SwarmioItemKeySpecifier)[];
export type SwarmioItemFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	catalogIds?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryIds?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	costs?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	externalSKU?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	productOrigin?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	provisioner?: FieldPolicy<any> | FieldReadFunction<any>,
	stock?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioPayPaymentKeySpecifier = ('dateReceived' | 'destinationService' | 'id' | 'internalTransactionId' | 'isValid' | 'itemId' | 'paymentProviderTransactionId' | 'paymentStatus' | 'paymentType' | 'receivedAmount' | 'receivedCurrency' | 'requestedAmount' | 'requestedCurrency' | SwarmioPayPaymentKeySpecifier)[];
export type SwarmioPayPaymentFieldPolicy = {
	dateReceived?: FieldPolicy<any> | FieldReadFunction<any>,
	destinationService?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	internalTransactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	isValid?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentProviderTransactionId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentType?: FieldPolicy<any> | FieldReadFunction<any>,
	receivedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	receivedCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedCurrency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioSubscriptionKeySpecifier = ('expiry' | 'id' | 'isUsable' | 'secret' | 'subscriptionImplementation' | 'subscriptionState' | 'subscriptionType' | 'subscriptionTypeId' | SwarmioSubscriptionKeySpecifier)[];
export type SwarmioSubscriptionFieldPolicy = {
	expiry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isUsable?: FieldPolicy<any> | FieldReadFunction<any>,
	secret?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionImplementation?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionState?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionType?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionTypeId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioVoucherKeySpecifier = ('code' | 'expirationDate' | 'id' | 'issueDate' | 'voucherType' | SwarmioVoucherKeySpecifier)[];
export type SwarmioVoucherFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	expirationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioWalletKeySpecifier = ('balance' | 'boughtTransactions' | 'cashOutTransactions' | 'created' | 'exchangedTransactions' | 'freebieTransactions' | 'id' | 'ownerId' | 'swarmioCurrency' | 'swarmioCurrencyId' | 'transactions' | 'transferTransactions' | SwarmioWalletKeySpecifier)[];
export type SwarmioWalletFieldPolicy = {
	balance?: FieldPolicy<any> | FieldReadFunction<any>,
	boughtTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	cashOutTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	exchangedTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	freebieTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	swarmioCurrencyId?: FieldPolicy<any> | FieldReadFunction<any>,
	transactions?: FieldPolicy<any> | FieldReadFunction<any>,
	transferTransactions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SwarmioWalletTransactionWithMetadataKeySpecifier = ('amount' | 'created' | 'id' | 'transactionType' | 'wallet' | 'walletId' | SwarmioWalletTransactionWithMetadataKeySpecifier)[];
export type SwarmioWalletTransactionWithMetadataFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionType?: FieldPolicy<any> | FieldReadFunction<any>,
	wallet?: FieldPolicy<any> | FieldReadFunction<any>,
	walletId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagKeySpecifier = ('localizations' | 'name' | TagKeySpecifier)[];
export type TagFieldPolicy = {
	localizations?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetCurrencyPriceKeySpecifier = ('currency' | 'dealPrice' | 'dealTagId' | 'price' | 'tagId' | TargetCurrencyPriceKeySpecifier)[];
export type TargetCurrencyPriceFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	dealTagId?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	tagId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TargetCurrencyPricesKeySpecifier = ('currency' | 'dealPrice' | 'dealTagId' | 'price' | 'tagId' | TargetCurrencyPricesKeySpecifier)[];
export type TargetCurrencyPricesFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	dealPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	dealTagId?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	tagId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TeamKeySpecifier = ('accountInvites' | 'accountType' | 'avatarURL' | 'bannerURL' | 'created' | 'description' | 'eventParticipations' | 'groupInvites' | 'groupMembers' | 'groupMemberships' | 'groupType' | 'id' | 'isSupplier' | 'lastUpdated' | 'managedAccounts' | 'name' | 'otherFields' | 'ownerId' | 'payPurchaseTransactions' | 'publicURL' | 'purchaseTransactions' | 'socialLinks' | 'subscriptionProviderAccounts' | 'subscriptions' | 'updated' | 'wallets' | TeamKeySpecifier)[];
export type TeamFieldPolicy = {
	accountInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	accountType?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarURL?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerURL?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	eventParticipations?: FieldPolicy<any> | FieldReadFunction<any>,
	groupInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	groupMembers?: FieldPolicy<any> | FieldReadFunction<any>,
	groupMemberships?: FieldPolicy<any> | FieldReadFunction<any>,
	groupType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSupplier?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	managedAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	otherFields?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerId?: FieldPolicy<any> | FieldReadFunction<any>,
	payPurchaseTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	publicURL?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseTransactions?: FieldPolicy<any> | FieldReadFunction<any>,
	socialLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionProviderAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>,
	wallets?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TeamEventEntryRulesKeySpecifier = ('id' | 'maximumTeamMembers' | 'minimumTeamMembers' | TeamEventEntryRulesKeySpecifier)[];
export type TeamEventEntryRulesFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumTeamMembers?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumTeamMembers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TeamParticipantKeySpecifier = ('accountId' | 'confirmed' | 'created' | 'id' | 'participantType' | 'requirementsNotMet' | 'result' | 'team' | 'teamId' | 'teamMemberRequirementsNotMet' | 'teamMembers' | TeamParticipantKeySpecifier)[];
export type TeamParticipantFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	participantType?: FieldPolicy<any> | FieldReadFunction<any>,
	requirementsNotMet?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>,
	team?: FieldPolicy<any> | FieldReadFunction<any>,
	teamId?: FieldPolicy<any> | FieldReadFunction<any>,
	teamMemberRequirementsNotMet?: FieldPolicy<any> | FieldReadFunction<any>,
	teamMembers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TechnicalParticipantKeySpecifier = ('accountId' | 'id' | 'participant' | 'roles' | TechnicalParticipantKeySpecifier)[];
export type TechnicalParticipantFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	participant?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TournamentKeySpecifier = ('bracketModifications' | 'brackets' | 'competitionState' | 'competitionTiming' | 'competitionType' | 'created' | 'event' | 'eventId' | 'eventStageId' | 'game' | 'gameId' | 'gameSpecificDetails' | 'id' | 'isSimulated' | 'manualAdvancement' | 'numberOfRounds' | 'participantType' | 'participants' | 'phaseBufferTime' | 'tournamentFormat' | 'tournamentFormatSpecificDetails' | TournamentKeySpecifier)[];
export type TournamentFieldPolicy = {
	bracketModifications?: FieldPolicy<any> | FieldReadFunction<any>,
	brackets?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionState?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionTiming?: FieldPolicy<any> | FieldReadFunction<any>,
	competitionType?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	eventId?: FieldPolicy<any> | FieldReadFunction<any>,
	eventStageId?: FieldPolicy<any> | FieldReadFunction<any>,
	game?: FieldPolicy<any> | FieldReadFunction<any>,
	gameId?: FieldPolicy<any> | FieldReadFunction<any>,
	gameSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSimulated?: FieldPolicy<any> | FieldReadFunction<any>,
	manualAdvancement?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfRounds?: FieldPolicy<any> | FieldReadFunction<any>,
	participantType?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>,
	phaseBufferTime?: FieldPolicy<any> | FieldReadFunction<any>,
	tournamentFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	tournamentFormatSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TournamentBracketKeySpecifier = ('id' | 'isComplete' | 'name' | 'phases' | TournamentBracketKeySpecifier)[];
export type TournamentBracketFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phases?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TournamentMatchKeySpecifier = ('assets' | 'gameSpecificDetails' | 'id' | 'isComplete' | 'name' | 'startTime' | TournamentMatchKeySpecifier)[];
export type TournamentMatchFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	gameSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TournamentMatchByeKeySpecifier = ('assets' | 'gameSpecificDetails' | 'id' | 'isComplete' | 'name' | 'participants' | 'startTime' | TournamentMatchByeKeySpecifier)[];
export type TournamentMatchByeFieldPolicy = {
	assets?: FieldPolicy<any> | FieldReadFunction<any>,
	gameSpecificDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TournamentPhaseKeySpecifier = ('id' | 'isComplete' | 'matches' | 'phaseNumber' | TournamentPhaseKeySpecifier)[];
export type TournamentPhaseFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	matches?: FieldPolicy<any> | FieldReadFunction<any>,
	phaseNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TournamentRoundKeySpecifier = ('id' | 'isComplete' | 'participants' | 'roundNumber' | TournamentRoundKeySpecifier)[];
export type TournamentRoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>,
	roundNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TournamentSpecificDetailsKeySpecifier = ('id' | 'maybeMaxRoundParticipants' | 'maybeParticipantsInRound' | 'tournamentFormat' | TournamentSpecificDetailsKeySpecifier)[];
export type TournamentSpecificDetailsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeMaxRoundParticipants?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeParticipantsInRound?: FieldPolicy<any> | FieldReadFunction<any>,
	tournamentFormat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransferTransactionKeySpecifier = ('amount' | 'created' | 'id' | 'notes' | 'otherWalletId' | 'transactionType' | 'wallet' | 'walletId' | TransferTransactionKeySpecifier)[];
export type TransferTransactionFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	otherWalletId?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionType?: FieldPolicy<any> | FieldReadFunction<any>,
	wallet?: FieldPolicy<any> | FieldReadFunction<any>,
	walletId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TwitchStreamKeySpecifier = ('id' | 'url' | 'username' | 'weight' | TwitchStreamKeySpecifier)[];
export type TwitchStreamFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnappliedPaymentKeySpecifier = ('amount' | 'currency' | 'id' | 'notes' | 'received' | 'state' | UnappliedPaymentKeySpecifier)[];
export type UnappliedPaymentFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	received?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnreadyIndividualParticipantKeySpecifier = ('accountId' | 'confirmed' | 'created' | 'id' | 'inviteLink' | 'maybeGameAccountId' | 'participantType' | 'person' | 'requirementsNotMet' | 'result' | UnreadyIndividualParticipantKeySpecifier)[];
export type UnreadyIndividualParticipantFieldPolicy = {
	accountId?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteLink?: FieldPolicy<any> | FieldReadFunction<any>,
	maybeGameAccountId?: FieldPolicy<any> | FieldReadFunction<any>,
	participantType?: FieldPolicy<any> | FieldReadFunction<any>,
	person?: FieldPolicy<any> | FieldReadFunction<any>,
	requirementsNotMet?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpcomingKingOfTheHillParticipantKeySpecifier = ('display' | 'expectedStartTime' | 'order' | 'participant' | UpcomingKingOfTheHillParticipantKeySpecifier)[];
export type UpcomingKingOfTheHillParticipantFieldPolicy = {
	display?: FieldPolicy<any> | FieldReadFunction<any>,
	expectedStartTime?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	participant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateDisabledPaymentChannelResponseKeySpecifier = ('disabledPaymentChannels' | 'itemId' | 'partnerId' | 'paymentType' | UpdateDisabledPaymentChannelResponseKeySpecifier)[];
export type UpdateDisabledPaymentChannelResponseFieldPolicy = {
	disabledPaymentChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateHiveContactRequestKeySpecifier = ('contact' | 'contactType' | 'isError' | 'newContact' | 'verified' | UpdateHiveContactRequestKeySpecifier)[];
export type UpdateHiveContactRequestFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contactType?: FieldPolicy<any> | FieldReadFunction<any>,
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	newContact?: FieldPolicy<any> | FieldReadFunction<any>,
	verified?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePartnerItemPaymentChannelResponseKeySpecifier = ('itemId' | 'partnerId' | 'updatedPartnerItemPaymentChannels' | UpdatePartnerItemPaymentChannelResponseKeySpecifier)[];
export type UpdatePartnerItemPaymentChannelResponseFieldPolicy = {
	itemId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedPartnerItemPaymentChannels?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatedPartnerItemPaymentChannelResponseKeySpecifier = ('channelId' | 'channelName' | 'isEnabled' | 'markedUpPercentage' | UpdatedPartnerItemPaymentChannelResponseKeySpecifier)[];
export type UpdatedPartnerItemPaymentChannelResponseFieldPolicy = {
	channelId?: FieldPolicy<any> | FieldReadFunction<any>,
	channelName?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	markedUpPercentage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadTraitKeySpecifier = ('expiry' | 'id' | 'mediaType' | 'weight' | UploadTraitKeySpecifier)[];
export type UploadTraitFieldPolicy = {
	expiry?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaType?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('accountManagers' | 'accountType' | 'avatarURL' | 'bannerURL' | 'contactIdentifier' | 'created' | 'description' | 'displayName' | 'email' | 'emailContact' | 'emailVerified' | 'groupInvites' | 'groupMemberships' | 'hasValidContact' | 'id' | 'managedAccounts' | 'msisdn' | 'msisdnContact' | 'msisdnVerified' | 'otherFields' | 'publicURL' | 'socialLinks' | 'updated' | 'userType' | 'wallets' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	accountManagers?: FieldPolicy<any> | FieldReadFunction<any>,
	accountType?: FieldPolicy<any> | FieldReadFunction<any>,
	avatarURL?: FieldPolicy<any> | FieldReadFunction<any>,
	bannerURL?: FieldPolicy<any> | FieldReadFunction<any>,
	contactIdentifier?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	emailContact?: FieldPolicy<any> | FieldReadFunction<any>,
	emailVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	groupInvites?: FieldPolicy<any> | FieldReadFunction<any>,
	groupMemberships?: FieldPolicy<any> | FieldReadFunction<any>,
	hasValidContact?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	managedAccounts?: FieldPolicy<any> | FieldReadFunction<any>,
	msisdn?: FieldPolicy<any> | FieldReadFunction<any>,
	msisdnContact?: FieldPolicy<any> | FieldReadFunction<any>,
	msisdnVerified?: FieldPolicy<any> | FieldReadFunction<any>,
	otherFields?: FieldPolicy<any> | FieldReadFunction<any>,
	publicURL?: FieldPolicy<any> | FieldReadFunction<any>,
	socialLinks?: FieldPolicy<any> | FieldReadFunction<any>,
	updated?: FieldPolicy<any> | FieldReadFunction<any>,
	userType?: FieldPolicy<any> | FieldReadFunction<any>,
	wallets?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ValorantCompetitionDetailsKeySpecifier = ('gameId' | 'matchType' | ValorantCompetitionDetailsKeySpecifier)[];
export type ValorantCompetitionDetailsFieldPolicy = {
	gameId?: FieldPolicy<any> | FieldReadFunction<any>,
	matchType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VariablePrizeKeySpecifier = ('conditionalPrizes' | 'defaultPrize' | 'id' | 'prizeType' | VariablePrizeKeySpecifier)[];
export type VariablePrizeFieldPolicy = {
	conditionalPrizes?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultPrize?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	prizeType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VariablePrizeConditionKeySpecifier = ('description' | 'id' | 'order' | 'prize' | 'variablePrizeConditionType' | VariablePrizeConditionKeySpecifier)[];
export type VariablePrizeConditionFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	prize?: FieldPolicy<any> | FieldReadFunction<any>,
	variablePrizeConditionType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VerifiedHiveContactKeySpecifier = ('contact' | 'contactType' | 'isError' | 'verified' | VerifiedHiveContactKeySpecifier)[];
export type VerifiedHiveContactFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contactType?: FieldPolicy<any> | FieldReadFunction<any>,
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	verified?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherKeySpecifier = ('expirationDate' | 'pin' | 'serial' | 'voucherId' | VoucherKeySpecifier)[];
export type VoucherFieldPolicy = {
	expirationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	pin?: FieldPolicy<any> | FieldReadFunction<any>,
	serial?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherInventoryKeySpecifier = ('batchId' | 'createdDate' | 'currency' | 'id' | 'modifiedDate' | 'status' | 'stockCount' | 'unitPrice' | VoucherInventoryKeySpecifier)[];
export type VoucherInventoryFieldPolicy = {
	batchId?: FieldPolicy<any> | FieldReadFunction<any>,
	createdDate?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	stockCount?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WithUnverifiedHiveContactKeySpecifier = ('contact' | 'contactType' | 'isError' | 'newContact' | 'verified' | WithUnverifiedHiveContactKeySpecifier)[];
export type WithUnverifiedHiveContactFieldPolicy = {
	contact?: FieldPolicy<any> | FieldReadFunction<any>,
	contactType?: FieldPolicy<any> | FieldReadFunction<any>,
	isError?: FieldPolicy<any> | FieldReadFunction<any>,
	newContact?: FieldPolicy<any> | FieldReadFunction<any>,
	verified?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YouTubeStreamKeySpecifier = ('channelId' | 'id' | 'url' | 'weight' | YouTubeStreamKeySpecifier)[];
export type YouTubeStreamFieldPolicy = {
	channelId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YouTubeVideoKeySpecifier = ('id' | 'url' | 'videoId' | 'weight' | YouTubeVideoKeySpecifier)[];
export type YouTubeVideoFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	videoId?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cms_bannersAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | cms_bannersAccessKeySpecifier)[];
export type cms_bannersAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cms_bannersDocAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | cms_bannersDocAccessKeySpecifier)[];
export type cms_bannersDocAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cms_blog_pagesAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | cms_blog_pagesAccessKeySpecifier)[];
export type cms_blog_pagesAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cms_blog_pagesDocAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | cms_blog_pagesDocAccessKeySpecifier)[];
export type cms_blog_pagesDocAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cms_blog_postsAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | cms_blog_postsAccessKeySpecifier)[];
export type cms_blog_postsAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cms_blog_postsDocAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | cms_blog_postsDocAccessKeySpecifier)[];
export type cms_blog_postsDocAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cms_gamersAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | cms_gamersAccessKeySpecifier)[];
export type cms_gamersAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cms_gamersDocAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | cms_gamersDocAccessKeySpecifier)[];
export type cms_gamersDocAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cms_gamesAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | cms_gamesAccessKeySpecifier)[];
export type cms_gamesAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cms_gamesDocAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | cms_gamesDocAccessKeySpecifier)[];
export type cms_gamesDocAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cms_mediaAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | cms_mediaAccessKeySpecifier)[];
export type cms_mediaAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type cms_mediaDocAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | cms_mediaDocAccessKeySpecifier)[];
export type cms_mediaDocAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type countCmsBannersKeySpecifier = ('totalDocs' | countCmsBannersKeySpecifier)[];
export type countCmsBannersFieldPolicy = {
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type countCmsBlogPagesKeySpecifier = ('totalDocs' | countCmsBlogPagesKeySpecifier)[];
export type countCmsBlogPagesFieldPolicy = {
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type countCmsBlogPostsKeySpecifier = ('totalDocs' | countCmsBlogPostsKeySpecifier)[];
export type countCmsBlogPostsFieldPolicy = {
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type countCmsGamersKeySpecifier = ('totalDocs' | countCmsGamersKeySpecifier)[];
export type countCmsGamersFieldPolicy = {
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type countCmsGamesKeySpecifier = ('totalDocs' | countCmsGamesKeySpecifier)[];
export type countCmsGamesFieldPolicy = {
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type countCmsMediasKeySpecifier = ('totalDocs' | countCmsMediasKeySpecifier)[];
export type countCmsMediasFieldPolicy = {
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type countCmsUsersKeySpecifier = ('totalDocs' | countCmsUsersKeySpecifier)[];
export type countCmsUsersFieldPolicy = {
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type countPayloadLockedDocumentsKeySpecifier = ('totalDocs' | countPayloadLockedDocumentsKeySpecifier)[];
export type countPayloadLockedDocumentsFieldPolicy = {
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type countPayloadPreferencesKeySpecifier = ('totalDocs' | countPayloadPreferencesKeySpecifier)[];
export type countPayloadPreferencesFieldPolicy = {
	totalDocs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type partnerDataForItemKeySpecifier = ('id' | 'isPartnerMappedToItem' | 'partnerId' | 'partnerName' | partnerDataForItemKeySpecifier)[];
export type partnerDataForItemFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPartnerMappedToItem?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerId?: FieldPolicy<any> | FieldReadFunction<any>,
	partnerName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payload_locked_documentsAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | payload_locked_documentsAccessKeySpecifier)[];
export type payload_locked_documentsAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payload_locked_documentsDocAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | payload_locked_documentsDocAccessKeySpecifier)[];
export type payload_locked_documentsDocAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payload_preferencesAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | payload_preferencesAccessKeySpecifier)[];
export type payload_preferencesAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type payload_preferencesDocAccessKeySpecifier = ('create' | 'delete' | 'fields' | 'read' | 'update' | payload_preferencesDocAccessKeySpecifier)[];
export type payload_preferencesDocAccessFieldPolicy = {
	create?: FieldPolicy<any> | FieldReadFunction<any>,
	delete?: FieldPolicy<any> | FieldReadFunction<any>,
	fields?: FieldPolicy<any> | FieldReadFunction<any>,
	read?: FieldPolicy<any> | FieldReadFunction<any>,
	update?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	Access?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccessKeySpecifier | (() => undefined | AccessKeySpecifier),
		fields?: AccessFieldPolicy,
	},
	Account?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountKeySpecifier | (() => undefined | AccountKeySpecifier),
		fields?: AccountFieldPolicy,
	},
	AccountInvite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountInviteKeySpecifier | (() => undefined | AccountInviteKeySpecifier),
		fields?: AccountInviteFieldPolicy,
	},
	AccountInviteWithPossibleError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountInviteWithPossibleErrorKeySpecifier | (() => undefined | AccountInviteWithPossibleErrorKeySpecifier),
		fields?: AccountInviteWithPossibleErrorFieldPolicy,
	},
	AccountManager?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountManagerKeySpecifier | (() => undefined | AccountManagerKeySpecifier),
		fields?: AccountManagerFieldPolicy,
	},
	AccountManagerWithPossibleError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountManagerWithPossibleErrorKeySpecifier | (() => undefined | AccountManagerWithPossibleErrorKeySpecifier),
		fields?: AccountManagerWithPossibleErrorFieldPolicy,
	},
	AccountNotification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountNotificationKeySpecifier | (() => undefined | AccountNotificationKeySpecifier),
		fields?: AccountNotificationFieldPolicy,
	},
	AccountNotificationEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountNotificationEventKeySpecifier | (() => undefined | AccountNotificationEventKeySpecifier),
		fields?: AccountNotificationEventFieldPolicy,
	},
	AccountProjection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountProjectionKeySpecifier | (() => undefined | AccountProjectionKeySpecifier),
		fields?: AccountProjectionFieldPolicy,
	},
	AccountTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountTagKeySpecifier | (() => undefined | AccountTagKeySpecifier),
		fields?: AccountTagFieldPolicy,
	},
	ActionNotAllowedError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActionNotAllowedErrorKeySpecifier | (() => undefined | ActionNotAllowedErrorKeySpecifier),
		fields?: ActionNotAllowedErrorFieldPolicy,
	},
	AdditionalInformation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdditionalInformationKeySpecifier | (() => undefined | AdditionalInformationKeySpecifier),
		fields?: AdditionalInformationFieldPolicy,
	},
	AdvanceStrategy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AdvanceStrategyKeySpecifier | (() => undefined | AdvanceStrategyKeySpecifier),
		fields?: AdvanceStrategyFieldPolicy,
	},
	AllServHealthCheck?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AllServHealthCheckKeySpecifier | (() => undefined | AllServHealthCheckKeySpecifier),
		fields?: AllServHealthCheckFieldPolicy,
	},
	ApplicationConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ApplicationConfigKeySpecifier | (() => undefined | ApplicationConfigKeySpecifier),
		fields?: ApplicationConfigFieldPolicy,
	},
	AtLeastPlacementAdvanceStrategy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AtLeastPlacementAdvanceStrategyKeySpecifier | (() => undefined | AtLeastPlacementAdvanceStrategyKeySpecifier),
		fields?: AtLeastPlacementAdvanceStrategyFieldPolicy,
	},
	AutomaticallyVerifiedResultsForRoundFromParticipant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AutomaticallyVerifiedResultsForRoundFromParticipantKeySpecifier | (() => undefined | AutomaticallyVerifiedResultsForRoundFromParticipantKeySpecifier),
		fields?: AutomaticallyVerifiedResultsForRoundFromParticipantFieldPolicy,
	},
	Banner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BannerKeySpecifier | (() => undefined | BannerKeySpecifier),
		fields?: BannerFieldPolicy,
	},
	BaseEventTeamMember?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BaseEventTeamMemberKeySpecifier | (() => undefined | BaseEventTeamMemberKeySpecifier),
		fields?: BaseEventTeamMemberFieldPolicy,
	},
	BasicAutomaticallyVerifiedResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BasicAutomaticallyVerifiedResultKeySpecifier | (() => undefined | BasicAutomaticallyVerifiedResultKeySpecifier),
		fields?: BasicAutomaticallyVerifiedResultFieldPolicy,
	},
	BasicResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BasicResultKeySpecifier | (() => undefined | BasicResultKeySpecifier),
		fields?: BasicResultFieldPolicy,
	},
	BattleRoyaleSpecificDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BattleRoyaleSpecificDetailsKeySpecifier | (() => undefined | BattleRoyaleSpecificDetailsKeySpecifier),
		fields?: BattleRoyaleSpecificDetailsFieldPolicy,
	},
	BeedlePayment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BeedlePaymentKeySpecifier | (() => undefined | BeedlePaymentKeySpecifier),
		fields?: BeedlePaymentFieldPolicy,
	},
	Bots?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BotsKeySpecifier | (() => undefined | BotsKeySpecifier),
		fields?: BotsFieldPolicy,
	},
	BoughtTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BoughtTransactionKeySpecifier | (() => undefined | BoughtTransactionKeySpecifier),
		fields?: BoughtTransactionFieldPolicy,
	},
	BracketModifications?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BracketModificationsKeySpecifier | (() => undefined | BracketModificationsKeySpecifier),
		fields?: BracketModificationsFieldPolicy,
	},
	BreakStrategy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BreakStrategyKeySpecifier | (() => undefined | BreakStrategyKeySpecifier),
		fields?: BreakStrategyFieldPolicy,
	},
	BucketDimensionsMap?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BucketDimensionsMapKeySpecifier | (() => undefined | BucketDimensionsMapKeySpecifier),
		fields?: BucketDimensionsMapFieldPolicy,
	},
	BucketMultipliers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BucketMultipliersKeySpecifier | (() => undefined | BucketMultipliersKeySpecifier),
		fields?: BucketMultipliersFieldPolicy,
	},
	CSGOCompetitionDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CSGOCompetitionDetailsKeySpecifier | (() => undefined | CSGOCompetitionDetailsKeySpecifier),
		fields?: CSGOCompetitionDetailsFieldPolicy,
	},
	CSGOMatchDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CSGOMatchDetailsKeySpecifier | (() => undefined | CSGOMatchDetailsKeySpecifier),
		fields?: CSGOMatchDetailsFieldPolicy,
	},
	CSVFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CSVFileKeySpecifier | (() => undefined | CSVFileKeySpecifier),
		fields?: CSVFileFieldPolicy,
	},
	CashOutTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CashOutTransactionKeySpecifier | (() => undefined | CashOutTransactionKeySpecifier),
		fields?: CashOutTransactionFieldPolicy,
	},
	Catalog?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CatalogKeySpecifier | (() => undefined | CatalogKeySpecifier),
		fields?: CatalogFieldPolicy,
	},
	CatalogItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CatalogItemKeySpecifier | (() => undefined | CatalogItemKeySpecifier),
		fields?: CatalogItemFieldPolicy,
	},
	CatalogItemDeal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CatalogItemDealKeySpecifier | (() => undefined | CatalogItemDealKeySpecifier),
		fields?: CatalogItemDealFieldPolicy,
	},
	CatalogMappingDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CatalogMappingDtoKeySpecifier | (() => undefined | CatalogMappingDtoKeySpecifier),
		fields?: CatalogMappingDtoFieldPolicy,
	},
	Category?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryKeySpecifier | (() => undefined | CategoryKeySpecifier),
		fields?: CategoryFieldPolicy,
	},
	CategoryCatalog?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryCatalogKeySpecifier | (() => undefined | CategoryCatalogKeySpecifier),
		fields?: CategoryCatalogFieldPolicy,
	},
	CategoryCatalogResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryCatalogResponseKeySpecifier | (() => undefined | CategoryCatalogResponseKeySpecifier),
		fields?: CategoryCatalogResponseFieldPolicy,
	},
	CategoryDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryDtoKeySpecifier | (() => undefined | CategoryDtoKeySpecifier),
		fields?: CategoryDtoFieldPolicy,
	},
	CategoryInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryInfoKeySpecifier | (() => undefined | CategoryInfoKeySpecifier),
		fields?: CategoryInfoFieldPolicy,
	},
	CategoryLanguage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryLanguageKeySpecifier | (() => undefined | CategoryLanguageKeySpecifier),
		fields?: CategoryLanguageFieldPolicy,
	},
	CategoryLanguageDataResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryLanguageDataResponseKeySpecifier | (() => undefined | CategoryLanguageDataResponseKeySpecifier),
		fields?: CategoryLanguageDataResponseFieldPolicy,
	},
	CategoryLanguageDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryLanguageDetailsKeySpecifier | (() => undefined | CategoryLanguageDetailsKeySpecifier),
		fields?: CategoryLanguageDetailsFieldPolicy,
	},
	CategoryProductGroupResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryProductGroupResponseKeySpecifier | (() => undefined | CategoryProductGroupResponseKeySpecifier),
		fields?: CategoryProductGroupResponseFieldPolicy,
	},
	CategoryResponseData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryResponseDataKeySpecifier | (() => undefined | CategoryResponseDataKeySpecifier),
		fields?: CategoryResponseDataFieldPolicy,
	},
	Challenge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChallengeKeySpecifier | (() => undefined | ChallengeKeySpecifier),
		fields?: ChallengeFieldPolicy,
	},
	ChallengeSpecificDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChallengeSpecificDetailsKeySpecifier | (() => undefined | ChallengeSpecificDetailsKeySpecifier),
		fields?: ChallengeSpecificDetailsFieldPolicy,
	},
	ClientNotificationEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientNotificationEventKeySpecifier | (() => undefined | ClientNotificationEventKeySpecifier),
		fields?: ClientNotificationEventFieldPolicy,
	},
	ClientVisibleError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ClientVisibleErrorKeySpecifier | (() => undefined | ClientVisibleErrorKeySpecifier),
		fields?: ClientVisibleErrorFieldPolicy,
	},
	CmsBanner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannerKeySpecifier | (() => undefined | CmsBannerKeySpecifier),
		fields?: CmsBannerFieldPolicy,
	},
	CmsBanners?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersKeySpecifier | (() => undefined | CmsBannersKeySpecifier),
		fields?: CmsBannersFieldPolicy,
	},
	CmsBannersCreateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersCreateAccessKeySpecifier | (() => undefined | CmsBannersCreateAccessKeySpecifier),
		fields?: CmsBannersCreateAccessFieldPolicy,
	},
	CmsBannersCreateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersCreateDocAccessKeySpecifier | (() => undefined | CmsBannersCreateDocAccessKeySpecifier),
		fields?: CmsBannersCreateDocAccessFieldPolicy,
	},
	CmsBannersDeleteAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDeleteAccessKeySpecifier | (() => undefined | CmsBannersDeleteAccessKeySpecifier),
		fields?: CmsBannersDeleteAccessFieldPolicy,
	},
	CmsBannersDeleteDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDeleteDocAccessKeySpecifier | (() => undefined | CmsBannersDeleteDocAccessKeySpecifier),
		fields?: CmsBannersDeleteDocAccessFieldPolicy,
	},
	CmsBannersDocAccessFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFieldsKeySpecifier | (() => undefined | CmsBannersDocAccessFieldsKeySpecifier),
		fields?: CmsBannersDocAccessFieldsFieldPolicy,
	},
	CmsBannersDocAccessFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_createdAtKeySpecifier | (() => undefined | CmsBannersDocAccessFields_createdAtKeySpecifier),
		fields?: CmsBannersDocAccessFields_createdAtFieldPolicy,
	},
	CmsBannersDocAccessFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_createdAt_CreateKeySpecifier | (() => undefined | CmsBannersDocAccessFields_createdAt_CreateKeySpecifier),
		fields?: CmsBannersDocAccessFields_createdAt_CreateFieldPolicy,
	},
	CmsBannersDocAccessFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsBannersDocAccessFields_createdAt_DeleteKeySpecifier),
		fields?: CmsBannersDocAccessFields_createdAt_DeleteFieldPolicy,
	},
	CmsBannersDocAccessFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_createdAt_ReadKeySpecifier | (() => undefined | CmsBannersDocAccessFields_createdAt_ReadKeySpecifier),
		fields?: CmsBannersDocAccessFields_createdAt_ReadFieldPolicy,
	},
	CmsBannersDocAccessFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsBannersDocAccessFields_createdAt_UpdateKeySpecifier),
		fields?: CmsBannersDocAccessFields_createdAt_UpdateFieldPolicy,
	},
	CmsBannersDocAccessFields_featuredImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_featuredImageKeySpecifier | (() => undefined | CmsBannersDocAccessFields_featuredImageKeySpecifier),
		fields?: CmsBannersDocAccessFields_featuredImageFieldPolicy,
	},
	CmsBannersDocAccessFields_featuredImage_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_featuredImage_CreateKeySpecifier | (() => undefined | CmsBannersDocAccessFields_featuredImage_CreateKeySpecifier),
		fields?: CmsBannersDocAccessFields_featuredImage_CreateFieldPolicy,
	},
	CmsBannersDocAccessFields_featuredImage_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_featuredImage_DeleteKeySpecifier | (() => undefined | CmsBannersDocAccessFields_featuredImage_DeleteKeySpecifier),
		fields?: CmsBannersDocAccessFields_featuredImage_DeleteFieldPolicy,
	},
	CmsBannersDocAccessFields_featuredImage_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_featuredImage_ReadKeySpecifier | (() => undefined | CmsBannersDocAccessFields_featuredImage_ReadKeySpecifier),
		fields?: CmsBannersDocAccessFields_featuredImage_ReadFieldPolicy,
	},
	CmsBannersDocAccessFields_featuredImage_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_featuredImage_UpdateKeySpecifier | (() => undefined | CmsBannersDocAccessFields_featuredImage_UpdateKeySpecifier),
		fields?: CmsBannersDocAccessFields_featuredImage_UpdateFieldPolicy,
	},
	CmsBannersDocAccessFields_link?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_linkKeySpecifier | (() => undefined | CmsBannersDocAccessFields_linkKeySpecifier),
		fields?: CmsBannersDocAccessFields_linkFieldPolicy,
	},
	CmsBannersDocAccessFields_link_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_link_CreateKeySpecifier | (() => undefined | CmsBannersDocAccessFields_link_CreateKeySpecifier),
		fields?: CmsBannersDocAccessFields_link_CreateFieldPolicy,
	},
	CmsBannersDocAccessFields_link_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_link_DeleteKeySpecifier | (() => undefined | CmsBannersDocAccessFields_link_DeleteKeySpecifier),
		fields?: CmsBannersDocAccessFields_link_DeleteFieldPolicy,
	},
	CmsBannersDocAccessFields_link_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_link_ReadKeySpecifier | (() => undefined | CmsBannersDocAccessFields_link_ReadKeySpecifier),
		fields?: CmsBannersDocAccessFields_link_ReadFieldPolicy,
	},
	CmsBannersDocAccessFields_link_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_link_UpdateKeySpecifier | (() => undefined | CmsBannersDocAccessFields_link_UpdateKeySpecifier),
		fields?: CmsBannersDocAccessFields_link_UpdateFieldPolicy,
	},
	CmsBannersDocAccessFields_relatedPost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_relatedPostKeySpecifier | (() => undefined | CmsBannersDocAccessFields_relatedPostKeySpecifier),
		fields?: CmsBannersDocAccessFields_relatedPostFieldPolicy,
	},
	CmsBannersDocAccessFields_relatedPost_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_relatedPost_CreateKeySpecifier | (() => undefined | CmsBannersDocAccessFields_relatedPost_CreateKeySpecifier),
		fields?: CmsBannersDocAccessFields_relatedPost_CreateFieldPolicy,
	},
	CmsBannersDocAccessFields_relatedPost_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_relatedPost_DeleteKeySpecifier | (() => undefined | CmsBannersDocAccessFields_relatedPost_DeleteKeySpecifier),
		fields?: CmsBannersDocAccessFields_relatedPost_DeleteFieldPolicy,
	},
	CmsBannersDocAccessFields_relatedPost_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_relatedPost_ReadKeySpecifier | (() => undefined | CmsBannersDocAccessFields_relatedPost_ReadKeySpecifier),
		fields?: CmsBannersDocAccessFields_relatedPost_ReadFieldPolicy,
	},
	CmsBannersDocAccessFields_relatedPost_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_relatedPost_UpdateKeySpecifier | (() => undefined | CmsBannersDocAccessFields_relatedPost_UpdateKeySpecifier),
		fields?: CmsBannersDocAccessFields_relatedPost_UpdateFieldPolicy,
	},
	CmsBannersDocAccessFields_title?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_titleKeySpecifier | (() => undefined | CmsBannersDocAccessFields_titleKeySpecifier),
		fields?: CmsBannersDocAccessFields_titleFieldPolicy,
	},
	CmsBannersDocAccessFields_title_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_title_CreateKeySpecifier | (() => undefined | CmsBannersDocAccessFields_title_CreateKeySpecifier),
		fields?: CmsBannersDocAccessFields_title_CreateFieldPolicy,
	},
	CmsBannersDocAccessFields_title_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_title_DeleteKeySpecifier | (() => undefined | CmsBannersDocAccessFields_title_DeleteKeySpecifier),
		fields?: CmsBannersDocAccessFields_title_DeleteFieldPolicy,
	},
	CmsBannersDocAccessFields_title_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_title_ReadKeySpecifier | (() => undefined | CmsBannersDocAccessFields_title_ReadKeySpecifier),
		fields?: CmsBannersDocAccessFields_title_ReadFieldPolicy,
	},
	CmsBannersDocAccessFields_title_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_title_UpdateKeySpecifier | (() => undefined | CmsBannersDocAccessFields_title_UpdateKeySpecifier),
		fields?: CmsBannersDocAccessFields_title_UpdateFieldPolicy,
	},
	CmsBannersDocAccessFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_updatedAtKeySpecifier | (() => undefined | CmsBannersDocAccessFields_updatedAtKeySpecifier),
		fields?: CmsBannersDocAccessFields_updatedAtFieldPolicy,
	},
	CmsBannersDocAccessFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsBannersDocAccessFields_updatedAt_CreateKeySpecifier),
		fields?: CmsBannersDocAccessFields_updatedAt_CreateFieldPolicy,
	},
	CmsBannersDocAccessFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsBannersDocAccessFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsBannersDocAccessFields_updatedAt_DeleteFieldPolicy,
	},
	CmsBannersDocAccessFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsBannersDocAccessFields_updatedAt_ReadKeySpecifier),
		fields?: CmsBannersDocAccessFields_updatedAt_ReadFieldPolicy,
	},
	CmsBannersDocAccessFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersDocAccessFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsBannersDocAccessFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsBannersDocAccessFields_updatedAt_UpdateFieldPolicy,
	},
	CmsBannersFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFieldsKeySpecifier | (() => undefined | CmsBannersFieldsKeySpecifier),
		fields?: CmsBannersFieldsFieldPolicy,
	},
	CmsBannersFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_createdAtKeySpecifier | (() => undefined | CmsBannersFields_createdAtKeySpecifier),
		fields?: CmsBannersFields_createdAtFieldPolicy,
	},
	CmsBannersFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_createdAt_CreateKeySpecifier | (() => undefined | CmsBannersFields_createdAt_CreateKeySpecifier),
		fields?: CmsBannersFields_createdAt_CreateFieldPolicy,
	},
	CmsBannersFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsBannersFields_createdAt_DeleteKeySpecifier),
		fields?: CmsBannersFields_createdAt_DeleteFieldPolicy,
	},
	CmsBannersFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_createdAt_ReadKeySpecifier | (() => undefined | CmsBannersFields_createdAt_ReadKeySpecifier),
		fields?: CmsBannersFields_createdAt_ReadFieldPolicy,
	},
	CmsBannersFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsBannersFields_createdAt_UpdateKeySpecifier),
		fields?: CmsBannersFields_createdAt_UpdateFieldPolicy,
	},
	CmsBannersFields_featuredImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_featuredImageKeySpecifier | (() => undefined | CmsBannersFields_featuredImageKeySpecifier),
		fields?: CmsBannersFields_featuredImageFieldPolicy,
	},
	CmsBannersFields_featuredImage_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_featuredImage_CreateKeySpecifier | (() => undefined | CmsBannersFields_featuredImage_CreateKeySpecifier),
		fields?: CmsBannersFields_featuredImage_CreateFieldPolicy,
	},
	CmsBannersFields_featuredImage_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_featuredImage_DeleteKeySpecifier | (() => undefined | CmsBannersFields_featuredImage_DeleteKeySpecifier),
		fields?: CmsBannersFields_featuredImage_DeleteFieldPolicy,
	},
	CmsBannersFields_featuredImage_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_featuredImage_ReadKeySpecifier | (() => undefined | CmsBannersFields_featuredImage_ReadKeySpecifier),
		fields?: CmsBannersFields_featuredImage_ReadFieldPolicy,
	},
	CmsBannersFields_featuredImage_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_featuredImage_UpdateKeySpecifier | (() => undefined | CmsBannersFields_featuredImage_UpdateKeySpecifier),
		fields?: CmsBannersFields_featuredImage_UpdateFieldPolicy,
	},
	CmsBannersFields_link?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_linkKeySpecifier | (() => undefined | CmsBannersFields_linkKeySpecifier),
		fields?: CmsBannersFields_linkFieldPolicy,
	},
	CmsBannersFields_link_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_link_CreateKeySpecifier | (() => undefined | CmsBannersFields_link_CreateKeySpecifier),
		fields?: CmsBannersFields_link_CreateFieldPolicy,
	},
	CmsBannersFields_link_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_link_DeleteKeySpecifier | (() => undefined | CmsBannersFields_link_DeleteKeySpecifier),
		fields?: CmsBannersFields_link_DeleteFieldPolicy,
	},
	CmsBannersFields_link_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_link_ReadKeySpecifier | (() => undefined | CmsBannersFields_link_ReadKeySpecifier),
		fields?: CmsBannersFields_link_ReadFieldPolicy,
	},
	CmsBannersFields_link_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_link_UpdateKeySpecifier | (() => undefined | CmsBannersFields_link_UpdateKeySpecifier),
		fields?: CmsBannersFields_link_UpdateFieldPolicy,
	},
	CmsBannersFields_relatedPost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_relatedPostKeySpecifier | (() => undefined | CmsBannersFields_relatedPostKeySpecifier),
		fields?: CmsBannersFields_relatedPostFieldPolicy,
	},
	CmsBannersFields_relatedPost_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_relatedPost_CreateKeySpecifier | (() => undefined | CmsBannersFields_relatedPost_CreateKeySpecifier),
		fields?: CmsBannersFields_relatedPost_CreateFieldPolicy,
	},
	CmsBannersFields_relatedPost_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_relatedPost_DeleteKeySpecifier | (() => undefined | CmsBannersFields_relatedPost_DeleteKeySpecifier),
		fields?: CmsBannersFields_relatedPost_DeleteFieldPolicy,
	},
	CmsBannersFields_relatedPost_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_relatedPost_ReadKeySpecifier | (() => undefined | CmsBannersFields_relatedPost_ReadKeySpecifier),
		fields?: CmsBannersFields_relatedPost_ReadFieldPolicy,
	},
	CmsBannersFields_relatedPost_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_relatedPost_UpdateKeySpecifier | (() => undefined | CmsBannersFields_relatedPost_UpdateKeySpecifier),
		fields?: CmsBannersFields_relatedPost_UpdateFieldPolicy,
	},
	CmsBannersFields_title?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_titleKeySpecifier | (() => undefined | CmsBannersFields_titleKeySpecifier),
		fields?: CmsBannersFields_titleFieldPolicy,
	},
	CmsBannersFields_title_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_title_CreateKeySpecifier | (() => undefined | CmsBannersFields_title_CreateKeySpecifier),
		fields?: CmsBannersFields_title_CreateFieldPolicy,
	},
	CmsBannersFields_title_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_title_DeleteKeySpecifier | (() => undefined | CmsBannersFields_title_DeleteKeySpecifier),
		fields?: CmsBannersFields_title_DeleteFieldPolicy,
	},
	CmsBannersFields_title_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_title_ReadKeySpecifier | (() => undefined | CmsBannersFields_title_ReadKeySpecifier),
		fields?: CmsBannersFields_title_ReadFieldPolicy,
	},
	CmsBannersFields_title_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_title_UpdateKeySpecifier | (() => undefined | CmsBannersFields_title_UpdateKeySpecifier),
		fields?: CmsBannersFields_title_UpdateFieldPolicy,
	},
	CmsBannersFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_updatedAtKeySpecifier | (() => undefined | CmsBannersFields_updatedAtKeySpecifier),
		fields?: CmsBannersFields_updatedAtFieldPolicy,
	},
	CmsBannersFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsBannersFields_updatedAt_CreateKeySpecifier),
		fields?: CmsBannersFields_updatedAt_CreateFieldPolicy,
	},
	CmsBannersFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsBannersFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsBannersFields_updatedAt_DeleteFieldPolicy,
	},
	CmsBannersFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsBannersFields_updatedAt_ReadKeySpecifier),
		fields?: CmsBannersFields_updatedAt_ReadFieldPolicy,
	},
	CmsBannersFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsBannersFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsBannersFields_updatedAt_UpdateFieldPolicy,
	},
	CmsBannersReadAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersReadAccessKeySpecifier | (() => undefined | CmsBannersReadAccessKeySpecifier),
		fields?: CmsBannersReadAccessFieldPolicy,
	},
	CmsBannersReadDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersReadDocAccessKeySpecifier | (() => undefined | CmsBannersReadDocAccessKeySpecifier),
		fields?: CmsBannersReadDocAccessFieldPolicy,
	},
	CmsBannersUpdateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersUpdateAccessKeySpecifier | (() => undefined | CmsBannersUpdateAccessKeySpecifier),
		fields?: CmsBannersUpdateAccessFieldPolicy,
	},
	CmsBannersUpdateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBannersUpdateDocAccessKeySpecifier | (() => undefined | CmsBannersUpdateDocAccessKeySpecifier),
		fields?: CmsBannersUpdateDocAccessFieldPolicy,
	},
	CmsBlogPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPageKeySpecifier | (() => undefined | CmsBlogPageKeySpecifier),
		fields?: CmsBlogPageFieldPolicy,
	},
	CmsBlogPage_Sections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPage_SectionsKeySpecifier | (() => undefined | CmsBlogPage_SectionsKeySpecifier),
		fields?: CmsBlogPage_SectionsFieldPolicy,
	},
	CmsBlogPages?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesKeySpecifier | (() => undefined | CmsBlogPagesKeySpecifier),
		fields?: CmsBlogPagesFieldPolicy,
	},
	CmsBlogPagesCreateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesCreateAccessKeySpecifier | (() => undefined | CmsBlogPagesCreateAccessKeySpecifier),
		fields?: CmsBlogPagesCreateAccessFieldPolicy,
	},
	CmsBlogPagesCreateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesCreateDocAccessKeySpecifier | (() => undefined | CmsBlogPagesCreateDocAccessKeySpecifier),
		fields?: CmsBlogPagesCreateDocAccessFieldPolicy,
	},
	CmsBlogPagesDeleteAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDeleteAccessKeySpecifier | (() => undefined | CmsBlogPagesDeleteAccessKeySpecifier),
		fields?: CmsBlogPagesDeleteAccessFieldPolicy,
	},
	CmsBlogPagesDeleteDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDeleteDocAccessKeySpecifier | (() => undefined | CmsBlogPagesDeleteDocAccessKeySpecifier),
		fields?: CmsBlogPagesDeleteDocAccessFieldPolicy,
	},
	CmsBlogPagesDocAccessFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFieldsKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFieldsKeySpecifier),
		fields?: CmsBlogPagesDocAccessFieldsFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_createdAtKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_createdAtKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_createdAtFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_createdAt_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_createdAt_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_createdAt_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_createdAt_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_createdAt_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_createdAt_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_createdAt_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_createdAt_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_createdAt_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_createdAt_UpdateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sectionsKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sectionsKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sectionsFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_FieldsKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_FieldsKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_FieldsFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_UpdateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredBanners?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredBannersKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredBannersKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredBannersFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredBanners_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredBanners_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredBanners_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredBanners_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredBanners_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredBanners_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredBanners_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredBanners_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredBanners_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredBanners_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredBanners_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredBanners_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredBanners_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredBanners_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredBanners_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredBanners_UpdateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredBlogPosts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredBlogPostsKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredBlogPostsKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredBlogPostsFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredBlogPosts_UpdateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredGamers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredGamersKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredGamersKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredGamersFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredGamers_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredGamers_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredGamers_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredGamers_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredGamers_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredGamers_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredGamers_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredGamers_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredGamers_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredGamers_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredGamers_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredGamers_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredGamers_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredGamers_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredGamers_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredGamers_UpdateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredGames?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredGamesKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredGamesKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredGamesFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredGames_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredGames_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredGames_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredGames_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredGames_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredGames_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredGames_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredGames_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredGames_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredGames_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredGames_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredGames_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_featuredGames_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_featuredGames_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_featuredGames_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_featuredGames_UpdateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_idKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_idKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_idFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_id_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_id_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_id_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_id_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_id_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_id_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_id_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_id_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_id_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_id_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_id_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_id_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_id_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_id_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_id_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_id_UpdateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_sectionTitle?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_sectionTitleKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_sectionTitleKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_sectionTitleFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_sectionTitle_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_sectionTitle_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_sectionTitle_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_sectionTitle_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_sectionTitle_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_sectionTitle_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_sectionTitle_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_sectionTitle_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_sectionTitle_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_sectionTitle_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_sectionTitle_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_sectionTitle_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_sectionTitle_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_sectionTitle_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_sectionTitle_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_sectionTitle_UpdateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_sectionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_sectionTypeKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_sectionTypeKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_sectionTypeFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_sectionType_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_sectionType_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_sectionType_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_sectionType_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_sectionType_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_sectionType_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_sectionType_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_sectionType_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_sectionType_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_sectionType_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_sectionType_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_sectionType_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_sections_sectionType_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_sections_sectionType_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_sections_sectionType_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_sections_sectionType_UpdateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_slug?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_slugKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_slugKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_slugFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_slug_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_slug_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_slug_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_slug_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_slug_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_slug_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_slug_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_slug_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_slug_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_slug_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_slug_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_slug_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_slug_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_slug_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_slug_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_slug_UpdateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_status?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_statusKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_statusKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_statusFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_status_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_status_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_status_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_status_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_status_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_status_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_status_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_status_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_status_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_status_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_status_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_status_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_status_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_status_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_status_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_status_UpdateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_title?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_titleKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_titleKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_titleFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_title_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_title_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_title_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_title_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_title_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_title_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_title_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_title_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_title_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_title_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_title_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_title_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_title_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_title_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_title_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_title_UpdateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_updatedAtKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_updatedAtKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_updatedAtFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_updatedAt_CreateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_updatedAt_CreateFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_updatedAt_DeleteFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_updatedAt_ReadKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_updatedAt_ReadFieldPolicy,
	},
	CmsBlogPagesDocAccessFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesDocAccessFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsBlogPagesDocAccessFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsBlogPagesDocAccessFields_updatedAt_UpdateFieldPolicy,
	},
	CmsBlogPagesFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFieldsKeySpecifier | (() => undefined | CmsBlogPagesFieldsKeySpecifier),
		fields?: CmsBlogPagesFieldsFieldPolicy,
	},
	CmsBlogPagesFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_createdAtKeySpecifier | (() => undefined | CmsBlogPagesFields_createdAtKeySpecifier),
		fields?: CmsBlogPagesFields_createdAtFieldPolicy,
	},
	CmsBlogPagesFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_createdAt_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_createdAt_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_createdAt_CreateFieldPolicy,
	},
	CmsBlogPagesFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_createdAt_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_createdAt_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_createdAt_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_createdAt_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_createdAt_ReadFieldPolicy,
	},
	CmsBlogPagesFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_createdAt_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_createdAt_UpdateFieldPolicy,
	},
	CmsBlogPagesFields_sections?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sectionsKeySpecifier | (() => undefined | CmsBlogPagesFields_sectionsKeySpecifier),
		fields?: CmsBlogPagesFields_sectionsFieldPolicy,
	},
	CmsBlogPagesFields_sections_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_CreateFieldPolicy,
	},
	CmsBlogPagesFields_sections_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_sections_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_sections_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_FieldsKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_FieldsKeySpecifier),
		fields?: CmsBlogPagesFields_sections_FieldsFieldPolicy,
	},
	CmsBlogPagesFields_sections_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_sections_ReadFieldPolicy,
	},
	CmsBlogPagesFields_sections_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_UpdateFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredBanners?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredBannersKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredBannersKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredBannersFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredBanners_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredBanners_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredBanners_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredBanners_CreateFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredBanners_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredBanners_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredBanners_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredBanners_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredBanners_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredBanners_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredBanners_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredBanners_ReadFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredBanners_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredBanners_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredBanners_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredBanners_UpdateFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredBlogPosts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredBlogPostsKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredBlogPostsKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredBlogPostsFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredBlogPosts_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredBlogPosts_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredBlogPosts_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredBlogPosts_CreateFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredBlogPosts_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredBlogPosts_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredBlogPosts_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredBlogPosts_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredBlogPosts_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredBlogPosts_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredBlogPosts_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredBlogPosts_ReadFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredBlogPosts_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredBlogPosts_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredBlogPosts_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredBlogPosts_UpdateFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredGamers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredGamersKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredGamersKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredGamersFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredGamers_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredGamers_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredGamers_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredGamers_CreateFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredGamers_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredGamers_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredGamers_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredGamers_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredGamers_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredGamers_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredGamers_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredGamers_ReadFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredGamers_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredGamers_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredGamers_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredGamers_UpdateFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredGames?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredGamesKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredGamesKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredGamesFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredGames_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredGames_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredGames_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredGames_CreateFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredGames_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredGames_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredGames_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredGames_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredGames_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredGames_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredGames_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredGames_ReadFieldPolicy,
	},
	CmsBlogPagesFields_sections_featuredGames_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_featuredGames_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_featuredGames_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_featuredGames_UpdateFieldPolicy,
	},
	CmsBlogPagesFields_sections_id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_idKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_idKeySpecifier),
		fields?: CmsBlogPagesFields_sections_idFieldPolicy,
	},
	CmsBlogPagesFields_sections_id_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_id_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_id_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_id_CreateFieldPolicy,
	},
	CmsBlogPagesFields_sections_id_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_id_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_id_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_sections_id_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_sections_id_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_id_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_id_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_sections_id_ReadFieldPolicy,
	},
	CmsBlogPagesFields_sections_id_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_id_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_id_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_id_UpdateFieldPolicy,
	},
	CmsBlogPagesFields_sections_sectionTitle?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_sectionTitleKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_sectionTitleKeySpecifier),
		fields?: CmsBlogPagesFields_sections_sectionTitleFieldPolicy,
	},
	CmsBlogPagesFields_sections_sectionTitle_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_sectionTitle_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_sectionTitle_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_sectionTitle_CreateFieldPolicy,
	},
	CmsBlogPagesFields_sections_sectionTitle_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_sectionTitle_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_sectionTitle_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_sections_sectionTitle_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_sections_sectionTitle_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_sectionTitle_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_sectionTitle_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_sections_sectionTitle_ReadFieldPolicy,
	},
	CmsBlogPagesFields_sections_sectionTitle_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_sectionTitle_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_sectionTitle_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_sectionTitle_UpdateFieldPolicy,
	},
	CmsBlogPagesFields_sections_sectionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_sectionTypeKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_sectionTypeKeySpecifier),
		fields?: CmsBlogPagesFields_sections_sectionTypeFieldPolicy,
	},
	CmsBlogPagesFields_sections_sectionType_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_sectionType_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_sectionType_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_sectionType_CreateFieldPolicy,
	},
	CmsBlogPagesFields_sections_sectionType_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_sectionType_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_sectionType_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_sections_sectionType_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_sections_sectionType_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_sectionType_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_sectionType_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_sections_sectionType_ReadFieldPolicy,
	},
	CmsBlogPagesFields_sections_sectionType_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_sections_sectionType_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_sections_sectionType_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_sections_sectionType_UpdateFieldPolicy,
	},
	CmsBlogPagesFields_slug?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_slugKeySpecifier | (() => undefined | CmsBlogPagesFields_slugKeySpecifier),
		fields?: CmsBlogPagesFields_slugFieldPolicy,
	},
	CmsBlogPagesFields_slug_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_slug_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_slug_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_slug_CreateFieldPolicy,
	},
	CmsBlogPagesFields_slug_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_slug_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_slug_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_slug_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_slug_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_slug_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_slug_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_slug_ReadFieldPolicy,
	},
	CmsBlogPagesFields_slug_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_slug_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_slug_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_slug_UpdateFieldPolicy,
	},
	CmsBlogPagesFields_status?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_statusKeySpecifier | (() => undefined | CmsBlogPagesFields_statusKeySpecifier),
		fields?: CmsBlogPagesFields_statusFieldPolicy,
	},
	CmsBlogPagesFields_status_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_status_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_status_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_status_CreateFieldPolicy,
	},
	CmsBlogPagesFields_status_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_status_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_status_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_status_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_status_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_status_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_status_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_status_ReadFieldPolicy,
	},
	CmsBlogPagesFields_status_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_status_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_status_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_status_UpdateFieldPolicy,
	},
	CmsBlogPagesFields_title?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_titleKeySpecifier | (() => undefined | CmsBlogPagesFields_titleKeySpecifier),
		fields?: CmsBlogPagesFields_titleFieldPolicy,
	},
	CmsBlogPagesFields_title_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_title_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_title_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_title_CreateFieldPolicy,
	},
	CmsBlogPagesFields_title_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_title_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_title_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_title_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_title_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_title_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_title_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_title_ReadFieldPolicy,
	},
	CmsBlogPagesFields_title_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_title_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_title_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_title_UpdateFieldPolicy,
	},
	CmsBlogPagesFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_updatedAtKeySpecifier | (() => undefined | CmsBlogPagesFields_updatedAtKeySpecifier),
		fields?: CmsBlogPagesFields_updatedAtFieldPolicy,
	},
	CmsBlogPagesFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsBlogPagesFields_updatedAt_CreateKeySpecifier),
		fields?: CmsBlogPagesFields_updatedAt_CreateFieldPolicy,
	},
	CmsBlogPagesFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsBlogPagesFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsBlogPagesFields_updatedAt_DeleteFieldPolicy,
	},
	CmsBlogPagesFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsBlogPagesFields_updatedAt_ReadKeySpecifier),
		fields?: CmsBlogPagesFields_updatedAt_ReadFieldPolicy,
	},
	CmsBlogPagesFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsBlogPagesFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsBlogPagesFields_updatedAt_UpdateFieldPolicy,
	},
	CmsBlogPagesReadAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesReadAccessKeySpecifier | (() => undefined | CmsBlogPagesReadAccessKeySpecifier),
		fields?: CmsBlogPagesReadAccessFieldPolicy,
	},
	CmsBlogPagesReadDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesReadDocAccessKeySpecifier | (() => undefined | CmsBlogPagesReadDocAccessKeySpecifier),
		fields?: CmsBlogPagesReadDocAccessFieldPolicy,
	},
	CmsBlogPagesUpdateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesUpdateAccessKeySpecifier | (() => undefined | CmsBlogPagesUpdateAccessKeySpecifier),
		fields?: CmsBlogPagesUpdateAccessFieldPolicy,
	},
	CmsBlogPagesUpdateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPagesUpdateDocAccessKeySpecifier | (() => undefined | CmsBlogPagesUpdateDocAccessKeySpecifier),
		fields?: CmsBlogPagesUpdateDocAccessFieldPolicy,
	},
	CmsBlogPost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostKeySpecifier | (() => undefined | CmsBlogPostKeySpecifier),
		fields?: CmsBlogPostFieldPolicy,
	},
	CmsBlogPost_Videos?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPost_VideosKeySpecifier | (() => undefined | CmsBlogPost_VideosKeySpecifier),
		fields?: CmsBlogPost_VideosFieldPolicy,
	},
	CmsBlogPosts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsKeySpecifier | (() => undefined | CmsBlogPostsKeySpecifier),
		fields?: CmsBlogPostsFieldPolicy,
	},
	CmsBlogPostsCreateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsCreateAccessKeySpecifier | (() => undefined | CmsBlogPostsCreateAccessKeySpecifier),
		fields?: CmsBlogPostsCreateAccessFieldPolicy,
	},
	CmsBlogPostsCreateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsCreateDocAccessKeySpecifier | (() => undefined | CmsBlogPostsCreateDocAccessKeySpecifier),
		fields?: CmsBlogPostsCreateDocAccessFieldPolicy,
	},
	CmsBlogPostsDeleteAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDeleteAccessKeySpecifier | (() => undefined | CmsBlogPostsDeleteAccessKeySpecifier),
		fields?: CmsBlogPostsDeleteAccessFieldPolicy,
	},
	CmsBlogPostsDeleteDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDeleteDocAccessKeySpecifier | (() => undefined | CmsBlogPostsDeleteDocAccessKeySpecifier),
		fields?: CmsBlogPostsDeleteDocAccessFieldPolicy,
	},
	CmsBlogPostsDocAccessFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFieldsKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFieldsKeySpecifier),
		fields?: CmsBlogPostsDocAccessFieldsFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_content?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_contentKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_contentKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_contentFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_content_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_content_CreateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_content_CreateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_content_CreateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_content_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_content_DeleteKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_content_DeleteKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_content_DeleteFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_content_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_content_ReadKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_content_ReadKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_content_ReadFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_content_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_content_UpdateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_content_UpdateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_content_UpdateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_createdAtKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_createdAtKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_createdAtFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_createdAt_CreateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_createdAt_CreateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_createdAt_CreateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_createdAt_DeleteKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_createdAt_DeleteFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_createdAt_ReadKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_createdAt_ReadKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_createdAt_ReadFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_createdAt_UpdateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_createdAt_UpdateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_description?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_descriptionKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_descriptionKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_descriptionFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_description_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_description_CreateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_description_CreateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_description_CreateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_description_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_description_DeleteKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_description_DeleteKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_description_DeleteFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_description_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_description_ReadKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_description_ReadKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_description_ReadFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_description_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_description_UpdateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_description_UpdateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_description_UpdateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_featuredImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_featuredImageKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_featuredImageKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_featuredImageFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_featuredImage_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_featuredImage_CreateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_featuredImage_CreateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_featuredImage_CreateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_featuredImage_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_featuredImage_DeleteKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_featuredImage_DeleteKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_featuredImage_DeleteFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_featuredImage_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_featuredImage_ReadKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_featuredImage_ReadKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_featuredImage_ReadFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_featuredImage_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_featuredImage_UpdateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_featuredImage_UpdateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_featuredImage_UpdateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_relatedPosts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_relatedPostsKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_relatedPostsKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_relatedPostsFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_relatedPosts_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_relatedPosts_CreateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_relatedPosts_CreateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_relatedPosts_CreateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_relatedPosts_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_relatedPosts_DeleteKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_relatedPosts_DeleteKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_relatedPosts_DeleteFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_relatedPosts_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_relatedPosts_ReadKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_relatedPosts_ReadKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_relatedPosts_ReadFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_relatedPosts_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_relatedPosts_UpdateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_relatedPosts_UpdateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_relatedPosts_UpdateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_title?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_titleKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_titleKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_titleFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_title_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_title_CreateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_title_CreateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_title_CreateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_title_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_title_DeleteKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_title_DeleteKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_title_DeleteFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_title_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_title_ReadKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_title_ReadKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_title_ReadFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_title_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_title_UpdateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_title_UpdateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_title_UpdateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_updatedAtKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_updatedAtKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_updatedAtFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_updatedAt_CreateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_updatedAt_CreateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_updatedAt_DeleteFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_updatedAt_ReadKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_updatedAt_ReadFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_updatedAt_UpdateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videosKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videosKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videosFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_CreateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_CreateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_CreateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_DeleteKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_DeleteKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_DeleteFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_FieldsKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_FieldsKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_FieldsFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_ReadKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_ReadKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_ReadFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_UpdateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_UpdateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_UpdateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_embedId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_embedIdKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_embedIdKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_embedIdFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_embedId_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_embedId_CreateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_embedId_CreateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_embedId_CreateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_embedId_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_embedId_DeleteKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_embedId_DeleteKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_embedId_DeleteFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_embedId_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_embedId_ReadKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_embedId_ReadKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_embedId_ReadFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_embedId_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_embedId_UpdateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_embedId_UpdateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_embedId_UpdateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_idKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_idKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_idFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_id_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_id_CreateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_id_CreateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_id_CreateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_id_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_id_DeleteKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_id_DeleteKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_id_DeleteFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_id_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_id_ReadKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_id_ReadKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_id_ReadFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_id_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_id_UpdateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_id_UpdateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_id_UpdateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_title?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_titleKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_titleKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_titleFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_title_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_title_CreateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_title_CreateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_title_CreateFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_title_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_title_DeleteKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_title_DeleteKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_title_DeleteFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_title_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_title_ReadKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_title_ReadKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_title_ReadFieldPolicy,
	},
	CmsBlogPostsDocAccessFields_videos_title_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsDocAccessFields_videos_title_UpdateKeySpecifier | (() => undefined | CmsBlogPostsDocAccessFields_videos_title_UpdateKeySpecifier),
		fields?: CmsBlogPostsDocAccessFields_videos_title_UpdateFieldPolicy,
	},
	CmsBlogPostsFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFieldsKeySpecifier | (() => undefined | CmsBlogPostsFieldsKeySpecifier),
		fields?: CmsBlogPostsFieldsFieldPolicy,
	},
	CmsBlogPostsFields_content?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_contentKeySpecifier | (() => undefined | CmsBlogPostsFields_contentKeySpecifier),
		fields?: CmsBlogPostsFields_contentFieldPolicy,
	},
	CmsBlogPostsFields_content_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_content_CreateKeySpecifier | (() => undefined | CmsBlogPostsFields_content_CreateKeySpecifier),
		fields?: CmsBlogPostsFields_content_CreateFieldPolicy,
	},
	CmsBlogPostsFields_content_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_content_DeleteKeySpecifier | (() => undefined | CmsBlogPostsFields_content_DeleteKeySpecifier),
		fields?: CmsBlogPostsFields_content_DeleteFieldPolicy,
	},
	CmsBlogPostsFields_content_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_content_ReadKeySpecifier | (() => undefined | CmsBlogPostsFields_content_ReadKeySpecifier),
		fields?: CmsBlogPostsFields_content_ReadFieldPolicy,
	},
	CmsBlogPostsFields_content_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_content_UpdateKeySpecifier | (() => undefined | CmsBlogPostsFields_content_UpdateKeySpecifier),
		fields?: CmsBlogPostsFields_content_UpdateFieldPolicy,
	},
	CmsBlogPostsFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_createdAtKeySpecifier | (() => undefined | CmsBlogPostsFields_createdAtKeySpecifier),
		fields?: CmsBlogPostsFields_createdAtFieldPolicy,
	},
	CmsBlogPostsFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_createdAt_CreateKeySpecifier | (() => undefined | CmsBlogPostsFields_createdAt_CreateKeySpecifier),
		fields?: CmsBlogPostsFields_createdAt_CreateFieldPolicy,
	},
	CmsBlogPostsFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsBlogPostsFields_createdAt_DeleteKeySpecifier),
		fields?: CmsBlogPostsFields_createdAt_DeleteFieldPolicy,
	},
	CmsBlogPostsFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_createdAt_ReadKeySpecifier | (() => undefined | CmsBlogPostsFields_createdAt_ReadKeySpecifier),
		fields?: CmsBlogPostsFields_createdAt_ReadFieldPolicy,
	},
	CmsBlogPostsFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsBlogPostsFields_createdAt_UpdateKeySpecifier),
		fields?: CmsBlogPostsFields_createdAt_UpdateFieldPolicy,
	},
	CmsBlogPostsFields_description?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_descriptionKeySpecifier | (() => undefined | CmsBlogPostsFields_descriptionKeySpecifier),
		fields?: CmsBlogPostsFields_descriptionFieldPolicy,
	},
	CmsBlogPostsFields_description_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_description_CreateKeySpecifier | (() => undefined | CmsBlogPostsFields_description_CreateKeySpecifier),
		fields?: CmsBlogPostsFields_description_CreateFieldPolicy,
	},
	CmsBlogPostsFields_description_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_description_DeleteKeySpecifier | (() => undefined | CmsBlogPostsFields_description_DeleteKeySpecifier),
		fields?: CmsBlogPostsFields_description_DeleteFieldPolicy,
	},
	CmsBlogPostsFields_description_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_description_ReadKeySpecifier | (() => undefined | CmsBlogPostsFields_description_ReadKeySpecifier),
		fields?: CmsBlogPostsFields_description_ReadFieldPolicy,
	},
	CmsBlogPostsFields_description_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_description_UpdateKeySpecifier | (() => undefined | CmsBlogPostsFields_description_UpdateKeySpecifier),
		fields?: CmsBlogPostsFields_description_UpdateFieldPolicy,
	},
	CmsBlogPostsFields_featuredImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_featuredImageKeySpecifier | (() => undefined | CmsBlogPostsFields_featuredImageKeySpecifier),
		fields?: CmsBlogPostsFields_featuredImageFieldPolicy,
	},
	CmsBlogPostsFields_featuredImage_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_featuredImage_CreateKeySpecifier | (() => undefined | CmsBlogPostsFields_featuredImage_CreateKeySpecifier),
		fields?: CmsBlogPostsFields_featuredImage_CreateFieldPolicy,
	},
	CmsBlogPostsFields_featuredImage_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_featuredImage_DeleteKeySpecifier | (() => undefined | CmsBlogPostsFields_featuredImage_DeleteKeySpecifier),
		fields?: CmsBlogPostsFields_featuredImage_DeleteFieldPolicy,
	},
	CmsBlogPostsFields_featuredImage_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_featuredImage_ReadKeySpecifier | (() => undefined | CmsBlogPostsFields_featuredImage_ReadKeySpecifier),
		fields?: CmsBlogPostsFields_featuredImage_ReadFieldPolicy,
	},
	CmsBlogPostsFields_featuredImage_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_featuredImage_UpdateKeySpecifier | (() => undefined | CmsBlogPostsFields_featuredImage_UpdateKeySpecifier),
		fields?: CmsBlogPostsFields_featuredImage_UpdateFieldPolicy,
	},
	CmsBlogPostsFields_relatedPosts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_relatedPostsKeySpecifier | (() => undefined | CmsBlogPostsFields_relatedPostsKeySpecifier),
		fields?: CmsBlogPostsFields_relatedPostsFieldPolicy,
	},
	CmsBlogPostsFields_relatedPosts_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_relatedPosts_CreateKeySpecifier | (() => undefined | CmsBlogPostsFields_relatedPosts_CreateKeySpecifier),
		fields?: CmsBlogPostsFields_relatedPosts_CreateFieldPolicy,
	},
	CmsBlogPostsFields_relatedPosts_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_relatedPosts_DeleteKeySpecifier | (() => undefined | CmsBlogPostsFields_relatedPosts_DeleteKeySpecifier),
		fields?: CmsBlogPostsFields_relatedPosts_DeleteFieldPolicy,
	},
	CmsBlogPostsFields_relatedPosts_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_relatedPosts_ReadKeySpecifier | (() => undefined | CmsBlogPostsFields_relatedPosts_ReadKeySpecifier),
		fields?: CmsBlogPostsFields_relatedPosts_ReadFieldPolicy,
	},
	CmsBlogPostsFields_relatedPosts_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_relatedPosts_UpdateKeySpecifier | (() => undefined | CmsBlogPostsFields_relatedPosts_UpdateKeySpecifier),
		fields?: CmsBlogPostsFields_relatedPosts_UpdateFieldPolicy,
	},
	CmsBlogPostsFields_title?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_titleKeySpecifier | (() => undefined | CmsBlogPostsFields_titleKeySpecifier),
		fields?: CmsBlogPostsFields_titleFieldPolicy,
	},
	CmsBlogPostsFields_title_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_title_CreateKeySpecifier | (() => undefined | CmsBlogPostsFields_title_CreateKeySpecifier),
		fields?: CmsBlogPostsFields_title_CreateFieldPolicy,
	},
	CmsBlogPostsFields_title_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_title_DeleteKeySpecifier | (() => undefined | CmsBlogPostsFields_title_DeleteKeySpecifier),
		fields?: CmsBlogPostsFields_title_DeleteFieldPolicy,
	},
	CmsBlogPostsFields_title_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_title_ReadKeySpecifier | (() => undefined | CmsBlogPostsFields_title_ReadKeySpecifier),
		fields?: CmsBlogPostsFields_title_ReadFieldPolicy,
	},
	CmsBlogPostsFields_title_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_title_UpdateKeySpecifier | (() => undefined | CmsBlogPostsFields_title_UpdateKeySpecifier),
		fields?: CmsBlogPostsFields_title_UpdateFieldPolicy,
	},
	CmsBlogPostsFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_updatedAtKeySpecifier | (() => undefined | CmsBlogPostsFields_updatedAtKeySpecifier),
		fields?: CmsBlogPostsFields_updatedAtFieldPolicy,
	},
	CmsBlogPostsFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsBlogPostsFields_updatedAt_CreateKeySpecifier),
		fields?: CmsBlogPostsFields_updatedAt_CreateFieldPolicy,
	},
	CmsBlogPostsFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsBlogPostsFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsBlogPostsFields_updatedAt_DeleteFieldPolicy,
	},
	CmsBlogPostsFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsBlogPostsFields_updatedAt_ReadKeySpecifier),
		fields?: CmsBlogPostsFields_updatedAt_ReadFieldPolicy,
	},
	CmsBlogPostsFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsBlogPostsFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsBlogPostsFields_updatedAt_UpdateFieldPolicy,
	},
	CmsBlogPostsFields_videos?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videosKeySpecifier | (() => undefined | CmsBlogPostsFields_videosKeySpecifier),
		fields?: CmsBlogPostsFields_videosFieldPolicy,
	},
	CmsBlogPostsFields_videos_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_CreateKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_CreateKeySpecifier),
		fields?: CmsBlogPostsFields_videos_CreateFieldPolicy,
	},
	CmsBlogPostsFields_videos_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_DeleteKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_DeleteKeySpecifier),
		fields?: CmsBlogPostsFields_videos_DeleteFieldPolicy,
	},
	CmsBlogPostsFields_videos_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_FieldsKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_FieldsKeySpecifier),
		fields?: CmsBlogPostsFields_videos_FieldsFieldPolicy,
	},
	CmsBlogPostsFields_videos_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_ReadKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_ReadKeySpecifier),
		fields?: CmsBlogPostsFields_videos_ReadFieldPolicy,
	},
	CmsBlogPostsFields_videos_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_UpdateKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_UpdateKeySpecifier),
		fields?: CmsBlogPostsFields_videos_UpdateFieldPolicy,
	},
	CmsBlogPostsFields_videos_embedId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_embedIdKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_embedIdKeySpecifier),
		fields?: CmsBlogPostsFields_videos_embedIdFieldPolicy,
	},
	CmsBlogPostsFields_videos_embedId_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_embedId_CreateKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_embedId_CreateKeySpecifier),
		fields?: CmsBlogPostsFields_videos_embedId_CreateFieldPolicy,
	},
	CmsBlogPostsFields_videos_embedId_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_embedId_DeleteKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_embedId_DeleteKeySpecifier),
		fields?: CmsBlogPostsFields_videos_embedId_DeleteFieldPolicy,
	},
	CmsBlogPostsFields_videos_embedId_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_embedId_ReadKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_embedId_ReadKeySpecifier),
		fields?: CmsBlogPostsFields_videos_embedId_ReadFieldPolicy,
	},
	CmsBlogPostsFields_videos_embedId_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_embedId_UpdateKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_embedId_UpdateKeySpecifier),
		fields?: CmsBlogPostsFields_videos_embedId_UpdateFieldPolicy,
	},
	CmsBlogPostsFields_videos_id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_idKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_idKeySpecifier),
		fields?: CmsBlogPostsFields_videos_idFieldPolicy,
	},
	CmsBlogPostsFields_videos_id_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_id_CreateKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_id_CreateKeySpecifier),
		fields?: CmsBlogPostsFields_videos_id_CreateFieldPolicy,
	},
	CmsBlogPostsFields_videos_id_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_id_DeleteKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_id_DeleteKeySpecifier),
		fields?: CmsBlogPostsFields_videos_id_DeleteFieldPolicy,
	},
	CmsBlogPostsFields_videos_id_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_id_ReadKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_id_ReadKeySpecifier),
		fields?: CmsBlogPostsFields_videos_id_ReadFieldPolicy,
	},
	CmsBlogPostsFields_videos_id_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_id_UpdateKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_id_UpdateKeySpecifier),
		fields?: CmsBlogPostsFields_videos_id_UpdateFieldPolicy,
	},
	CmsBlogPostsFields_videos_title?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_titleKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_titleKeySpecifier),
		fields?: CmsBlogPostsFields_videos_titleFieldPolicy,
	},
	CmsBlogPostsFields_videos_title_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_title_CreateKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_title_CreateKeySpecifier),
		fields?: CmsBlogPostsFields_videos_title_CreateFieldPolicy,
	},
	CmsBlogPostsFields_videos_title_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_title_DeleteKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_title_DeleteKeySpecifier),
		fields?: CmsBlogPostsFields_videos_title_DeleteFieldPolicy,
	},
	CmsBlogPostsFields_videos_title_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_title_ReadKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_title_ReadKeySpecifier),
		fields?: CmsBlogPostsFields_videos_title_ReadFieldPolicy,
	},
	CmsBlogPostsFields_videos_title_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsFields_videos_title_UpdateKeySpecifier | (() => undefined | CmsBlogPostsFields_videos_title_UpdateKeySpecifier),
		fields?: CmsBlogPostsFields_videos_title_UpdateFieldPolicy,
	},
	CmsBlogPostsReadAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsReadAccessKeySpecifier | (() => undefined | CmsBlogPostsReadAccessKeySpecifier),
		fields?: CmsBlogPostsReadAccessFieldPolicy,
	},
	CmsBlogPostsReadDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsReadDocAccessKeySpecifier | (() => undefined | CmsBlogPostsReadDocAccessKeySpecifier),
		fields?: CmsBlogPostsReadDocAccessFieldPolicy,
	},
	CmsBlogPostsUpdateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsUpdateAccessKeySpecifier | (() => undefined | CmsBlogPostsUpdateAccessKeySpecifier),
		fields?: CmsBlogPostsUpdateAccessFieldPolicy,
	},
	CmsBlogPostsUpdateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsBlogPostsUpdateDocAccessKeySpecifier | (() => undefined | CmsBlogPostsUpdateDocAccessKeySpecifier),
		fields?: CmsBlogPostsUpdateDocAccessFieldPolicy,
	},
	CmsGame?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGameKeySpecifier | (() => undefined | CmsGameKeySpecifier),
		fields?: CmsGameFieldPolicy,
	},
	CmsGame_GameTrailerEmbedId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGame_GameTrailerEmbedIdKeySpecifier | (() => undefined | CmsGame_GameTrailerEmbedIdKeySpecifier),
		fields?: CmsGame_GameTrailerEmbedIdFieldPolicy,
	},
	CmsGame_Images?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGame_ImagesKeySpecifier | (() => undefined | CmsGame_ImagesKeySpecifier),
		fields?: CmsGame_ImagesFieldPolicy,
	},
	CmsGamer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamerKeySpecifier | (() => undefined | CmsGamerKeySpecifier),
		fields?: CmsGamerFieldPolicy,
	},
	CmsGamer_GamerSocialMedia?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamer_GamerSocialMediaKeySpecifier | (() => undefined | CmsGamer_GamerSocialMediaKeySpecifier),
		fields?: CmsGamer_GamerSocialMediaFieldPolicy,
	},
	CmsGamers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersKeySpecifier | (() => undefined | CmsGamersKeySpecifier),
		fields?: CmsGamersFieldPolicy,
	},
	CmsGamersCreateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersCreateAccessKeySpecifier | (() => undefined | CmsGamersCreateAccessKeySpecifier),
		fields?: CmsGamersCreateAccessFieldPolicy,
	},
	CmsGamersCreateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersCreateDocAccessKeySpecifier | (() => undefined | CmsGamersCreateDocAccessKeySpecifier),
		fields?: CmsGamersCreateDocAccessFieldPolicy,
	},
	CmsGamersDeleteAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDeleteAccessKeySpecifier | (() => undefined | CmsGamersDeleteAccessKeySpecifier),
		fields?: CmsGamersDeleteAccessFieldPolicy,
	},
	CmsGamersDeleteDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDeleteDocAccessKeySpecifier | (() => undefined | CmsGamersDeleteDocAccessKeySpecifier),
		fields?: CmsGamersDeleteDocAccessFieldPolicy,
	},
	CmsGamersDocAccessFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFieldsKeySpecifier | (() => undefined | CmsGamersDocAccessFieldsKeySpecifier),
		fields?: CmsGamersDocAccessFieldsFieldPolicy,
	},
	CmsGamersDocAccessFields_avatar?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_avatarKeySpecifier | (() => undefined | CmsGamersDocAccessFields_avatarKeySpecifier),
		fields?: CmsGamersDocAccessFields_avatarFieldPolicy,
	},
	CmsGamersDocAccessFields_avatar_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_avatar_CreateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_avatar_CreateKeySpecifier),
		fields?: CmsGamersDocAccessFields_avatar_CreateFieldPolicy,
	},
	CmsGamersDocAccessFields_avatar_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_avatar_DeleteKeySpecifier | (() => undefined | CmsGamersDocAccessFields_avatar_DeleteKeySpecifier),
		fields?: CmsGamersDocAccessFields_avatar_DeleteFieldPolicy,
	},
	CmsGamersDocAccessFields_avatar_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_avatar_ReadKeySpecifier | (() => undefined | CmsGamersDocAccessFields_avatar_ReadKeySpecifier),
		fields?: CmsGamersDocAccessFields_avatar_ReadFieldPolicy,
	},
	CmsGamersDocAccessFields_avatar_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_avatar_UpdateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_avatar_UpdateKeySpecifier),
		fields?: CmsGamersDocAccessFields_avatar_UpdateFieldPolicy,
	},
	CmsGamersDocAccessFields_country?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_countryKeySpecifier | (() => undefined | CmsGamersDocAccessFields_countryKeySpecifier),
		fields?: CmsGamersDocAccessFields_countryFieldPolicy,
	},
	CmsGamersDocAccessFields_country_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_country_CreateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_country_CreateKeySpecifier),
		fields?: CmsGamersDocAccessFields_country_CreateFieldPolicy,
	},
	CmsGamersDocAccessFields_country_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_country_DeleteKeySpecifier | (() => undefined | CmsGamersDocAccessFields_country_DeleteKeySpecifier),
		fields?: CmsGamersDocAccessFields_country_DeleteFieldPolicy,
	},
	CmsGamersDocAccessFields_country_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_country_ReadKeySpecifier | (() => undefined | CmsGamersDocAccessFields_country_ReadKeySpecifier),
		fields?: CmsGamersDocAccessFields_country_ReadFieldPolicy,
	},
	CmsGamersDocAccessFields_country_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_country_UpdateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_country_UpdateKeySpecifier),
		fields?: CmsGamersDocAccessFields_country_UpdateFieldPolicy,
	},
	CmsGamersDocAccessFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_createdAtKeySpecifier | (() => undefined | CmsGamersDocAccessFields_createdAtKeySpecifier),
		fields?: CmsGamersDocAccessFields_createdAtFieldPolicy,
	},
	CmsGamersDocAccessFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_createdAt_CreateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_createdAt_CreateKeySpecifier),
		fields?: CmsGamersDocAccessFields_createdAt_CreateFieldPolicy,
	},
	CmsGamersDocAccessFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsGamersDocAccessFields_createdAt_DeleteKeySpecifier),
		fields?: CmsGamersDocAccessFields_createdAt_DeleteFieldPolicy,
	},
	CmsGamersDocAccessFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_createdAt_ReadKeySpecifier | (() => undefined | CmsGamersDocAccessFields_createdAt_ReadKeySpecifier),
		fields?: CmsGamersDocAccessFields_createdAt_ReadFieldPolicy,
	},
	CmsGamersDocAccessFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_createdAt_UpdateKeySpecifier),
		fields?: CmsGamersDocAccessFields_createdAt_UpdateFieldPolicy,
	},
	CmsGamersDocAccessFields_description?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_descriptionKeySpecifier | (() => undefined | CmsGamersDocAccessFields_descriptionKeySpecifier),
		fields?: CmsGamersDocAccessFields_descriptionFieldPolicy,
	},
	CmsGamersDocAccessFields_description_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_description_CreateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_description_CreateKeySpecifier),
		fields?: CmsGamersDocAccessFields_description_CreateFieldPolicy,
	},
	CmsGamersDocAccessFields_description_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_description_DeleteKeySpecifier | (() => undefined | CmsGamersDocAccessFields_description_DeleteKeySpecifier),
		fields?: CmsGamersDocAccessFields_description_DeleteFieldPolicy,
	},
	CmsGamersDocAccessFields_description_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_description_ReadKeySpecifier | (() => undefined | CmsGamersDocAccessFields_description_ReadKeySpecifier),
		fields?: CmsGamersDocAccessFields_description_ReadFieldPolicy,
	},
	CmsGamersDocAccessFields_description_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_description_UpdateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_description_UpdateKeySpecifier),
		fields?: CmsGamersDocAccessFields_description_UpdateFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMediaKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMediaKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMediaFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_CreateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_CreateKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_CreateFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_DeleteKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_DeleteKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_DeleteFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_FieldsKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_FieldsKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_FieldsFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_ReadKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_ReadKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_ReadFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_UpdateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_UpdateKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_UpdateFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_idKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_idKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_idFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_id_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_id_CreateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_id_CreateKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_id_CreateFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_id_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_id_DeleteKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_id_DeleteKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_id_DeleteFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_id_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_id_ReadKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_id_ReadKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_id_ReadFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_id_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_id_UpdateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_id_UpdateKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_id_UpdateFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_link?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_linkKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_linkKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_linkFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_link_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_link_CreateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_link_CreateKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_link_CreateFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_link_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_link_DeleteKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_link_DeleteKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_link_DeleteFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_link_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_link_ReadKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_link_ReadKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_link_ReadFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_link_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_link_UpdateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_link_UpdateKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_link_UpdateFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_platform?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_platformKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_platformKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_platformFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_platform_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_platform_CreateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_platform_CreateKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_platform_CreateFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_platform_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_platform_DeleteKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_platform_DeleteKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_platform_DeleteFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_platform_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_platform_ReadKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_platform_ReadKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_platform_ReadFieldPolicy,
	},
	CmsGamersDocAccessFields_gamerSocialMedia_platform_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_gamerSocialMedia_platform_UpdateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_gamerSocialMedia_platform_UpdateKeySpecifier),
		fields?: CmsGamersDocAccessFields_gamerSocialMedia_platform_UpdateFieldPolicy,
	},
	CmsGamersDocAccessFields_name?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_nameKeySpecifier | (() => undefined | CmsGamersDocAccessFields_nameKeySpecifier),
		fields?: CmsGamersDocAccessFields_nameFieldPolicy,
	},
	CmsGamersDocAccessFields_name_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_name_CreateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_name_CreateKeySpecifier),
		fields?: CmsGamersDocAccessFields_name_CreateFieldPolicy,
	},
	CmsGamersDocAccessFields_name_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_name_DeleteKeySpecifier | (() => undefined | CmsGamersDocAccessFields_name_DeleteKeySpecifier),
		fields?: CmsGamersDocAccessFields_name_DeleteFieldPolicy,
	},
	CmsGamersDocAccessFields_name_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_name_ReadKeySpecifier | (() => undefined | CmsGamersDocAccessFields_name_ReadKeySpecifier),
		fields?: CmsGamersDocAccessFields_name_ReadFieldPolicy,
	},
	CmsGamersDocAccessFields_name_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_name_UpdateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_name_UpdateKeySpecifier),
		fields?: CmsGamersDocAccessFields_name_UpdateFieldPolicy,
	},
	CmsGamersDocAccessFields_nickname?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_nicknameKeySpecifier | (() => undefined | CmsGamersDocAccessFields_nicknameKeySpecifier),
		fields?: CmsGamersDocAccessFields_nicknameFieldPolicy,
	},
	CmsGamersDocAccessFields_nickname_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_nickname_CreateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_nickname_CreateKeySpecifier),
		fields?: CmsGamersDocAccessFields_nickname_CreateFieldPolicy,
	},
	CmsGamersDocAccessFields_nickname_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_nickname_DeleteKeySpecifier | (() => undefined | CmsGamersDocAccessFields_nickname_DeleteKeySpecifier),
		fields?: CmsGamersDocAccessFields_nickname_DeleteFieldPolicy,
	},
	CmsGamersDocAccessFields_nickname_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_nickname_ReadKeySpecifier | (() => undefined | CmsGamersDocAccessFields_nickname_ReadKeySpecifier),
		fields?: CmsGamersDocAccessFields_nickname_ReadFieldPolicy,
	},
	CmsGamersDocAccessFields_nickname_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_nickname_UpdateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_nickname_UpdateKeySpecifier),
		fields?: CmsGamersDocAccessFields_nickname_UpdateFieldPolicy,
	},
	CmsGamersDocAccessFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_updatedAtKeySpecifier | (() => undefined | CmsGamersDocAccessFields_updatedAtKeySpecifier),
		fields?: CmsGamersDocAccessFields_updatedAtFieldPolicy,
	},
	CmsGamersDocAccessFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_updatedAt_CreateKeySpecifier),
		fields?: CmsGamersDocAccessFields_updatedAt_CreateFieldPolicy,
	},
	CmsGamersDocAccessFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsGamersDocAccessFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsGamersDocAccessFields_updatedAt_DeleteFieldPolicy,
	},
	CmsGamersDocAccessFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsGamersDocAccessFields_updatedAt_ReadKeySpecifier),
		fields?: CmsGamersDocAccessFields_updatedAt_ReadFieldPolicy,
	},
	CmsGamersDocAccessFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersDocAccessFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsGamersDocAccessFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsGamersDocAccessFields_updatedAt_UpdateFieldPolicy,
	},
	CmsGamersFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFieldsKeySpecifier | (() => undefined | CmsGamersFieldsKeySpecifier),
		fields?: CmsGamersFieldsFieldPolicy,
	},
	CmsGamersFields_avatar?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_avatarKeySpecifier | (() => undefined | CmsGamersFields_avatarKeySpecifier),
		fields?: CmsGamersFields_avatarFieldPolicy,
	},
	CmsGamersFields_avatar_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_avatar_CreateKeySpecifier | (() => undefined | CmsGamersFields_avatar_CreateKeySpecifier),
		fields?: CmsGamersFields_avatar_CreateFieldPolicy,
	},
	CmsGamersFields_avatar_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_avatar_DeleteKeySpecifier | (() => undefined | CmsGamersFields_avatar_DeleteKeySpecifier),
		fields?: CmsGamersFields_avatar_DeleteFieldPolicy,
	},
	CmsGamersFields_avatar_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_avatar_ReadKeySpecifier | (() => undefined | CmsGamersFields_avatar_ReadKeySpecifier),
		fields?: CmsGamersFields_avatar_ReadFieldPolicy,
	},
	CmsGamersFields_avatar_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_avatar_UpdateKeySpecifier | (() => undefined | CmsGamersFields_avatar_UpdateKeySpecifier),
		fields?: CmsGamersFields_avatar_UpdateFieldPolicy,
	},
	CmsGamersFields_country?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_countryKeySpecifier | (() => undefined | CmsGamersFields_countryKeySpecifier),
		fields?: CmsGamersFields_countryFieldPolicy,
	},
	CmsGamersFields_country_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_country_CreateKeySpecifier | (() => undefined | CmsGamersFields_country_CreateKeySpecifier),
		fields?: CmsGamersFields_country_CreateFieldPolicy,
	},
	CmsGamersFields_country_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_country_DeleteKeySpecifier | (() => undefined | CmsGamersFields_country_DeleteKeySpecifier),
		fields?: CmsGamersFields_country_DeleteFieldPolicy,
	},
	CmsGamersFields_country_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_country_ReadKeySpecifier | (() => undefined | CmsGamersFields_country_ReadKeySpecifier),
		fields?: CmsGamersFields_country_ReadFieldPolicy,
	},
	CmsGamersFields_country_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_country_UpdateKeySpecifier | (() => undefined | CmsGamersFields_country_UpdateKeySpecifier),
		fields?: CmsGamersFields_country_UpdateFieldPolicy,
	},
	CmsGamersFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_createdAtKeySpecifier | (() => undefined | CmsGamersFields_createdAtKeySpecifier),
		fields?: CmsGamersFields_createdAtFieldPolicy,
	},
	CmsGamersFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_createdAt_CreateKeySpecifier | (() => undefined | CmsGamersFields_createdAt_CreateKeySpecifier),
		fields?: CmsGamersFields_createdAt_CreateFieldPolicy,
	},
	CmsGamersFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsGamersFields_createdAt_DeleteKeySpecifier),
		fields?: CmsGamersFields_createdAt_DeleteFieldPolicy,
	},
	CmsGamersFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_createdAt_ReadKeySpecifier | (() => undefined | CmsGamersFields_createdAt_ReadKeySpecifier),
		fields?: CmsGamersFields_createdAt_ReadFieldPolicy,
	},
	CmsGamersFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsGamersFields_createdAt_UpdateKeySpecifier),
		fields?: CmsGamersFields_createdAt_UpdateFieldPolicy,
	},
	CmsGamersFields_description?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_descriptionKeySpecifier | (() => undefined | CmsGamersFields_descriptionKeySpecifier),
		fields?: CmsGamersFields_descriptionFieldPolicy,
	},
	CmsGamersFields_description_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_description_CreateKeySpecifier | (() => undefined | CmsGamersFields_description_CreateKeySpecifier),
		fields?: CmsGamersFields_description_CreateFieldPolicy,
	},
	CmsGamersFields_description_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_description_DeleteKeySpecifier | (() => undefined | CmsGamersFields_description_DeleteKeySpecifier),
		fields?: CmsGamersFields_description_DeleteFieldPolicy,
	},
	CmsGamersFields_description_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_description_ReadKeySpecifier | (() => undefined | CmsGamersFields_description_ReadKeySpecifier),
		fields?: CmsGamersFields_description_ReadFieldPolicy,
	},
	CmsGamersFields_description_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_description_UpdateKeySpecifier | (() => undefined | CmsGamersFields_description_UpdateKeySpecifier),
		fields?: CmsGamersFields_description_UpdateFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMediaKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMediaKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMediaFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_CreateKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_CreateKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_CreateFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_DeleteKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_DeleteKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_DeleteFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_FieldsKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_FieldsKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_FieldsFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_ReadKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_ReadKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_ReadFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_UpdateKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_UpdateKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_UpdateFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_idKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_idKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_idFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_id_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_id_CreateKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_id_CreateKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_id_CreateFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_id_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_id_DeleteKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_id_DeleteKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_id_DeleteFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_id_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_id_ReadKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_id_ReadKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_id_ReadFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_id_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_id_UpdateKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_id_UpdateKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_id_UpdateFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_link?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_linkKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_linkKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_linkFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_link_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_link_CreateKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_link_CreateKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_link_CreateFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_link_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_link_DeleteKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_link_DeleteKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_link_DeleteFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_link_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_link_ReadKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_link_ReadKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_link_ReadFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_link_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_link_UpdateKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_link_UpdateKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_link_UpdateFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_platform?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_platformKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_platformKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_platformFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_platform_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_platform_CreateKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_platform_CreateKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_platform_CreateFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_platform_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_platform_DeleteKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_platform_DeleteKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_platform_DeleteFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_platform_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_platform_ReadKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_platform_ReadKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_platform_ReadFieldPolicy,
	},
	CmsGamersFields_gamerSocialMedia_platform_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_gamerSocialMedia_platform_UpdateKeySpecifier | (() => undefined | CmsGamersFields_gamerSocialMedia_platform_UpdateKeySpecifier),
		fields?: CmsGamersFields_gamerSocialMedia_platform_UpdateFieldPolicy,
	},
	CmsGamersFields_name?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_nameKeySpecifier | (() => undefined | CmsGamersFields_nameKeySpecifier),
		fields?: CmsGamersFields_nameFieldPolicy,
	},
	CmsGamersFields_name_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_name_CreateKeySpecifier | (() => undefined | CmsGamersFields_name_CreateKeySpecifier),
		fields?: CmsGamersFields_name_CreateFieldPolicy,
	},
	CmsGamersFields_name_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_name_DeleteKeySpecifier | (() => undefined | CmsGamersFields_name_DeleteKeySpecifier),
		fields?: CmsGamersFields_name_DeleteFieldPolicy,
	},
	CmsGamersFields_name_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_name_ReadKeySpecifier | (() => undefined | CmsGamersFields_name_ReadKeySpecifier),
		fields?: CmsGamersFields_name_ReadFieldPolicy,
	},
	CmsGamersFields_name_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_name_UpdateKeySpecifier | (() => undefined | CmsGamersFields_name_UpdateKeySpecifier),
		fields?: CmsGamersFields_name_UpdateFieldPolicy,
	},
	CmsGamersFields_nickname?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_nicknameKeySpecifier | (() => undefined | CmsGamersFields_nicknameKeySpecifier),
		fields?: CmsGamersFields_nicknameFieldPolicy,
	},
	CmsGamersFields_nickname_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_nickname_CreateKeySpecifier | (() => undefined | CmsGamersFields_nickname_CreateKeySpecifier),
		fields?: CmsGamersFields_nickname_CreateFieldPolicy,
	},
	CmsGamersFields_nickname_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_nickname_DeleteKeySpecifier | (() => undefined | CmsGamersFields_nickname_DeleteKeySpecifier),
		fields?: CmsGamersFields_nickname_DeleteFieldPolicy,
	},
	CmsGamersFields_nickname_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_nickname_ReadKeySpecifier | (() => undefined | CmsGamersFields_nickname_ReadKeySpecifier),
		fields?: CmsGamersFields_nickname_ReadFieldPolicy,
	},
	CmsGamersFields_nickname_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_nickname_UpdateKeySpecifier | (() => undefined | CmsGamersFields_nickname_UpdateKeySpecifier),
		fields?: CmsGamersFields_nickname_UpdateFieldPolicy,
	},
	CmsGamersFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_updatedAtKeySpecifier | (() => undefined | CmsGamersFields_updatedAtKeySpecifier),
		fields?: CmsGamersFields_updatedAtFieldPolicy,
	},
	CmsGamersFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsGamersFields_updatedAt_CreateKeySpecifier),
		fields?: CmsGamersFields_updatedAt_CreateFieldPolicy,
	},
	CmsGamersFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsGamersFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsGamersFields_updatedAt_DeleteFieldPolicy,
	},
	CmsGamersFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsGamersFields_updatedAt_ReadKeySpecifier),
		fields?: CmsGamersFields_updatedAt_ReadFieldPolicy,
	},
	CmsGamersFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsGamersFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsGamersFields_updatedAt_UpdateFieldPolicy,
	},
	CmsGamersReadAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersReadAccessKeySpecifier | (() => undefined | CmsGamersReadAccessKeySpecifier),
		fields?: CmsGamersReadAccessFieldPolicy,
	},
	CmsGamersReadDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersReadDocAccessKeySpecifier | (() => undefined | CmsGamersReadDocAccessKeySpecifier),
		fields?: CmsGamersReadDocAccessFieldPolicy,
	},
	CmsGamersUpdateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersUpdateAccessKeySpecifier | (() => undefined | CmsGamersUpdateAccessKeySpecifier),
		fields?: CmsGamersUpdateAccessFieldPolicy,
	},
	CmsGamersUpdateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamersUpdateDocAccessKeySpecifier | (() => undefined | CmsGamersUpdateDocAccessKeySpecifier),
		fields?: CmsGamersUpdateDocAccessFieldPolicy,
	},
	CmsGames?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesKeySpecifier | (() => undefined | CmsGamesKeySpecifier),
		fields?: CmsGamesFieldPolicy,
	},
	CmsGamesCreateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesCreateAccessKeySpecifier | (() => undefined | CmsGamesCreateAccessKeySpecifier),
		fields?: CmsGamesCreateAccessFieldPolicy,
	},
	CmsGamesCreateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesCreateDocAccessKeySpecifier | (() => undefined | CmsGamesCreateDocAccessKeySpecifier),
		fields?: CmsGamesCreateDocAccessFieldPolicy,
	},
	CmsGamesDeleteAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDeleteAccessKeySpecifier | (() => undefined | CmsGamesDeleteAccessKeySpecifier),
		fields?: CmsGamesDeleteAccessFieldPolicy,
	},
	CmsGamesDeleteDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDeleteDocAccessKeySpecifier | (() => undefined | CmsGamesDeleteDocAccessKeySpecifier),
		fields?: CmsGamesDeleteDocAccessFieldPolicy,
	},
	CmsGamesDocAccessFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFieldsKeySpecifier | (() => undefined | CmsGamesDocAccessFieldsKeySpecifier),
		fields?: CmsGamesDocAccessFieldsFieldPolicy,
	},
	CmsGamesDocAccessFields_avatar?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_avatarKeySpecifier | (() => undefined | CmsGamesDocAccessFields_avatarKeySpecifier),
		fields?: CmsGamesDocAccessFields_avatarFieldPolicy,
	},
	CmsGamesDocAccessFields_avatar_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_avatar_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_avatar_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_avatar_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_avatar_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_avatar_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_avatar_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_avatar_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_avatar_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_avatar_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_avatar_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_avatar_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_avatar_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_avatar_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_avatar_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_avatar_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_company?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_companyKeySpecifier | (() => undefined | CmsGamesDocAccessFields_companyKeySpecifier),
		fields?: CmsGamesDocAccessFields_companyFieldPolicy,
	},
	CmsGamesDocAccessFields_company_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_company_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_company_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_company_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_company_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_company_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_company_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_company_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_company_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_company_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_company_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_company_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_company_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_company_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_company_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_company_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_content?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_contentKeySpecifier | (() => undefined | CmsGamesDocAccessFields_contentKeySpecifier),
		fields?: CmsGamesDocAccessFields_contentFieldPolicy,
	},
	CmsGamesDocAccessFields_content_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_content_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_content_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_content_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_content_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_content_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_content_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_content_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_content_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_content_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_content_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_content_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_content_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_content_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_content_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_content_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_createdAtKeySpecifier | (() => undefined | CmsGamesDocAccessFields_createdAtKeySpecifier),
		fields?: CmsGamesDocAccessFields_createdAtFieldPolicy,
	},
	CmsGamesDocAccessFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_createdAt_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_createdAt_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_createdAt_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_createdAt_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_createdAt_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_createdAt_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_createdAt_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_createdAt_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_createdAt_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_createdAt_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_gameBanner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameBannerKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameBannerKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameBannerFieldPolicy,
	},
	CmsGamesDocAccessFields_gameBanner_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameBanner_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameBanner_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameBanner_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_gameBanner_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameBanner_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameBanner_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameBanner_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_gameBanner_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameBanner_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameBanner_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameBanner_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_gameBanner_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameBanner_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameBanner_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameBanner_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_gameLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameLinkKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameLinkKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameLinkFieldPolicy,
	},
	CmsGamesDocAccessFields_gameLink_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameLink_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameLink_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameLink_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_gameLink_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameLink_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameLink_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameLink_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_gameLink_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameLink_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameLink_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameLink_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_gameLink_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameLink_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameLink_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameLink_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedIdKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedIdKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedIdFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_FieldsKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_FieldsKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_FieldsFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_embedId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_embedIdKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_embedIdKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_embedIdFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_embedId_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_title?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_titleKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_titleKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_titleFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_title_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_title_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_title_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_title_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_title_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_title_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_title_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_title_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_title_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_title_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_title_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_title_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_gameTrailerEmbedId_title_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_gameTrailerEmbedId_title_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_gameTrailerEmbedId_title_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_gameTrailerEmbedId_title_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_images?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_imagesKeySpecifier | (() => undefined | CmsGamesDocAccessFields_imagesKeySpecifier),
		fields?: CmsGamesDocAccessFields_imagesFieldPolicy,
	},
	CmsGamesDocAccessFields_images_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_images_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_images_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_FieldsKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_FieldsKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_FieldsFieldPolicy,
	},
	CmsGamesDocAccessFields_images_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_images_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_images_id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_idKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_idKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_idFieldPolicy,
	},
	CmsGamesDocAccessFields_images_id_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_id_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_id_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_id_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_images_id_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_id_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_id_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_id_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_images_id_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_id_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_id_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_id_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_images_id_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_id_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_id_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_id_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_images_image?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_imageKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_imageKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_imageFieldPolicy,
	},
	CmsGamesDocAccessFields_images_image_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_image_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_image_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_image_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_images_image_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_image_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_image_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_image_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_images_image_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_image_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_image_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_image_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_images_image_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_images_image_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_images_image_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_images_image_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_name?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_nameKeySpecifier | (() => undefined | CmsGamesDocAccessFields_nameKeySpecifier),
		fields?: CmsGamesDocAccessFields_nameFieldPolicy,
	},
	CmsGamesDocAccessFields_name_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_name_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_name_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_name_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_name_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_name_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_name_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_name_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_name_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_name_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_name_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_name_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_name_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_name_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_name_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_name_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_relatedGames?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_relatedGamesKeySpecifier | (() => undefined | CmsGamesDocAccessFields_relatedGamesKeySpecifier),
		fields?: CmsGamesDocAccessFields_relatedGamesFieldPolicy,
	},
	CmsGamesDocAccessFields_relatedGames_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_relatedGames_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_relatedGames_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_relatedGames_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_relatedGames_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_relatedGames_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_relatedGames_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_relatedGames_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_relatedGames_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_relatedGames_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_relatedGames_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_relatedGames_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_relatedGames_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_relatedGames_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_relatedGames_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_relatedGames_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_shortDescription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_shortDescriptionKeySpecifier | (() => undefined | CmsGamesDocAccessFields_shortDescriptionKeySpecifier),
		fields?: CmsGamesDocAccessFields_shortDescriptionFieldPolicy,
	},
	CmsGamesDocAccessFields_shortDescription_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_shortDescription_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_shortDescription_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_shortDescription_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_shortDescription_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_shortDescription_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_shortDescription_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_shortDescription_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_shortDescription_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_shortDescription_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_shortDescription_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_shortDescription_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_shortDescription_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_shortDescription_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_shortDescription_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_shortDescription_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_status?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_statusKeySpecifier | (() => undefined | CmsGamesDocAccessFields_statusKeySpecifier),
		fields?: CmsGamesDocAccessFields_statusFieldPolicy,
	},
	CmsGamesDocAccessFields_status_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_status_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_status_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_status_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_status_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_status_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_status_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_status_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_status_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_status_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_status_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_status_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_status_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_status_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_status_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_status_UpdateFieldPolicy,
	},
	CmsGamesDocAccessFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_updatedAtKeySpecifier | (() => undefined | CmsGamesDocAccessFields_updatedAtKeySpecifier),
		fields?: CmsGamesDocAccessFields_updatedAtFieldPolicy,
	},
	CmsGamesDocAccessFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_updatedAt_CreateKeySpecifier),
		fields?: CmsGamesDocAccessFields_updatedAt_CreateFieldPolicy,
	},
	CmsGamesDocAccessFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsGamesDocAccessFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsGamesDocAccessFields_updatedAt_DeleteFieldPolicy,
	},
	CmsGamesDocAccessFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsGamesDocAccessFields_updatedAt_ReadKeySpecifier),
		fields?: CmsGamesDocAccessFields_updatedAt_ReadFieldPolicy,
	},
	CmsGamesDocAccessFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesDocAccessFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsGamesDocAccessFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsGamesDocAccessFields_updatedAt_UpdateFieldPolicy,
	},
	CmsGamesFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFieldsKeySpecifier | (() => undefined | CmsGamesFieldsKeySpecifier),
		fields?: CmsGamesFieldsFieldPolicy,
	},
	CmsGamesFields_avatar?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_avatarKeySpecifier | (() => undefined | CmsGamesFields_avatarKeySpecifier),
		fields?: CmsGamesFields_avatarFieldPolicy,
	},
	CmsGamesFields_avatar_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_avatar_CreateKeySpecifier | (() => undefined | CmsGamesFields_avatar_CreateKeySpecifier),
		fields?: CmsGamesFields_avatar_CreateFieldPolicy,
	},
	CmsGamesFields_avatar_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_avatar_DeleteKeySpecifier | (() => undefined | CmsGamesFields_avatar_DeleteKeySpecifier),
		fields?: CmsGamesFields_avatar_DeleteFieldPolicy,
	},
	CmsGamesFields_avatar_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_avatar_ReadKeySpecifier | (() => undefined | CmsGamesFields_avatar_ReadKeySpecifier),
		fields?: CmsGamesFields_avatar_ReadFieldPolicy,
	},
	CmsGamesFields_avatar_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_avatar_UpdateKeySpecifier | (() => undefined | CmsGamesFields_avatar_UpdateKeySpecifier),
		fields?: CmsGamesFields_avatar_UpdateFieldPolicy,
	},
	CmsGamesFields_company?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_companyKeySpecifier | (() => undefined | CmsGamesFields_companyKeySpecifier),
		fields?: CmsGamesFields_companyFieldPolicy,
	},
	CmsGamesFields_company_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_company_CreateKeySpecifier | (() => undefined | CmsGamesFields_company_CreateKeySpecifier),
		fields?: CmsGamesFields_company_CreateFieldPolicy,
	},
	CmsGamesFields_company_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_company_DeleteKeySpecifier | (() => undefined | CmsGamesFields_company_DeleteKeySpecifier),
		fields?: CmsGamesFields_company_DeleteFieldPolicy,
	},
	CmsGamesFields_company_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_company_ReadKeySpecifier | (() => undefined | CmsGamesFields_company_ReadKeySpecifier),
		fields?: CmsGamesFields_company_ReadFieldPolicy,
	},
	CmsGamesFields_company_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_company_UpdateKeySpecifier | (() => undefined | CmsGamesFields_company_UpdateKeySpecifier),
		fields?: CmsGamesFields_company_UpdateFieldPolicy,
	},
	CmsGamesFields_content?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_contentKeySpecifier | (() => undefined | CmsGamesFields_contentKeySpecifier),
		fields?: CmsGamesFields_contentFieldPolicy,
	},
	CmsGamesFields_content_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_content_CreateKeySpecifier | (() => undefined | CmsGamesFields_content_CreateKeySpecifier),
		fields?: CmsGamesFields_content_CreateFieldPolicy,
	},
	CmsGamesFields_content_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_content_DeleteKeySpecifier | (() => undefined | CmsGamesFields_content_DeleteKeySpecifier),
		fields?: CmsGamesFields_content_DeleteFieldPolicy,
	},
	CmsGamesFields_content_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_content_ReadKeySpecifier | (() => undefined | CmsGamesFields_content_ReadKeySpecifier),
		fields?: CmsGamesFields_content_ReadFieldPolicy,
	},
	CmsGamesFields_content_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_content_UpdateKeySpecifier | (() => undefined | CmsGamesFields_content_UpdateKeySpecifier),
		fields?: CmsGamesFields_content_UpdateFieldPolicy,
	},
	CmsGamesFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_createdAtKeySpecifier | (() => undefined | CmsGamesFields_createdAtKeySpecifier),
		fields?: CmsGamesFields_createdAtFieldPolicy,
	},
	CmsGamesFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_createdAt_CreateKeySpecifier | (() => undefined | CmsGamesFields_createdAt_CreateKeySpecifier),
		fields?: CmsGamesFields_createdAt_CreateFieldPolicy,
	},
	CmsGamesFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsGamesFields_createdAt_DeleteKeySpecifier),
		fields?: CmsGamesFields_createdAt_DeleteFieldPolicy,
	},
	CmsGamesFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_createdAt_ReadKeySpecifier | (() => undefined | CmsGamesFields_createdAt_ReadKeySpecifier),
		fields?: CmsGamesFields_createdAt_ReadFieldPolicy,
	},
	CmsGamesFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsGamesFields_createdAt_UpdateKeySpecifier),
		fields?: CmsGamesFields_createdAt_UpdateFieldPolicy,
	},
	CmsGamesFields_gameBanner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameBannerKeySpecifier | (() => undefined | CmsGamesFields_gameBannerKeySpecifier),
		fields?: CmsGamesFields_gameBannerFieldPolicy,
	},
	CmsGamesFields_gameBanner_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameBanner_CreateKeySpecifier | (() => undefined | CmsGamesFields_gameBanner_CreateKeySpecifier),
		fields?: CmsGamesFields_gameBanner_CreateFieldPolicy,
	},
	CmsGamesFields_gameBanner_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameBanner_DeleteKeySpecifier | (() => undefined | CmsGamesFields_gameBanner_DeleteKeySpecifier),
		fields?: CmsGamesFields_gameBanner_DeleteFieldPolicy,
	},
	CmsGamesFields_gameBanner_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameBanner_ReadKeySpecifier | (() => undefined | CmsGamesFields_gameBanner_ReadKeySpecifier),
		fields?: CmsGamesFields_gameBanner_ReadFieldPolicy,
	},
	CmsGamesFields_gameBanner_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameBanner_UpdateKeySpecifier | (() => undefined | CmsGamesFields_gameBanner_UpdateKeySpecifier),
		fields?: CmsGamesFields_gameBanner_UpdateFieldPolicy,
	},
	CmsGamesFields_gameLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameLinkKeySpecifier | (() => undefined | CmsGamesFields_gameLinkKeySpecifier),
		fields?: CmsGamesFields_gameLinkFieldPolicy,
	},
	CmsGamesFields_gameLink_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameLink_CreateKeySpecifier | (() => undefined | CmsGamesFields_gameLink_CreateKeySpecifier),
		fields?: CmsGamesFields_gameLink_CreateFieldPolicy,
	},
	CmsGamesFields_gameLink_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameLink_DeleteKeySpecifier | (() => undefined | CmsGamesFields_gameLink_DeleteKeySpecifier),
		fields?: CmsGamesFields_gameLink_DeleteFieldPolicy,
	},
	CmsGamesFields_gameLink_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameLink_ReadKeySpecifier | (() => undefined | CmsGamesFields_gameLink_ReadKeySpecifier),
		fields?: CmsGamesFields_gameLink_ReadFieldPolicy,
	},
	CmsGamesFields_gameLink_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameLink_UpdateKeySpecifier | (() => undefined | CmsGamesFields_gameLink_UpdateKeySpecifier),
		fields?: CmsGamesFields_gameLink_UpdateFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedIdKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedIdKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedIdFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_CreateKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_CreateKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_CreateFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_DeleteKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_DeleteKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_DeleteFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_FieldsKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_FieldsKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_FieldsFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_ReadKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_ReadKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_ReadFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_UpdateKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_UpdateKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_UpdateFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_embedId?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_embedIdKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_embedIdKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_embedIdFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_embedId_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_embedId_CreateKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_embedId_CreateKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_embedId_CreateFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_embedId_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_embedId_DeleteKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_embedId_DeleteKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_embedId_DeleteFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_embedId_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_embedId_ReadKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_embedId_ReadKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_embedId_ReadFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_embedId_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_embedId_UpdateKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_embedId_UpdateKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_embedId_UpdateFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_title?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_titleKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_titleKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_titleFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_title_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_title_CreateKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_title_CreateKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_title_CreateFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_title_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_title_DeleteKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_title_DeleteKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_title_DeleteFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_title_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_title_ReadKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_title_ReadKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_title_ReadFieldPolicy,
	},
	CmsGamesFields_gameTrailerEmbedId_title_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_gameTrailerEmbedId_title_UpdateKeySpecifier | (() => undefined | CmsGamesFields_gameTrailerEmbedId_title_UpdateKeySpecifier),
		fields?: CmsGamesFields_gameTrailerEmbedId_title_UpdateFieldPolicy,
	},
	CmsGamesFields_images?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_imagesKeySpecifier | (() => undefined | CmsGamesFields_imagesKeySpecifier),
		fields?: CmsGamesFields_imagesFieldPolicy,
	},
	CmsGamesFields_images_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_CreateKeySpecifier | (() => undefined | CmsGamesFields_images_CreateKeySpecifier),
		fields?: CmsGamesFields_images_CreateFieldPolicy,
	},
	CmsGamesFields_images_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_DeleteKeySpecifier | (() => undefined | CmsGamesFields_images_DeleteKeySpecifier),
		fields?: CmsGamesFields_images_DeleteFieldPolicy,
	},
	CmsGamesFields_images_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_FieldsKeySpecifier | (() => undefined | CmsGamesFields_images_FieldsKeySpecifier),
		fields?: CmsGamesFields_images_FieldsFieldPolicy,
	},
	CmsGamesFields_images_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_ReadKeySpecifier | (() => undefined | CmsGamesFields_images_ReadKeySpecifier),
		fields?: CmsGamesFields_images_ReadFieldPolicy,
	},
	CmsGamesFields_images_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_UpdateKeySpecifier | (() => undefined | CmsGamesFields_images_UpdateKeySpecifier),
		fields?: CmsGamesFields_images_UpdateFieldPolicy,
	},
	CmsGamesFields_images_id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_idKeySpecifier | (() => undefined | CmsGamesFields_images_idKeySpecifier),
		fields?: CmsGamesFields_images_idFieldPolicy,
	},
	CmsGamesFields_images_id_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_id_CreateKeySpecifier | (() => undefined | CmsGamesFields_images_id_CreateKeySpecifier),
		fields?: CmsGamesFields_images_id_CreateFieldPolicy,
	},
	CmsGamesFields_images_id_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_id_DeleteKeySpecifier | (() => undefined | CmsGamesFields_images_id_DeleteKeySpecifier),
		fields?: CmsGamesFields_images_id_DeleteFieldPolicy,
	},
	CmsGamesFields_images_id_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_id_ReadKeySpecifier | (() => undefined | CmsGamesFields_images_id_ReadKeySpecifier),
		fields?: CmsGamesFields_images_id_ReadFieldPolicy,
	},
	CmsGamesFields_images_id_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_id_UpdateKeySpecifier | (() => undefined | CmsGamesFields_images_id_UpdateKeySpecifier),
		fields?: CmsGamesFields_images_id_UpdateFieldPolicy,
	},
	CmsGamesFields_images_image?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_imageKeySpecifier | (() => undefined | CmsGamesFields_images_imageKeySpecifier),
		fields?: CmsGamesFields_images_imageFieldPolicy,
	},
	CmsGamesFields_images_image_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_image_CreateKeySpecifier | (() => undefined | CmsGamesFields_images_image_CreateKeySpecifier),
		fields?: CmsGamesFields_images_image_CreateFieldPolicy,
	},
	CmsGamesFields_images_image_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_image_DeleteKeySpecifier | (() => undefined | CmsGamesFields_images_image_DeleteKeySpecifier),
		fields?: CmsGamesFields_images_image_DeleteFieldPolicy,
	},
	CmsGamesFields_images_image_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_image_ReadKeySpecifier | (() => undefined | CmsGamesFields_images_image_ReadKeySpecifier),
		fields?: CmsGamesFields_images_image_ReadFieldPolicy,
	},
	CmsGamesFields_images_image_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_images_image_UpdateKeySpecifier | (() => undefined | CmsGamesFields_images_image_UpdateKeySpecifier),
		fields?: CmsGamesFields_images_image_UpdateFieldPolicy,
	},
	CmsGamesFields_name?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_nameKeySpecifier | (() => undefined | CmsGamesFields_nameKeySpecifier),
		fields?: CmsGamesFields_nameFieldPolicy,
	},
	CmsGamesFields_name_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_name_CreateKeySpecifier | (() => undefined | CmsGamesFields_name_CreateKeySpecifier),
		fields?: CmsGamesFields_name_CreateFieldPolicy,
	},
	CmsGamesFields_name_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_name_DeleteKeySpecifier | (() => undefined | CmsGamesFields_name_DeleteKeySpecifier),
		fields?: CmsGamesFields_name_DeleteFieldPolicy,
	},
	CmsGamesFields_name_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_name_ReadKeySpecifier | (() => undefined | CmsGamesFields_name_ReadKeySpecifier),
		fields?: CmsGamesFields_name_ReadFieldPolicy,
	},
	CmsGamesFields_name_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_name_UpdateKeySpecifier | (() => undefined | CmsGamesFields_name_UpdateKeySpecifier),
		fields?: CmsGamesFields_name_UpdateFieldPolicy,
	},
	CmsGamesFields_relatedGames?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_relatedGamesKeySpecifier | (() => undefined | CmsGamesFields_relatedGamesKeySpecifier),
		fields?: CmsGamesFields_relatedGamesFieldPolicy,
	},
	CmsGamesFields_relatedGames_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_relatedGames_CreateKeySpecifier | (() => undefined | CmsGamesFields_relatedGames_CreateKeySpecifier),
		fields?: CmsGamesFields_relatedGames_CreateFieldPolicy,
	},
	CmsGamesFields_relatedGames_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_relatedGames_DeleteKeySpecifier | (() => undefined | CmsGamesFields_relatedGames_DeleteKeySpecifier),
		fields?: CmsGamesFields_relatedGames_DeleteFieldPolicy,
	},
	CmsGamesFields_relatedGames_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_relatedGames_ReadKeySpecifier | (() => undefined | CmsGamesFields_relatedGames_ReadKeySpecifier),
		fields?: CmsGamesFields_relatedGames_ReadFieldPolicy,
	},
	CmsGamesFields_relatedGames_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_relatedGames_UpdateKeySpecifier | (() => undefined | CmsGamesFields_relatedGames_UpdateKeySpecifier),
		fields?: CmsGamesFields_relatedGames_UpdateFieldPolicy,
	},
	CmsGamesFields_shortDescription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_shortDescriptionKeySpecifier | (() => undefined | CmsGamesFields_shortDescriptionKeySpecifier),
		fields?: CmsGamesFields_shortDescriptionFieldPolicy,
	},
	CmsGamesFields_shortDescription_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_shortDescription_CreateKeySpecifier | (() => undefined | CmsGamesFields_shortDescription_CreateKeySpecifier),
		fields?: CmsGamesFields_shortDescription_CreateFieldPolicy,
	},
	CmsGamesFields_shortDescription_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_shortDescription_DeleteKeySpecifier | (() => undefined | CmsGamesFields_shortDescription_DeleteKeySpecifier),
		fields?: CmsGamesFields_shortDescription_DeleteFieldPolicy,
	},
	CmsGamesFields_shortDescription_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_shortDescription_ReadKeySpecifier | (() => undefined | CmsGamesFields_shortDescription_ReadKeySpecifier),
		fields?: CmsGamesFields_shortDescription_ReadFieldPolicy,
	},
	CmsGamesFields_shortDescription_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_shortDescription_UpdateKeySpecifier | (() => undefined | CmsGamesFields_shortDescription_UpdateKeySpecifier),
		fields?: CmsGamesFields_shortDescription_UpdateFieldPolicy,
	},
	CmsGamesFields_status?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_statusKeySpecifier | (() => undefined | CmsGamesFields_statusKeySpecifier),
		fields?: CmsGamesFields_statusFieldPolicy,
	},
	CmsGamesFields_status_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_status_CreateKeySpecifier | (() => undefined | CmsGamesFields_status_CreateKeySpecifier),
		fields?: CmsGamesFields_status_CreateFieldPolicy,
	},
	CmsGamesFields_status_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_status_DeleteKeySpecifier | (() => undefined | CmsGamesFields_status_DeleteKeySpecifier),
		fields?: CmsGamesFields_status_DeleteFieldPolicy,
	},
	CmsGamesFields_status_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_status_ReadKeySpecifier | (() => undefined | CmsGamesFields_status_ReadKeySpecifier),
		fields?: CmsGamesFields_status_ReadFieldPolicy,
	},
	CmsGamesFields_status_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_status_UpdateKeySpecifier | (() => undefined | CmsGamesFields_status_UpdateKeySpecifier),
		fields?: CmsGamesFields_status_UpdateFieldPolicy,
	},
	CmsGamesFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_updatedAtKeySpecifier | (() => undefined | CmsGamesFields_updatedAtKeySpecifier),
		fields?: CmsGamesFields_updatedAtFieldPolicy,
	},
	CmsGamesFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsGamesFields_updatedAt_CreateKeySpecifier),
		fields?: CmsGamesFields_updatedAt_CreateFieldPolicy,
	},
	CmsGamesFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsGamesFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsGamesFields_updatedAt_DeleteFieldPolicy,
	},
	CmsGamesFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsGamesFields_updatedAt_ReadKeySpecifier),
		fields?: CmsGamesFields_updatedAt_ReadFieldPolicy,
	},
	CmsGamesFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsGamesFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsGamesFields_updatedAt_UpdateFieldPolicy,
	},
	CmsGamesReadAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesReadAccessKeySpecifier | (() => undefined | CmsGamesReadAccessKeySpecifier),
		fields?: CmsGamesReadAccessFieldPolicy,
	},
	CmsGamesReadDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesReadDocAccessKeySpecifier | (() => undefined | CmsGamesReadDocAccessKeySpecifier),
		fields?: CmsGamesReadDocAccessFieldPolicy,
	},
	CmsGamesUpdateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesUpdateAccessKeySpecifier | (() => undefined | CmsGamesUpdateAccessKeySpecifier),
		fields?: CmsGamesUpdateAccessFieldPolicy,
	},
	CmsGamesUpdateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsGamesUpdateDocAccessKeySpecifier | (() => undefined | CmsGamesUpdateDocAccessKeySpecifier),
		fields?: CmsGamesUpdateDocAccessFieldPolicy,
	},
	CmsMedia?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaKeySpecifier | (() => undefined | CmsMediaKeySpecifier),
		fields?: CmsMediaFieldPolicy,
	},
	CmsMediaCreateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaCreateAccessKeySpecifier | (() => undefined | CmsMediaCreateAccessKeySpecifier),
		fields?: CmsMediaCreateAccessFieldPolicy,
	},
	CmsMediaCreateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaCreateDocAccessKeySpecifier | (() => undefined | CmsMediaCreateDocAccessKeySpecifier),
		fields?: CmsMediaCreateDocAccessFieldPolicy,
	},
	CmsMediaDeleteAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDeleteAccessKeySpecifier | (() => undefined | CmsMediaDeleteAccessKeySpecifier),
		fields?: CmsMediaDeleteAccessFieldPolicy,
	},
	CmsMediaDeleteDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDeleteDocAccessKeySpecifier | (() => undefined | CmsMediaDeleteDocAccessKeySpecifier),
		fields?: CmsMediaDeleteDocAccessFieldPolicy,
	},
	CmsMediaDocAccessFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFieldsKeySpecifier | (() => undefined | CmsMediaDocAccessFieldsKeySpecifier),
		fields?: CmsMediaDocAccessFieldsFieldPolicy,
	},
	CmsMediaDocAccessFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_createdAtKeySpecifier | (() => undefined | CmsMediaDocAccessFields_createdAtKeySpecifier),
		fields?: CmsMediaDocAccessFields_createdAtFieldPolicy,
	},
	CmsMediaDocAccessFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_createdAt_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_createdAt_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_createdAt_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_createdAt_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_createdAt_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_createdAt_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_createdAt_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_createdAt_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_createdAt_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_createdAt_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_filename?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_filenameKeySpecifier | (() => undefined | CmsMediaDocAccessFields_filenameKeySpecifier),
		fields?: CmsMediaDocAccessFields_filenameFieldPolicy,
	},
	CmsMediaDocAccessFields_filename_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_filename_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_filename_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_filename_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_filename_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_filename_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_filename_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_filename_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_filename_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_filename_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_filename_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_filename_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_filename_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_filename_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_filename_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_filename_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_filesize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_filesizeKeySpecifier | (() => undefined | CmsMediaDocAccessFields_filesizeKeySpecifier),
		fields?: CmsMediaDocAccessFields_filesizeFieldPolicy,
	},
	CmsMediaDocAccessFields_filesize_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_filesize_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_filesize_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_filesize_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_filesize_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_filesize_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_filesize_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_filesize_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_filesize_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_filesize_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_filesize_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_filesize_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_filesize_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_filesize_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_filesize_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_filesize_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_focalX?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_focalXKeySpecifier | (() => undefined | CmsMediaDocAccessFields_focalXKeySpecifier),
		fields?: CmsMediaDocAccessFields_focalXFieldPolicy,
	},
	CmsMediaDocAccessFields_focalX_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_focalX_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_focalX_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_focalX_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_focalX_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_focalX_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_focalX_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_focalX_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_focalX_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_focalX_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_focalX_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_focalX_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_focalX_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_focalX_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_focalX_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_focalX_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_focalY?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_focalYKeySpecifier | (() => undefined | CmsMediaDocAccessFields_focalYKeySpecifier),
		fields?: CmsMediaDocAccessFields_focalYFieldPolicy,
	},
	CmsMediaDocAccessFields_focalY_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_focalY_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_focalY_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_focalY_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_focalY_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_focalY_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_focalY_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_focalY_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_focalY_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_focalY_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_focalY_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_focalY_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_focalY_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_focalY_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_focalY_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_focalY_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_height?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_heightKeySpecifier | (() => undefined | CmsMediaDocAccessFields_heightKeySpecifier),
		fields?: CmsMediaDocAccessFields_heightFieldPolicy,
	},
	CmsMediaDocAccessFields_height_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_height_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_height_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_height_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_height_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_height_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_height_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_height_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_height_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_height_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_height_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_height_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_height_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_height_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_height_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_height_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_mimeType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_mimeTypeKeySpecifier | (() => undefined | CmsMediaDocAccessFields_mimeTypeKeySpecifier),
		fields?: CmsMediaDocAccessFields_mimeTypeFieldPolicy,
	},
	CmsMediaDocAccessFields_mimeType_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_mimeType_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_mimeType_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_mimeType_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_mimeType_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_mimeType_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_mimeType_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_mimeType_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_mimeType_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_mimeType_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_mimeType_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_mimeType_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_mimeType_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_mimeType_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_mimeType_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_mimeType_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizesKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizesKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizesFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_FieldsKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_FieldsKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_FieldsFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnailKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnailKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnailFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_FieldsKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_FieldsKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_FieldsFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_filename?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_filenameKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_filenameKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_filenameFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_filename_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_filename_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_filename_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_filename_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_filename_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_filename_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_filename_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_filename_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_filename_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_filename_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_filename_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_filename_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_filename_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_filename_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_filename_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_filename_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_filesize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_filesizeKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_filesizeKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_filesizeFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_filesize_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_filesize_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_filesize_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_filesize_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_filesize_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_filesize_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_filesize_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_filesize_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_filesize_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_filesize_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_filesize_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_filesize_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_filesize_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_filesize_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_filesize_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_filesize_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_height?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_heightKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_heightKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_heightFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_height_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_height_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_height_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_height_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_height_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_height_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_height_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_height_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_height_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_height_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_height_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_height_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_height_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_height_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_height_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_height_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_mimeType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_mimeTypeKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_mimeTypeKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_mimeTypeFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_mimeType_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_mimeType_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_mimeType_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_mimeType_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_mimeType_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_mimeType_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_mimeType_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_mimeType_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_mimeType_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_mimeType_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_mimeType_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_mimeType_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_mimeType_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_mimeType_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_mimeType_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_mimeType_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_url?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_urlKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_urlKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_urlFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_url_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_url_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_url_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_url_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_url_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_url_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_url_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_url_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_url_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_url_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_url_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_url_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_url_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_url_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_url_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_url_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_width?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_widthKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_widthKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_widthFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_width_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_width_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_width_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_width_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_width_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_width_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_width_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_width_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_width_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_width_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_width_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_width_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_sizes_thumbnail_width_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_sizes_thumbnail_width_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_sizes_thumbnail_width_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_sizes_thumbnail_width_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_thumbnailURL?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_thumbnailURLKeySpecifier | (() => undefined | CmsMediaDocAccessFields_thumbnailURLKeySpecifier),
		fields?: CmsMediaDocAccessFields_thumbnailURLFieldPolicy,
	},
	CmsMediaDocAccessFields_thumbnailURL_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_thumbnailURL_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_thumbnailURL_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_thumbnailURL_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_thumbnailURL_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_thumbnailURL_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_thumbnailURL_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_thumbnailURL_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_thumbnailURL_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_thumbnailURL_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_thumbnailURL_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_thumbnailURL_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_thumbnailURL_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_thumbnailURL_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_thumbnailURL_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_thumbnailURL_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_updatedAtKeySpecifier | (() => undefined | CmsMediaDocAccessFields_updatedAtKeySpecifier),
		fields?: CmsMediaDocAccessFields_updatedAtFieldPolicy,
	},
	CmsMediaDocAccessFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_updatedAt_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_updatedAt_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_updatedAt_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_updatedAt_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_updatedAt_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_updatedAt_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_url?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_urlKeySpecifier | (() => undefined | CmsMediaDocAccessFields_urlKeySpecifier),
		fields?: CmsMediaDocAccessFields_urlFieldPolicy,
	},
	CmsMediaDocAccessFields_url_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_url_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_url_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_url_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_url_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_url_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_url_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_url_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_url_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_url_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_url_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_url_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_url_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_url_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_url_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_url_UpdateFieldPolicy,
	},
	CmsMediaDocAccessFields_width?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_widthKeySpecifier | (() => undefined | CmsMediaDocAccessFields_widthKeySpecifier),
		fields?: CmsMediaDocAccessFields_widthFieldPolicy,
	},
	CmsMediaDocAccessFields_width_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_width_CreateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_width_CreateKeySpecifier),
		fields?: CmsMediaDocAccessFields_width_CreateFieldPolicy,
	},
	CmsMediaDocAccessFields_width_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_width_DeleteKeySpecifier | (() => undefined | CmsMediaDocAccessFields_width_DeleteKeySpecifier),
		fields?: CmsMediaDocAccessFields_width_DeleteFieldPolicy,
	},
	CmsMediaDocAccessFields_width_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_width_ReadKeySpecifier | (() => undefined | CmsMediaDocAccessFields_width_ReadKeySpecifier),
		fields?: CmsMediaDocAccessFields_width_ReadFieldPolicy,
	},
	CmsMediaDocAccessFields_width_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaDocAccessFields_width_UpdateKeySpecifier | (() => undefined | CmsMediaDocAccessFields_width_UpdateKeySpecifier),
		fields?: CmsMediaDocAccessFields_width_UpdateFieldPolicy,
	},
	CmsMediaFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFieldsKeySpecifier | (() => undefined | CmsMediaFieldsKeySpecifier),
		fields?: CmsMediaFieldsFieldPolicy,
	},
	CmsMediaFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_createdAtKeySpecifier | (() => undefined | CmsMediaFields_createdAtKeySpecifier),
		fields?: CmsMediaFields_createdAtFieldPolicy,
	},
	CmsMediaFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_createdAt_CreateKeySpecifier | (() => undefined | CmsMediaFields_createdAt_CreateKeySpecifier),
		fields?: CmsMediaFields_createdAt_CreateFieldPolicy,
	},
	CmsMediaFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsMediaFields_createdAt_DeleteKeySpecifier),
		fields?: CmsMediaFields_createdAt_DeleteFieldPolicy,
	},
	CmsMediaFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_createdAt_ReadKeySpecifier | (() => undefined | CmsMediaFields_createdAt_ReadKeySpecifier),
		fields?: CmsMediaFields_createdAt_ReadFieldPolicy,
	},
	CmsMediaFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsMediaFields_createdAt_UpdateKeySpecifier),
		fields?: CmsMediaFields_createdAt_UpdateFieldPolicy,
	},
	CmsMediaFields_filename?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_filenameKeySpecifier | (() => undefined | CmsMediaFields_filenameKeySpecifier),
		fields?: CmsMediaFields_filenameFieldPolicy,
	},
	CmsMediaFields_filename_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_filename_CreateKeySpecifier | (() => undefined | CmsMediaFields_filename_CreateKeySpecifier),
		fields?: CmsMediaFields_filename_CreateFieldPolicy,
	},
	CmsMediaFields_filename_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_filename_DeleteKeySpecifier | (() => undefined | CmsMediaFields_filename_DeleteKeySpecifier),
		fields?: CmsMediaFields_filename_DeleteFieldPolicy,
	},
	CmsMediaFields_filename_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_filename_ReadKeySpecifier | (() => undefined | CmsMediaFields_filename_ReadKeySpecifier),
		fields?: CmsMediaFields_filename_ReadFieldPolicy,
	},
	CmsMediaFields_filename_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_filename_UpdateKeySpecifier | (() => undefined | CmsMediaFields_filename_UpdateKeySpecifier),
		fields?: CmsMediaFields_filename_UpdateFieldPolicy,
	},
	CmsMediaFields_filesize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_filesizeKeySpecifier | (() => undefined | CmsMediaFields_filesizeKeySpecifier),
		fields?: CmsMediaFields_filesizeFieldPolicy,
	},
	CmsMediaFields_filesize_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_filesize_CreateKeySpecifier | (() => undefined | CmsMediaFields_filesize_CreateKeySpecifier),
		fields?: CmsMediaFields_filesize_CreateFieldPolicy,
	},
	CmsMediaFields_filesize_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_filesize_DeleteKeySpecifier | (() => undefined | CmsMediaFields_filesize_DeleteKeySpecifier),
		fields?: CmsMediaFields_filesize_DeleteFieldPolicy,
	},
	CmsMediaFields_filesize_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_filesize_ReadKeySpecifier | (() => undefined | CmsMediaFields_filesize_ReadKeySpecifier),
		fields?: CmsMediaFields_filesize_ReadFieldPolicy,
	},
	CmsMediaFields_filesize_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_filesize_UpdateKeySpecifier | (() => undefined | CmsMediaFields_filesize_UpdateKeySpecifier),
		fields?: CmsMediaFields_filesize_UpdateFieldPolicy,
	},
	CmsMediaFields_focalX?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_focalXKeySpecifier | (() => undefined | CmsMediaFields_focalXKeySpecifier),
		fields?: CmsMediaFields_focalXFieldPolicy,
	},
	CmsMediaFields_focalX_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_focalX_CreateKeySpecifier | (() => undefined | CmsMediaFields_focalX_CreateKeySpecifier),
		fields?: CmsMediaFields_focalX_CreateFieldPolicy,
	},
	CmsMediaFields_focalX_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_focalX_DeleteKeySpecifier | (() => undefined | CmsMediaFields_focalX_DeleteKeySpecifier),
		fields?: CmsMediaFields_focalX_DeleteFieldPolicy,
	},
	CmsMediaFields_focalX_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_focalX_ReadKeySpecifier | (() => undefined | CmsMediaFields_focalX_ReadKeySpecifier),
		fields?: CmsMediaFields_focalX_ReadFieldPolicy,
	},
	CmsMediaFields_focalX_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_focalX_UpdateKeySpecifier | (() => undefined | CmsMediaFields_focalX_UpdateKeySpecifier),
		fields?: CmsMediaFields_focalX_UpdateFieldPolicy,
	},
	CmsMediaFields_focalY?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_focalYKeySpecifier | (() => undefined | CmsMediaFields_focalYKeySpecifier),
		fields?: CmsMediaFields_focalYFieldPolicy,
	},
	CmsMediaFields_focalY_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_focalY_CreateKeySpecifier | (() => undefined | CmsMediaFields_focalY_CreateKeySpecifier),
		fields?: CmsMediaFields_focalY_CreateFieldPolicy,
	},
	CmsMediaFields_focalY_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_focalY_DeleteKeySpecifier | (() => undefined | CmsMediaFields_focalY_DeleteKeySpecifier),
		fields?: CmsMediaFields_focalY_DeleteFieldPolicy,
	},
	CmsMediaFields_focalY_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_focalY_ReadKeySpecifier | (() => undefined | CmsMediaFields_focalY_ReadKeySpecifier),
		fields?: CmsMediaFields_focalY_ReadFieldPolicy,
	},
	CmsMediaFields_focalY_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_focalY_UpdateKeySpecifier | (() => undefined | CmsMediaFields_focalY_UpdateKeySpecifier),
		fields?: CmsMediaFields_focalY_UpdateFieldPolicy,
	},
	CmsMediaFields_height?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_heightKeySpecifier | (() => undefined | CmsMediaFields_heightKeySpecifier),
		fields?: CmsMediaFields_heightFieldPolicy,
	},
	CmsMediaFields_height_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_height_CreateKeySpecifier | (() => undefined | CmsMediaFields_height_CreateKeySpecifier),
		fields?: CmsMediaFields_height_CreateFieldPolicy,
	},
	CmsMediaFields_height_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_height_DeleteKeySpecifier | (() => undefined | CmsMediaFields_height_DeleteKeySpecifier),
		fields?: CmsMediaFields_height_DeleteFieldPolicy,
	},
	CmsMediaFields_height_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_height_ReadKeySpecifier | (() => undefined | CmsMediaFields_height_ReadKeySpecifier),
		fields?: CmsMediaFields_height_ReadFieldPolicy,
	},
	CmsMediaFields_height_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_height_UpdateKeySpecifier | (() => undefined | CmsMediaFields_height_UpdateKeySpecifier),
		fields?: CmsMediaFields_height_UpdateFieldPolicy,
	},
	CmsMediaFields_mimeType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_mimeTypeKeySpecifier | (() => undefined | CmsMediaFields_mimeTypeKeySpecifier),
		fields?: CmsMediaFields_mimeTypeFieldPolicy,
	},
	CmsMediaFields_mimeType_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_mimeType_CreateKeySpecifier | (() => undefined | CmsMediaFields_mimeType_CreateKeySpecifier),
		fields?: CmsMediaFields_mimeType_CreateFieldPolicy,
	},
	CmsMediaFields_mimeType_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_mimeType_DeleteKeySpecifier | (() => undefined | CmsMediaFields_mimeType_DeleteKeySpecifier),
		fields?: CmsMediaFields_mimeType_DeleteFieldPolicy,
	},
	CmsMediaFields_mimeType_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_mimeType_ReadKeySpecifier | (() => undefined | CmsMediaFields_mimeType_ReadKeySpecifier),
		fields?: CmsMediaFields_mimeType_ReadFieldPolicy,
	},
	CmsMediaFields_mimeType_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_mimeType_UpdateKeySpecifier | (() => undefined | CmsMediaFields_mimeType_UpdateKeySpecifier),
		fields?: CmsMediaFields_mimeType_UpdateFieldPolicy,
	},
	CmsMediaFields_sizes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizesKeySpecifier | (() => undefined | CmsMediaFields_sizesKeySpecifier),
		fields?: CmsMediaFields_sizesFieldPolicy,
	},
	CmsMediaFields_sizes_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_CreateKeySpecifier | (() => undefined | CmsMediaFields_sizes_CreateKeySpecifier),
		fields?: CmsMediaFields_sizes_CreateFieldPolicy,
	},
	CmsMediaFields_sizes_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_DeleteKeySpecifier | (() => undefined | CmsMediaFields_sizes_DeleteKeySpecifier),
		fields?: CmsMediaFields_sizes_DeleteFieldPolicy,
	},
	CmsMediaFields_sizes_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_FieldsKeySpecifier | (() => undefined | CmsMediaFields_sizes_FieldsKeySpecifier),
		fields?: CmsMediaFields_sizes_FieldsFieldPolicy,
	},
	CmsMediaFields_sizes_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_ReadKeySpecifier | (() => undefined | CmsMediaFields_sizes_ReadKeySpecifier),
		fields?: CmsMediaFields_sizes_ReadFieldPolicy,
	},
	CmsMediaFields_sizes_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_UpdateKeySpecifier | (() => undefined | CmsMediaFields_sizes_UpdateKeySpecifier),
		fields?: CmsMediaFields_sizes_UpdateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnailKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnailKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnailFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_CreateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_CreateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_CreateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_DeleteKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_DeleteKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_DeleteFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_Fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_FieldsKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_FieldsKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_FieldsFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_ReadKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_ReadKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_ReadFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_UpdateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_UpdateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_UpdateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_filename?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_filenameKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_filenameKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_filenameFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_filename_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_filename_CreateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_filename_CreateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_filename_CreateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_filename_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_filename_DeleteKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_filename_DeleteKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_filename_DeleteFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_filename_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_filename_ReadKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_filename_ReadKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_filename_ReadFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_filename_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_filename_UpdateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_filename_UpdateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_filename_UpdateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_filesize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_filesizeKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_filesizeKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_filesizeFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_filesize_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_filesize_CreateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_filesize_CreateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_filesize_CreateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_filesize_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_filesize_DeleteKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_filesize_DeleteKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_filesize_DeleteFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_filesize_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_filesize_ReadKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_filesize_ReadKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_filesize_ReadFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_filesize_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_filesize_UpdateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_filesize_UpdateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_filesize_UpdateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_height?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_heightKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_heightKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_heightFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_height_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_height_CreateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_height_CreateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_height_CreateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_height_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_height_DeleteKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_height_DeleteKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_height_DeleteFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_height_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_height_ReadKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_height_ReadKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_height_ReadFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_height_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_height_UpdateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_height_UpdateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_height_UpdateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_mimeType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_mimeTypeKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_mimeTypeKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_mimeTypeFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_mimeType_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_mimeType_CreateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_mimeType_CreateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_mimeType_CreateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_mimeType_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_mimeType_DeleteKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_mimeType_DeleteKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_mimeType_DeleteFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_mimeType_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_mimeType_ReadKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_mimeType_ReadKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_mimeType_ReadFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_mimeType_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_mimeType_UpdateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_mimeType_UpdateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_mimeType_UpdateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_url?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_urlKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_urlKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_urlFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_url_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_url_CreateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_url_CreateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_url_CreateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_url_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_url_DeleteKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_url_DeleteKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_url_DeleteFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_url_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_url_ReadKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_url_ReadKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_url_ReadFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_url_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_url_UpdateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_url_UpdateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_url_UpdateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_width?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_widthKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_widthKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_widthFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_width_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_width_CreateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_width_CreateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_width_CreateFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_width_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_width_DeleteKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_width_DeleteKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_width_DeleteFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_width_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_width_ReadKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_width_ReadKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_width_ReadFieldPolicy,
	},
	CmsMediaFields_sizes_thumbnail_width_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_sizes_thumbnail_width_UpdateKeySpecifier | (() => undefined | CmsMediaFields_sizes_thumbnail_width_UpdateKeySpecifier),
		fields?: CmsMediaFields_sizes_thumbnail_width_UpdateFieldPolicy,
	},
	CmsMediaFields_thumbnailURL?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_thumbnailURLKeySpecifier | (() => undefined | CmsMediaFields_thumbnailURLKeySpecifier),
		fields?: CmsMediaFields_thumbnailURLFieldPolicy,
	},
	CmsMediaFields_thumbnailURL_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_thumbnailURL_CreateKeySpecifier | (() => undefined | CmsMediaFields_thumbnailURL_CreateKeySpecifier),
		fields?: CmsMediaFields_thumbnailURL_CreateFieldPolicy,
	},
	CmsMediaFields_thumbnailURL_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_thumbnailURL_DeleteKeySpecifier | (() => undefined | CmsMediaFields_thumbnailURL_DeleteKeySpecifier),
		fields?: CmsMediaFields_thumbnailURL_DeleteFieldPolicy,
	},
	CmsMediaFields_thumbnailURL_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_thumbnailURL_ReadKeySpecifier | (() => undefined | CmsMediaFields_thumbnailURL_ReadKeySpecifier),
		fields?: CmsMediaFields_thumbnailURL_ReadFieldPolicy,
	},
	CmsMediaFields_thumbnailURL_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_thumbnailURL_UpdateKeySpecifier | (() => undefined | CmsMediaFields_thumbnailURL_UpdateKeySpecifier),
		fields?: CmsMediaFields_thumbnailURL_UpdateFieldPolicy,
	},
	CmsMediaFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_updatedAtKeySpecifier | (() => undefined | CmsMediaFields_updatedAtKeySpecifier),
		fields?: CmsMediaFields_updatedAtFieldPolicy,
	},
	CmsMediaFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsMediaFields_updatedAt_CreateKeySpecifier),
		fields?: CmsMediaFields_updatedAt_CreateFieldPolicy,
	},
	CmsMediaFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsMediaFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsMediaFields_updatedAt_DeleteFieldPolicy,
	},
	CmsMediaFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsMediaFields_updatedAt_ReadKeySpecifier),
		fields?: CmsMediaFields_updatedAt_ReadFieldPolicy,
	},
	CmsMediaFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsMediaFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsMediaFields_updatedAt_UpdateFieldPolicy,
	},
	CmsMediaFields_url?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_urlKeySpecifier | (() => undefined | CmsMediaFields_urlKeySpecifier),
		fields?: CmsMediaFields_urlFieldPolicy,
	},
	CmsMediaFields_url_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_url_CreateKeySpecifier | (() => undefined | CmsMediaFields_url_CreateKeySpecifier),
		fields?: CmsMediaFields_url_CreateFieldPolicy,
	},
	CmsMediaFields_url_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_url_DeleteKeySpecifier | (() => undefined | CmsMediaFields_url_DeleteKeySpecifier),
		fields?: CmsMediaFields_url_DeleteFieldPolicy,
	},
	CmsMediaFields_url_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_url_ReadKeySpecifier | (() => undefined | CmsMediaFields_url_ReadKeySpecifier),
		fields?: CmsMediaFields_url_ReadFieldPolicy,
	},
	CmsMediaFields_url_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_url_UpdateKeySpecifier | (() => undefined | CmsMediaFields_url_UpdateKeySpecifier),
		fields?: CmsMediaFields_url_UpdateFieldPolicy,
	},
	CmsMediaFields_width?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_widthKeySpecifier | (() => undefined | CmsMediaFields_widthKeySpecifier),
		fields?: CmsMediaFields_widthFieldPolicy,
	},
	CmsMediaFields_width_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_width_CreateKeySpecifier | (() => undefined | CmsMediaFields_width_CreateKeySpecifier),
		fields?: CmsMediaFields_width_CreateFieldPolicy,
	},
	CmsMediaFields_width_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_width_DeleteKeySpecifier | (() => undefined | CmsMediaFields_width_DeleteKeySpecifier),
		fields?: CmsMediaFields_width_DeleteFieldPolicy,
	},
	CmsMediaFields_width_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_width_ReadKeySpecifier | (() => undefined | CmsMediaFields_width_ReadKeySpecifier),
		fields?: CmsMediaFields_width_ReadFieldPolicy,
	},
	CmsMediaFields_width_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaFields_width_UpdateKeySpecifier | (() => undefined | CmsMediaFields_width_UpdateKeySpecifier),
		fields?: CmsMediaFields_width_UpdateFieldPolicy,
	},
	CmsMediaReadAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaReadAccessKeySpecifier | (() => undefined | CmsMediaReadAccessKeySpecifier),
		fields?: CmsMediaReadAccessFieldPolicy,
	},
	CmsMediaReadDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaReadDocAccessKeySpecifier | (() => undefined | CmsMediaReadDocAccessKeySpecifier),
		fields?: CmsMediaReadDocAccessFieldPolicy,
	},
	CmsMediaUpdateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaUpdateAccessKeySpecifier | (() => undefined | CmsMediaUpdateAccessKeySpecifier),
		fields?: CmsMediaUpdateAccessFieldPolicy,
	},
	CmsMediaUpdateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediaUpdateDocAccessKeySpecifier | (() => undefined | CmsMediaUpdateDocAccessKeySpecifier),
		fields?: CmsMediaUpdateDocAccessFieldPolicy,
	},
	CmsMedia_Sizes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMedia_SizesKeySpecifier | (() => undefined | CmsMedia_SizesKeySpecifier),
		fields?: CmsMedia_SizesFieldPolicy,
	},
	CmsMedia_Sizes_Thumbnail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMedia_Sizes_ThumbnailKeySpecifier | (() => undefined | CmsMedia_Sizes_ThumbnailKeySpecifier),
		fields?: CmsMedia_Sizes_ThumbnailFieldPolicy,
	},
	CmsMedias?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsMediasKeySpecifier | (() => undefined | CmsMediasKeySpecifier),
		fields?: CmsMediasFieldPolicy,
	},
	CmsUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUserKeySpecifier | (() => undefined | CmsUserKeySpecifier),
		fields?: CmsUserFieldPolicy,
	},
	CmsUsers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersKeySpecifier | (() => undefined | CmsUsersKeySpecifier),
		fields?: CmsUsersFieldPolicy,
	},
	CmsUsersAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersAccessKeySpecifier | (() => undefined | CmsUsersAccessKeySpecifier),
		fields?: CmsUsersAccessFieldPolicy,
	},
	CmsUsersCreateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersCreateAccessKeySpecifier | (() => undefined | CmsUsersCreateAccessKeySpecifier),
		fields?: CmsUsersCreateAccessFieldPolicy,
	},
	CmsUsersCreateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersCreateDocAccessKeySpecifier | (() => undefined | CmsUsersCreateDocAccessKeySpecifier),
		fields?: CmsUsersCreateDocAccessFieldPolicy,
	},
	CmsUsersDeleteAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDeleteAccessKeySpecifier | (() => undefined | CmsUsersDeleteAccessKeySpecifier),
		fields?: CmsUsersDeleteAccessFieldPolicy,
	},
	CmsUsersDeleteDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDeleteDocAccessKeySpecifier | (() => undefined | CmsUsersDeleteDocAccessKeySpecifier),
		fields?: CmsUsersDeleteDocAccessFieldPolicy,
	},
	CmsUsersDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessKeySpecifier | (() => undefined | CmsUsersDocAccessKeySpecifier),
		fields?: CmsUsersDocAccessFieldPolicy,
	},
	CmsUsersDocAccessFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFieldsKeySpecifier | (() => undefined | CmsUsersDocAccessFieldsKeySpecifier),
		fields?: CmsUsersDocAccessFieldsFieldPolicy,
	},
	CmsUsersDocAccessFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_createdAtKeySpecifier | (() => undefined | CmsUsersDocAccessFields_createdAtKeySpecifier),
		fields?: CmsUsersDocAccessFields_createdAtFieldPolicy,
	},
	CmsUsersDocAccessFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_createdAt_CreateKeySpecifier | (() => undefined | CmsUsersDocAccessFields_createdAt_CreateKeySpecifier),
		fields?: CmsUsersDocAccessFields_createdAt_CreateFieldPolicy,
	},
	CmsUsersDocAccessFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsUsersDocAccessFields_createdAt_DeleteKeySpecifier),
		fields?: CmsUsersDocAccessFields_createdAt_DeleteFieldPolicy,
	},
	CmsUsersDocAccessFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_createdAt_ReadKeySpecifier | (() => undefined | CmsUsersDocAccessFields_createdAt_ReadKeySpecifier),
		fields?: CmsUsersDocAccessFields_createdAt_ReadFieldPolicy,
	},
	CmsUsersDocAccessFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsUsersDocAccessFields_createdAt_UpdateKeySpecifier),
		fields?: CmsUsersDocAccessFields_createdAt_UpdateFieldPolicy,
	},
	CmsUsersDocAccessFields_email?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_emailKeySpecifier | (() => undefined | CmsUsersDocAccessFields_emailKeySpecifier),
		fields?: CmsUsersDocAccessFields_emailFieldPolicy,
	},
	CmsUsersDocAccessFields_email_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_email_CreateKeySpecifier | (() => undefined | CmsUsersDocAccessFields_email_CreateKeySpecifier),
		fields?: CmsUsersDocAccessFields_email_CreateFieldPolicy,
	},
	CmsUsersDocAccessFields_email_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_email_DeleteKeySpecifier | (() => undefined | CmsUsersDocAccessFields_email_DeleteKeySpecifier),
		fields?: CmsUsersDocAccessFields_email_DeleteFieldPolicy,
	},
	CmsUsersDocAccessFields_email_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_email_ReadKeySpecifier | (() => undefined | CmsUsersDocAccessFields_email_ReadKeySpecifier),
		fields?: CmsUsersDocAccessFields_email_ReadFieldPolicy,
	},
	CmsUsersDocAccessFields_email_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_email_UpdateKeySpecifier | (() => undefined | CmsUsersDocAccessFields_email_UpdateKeySpecifier),
		fields?: CmsUsersDocAccessFields_email_UpdateFieldPolicy,
	},
	CmsUsersDocAccessFields_name?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_nameKeySpecifier | (() => undefined | CmsUsersDocAccessFields_nameKeySpecifier),
		fields?: CmsUsersDocAccessFields_nameFieldPolicy,
	},
	CmsUsersDocAccessFields_name_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_name_CreateKeySpecifier | (() => undefined | CmsUsersDocAccessFields_name_CreateKeySpecifier),
		fields?: CmsUsersDocAccessFields_name_CreateFieldPolicy,
	},
	CmsUsersDocAccessFields_name_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_name_DeleteKeySpecifier | (() => undefined | CmsUsersDocAccessFields_name_DeleteKeySpecifier),
		fields?: CmsUsersDocAccessFields_name_DeleteFieldPolicy,
	},
	CmsUsersDocAccessFields_name_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_name_ReadKeySpecifier | (() => undefined | CmsUsersDocAccessFields_name_ReadKeySpecifier),
		fields?: CmsUsersDocAccessFields_name_ReadFieldPolicy,
	},
	CmsUsersDocAccessFields_name_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_name_UpdateKeySpecifier | (() => undefined | CmsUsersDocAccessFields_name_UpdateKeySpecifier),
		fields?: CmsUsersDocAccessFields_name_UpdateFieldPolicy,
	},
	CmsUsersDocAccessFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_updatedAtKeySpecifier | (() => undefined | CmsUsersDocAccessFields_updatedAtKeySpecifier),
		fields?: CmsUsersDocAccessFields_updatedAtFieldPolicy,
	},
	CmsUsersDocAccessFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsUsersDocAccessFields_updatedAt_CreateKeySpecifier),
		fields?: CmsUsersDocAccessFields_updatedAt_CreateFieldPolicy,
	},
	CmsUsersDocAccessFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsUsersDocAccessFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsUsersDocAccessFields_updatedAt_DeleteFieldPolicy,
	},
	CmsUsersDocAccessFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsUsersDocAccessFields_updatedAt_ReadKeySpecifier),
		fields?: CmsUsersDocAccessFields_updatedAt_ReadFieldPolicy,
	},
	CmsUsersDocAccessFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersDocAccessFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsUsersDocAccessFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsUsersDocAccessFields_updatedAt_UpdateFieldPolicy,
	},
	CmsUsersFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFieldsKeySpecifier | (() => undefined | CmsUsersFieldsKeySpecifier),
		fields?: CmsUsersFieldsFieldPolicy,
	},
	CmsUsersFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_createdAtKeySpecifier | (() => undefined | CmsUsersFields_createdAtKeySpecifier),
		fields?: CmsUsersFields_createdAtFieldPolicy,
	},
	CmsUsersFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_createdAt_CreateKeySpecifier | (() => undefined | CmsUsersFields_createdAt_CreateKeySpecifier),
		fields?: CmsUsersFields_createdAt_CreateFieldPolicy,
	},
	CmsUsersFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_createdAt_DeleteKeySpecifier | (() => undefined | CmsUsersFields_createdAt_DeleteKeySpecifier),
		fields?: CmsUsersFields_createdAt_DeleteFieldPolicy,
	},
	CmsUsersFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_createdAt_ReadKeySpecifier | (() => undefined | CmsUsersFields_createdAt_ReadKeySpecifier),
		fields?: CmsUsersFields_createdAt_ReadFieldPolicy,
	},
	CmsUsersFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_createdAt_UpdateKeySpecifier | (() => undefined | CmsUsersFields_createdAt_UpdateKeySpecifier),
		fields?: CmsUsersFields_createdAt_UpdateFieldPolicy,
	},
	CmsUsersFields_email?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_emailKeySpecifier | (() => undefined | CmsUsersFields_emailKeySpecifier),
		fields?: CmsUsersFields_emailFieldPolicy,
	},
	CmsUsersFields_email_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_email_CreateKeySpecifier | (() => undefined | CmsUsersFields_email_CreateKeySpecifier),
		fields?: CmsUsersFields_email_CreateFieldPolicy,
	},
	CmsUsersFields_email_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_email_DeleteKeySpecifier | (() => undefined | CmsUsersFields_email_DeleteKeySpecifier),
		fields?: CmsUsersFields_email_DeleteFieldPolicy,
	},
	CmsUsersFields_email_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_email_ReadKeySpecifier | (() => undefined | CmsUsersFields_email_ReadKeySpecifier),
		fields?: CmsUsersFields_email_ReadFieldPolicy,
	},
	CmsUsersFields_email_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_email_UpdateKeySpecifier | (() => undefined | CmsUsersFields_email_UpdateKeySpecifier),
		fields?: CmsUsersFields_email_UpdateFieldPolicy,
	},
	CmsUsersFields_name?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_nameKeySpecifier | (() => undefined | CmsUsersFields_nameKeySpecifier),
		fields?: CmsUsersFields_nameFieldPolicy,
	},
	CmsUsersFields_name_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_name_CreateKeySpecifier | (() => undefined | CmsUsersFields_name_CreateKeySpecifier),
		fields?: CmsUsersFields_name_CreateFieldPolicy,
	},
	CmsUsersFields_name_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_name_DeleteKeySpecifier | (() => undefined | CmsUsersFields_name_DeleteKeySpecifier),
		fields?: CmsUsersFields_name_DeleteFieldPolicy,
	},
	CmsUsersFields_name_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_name_ReadKeySpecifier | (() => undefined | CmsUsersFields_name_ReadKeySpecifier),
		fields?: CmsUsersFields_name_ReadFieldPolicy,
	},
	CmsUsersFields_name_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_name_UpdateKeySpecifier | (() => undefined | CmsUsersFields_name_UpdateKeySpecifier),
		fields?: CmsUsersFields_name_UpdateFieldPolicy,
	},
	CmsUsersFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_updatedAtKeySpecifier | (() => undefined | CmsUsersFields_updatedAtKeySpecifier),
		fields?: CmsUsersFields_updatedAtFieldPolicy,
	},
	CmsUsersFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_updatedAt_CreateKeySpecifier | (() => undefined | CmsUsersFields_updatedAt_CreateKeySpecifier),
		fields?: CmsUsersFields_updatedAt_CreateFieldPolicy,
	},
	CmsUsersFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_updatedAt_DeleteKeySpecifier | (() => undefined | CmsUsersFields_updatedAt_DeleteKeySpecifier),
		fields?: CmsUsersFields_updatedAt_DeleteFieldPolicy,
	},
	CmsUsersFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_updatedAt_ReadKeySpecifier | (() => undefined | CmsUsersFields_updatedAt_ReadKeySpecifier),
		fields?: CmsUsersFields_updatedAt_ReadFieldPolicy,
	},
	CmsUsersFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersFields_updatedAt_UpdateKeySpecifier | (() => undefined | CmsUsersFields_updatedAt_UpdateKeySpecifier),
		fields?: CmsUsersFields_updatedAt_UpdateFieldPolicy,
	},
	CmsUsersJWT?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersJWTKeySpecifier | (() => undefined | CmsUsersJWTKeySpecifier),
		fields?: CmsUsersJWTFieldPolicy,
	},
	CmsUsersLoginResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersLoginResultKeySpecifier | (() => undefined | CmsUsersLoginResultKeySpecifier),
		fields?: CmsUsersLoginResultFieldPolicy,
	},
	CmsUsersMe?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersMeKeySpecifier | (() => undefined | CmsUsersMeKeySpecifier),
		fields?: CmsUsersMeFieldPolicy,
	},
	CmsUsersReadAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersReadAccessKeySpecifier | (() => undefined | CmsUsersReadAccessKeySpecifier),
		fields?: CmsUsersReadAccessFieldPolicy,
	},
	CmsUsersReadDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersReadDocAccessKeySpecifier | (() => undefined | CmsUsersReadDocAccessKeySpecifier),
		fields?: CmsUsersReadDocAccessFieldPolicy,
	},
	CmsUsersRefreshedCmsUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersRefreshedCmsUserKeySpecifier | (() => undefined | CmsUsersRefreshedCmsUserKeySpecifier),
		fields?: CmsUsersRefreshedCmsUserFieldPolicy,
	},
	CmsUsersResetPassword?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersResetPasswordKeySpecifier | (() => undefined | CmsUsersResetPasswordKeySpecifier),
		fields?: CmsUsersResetPasswordFieldPolicy,
	},
	CmsUsersUnlockAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersUnlockAccessKeySpecifier | (() => undefined | CmsUsersUnlockAccessKeySpecifier),
		fields?: CmsUsersUnlockAccessFieldPolicy,
	},
	CmsUsersUnlockDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersUnlockDocAccessKeySpecifier | (() => undefined | CmsUsersUnlockDocAccessKeySpecifier),
		fields?: CmsUsersUnlockDocAccessFieldPolicy,
	},
	CmsUsersUpdateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersUpdateAccessKeySpecifier | (() => undefined | CmsUsersUpdateAccessKeySpecifier),
		fields?: CmsUsersUpdateAccessFieldPolicy,
	},
	CmsUsersUpdateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CmsUsersUpdateDocAccessKeySpecifier | (() => undefined | CmsUsersUpdateDocAccessKeySpecifier),
		fields?: CmsUsersUpdateDocAccessFieldPolicy,
	},
	Competition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompetitionKeySpecifier | (() => undefined | CompetitionKeySpecifier),
		fields?: CompetitionFieldPolicy,
	},
	CompetitionMatch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompetitionMatchKeySpecifier | (() => undefined | CompetitionMatchKeySpecifier),
		fields?: CompetitionMatchFieldPolicy,
	},
	CompetitionParticipantReference?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompetitionParticipantReferenceKeySpecifier | (() => undefined | CompetitionParticipantReferenceKeySpecifier),
		fields?: CompetitionParticipantReferenceFieldPolicy,
	},
	CompetitionParticipantReferenceWithRoster?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompetitionParticipantReferenceWithRosterKeySpecifier | (() => undefined | CompetitionParticipantReferenceWithRosterKeySpecifier),
		fields?: CompetitionParticipantReferenceWithRosterFieldPolicy,
	},
	CompetitionSpecificDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompetitionSpecificDetailsKeySpecifier | (() => undefined | CompetitionSpecificDetailsKeySpecifier),
		fields?: CompetitionSpecificDetailsFieldPolicy,
	},
	CompetitionTiming?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompetitionTimingKeySpecifier | (() => undefined | CompetitionTimingKeySpecifier),
		fields?: CompetitionTimingFieldPolicy,
	},
	Contact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactKeySpecifier | (() => undefined | ContactKeySpecifier),
		fields?: ContactFieldPolicy,
	},
	Cost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CostKeySpecifier | (() => undefined | CostKeySpecifier),
		fields?: CostFieldPolicy,
	},
	CurrencyConversion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CurrencyConversionKeySpecifier | (() => undefined | CurrencyConversionKeySpecifier),
		fields?: CurrencyConversionFieldPolicy,
	},
	CurrencyItemCost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CurrencyItemCostKeySpecifier | (() => undefined | CurrencyItemCostKeySpecifier),
		fields?: CurrencyItemCostFieldPolicy,
	},
	CurrencyItemCostArchive?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CurrencyItemCostArchiveKeySpecifier | (() => undefined | CurrencyItemCostArchiveKeySpecifier),
		fields?: CurrencyItemCostArchiveFieldPolicy,
	},
	CurrencyPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CurrencyPriceKeySpecifier | (() => undefined | CurrencyPriceKeySpecifier),
		fields?: CurrencyPriceFieldPolicy,
	},
	CustomPrize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomPrizeKeySpecifier | (() => undefined | CustomPrizeKeySpecifier),
		fields?: CustomPrizeFieldPolicy,
	},
	CustomPrizePayoutReceipt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomPrizePayoutReceiptKeySpecifier | (() => undefined | CustomPrizePayoutReceiptKeySpecifier),
		fields?: CustomPrizePayoutReceiptFieldPolicy,
	},
	DateAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DateAttributeKeySpecifier | (() => undefined | DateAttributeKeySpecifier),
		fields?: DateAttributeFieldPolicy,
	},
	DateAttributeWithPossibleError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DateAttributeWithPossibleErrorKeySpecifier | (() => undefined | DateAttributeWithPossibleErrorKeySpecifier),
		fields?: DateAttributeWithPossibleErrorFieldPolicy,
	},
	Deal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealKeySpecifier | (() => undefined | DealKeySpecifier),
		fields?: DealFieldPolicy,
	},
	DealActivePartnerItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealActivePartnerItemKeySpecifier | (() => undefined | DealActivePartnerItemKeySpecifier),
		fields?: DealActivePartnerItemFieldPolicy,
	},
	DealCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealCategoryKeySpecifier | (() => undefined | DealCategoryKeySpecifier),
		fields?: DealCategoryFieldPolicy,
	},
	DealDetailsDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealDetailsDtoKeySpecifier | (() => undefined | DealDetailsDtoKeySpecifier),
		fields?: DealDetailsDtoFieldPolicy,
	},
	DealDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealDtoKeySpecifier | (() => undefined | DealDtoKeySpecifier),
		fields?: DealDtoFieldPolicy,
	},
	DealItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealItemKeySpecifier | (() => undefined | DealItemKeySpecifier),
		fields?: DealItemFieldPolicy,
	},
	DealLogDetailDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealLogDetailDtoKeySpecifier | (() => undefined | DealLogDetailDtoKeySpecifier),
		fields?: DealLogDetailDtoFieldPolicy,
	},
	DealLogDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealLogDtoKeySpecifier | (() => undefined | DealLogDtoKeySpecifier),
		fields?: DealLogDtoFieldPolicy,
	},
	DealPartner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealPartnerKeySpecifier | (() => undefined | DealPartnerKeySpecifier),
		fields?: DealPartnerFieldPolicy,
	},
	DealPartnerDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealPartnerDtoKeySpecifier | (() => undefined | DealPartnerDtoKeySpecifier),
		fields?: DealPartnerDtoFieldPolicy,
	},
	DealPartnerItemDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealPartnerItemDtoKeySpecifier | (() => undefined | DealPartnerItemDtoKeySpecifier),
		fields?: DealPartnerItemDtoFieldPolicy,
	},
	DealPaymentChannel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealPaymentChannelKeySpecifier | (() => undefined | DealPaymentChannelKeySpecifier),
		fields?: DealPaymentChannelFieldPolicy,
	},
	DealPaymentChannelsDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealPaymentChannelsDtoKeySpecifier | (() => undefined | DealPaymentChannelsDtoKeySpecifier),
		fields?: DealPaymentChannelsDtoFieldPolicy,
	},
	DealProductGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DealProductGroupKeySpecifier | (() => undefined | DealProductGroupKeySpecifier),
		fields?: DealProductGroupFieldPolicy,
	},
	DimensionMultiplier?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DimensionMultiplierKeySpecifier | (() => undefined | DimensionMultiplierKeySpecifier),
		fields?: DimensionMultiplierFieldPolicy,
	},
	DistributionInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DistributionInfoKeySpecifier | (() => undefined | DistributionInfoKeySpecifier),
		fields?: DistributionInfoFieldPolicy,
	},
	DraftProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftProductKeySpecifier | (() => undefined | DraftProductKeySpecifier),
		fields?: DraftProductFieldPolicy,
	},
	EmbeddedGame?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmbeddedGameKeySpecifier | (() => undefined | EmbeddedGameKeySpecifier),
		fields?: EmbeddedGameFieldPolicy,
	},
	EnumMissingParticipantRequirement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnumMissingParticipantRequirementKeySpecifier | (() => undefined | EnumMissingParticipantRequirementKeySpecifier),
		fields?: EnumMissingParticipantRequirementFieldPolicy,
	},
	Event?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventKeySpecifier | (() => undefined | EventKeySpecifier),
		fields?: EventFieldPolicy,
	},
	EventCurrencyExchanges?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventCurrencyExchangesKeySpecifier | (() => undefined | EventCurrencyExchangesKeySpecifier),
		fields?: EventCurrencyExchangesFieldPolicy,
	},
	EventEntryRules?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventEntryRulesKeySpecifier | (() => undefined | EventEntryRulesKeySpecifier),
		fields?: EventEntryRulesFieldPolicy,
	},
	EventLimitations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventLimitationsKeySpecifier | (() => undefined | EventLimitationsKeySpecifier),
		fields?: EventLimitationsFieldPolicy,
	},
	EventRequirement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventRequirementKeySpecifier | (() => undefined | EventRequirementKeySpecifier),
		fields?: EventRequirementFieldPolicy,
	},
	EventStage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventStageKeySpecifier | (() => undefined | EventStageKeySpecifier),
		fields?: EventStageFieldPolicy,
	},
	EventStageParticipantReference?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventStageParticipantReferenceKeySpecifier | (() => undefined | EventStageParticipantReferenceKeySpecifier),
		fields?: EventStageParticipantReferenceFieldPolicy,
	},
	EventTeamMember?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventTeamMemberKeySpecifier | (() => undefined | EventTeamMemberKeySpecifier),
		fields?: EventTeamMemberFieldPolicy,
	},
	EventTiming?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventTimingKeySpecifier | (() => undefined | EventTimingKeySpecifier),
		fields?: EventTimingFieldPolicy,
	},
	ExactPlacementAdvanceStrategy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExactPlacementAdvanceStrategyKeySpecifier | (() => undefined | ExactPlacementAdvanceStrategyKeySpecifier),
		fields?: ExactPlacementAdvanceStrategyFieldPolicy,
	},
	ExchangedTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExchangedTransactionKeySpecifier | (() => undefined | ExchangedTransactionKeySpecifier),
		fields?: ExchangedTransactionFieldPolicy,
	},
	ExplicitEnrollment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExplicitEnrollmentKeySpecifier | (() => undefined | ExplicitEnrollmentKeySpecifier),
		fields?: ExplicitEnrollmentFieldPolicy,
	},
	ExplicitSubscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExplicitSubscriptionKeySpecifier | (() => undefined | ExplicitSubscriptionKeySpecifier),
		fields?: ExplicitSubscriptionFieldPolicy,
	},
	ExportedItemsCSV?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportedItemsCSVKeySpecifier | (() => undefined | ExportedItemsCSVKeySpecifier),
		fields?: ExportedItemsCSVFieldPolicy,
	},
	ExternalCurrencyItemCost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalCurrencyItemCostKeySpecifier | (() => undefined | ExternalCurrencyItemCostKeySpecifier),
		fields?: ExternalCurrencyItemCostFieldPolicy,
	},
	ExternalCurrencyItemCostArchive?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalCurrencyItemCostArchiveKeySpecifier | (() => undefined | ExternalCurrencyItemCostArchiveKeySpecifier),
		fields?: ExternalCurrencyItemCostArchiveFieldPolicy,
	},
	ExternalField?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalFieldKeySpecifier | (() => undefined | ExternalFieldKeySpecifier),
		fields?: ExternalFieldFieldPolicy,
	},
	ExternalSubscriptionPackage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalSubscriptionPackageKeySpecifier | (() => undefined | ExternalSubscriptionPackageKeySpecifier),
		fields?: ExternalSubscriptionPackageFieldPolicy,
	},
	FailedOrderTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FailedOrderTransactionKeySpecifier | (() => undefined | FailedOrderTransactionKeySpecifier),
		fields?: FailedOrderTransactionFieldPolicy,
	},
	Feature?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FeatureKeySpecifier | (() => undefined | FeatureKeySpecifier),
		fields?: FeatureFieldPolicy,
	},
	FeatureFlag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FeatureFlagKeySpecifier | (() => undefined | FeatureFlagKeySpecifier),
		fields?: FeatureFlagFieldPolicy,
	},
	FixedNumberBreakStrategy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FixedNumberBreakStrategyKeySpecifier | (() => undefined | FixedNumberBreakStrategyKeySpecifier),
		fields?: FixedNumberBreakStrategyFieldPolicy,
	},
	FixedPrize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FixedPrizeKeySpecifier | (() => undefined | FixedPrizeKeySpecifier),
		fields?: FixedPrizeFieldPolicy,
	},
	FreebieTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FreebieTransactionKeySpecifier | (() => undefined | FreebieTransactionKeySpecifier),
		fields?: FreebieTransactionFieldPolicy,
	},
	Game?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GameKeySpecifier | (() => undefined | GameKeySpecifier),
		fields?: GameFieldPolicy,
	},
	GameAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GameAccountKeySpecifier | (() => undefined | GameAccountKeySpecifier),
		fields?: GameAccountFieldPolicy,
	},
	GameAccountType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GameAccountTypeKeySpecifier | (() => undefined | GameAccountTypeKeySpecifier),
		fields?: GameAccountTypeFieldPolicy,
	},
	GameSpecificCompetitionDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GameSpecificCompetitionDetailsKeySpecifier | (() => undefined | GameSpecificCompetitionDetailsKeySpecifier),
		fields?: GameSpecificCompetitionDetailsFieldPolicy,
	},
	GameSpecificDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GameSpecificDetailsKeySpecifier | (() => undefined | GameSpecificDetailsKeySpecifier),
		fields?: GameSpecificDetailsFieldPolicy,
	},
	GameUserIdValidationResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GameUserIdValidationResponseKeySpecifier | (() => undefined | GameUserIdValidationResponseKeySpecifier),
		fields?: GameUserIdValidationResponseFieldPolicy,
	},
	GamingActionable?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GamingActionableKeySpecifier | (() => undefined | GamingActionableKeySpecifier),
		fields?: GamingActionableFieldPolicy,
	},
	GamingFullRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GamingFullRoleKeySpecifier | (() => undefined | GamingFullRoleKeySpecifier),
		fields?: GamingFullRoleFieldPolicy,
	},
	GamingRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GamingRoleKeySpecifier | (() => undefined | GamingRoleKeySpecifier),
		fields?: GamingRoleFieldPolicy,
	},
	GamingRoleFragment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GamingRoleFragmentKeySpecifier | (() => undefined | GamingRoleFragmentKeySpecifier),
		fields?: GamingRoleFragmentFieldPolicy,
	},
	GamingScope?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GamingScopeKeySpecifier | (() => undefined | GamingScopeKeySpecifier),
		fields?: GamingScopeFieldPolicy,
	},
	GamingScopeGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GamingScopeGroupKeySpecifier | (() => undefined | GamingScopeGroupKeySpecifier),
		fields?: GamingScopeGroupFieldPolicy,
	},
	Group?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupKeySpecifier | (() => undefined | GroupKeySpecifier),
		fields?: GroupFieldPolicy,
	},
	GroupInvite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupInviteKeySpecifier | (() => undefined | GroupInviteKeySpecifier),
		fields?: GroupInviteFieldPolicy,
	},
	GroupInviteWithPossibleError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupInviteWithPossibleErrorKeySpecifier | (() => undefined | GroupInviteWithPossibleErrorKeySpecifier),
		fields?: GroupInviteWithPossibleErrorFieldPolicy,
	},
	GroupMember?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupMemberKeySpecifier | (() => undefined | GroupMemberKeySpecifier),
		fields?: GroupMemberFieldPolicy,
	},
	GroupMembership?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupMembershipKeySpecifier | (() => undefined | GroupMembershipKeySpecifier),
		fields?: GroupMembershipFieldPolicy,
	},
	GroupTrait?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupTraitKeySpecifier | (() => undefined | GroupTraitKeySpecifier),
		fields?: GroupTraitFieldPolicy,
	},
	HiveContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HiveContactKeySpecifier | (() => undefined | HiveContactKeySpecifier),
		fields?: HiveContactFieldPolicy,
	},
	HiveContactWithPossibleError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HiveContactWithPossibleErrorKeySpecifier | (() => undefined | HiveContactWithPossibleErrorKeySpecifier),
		fields?: HiveContactWithPossibleErrorFieldPolicy,
	},
	IdentityProvider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IdentityProviderKeySpecifier | (() => undefined | IdentityProviderKeySpecifier),
		fields?: IdentityProviderFieldPolicy,
	},
	IdentityProviderWithPossibleError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IdentityProviderWithPossibleErrorKeySpecifier | (() => undefined | IdentityProviderWithPossibleErrorKeySpecifier),
		fields?: IdentityProviderWithPossibleErrorFieldPolicy,
	},
	ImplicitEnrollment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImplicitEnrollmentKeySpecifier | (() => undefined | ImplicitEnrollmentKeySpecifier),
		fields?: ImplicitEnrollmentFieldPolicy,
	},
	ImplicitSubscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImplicitSubscriptionKeySpecifier | (() => undefined | ImplicitSubscriptionKeySpecifier),
		fields?: ImplicitSubscriptionFieldPolicy,
	},
	InGameResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InGameResultKeySpecifier | (() => undefined | InGameResultKeySpecifier),
		fields?: InGameResultFieldPolicy,
	},
	IndividualParticipant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndividualParticipantKeySpecifier | (() => undefined | IndividualParticipantKeySpecifier),
		fields?: IndividualParticipantFieldPolicy,
	},
	IndividualParticipantInviteLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndividualParticipantInviteLinkKeySpecifier | (() => undefined | IndividualParticipantInviteLinkKeySpecifier),
		fields?: IndividualParticipantInviteLinkFieldPolicy,
	},
	IntegratedVoucher?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IntegratedVoucherKeySpecifier | (() => undefined | IntegratedVoucherKeySpecifier),
		fields?: IntegratedVoucherFieldPolicy,
	},
	InternalPayment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalPaymentKeySpecifier | (() => undefined | InternalPaymentKeySpecifier),
		fields?: InternalPaymentFieldPolicy,
	},
	InternalSchedule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalScheduleKeySpecifier | (() => undefined | InternalScheduleKeySpecifier),
		fields?: InternalScheduleFieldPolicy,
	},
	InternalService?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InternalServiceKeySpecifier | (() => undefined | InternalServiceKeySpecifier),
		fields?: InternalServiceFieldPolicy,
	},
	InviteCode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InviteCodeKeySpecifier | (() => undefined | InviteCodeKeySpecifier),
		fields?: InviteCodeFieldPolicy,
	},
	Item?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemKeySpecifier | (() => undefined | ItemKeySpecifier),
		fields?: ItemFieldPolicy,
	},
	ItemCost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemCostKeySpecifier | (() => undefined | ItemCostKeySpecifier),
		fields?: ItemCostFieldPolicy,
	},
	ItemLanguageDTO?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemLanguageDTOKeySpecifier | (() => undefined | ItemLanguageDTOKeySpecifier),
		fields?: ItemLanguageDTOFieldPolicy,
	},
	ItemLanguageData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemLanguageDataKeySpecifier | (() => undefined | ItemLanguageDataKeySpecifier),
		fields?: ItemLanguageDataFieldPolicy,
	},
	ItemLanguageResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemLanguageResponseKeySpecifier | (() => undefined | ItemLanguageResponseKeySpecifier),
		fields?: ItemLanguageResponseFieldPolicy,
	},
	ItemLanguagesResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemLanguagesResponseKeySpecifier | (() => undefined | ItemLanguagesResponseKeySpecifier),
		fields?: ItemLanguagesResponseFieldPolicy,
	},
	ItemPoints?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemPointsKeySpecifier | (() => undefined | ItemPointsKeySpecifier),
		fields?: ItemPointsFieldPolicy,
	},
	ItemProductGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ItemProductGroupKeySpecifier | (() => undefined | ItemProductGroupKeySpecifier),
		fields?: ItemProductGroupFieldPolicy,
	},
	JobInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JobInfoKeySpecifier | (() => undefined | JobInfoKeySpecifier),
		fields?: JobInfoFieldPolicy,
	},
	KingOfTheHillSpecificDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KingOfTheHillSpecificDetailsKeySpecifier | (() => undefined | KingOfTheHillSpecificDetailsKeySpecifier),
		fields?: KingOfTheHillSpecificDetailsFieldPolicy,
	},
	LadderSpecificDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LadderSpecificDetailsKeySpecifier | (() => undefined | LadderSpecificDetailsKeySpecifier),
		fields?: LadderSpecificDetailsFieldPolicy,
	},
	Language?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LanguageKeySpecifier | (() => undefined | LanguageKeySpecifier),
		fields?: LanguageFieldPolicy,
	},
	LanguageDto?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LanguageDtoKeySpecifier | (() => undefined | LanguageDtoKeySpecifier),
		fields?: LanguageDtoFieldPolicy,
	},
	LocalizedMediaContentDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocalizedMediaContentDetailsKeySpecifier | (() => undefined | LocalizedMediaContentDetailsKeySpecifier),
		fields?: LocalizedMediaContentDetailsFieldPolicy,
	},
	LocalizedOptionalString?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocalizedOptionalStringKeySpecifier | (() => undefined | LocalizedOptionalStringKeySpecifier),
		fields?: LocalizedOptionalStringFieldPolicy,
	},
	LocalizedString?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocalizedStringKeySpecifier | (() => undefined | LocalizedStringKeySpecifier),
		fields?: LocalizedStringFieldPolicy,
	},
	ManagedAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManagedAccountKeySpecifier | (() => undefined | ManagedAccountKeySpecifier),
		fields?: ManagedAccountFieldPolicy,
	},
	ManagedAccountWithPossibleError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManagedAccountWithPossibleErrorKeySpecifier | (() => undefined | ManagedAccountWithPossibleErrorKeySpecifier),
		fields?: ManagedAccountWithPossibleErrorFieldPolicy,
	},
	ManualResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManualResultKeySpecifier | (() => undefined | ManualResultKeySpecifier),
		fields?: ManualResultFieldPolicy,
	},
	ManuallyVerifiedResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManuallyVerifiedResultKeySpecifier | (() => undefined | ManuallyVerifiedResultKeySpecifier),
		fields?: ManuallyVerifiedResultFieldPolicy,
	},
	MatchModifications?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MatchModificationsKeySpecifier | (() => undefined | MatchModificationsKeySpecifier),
		fields?: MatchModificationsFieldPolicy,
	},
	MatchUp?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MatchUpKeySpecifier | (() => undefined | MatchUpKeySpecifier),
		fields?: MatchUpFieldPolicy,
	},
	MatchUpFormatSpecificDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MatchUpFormatSpecificDetailsKeySpecifier | (() => undefined | MatchUpFormatSpecificDetailsKeySpecifier),
		fields?: MatchUpFormatSpecificDetailsFieldPolicy,
	},
	MatchUpMatch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MatchUpMatchKeySpecifier | (() => undefined | MatchUpMatchKeySpecifier),
		fields?: MatchUpMatchFieldPolicy,
	},
	MatchUpMatchBye?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MatchUpMatchByeKeySpecifier | (() => undefined | MatchUpMatchByeKeySpecifier),
		fields?: MatchUpMatchByeFieldPolicy,
	},
	MatchUpPhase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MatchUpPhaseKeySpecifier | (() => undefined | MatchUpPhaseKeySpecifier),
		fields?: MatchUpPhaseFieldPolicy,
	},
	MatchUpRound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MatchUpRoundKeySpecifier | (() => undefined | MatchUpRoundKeySpecifier),
		fields?: MatchUpRoundFieldPolicy,
	},
	MaximumParticipantsBreakStrategy?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MaximumParticipantsBreakStrategyKeySpecifier | (() => undefined | MaximumParticipantsBreakStrategyKeySpecifier),
		fields?: MaximumParticipantsBreakStrategyFieldPolicy,
	},
	MediaContentDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaContentDetailsKeySpecifier | (() => undefined | MediaContentDetailsKeySpecifier),
		fields?: MediaContentDetailsFieldPolicy,
	},
	MediaTrait?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaTraitKeySpecifier | (() => undefined | MediaTraitKeySpecifier),
		fields?: MediaTraitFieldPolicy,
	},
	MediaTwitchStreamType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaTwitchStreamTypeKeySpecifier | (() => undefined | MediaTwitchStreamTypeKeySpecifier),
		fields?: MediaTwitchStreamTypeFieldPolicy,
	},
	MerchantPaymentMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MerchantPaymentMethodKeySpecifier | (() => undefined | MerchantPaymentMethodKeySpecifier),
		fields?: MerchantPaymentMethodFieldPolicy,
	},
	MissingParticipantRequirement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MissingParticipantRequirementKeySpecifier | (() => undefined | MissingParticipantRequirementKeySpecifier),
		fields?: MissingParticipantRequirementFieldPolicy,
	},
	MonetaryValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MonetaryValueKeySpecifier | (() => undefined | MonetaryValueKeySpecifier),
		fields?: MonetaryValueFieldPolicy,
	},
	MultiDimensionalBucketBasedResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MultiDimensionalBucketBasedResultKeySpecifier | (() => undefined | MultiDimensionalBucketBasedResultKeySpecifier),
		fields?: MultiDimensionalBucketBasedResultFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	NewHiveContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NewHiveContactKeySpecifier | (() => undefined | NewHiveContactKeySpecifier),
		fields?: NewHiveContactFieldPolicy,
	},
	NonIntegratedVoucher?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NonIntegratedVoucherKeySpecifier | (() => undefined | NonIntegratedVoucherKeySpecifier),
		fields?: NonIntegratedVoucherFieldPolicy,
	},
	NotEnoughTeamMembers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotEnoughTeamMembersKeySpecifier | (() => undefined | NotEnoughTeamMembersKeySpecifier),
		fields?: NotEnoughTeamMembersFieldPolicy,
	},
	ObjectRepresentation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ObjectRepresentationKeySpecifier | (() => undefined | ObjectRepresentationKeySpecifier),
		fields?: ObjectRepresentationFieldPolicy,
	},
	Order?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderKeySpecifier | (() => undefined | OrderKeySpecifier),
		fields?: OrderFieldPolicy,
	},
	OrderFieldsProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderFieldsProductKeySpecifier | (() => undefined | OrderFieldsProductKeySpecifier),
		fields?: OrderFieldsProductFieldPolicy,
	},
	OrderTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderTransactionKeySpecifier | (() => undefined | OrderTransactionKeySpecifier),
		fields?: OrderTransactionFieldPolicy,
	},
	OutOfContextCompetitionMatches?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OutOfContextCompetitionMatchesKeySpecifier | (() => undefined | OutOfContextCompetitionMatchesKeySpecifier),
		fields?: OutOfContextCompetitionMatchesFieldPolicy,
	},
	OutOfContextMatchUpMatches?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OutOfContextMatchUpMatchesKeySpecifier | (() => undefined | OutOfContextMatchUpMatchesKeySpecifier),
		fields?: OutOfContextMatchUpMatchesFieldPolicy,
	},
	OutOfContextPurchaseTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OutOfContextPurchaseTransactionKeySpecifier | (() => undefined | OutOfContextPurchaseTransactionKeySpecifier),
		fields?: OutOfContextPurchaseTransactionFieldPolicy,
	},
	OutOfContextTournamentMatches?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OutOfContextTournamentMatchesKeySpecifier | (() => undefined | OutOfContextTournamentMatchesKeySpecifier),
		fields?: OutOfContextTournamentMatchesFieldPolicy,
	},
	PaginatedBoughtTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedBoughtTransactionKeySpecifier | (() => undefined | PaginatedBoughtTransactionKeySpecifier),
		fields?: PaginatedBoughtTransactionFieldPolicy,
	},
	PaginatedCSVFiles?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedCSVFilesKeySpecifier | (() => undefined | PaginatedCSVFilesKeySpecifier),
		fields?: PaginatedCSVFilesFieldPolicy,
	},
	PaginatedCashOutTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedCashOutTransactionKeySpecifier | (() => undefined | PaginatedCashOutTransactionKeySpecifier),
		fields?: PaginatedCashOutTransactionFieldPolicy,
	},
	PaginatedCatalogItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedCatalogItemsKeySpecifier | (() => undefined | PaginatedCatalogItemsKeySpecifier),
		fields?: PaginatedCatalogItemsFieldPolicy,
	},
	PaginatedCategoryLanguage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedCategoryLanguageKeySpecifier | (() => undefined | PaginatedCategoryLanguageKeySpecifier),
		fields?: PaginatedCategoryLanguageFieldPolicy,
	},
	PaginatedCategoryProductGroups?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedCategoryProductGroupsKeySpecifier | (() => undefined | PaginatedCategoryProductGroupsKeySpecifier),
		fields?: PaginatedCategoryProductGroupsFieldPolicy,
	},
	PaginatedDeal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedDealKeySpecifier | (() => undefined | PaginatedDealKeySpecifier),
		fields?: PaginatedDealFieldPolicy,
	},
	PaginatedEmbeddedGame?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedEmbeddedGameKeySpecifier | (() => undefined | PaginatedEmbeddedGameKeySpecifier),
		fields?: PaginatedEmbeddedGameFieldPolicy,
	},
	PaginatedEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedEventKeySpecifier | (() => undefined | PaginatedEventKeySpecifier),
		fields?: PaginatedEventFieldPolicy,
	},
	PaginatedExchangedTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedExchangedTransactionKeySpecifier | (() => undefined | PaginatedExchangedTransactionKeySpecifier),
		fields?: PaginatedExchangedTransactionFieldPolicy,
	},
	PaginatedFailedOrderTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedFailedOrderTransactionKeySpecifier | (() => undefined | PaginatedFailedOrderTransactionKeySpecifier),
		fields?: PaginatedFailedOrderTransactionFieldPolicy,
	},
	PaginatedFreebieTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedFreebieTransactionKeySpecifier | (() => undefined | PaginatedFreebieTransactionKeySpecifier),
		fields?: PaginatedFreebieTransactionFieldPolicy,
	},
	PaginatedItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedItemsKeySpecifier | (() => undefined | PaginatedItemsKeySpecifier),
		fields?: PaginatedItemsFieldPolicy,
	},
	PaginatedOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedOrderKeySpecifier | (() => undefined | PaginatedOrderKeySpecifier),
		fields?: PaginatedOrderFieldPolicy,
	},
	PaginatedPartnerLanguage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedPartnerLanguageKeySpecifier | (() => undefined | PaginatedPartnerLanguageKeySpecifier),
		fields?: PaginatedPartnerLanguageFieldPolicy,
	},
	PaginatedPartnerProductGroups?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedPartnerProductGroupsKeySpecifier | (() => undefined | PaginatedPartnerProductGroupsKeySpecifier),
		fields?: PaginatedPartnerProductGroupsFieldPolicy,
	},
	PaginatedPaymentChannel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedPaymentChannelKeySpecifier | (() => undefined | PaginatedPaymentChannelKeySpecifier),
		fields?: PaginatedPaymentChannelFieldPolicy,
	},
	PaginatedProductGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedProductGroupKeySpecifier | (() => undefined | PaginatedProductGroupKeySpecifier),
		fields?: PaginatedProductGroupFieldPolicy,
	},
	PaginatedProducts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedProductsKeySpecifier | (() => undefined | PaginatedProductsKeySpecifier),
		fields?: PaginatedProductsFieldPolicy,
	},
	PaginatedSwarmioCurrency?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedSwarmioCurrencyKeySpecifier | (() => undefined | PaginatedSwarmioCurrencyKeySpecifier),
		fields?: PaginatedSwarmioCurrencyFieldPolicy,
	},
	PaginatedSwarmioCurrencyExchangeBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedSwarmioCurrencyExchangeBlockKeySpecifier | (() => undefined | PaginatedSwarmioCurrencyExchangeBlockKeySpecifier),
		fields?: PaginatedSwarmioCurrencyExchangeBlockFieldPolicy,
	},
	PaginatedSwarmioCurrencyItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedSwarmioCurrencyItemKeySpecifier | (() => undefined | PaginatedSwarmioCurrencyItemKeySpecifier),
		fields?: PaginatedSwarmioCurrencyItemFieldPolicy,
	},
	PaginatedSwarmioCurrencyPayout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedSwarmioCurrencyPayoutKeySpecifier | (() => undefined | PaginatedSwarmioCurrencyPayoutKeySpecifier),
		fields?: PaginatedSwarmioCurrencyPayoutFieldPolicy,
	},
	PaginatedSwarmioWalletTransactionWithMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedSwarmioWalletTransactionWithMetadataKeySpecifier | (() => undefined | PaginatedSwarmioWalletTransactionWithMetadataKeySpecifier),
		fields?: PaginatedSwarmioWalletTransactionWithMetadataFieldPolicy,
	},
	PaginatedTransferTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedTransferTransactionKeySpecifier | (() => undefined | PaginatedTransferTransactionKeySpecifier),
		fields?: PaginatedTransferTransactionFieldPolicy,
	},
	PaginatedUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedUserKeySpecifier | (() => undefined | PaginatedUserKeySpecifier),
		fields?: PaginatedUserFieldPolicy,
	},
	PaginatedVouchers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedVouchersKeySpecifier | (() => undefined | PaginatedVouchersKeySpecifier),
		fields?: PaginatedVouchersFieldPolicy,
	},
	Participant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ParticipantKeySpecifier | (() => undefined | ParticipantKeySpecifier),
		fields?: ParticipantFieldPolicy,
	},
	ParticipantReference?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ParticipantReferenceKeySpecifier | (() => undefined | ParticipantReferenceKeySpecifier),
		fields?: ParticipantReferenceFieldPolicy,
	},
	ParticipantRequirementNotMet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ParticipantRequirementNotMetKeySpecifier | (() => undefined | ParticipantRequirementNotMetKeySpecifier),
		fields?: ParticipantRequirementNotMetFieldPolicy,
	},
	ParticipantScore?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ParticipantScoreKeySpecifier | (() => undefined | ParticipantScoreKeySpecifier),
		fields?: ParticipantScoreFieldPolicy,
	},
	ParticipationData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ParticipationDataKeySpecifier | (() => undefined | ParticipationDataKeySpecifier),
		fields?: ParticipationDataFieldPolicy,
	},
	Partner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerKeySpecifier | (() => undefined | PartnerKeySpecifier),
		fields?: PartnerFieldPolicy,
	},
	PartnerConversion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerConversionKeySpecifier | (() => undefined | PartnerConversionKeySpecifier),
		fields?: PartnerConversionFieldPolicy,
	},
	PartnerCurrencyPreference?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerCurrencyPreferenceKeySpecifier | (() => undefined | PartnerCurrencyPreferenceKeySpecifier),
		fields?: PartnerCurrencyPreferenceFieldPolicy,
	},
	PartnerItemPaymentChannelResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerItemPaymentChannelResponseKeySpecifier | (() => undefined | PartnerItemPaymentChannelResponseKeySpecifier),
		fields?: PartnerItemPaymentChannelResponseFieldPolicy,
	},
	PartnerLanguage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerLanguageKeySpecifier | (() => undefined | PartnerLanguageKeySpecifier),
		fields?: PartnerLanguageFieldPolicy,
	},
	PartnerLocalCurrencyConversion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerLocalCurrencyConversionKeySpecifier | (() => undefined | PartnerLocalCurrencyConversionKeySpecifier),
		fields?: PartnerLocalCurrencyConversionFieldPolicy,
	},
	PartnerPaymentChannel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerPaymentChannelKeySpecifier | (() => undefined | PartnerPaymentChannelKeySpecifier),
		fields?: PartnerPaymentChannelFieldPolicy,
	},
	PartnerPaymentChannelData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PartnerPaymentChannelDataKeySpecifier | (() => undefined | PartnerPaymentChannelDataKeySpecifier),
		fields?: PartnerPaymentChannelDataFieldPolicy,
	},
	PayPurchaseTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayPurchaseTransactionKeySpecifier | (() => undefined | PayPurchaseTransactionKeySpecifier),
		fields?: PayPurchaseTransactionFieldPolicy,
	},
	PayloadLockedDocument?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentKeySpecifier | (() => undefined | PayloadLockedDocumentKeySpecifier),
		fields?: PayloadLockedDocumentFieldPolicy,
	},
	PayloadLockedDocument_Document_Relationship?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocument_Document_RelationshipKeySpecifier | (() => undefined | PayloadLockedDocument_Document_RelationshipKeySpecifier),
		fields?: PayloadLockedDocument_Document_RelationshipFieldPolicy,
	},
	PayloadLockedDocument_User_Relationship?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocument_User_RelationshipKeySpecifier | (() => undefined | PayloadLockedDocument_User_RelationshipKeySpecifier),
		fields?: PayloadLockedDocument_User_RelationshipFieldPolicy,
	},
	PayloadLockedDocuments?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsKeySpecifier | (() => undefined | PayloadLockedDocumentsKeySpecifier),
		fields?: PayloadLockedDocumentsFieldPolicy,
	},
	PayloadLockedDocumentsCreateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsCreateAccessKeySpecifier | (() => undefined | PayloadLockedDocumentsCreateAccessKeySpecifier),
		fields?: PayloadLockedDocumentsCreateAccessFieldPolicy,
	},
	PayloadLockedDocumentsCreateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsCreateDocAccessKeySpecifier | (() => undefined | PayloadLockedDocumentsCreateDocAccessKeySpecifier),
		fields?: PayloadLockedDocumentsCreateDocAccessFieldPolicy,
	},
	PayloadLockedDocumentsDeleteAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDeleteAccessKeySpecifier | (() => undefined | PayloadLockedDocumentsDeleteAccessKeySpecifier),
		fields?: PayloadLockedDocumentsDeleteAccessFieldPolicy,
	},
	PayloadLockedDocumentsDeleteDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDeleteDocAccessKeySpecifier | (() => undefined | PayloadLockedDocumentsDeleteDocAccessKeySpecifier),
		fields?: PayloadLockedDocumentsDeleteDocAccessFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFieldsKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFieldsKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFieldsFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_createdAtKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_createdAtKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_createdAtFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_createdAt_CreateKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_createdAt_CreateKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_createdAt_CreateFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_createdAt_DeleteKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_createdAt_DeleteKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_createdAt_DeleteFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_createdAt_ReadKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_createdAt_ReadKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_createdAt_ReadFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_createdAt_UpdateKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_createdAt_UpdateKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_createdAt_UpdateFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_document?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_documentKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_documentKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_documentFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_document_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_document_CreateKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_document_CreateKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_document_CreateFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_document_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_document_DeleteKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_document_DeleteKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_document_DeleteFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_document_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_document_ReadKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_document_ReadKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_document_ReadFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_document_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_document_UpdateKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_document_UpdateKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_document_UpdateFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_globalSlug?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_globalSlugKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_globalSlugKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_globalSlugFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_globalSlug_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_globalSlug_CreateKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_globalSlug_CreateKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_globalSlug_CreateFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_globalSlug_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_globalSlug_DeleteKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_globalSlug_DeleteKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_globalSlug_DeleteFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_globalSlug_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_globalSlug_ReadKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_globalSlug_ReadKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_globalSlug_ReadFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_globalSlug_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_globalSlug_UpdateKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_globalSlug_UpdateKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_globalSlug_UpdateFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_updatedAtKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_updatedAtKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_updatedAtFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_updatedAt_CreateKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_updatedAt_CreateKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_updatedAt_CreateFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_updatedAt_DeleteKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_updatedAt_DeleteKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_updatedAt_DeleteFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_updatedAt_ReadKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_updatedAt_ReadKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_updatedAt_ReadFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_updatedAt_UpdateKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_updatedAt_UpdateKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_updatedAt_UpdateFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_user?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_userKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_userKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_userFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_user_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_user_CreateKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_user_CreateKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_user_CreateFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_user_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_user_DeleteKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_user_DeleteKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_user_DeleteFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_user_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_user_ReadKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_user_ReadKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_user_ReadFieldPolicy,
	},
	PayloadLockedDocumentsDocAccessFields_user_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsDocAccessFields_user_UpdateKeySpecifier | (() => undefined | PayloadLockedDocumentsDocAccessFields_user_UpdateKeySpecifier),
		fields?: PayloadLockedDocumentsDocAccessFields_user_UpdateFieldPolicy,
	},
	PayloadLockedDocumentsFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFieldsKeySpecifier | (() => undefined | PayloadLockedDocumentsFieldsKeySpecifier),
		fields?: PayloadLockedDocumentsFieldsFieldPolicy,
	},
	PayloadLockedDocumentsFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_createdAtKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_createdAtKeySpecifier),
		fields?: PayloadLockedDocumentsFields_createdAtFieldPolicy,
	},
	PayloadLockedDocumentsFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_createdAt_CreateKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_createdAt_CreateKeySpecifier),
		fields?: PayloadLockedDocumentsFields_createdAt_CreateFieldPolicy,
	},
	PayloadLockedDocumentsFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_createdAt_DeleteKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_createdAt_DeleteKeySpecifier),
		fields?: PayloadLockedDocumentsFields_createdAt_DeleteFieldPolicy,
	},
	PayloadLockedDocumentsFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_createdAt_ReadKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_createdAt_ReadKeySpecifier),
		fields?: PayloadLockedDocumentsFields_createdAt_ReadFieldPolicy,
	},
	PayloadLockedDocumentsFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_createdAt_UpdateKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_createdAt_UpdateKeySpecifier),
		fields?: PayloadLockedDocumentsFields_createdAt_UpdateFieldPolicy,
	},
	PayloadLockedDocumentsFields_document?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_documentKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_documentKeySpecifier),
		fields?: PayloadLockedDocumentsFields_documentFieldPolicy,
	},
	PayloadLockedDocumentsFields_document_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_document_CreateKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_document_CreateKeySpecifier),
		fields?: PayloadLockedDocumentsFields_document_CreateFieldPolicy,
	},
	PayloadLockedDocumentsFields_document_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_document_DeleteKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_document_DeleteKeySpecifier),
		fields?: PayloadLockedDocumentsFields_document_DeleteFieldPolicy,
	},
	PayloadLockedDocumentsFields_document_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_document_ReadKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_document_ReadKeySpecifier),
		fields?: PayloadLockedDocumentsFields_document_ReadFieldPolicy,
	},
	PayloadLockedDocumentsFields_document_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_document_UpdateKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_document_UpdateKeySpecifier),
		fields?: PayloadLockedDocumentsFields_document_UpdateFieldPolicy,
	},
	PayloadLockedDocumentsFields_globalSlug?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_globalSlugKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_globalSlugKeySpecifier),
		fields?: PayloadLockedDocumentsFields_globalSlugFieldPolicy,
	},
	PayloadLockedDocumentsFields_globalSlug_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_globalSlug_CreateKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_globalSlug_CreateKeySpecifier),
		fields?: PayloadLockedDocumentsFields_globalSlug_CreateFieldPolicy,
	},
	PayloadLockedDocumentsFields_globalSlug_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_globalSlug_DeleteKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_globalSlug_DeleteKeySpecifier),
		fields?: PayloadLockedDocumentsFields_globalSlug_DeleteFieldPolicy,
	},
	PayloadLockedDocumentsFields_globalSlug_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_globalSlug_ReadKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_globalSlug_ReadKeySpecifier),
		fields?: PayloadLockedDocumentsFields_globalSlug_ReadFieldPolicy,
	},
	PayloadLockedDocumentsFields_globalSlug_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_globalSlug_UpdateKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_globalSlug_UpdateKeySpecifier),
		fields?: PayloadLockedDocumentsFields_globalSlug_UpdateFieldPolicy,
	},
	PayloadLockedDocumentsFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_updatedAtKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_updatedAtKeySpecifier),
		fields?: PayloadLockedDocumentsFields_updatedAtFieldPolicy,
	},
	PayloadLockedDocumentsFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_updatedAt_CreateKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_updatedAt_CreateKeySpecifier),
		fields?: PayloadLockedDocumentsFields_updatedAt_CreateFieldPolicy,
	},
	PayloadLockedDocumentsFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_updatedAt_DeleteKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_updatedAt_DeleteKeySpecifier),
		fields?: PayloadLockedDocumentsFields_updatedAt_DeleteFieldPolicy,
	},
	PayloadLockedDocumentsFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_updatedAt_ReadKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_updatedAt_ReadKeySpecifier),
		fields?: PayloadLockedDocumentsFields_updatedAt_ReadFieldPolicy,
	},
	PayloadLockedDocumentsFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_updatedAt_UpdateKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_updatedAt_UpdateKeySpecifier),
		fields?: PayloadLockedDocumentsFields_updatedAt_UpdateFieldPolicy,
	},
	PayloadLockedDocumentsFields_user?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_userKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_userKeySpecifier),
		fields?: PayloadLockedDocumentsFields_userFieldPolicy,
	},
	PayloadLockedDocumentsFields_user_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_user_CreateKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_user_CreateKeySpecifier),
		fields?: PayloadLockedDocumentsFields_user_CreateFieldPolicy,
	},
	PayloadLockedDocumentsFields_user_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_user_DeleteKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_user_DeleteKeySpecifier),
		fields?: PayloadLockedDocumentsFields_user_DeleteFieldPolicy,
	},
	PayloadLockedDocumentsFields_user_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_user_ReadKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_user_ReadKeySpecifier),
		fields?: PayloadLockedDocumentsFields_user_ReadFieldPolicy,
	},
	PayloadLockedDocumentsFields_user_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsFields_user_UpdateKeySpecifier | (() => undefined | PayloadLockedDocumentsFields_user_UpdateKeySpecifier),
		fields?: PayloadLockedDocumentsFields_user_UpdateFieldPolicy,
	},
	PayloadLockedDocumentsReadAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsReadAccessKeySpecifier | (() => undefined | PayloadLockedDocumentsReadAccessKeySpecifier),
		fields?: PayloadLockedDocumentsReadAccessFieldPolicy,
	},
	PayloadLockedDocumentsReadDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsReadDocAccessKeySpecifier | (() => undefined | PayloadLockedDocumentsReadDocAccessKeySpecifier),
		fields?: PayloadLockedDocumentsReadDocAccessFieldPolicy,
	},
	PayloadLockedDocumentsUpdateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsUpdateAccessKeySpecifier | (() => undefined | PayloadLockedDocumentsUpdateAccessKeySpecifier),
		fields?: PayloadLockedDocumentsUpdateAccessFieldPolicy,
	},
	PayloadLockedDocumentsUpdateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadLockedDocumentsUpdateDocAccessKeySpecifier | (() => undefined | PayloadLockedDocumentsUpdateDocAccessKeySpecifier),
		fields?: PayloadLockedDocumentsUpdateDocAccessFieldPolicy,
	},
	PayloadPreference?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferenceKeySpecifier | (() => undefined | PayloadPreferenceKeySpecifier),
		fields?: PayloadPreferenceFieldPolicy,
	},
	PayloadPreference_User_Relationship?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreference_User_RelationshipKeySpecifier | (() => undefined | PayloadPreference_User_RelationshipKeySpecifier),
		fields?: PayloadPreference_User_RelationshipFieldPolicy,
	},
	PayloadPreferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesKeySpecifier | (() => undefined | PayloadPreferencesKeySpecifier),
		fields?: PayloadPreferencesFieldPolicy,
	},
	PayloadPreferencesCreateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesCreateAccessKeySpecifier | (() => undefined | PayloadPreferencesCreateAccessKeySpecifier),
		fields?: PayloadPreferencesCreateAccessFieldPolicy,
	},
	PayloadPreferencesCreateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesCreateDocAccessKeySpecifier | (() => undefined | PayloadPreferencesCreateDocAccessKeySpecifier),
		fields?: PayloadPreferencesCreateDocAccessFieldPolicy,
	},
	PayloadPreferencesDeleteAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDeleteAccessKeySpecifier | (() => undefined | PayloadPreferencesDeleteAccessKeySpecifier),
		fields?: PayloadPreferencesDeleteAccessFieldPolicy,
	},
	PayloadPreferencesDeleteDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDeleteDocAccessKeySpecifier | (() => undefined | PayloadPreferencesDeleteDocAccessKeySpecifier),
		fields?: PayloadPreferencesDeleteDocAccessFieldPolicy,
	},
	PayloadPreferencesDocAccessFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFieldsKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFieldsKeySpecifier),
		fields?: PayloadPreferencesDocAccessFieldsFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_createdAtKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_createdAtKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_createdAtFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_createdAt_CreateKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_createdAt_CreateKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_createdAt_CreateFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_createdAt_DeleteKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_createdAt_DeleteKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_createdAt_DeleteFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_createdAt_ReadKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_createdAt_ReadKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_createdAt_ReadFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_createdAt_UpdateKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_createdAt_UpdateKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_createdAt_UpdateFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_key?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_keyKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_keyKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_keyFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_key_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_key_CreateKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_key_CreateKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_key_CreateFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_key_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_key_DeleteKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_key_DeleteKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_key_DeleteFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_key_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_key_ReadKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_key_ReadKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_key_ReadFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_key_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_key_UpdateKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_key_UpdateKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_key_UpdateFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_updatedAtKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_updatedAtKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_updatedAtFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_updatedAt_CreateKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_updatedAt_CreateKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_updatedAt_CreateFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_updatedAt_DeleteKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_updatedAt_DeleteKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_updatedAt_DeleteFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_updatedAt_ReadKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_updatedAt_ReadKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_updatedAt_ReadFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_updatedAt_UpdateKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_updatedAt_UpdateKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_updatedAt_UpdateFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_user?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_userKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_userKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_userFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_user_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_user_CreateKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_user_CreateKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_user_CreateFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_user_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_user_DeleteKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_user_DeleteKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_user_DeleteFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_user_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_user_ReadKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_user_ReadKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_user_ReadFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_user_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_user_UpdateKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_user_UpdateKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_user_UpdateFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_value?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_valueKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_valueKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_valueFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_value_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_value_CreateKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_value_CreateKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_value_CreateFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_value_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_value_DeleteKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_value_DeleteKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_value_DeleteFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_value_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_value_ReadKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_value_ReadKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_value_ReadFieldPolicy,
	},
	PayloadPreferencesDocAccessFields_value_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesDocAccessFields_value_UpdateKeySpecifier | (() => undefined | PayloadPreferencesDocAccessFields_value_UpdateKeySpecifier),
		fields?: PayloadPreferencesDocAccessFields_value_UpdateFieldPolicy,
	},
	PayloadPreferencesFields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFieldsKeySpecifier | (() => undefined | PayloadPreferencesFieldsKeySpecifier),
		fields?: PayloadPreferencesFieldsFieldPolicy,
	},
	PayloadPreferencesFields_createdAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_createdAtKeySpecifier | (() => undefined | PayloadPreferencesFields_createdAtKeySpecifier),
		fields?: PayloadPreferencesFields_createdAtFieldPolicy,
	},
	PayloadPreferencesFields_createdAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_createdAt_CreateKeySpecifier | (() => undefined | PayloadPreferencesFields_createdAt_CreateKeySpecifier),
		fields?: PayloadPreferencesFields_createdAt_CreateFieldPolicy,
	},
	PayloadPreferencesFields_createdAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_createdAt_DeleteKeySpecifier | (() => undefined | PayloadPreferencesFields_createdAt_DeleteKeySpecifier),
		fields?: PayloadPreferencesFields_createdAt_DeleteFieldPolicy,
	},
	PayloadPreferencesFields_createdAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_createdAt_ReadKeySpecifier | (() => undefined | PayloadPreferencesFields_createdAt_ReadKeySpecifier),
		fields?: PayloadPreferencesFields_createdAt_ReadFieldPolicy,
	},
	PayloadPreferencesFields_createdAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_createdAt_UpdateKeySpecifier | (() => undefined | PayloadPreferencesFields_createdAt_UpdateKeySpecifier),
		fields?: PayloadPreferencesFields_createdAt_UpdateFieldPolicy,
	},
	PayloadPreferencesFields_key?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_keyKeySpecifier | (() => undefined | PayloadPreferencesFields_keyKeySpecifier),
		fields?: PayloadPreferencesFields_keyFieldPolicy,
	},
	PayloadPreferencesFields_key_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_key_CreateKeySpecifier | (() => undefined | PayloadPreferencesFields_key_CreateKeySpecifier),
		fields?: PayloadPreferencesFields_key_CreateFieldPolicy,
	},
	PayloadPreferencesFields_key_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_key_DeleteKeySpecifier | (() => undefined | PayloadPreferencesFields_key_DeleteKeySpecifier),
		fields?: PayloadPreferencesFields_key_DeleteFieldPolicy,
	},
	PayloadPreferencesFields_key_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_key_ReadKeySpecifier | (() => undefined | PayloadPreferencesFields_key_ReadKeySpecifier),
		fields?: PayloadPreferencesFields_key_ReadFieldPolicy,
	},
	PayloadPreferencesFields_key_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_key_UpdateKeySpecifier | (() => undefined | PayloadPreferencesFields_key_UpdateKeySpecifier),
		fields?: PayloadPreferencesFields_key_UpdateFieldPolicy,
	},
	PayloadPreferencesFields_updatedAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_updatedAtKeySpecifier | (() => undefined | PayloadPreferencesFields_updatedAtKeySpecifier),
		fields?: PayloadPreferencesFields_updatedAtFieldPolicy,
	},
	PayloadPreferencesFields_updatedAt_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_updatedAt_CreateKeySpecifier | (() => undefined | PayloadPreferencesFields_updatedAt_CreateKeySpecifier),
		fields?: PayloadPreferencesFields_updatedAt_CreateFieldPolicy,
	},
	PayloadPreferencesFields_updatedAt_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_updatedAt_DeleteKeySpecifier | (() => undefined | PayloadPreferencesFields_updatedAt_DeleteKeySpecifier),
		fields?: PayloadPreferencesFields_updatedAt_DeleteFieldPolicy,
	},
	PayloadPreferencesFields_updatedAt_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_updatedAt_ReadKeySpecifier | (() => undefined | PayloadPreferencesFields_updatedAt_ReadKeySpecifier),
		fields?: PayloadPreferencesFields_updatedAt_ReadFieldPolicy,
	},
	PayloadPreferencesFields_updatedAt_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_updatedAt_UpdateKeySpecifier | (() => undefined | PayloadPreferencesFields_updatedAt_UpdateKeySpecifier),
		fields?: PayloadPreferencesFields_updatedAt_UpdateFieldPolicy,
	},
	PayloadPreferencesFields_user?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_userKeySpecifier | (() => undefined | PayloadPreferencesFields_userKeySpecifier),
		fields?: PayloadPreferencesFields_userFieldPolicy,
	},
	PayloadPreferencesFields_user_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_user_CreateKeySpecifier | (() => undefined | PayloadPreferencesFields_user_CreateKeySpecifier),
		fields?: PayloadPreferencesFields_user_CreateFieldPolicy,
	},
	PayloadPreferencesFields_user_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_user_DeleteKeySpecifier | (() => undefined | PayloadPreferencesFields_user_DeleteKeySpecifier),
		fields?: PayloadPreferencesFields_user_DeleteFieldPolicy,
	},
	PayloadPreferencesFields_user_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_user_ReadKeySpecifier | (() => undefined | PayloadPreferencesFields_user_ReadKeySpecifier),
		fields?: PayloadPreferencesFields_user_ReadFieldPolicy,
	},
	PayloadPreferencesFields_user_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_user_UpdateKeySpecifier | (() => undefined | PayloadPreferencesFields_user_UpdateKeySpecifier),
		fields?: PayloadPreferencesFields_user_UpdateFieldPolicy,
	},
	PayloadPreferencesFields_value?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_valueKeySpecifier | (() => undefined | PayloadPreferencesFields_valueKeySpecifier),
		fields?: PayloadPreferencesFields_valueFieldPolicy,
	},
	PayloadPreferencesFields_value_Create?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_value_CreateKeySpecifier | (() => undefined | PayloadPreferencesFields_value_CreateKeySpecifier),
		fields?: PayloadPreferencesFields_value_CreateFieldPolicy,
	},
	PayloadPreferencesFields_value_Delete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_value_DeleteKeySpecifier | (() => undefined | PayloadPreferencesFields_value_DeleteKeySpecifier),
		fields?: PayloadPreferencesFields_value_DeleteFieldPolicy,
	},
	PayloadPreferencesFields_value_Read?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_value_ReadKeySpecifier | (() => undefined | PayloadPreferencesFields_value_ReadKeySpecifier),
		fields?: PayloadPreferencesFields_value_ReadFieldPolicy,
	},
	PayloadPreferencesFields_value_Update?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesFields_value_UpdateKeySpecifier | (() => undefined | PayloadPreferencesFields_value_UpdateKeySpecifier),
		fields?: PayloadPreferencesFields_value_UpdateFieldPolicy,
	},
	PayloadPreferencesReadAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesReadAccessKeySpecifier | (() => undefined | PayloadPreferencesReadAccessKeySpecifier),
		fields?: PayloadPreferencesReadAccessFieldPolicy,
	},
	PayloadPreferencesReadDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesReadDocAccessKeySpecifier | (() => undefined | PayloadPreferencesReadDocAccessKeySpecifier),
		fields?: PayloadPreferencesReadDocAccessFieldPolicy,
	},
	PayloadPreferencesUpdateAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesUpdateAccessKeySpecifier | (() => undefined | PayloadPreferencesUpdateAccessKeySpecifier),
		fields?: PayloadPreferencesUpdateAccessFieldPolicy,
	},
	PayloadPreferencesUpdateDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayloadPreferencesUpdateDocAccessKeySpecifier | (() => undefined | PayloadPreferencesUpdateDocAccessKeySpecifier),
		fields?: PayloadPreferencesUpdateDocAccessFieldPolicy,
	},
	Payment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentKeySpecifier | (() => undefined | PaymentKeySpecifier),
		fields?: PaymentFieldPolicy,
	},
	PaymentChannel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentChannelKeySpecifier | (() => undefined | PaymentChannelKeySpecifier),
		fields?: PaymentChannelFieldPolicy,
	},
	PaymentChannelPricing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentChannelPricingKeySpecifier | (() => undefined | PaymentChannelPricingKeySpecifier),
		fields?: PaymentChannelPricingFieldPolicy,
	},
	PaymentMethodConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodConfigKeySpecifier | (() => undefined | PaymentMethodConfigKeySpecifier),
		fields?: PaymentMethodConfigFieldPolicy,
	},
	Person?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PersonKeySpecifier | (() => undefined | PersonKeySpecifier),
		fields?: PersonFieldPolicy,
	},
	PhaseModifications?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhaseModificationsKeySpecifier | (() => undefined | PhaseModificationsKeySpecifier),
		fields?: PhaseModificationsFieldPolicy,
	},
	PhasedCompetitionFormatSpecificDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PhasedCompetitionFormatSpecificDetailsKeySpecifier | (() => undefined | PhasedCompetitionFormatSpecificDetailsKeySpecifier),
		fields?: PhasedCompetitionFormatSpecificDetailsFieldPolicy,
	},
	PlayableMatchUpMatch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayableMatchUpMatchKeySpecifier | (() => undefined | PlayableMatchUpMatchKeySpecifier),
		fields?: PlayableMatchUpMatchFieldPolicy,
	},
	PlayableTournamentMatch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlayableTournamentMatchKeySpecifier | (() => undefined | PlayableTournamentMatchKeySpecifier),
		fields?: PlayableTournamentMatchFieldPolicy,
	},
	Points?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PointsKeySpecifier | (() => undefined | PointsKeySpecifier),
		fields?: PointsFieldPolicy,
	},
	PointsArchive?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PointsArchiveKeySpecifier | (() => undefined | PointsArchiveKeySpecifier),
		fields?: PointsArchiveFieldPolicy,
	},
	PrivateGameServer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrivateGameServerKeySpecifier | (() => undefined | PrivateGameServerKeySpecifier),
		fields?: PrivateGameServerFieldPolicy,
	},
	Prize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrizeKeySpecifier | (() => undefined | PrizeKeySpecifier),
		fields?: PrizeFieldPolicy,
	},
	PrizeList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrizeListKeySpecifier | (() => undefined | PrizeListKeySpecifier),
		fields?: PrizeListFieldPolicy,
	},
	PrizePayoutReceipt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrizePayoutReceiptKeySpecifier | (() => undefined | PrizePayoutReceiptKeySpecifier),
		fields?: PrizePayoutReceiptFieldPolicy,
	},
	PrizeTier?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrizeTierKeySpecifier | (() => undefined | PrizeTierKeySpecifier),
		fields?: PrizeTierFieldPolicy,
	},
	Product?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductKeySpecifier | (() => undefined | ProductKeySpecifier),
		fields?: ProductFieldPolicy,
	},
	ProductDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductDeleteKeySpecifier | (() => undefined | ProductDeleteKeySpecifier),
		fields?: ProductDeleteFieldPolicy,
	},
	ProductGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductGroupKeySpecifier | (() => undefined | ProductGroupKeySpecifier),
		fields?: ProductGroupFieldPolicy,
	},
	ProductGroupCatalogCategory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductGroupCatalogCategoryKeySpecifier | (() => undefined | ProductGroupCatalogCategoryKeySpecifier),
		fields?: ProductGroupCatalogCategoryFieldPolicy,
	},
	ProductGroupCatalogCategoryInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductGroupCatalogCategoryInfoKeySpecifier | (() => undefined | ProductGroupCatalogCategoryInfoKeySpecifier),
		fields?: ProductGroupCatalogCategoryInfoFieldPolicy,
	},
	ProductGroupInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductGroupInfoKeySpecifier | (() => undefined | ProductGroupInfoKeySpecifier),
		fields?: ProductGroupInfoFieldPolicy,
	},
	ProductGroupItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductGroupItemKeySpecifier | (() => undefined | ProductGroupItemKeySpecifier),
		fields?: ProductGroupItemFieldPolicy,
	},
	ProductGroupLanguageDTO?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductGroupLanguageDTOKeySpecifier | (() => undefined | ProductGroupLanguageDTOKeySpecifier),
		fields?: ProductGroupLanguageDTOFieldPolicy,
	},
	ProductGroupLanguageData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductGroupLanguageDataKeySpecifier | (() => undefined | ProductGroupLanguageDataKeySpecifier),
		fields?: ProductGroupLanguageDataFieldPolicy,
	},
	ProductGroupLanguageResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductGroupLanguageResponseKeySpecifier | (() => undefined | ProductGroupLanguageResponseKeySpecifier),
		fields?: ProductGroupLanguageResponseFieldPolicy,
	},
	ProductGroupLanguagesResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductGroupLanguagesResponseKeySpecifier | (() => undefined | ProductGroupLanguagesResponseKeySpecifier),
		fields?: ProductGroupLanguagesResponseFieldPolicy,
	},
	ProductGroupResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductGroupResponseKeySpecifier | (() => undefined | ProductGroupResponseKeySpecifier),
		fields?: ProductGroupResponseFieldPolicy,
	},
	ProductPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductPriceKeySpecifier | (() => undefined | ProductPriceKeySpecifier),
		fields?: ProductPriceFieldPolicy,
	},
	ProductVoucher?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVoucherKeySpecifier | (() => undefined | ProductVoucherKeySpecifier),
		fields?: ProductVoucherFieldPolicy,
	},
	PrunedDoubleEliminationSpecificDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrunedDoubleEliminationSpecificDetailsKeySpecifier | (() => undefined | PrunedDoubleEliminationSpecificDetailsKeySpecifier),
		fields?: PrunedDoubleEliminationSpecificDetailsFieldPolicy,
	},
	PrunedSingleEliminationSpecificDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PrunedSingleEliminationSpecificDetailsKeySpecifier | (() => undefined | PrunedSingleEliminationSpecificDetailsKeySpecifier),
		fields?: PrunedSingleEliminationSpecificDetailsFieldPolicy,
	},
	PublicGameServer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicGameServerKeySpecifier | (() => undefined | PublicGameServerKeySpecifier),
		fields?: PublicGameServerFieldPolicy,
	},
	PurchaseResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PurchaseResponseKeySpecifier | (() => undefined | PurchaseResponseKeySpecifier),
		fields?: PurchaseResponseFieldPolicy,
	},
	PurchaseTagIdRegistrationResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PurchaseTagIdRegistrationResponseKeySpecifier | (() => undefined | PurchaseTagIdRegistrationResponseKeySpecifier),
		fields?: PurchaseTagIdRegistrationResponseFieldPolicy,
	},
	PurchaseTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PurchaseTransactionKeySpecifier | (() => undefined | PurchaseTransactionKeySpecifier),
		fields?: PurchaseTransactionFieldPolicy,
	},
	PurchaserData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PurchaserDataKeySpecifier | (() => undefined | PurchaserDataKeySpecifier),
		fields?: PurchaserDataFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	ReadyIndividualParticipant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReadyIndividualParticipantKeySpecifier | (() => undefined | ReadyIndividualParticipantKeySpecifier),
		fields?: ReadyIndividualParticipantFieldPolicy,
	},
	RealWorldCurrencyCost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RealWorldCurrencyCostKeySpecifier | (() => undefined | RealWorldCurrencyCostKeySpecifier),
		fields?: RealWorldCurrencyCostFieldPolicy,
	},
	Recipient?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RecipientKeySpecifier | (() => undefined | RecipientKeySpecifier),
		fields?: RecipientFieldPolicy,
	},
	RecurringReward?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RecurringRewardKeySpecifier | (() => undefined | RecurringRewardKeySpecifier),
		fields?: RecurringRewardFieldPolicy,
	},
	Redemption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RedemptionKeySpecifier | (() => undefined | RedemptionKeySpecifier),
		fields?: RedemptionFieldPolicy,
	},
	Result?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResultKeySpecifier | (() => undefined | ResultKeySpecifier),
		fields?: ResultFieldPolicy,
	},
	ResultBucket?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResultBucketKeySpecifier | (() => undefined | ResultBucketKeySpecifier),
		fields?: ResultBucketFieldPolicy,
	},
	RetriedFailedTransactions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RetriedFailedTransactionsKeySpecifier | (() => undefined | RetriedFailedTransactionsKeySpecifier),
		fields?: RetriedFailedTransactionsFieldPolicy,
	},
	Role?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleKeySpecifier | (() => undefined | RoleKeySpecifier),
		fields?: RoleFieldPolicy,
	},
	RootCode_Order?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RootCode_OrderKeySpecifier | (() => undefined | RootCode_OrderKeySpecifier),
		fields?: RootCode_OrderFieldPolicy,
	},
	RootCode_ProductVoucher?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RootCode_ProductVoucherKeySpecifier | (() => undefined | RootCode_ProductVoucherKeySpecifier),
		fields?: RootCode_ProductVoucherFieldPolicy,
	},
	Rule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RuleKeySpecifier | (() => undefined | RuleKeySpecifier),
		fields?: RuleFieldPolicy,
	},
	SLTExternalSubscriptionPackage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SLTExternalSubscriptionPackageKeySpecifier | (() => undefined | SLTExternalSubscriptionPackageKeySpecifier),
		fields?: SLTExternalSubscriptionPackageFieldPolicy,
	},
	SLTProviderAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SLTProviderAccountKeySpecifier | (() => undefined | SLTProviderAccountKeySpecifier),
		fields?: SLTProviderAccountFieldPolicy,
	},
	SLTProviderExternalSubscriptionPackage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SLTProviderExternalSubscriptionPackageKeySpecifier | (() => undefined | SLTProviderExternalSubscriptionPackageKeySpecifier),
		fields?: SLTProviderExternalSubscriptionPackageFieldPolicy,
	},
	Segment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SegmentKeySpecifier | (() => undefined | SegmentKeySpecifier),
		fields?: SegmentFieldPolicy,
	},
	Server?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServerKeySpecifier | (() => undefined | ServerKeySpecifier),
		fields?: ServerFieldPolicy,
	},
	ServerDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ServerDetailsKeySpecifier | (() => undefined | ServerDetailsKeySpecifier),
		fields?: ServerDetailsFieldPolicy,
	},
	SessionRequestResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionRequestResultKeySpecifier | (() => undefined | SessionRequestResultKeySpecifier),
		fields?: SessionRequestResultFieldPolicy,
	},
	Shipment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShipmentKeySpecifier | (() => undefined | ShipmentKeySpecifier),
		fields?: ShipmentFieldPolicy,
	},
	SingleDimensionResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SingleDimensionResultKeySpecifier | (() => undefined | SingleDimensionResultKeySpecifier),
		fields?: SingleDimensionResultFieldPolicy,
	},
	SingleEliminationSpecificDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SingleEliminationSpecificDetailsKeySpecifier | (() => undefined | SingleEliminationSpecificDetailsKeySpecifier),
		fields?: SingleEliminationSpecificDetailsFieldPolicy,
	},
	SocialLink?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SocialLinkKeySpecifier | (() => undefined | SocialLinkKeySpecifier),
		fields?: SocialLinkFieldPolicy,
	},
	SpecificSubscriptionPrizeCondition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpecificSubscriptionPrizeConditionKeySpecifier | (() => undefined | SpecificSubscriptionPrizeConditionKeySpecifier),
		fields?: SpecificSubscriptionPrizeConditionFieldPolicy,
	},
	StoreMerchantPaymentMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StoreMerchantPaymentMethodKeySpecifier | (() => undefined | StoreMerchantPaymentMethodKeySpecifier),
		fields?: StoreMerchantPaymentMethodFieldPolicy,
	},
	Stream?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StreamKeySpecifier | (() => undefined | StreamKeySpecifier),
		fields?: StreamFieldPolicy,
	},
	StreamingEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StreamingEventKeySpecifier | (() => undefined | StreamingEventKeySpecifier),
		fields?: StreamingEventFieldPolicy,
	},
	Streams?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StreamsKeySpecifier | (() => undefined | StreamsKeySpecifier),
		fields?: StreamsFieldPolicy,
	},
	StringAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StringAttributeKeySpecifier | (() => undefined | StringAttributeKeySpecifier),
		fields?: StringAttributeFieldPolicy,
	},
	StringAttributeWithPossibleError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StringAttributeWithPossibleErrorKeySpecifier | (() => undefined | StringAttributeWithPossibleErrorKeySpecifier),
		fields?: StringAttributeWithPossibleErrorFieldPolicy,
	},
	Subscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionKeySpecifier | (() => undefined | SubscriptionKeySpecifier),
		fields?: SubscriptionFieldPolicy,
	},
	SubscriptionPrizeCondition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionPrizeConditionKeySpecifier | (() => undefined | SubscriptionPrizeConditionKeySpecifier),
		fields?: SubscriptionPrizeConditionFieldPolicy,
	},
	SubscriptionProviderAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionProviderAccountKeySpecifier | (() => undefined | SubscriptionProviderAccountKeySpecifier),
		fields?: SubscriptionProviderAccountFieldPolicy,
	},
	SubscriptionType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionTypeKeySpecifier | (() => undefined | SubscriptionTypeKeySpecifier),
		fields?: SubscriptionTypeFieldPolicy,
	},
	Supplier?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SupplierKeySpecifier | (() => undefined | SupplierKeySpecifier),
		fields?: SupplierFieldPolicy,
	},
	SupplierConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SupplierConfigurationKeySpecifier | (() => undefined | SupplierConfigurationKeySpecifier),
		fields?: SupplierConfigurationFieldPolicy,
	},
	SwarmioCurrency?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyKeySpecifier | (() => undefined | SwarmioCurrencyKeySpecifier),
		fields?: SwarmioCurrencyFieldPolicy,
	},
	SwarmioCurrencyExchangeBlock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyExchangeBlockKeySpecifier | (() => undefined | SwarmioCurrencyExchangeBlockKeySpecifier),
		fields?: SwarmioCurrencyExchangeBlockFieldPolicy,
	},
	SwarmioCurrencyFixedPrizePayoutReceipt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyFixedPrizePayoutReceiptKeySpecifier | (() => undefined | SwarmioCurrencyFixedPrizePayoutReceiptKeySpecifier),
		fields?: SwarmioCurrencyFixedPrizePayoutReceiptFieldPolicy,
	},
	SwarmioCurrencyItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyItemKeySpecifier | (() => undefined | SwarmioCurrencyItemKeySpecifier),
		fields?: SwarmioCurrencyItemFieldPolicy,
	},
	SwarmioCurrencyItemCost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyItemCostKeySpecifier | (() => undefined | SwarmioCurrencyItemCostKeySpecifier),
		fields?: SwarmioCurrencyItemCostFieldPolicy,
	},
	SwarmioCurrencyItemCostArchive?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyItemCostArchiveKeySpecifier | (() => undefined | SwarmioCurrencyItemCostArchiveKeySpecifier),
		fields?: SwarmioCurrencyItemCostArchiveFieldPolicy,
	},
	SwarmioCurrencyItemCostPurchaseRequest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyItemCostPurchaseRequestKeySpecifier | (() => undefined | SwarmioCurrencyItemCostPurchaseRequestKeySpecifier),
		fields?: SwarmioCurrencyItemCostPurchaseRequestFieldPolicy,
	},
	SwarmioCurrencyPayout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyPayoutKeySpecifier | (() => undefined | SwarmioCurrencyPayoutKeySpecifier),
		fields?: SwarmioCurrencyPayoutFieldPolicy,
	},
	SwarmioCurrencyPayoutCost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyPayoutCostKeySpecifier | (() => undefined | SwarmioCurrencyPayoutCostKeySpecifier),
		fields?: SwarmioCurrencyPayoutCostFieldPolicy,
	},
	SwarmioCurrencyPayoutCostArchive?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyPayoutCostArchiveKeySpecifier | (() => undefined | SwarmioCurrencyPayoutCostArchiveKeySpecifier),
		fields?: SwarmioCurrencyPayoutCostArchiveFieldPolicy,
	},
	SwarmioCurrencyPayoutPrize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyPayoutPrizeKeySpecifier | (() => undefined | SwarmioCurrencyPayoutPrizeKeySpecifier),
		fields?: SwarmioCurrencyPayoutPrizeFieldPolicy,
	},
	SwarmioCurrencyPayoutRequest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyPayoutRequestKeySpecifier | (() => undefined | SwarmioCurrencyPayoutRequestKeySpecifier),
		fields?: SwarmioCurrencyPayoutRequestFieldPolicy,
	},
	SwarmioCurrencyReward?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioCurrencyRewardKeySpecifier | (() => undefined | SwarmioCurrencyRewardKeySpecifier),
		fields?: SwarmioCurrencyRewardFieldPolicy,
	},
	SwarmioItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioItemKeySpecifier | (() => undefined | SwarmioItemKeySpecifier),
		fields?: SwarmioItemFieldPolicy,
	},
	SwarmioPayPayment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioPayPaymentKeySpecifier | (() => undefined | SwarmioPayPaymentKeySpecifier),
		fields?: SwarmioPayPaymentFieldPolicy,
	},
	SwarmioSubscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioSubscriptionKeySpecifier | (() => undefined | SwarmioSubscriptionKeySpecifier),
		fields?: SwarmioSubscriptionFieldPolicy,
	},
	SwarmioVoucher?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioVoucherKeySpecifier | (() => undefined | SwarmioVoucherKeySpecifier),
		fields?: SwarmioVoucherFieldPolicy,
	},
	SwarmioWallet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioWalletKeySpecifier | (() => undefined | SwarmioWalletKeySpecifier),
		fields?: SwarmioWalletFieldPolicy,
	},
	SwarmioWalletTransactionWithMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SwarmioWalletTransactionWithMetadataKeySpecifier | (() => undefined | SwarmioWalletTransactionWithMetadataKeySpecifier),
		fields?: SwarmioWalletTransactionWithMetadataFieldPolicy,
	},
	Tag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagKeySpecifier | (() => undefined | TagKeySpecifier),
		fields?: TagFieldPolicy,
	},
	TargetCurrencyPrice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetCurrencyPriceKeySpecifier | (() => undefined | TargetCurrencyPriceKeySpecifier),
		fields?: TargetCurrencyPriceFieldPolicy,
	},
	TargetCurrencyPrices?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TargetCurrencyPricesKeySpecifier | (() => undefined | TargetCurrencyPricesKeySpecifier),
		fields?: TargetCurrencyPricesFieldPolicy,
	},
	Team?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TeamKeySpecifier | (() => undefined | TeamKeySpecifier),
		fields?: TeamFieldPolicy,
	},
	TeamEventEntryRules?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TeamEventEntryRulesKeySpecifier | (() => undefined | TeamEventEntryRulesKeySpecifier),
		fields?: TeamEventEntryRulesFieldPolicy,
	},
	TeamParticipant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TeamParticipantKeySpecifier | (() => undefined | TeamParticipantKeySpecifier),
		fields?: TeamParticipantFieldPolicy,
	},
	TechnicalParticipant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TechnicalParticipantKeySpecifier | (() => undefined | TechnicalParticipantKeySpecifier),
		fields?: TechnicalParticipantFieldPolicy,
	},
	Tournament?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TournamentKeySpecifier | (() => undefined | TournamentKeySpecifier),
		fields?: TournamentFieldPolicy,
	},
	TournamentBracket?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TournamentBracketKeySpecifier | (() => undefined | TournamentBracketKeySpecifier),
		fields?: TournamentBracketFieldPolicy,
	},
	TournamentMatch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TournamentMatchKeySpecifier | (() => undefined | TournamentMatchKeySpecifier),
		fields?: TournamentMatchFieldPolicy,
	},
	TournamentMatchBye?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TournamentMatchByeKeySpecifier | (() => undefined | TournamentMatchByeKeySpecifier),
		fields?: TournamentMatchByeFieldPolicy,
	},
	TournamentPhase?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TournamentPhaseKeySpecifier | (() => undefined | TournamentPhaseKeySpecifier),
		fields?: TournamentPhaseFieldPolicy,
	},
	TournamentRound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TournamentRoundKeySpecifier | (() => undefined | TournamentRoundKeySpecifier),
		fields?: TournamentRoundFieldPolicy,
	},
	TournamentSpecificDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TournamentSpecificDetailsKeySpecifier | (() => undefined | TournamentSpecificDetailsKeySpecifier),
		fields?: TournamentSpecificDetailsFieldPolicy,
	},
	TransferTransaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransferTransactionKeySpecifier | (() => undefined | TransferTransactionKeySpecifier),
		fields?: TransferTransactionFieldPolicy,
	},
	TwitchStream?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TwitchStreamKeySpecifier | (() => undefined | TwitchStreamKeySpecifier),
		fields?: TwitchStreamFieldPolicy,
	},
	UnappliedPayment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnappliedPaymentKeySpecifier | (() => undefined | UnappliedPaymentKeySpecifier),
		fields?: UnappliedPaymentFieldPolicy,
	},
	UnreadyIndividualParticipant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnreadyIndividualParticipantKeySpecifier | (() => undefined | UnreadyIndividualParticipantKeySpecifier),
		fields?: UnreadyIndividualParticipantFieldPolicy,
	},
	UpcomingKingOfTheHillParticipant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpcomingKingOfTheHillParticipantKeySpecifier | (() => undefined | UpcomingKingOfTheHillParticipantKeySpecifier),
		fields?: UpcomingKingOfTheHillParticipantFieldPolicy,
	},
	UpdateDisabledPaymentChannelResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateDisabledPaymentChannelResponseKeySpecifier | (() => undefined | UpdateDisabledPaymentChannelResponseKeySpecifier),
		fields?: UpdateDisabledPaymentChannelResponseFieldPolicy,
	},
	UpdateHiveContactRequest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateHiveContactRequestKeySpecifier | (() => undefined | UpdateHiveContactRequestKeySpecifier),
		fields?: UpdateHiveContactRequestFieldPolicy,
	},
	UpdatePartnerItemPaymentChannelResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePartnerItemPaymentChannelResponseKeySpecifier | (() => undefined | UpdatePartnerItemPaymentChannelResponseKeySpecifier),
		fields?: UpdatePartnerItemPaymentChannelResponseFieldPolicy,
	},
	UpdatedPartnerItemPaymentChannelResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatedPartnerItemPaymentChannelResponseKeySpecifier | (() => undefined | UpdatedPartnerItemPaymentChannelResponseKeySpecifier),
		fields?: UpdatedPartnerItemPaymentChannelResponseFieldPolicy,
	},
	UploadTrait?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadTraitKeySpecifier | (() => undefined | UploadTraitKeySpecifier),
		fields?: UploadTraitFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	ValorantCompetitionDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ValorantCompetitionDetailsKeySpecifier | (() => undefined | ValorantCompetitionDetailsKeySpecifier),
		fields?: ValorantCompetitionDetailsFieldPolicy,
	},
	VariablePrize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VariablePrizeKeySpecifier | (() => undefined | VariablePrizeKeySpecifier),
		fields?: VariablePrizeFieldPolicy,
	},
	VariablePrizeCondition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VariablePrizeConditionKeySpecifier | (() => undefined | VariablePrizeConditionKeySpecifier),
		fields?: VariablePrizeConditionFieldPolicy,
	},
	VerifiedHiveContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VerifiedHiveContactKeySpecifier | (() => undefined | VerifiedHiveContactKeySpecifier),
		fields?: VerifiedHiveContactFieldPolicy,
	},
	Voucher?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherKeySpecifier | (() => undefined | VoucherKeySpecifier),
		fields?: VoucherFieldPolicy,
	},
	VoucherInventory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherInventoryKeySpecifier | (() => undefined | VoucherInventoryKeySpecifier),
		fields?: VoucherInventoryFieldPolicy,
	},
	WithUnverifiedHiveContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WithUnverifiedHiveContactKeySpecifier | (() => undefined | WithUnverifiedHiveContactKeySpecifier),
		fields?: WithUnverifiedHiveContactFieldPolicy,
	},
	YouTubeStream?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YouTubeStreamKeySpecifier | (() => undefined | YouTubeStreamKeySpecifier),
		fields?: YouTubeStreamFieldPolicy,
	},
	YouTubeVideo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YouTubeVideoKeySpecifier | (() => undefined | YouTubeVideoKeySpecifier),
		fields?: YouTubeVideoFieldPolicy,
	},
	cms_bannersAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cms_bannersAccessKeySpecifier | (() => undefined | cms_bannersAccessKeySpecifier),
		fields?: cms_bannersAccessFieldPolicy,
	},
	cms_bannersDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cms_bannersDocAccessKeySpecifier | (() => undefined | cms_bannersDocAccessKeySpecifier),
		fields?: cms_bannersDocAccessFieldPolicy,
	},
	cms_blog_pagesAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cms_blog_pagesAccessKeySpecifier | (() => undefined | cms_blog_pagesAccessKeySpecifier),
		fields?: cms_blog_pagesAccessFieldPolicy,
	},
	cms_blog_pagesDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cms_blog_pagesDocAccessKeySpecifier | (() => undefined | cms_blog_pagesDocAccessKeySpecifier),
		fields?: cms_blog_pagesDocAccessFieldPolicy,
	},
	cms_blog_postsAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cms_blog_postsAccessKeySpecifier | (() => undefined | cms_blog_postsAccessKeySpecifier),
		fields?: cms_blog_postsAccessFieldPolicy,
	},
	cms_blog_postsDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cms_blog_postsDocAccessKeySpecifier | (() => undefined | cms_blog_postsDocAccessKeySpecifier),
		fields?: cms_blog_postsDocAccessFieldPolicy,
	},
	cms_gamersAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cms_gamersAccessKeySpecifier | (() => undefined | cms_gamersAccessKeySpecifier),
		fields?: cms_gamersAccessFieldPolicy,
	},
	cms_gamersDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cms_gamersDocAccessKeySpecifier | (() => undefined | cms_gamersDocAccessKeySpecifier),
		fields?: cms_gamersDocAccessFieldPolicy,
	},
	cms_gamesAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cms_gamesAccessKeySpecifier | (() => undefined | cms_gamesAccessKeySpecifier),
		fields?: cms_gamesAccessFieldPolicy,
	},
	cms_gamesDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cms_gamesDocAccessKeySpecifier | (() => undefined | cms_gamesDocAccessKeySpecifier),
		fields?: cms_gamesDocAccessFieldPolicy,
	},
	cms_mediaAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cms_mediaAccessKeySpecifier | (() => undefined | cms_mediaAccessKeySpecifier),
		fields?: cms_mediaAccessFieldPolicy,
	},
	cms_mediaDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | cms_mediaDocAccessKeySpecifier | (() => undefined | cms_mediaDocAccessKeySpecifier),
		fields?: cms_mediaDocAccessFieldPolicy,
	},
	countCmsBanners?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | countCmsBannersKeySpecifier | (() => undefined | countCmsBannersKeySpecifier),
		fields?: countCmsBannersFieldPolicy,
	},
	countCmsBlogPages?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | countCmsBlogPagesKeySpecifier | (() => undefined | countCmsBlogPagesKeySpecifier),
		fields?: countCmsBlogPagesFieldPolicy,
	},
	countCmsBlogPosts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | countCmsBlogPostsKeySpecifier | (() => undefined | countCmsBlogPostsKeySpecifier),
		fields?: countCmsBlogPostsFieldPolicy,
	},
	countCmsGamers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | countCmsGamersKeySpecifier | (() => undefined | countCmsGamersKeySpecifier),
		fields?: countCmsGamersFieldPolicy,
	},
	countCmsGames?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | countCmsGamesKeySpecifier | (() => undefined | countCmsGamesKeySpecifier),
		fields?: countCmsGamesFieldPolicy,
	},
	countCmsMedias?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | countCmsMediasKeySpecifier | (() => undefined | countCmsMediasKeySpecifier),
		fields?: countCmsMediasFieldPolicy,
	},
	countCmsUsers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | countCmsUsersKeySpecifier | (() => undefined | countCmsUsersKeySpecifier),
		fields?: countCmsUsersFieldPolicy,
	},
	countPayloadLockedDocuments?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | countPayloadLockedDocumentsKeySpecifier | (() => undefined | countPayloadLockedDocumentsKeySpecifier),
		fields?: countPayloadLockedDocumentsFieldPolicy,
	},
	countPayloadPreferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | countPayloadPreferencesKeySpecifier | (() => undefined | countPayloadPreferencesKeySpecifier),
		fields?: countPayloadPreferencesFieldPolicy,
	},
	partnerDataForItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | partnerDataForItemKeySpecifier | (() => undefined | partnerDataForItemKeySpecifier),
		fields?: partnerDataForItemFieldPolicy,
	},
	payload_locked_documentsAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payload_locked_documentsAccessKeySpecifier | (() => undefined | payload_locked_documentsAccessKeySpecifier),
		fields?: payload_locked_documentsAccessFieldPolicy,
	},
	payload_locked_documentsDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payload_locked_documentsDocAccessKeySpecifier | (() => undefined | payload_locked_documentsDocAccessKeySpecifier),
		fields?: payload_locked_documentsDocAccessFieldPolicy,
	},
	payload_preferencesAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payload_preferencesAccessKeySpecifier | (() => undefined | payload_preferencesAccessKeySpecifier),
		fields?: payload_preferencesAccessFieldPolicy,
	},
	payload_preferencesDocAccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | payload_preferencesDocAccessKeySpecifier | (() => undefined | payload_preferencesDocAccessKeySpecifier),
		fields?: payload_preferencesDocAccessFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;